
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

parcelRegister("ih19M", function(module, exports) {
'use strict';

module.exports = (parcelRequire("0qhf8"));

});
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
'use strict';

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $92f4fea5bc247620$export$3ba232387fd5d6dd; }, function (v) { return $92f4fea5bc247620$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$3ba232387fd5d6dd;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
'use strict';
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
function $92f4fea5bc247620$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$3ba232387fd5d6dd = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("eB0am", function(module, exports) {
"use strict";
var $aa04a65a7ba779be$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $aa04a65a7ba779be$var$PostgrestQueryBuilder_1 = $aa04a65a7ba779be$var$__importDefault((parcelRequire("3KbHr")));

const $aa04a65a7ba779be$var$PostgrestFilterBuilder_1 = $aa04a65a7ba779be$var$__importDefault((parcelRequire("llMbM")));

var $cxCrK = parcelRequire("cxCrK");
/**
 * PostgREST client.
 *
 * @typeParam Database - Types for the schema from the [type
 * generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
 *
 * @typeParam SchemaName - Postgres schema to switch to. Must be a string
 * literal, the same one passed to the constructor. If the schema is not
 * `"public"`, this must be supplied manually.
 */ class $aa04a65a7ba779be$var$PostgrestClient {
    // TODO: Add back shouldThrowOnError once we figure out the typings
    /**
     * Creates a PostgREST client.
     *
     * @param url - URL of the PostgREST endpoint
     * @param options - Named parameters
     * @param options.headers - Custom headers
     * @param options.schema - Postgres schema to switch to
     * @param options.fetch - Custom fetch
     */ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch } = {}){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, $cxCrK.DEFAULT_HEADERS), headers);
        this.schemaName = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        const url = new URL(`${this.url}/${relation}`);
        return new $aa04a65a7ba779be$var$PostgrestQueryBuilder_1.default(url, {
            headers: Object.assign({}, this.headers),
            schema: this.schemaName,
            fetch: this.fetch
        });
    }
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return new $aa04a65a7ba779be$var$PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch
        });
    }
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        if (head || get) {
            method = head ? 'HEAD' : 'GET';
            Object.entries(args)// params with undefined value needs to be filtered out, otherwise it'll
            // show up as `?param=undefined`
            .filter(([_, value])=>value !== undefined)// array values need special syntax
            .map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(',')}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = 'POST';
            body = args;
        }
        const headers = Object.assign({}, this.headers);
        if (count) headers['Prefer'] = `count=${count}`;
        return new $aa04a65a7ba779be$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $aa04a65a7ba779be$var$PostgrestClient;

});
parcelRegister("3KbHr", function(module, exports) {
"use strict";
var $2b9ebe43585cd5c6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $2b9ebe43585cd5c6$var$PostgrestFilterBuilder_1 = $2b9ebe43585cd5c6$var$__importDefault((parcelRequire("llMbM")));
class $2b9ebe43585cd5c6$var$PostgrestQueryBuilder {
    constructor(url, { headers: headers = {}, schema: schema, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.schema = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a SELECT query on the table or view.
     *
     * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
     *
     * @param options - Named parameters
     *
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     *
     * @param options.count - Count algorithm to use to count rows in the table or view.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ select(columns, { head: head = false, count: count } = {}) {
        const method = head ? 'HEAD' : 'GET';
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (count) this.headers['Prefer'] = `count=${count}`;
        return new $2b9ebe43585cd5c6$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an INSERT into the table or view.
     *
     * By default, inserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to insert. Pass an object to insert a single row
     * or an array to insert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count inserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. Only applies for bulk
     * inserts.
     */ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $2b9ebe43585cd5c6$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPSERT on the table or view. Depending on the column(s) passed
     * to `onConflict`, `.upsert()` allows you to perform the equivalent of
     * `.insert()` if a row with the corresponding `onConflict` columns doesn't
     * exist, or if it does exist, perform an alternative action depending on
     * `ignoreDuplicates`.
     *
     * By default, upserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to upsert with. Pass an object to upsert a
     * single row or an array to upsert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
     * duplicate rows are determined. Two rows are duplicates if all the
     * `onConflict` columns are equal.
     *
     * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
     * `false`, duplicate rows are merged with existing rows.
     *
     * @param options.count - Count algorithm to use to count upserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. This only applies when
     * inserting new rows, not when merging with existing rows under
     * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
     */ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [
            `resolution=${ignoreDuplicates ? 'ignore' : 'merge'}-duplicates`
        ];
        if (onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $2b9ebe43585cd5c6$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPDATE on the table or view.
     *
     * By default, updated rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param values - The values to update with
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count updated rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ update(values, { count: count } = {}) {
        const method = 'PATCH';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $2b9ebe43585cd5c6$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform a DELETE on the table or view.
     *
     * By default, deleted rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count deleted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ delete({ count: count } = {}) {
        const method = 'DELETE';
        const prefersHeaders = [];
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $2b9ebe43585cd5c6$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $2b9ebe43585cd5c6$var$PostgrestQueryBuilder;

});
parcelRegister("llMbM", function(module, exports) {
"use strict";
var $f8b0f07e53df780f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $f8b0f07e53df780f$var$PostgrestTransformBuilder_1 = $f8b0f07e53df780f$var$__importDefault((parcelRequire("1u3br")));
class $f8b0f07e53df780f$var$PostgrestFilterBuilder extends $f8b0f07e53df780f$var$PostgrestTransformBuilder_1.default {
    /**
     * Match only rows where `column` is equal to `value`.
     *
     * To check if the value of `column` is NULL, you should use `.is()` instead.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is not equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-sensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-insensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` IS `value`.
     *
     * For non-boolean columns, this is only relevant for checking if the value of
     * `column` is NULL by setting `value` to `null`.
     *
     * For boolean columns, you can also set `value` to `true` or `false` and it
     * will behave the same way as `.eq()`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is included in the `values` array.
     *
     * @param column - The column to filter on
     * @param values - The values array to filter with
     */ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            // handle postgrest reserved characters
            // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
            if (typeof s === 'string' && new RegExp('[,()]').test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(',');
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * `column` contains every element appearing in `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ contains(column, value) {
        if (typeof value === 'string') // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cs.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * every element appearing in `column` is contained by `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ containedBy(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cd.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is greater than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or greater than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is less than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or less than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where `column` is
     * mutually exclusive to `range` and there can be no element between the two
     * ranges.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
     * Only relevant for array and range columns. Match only rows where
     * `column` and `value` have an element in common.
     *
     * @param column - The array or range column to filter on
     * @param value - The array or range value to filter with
     */ overlaps(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `ov.${value}`);
        else // array
        this.url.searchParams.append(column, `ov.{${value.join(',')}}`);
        return this;
    }
    /**
     * Only relevant for text and tsvector columns. Match only rows where
     * `column` matches the query string in `query`.
     *
     * @param column - The text or tsvector column to filter on
     * @param query - The query text to match with
     * @param options - Named parameters
     * @param options.config - The text search configuration to use
     * @param options.type - Change how the `query` text is interpreted
     */ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = '';
        if (type === 'plain') typePart = 'pl';
        else if (type === 'phrase') typePart = 'ph';
        else if (type === 'websearch') typePart = 'w';
        const configPart = config === undefined ? '' : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
     * Match only rows where each column in `query` keys is equal to its
     * associated value. Shorthand for multiple `.eq()`s.
     *
     * @param query - The object to filter with, with column names as keys mapped
     * to their filter values
     */ match(query) {
        Object.entries(query).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
     * Match only rows which doesn't satisfy the filter.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to be negated to filter with, following
     * PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
     * Match only rows which satisfy at least one of the filters.
     *
     * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure it's properly sanitized.
     *
     * It's currently not possible to do an `.or()` filter across multiple tables.
     *
     * @param filters - The filters to use, following PostgREST syntax
     * @param options - Named parameters
     * @param options.referencedTable - Set this to filter on referenced tables
     * instead of the parent table
     * @param options.foreignTable - Deprecated, use `referencedTable` instead
     */ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : 'or';
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
     * Match only rows which satisfy the filter. This is an escape hatch - you
     * should use the specific filter methods wherever possible.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to filter with, following PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
}
module.exports.default = $f8b0f07e53df780f$var$PostgrestFilterBuilder;

});
parcelRegister("1u3br", function(module, exports) {
"use strict";
var $114b0ff512d0b422$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $114b0ff512d0b422$var$PostgrestBuilder_1 = $114b0ff512d0b422$var$__importDefault((parcelRequire("a6jdf")));
class $114b0ff512d0b422$var$PostgrestTransformBuilder extends $114b0ff512d0b422$var$PostgrestBuilder_1.default {
    /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */ select(columns) {
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (this.headers['Prefer']) this.headers['Prefer'] += ',';
        this.headers['Prefer'] += 'return=representation';
        return this;
    }
    /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order referenced tables, but it only affects the ordering of the
     * parent table if you use `!inner` in the query.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.referencedTable - Set this to order a referenced table by
     * its columns
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : 'order';
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ''}${column}.${ascending ? 'asc' : 'desc'}${nullsFirst === undefined ? '' : nullsFirst ? '.nullsfirst' : '.nullslast'}`);
        return this;
    }
    /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
     * Limit the query result by starting at an offset `from` and ending at the offset `to`.
     * Only records within this range are returned.
     * This respects the query order and if there is no order clause the range could behave unexpectedly.
     * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
     * and fourth rows of the query.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === 'undefined' ? 'offset' : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        // Range is inclusive, so add 1
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */ single() {
        this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */ maybeSingle() {
        // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
        // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
        if (this.method === 'GET') this.headers['Accept'] = 'application/json';
        else this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        this.isMaybeSingle = true;
        return this;
    }
    /**
     * Return `data` as a string in CSV format.
     */ csv() {
        this.headers['Accept'] = 'text/csv';
        return this;
    }
    /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */ geojson() {
        this.headers['Accept'] = 'application/geo+json';
        return this;
    }
    /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * You need to enable the
     * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
     * setting before using this method.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = 'text' } = {}) {
        var _a;
        const options = [
            analyze ? 'analyze' : null,
            verbose ? 'verbose' : null,
            settings ? 'settings' : null,
            buffers ? 'buffers' : null,
            wal ? 'wal' : null
        ].filter(Boolean).join('|');
        // An Accept header can carry multiple media types but postgrest-js always sends one
        const forMediatype = (_a = this.headers['Accept']) !== null && _a !== void 0 ? _a : 'application/json';
        this.headers['Accept'] = `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`;
        if (format === 'json') return this;
        else return this;
    }
    /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */ rollback() {
        var _a;
        if (((_a = this.headers['Prefer']) !== null && _a !== void 0 ? _a : '').trim().length > 0) this.headers['Prefer'] += ',tx=rollback';
        else this.headers['Prefer'] = 'tx=rollback';
        return this;
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     */ returns() {
        return this;
    }
}
module.exports.default = $114b0ff512d0b422$var$PostgrestTransformBuilder;

});
parcelRegister("a6jdf", function(module, exports) {
"use strict";
var $75a95e2e994fb2b8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// @ts-ignore
const $75a95e2e994fb2b8$var$node_fetch_1 = $75a95e2e994fb2b8$var$__importDefault((parcelRequire("8oL7M")));

const $75a95e2e994fb2b8$var$PostgrestError_1 = $75a95e2e994fb2b8$var$__importDefault((parcelRequire("dUzfo")));
class $75a95e2e994fb2b8$var$PostgrestBuilder {
    constructor(builder){
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = builder.headers;
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = builder.shouldThrowOnError;
        this.signal = builder.signal;
        this.isMaybeSingle = builder.isMaybeSingle;
        if (builder.fetch) this.fetch = builder.fetch;
        else if (typeof fetch === 'undefined') this.fetch = $75a95e2e994fb2b8$var$node_fetch_1.default;
        else this.fetch = fetch;
    }
    /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
     * Set an HTTP header for the request.
     */ setHeader(name, value) {
        this.headers = Object.assign({}, this.headers);
        this.headers[name] = value;
        return this;
    }
    then(onfulfilled, onrejected) {
        // https://postgrest.org/en/stable/api.html#switching-schemas
        if (this.schema === undefined) ;
        else if ([
            'GET',
            'HEAD'
        ].includes(this.method)) this.headers['Accept-Profile'] = this.schema;
        else this.headers['Content-Profile'] = this.schema;
        if (this.method !== 'GET' && this.method !== 'HEAD') this.headers['Content-Type'] = 'application/json';
        // NOTE: Invoke w/o `this` to avoid illegal invocation error.
        // https://github.com/supabase/postgrest-js/pull/247
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res)=>{
            var _a, _b, _c;
            let error = null;
            let data = null;
            let count = null;
            let status = res.status;
            let statusText = res.statusText;
            if (res.ok) {
                if (this.method !== 'HEAD') {
                    const body = await res.text();
                    if (body === '') ;
                    else if (this.headers['Accept'] === 'text/csv') data = body;
                    else if (this.headers['Accept'] && this.headers['Accept'].includes('application/vnd.pgrst.plan+text')) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_a = this.headers['Prefer']) === null || _a === void 0 ? void 0 : _a.match(/count=(exact|planned|estimated)/);
                const contentRange = (_b = res.headers.get('content-range')) === null || _b === void 0 ? void 0 : _b.split('/');
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                if (this.isMaybeSingle && this.method === 'GET' && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
                            code: 'PGRST116',
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: 'JSON object requested, multiple (or no) rows returned'
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = 'Not Acceptable';
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                const body = await res.text();
                try {
                    error = JSON.parse(body);
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (Array.isArray(error) && res.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = 'OK';
                    }
                } catch (_d) {
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (res.status === 404 && body === '') {
                        status = 204;
                        statusText = 'No Content';
                    } else error = {
                        message: body
                    };
                }
                if (error && this.isMaybeSingle && ((_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.includes('0 rows'))) {
                    error = null;
                    status = 200;
                    statusText = 'OK';
                }
                if (error && this.shouldThrowOnError) throw new $75a95e2e994fb2b8$var$PostgrestError_1.default(error);
            }
            const postgrestResponse = {
                error: error,
                data: data,
                count: count,
                status: status,
                statusText: statusText
            };
            return postgrestResponse;
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _a, _b, _c;
            return {
                error: {
                    message: `${(_a = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _a !== void 0 ? _a : 'FetchError'}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: `${(_b = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _b !== void 0 ? _b : ''}`,
                    hint: '',
                    code: `${(_c = fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) !== null && _c !== void 0 ? _c : ''}`
                },
                data: null,
                count: null,
                status: 0,
                statusText: ''
            };
        });
        return res.then(onfulfilled, onrejected);
    }
}
module.exports.default = $75a95e2e994fb2b8$var$PostgrestBuilder;

});
parcelRegister("8oL7M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fetch", function () { return $61d51e8f3cb10a93$export$e7aa7bc5c1b3cfb3; });
$parcel$export(module.exports, "default", function () { return $61d51e8f3cb10a93$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Headers", function () { return $61d51e8f3cb10a93$export$79b704688b15c0f4; });
$parcel$export(module.exports, "Request", function () { return $61d51e8f3cb10a93$export$7fa6c5b6f8193917; });
$parcel$export(module.exports, "Response", function () { return $61d51e8f3cb10a93$export$9f633d56d7ec90d3; });
"use strict";
// ref: https://github.com/tc39/proposal-global
var $61d51e8f3cb10a93$var$getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var $61d51e8f3cb10a93$var$globalObject = $61d51e8f3cb10a93$var$getGlobal();
const $61d51e8f3cb10a93$export$e7aa7bc5c1b3cfb3 = $61d51e8f3cb10a93$var$globalObject.fetch;
var $61d51e8f3cb10a93$export$2e2bcd8739ae039 = $61d51e8f3cb10a93$var$globalObject.fetch.bind($61d51e8f3cb10a93$var$globalObject);
const $61d51e8f3cb10a93$export$79b704688b15c0f4 = $61d51e8f3cb10a93$var$globalObject.Headers;
const $61d51e8f3cb10a93$export$7fa6c5b6f8193917 = $61d51e8f3cb10a93$var$globalObject.Request;
const $61d51e8f3cb10a93$export$9f633d56d7ec90d3 = $61d51e8f3cb10a93$var$globalObject.Response;

});

parcelRegister("dUzfo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Error format
 *
 * {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
 */ class $a20bd8b71e52f522$var$PostgrestError extends Error {
    constructor(context){
        super(context.message);
        this.name = 'PostgrestError';
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
}
module.exports.default = $a20bd8b71e52f522$var$PostgrestError;

});





parcelRegister("cxCrK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_HEADERS = void 0;

var $2r6ZZ = parcelRequire("2r6ZZ");
module.exports.DEFAULT_HEADERS = {
    'X-Client-Info': `postgrest-js/${$2r6ZZ.version}`
};

});
parcelRegister("2r6ZZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
module.exports.version = '0.0.0-automated';

});



parcelRegister("qM4kX", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("i8uP8").then(()=>parcelRequire('ivIUF'));

});
parcelRegister("hffE7", function(module, exports) {
"use strict";

function $c8dff9588896671a$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("kyEFX")).resolve(id));
}
module.exports = $c8dff9588896671a$var$load;

});


parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
'use strict';

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$Lg(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$Lg(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$Sg(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Ug = $b36288e2db101ba3$var$Og(!0), $b36288e2db101ba3$var$Vg = $b36288e2db101ba3$var$Og(!1), $b36288e2db101ba3$var$Wg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Xg = null, $b36288e2db101ba3$var$Yg = null, $b36288e2db101ba3$var$Zg = null;
function $b36288e2db101ba3$var$$g() {
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Xg = null;
}
function $b36288e2db101ba3$var$ah(a) {
    var b = $b36288e2db101ba3$var$Wg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$ch(a, b) {
    $b36288e2db101ba3$var$Xg = a;
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$dh = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$eh(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Yg) {
            if (null === $b36288e2db101ba3$var$Xg) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Yg = a;
            $b36288e2db101ba3$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Yg.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$fh = null;
function $b36288e2db101ba3$var$gh(a) {
    null === $b36288e2db101ba3$var$fh ? $b36288e2db101ba3$var$fh = [
        a
    ] : $b36288e2db101ba3$var$fh.push(a);
}
function $b36288e2db101ba3$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$ih(a, d);
}
function $b36288e2db101ba3$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$jh = !1;
function $b36288e2db101ba3$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$ih(a, c);
}
function $b36288e2db101ba3$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$th = {}, $b36288e2db101ba3$var$uh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$vh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$wh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th);
function $b36288e2db101ba3$var$xh(a) {
    if (a === $b36288e2db101ba3$var$th) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$yh(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$wh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, $b36288e2db101ba3$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, b);
}
function $b36288e2db101ba3$var$zh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$wh);
}
function $b36288e2db101ba3$var$Ah(a) {
    $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
    var b = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, c));
}
function $b36288e2db101ba3$var$Bh(a) {
    $b36288e2db101ba3$var$vh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh));
}
var $b36288e2db101ba3$var$L = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Dh = [];
function $b36288e2db101ba3$var$Eh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Dh.length; a++)$b36288e2db101ba3$var$Dh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Dh.length = 0;
}
var $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Hh = 0, $b36288e2db101ba3$var$M = null, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$Ih = !1, $b36288e2db101ba3$var$Jh = !1, $b36288e2db101ba3$var$Kh = 0, $b36288e2db101ba3$var$Lh = 0;
function $b36288e2db101ba3$var$P() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Nh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Hh = f;
    $b36288e2db101ba3$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Fh.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Oh : $b36288e2db101ba3$var$Ph;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Jh) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Qh;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Jh);
    }
    $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
    b = null !== $b36288e2db101ba3$var$N && null !== $b36288e2db101ba3$var$N.next;
    $b36288e2db101ba3$var$Hh = 0;
    $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
    $b36288e2db101ba3$var$Ih = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$Sh() {
    var a = 0 !== $b36288e2db101ba3$var$Kh;
    $b36288e2db101ba3$var$Kh = 0;
    return a;
}
function $b36288e2db101ba3$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Uh() {
    if (null === $b36288e2db101ba3$var$N) {
        var a = $b36288e2db101ba3$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$N.next;
    var b = null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState : $b36288e2db101ba3$var$O.next;
    if (null !== b) $b36288e2db101ba3$var$O = b, $b36288e2db101ba3$var$N = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$N = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$N.memoizedState,
            baseState: $b36288e2db101ba3$var$N.baseState,
            baseQueue: $b36288e2db101ba3$var$N.baseQueue,
            queue: $b36288e2db101ba3$var$N.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    }
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$Wh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$M.lanes |= m;
                $b36288e2db101ba3$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$M.lanes |= f, $b36288e2db101ba3$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$Xh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$Yh() {}
function $b36288e2db101ba3$var$Zh(a, b) {
    var c = $b36288e2db101ba3$var$M, d = $b36288e2db101ba3$var$Uh(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$dh = !0);
    d = d.queue;
    $b36288e2db101ba3$var$$h($b36288e2db101ba3$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$O && $b36288e2db101ba3$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
}
function $b36288e2db101ba3$var$ai(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
    });
}
function $b36288e2db101ba3$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$ih(a, 1);
    null !== b && $b36288e2db101ba3$var$gi(b, a, 1, -1);
}
function $b36288e2db101ba3$var$hi(a) {
    var b = $b36288e2db101ba3$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ii.bind(null, $b36288e2db101ba3$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$ji() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$ki(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Th();
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$N) {
        var g = $b36288e2db101ba3$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Mh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$bi(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$mi(a, b) {
    return $b36288e2db101ba3$var$ki(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$$h(a, b) {
    return $b36288e2db101ba3$var$li(2048, 8, a, b);
}
function $b36288e2db101ba3$var$ni(a, b) {
    return $b36288e2db101ba3$var$li(4, 2, a, b);
}
function $b36288e2db101ba3$var$oi(a, b) {
    return $b36288e2db101ba3$var$li(4, 4, a, b);
}
function $b36288e2db101ba3$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$li(4, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$ri() {}
function $b36288e2db101ba3$var$si(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ti(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ui(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$dh = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$M.lanes |= c, $b36288e2db101ba3$var$rh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$vi(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Gh.transition;
    $b36288e2db101ba3$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Gh.transition = d;
    }
}
function $b36288e2db101ba3$var$wi() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$xi(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, c);
    else if (c = $b36288e2db101ba3$var$hh(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$R();
        $b36288e2db101ba3$var$gi(c, a, d, e);
        $b36288e2db101ba3$var$Bi(c, b, d);
    }
}
function $b36288e2db101ba3$var$ii(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$hh(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$R(), $b36288e2db101ba3$var$gi(c, a, d, e), $b36288e2db101ba3$var$Bi(c, b, d));
    }
}
function $b36288e2db101ba3$var$zi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$M || null !== b && b === $b36288e2db101ba3$var$M;
}
function $b36288e2db101ba3$var$Ai(a, b) {
    $b36288e2db101ba3$var$Jh = $b36288e2db101ba3$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$Rh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$P,
    useContext: $b36288e2db101ba3$var$P,
    useEffect: $b36288e2db101ba3$var$P,
    useImperativeHandle: $b36288e2db101ba3$var$P,
    useInsertionEffect: $b36288e2db101ba3$var$P,
    useLayoutEffect: $b36288e2db101ba3$var$P,
    useMemo: $b36288e2db101ba3$var$P,
    useReducer: $b36288e2db101ba3$var$P,
    useRef: $b36288e2db101ba3$var$P,
    useState: $b36288e2db101ba3$var$P,
    useDebugValue: $b36288e2db101ba3$var$P,
    useDeferredValue: $b36288e2db101ba3$var$P,
    useTransition: $b36288e2db101ba3$var$P,
    useMutableSource: $b36288e2db101ba3$var$P,
    useSyncExternalStore: $b36288e2db101ba3$var$P,
    useId: $b36288e2db101ba3$var$P,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Oh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ki(4194308, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$xi.bind(null, $b36288e2db101ba3$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$hi,
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$hi(!1), b = a[0];
        a = $b36288e2db101ba3$var$vi.bind(null, a[1]);
        $b36288e2db101ba3$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$M, e = $b36288e2db101ba3$var$Th();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$mi($b36288e2db101ba3$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$Th(), b = $b36288e2db101ba3$var$Q.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Ph = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Wh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Qh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Xh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return null === $b36288e2db101ba3$var$N ? b.memoizedState = a : $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b36288e2db101ba3$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$R(), d = $b36288e2db101ba3$var$yi(a), e = $b36288e2db101ba3$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$nh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, d, c), $b36288e2db101ba3$var$oh(b, a, d));
    }
};
function $b36288e2db101ba3$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$eh(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b36288e2db101ba3$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$eh(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$Ei.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Ni(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Oi || ($b36288e2db101ba3$var$Oi = !0, $b36288e2db101ba3$var$Pi = d);
        $b36288e2db101ba3$var$Li(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Qi(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Li(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Ri ? $b36288e2db101ba3$var$Ri = new Set([
            this
        ]) : $b36288e2db101ba3$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$mh(-1, 1), b.tag = 2, $b36288e2db101ba3$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Wi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$dh = !1;
function $b36288e2db101ba3$var$Xi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Vg(b, null, c, d) : $b36288e2db101ba3$var$Ug(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$ch(b, e);
    d = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$bj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$dh = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$Zi(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$cj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj);
            $b36288e2db101ba3$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= d;
    $b36288e2db101ba3$var$Xi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$ch(b, e);
    c = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$ch(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$ij(a, b), $b36288e2db101ba3$var$Gi(b, c, d), $b36288e2db101ba3$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$eh(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$Hi(b, g, d, l);
        $b36288e2db101ba3$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof m && ($b36288e2db101ba3$var$Di(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$eh(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$Hi(b, g, d, k);
        $b36288e2db101ba3$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof y && ($b36288e2db101ba3$var$Di(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$jj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$jj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$Zi(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Ug(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Ug(b, null, h, f)) : $b36288e2db101ba3$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$yh(a, b.containerInfo);
}
function $b36288e2db101ba3$var$lj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Xi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$pj(g, d, 0, null), a = $b36288e2db101ba3$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$nj(c), b.memoizedState = $b36288e2db101ba3$var$mj, a) : $b36288e2db101ba3$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$Pg(h, f) : (f = $b36288e2db101ba3$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$qj(a, b) {
    b = $b36288e2db101ba3$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$sj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Ug(b, a.child, null, c);
    a = $b36288e2db101ba3$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$nj(g);
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Ki(f, d, void 0);
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$dh || h) {
        d = $b36288e2db101ba3$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$ih(a, e), $b36288e2db101ba3$var$gi(d, a, e, -1));
        }
        $b36288e2db101ba3$var$tj();
        d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$bh(a.return, b, c);
}
function $b36288e2db101ba3$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Xi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$vj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$kj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Ah(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$oj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
                a = $b36288e2db101ba3$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$dj(a, b, c);
    }
    return $b36288e2db101ba3$var$Zi(a, b, c);
}
var $b36288e2db101ba3$var$zj, $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj;
$b36288e2db101ba3$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Aj = function() {};
$b36288e2db101ba3$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Dj(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$zh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Aj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Bh(b);
            var e = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
                $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$L.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$Aj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Dj(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Gj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$L.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$fj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Ij(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Bh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L), null;
        case 4:
            return $b36288e2db101ba3$var$zh(), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Jj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Nj = !1;
function $b36288e2db101ba3$var$Oj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Nj;
    $b36288e2db101ba3$var$Nj = !1;
    return n;
}
function $b36288e2db101ba3$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Xj = !1;
function $b36288e2db101ba3$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$Zj(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$Zj(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Lj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Xj = !0;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Mj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Yj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Yj(a, b, c);
    }
}
function $b36288e2db101ba3$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Kj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Xj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$Zj(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$dk(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Pj(3, a, a.return), $b36288e2db101ba3$var$Qj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Pj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            break;
        case 13:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$fk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$ek(a);
    }
}
function $b36288e2db101ba3$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$hk(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$ik(a, b, c);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Jj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Jj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$jk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$jk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$ik(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Jj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$kk(a, b, c);
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Rj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$gk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$jk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Qj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$lk = Math.ceil, $b36288e2db101ba3$var$mk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$fj = 0, $b36288e2db101ba3$var$ej = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$pk = null, $b36288e2db101ba3$var$rh = 0, $b36288e2db101ba3$var$qk = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = null, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$fk = 0, $b36288e2db101ba3$var$Gj = Infinity, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Oi = !1, $b36288e2db101ba3$var$Pi = null, $b36288e2db101ba3$var$Ri = null, $b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = null, $b36288e2db101ba3$var$xk = 0, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, $b36288e2db101ba3$var$Ak = -1, $b36288e2db101ba3$var$Bk = 0;
function $b36288e2db101ba3$var$R() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$Ak : $b36288e2db101ba3$var$Ak = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Bk && ($b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Bk;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$gi(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$yk) throw $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$Q) a === $b36288e2db101ba3$var$Q && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$qk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Ck(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Dk(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Dk(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Ek.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Ek.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Fk(c, $b36288e2db101ba3$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Gk(a, b) {
    $b36288e2db101ba3$var$Ak = -1;
    $b36288e2db101ba3$var$Bk = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Hk() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Ik(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Jk();
        if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Kk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Lk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Mk(a, h);
        }
        $b36288e2db101ba3$var$$g();
        $b36288e2db101ba3$var$mk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Nk(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Ok(e) && (b = $b36288e2db101ba3$var$Ik(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Nk(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$fk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Gk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    var c = $b36288e2db101ba3$var$sk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Kk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Ik(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$tk = c, null !== b && $b36288e2db101ba3$var$Fj(b));
    return a;
}
function $b36288e2db101ba3$var$Fj(a) {
    null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = a : $b36288e2db101ba3$var$tk.push.apply($b36288e2db101ba3$var$tk, a);
}
function $b36288e2db101ba3$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Ck(a, b) {
    b &= ~$b36288e2db101ba3$var$rk;
    b &= ~$b36288e2db101ba3$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Ek(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Nk(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, b), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Qk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Rk(a) {
    null !== $b36288e2db101ba3$var$wk && 0 === $b36288e2db101ba3$var$wk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$ok.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$ok.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Hj() {
    $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$ej.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$ej);
}
function $b36288e2db101ba3$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$zh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Eh();
                break;
            case 5:
                $b36288e2db101ba3$var$Bh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$zh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 10:
                $b36288e2db101ba3$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Hj();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$Q = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$Pg(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$fj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$pk = null;
    $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$qk = $b36288e2db101ba3$var$rh = 0;
    $b36288e2db101ba3$var$tk = $b36288e2db101ba3$var$sk = null;
    if (null !== $b36288e2db101ba3$var$fh) {
        for(b = 0; b < $b36288e2db101ba3$var$fh.length; b++)if (c = $b36288e2db101ba3$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$fh = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Mk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$$g();
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
            if ($b36288e2db101ba3$var$Ih) {
                for(var d = $b36288e2db101ba3$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Ih = !1;
            }
            $b36288e2db101ba3$var$Hh = 0;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            $b36288e2db101ba3$var$nk.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$pk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Si(f, l, b);
                            $b36288e2db101ba3$var$tj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Vi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ji(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$sk ? $b36288e2db101ba3$var$sk = [
                    f
                ] : $b36288e2db101ba3$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Ni(f, k, b);
                            $b36288e2db101ba3$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Qi(f, h, b);
                                $b36288e2db101ba3$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Sk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Jk() {
    var a = $b36288e2db101ba3$var$mk.current;
    $b36288e2db101ba3$var$mk.current = $b36288e2db101ba3$var$Rh;
    return null === a ? $b36288e2db101ba3$var$Rh : a;
}
function $b36288e2db101ba3$var$tj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$Q || 0 === ($b36288e2db101ba3$var$rh & 268435455) && 0 === ($b36288e2db101ba3$var$qk & 268435455) || $b36288e2db101ba3$var$Ck($b36288e2db101ba3$var$Q, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Ik(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Jk();
    if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Kk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Tk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Mk(a, e);
    }
    $b36288e2db101ba3$var$$g();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$mk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$Q = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Tk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Lk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Uk(a) {
    var b = $b36288e2db101ba3$var$Vk(a.alternate, a, $b36288e2db101ba3$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Sk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$nk.current = null;
}
function $b36288e2db101ba3$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Ej(c, b, $b36288e2db101ba3$var$fj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Pk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$ok.transition;
    try {
        $b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Wk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$ok.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Wk(a, b, c, d) {
    do $b36288e2db101ba3$var$Hk();
    while (null !== $b36288e2db101ba3$var$wk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$Q && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$vk || ($b36288e2db101ba3$var$vk = !0, $b36288e2db101ba3$var$Fk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$ok.transition;
        $b36288e2db101ba3$var$ok.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$nk.current = null;
        $b36288e2db101ba3$var$Oj(a, c);
        $b36288e2db101ba3$var$dk(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$hk(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$ok.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$vk && ($b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = a, $b36288e2db101ba3$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Ri = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Oi) throw $b36288e2db101ba3$var$Oi = !1, a = $b36288e2db101ba3$var$Pi, $b36288e2db101ba3$var$Pi = null, a;
    0 !== ($b36288e2db101ba3$var$xk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$zk ? $b36288e2db101ba3$var$yk++ : ($b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = a) : $b36288e2db101ba3$var$yk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Hk() {
    if (null !== $b36288e2db101ba3$var$wk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$xk), b = $b36288e2db101ba3$var$ok.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$ok.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$wk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$wk;
                $b36288e2db101ba3$var$wk = null;
                $b36288e2db101ba3$var$xk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Sj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$ok.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Xk(a, b, c) {
    b = $b36288e2db101ba3$var$Ji(c, b);
    b = $b36288e2db101ba3$var$Ni(a, b, 1);
    a = $b36288e2db101ba3$var$nh(a, b, 1);
    b = $b36288e2db101ba3$var$R();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Dk(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(d))) {
                a = $b36288e2db101ba3$var$Ji(c, a);
                a = $b36288e2db101ba3$var$Qi(b, a, 1);
                b = $b36288e2db101ba3$var$nh(b, a, 1);
                a = $b36288e2db101ba3$var$R();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$Q === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$fk ? $b36288e2db101ba3$var$Kk(a, 0) : $b36288e2db101ba3$var$rk |= c);
    $b36288e2db101ba3$var$Dk(a, b);
}
function $b36288e2db101ba3$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$R();
    a = $b36288e2db101ba3$var$ih(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Dk(a, c));
}
function $b36288e2db101ba3$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Yk(a, c);
}
function $b36288e2db101ba3$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Yk(a, c);
}
var $b36288e2db101ba3$var$Vk;
$b36288e2db101ba3$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$yj(a, b, c);
            $b36288e2db101ba3$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$ij(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$ch(b, c);
            e = $b36288e2db101ba3$var$Nh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$kh(b), e.updater = $b36288e2db101ba3$var$Ei, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$Ii(b, d, a, c), b = $b36288e2db101ba3$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$Zk(d);
                a = $b36288e2db101ba3$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$$i(null, b, d, $b36288e2db101ba3$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$kj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$lh(a, b);
                $b36288e2db101ba3$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$Zi(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Ah(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$gj(a, b), $b36288e2db101ba3$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$oj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Ug(b, null, d, c) : $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$Yi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$ch(b, c), e = $b36288e2db101ba3$var$eh(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Ci(d, b.pendingProps), e = $b36288e2db101ba3$var$Ci(d.type, e), $b36288e2db101ba3$var$$i(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$ij(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$ch(b, c), $b36288e2db101ba3$var$Gi(b, d, e), $b36288e2db101ba3$var$Ii(b, d, e, c), $b36288e2db101ba3$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$xj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$dj(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Fk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$$k(a, b, c, d);
}
function $b36288e2db101ba3$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$Zk(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Tg(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Tg(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$pj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$Qg(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$kh(f);
    return a;
}
function $b36288e2db101ba3$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$dl(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$dl(null);
    c = a.current;
    d = $b36288e2db101ba3$var$R();
    e = $b36288e2db101ba3$var$yi(c);
    f = $b36288e2db101ba3$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$nh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Dk(a, d);
    return a;
}
function $b36288e2db101ba3$var$fl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$R(), g = $b36288e2db101ba3$var$yi(e);
    c = $b36288e2db101ba3$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$nh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$gi(a, e, g, f), $b36288e2db101ba3$var$oh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    $b36288e2db101ba3$var$hl(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$hl(a, b);
}
function $b36288e2db101ba3$var$jl() {
    return null;
}
var $b36288e2db101ba3$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ll(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.render = $b36288e2db101ba3$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$fl(a, b, null, null);
};
$b36288e2db101ba3$var$ml.prototype.unmount = $b36288e2db101ba3$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Rk(function() {
            $b36288e2db101ba3$var$fl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$pl() {}
function $b36288e2db101ba3$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$el(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$pl);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$gl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$bl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$pl);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$fl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$fl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$ql(c, b, a, e, d);
    return $b36288e2db101ba3$var$gl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Dk(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Rk(function() {
                var b = $b36288e2db101ba3$var$ih(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$R();
                    $b36288e2db101ba3$var$gi(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$il(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$il(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$yi(a), c = $b36288e2db101ba3$var$ih(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(c, a, b, d);
        }
        $b36288e2db101ba3$var$il(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Rk;
var $b36288e2db101ba3$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Qk
    ]
}, $b36288e2db101ba3$var$tl = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$ul = {
    bundleType: $b36288e2db101ba3$var$tl.bundleType,
    version: $b36288e2db101ba3$var$tl.version,
    rendererPackageName: $b36288e2db101ba3$var$tl.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$tl.findFiberByHostInstance || $b36288e2db101ba3$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$vl.isDisabled && $b36288e2db101ba3$var$vl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$vl.inject($b36288e2db101ba3$var$ul), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$vl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$sl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$nl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$cl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ll(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Rk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$ol(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$rl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("4LCdk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
'use strict';
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRegister("10WBQ", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $0bd3411f2ec14e23$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("99w1R")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("99w1R")).useNavigate; });
/**
 * React Router DOM v6.28.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $fSADM = parcelRequire("fSADM");
var $99w1R = parcelRequire("99w1R");

var $fSADM = parcelRequire("fSADM");
function $0bd3411f2ec14e23$var$_extends() {
    $0bd3411f2ec14e23$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0bd3411f2ec14e23$var$_extends.apply(this, arguments);
}
function $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0bd3411f2ec14e23$var$defaultMethod = "get";
const $0bd3411f2ec14e23$var$defaultEncType = "application/x-www-form-urlencoded";
function $0bd3411f2ec14e23$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0bd3411f2ec14e23$var$isButtonElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0bd3411f2ec14e23$var$isFormElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0bd3411f2ec14e23$var$isInputElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0bd3411f2ec14e23$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0bd3411f2ec14e23$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0bd3411f2ec14e23$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = null;
function $0bd3411f2ec14e23$var$isFormDataSubmitterSupported() {
    if ($0bd3411f2ec14e23$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = true;
    }
    return $0bd3411f2ec14e23$var$_formDataSupportsSubmitter;
}
const $0bd3411f2ec14e23$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0bd3411f2ec14e23$var$getFormEncType(encType) {
    if (encType != null && !$0bd3411f2ec14e23$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0bd3411f2ec14e23$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $fSADM.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0bd3411f2ec14e23$var$isButtonElement(target) || $0bd3411f2ec14e23$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $fSADM.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("formenctype")) || $0bd3411f2ec14e23$var$getFormEncType(form.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0bd3411f2ec14e23$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0bd3411f2ec14e23$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0bd3411f2ec14e23$var$defaultMethod;
        action = null;
        encType = $0bd3411f2ec14e23$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0bd3411f2ec14e23$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $0bd3411f2ec14e23$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $0bd3411f2ec14e23$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0bd3411f2ec14e23$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0bd3411f2ec14e23$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0bd3411f2ec14e23$export$1f3f55432a00e06d(routes, opts) {
    return (0, $fSADM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fSADM.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $99w1R.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0bd3411f2ec14e23$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $fSADM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fSADM.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $99w1R.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0bd3411f2ec14e23$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0bd3411f2ec14e23$var$_extends({}, state, {
        errors: $0bd3411f2ec14e23$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0bd3411f2ec14e23$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $fSADM.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0bd3411f2ec14e23$export$7ad602f0e94e62d1 = /*#__PURE__*/ $bh6RR.createContext({
    isTransitioning: false
});
const $0bd3411f2ec14e23$export$148fd98d095596d4 = /*#__PURE__*/ $bh6RR.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0bd3411f2ec14e23$var$START_TRANSITION = "startTransition";
const $0bd3411f2ec14e23$var$startTransitionImpl = $bh6RR[$0bd3411f2ec14e23$var$START_TRANSITION];
const $0bd3411f2ec14e23$var$FLUSH_SYNC = "flushSync";
const $0bd3411f2ec14e23$var$flushSyncImpl = $6afFj[$0bd3411f2ec14e23$var$FLUSH_SYNC];
const $0bd3411f2ec14e23$var$USE_ID = "useId";
const $0bd3411f2ec14e23$var$useIdImpl = $bh6RR[$0bd3411f2ec14e23$var$USE_ID];
function $0bd3411f2ec14e23$var$startTransitionSafe(cb) {
    if ($0bd3411f2ec14e23$var$startTransitionImpl) $0bd3411f2ec14e23$var$startTransitionImpl(cb);
    else cb();
}
function $0bd3411f2ec14e23$var$flushSyncSafe(cb) {
    if ($0bd3411f2ec14e23$var$flushSyncImpl) $0bd3411f2ec14e23$var$flushSyncImpl(cb);
    else cb();
}
class $0bd3411f2ec14e23$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0bd3411f2ec14e23$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let [pendingState, setPendingState] = $bh6RR.useState();
    let [vtContext, setVtContext] = $bh6RR.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $bh6RR.useState();
    let [transition, setTransition] = $bh6RR.useState();
    let [interruption, setInterruption] = $bh6RR.useState();
    let fetcherData = $bh6RR.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $bh6RR.useCallback((cb)=>{
        if (v7_startTransition) $0bd3411f2ec14e23$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $bh6RR.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0bd3411f2ec14e23$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0bd3411f2ec14e23$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0bd3411f2ec14e23$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0bd3411f2ec14e23$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0bd3411f2ec14e23$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $bh6RR.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0bd3411f2ec14e23$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $bh6RR.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $bh6RR.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $bh6RR.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $bh6RR.useEffect(()=>(0, $99w1R.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $0bd3411f2ec14e23$var$MemoizedDataRoutes = /*#__PURE__*/ $bh6RR.memo($0bd3411f2ec14e23$var$DataRoutes);
function $0bd3411f2ec14e23$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $99w1R.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fSADM.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $bh6RR.useEffect(()=>(0, $99w1R.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0bd3411f2ec14e23$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fSADM.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $bh6RR.useEffect(()=>(0, $99w1R.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0bd3411f2ec14e23$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $bh6RR.useEffect(()=>(0, $99w1R.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0bd3411f2ec14e23$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0bd3411f2ec14e23$export$a6c7ac8248d6e38a = /*#__PURE__*/ $bh6RR.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref7, $0bd3411f2ec14e23$var$_excluded);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0bd3411f2ec14e23$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $fSADM.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $99w1R.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $0bd3411f2ec14e23$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $bh6RR.createElement("a", $0bd3411f2ec14e23$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0bd3411f2ec14e23$export$b0d92dbee9b5b60d = /*#__PURE__*/ $bh6RR.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref8, $0bd3411f2ec14e23$var$_excluded2);
    let path = (0, $99w1R.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $99w1R.useLocation)();
    let routerState = $bh6RR.useContext((0, $99w1R.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0bd3411f2ec14e23$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $fSADM.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a6c7ac8248d6e38a, $0bd3411f2ec14e23$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0bd3411f2ec14e23$export$a7fed597f4b8afd8 = /*#__PURE__*/ $bh6RR.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0bd3411f2ec14e23$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref9, $0bd3411f2ec14e23$var$_excluded3);
    let submit = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    let formAction = $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $bh6RR.createElement("form", $0bd3411f2ec14e23$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0bd3411f2ec14e23$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0bd3411f2ec14e23$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0bd3411f2ec14e23$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0bd3411f2ec14e23$var$DataRouterHook || ($0bd3411f2ec14e23$var$DataRouterHook = {}));
var $0bd3411f2ec14e23$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0bd3411f2ec14e23$var$DataRouterStateHook || ($0bd3411f2ec14e23$var$DataRouterStateHook = {}));
// Internal hooks
function $0bd3411f2ec14e23$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $0bd3411f2ec14e23$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext((0, $99w1R.UNSAFE_DataRouterContext));
    !ctx && (0, $fSADM.UNSAFE_invariant)(false);
    return ctx;
}
function $0bd3411f2ec14e23$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext((0, $99w1R.UNSAFE_DataRouterStateContext));
    !state && (0, $fSADM.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0bd3411f2ec14e23$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $99w1R.useNavigate)();
    let location = (0, $99w1R.useLocation)();
    let path = (0, $99w1R.useResolvedPath)(to, {
        relative: relative
    });
    return $bh6RR.useCallback((event)=>{
        if ($0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $fSADM.createPath)(location) === (0, $fSADM.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0bd3411f2ec14e23$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $bh6RR.useRef($0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bh6RR.useRef(false);
    let location = (0, $99w1R.useLocation)();
    let searchParams = $bh6RR.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0bd3411f2ec14e23$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $99w1R.useNavigate)();
    let setSearchParams = $bh6RR.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0bd3411f2ec14e23$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0bd3411f2ec14e23$var$fetcherId = 0;
let $0bd3411f2ec14e23$var$getUniqueFetcherId = ()=>"__" + String(++$0bd3411f2ec14e23$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0bd3411f2ec14e23$export$47c85c6e3a081d3() {
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let currentRouteId = (0, $99w1R.UNSAFE_useRouteId)();
    return $bh6RR.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0bd3411f2ec14e23$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0bd3411f2ec14e23$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let routeContext = $bh6RR.useContext((0, $99w1R.UNSAFE_RouteContext));
    !routeContext && (0, $fSADM.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0bd3411f2ec14e23$var$_extends({}, (0, $99w1R.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $99w1R.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fSADM.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $fSADM.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0bd3411f2ec14e23$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseFetcher);
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $bh6RR.useContext($0bd3411f2ec14e23$export$148fd98d095596d4);
    let route = $bh6RR.useContext((0, $99w1R.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $fSADM.UNSAFE_invariant)(false);
    !route && (0, $fSADM.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $fSADM.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0bd3411f2ec14e23$var$useIdImpl ? $0bd3411f2ec14e23$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $bh6RR.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0bd3411f2ec14e23$var$getUniqueFetcherId());
    // Registration/cleanup
    $bh6RR.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $bh6RR.useCallback((href, opts)=>{
        !routeId && (0, $fSADM.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    let submit = $bh6RR.useCallback((target, opts)=>{
        submitImpl(target, $0bd3411f2ec14e23$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $bh6RR.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $bh6RR.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a7fed597f4b8afd8, $0bd3411f2ec14e23$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $fSADM.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $bh6RR.useMemo(()=>$0bd3411f2ec14e23$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0bd3411f2ec14e23$export$fa996778a3a31087() {
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0bd3411f2ec14e23$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0bd3411f2ec14e23$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0bd3411f2ec14e23$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let location = (0, $99w1R.useLocation)();
    let matches = (0, $99w1R.useMatches)();
    let navigation = (0, $99w1R.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $bh6RR.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0bd3411f2ec14e23$var$usePageHide($bh6RR.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0bd3411f2ec14e23$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0bd3411f2ec14e23$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0bd3411f2ec14e23$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0bd3411f2ec14e23$var$_extends({}, location, {
                    pathname: (0, $fSADM.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0bd3411f2ec14e23$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0bd3411f2ec14e23$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $99w1R.useBlocker)(when);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0bd3411f2ec14e23$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $bh6RR.useContext($0bd3411f2ec14e23$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $fSADM.UNSAFE_invariant)(false);
    let { basename: basename } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.useViewTransitionState);
    let path = (0, $99w1R.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $fSADM.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $fSADM.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $fSADM.matchPath)(path.pathname, nextPath) != null || (0, $fSADM.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("6afFj", function(module, exports) {
'use strict';
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

module.exports = (parcelRequire("foRq4"));

});

parcelRegister("fSADM", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $b8f852338811df1a$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $b8f852338811df1a$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $b8f852338811df1a$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $b8f852338811df1a$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $b8f852338811df1a$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $b8f852338811df1a$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $b8f852338811df1a$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $b8f852338811df1a$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $b8f852338811df1a$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $b8f852338811df1a$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $b8f852338811df1a$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $b8f852338811df1a$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $b8f852338811df1a$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $b8f852338811df1a$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $b8f852338811df1a$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $b8f852338811df1a$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $b8f852338811df1a$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $b8f852338811df1a$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $b8f852338811df1a$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $b8f852338811df1a$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $b8f852338811df1a$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $b8f852338811df1a$var$_extends() {
    $b8f852338811df1a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8f852338811df1a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $b8f852338811df1a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($b8f852338811df1a$export$e19cd5f9376f8cee || ($b8f852338811df1a$export$e19cd5f9376f8cee = {}));
const $b8f852338811df1a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $b8f852338811df1a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $b8f852338811df1a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $b8f852338811df1a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $b8f852338811df1a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $b8f852338811df1a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $b8f852338811df1a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $b8f852338811df1a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $b8f852338811df1a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $b8f852338811df1a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $b8f852338811df1a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $b8f852338811df1a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $b8f852338811df1a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $b8f852338811df1a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $b8f852338811df1a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $b8f852338811df1a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($b8f852338811df1a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $b8f852338811df1a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $b8f852338811df1a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($b8f852338811df1a$var$ResultType || ($b8f852338811df1a$var$ResultType = {}));
const $b8f852338811df1a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $b8f852338811df1a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $b8f852338811df1a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $b8f852338811df1a$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($b8f852338811df1a$var$isIndexRoute(route)) {
            let indexRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $b8f852338811df1a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $b8f852338811df1a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $b8f852338811df1a$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $b8f852338811df1a$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $b8f852338811df1a$var$flattenRoutes(routes);
    $b8f852338811df1a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $b8f852338811df1a$export$30d21fd6d7295f52(pathname);
        matches = $b8f852338811df1a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $b8f852338811df1a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $b8f852338811df1a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $b8f852338811df1a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $b8f852338811df1a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $b8f852338811df1a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $b8f852338811df1a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $b8f852338811df1a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $b8f852338811df1a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $b8f852338811df1a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $b8f852338811df1a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $b8f852338811df1a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $b8f852338811df1a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $b8f852338811df1a$var$paramRe = /^:[\w-]+$/;
const $b8f852338811df1a$var$dynamicSegmentValue = 3;
const $b8f852338811df1a$var$indexRouteValue = 2;
const $b8f852338811df1a$var$emptySegmentValue = 1;
const $b8f852338811df1a$var$staticSegmentValue = 10;
const $b8f852338811df1a$var$splatPenalty = -2;
const $b8f852338811df1a$var$isSplat = (s)=>s === "*";
function $b8f852338811df1a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($b8f852338811df1a$var$isSplat)) initialScore += $b8f852338811df1a$var$splatPenalty;
    if (index) initialScore += $b8f852338811df1a$var$indexRouteValue;
    return segments.filter((s)=>!$b8f852338811df1a$var$isSplat(s)).reduce((score, segment)=>score + ($b8f852338811df1a$var$paramRe.test(segment) ? $b8f852338811df1a$var$dynamicSegmentValue : segment === "" ? $b8f852338811df1a$var$emptySegmentValue : $b8f852338811df1a$var$staticSegmentValue), initialScore);
}
function $b8f852338811df1a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $b8f852338811df1a$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $b8f852338811df1a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $b8f852338811df1a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $b8f852338811df1a$export$a5c6d149b50c1d86($b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $b8f852338811df1a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $b8f852338811df1a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $b8f852338811df1a$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $b8f852338811df1a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $b8f852338811df1a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $b8f852338811df1a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $b8f852338811df1a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $b8f852338811df1a$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $b8f852338811df1a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $b8f852338811df1a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $b8f852338811df1a$var$normalizeSearch(search),
        hash: $b8f852338811df1a$var$normalizeHash(hash)
    };
}
function $b8f852338811df1a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $b8f852338811df1a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $b8f852338811df1a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $b8f852338811df1a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $b8f852338811df1a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $b8f852338811df1a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $b8f852338811df1a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $b8f852338811df1a$var$_extends({}, toArg);
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $b8f852338811df1a$var$getInvalidPathError("?", "pathname", "search", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "pathname", "hash", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $b8f852338811df1a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $b8f852338811df1a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $b8f852338811df1a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $b8f852338811df1a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $b8f852338811df1a$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $b8f852338811df1a$export$4051a07651545597(data, init) {
    return new $b8f852338811df1a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $b8f852338811df1a$export$42a99a7a4bc0e76a extends Error {
}
class $b8f852338811df1a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $b8f852338811df1a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $b8f852338811df1a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $b8f852338811df1a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $b8f852338811df1a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $b8f852338811df1a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $b8f852338811df1a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $b8f852338811df1a$var$unwrapTrackedPromise(value) {
    if (!$b8f852338811df1a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $b8f852338811df1a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $b8f852338811df1a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $b8f852338811df1a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $b8f852338811df1a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $b8f852338811df1a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $b8f852338811df1a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $b8f852338811df1a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $b8f852338811df1a$var$validMutationMethods = new Set($b8f852338811df1a$var$validMutationMethodsArr);
const $b8f852338811df1a$var$validRequestMethodsArr = [
    "get",
    ...$b8f852338811df1a$var$validMutationMethodsArr
];
const $b8f852338811df1a$var$validRequestMethods = new Set($b8f852338811df1a$var$validRequestMethodsArr);
const $b8f852338811df1a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $b8f852338811df1a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $b8f852338811df1a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $b8f852338811df1a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $b8f852338811df1a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $b8f852338811df1a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $b8f852338811df1a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $b8f852338811df1a$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$b8f852338811df1a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$b8f852338811df1a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $b8f852338811df1a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $b8f852338811df1a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$b8f852338811df1a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($b8f852338811df1a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $b8f852338811df1a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $b8f852338811df1a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $b8f852338811df1a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($b8f852338811df1a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $b8f852338811df1a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $b8f852338811df1a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $b8f852338811df1a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $b8f852338811df1a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $b8f852338811df1a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $b8f852338811df1a$var$findNearestBoundary(matches).route.id,
            {
                type: $b8f852338811df1a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($b8f852338811df1a$var$isErrorResult(result) && $b8f852338811df1a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $b8f852338811df1a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $b8f852338811df1a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $b8f852338811df1a$var$_extends({
            matches: updatedMatches || matches
        }, $b8f852338811df1a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $b8f852338811df1a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $b8f852338811df1a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $b8f852338811df1a$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $b8f852338811df1a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $b8f852338811df1a$var$ResultType.error,
            error: $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $b8f852338811df1a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isDeferredResult(result)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $b8f852338811df1a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $b8f852338811df1a$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($b8f852338811df1a$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $b8f852338811df1a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $b8f852338811df1a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $b8f852338811df1a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $b8f852338811df1a$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $b8f852338811df1a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $b8f852338811df1a$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $b8f852338811df1a$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$b8f852338811df1a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $b8f852338811df1a$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $b8f852338811df1a$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($b8f852338811df1a$var$isRedirectResult(actionResult) || $b8f852338811df1a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($b8f852338811df1a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $b8f852338811df1a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($b8f852338811df1a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($b8f852338811df1a$var$isDeferredResult(actionResult)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $b8f852338811df1a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $b8f852338811df1a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $b8f852338811df1a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $b8f852338811df1a$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $b8f852338811df1a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $b8f852338811df1a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $b8f852338811df1a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b8f852338811df1a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $b8f852338811df1a$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($b8f852338811df1a$var$isDeferredResult(result)) result = await $b8f852338811df1a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $b8f852338811df1a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $b8f852338811df1a$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $b8f852338811df1a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $b8f852338811df1a$export$e19cd5f9376f8cee.Replace : $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $b8f852338811df1a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($b8f852338811df1a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $b8f852338811df1a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $b8f852338811df1a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $b8f852338811df1a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $b8f852338811df1a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $b8f852338811df1a$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($b8f852338811df1a$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $b8f852338811df1a$var$ResultType.redirect,
                response: $b8f852338811df1a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $b8f852338811df1a$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $b8f852338811df1a$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $b8f852338811df1a$var$ResultType.error,
                    error: $b8f852338811df1a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $b8f852338811df1a$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $b8f852338811df1a$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $b8f852338811df1a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $b8f852338811df1a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $b8f852338811df1a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $b8f852338811df1a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$b8f852338811df1a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $b8f852338811df1a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $b8f852338811df1a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $b8f852338811df1a$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $b8f852338811df1a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $b8f852338811df1a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $b8f852338811df1a$export$4d0306f8f6a4585b = Symbol("deferred");
function $b8f852338811df1a$export$3336b097a6fbc59a(routes, opts) {
    $b8f852338811df1a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $b8f852338811df1a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $b8f852338811df1a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $b8f852338811df1a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$b8f852338811df1a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $b8f852338811df1a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($b8f852338811df1a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $b8f852338811df1a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $b8f852338811df1a$var$isResponse(result) ? result : $b8f852338811df1a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($b8f852338811df1a$var$isDataStrategyResult(e) && $b8f852338811df1a$var$isResponse(e.result)) {
                if (e.type === $b8f852338811df1a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($b8f852338811df1a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($b8f852338811df1a$var$isDeferredResult(result)) {
            let error = $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($b8f852338811df1a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $b8f852338811df1a$var$_extends({}, context, {
                statusCode: $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $b8f852338811df1a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $b8f852338811df1a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $b8f852338811df1a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $b8f852338811df1a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $b8f852338811df1a$var$callDataStrategyImpl(dataStrategy || $b8f852338811df1a$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($b8f852338811df1a$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $b8f852338811df1a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($b8f852338811df1a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $b8f852338811df1a$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $b8f852338811df1a$export$fec11da027c70692(routes, context, error) {
    let newContext = $b8f852338811df1a$var$_extends({}, context, {
        statusCode: $b8f852338811df1a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $b8f852338811df1a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $b8f852338811df1a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $b8f852338811df1a$export$cae722b0cc860f13(to ? to : ".", $b8f852338811df1a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $b8f852338811df1a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $b8f852338811df1a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $b8f852338811df1a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $b8f852338811df1a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$b8f852338811df1a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$b8f852338811df1a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $b8f852338811df1a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $b8f852338811df1a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $b8f852338811df1a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($b8f852338811df1a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $b8f852338811df1a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $b8f852338811df1a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $b8f852338811df1a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $b8f852338811df1a$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $b8f852338811df1a$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($b8f852338811df1a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $b8f852338811df1a$var$shouldRevalidateLoader(match, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $b8f852338811df1a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $b8f852338811df1a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $b8f852338811df1a$var$shouldRevalidateLoader(fetcherMatch, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $b8f852338811df1a$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $b8f852338811df1a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $b8f852338811df1a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $b8f852338811df1a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $b8f852338811df1a$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$b8f852338811df1a$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $b8f852338811df1a$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$b8f852338811df1a$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $b8f852338811df1a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $b8f852338811df1a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $b8f852338811df1a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$b8f852338811df1a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $b8f852338811df1a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $b8f852338811df1a$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $b8f852338811df1a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $b8f852338811df1a$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $b8f852338811df1a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $b8f852338811df1a$var$ResultType.data,
                result: undefined
            });
        };
        return $b8f852338811df1a$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $b8f852338811df1a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $b8f852338811df1a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $b8f852338811df1a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $b8f852338811df1a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $b8f852338811df1a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($b8f852338811df1a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $b8f852338811df1a$var$ResultType.error,
                error: e
            };
        }
        if (type === $b8f852338811df1a$var$ResultType.error) return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: new $b8f852338811df1a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $b8f852338811df1a$var$ResultType.error) {
        if ($b8f852338811df1a$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $b8f852338811df1a$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $b8f852338811df1a$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: result,
            statusCode: $b8f852338811df1a$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($b8f852338811df1a$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $b8f852338811df1a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($b8f852338811df1a$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $b8f852338811df1a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $b8f852338811df1a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $b8f852338811df1a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $b8f852338811df1a$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $b8f852338811df1a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($b8f852338811df1a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $b8f852338811df1a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $b8f852338811df1a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $b8f852338811df1a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($b8f852338811df1a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $b8f852338811df1a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $b8f852338811df1a$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($b8f852338811df1a$var$isErrorResult(result)) {
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $b8f852338811df1a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($b8f852338811df1a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($b8f852338811df1a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $b8f852338811df1a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $b8f852338811df1a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $b8f852338811df1a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $b8f852338811df1a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $b8f852338811df1a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $b8f852338811df1a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $b8f852338811df1a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $b8f852338811df1a$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($b8f852338811df1a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $b8f852338811df1a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(path) : path;
    return $b8f852338811df1a$export$fe53371bee54353d($b8f852338811df1a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $b8f852338811df1a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $b8f852338811df1a$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $b8f852338811df1a$var$ResultType.data || result.type === $b8f852338811df1a$var$ResultType.error);
}
function $b8f852338811df1a$var$isRedirectDataStrategyResultResult(result) {
    return $b8f852338811df1a$var$isResponse(result.result) && $b8f852338811df1a$var$redirectStatusCodes.has(result.result.status);
}
function $b8f852338811df1a$var$isDeferredResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.deferred;
}
function $b8f852338811df1a$var$isErrorResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.error;
}
function $b8f852338811df1a$var$isRedirectResult(result) {
    return (result && result.type) === $b8f852338811df1a$var$ResultType.redirect;
}
function $b8f852338811df1a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $b8f852338811df1a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $b8f852338811df1a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $b8f852338811df1a$var$isRedirectResponse(result) {
    if (!$b8f852338811df1a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $b8f852338811df1a$var$isValidMethod(method) {
    return $b8f852338811df1a$var$validRequestMethods.has(method.toLowerCase());
}
function $b8f852338811df1a$var$isMutationMethod(method) {
    return $b8f852338811df1a$var$validMutationMethods.has(method.toLowerCase());
}
async function $b8f852338811df1a$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($b8f852338811df1a$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $b8f852338811df1a$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $b8f852338811df1a$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($b8f852338811df1a$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $b8f852338811df1a$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $b8f852338811df1a$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $b8f852338811df1a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $b8f852338811df1a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $b8f852338811df1a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $b8f852338811df1a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $b8f852338811df1a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $b8f852338811df1a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $b8f852338811df1a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $b8f852338811df1a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $b8f852338811df1a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $b8f852338811df1a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $b8f852338811df1a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $b8f852338811df1a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $b8f852338811df1a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("99w1R", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $6a9dcc96d11bcd0d$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $6a9dcc96d11bcd0d$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $6a9dcc96d11bcd0d$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $6a9dcc96d11bcd0d$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $6a9dcc96d11bcd0d$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $6a9dcc96d11bcd0d$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $6a9dcc96d11bcd0d$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $6a9dcc96d11bcd0d$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $6a9dcc96d11bcd0d$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $6a9dcc96d11bcd0d$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $6a9dcc96d11bcd0d$export$b273b3273281a049; });
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", function () { return $6a9dcc96d11bcd0d$export$db5148ec97d6af7a; });
$parcel$export(module.exports, "Router", function () { return $6a9dcc96d11bcd0d$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Outlet", function () { return $6a9dcc96d11bcd0d$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $6a9dcc96d11bcd0d$export$52b333d321859367; });
/**
 * React Router v6.28.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

var $fSADM = parcelRequire("fSADM");
function $6a9dcc96d11bcd0d$var$_extends() {
    $6a9dcc96d11bcd0d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a9dcc96d11bcd0d$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6a9dcc96d11bcd0d$export$3add0d5dce533e2e = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$145dfa71566a64dc = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$var$AwaitContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6a9dcc96d11bcd0d$export$26749e8557646306 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$c7914228fb69b0f5 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$9072aa6dd1f93057 = /*#__PURE__*/ $bh6RR.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $6a9dcc96d11bcd0d$var$RouteErrorContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $6a9dcc96d11bcd0d$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $fSADM.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $6a9dcc96d11bcd0d$export$45d76561a5302f2b() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $6a9dcc96d11bcd0d$export$1b3f31771c5d07c() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $6a9dcc96d11bcd0d$export$6c330e8992e8a295(pattern) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { pathname: pathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    return $bh6RR.useMemo(()=>(0, $fSADM.matchPath)(pattern, (0, $fSADM.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6a9dcc96d11bcd0d$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $bh6RR.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $6a9dcc96d11bcd0d$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6a9dcc96d11bcd0d$var$useNavigateStable() : $6a9dcc96d11bcd0d$var$useNavigateUnstable();
}
function $6a9dcc96d11bcd0d$var$useNavigateUnstable() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fSADM.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $fSADM.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fSADM.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$OutletContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $6a9dcc96d11bcd0d$export$4138103a3ae699cc() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(context) {
    let outlet = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fSADM.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $bh6RR.useMemo(()=>(0, $fSADM.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $6a9dcc96d11bcd0d$export$5d3fca4a98652595(routes, locationArg) {
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: parentMatches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $fSADM.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $fSADM.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $fSADM.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $6a9dcc96d11bcd0d$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $fSADM.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $fSADM.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6a9dcc96d11bcd0d$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $fSADM.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6a9dcc96d11bcd0d$var$DefaultErrorComponent() {
    let error = $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2();
    let message = (0, $fSADM.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $bh6RR.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $bh6RR.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6a9dcc96d11bcd0d$var$defaultErrorElement = /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DefaultErrorComponent, null);
class $6a9dcc96d11bcd0d$var$RenderErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $6a9dcc96d11bcd0d$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6a9dcc96d11bcd0d$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $fSADM.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $6a9dcc96d11bcd0d$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $6a9dcc96d11bcd0d$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $bh6RR.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6a9dcc96d11bcd0d$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($6a9dcc96d11bcd0d$var$DataRouterHook || {});
var $6a9dcc96d11bcd0d$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($6a9dcc96d11bcd0d$var$DataRouterStateHook || {});
function $6a9dcc96d11bcd0d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $6a9dcc96d11bcd0d$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    !ctx && (0, $fSADM.UNSAFE_invariant)(false);
    return ctx;
}
function $6a9dcc96d11bcd0d$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext($6a9dcc96d11bcd0d$export$145dfa71566a64dc);
    !state && (0, $fSADM.UNSAFE_invariant)(false);
    return state;
}
function $6a9dcc96d11bcd0d$var$useRouteContext(hookName) {
    let route = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    !route && (0, $fSADM.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $6a9dcc96d11bcd0d$var$useCurrentRouteId(hookName) {
    let route = $6a9dcc96d11bcd0d$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $fSADM.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6a9dcc96d11bcd0d$export$5fc8298006ad9e58() {
    return $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6a9dcc96d11bcd0d$export$d0fd4b7106de2769() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6a9dcc96d11bcd0d$export$600dc272ed516c15() {
    let dataRouterContext = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseRevalidator);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRevalidator);
    return $bh6RR.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6a9dcc96d11bcd0d$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseMatches);
    return $bh6RR.useMemo(()=>matches.map((m)=>(0, $fSADM.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6a9dcc96d11bcd0d$export$1448a5050d252c4d() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6a9dcc96d11bcd0d$export$fd5d37484eab868d(routeId) {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6a9dcc96d11bcd0d$export$fdc00f3f26066d5e() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseActionData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $bh6RR.useContext($6a9dcc96d11bcd0d$var$RouteErrorContext);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $6a9dcc96d11bcd0d$export$78a72ddb39bdd145() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $6a9dcc96d11bcd0d$export$17f53340677d5831() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6a9dcc96d11bcd0d$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6a9dcc96d11bcd0d$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseBlocker);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $bh6RR.useState("");
    let blockerFunction = $bh6RR.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6a9dcc96d11bcd0d$var$_extends({}, currentLocation, {
                pathname: (0, $fSADM.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6a9dcc96d11bcd0d$var$_extends({}, nextLocation, {
                pathname: (0, $fSADM.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $bh6RR.useEffect(()=>{
        let key = String(++$6a9dcc96d11bcd0d$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $bh6RR.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $fSADM.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6a9dcc96d11bcd0d$var$useNavigateStable() {
    let { router: router } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseNavigateStable);
    let id = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6a9dcc96d11bcd0d$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$alreadyWarned$1 = {};
function $6a9dcc96d11bcd0d$var$warningOnce(key, cond, message) {
    if (!cond && !$6a9dcc96d11bcd0d$var$alreadyWarned$1[key]) $6a9dcc96d11bcd0d$var$alreadyWarned$1[key] = true;
}
const $6a9dcc96d11bcd0d$var$alreadyWarned = {};
function $6a9dcc96d11bcd0d$var$warnOnce(key, message) {
    if (!$6a9dcc96d11bcd0d$var$alreadyWarned[message]) {
        $6a9dcc96d11bcd0d$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $6a9dcc96d11bcd0d$var$logDeprecation = (flag, msg, link)=>$6a9dcc96d11bcd0d$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $6a9dcc96d11bcd0d$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $6a9dcc96d11bcd0d$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $6a9dcc96d11bcd0d$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $6a9dcc96d11bcd0d$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $6a9dcc96d11bcd0d$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $6a9dcc96d11bcd0d$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $6a9dcc96d11bcd0d$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6a9dcc96d11bcd0d$var$START_TRANSITION = "startTransition";
const $6a9dcc96d11bcd0d$var$startTransitionImpl = $bh6RR[$6a9dcc96d11bcd0d$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6a9dcc96d11bcd0d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        if (v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl) $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $bh6RR.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $bh6RR.useEffect(()=>$6a9dcc96d11bcd0d$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $6a9dcc96d11bcd0d$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $6a9dcc96d11bcd0d$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fSADM.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl ? $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $bh6RR.useEffect(()=>$6a9dcc96d11bcd0d$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $6a9dcc96d11bcd0d$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let navigate = $6a9dcc96d11bcd0d$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $fSADM.resolveTo)(to, (0, $fSADM.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bh6RR.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $6a9dcc96d11bcd0d$export$910ae8079b2c2852(props) {
    return $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6(_props) {
    (0, $fSADM.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $6a9dcc96d11bcd0d$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $fSADM.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bh6RR.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $6a9dcc96d11bcd0d$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $fSADM.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $bh6RR.useMemo(()=>{
        let trailingPathname = (0, $fSADM.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6a9dcc96d11bcd0d$export$5d3fca4a98652595($6a9dcc96d11bcd0d$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6a9dcc96d11bcd0d$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$ResolveAwait, null, children));
}
var $6a9dcc96d11bcd0d$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($6a9dcc96d11bcd0d$var$AwaitRenderStatus || {});
const $6a9dcc96d11bcd0d$var$neverSettledPromise = new Promise(()=>{});
class $6a9dcc96d11bcd0d$var$AwaitErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error : "_data" in promise ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success : $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && promise._error instanceof (0, $fSADM.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $6a9dcc96d11bcd0d$var$neverSettledPromise;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $6a9dcc96d11bcd0d$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6a9dcc96d11bcd0d$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $6a9dcc96d11bcd0d$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $bh6RR.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bh6RR.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6) && (0, $fSADM.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $fSADM.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6a9dcc96d11bcd0d$export$daf73786167a7f72(matches) {
    return $6a9dcc96d11bcd0d$var$_renderMatches(matches);
}
function $6a9dcc96d11bcd0d$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $bh6RR.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $bh6RR.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $bh6RR.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $6a9dcc96d11bcd0d$export$f30f7e456d254e83(routes, opts) {
    return (0, $fSADM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6a9dcc96d11bcd0d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fSADM.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6a9dcc96d11bcd0d$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("aWtcP", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $7f75f9de48639d3b$export$2881499e37b75b9a; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("cPVO8")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("i2TPN")).useSelector; });
parcelRequire("iUKqV");
parcelRequire("c3MnJ");
var $7KgLo = parcelRequire("7KgLo");
var $bh6RR = parcelRequire("bh6RR");
var $cPVO8 = parcelRequire("cPVO8");
var $i2TPN = parcelRequire("i2TPN");
var $jfISs = parcelRequire("jfISs");
parcelRequire("zQfHN");
var $1lCWl = parcelRequire("1lCWl");

var $krVVU = parcelRequire("krVVU");
const { useContext: $7f75f9de48639d3b$var$useContext, useEffect: $7f75f9de48639d3b$var$useEffect, useRef: $7f75f9de48639d3b$var$useRef, createContext: $7f75f9de48639d3b$var$createContext, createElement: $7f75f9de48639d3b$var$h } = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)));
const $7f75f9de48639d3b$var$SchemaContext = $7f75f9de48639d3b$var$createContext(null);
function $7f75f9de48639d3b$export$2881499e37b75b9a({ store: store, schema: schema, children: children }) {
    return $7f75f9de48639d3b$var$h((0, $7KgLo.default), {
        store: store,
        children: $7f75f9de48639d3b$var$h($7f75f9de48639d3b$var$SchemaContext.Provider, {
            value: schema,
            children: children
        })
    });
}
function $7f75f9de48639d3b$export$aecd9c955413bc92() {
    return $7f75f9de48639d3b$var$useContext($7f75f9de48639d3b$var$SchemaContext);
}
function $7f75f9de48639d3b$export$6ccbb43953eebf8() {
    return (0, $jfISs.useStore)();
}
function $7f75f9de48639d3b$export$14095de704efe3f9(action) {
    const schema = $7f75f9de48639d3b$export$aecd9c955413bc92();
    const id = (0, $krVVU.getIdFromAction)(action);
    return (0, $i2TPN.useSelector)((s)=>schema.loaders.selectById(s, {
            id: id
        }));
}
function $7f75f9de48639d3b$export$eb2799109db70ffd(action) {
    const dispatch = (0, $cPVO8.useDispatch)();
    const loader = $7f75f9de48639d3b$export$14095de704efe3f9(action);
    const trigger = (p)=>{
        if (typeof action === "function") dispatch(action(p));
        else dispatch(action);
    };
    return {
        ...loader,
        trigger: trigger,
        action: action
    };
}
function $7f75f9de48639d3b$export$dd0a697e1782aedd(action) {
    const api = $7f75f9de48639d3b$export$eb2799109db70ffd(action);
    $7f75f9de48639d3b$var$useEffect(()=>{
        api.trigger();
    }, [
        action.payload.key
    ]);
    return api;
}
function $7f75f9de48639d3b$export$c6e89b6bb9436bc0(action) {
    const schema = $7f75f9de48639d3b$export$aecd9c955413bc92();
    const id = action.payload.key;
    const data = (0, $i2TPN.useSelector)((s)=>schema.cache.selectById(s, {
            id: id
        }));
    const query = $7f75f9de48639d3b$export$dd0a697e1782aedd(action);
    return {
        ...query,
        data: data || null
    };
}
function $7f75f9de48639d3b$export$9b85b239e6e33af5(cur, success) {
    const prev = $7f75f9de48639d3b$var$useRef(cur);
    $7f75f9de48639d3b$var$useEffect(()=>{
        if (prev.current.status !== "success" && cur.status === "success") success();
        prev.current = cur;
    }, [
        cur.status
    ]);
}
function $7f75f9de48639d3b$var$Loading({ text: text }) {
    return $7f75f9de48639d3b$var$h("div", null, text);
}
function $7f75f9de48639d3b$export$311ca220e7478cda({ children: children, loading: loading = $7f75f9de48639d3b$var$h($7f75f9de48639d3b$var$Loading) }) {
    const schema = $7f75f9de48639d3b$export$aecd9c955413bc92();
    const ldr = (0, $i2TPN.useSelector)((s)=>schema.loaders.selectById(s, {
            id: (0, $1lCWl.PERSIST_LOADER_ID)
        }));
    if (ldr.status === "error") return $7f75f9de48639d3b$var$h("div", null, ldr.message);
    if (ldr.status !== "success") return loading;
    return children;
}

});
parcelRegister("iUKqV", function(module, exports) {
// https://github.com/tc39/proposal-accessible-object-hasownproperty/blob/main/polyfill.js
if (!Object.hasOwn) Object.defineProperty(Object, "hasOwn", {
    value: function(object, property) {
        if (object == null) throw new TypeError("Cannot convert undefined or null to object");
        return Object.prototype.hasOwnProperty.call(Object(object), property);
    },
    configurable: true,
    enumerable: false,
    writable: true
});

});

parcelRegister("c3MnJ", function(module, exports) {

$parcel$export(module.exports, "action", function () { return (parcelRequire("6wugg")).action; });
$parcel$export(module.exports, "call", function () { return (parcelRequire("15Qbp")).call; });
$parcel$export(module.exports, "createChannel", function () { return (parcelRequire("7NKgG")).createChannel; });
$parcel$export(module.exports, "createContext", function () { return (parcelRequire("lPibo")).createContext; });
$parcel$export(module.exports, "createQueue", function () { return (parcelRequire("dURZw")).createQueue; });
$parcel$export(module.exports, "createScope", function () { return (parcelRequire("kanWf")).createScope; });
$parcel$export(module.exports, "createSignal", function () { return (parcelRequire("5bXcR")).createSignal; });
$parcel$export(module.exports, "each", function () { return (parcelRequire("kGwWV")).each; });
$parcel$export(module.exports, "ensure", function () { return (parcelRequire("8Qg8J")).ensure; });
$parcel$export(module.exports, "Err", function () { return (parcelRequire("2EoHU")).Err; });
$parcel$export(module.exports, "Ok", function () { return (parcelRequire("2EoHU")).Ok; });
$parcel$export(module.exports, "race", function () { return (parcelRequire("j6X2g")).race; });
$parcel$export(module.exports, "resource", function () { return (parcelRequire("6wugg")).resource; });
$parcel$export(module.exports, "SignalQueueFactory", function () { return (parcelRequire("5bXcR")).SignalQueueFactory; });
$parcel$export(module.exports, "sleep", function () { return (parcelRequire("4PPHq")).sleep; });
$parcel$export(module.exports, "spawn", function () { return (parcelRequire("6wugg")).spawn; });
$parcel$export(module.exports, "useAbortSignal", function () { return (parcelRequire("fnVfN")).useAbortSignal; });
$parcel$export(module.exports, "React", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("bh6RR")))); });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("7KgLo")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("cPVO8")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("i2TPN")).useSelector; });
$parcel$export(module.exports, "useStore", function () { return (parcelRequire("jfISs")).useStore; });
$parcel$export(module.exports, "createSelector", function () { return (parcelRequire("1rr1p")).createSelector; });
$parcel$export(module.exports, "enablePatches", function () { return (parcelRequire("9YKpI")).enablePatches; });
$parcel$export(module.exports, "produceWithPatches", function () { return (parcelRequire("9YKpI")).produceWithPatches; });
parcelRequire("6x3PV");
var $6wugg = parcelRequire("6wugg");
var $15Qbp = parcelRequire("15Qbp");
var $7NKgG = parcelRequire("7NKgG");
var $lPibo = parcelRequire("lPibo");
var $dURZw = parcelRequire("dURZw");
var $kanWf = parcelRequire("kanWf");
var $5bXcR = parcelRequire("5bXcR");
var $kGwWV = parcelRequire("kGwWV");
var $8Qg8J = parcelRequire("8Qg8J");
var $2EoHU = parcelRequire("2EoHU");
var $j6X2g = parcelRequire("j6X2g");
var $4PPHq = parcelRequire("4PPHq");
var $fnVfN = parcelRequire("fnVfN");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("2YcCh");
var $7KgLo = parcelRequire("7KgLo");
var $cPVO8 = parcelRequire("cPVO8");
var $i2TPN = parcelRequire("i2TPN");
var $jfISs = parcelRequire("jfISs");

var $1rr1p = parcelRequire("1rr1p");

var $9YKpI = parcelRequire("9YKpI");

});
parcelRegister("6x3PV", function(module, exports) {
$parcel$export(module.exports, "action", function () { return (parcelRequire("6wugg")).action; });
$parcel$export(module.exports, "call", function () { return (parcelRequire("15Qbp")).call; });
$parcel$export(module.exports, "createChannel", function () { return (parcelRequire("7NKgG")).createChannel; });
$parcel$export(module.exports, "createContext", function () { return (parcelRequire("lPibo")).createContext; });
$parcel$export(module.exports, "createQueue", function () { return (parcelRequire("dURZw")).createQueue; });
$parcel$export(module.exports, "createScope", function () { return (parcelRequire("kanWf")).createScope; });
$parcel$export(module.exports, "createSignal", function () { return (parcelRequire("5bXcR")).createSignal; });
$parcel$export(module.exports, "each", function () { return (parcelRequire("kGwWV")).each; });
$parcel$export(module.exports, "ensure", function () { return (parcelRequire("8Qg8J")).ensure; });
$parcel$export(module.exports, "Err", function () { return (parcelRequire("2EoHU")).Err; });
$parcel$export(module.exports, "Ok", function () { return (parcelRequire("2EoHU")).Ok; });
$parcel$export(module.exports, "race", function () { return (parcelRequire("j6X2g")).race; });
$parcel$export(module.exports, "resource", function () { return (parcelRequire("6wugg")).resource; });
$parcel$export(module.exports, "SignalQueueFactory", function () { return (parcelRequire("5bXcR")).SignalQueueFactory; });
$parcel$export(module.exports, "sleep", function () { return (parcelRequire("4PPHq")).sleep; });
$parcel$export(module.exports, "spawn", function () { return (parcelRequire("6wugg")).spawn; });
$parcel$export(module.exports, "useAbortSignal", function () { return (parcelRequire("fnVfN")).useAbortSignal; });
parcelRequire("eRO9f");
parcelRequire("cgAOK");

});
parcelRegister("eRO9f", function(module, exports) {
/**
 * String.prototype.replaceAll() polyfill
 * https://gomakethings.com/how-to-replace-a-section-of-a-string-with-another-one-with-vanilla-js/
 * @author Chris Ferdinandi
 * @license MIT
 */ if (!String.prototype.replaceAll) String.prototype.replaceAll = function(str, newStr) {
    // If a regex pattern
    if (Object.prototype.toString.call(str).toLowerCase() === "[object regexp]") return this.replace(str, newStr);
    // If a string
    return this.replace(new RegExp(str, "g"), newStr);
};

});

parcelRegister("cgAOK", function(module, exports) {
$parcel$export(module.exports, "createChannel", function () { return (parcelRequire("7NKgG")).createChannel; });
$parcel$export(module.exports, "createContext", function () { return (parcelRequire("lPibo")).createContext; });
$parcel$export(module.exports, "action", function () { return (parcelRequire("6wugg")).action; });
$parcel$export(module.exports, "resource", function () { return (parcelRequire("6wugg")).resource; });
$parcel$export(module.exports, "spawn", function () { return (parcelRequire("6wugg")).spawn; });
$parcel$export(module.exports, "call", function () { return (parcelRequire("15Qbp")).call; });
$parcel$export(module.exports, "createScope", function () { return (parcelRequire("kanWf")).createScope; });
$parcel$export(module.exports, "sleep", function () { return (parcelRequire("4PPHq")).sleep; });
$parcel$export(module.exports, "first", function () { return (parcelRequire("j7yHE")).first; });
$parcel$export(module.exports, "useAbortSignal", function () { return (parcelRequire("fnVfN")).useAbortSignal; });
$parcel$export(module.exports, "Err", function () { return (parcelRequire("2EoHU")).Err; });
$parcel$export(module.exports, "Ok", function () { return (parcelRequire("2EoHU")).Ok; });
$parcel$export(module.exports, "each", function () { return (parcelRequire("kGwWV")).each; });
$parcel$export(module.exports, "createQueue", function () { return (parcelRequire("dURZw")).createQueue; });
$parcel$export(module.exports, "createSignal", function () { return (parcelRequire("5bXcR")).createSignal; });
$parcel$export(module.exports, "SignalQueueFactory", function () { return (parcelRequire("5bXcR")).SignalQueueFactory; });
$parcel$export(module.exports, "ensure", function () { return (parcelRequire("8Qg8J")).ensure; });
$parcel$export(module.exports, "race", function () { return (parcelRequire("j6X2g")).race; });
parcelRequire("h85F2");
parcelRequire("7NKgG");
parcelRequire("lPibo");
parcelRequire("6wugg");
parcelRequire("15Qbp");
parcelRequire("bFL3r");
parcelRequire("4PPHq");
parcelRequire("j7yHE");
parcelRequire("cZInJ");
parcelRequire("fnVfN");
parcelRequire("2EoHU");
parcelRequire("e0p8q");
parcelRequire("46GC1");
parcelRequire("jq6WH");
parcelRequire("3jbA0");
parcelRequire("ciUsu");
parcelRequire("4oBLs");
parcelRequire("36Me7");
parcelRequire("kGwWV");
parcelRequire("dURZw");
parcelRequire("5bXcR");
parcelRequire("8Qg8J");
parcelRequire("j6X2g");

});
parcelRegister("h85F2", function(module, exports) {

});

parcelRegister("7NKgG", function(module, exports) {

$parcel$export(module.exports, "createChannel", function () { return $5ae0ffe5b1e94a4c$export$47ab4c33d77e344d; });

var $5bXcR = parcelRequire("5bXcR");

var $3jbA0 = parcelRequire("3jbA0");
function $5ae0ffe5b1e94a4c$export$47ab4c33d77e344d() {
    let signal = (0, $5bXcR.createSignal)();
    return {
        send: (0, $3jbA0.lift)(signal.send),
        close: (0, $3jbA0.lift)(signal.close),
        subscribe: signal.subscribe
    };
}

});
parcelRegister("5bXcR", function(module, exports) {

$parcel$export(module.exports, "SignalQueueFactory", function () { return $3c7be7ffcd840cbb$export$4d29b3831fcda320; });
$parcel$export(module.exports, "createSignal", function () { return $3c7be7ffcd840cbb$export$c1e1e1ecbbe76a5; });

var $dURZw = parcelRequire("dURZw");

var $6wugg = parcelRequire("6wugg");

var $lPibo = parcelRequire("lPibo");
const $3c7be7ffcd840cbb$export$4d29b3831fcda320 = (0, $lPibo.createContext)("Signal.createQueue", (0, $dURZw.createQueue));
function $3c7be7ffcd840cbb$export$c1e1e1ecbbe76a5() {
    let subscribers = new Set();
    let useSubscription = (0, $6wugg.resource)(function*(provide) {
        let newQueue = yield* $3c7be7ffcd840cbb$export$4d29b3831fcda320;
        let queue = newQueue();
        subscribers.add(queue);
        try {
            yield* provide({
                next: queue.next
            });
        } finally{
            subscribers.delete(queue);
        }
    });
    function send(value) {
        for (let queue of [
            ...subscribers
        ])queue.add(value);
    }
    function close(value) {
        for (let queue of [
            ...subscribers
        ])queue.close(value);
    }
    return {
        send: send,
        close: close,
        subscribe: ()=>useSubscription
    };
}

});
parcelRegister("dURZw", function(module, exports) {

$parcel$export(module.exports, "createQueue", function () { return $a21a62ddb3fe4193$export$d16acf4b6e75743d; });

var $cUhaT = parcelRequire("cUhaT");
function $a21a62ddb3fe4193$export$d16acf4b6e75743d() {
    let items = [];
    let consumers = new Set();
    function enqueue(item) {
        items.unshift(item);
        while(items.length > 0 && consumers.size > 0){
            let [consume] = consumers;
            let top = items.pop();
            consume(top);
        }
    }
    return {
        add: (value)=>enqueue({
                done: false,
                value: value
            }),
        close: (value)=>enqueue({
                done: true,
                value: value
            }),
        *next () {
            let item = items.pop();
            if (item) return item;
            else return yield* (0, $cUhaT.pause)((resolve)=>{
                consumers.add(resolve);
                return ()=>consumers.delete(resolve);
            });
        }
    };
}

});
parcelRegister("cUhaT", function(module, exports) {

$parcel$export(module.exports, "pause", function () { return $96580983b90612a6$export$229c72e5fdee233b; });

var $2EoHU = parcelRequire("2EoHU");
parcelRequire("KLiMo");
var $f3Mwk = parcelRequire("f3Mwk");
function* $96580983b90612a6$export$229c72e5fdee233b(install) {
    let uninstall = ()=>{};
    try {
        return yield function pause_i() {
            return (0, $f3Mwk.shift)(function*(k) {
                let resolve = (value)=>k.tail((0, $2EoHU.Ok)(value));
                let reject = (error)=>k.tail((0, $2EoHU.Err)(error));
                uninstall = install(resolve, reject);
            });
        };
    } finally{
        if (uninstall) uninstall();
    }
}

});
parcelRegister("2EoHU", function(module, exports) {

$parcel$export(module.exports, "Ok", function () { return $1ee27b888816be67$export$8146e38189b4f4dc; });
$parcel$export(module.exports, "Err", function () { return $1ee27b888816be67$export$3659d3f2d3dfceb8; });
/**
 * @ignore
 */ const $1ee27b888816be67$export$8146e38189b4f4dc = (value)=>({
        ok: true,
        value: value
    });
const $1ee27b888816be67$export$3659d3f2d3dfceb8 = (error)=>({
        ok: false,
        error: error
    });

});

parcelRegister("KLiMo", function(module, exports) {
$parcel$export(module.exports, "evaluate", function () { return (parcelRequire("f3Mwk")).evaluate; });
$parcel$export(module.exports, "reset", function () { return (parcelRequire("f3Mwk")).reset; });
$parcel$export(module.exports, "shift", function () { return (parcelRequire("f3Mwk")).shift; });

var $lD6n5 = parcelRequire("lD6n5");
parcelRequire("f3Mwk");

});
parcelRegister("lD6n5", function(module, exports) {
// Copyright 2018-2022 the Deno authors. All rights reserved. MIT license.
/** A library of assertion functions.
 *
 * This module is browser compatible, but do not rely on good formatting of
 * values for AssertionError messages in browsers.
 *
 * @module
 */ 
var $3oZDH = parcelRequire("3oZDH");

var $etaz3 = parcelRequire("etaz3");

var $4PcZK = parcelRequire("4PcZK");
const $fbf22eb2d80c5977$var$CAN_NOT_DISPLAY = "[Cannot display]";
class $fbf22eb2d80c5977$export$7750cdfb4db2c3d extends Error {
    constructor(message){
        super(message);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AssertionError"
        });
    }
}
function $fbf22eb2d80c5977$var$isKeyedCollection(x) {
    return [
        Symbol.iterator,
        "size"
    ].every((k)=>k in x);
}
function $fbf22eb2d80c5977$export$411ce8e5a71e3069(c, d) {
    const seen = new Map();
    return function compare(a, b) {
        // Have to render RegExp & Date for string comparison
        // unless it's mistreated as object
        if (a && b && (a instanceof RegExp && b instanceof RegExp || a instanceof URL && b instanceof URL)) return String(a) === String(b);
        if (a instanceof Date && b instanceof Date) {
            const aTime = a.getTime();
            const bTime = b.getTime();
            // Check for NaN equality manually since NaN is not
            // equal to itself.
            if (Number.isNaN(aTime) && Number.isNaN(bTime)) return true;
            return aTime === bTime;
        }
        if (typeof a === "number" && typeof b === "number") return Number.isNaN(a) && Number.isNaN(b) || a === b;
        if (Object.is(a, b)) return true;
        if (a && typeof a === "object" && b && typeof b === "object") {
            if (a && b && !$fbf22eb2d80c5977$var$constructorsEqual(a, b)) return false;
            if (a instanceof WeakMap || b instanceof WeakMap) {
                if (!(a instanceof WeakMap && b instanceof WeakMap)) return false;
                throw new TypeError("cannot compare WeakMap instances");
            }
            if (a instanceof WeakSet || b instanceof WeakSet) {
                if (!(a instanceof WeakSet && b instanceof WeakSet)) return false;
                throw new TypeError("cannot compare WeakSet instances");
            }
            if (seen.get(a) === b) return true;
            if (Object.keys(a || {}).length !== Object.keys(b || {}).length) return false;
            seen.set(a, b);
            if ($fbf22eb2d80c5977$var$isKeyedCollection(a) && $fbf22eb2d80c5977$var$isKeyedCollection(b)) {
                if (a.size !== b.size) return false;
                let unmatchedEntries = a.size;
                for (const [aKey, aValue] of a.entries()){
                    for (const [bKey, bValue] of b.entries())/* Given that Map keys can be references, we need
                         * to ensure that they are also deeply equal */ if (aKey === aValue && bKey === bValue && compare(aKey, bKey) || compare(aKey, bKey) && compare(aValue, bValue)) {
                        unmatchedEntries--;
                        break;
                    }
                }
                return unmatchedEntries === 0;
            }
            const merged = {
                ...a,
                ...b
            };
            for (const key of [
                ...Object.getOwnPropertyNames(merged),
                ...Object.getOwnPropertySymbols(merged)
            ]){
                if (!compare(a && a[key], b && b[key])) return false;
                if (key in a && !(key in b) || key in b && !(key in a)) return false;
            }
            if (a instanceof WeakRef || b instanceof WeakRef) {
                if (!(a instanceof WeakRef && b instanceof WeakRef)) return false;
                return compare(a.deref(), b.deref());
            }
            return true;
        }
        return false;
    }(c, d);
}
// deno-lint-ignore ban-types
function $fbf22eb2d80c5977$var$constructorsEqual(a, b) {
    return a.constructor === b.constructor || a.constructor === Object && !b.constructor || !a.constructor && b.constructor === Object;
}
function $fbf22eb2d80c5977$export$a7a9523472993e97(expr, msg = "") {
    if (!expr) throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg);
}
function $fbf22eb2d80c5977$export$ae7f36b9ea08dbe(expr, msg = "") {
    if (expr) throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg);
}
function $fbf22eb2d80c5977$export$e134c4533d64905e(actual, expected, msg) {
    if ($fbf22eb2d80c5977$export$411ce8e5a71e3069(actual, expected)) return;
    let message = "";
    const actualString = (0, $4PcZK.format)(actual);
    const expectedString = (0, $4PcZK.format)(expected);
    try {
        const stringDiff = typeof actual === "string" && typeof expected === "string";
        const diffResult = stringDiff ? (0, $etaz3.diffstr)(actual, expected) : (0, $etaz3.diff)(actualString.split("\n"), expectedString.split("\n"));
        const diffMsg = (0, $etaz3.buildMessage)(diffResult, {
            stringDiff: stringDiff
        }).join("\n");
        message = `Values are not equal:\n${diffMsg}`;
    } catch  {
        message = `\n${(0, $3oZDH.red)($fbf22eb2d80c5977$var$CAN_NOT_DISPLAY)} + \n\n`;
    }
    if (msg) message = msg;
    throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(message);
}
function $fbf22eb2d80c5977$export$3ac5774dc0ce0719(actual, expected, msg) {
    if (!$fbf22eb2d80c5977$export$411ce8e5a71e3069(actual, expected)) return;
    let actualString;
    let expectedString;
    try {
        actualString = String(actual);
    } catch  {
        actualString = "[Cannot display]";
    }
    try {
        expectedString = String(expected);
    } catch  {
        expectedString = "[Cannot display]";
    }
    if (!msg) msg = `actual: ${actualString} expected not to be: ${expectedString}`;
    throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg);
}
function $fbf22eb2d80c5977$export$71e86289af19032d(actual, expected, msg) {
    if (Object.is(actual, expected)) return;
    let message;
    if (msg) message = msg;
    else {
        const actualString = (0, $4PcZK.format)(actual);
        const expectedString = (0, $4PcZK.format)(expected);
        if (actualString === expectedString) {
            const withOffset = actualString.split("\n").map((l)=>`    ${l}`).join("\n");
            message = `Values have the same structure but are not reference-equal:\n\n${(0, $3oZDH.red)(withOffset)}\n`;
        } else try {
            const stringDiff = typeof actual === "string" && typeof expected === "string";
            const diffResult = stringDiff ? (0, $etaz3.diffstr)(actual, expected) : (0, $etaz3.diff)(actualString.split("\n"), expectedString.split("\n"));
            const diffMsg = (0, $etaz3.buildMessage)(diffResult, {
                stringDiff: stringDiff
            }).join("\n");
            message = `Values are not strictly equal:\n${diffMsg}`;
        } catch  {
            message = `\n${(0, $3oZDH.red)($fbf22eb2d80c5977$var$CAN_NOT_DISPLAY)} + \n\n`;
        }
    }
    throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(message);
}
function $fbf22eb2d80c5977$export$292d574bd3c1ab9e(actual, expected, msg) {
    if (!Object.is(actual, expected)) return;
    throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg ?? `Expected "actual" to be strictly unequal to: ${(0, $4PcZK.format)(actual)}\n`);
}
function $fbf22eb2d80c5977$export$644d5912a4ca7138(actual, expected, tolerance = 1e-7, msg) {
    if (Object.is(actual, expected)) return;
    const delta = Math.abs(expected - actual);
    if (delta <= tolerance) return;
    const f = (n)=>Number.isInteger(n) ? n : n.toExponential();
    throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg ?? `actual: "${f(actual)}" expected to be close to "${f(expected)}": \
delta "${f(delta)}" is greater than "${f(tolerance)}"`);
}
function $fbf22eb2d80c5977$export$a5d83b356248b8b4(actual, expectedType, msg = "") {
    if (!msg) {
        const expectedTypeStr = expectedType.name;
        let actualTypeStr = "";
        if (actual === null) actualTypeStr = "null";
        else if (actual === undefined) actualTypeStr = "undefined";
        else if (typeof actual === "object") actualTypeStr = actual.constructor?.name ?? "Object";
        else actualTypeStr = typeof actual;
        if (expectedTypeStr == actualTypeStr) msg = `Expected object to be an instance of "${expectedTypeStr}".`;
        else if (actualTypeStr == "function") msg = `Expected object to be an instance of "${expectedTypeStr}" but was not an instanced object.`;
        else msg = `Expected object to be an instance of "${expectedTypeStr}" but was "${actualTypeStr}".`;
    }
    $fbf22eb2d80c5977$export$a7a9523472993e97(actual instanceof expectedType, msg);
}
function $fbf22eb2d80c5977$export$c9435fd6216a104f(actual, // deno-lint-ignore no-explicit-any
unexpectedType, msg = `Expected object to not be an instance of "${typeof unexpectedType}"`) {
    $fbf22eb2d80c5977$export$ae7f36b9ea08dbe(actual instanceof unexpectedType, msg);
}
function $fbf22eb2d80c5977$export$131d4c09c3e294fc(actual, msg) {
    if (actual === undefined || actual === null) {
        if (!msg) msg = `actual: "${actual}" expected to not be null or undefined`;
        throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg);
    }
}
function $fbf22eb2d80c5977$export$4db800548eab00c6(actual, expected, msg) {
    if (!actual.includes(expected)) {
        if (!msg) msg = `actual: "${actual}" expected to contain: "${expected}"`;
        throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg);
    }
}
function $fbf22eb2d80c5977$export$2c090c31a84fdc7(actual, expected, msg) {
    const missing = [];
    for(let i = 0; i < expected.length; i++){
        let found = false;
        for(let j = 0; j < actual.length; j++)if ($fbf22eb2d80c5977$export$411ce8e5a71e3069(expected[i], actual[j])) {
            found = true;
            break;
        }
        if (!found) missing.push(expected[i]);
    }
    if (missing.length === 0) return;
    if (!msg) msg = `actual: "${(0, $4PcZK.format)(actual)}" expected to include: "${(0, $4PcZK.format)(expected)}"\nmissing: ${(0, $4PcZK.format)(missing)}`;
    throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg);
}
function $fbf22eb2d80c5977$export$9dbdf0fe7818d91d(actual, expected, msg) {
    if (!expected.test(actual)) {
        if (!msg) msg = `actual: "${actual}" expected to match: "${expected}"`;
        throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg);
    }
}
function $fbf22eb2d80c5977$export$70e86346d86f9df1(actual, expected, msg) {
    if (expected.test(actual)) {
        if (!msg) msg = `actual: "${actual}" expected to not match: "${expected}"`;
        throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg);
    }
}
function $fbf22eb2d80c5977$export$ab92f6b8f3e3f9e(// deno-lint-ignore no-explicit-any
actual, expected) {
    function filter(a, b) {
        const seen = new WeakMap();
        return fn(a, b);
        function fn(a, b) {
            // Prevent infinite loop with circular references with same filter
            if (seen.has(a) && seen.get(a) === b) return a;
            seen.set(a, b);
            // Filter keys and symbols which are present in both actual and expected
            const filtered = {};
            const entries = [
                ...Object.getOwnPropertyNames(a),
                ...Object.getOwnPropertySymbols(a)
            ].filter((key)=>key in b).map((key)=>[
                    key,
                    a[key]
                ]);
            for (const [key, value] of entries){
                // On array references, build a filtered array and filter nested objects inside
                if (Array.isArray(value)) {
                    const subset = b[key];
                    if (Array.isArray(subset)) {
                        filtered[key] = fn({
                            ...value
                        }, {
                            ...subset
                        });
                        continue;
                    }
                } else if (value instanceof RegExp) {
                    filtered[key] = value;
                    continue;
                } else if (typeof value === "object") {
                    const subset = b[key];
                    if (typeof subset === "object" && subset) {
                        // When both operands are maps, build a filtered map with common keys and filter nested objects inside
                        if (value instanceof Map && subset instanceof Map) {
                            filtered[key] = new Map([
                                ...value
                            ].filter(([k])=>subset.has(k)).map(([k, v])=>[
                                    k,
                                    typeof v === "object" ? fn(v, subset.get(k)) : v
                                ]));
                            continue;
                        }
                        // When both operands are set, build a filtered set with common values
                        if (value instanceof Set && subset instanceof Set) {
                            filtered[key] = new Set([
                                ...value
                            ].filter((v)=>subset.has(v)));
                            continue;
                        }
                        filtered[key] = fn(value, subset);
                        continue;
                    }
                }
                filtered[key] = value;
            }
            return filtered;
        }
    }
    return $fbf22eb2d80c5977$export$e134c4533d64905e(// get the intersection of "actual" and "expected"
    // side effect: all the instances' constructor field is "Object" now.
    filter(actual, expected), // set (nested) instances' constructor field to be "Object" without changing expected value.
    // see https://github.com/denoland/deno_std/pull/1419
    filter(expected, expected));
}
function $fbf22eb2d80c5977$export$2b62a06a9fee979c(msg) {
    $fbf22eb2d80c5977$export$a7a9523472993e97(false, `Failed assertion${msg ? `: ${msg}` : "."}`);
}
function $fbf22eb2d80c5977$export$4558d041008ef9f0(error, // deno-lint-ignore no-explicit-any
ErrorClass, msgIncludes, msg) {
    if (error instanceof Error === false) throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(`Expected "error" to be an Error object.`);
    if (ErrorClass && !(error instanceof ErrorClass)) {
        msg = `Expected error to be instance of "${ErrorClass.name}", but was "${typeof error === "object" ? error?.constructor?.name : "[not an object]"}"${msg ? `: ${msg}` : "."}`;
        throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg);
    }
    if (msgIncludes && (!(error instanceof Error) || !(0, $3oZDH.stripColor)(error.message).includes((0, $3oZDH.stripColor)(msgIncludes)))) {
        msg = `Expected error message to include "${msgIncludes}", but got "${error instanceof Error ? error.message : "[not an Error]"}"${msg ? `: ${msg}` : "."}`;
        throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg);
    }
}
function $fbf22eb2d80c5977$export$da20efeb0558aa77(fn, errorClassOrCallbackOrMsg, msgIncludesOrMsg, msg) {
    // deno-lint-ignore no-explicit-any
    let ErrorClass = undefined;
    let msgIncludes = undefined;
    let errorCallback = undefined;
    let err;
    if (typeof errorClassOrCallbackOrMsg !== "string") {
        if (errorClassOrCallbackOrMsg === undefined || errorClassOrCallbackOrMsg.prototype instanceof Error || errorClassOrCallbackOrMsg.prototype === Error.prototype) {
            // deno-lint-ignore no-explicit-any
            ErrorClass = errorClassOrCallbackOrMsg;
            msgIncludes = msgIncludesOrMsg;
        } else {
            errorCallback = errorClassOrCallbackOrMsg;
            msg = msgIncludesOrMsg;
        }
    } else msg = errorClassOrCallbackOrMsg;
    let doesThrow = false;
    const msgToAppendToError = msg ? `: ${msg}` : ".";
    try {
        fn();
    } catch (error) {
        if (ErrorClass || errorCallback) {
            if (error instanceof Error === false) throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d("A non-Error object was thrown.");
            $fbf22eb2d80c5977$export$4558d041008ef9f0(error, ErrorClass, msgIncludes, msg);
            if (typeof errorCallback === "function") errorCallback(error);
        }
        err = error;
        doesThrow = true;
    }
    if (!doesThrow) {
        msg = `Expected function to throw${msgToAppendToError}`;
        throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg);
    }
    return err;
}
async function $fbf22eb2d80c5977$export$f7c4a025bbf69222(fn, errorClassOrCallbackOrMsg, msgIncludesOrMsg, msg) {
    // deno-lint-ignore no-explicit-any
    let ErrorClass = undefined;
    let msgIncludes = undefined;
    let errorCallback = undefined;
    let err;
    if (typeof errorClassOrCallbackOrMsg !== "string") {
        if (errorClassOrCallbackOrMsg === undefined || errorClassOrCallbackOrMsg.prototype instanceof Error || errorClassOrCallbackOrMsg.prototype === Error.prototype) {
            // deno-lint-ignore no-explicit-any
            ErrorClass = errorClassOrCallbackOrMsg;
            msgIncludes = msgIncludesOrMsg;
        } else {
            errorCallback = errorClassOrCallbackOrMsg;
            msg = msgIncludesOrMsg;
        }
    } else msg = errorClassOrCallbackOrMsg;
    let doesThrow = false;
    let isPromiseReturned = false;
    const msgToAppendToError = msg ? `: ${msg}` : ".";
    try {
        const possiblePromise = fn();
        if (possiblePromise && typeof possiblePromise === "object" && typeof possiblePromise.then === "function") {
            isPromiseReturned = true;
            await possiblePromise;
        }
    } catch (error) {
        if (!isPromiseReturned) throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(`Function throws when expected to reject${msgToAppendToError}`);
        if (ErrorClass || errorCallback) {
            if (error instanceof Error === false) throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d("A non-Error object was rejected.");
            $fbf22eb2d80c5977$export$4558d041008ef9f0(error, ErrorClass, msgIncludes, msg);
            if (typeof errorCallback == "function") errorCallback(error);
        }
        err = error;
        doesThrow = true;
    }
    if (!doesThrow) throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(`Expected function to reject${msgToAppendToError}`);
    return err;
}
function $fbf22eb2d80c5977$export$7c63beb5e5040ad2(msg) {
    throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d(msg || "unimplemented");
}
function $fbf22eb2d80c5977$export$565e9d9bd6b6e0d4() {
    throw new $fbf22eb2d80c5977$export$7750cdfb4db2c3d("unreachable");
}

});
parcelRegister("3oZDH", function(module, exports) {

$parcel$export(module.exports, "bold", function () { return $27a36d49bdada22b$export$73ba5813cda80a49; });
$parcel$export(module.exports, "red", function () { return $27a36d49bdada22b$export$a90204d1394caf30; });
$parcel$export(module.exports, "green", function () { return $27a36d49bdada22b$export$955a2ebd2fb142ae; });
$parcel$export(module.exports, "white", function () { return $27a36d49bdada22b$export$8fa4e5556fd77a60; });
$parcel$export(module.exports, "gray", function () { return $27a36d49bdada22b$export$3e2c219d3ab79d01; });
$parcel$export(module.exports, "bgRed", function () { return $27a36d49bdada22b$export$74a89e4512e7c91; });
$parcel$export(module.exports, "bgGreen", function () { return $27a36d49bdada22b$export$8137d14243d019b3; });
$parcel$export(module.exports, "stripColor", function () { return $27a36d49bdada22b$export$e763dd3f54523306; });
// Copyright 2018-2022 the Deno authors. All rights reserved. MIT license.
// A module to print ANSI terminal colors. Inspired by chalk, kleur, and colors
// on npm.
/**
 * String formatters and utilities for dealing with ANSI color codes.
 *
 * This module is browser compatible.
 *
 * ```ts
 * import { bgBlue, red, bold } from "https://deno.land/std@$STD_VERSION/fmt/colors.ts";
 * console.log(bgBlue(red(bold("Hello world!"))));
 * ```
 *
 * This module supports `NO_COLOR` environmental variable disabling any coloring
 * if `NO_COLOR` is set.
 *
 * @module
 */ // deno-lint-ignore no-explicit-any

var $dDyES = parcelRequire("dDyES");
const { Deno: $27a36d49bdada22b$var$Deno } = $dDyES.dntGlobalThis;
const $27a36d49bdada22b$var$noColor = typeof $27a36d49bdada22b$var$Deno?.noColor === "boolean" ? $27a36d49bdada22b$var$Deno.noColor : true;
let $27a36d49bdada22b$var$enabled = !$27a36d49bdada22b$var$noColor;
function $27a36d49bdada22b$export$13c4c5399f0ae503(value) {
    if ($27a36d49bdada22b$var$noColor) return;
    $27a36d49bdada22b$var$enabled = value;
}
function $27a36d49bdada22b$export$fe0ef0c10f8f823b() {
    return $27a36d49bdada22b$var$enabled;
}
/**
 * Builds color code
 * @param open
 * @param close
 */ function $27a36d49bdada22b$var$code(open, close) {
    return {
        open: `\x1b[${open.join(";")}m`,
        close: `\x1b[${close}m`,
        regexp: new RegExp(`\\x1b\\[${close}m`, "g")
    };
}
/**
 * Applies color and background based on color code and its associated text
 * @param str text to apply color settings to
 * @param code color code to apply
 */ function $27a36d49bdada22b$var$run(str, code) {
    return $27a36d49bdada22b$var$enabled ? `${code.open}${str.replace(code.regexp, code.open)}${code.close}` : str;
}
function $27a36d49bdada22b$export$aad8462122ac592b(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        0
    ], 0));
}
function $27a36d49bdada22b$export$73ba5813cda80a49(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        1
    ], 22));
}
function $27a36d49bdada22b$export$c96e90b4bcb7d4ca(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        2
    ], 22));
}
function $27a36d49bdada22b$export$5540da1282cbf565(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        3
    ], 23));
}
function $27a36d49bdada22b$export$425327af25286e5e(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        4
    ], 24));
}
function $27a36d49bdada22b$export$70ae2c07e401031b(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        7
    ], 27));
}
function $27a36d49bdada22b$export$73920f18ca706874(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        8
    ], 28));
}
function $27a36d49bdada22b$export$19426ff118fe8be(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        9
    ], 29));
}
function $27a36d49bdada22b$export$c073df10e766abfa(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        30
    ], 39));
}
function $27a36d49bdada22b$export$a90204d1394caf30(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        31
    ], 39));
}
function $27a36d49bdada22b$export$955a2ebd2fb142ae(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        32
    ], 39));
}
function $27a36d49bdada22b$export$594c5a8758200c32(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        33
    ], 39));
}
function $27a36d49bdada22b$export$2aa0182783e7e9de(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        34
    ], 39));
}
function $27a36d49bdada22b$export$2a9ca2e383622e18(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        35
    ], 39));
}
function $27a36d49bdada22b$export$7474046f446842ee(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        36
    ], 39));
}
function $27a36d49bdada22b$export$8fa4e5556fd77a60(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        37
    ], 39));
}
function $27a36d49bdada22b$export$3e2c219d3ab79d01(str) {
    return $27a36d49bdada22b$export$57264ea937479c5c(str);
}
function $27a36d49bdada22b$export$57264ea937479c5c(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        90
    ], 39));
}
function $27a36d49bdada22b$export$2759f0c8d6290948(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        91
    ], 39));
}
function $27a36d49bdada22b$export$bfc5a068d9509bff(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        92
    ], 39));
}
function $27a36d49bdada22b$export$d70554e2650363a6(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        93
    ], 39));
}
function $27a36d49bdada22b$export$25d4b99e14b352b3(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        94
    ], 39));
}
function $27a36d49bdada22b$export$39254b2b3b3ae23e(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        95
    ], 39));
}
function $27a36d49bdada22b$export$23f24850c0661622(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        96
    ], 39));
}
function $27a36d49bdada22b$export$965b1d8692c8399e(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        97
    ], 39));
}
function $27a36d49bdada22b$export$a91ca5b79f5fb26c(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        40
    ], 49));
}
function $27a36d49bdada22b$export$74a89e4512e7c91(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        41
    ], 49));
}
function $27a36d49bdada22b$export$8137d14243d019b3(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        42
    ], 49));
}
function $27a36d49bdada22b$export$3d3dcf8beff00fe1(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        43
    ], 49));
}
function $27a36d49bdada22b$export$ec69fb4048854b4(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        44
    ], 49));
}
function $27a36d49bdada22b$export$76507b7995de3038(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        45
    ], 49));
}
function $27a36d49bdada22b$export$1b1236a85ae1b824(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        46
    ], 49));
}
function $27a36d49bdada22b$export$2fbae6ef3123e0b0(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        47
    ], 49));
}
function $27a36d49bdada22b$export$6c33ff776a3eadf6(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        100
    ], 49));
}
function $27a36d49bdada22b$export$7d5f22493a43a37b(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        101
    ], 49));
}
function $27a36d49bdada22b$export$4de1c8df304d7e8a(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        102
    ], 49));
}
function $27a36d49bdada22b$export$c235c237065ee252(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        103
    ], 49));
}
function $27a36d49bdada22b$export$124e01b42587cf7c(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        104
    ], 49));
}
function $27a36d49bdada22b$export$50e681abe0c2f5c4(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        105
    ], 49));
}
function $27a36d49bdada22b$export$5f424fe9099c6ff9(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        106
    ], 49));
}
function $27a36d49bdada22b$export$d343ff3f337ed020(str) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        107
    ], 49));
}
/* Special Color Sequences */ /**
 * Clam and truncate color codes
 * @param n
 * @param max number to truncate to
 * @param min number to truncate from
 */ function $27a36d49bdada22b$var$clampAndTruncate(n, max = 255, min = 0) {
    return Math.trunc(Math.max(Math.min(n, max), min));
}
function $27a36d49bdada22b$export$f1e87f0dd9e14e78(str, color) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        38,
        5,
        $27a36d49bdada22b$var$clampAndTruncate(color)
    ], 39));
}
function $27a36d49bdada22b$export$282719b0adc2279f(str, color) {
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        48,
        5,
        $27a36d49bdada22b$var$clampAndTruncate(color)
    ], 49));
}
function $27a36d49bdada22b$export$cfc18c6eea6f3907(str, color) {
    if (typeof color === "number") return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        38,
        2,
        color >> 16 & 0xff,
        color >> 8 & 0xff,
        color & 0xff
    ], 39));
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        38,
        2,
        $27a36d49bdada22b$var$clampAndTruncate(color.r),
        $27a36d49bdada22b$var$clampAndTruncate(color.g),
        $27a36d49bdada22b$var$clampAndTruncate(color.b)
    ], 39));
}
function $27a36d49bdada22b$export$4d1cef896ec5cf56(str, color) {
    if (typeof color === "number") return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        48,
        2,
        color >> 16 & 0xff,
        color >> 8 & 0xff,
        color & 0xff
    ], 49));
    return $27a36d49bdada22b$var$run(str, $27a36d49bdada22b$var$code([
        48,
        2,
        $27a36d49bdada22b$var$clampAndTruncate(color.r),
        $27a36d49bdada22b$var$clampAndTruncate(color.g),
        $27a36d49bdada22b$var$clampAndTruncate(color.b)
    ], 49));
}
// https://github.com/chalk/ansi-regex/blob/02fa893d619d3da85411acc8fd4e2eea0e95a9d9/index.js
const $27a36d49bdada22b$var$ANSI_PATTERN = new RegExp([
    "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
    "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-nq-uy=><~]))"
].join("|"), "g");
function $27a36d49bdada22b$export$e763dd3f54523306(string) {
    return string.replace($27a36d49bdada22b$var$ANSI_PATTERN, "");
}

});
parcelRegister("dDyES", function(module, exports) {

$parcel$export(module.exports, "dntGlobalThis", function () { return $9ed9cd4ed16e9394$export$e54a252c25a3a0f; });
const $9ed9cd4ed16e9394$var$dntGlobals = {};
const $9ed9cd4ed16e9394$export$e54a252c25a3a0f = $9ed9cd4ed16e9394$var$createMergeProxy(globalThis, $9ed9cd4ed16e9394$var$dntGlobals);
// deno-lint-ignore ban-types
function $9ed9cd4ed16e9394$var$createMergeProxy(baseObj, extObj) {
    return new Proxy(baseObj, {
        get (_target, prop, _receiver) {
            if (prop in extObj) return extObj[prop];
            else return baseObj[prop];
        },
        set (_target, prop, value) {
            if (prop in extObj) delete extObj[prop];
            baseObj[prop] = value;
            return true;
        },
        deleteProperty (_target, prop) {
            let success = false;
            if (prop in extObj) {
                delete extObj[prop];
                success = true;
            }
            if (prop in baseObj) {
                delete baseObj[prop];
                success = true;
            }
            return success;
        },
        ownKeys (_target) {
            const baseKeys = Reflect.ownKeys(baseObj);
            const extKeys = Reflect.ownKeys(extObj);
            const extKeysSet = new Set(extKeys);
            return [
                ...baseKeys.filter((k)=>!extKeysSet.has(k)),
                ...extKeys
            ];
        },
        defineProperty (_target, prop, desc) {
            if (prop in extObj) delete extObj[prop];
            Reflect.defineProperty(baseObj, prop, desc);
            return true;
        },
        getOwnPropertyDescriptor (_target, prop) {
            if (prop in extObj) return Reflect.getOwnPropertyDescriptor(extObj, prop);
            else return Reflect.getOwnPropertyDescriptor(baseObj, prop);
        },
        has (_target, prop) {
            return prop in extObj || prop in baseObj;
        }
    });
}

});


parcelRegister("etaz3", function(module, exports) {

$parcel$export(module.exports, "diff", function () { return $a88bf7f985947f6a$export$a37e3c603d7117e5; });
$parcel$export(module.exports, "diffstr", function () { return $a88bf7f985947f6a$export$fd2a3824b632fe8d; });
$parcel$export(module.exports, "buildMessage", function () { return $a88bf7f985947f6a$export$5fd34988382c25bd; });
// Copyright 2018-2022 the Deno authors. All rights reserved. MIT license.
// This module is browser compatible.

var $3oZDH = parcelRequire("3oZDH");
var $a88bf7f985947f6a$export$ff2b1aa476090d9e;
(function(DiffType) {
    DiffType["removed"] = "removed";
    DiffType["common"] = "common";
    DiffType["added"] = "added";
})($a88bf7f985947f6a$export$ff2b1aa476090d9e || ($a88bf7f985947f6a$export$ff2b1aa476090d9e = {}));
const $a88bf7f985947f6a$var$REMOVED = 1;
const $a88bf7f985947f6a$var$COMMON = 2;
const $a88bf7f985947f6a$var$ADDED = 3;
function $a88bf7f985947f6a$var$createCommon(A, B, reverse) {
    const common = [];
    if (A.length === 0 || B.length === 0) return [];
    for(let i = 0; i < Math.min(A.length, B.length); i += 1){
        if (A[reverse ? A.length - i - 1 : i] === B[reverse ? B.length - i - 1 : i]) common.push(A[reverse ? A.length - i - 1 : i]);
        else return common;
    }
    return common;
}
function $a88bf7f985947f6a$export$a37e3c603d7117e5(A, B) {
    const prefixCommon = $a88bf7f985947f6a$var$createCommon(A, B);
    const suffixCommon = $a88bf7f985947f6a$var$createCommon(A.slice(prefixCommon.length), B.slice(prefixCommon.length), true).reverse();
    A = suffixCommon.length ? A.slice(prefixCommon.length, -suffixCommon.length) : A.slice(prefixCommon.length);
    B = suffixCommon.length ? B.slice(prefixCommon.length, -suffixCommon.length) : B.slice(prefixCommon.length);
    const swapped = B.length > A.length;
    [A, B] = swapped ? [
        B,
        A
    ] : [
        A,
        B
    ];
    const M = A.length;
    const N = B.length;
    if (!M && !N && !suffixCommon.length && !prefixCommon.length) return [];
    if (!N) return [
        ...prefixCommon.map((c)=>({
                type: $a88bf7f985947f6a$export$ff2b1aa476090d9e.common,
                value: c
            })),
        ...A.map((a)=>({
                type: swapped ? $a88bf7f985947f6a$export$ff2b1aa476090d9e.added : $a88bf7f985947f6a$export$ff2b1aa476090d9e.removed,
                value: a
            })),
        ...suffixCommon.map((c)=>({
                type: $a88bf7f985947f6a$export$ff2b1aa476090d9e.common,
                value: c
            }))
    ];
    const offset = N;
    const delta = M - N;
    const size = M + N + 1;
    const fp = Array.from({
        length: size
    }, ()=>({
            y: -1,
            id: -1
        }));
    /**
     * INFO:
     * This buffer is used to save memory and improve performance.
     * The first half is used to save route and last half is used to save diff
     * type.
     * This is because, when I kept new uint8array area to save type,performance
     * worsened.
     */ const routes = new Uint32Array((M * N + size + 1) * 2);
    const diffTypesPtrOffset = routes.length / 2;
    let ptr = 0;
    let p = -1;
    function backTrace(A, B, current, swapped) {
        const M = A.length;
        const N = B.length;
        const result = [];
        let a = M - 1;
        let b = N - 1;
        let j = routes[current.id];
        let type = routes[current.id + diffTypesPtrOffset];
        while(true){
            if (!j && !type) break;
            const prev = j;
            if (type === $a88bf7f985947f6a$var$REMOVED) {
                result.unshift({
                    type: swapped ? $a88bf7f985947f6a$export$ff2b1aa476090d9e.removed : $a88bf7f985947f6a$export$ff2b1aa476090d9e.added,
                    value: B[b]
                });
                b -= 1;
            } else if (type === $a88bf7f985947f6a$var$ADDED) {
                result.unshift({
                    type: swapped ? $a88bf7f985947f6a$export$ff2b1aa476090d9e.added : $a88bf7f985947f6a$export$ff2b1aa476090d9e.removed,
                    value: A[a]
                });
                a -= 1;
            } else {
                result.unshift({
                    type: $a88bf7f985947f6a$export$ff2b1aa476090d9e.common,
                    value: A[a]
                });
                a -= 1;
                b -= 1;
            }
            j = routes[prev];
            type = routes[prev + diffTypesPtrOffset];
        }
        return result;
    }
    function createFP(slide, down, k, M) {
        if (slide && slide.y === -1 && down && down.y === -1) return {
            y: 0,
            id: 0
        };
        if (down && down.y === -1 || k === M || (slide && slide.y) > (down && down.y) + 1) {
            const prev = slide.id;
            ptr++;
            routes[ptr] = prev;
            routes[ptr + diffTypesPtrOffset] = $a88bf7f985947f6a$var$ADDED;
            return {
                y: slide.y,
                id: ptr
            };
        } else {
            const prev = down.id;
            ptr++;
            routes[ptr] = prev;
            routes[ptr + diffTypesPtrOffset] = $a88bf7f985947f6a$var$REMOVED;
            return {
                y: down.y + 1,
                id: ptr
            };
        }
    }
    function snake(k, slide, down, _offset, A, B) {
        const M = A.length;
        const N = B.length;
        if (k < -N || M < k) return {
            y: -1,
            id: -1
        };
        const fp = createFP(slide, down, k, M);
        while(fp.y + k < M && fp.y < N && A[fp.y + k] === B[fp.y]){
            const prev = fp.id;
            ptr++;
            fp.id = ptr;
            fp.y += 1;
            routes[ptr] = prev;
            routes[ptr + diffTypesPtrOffset] = $a88bf7f985947f6a$var$COMMON;
        }
        return fp;
    }
    while(fp[delta + offset].y < N){
        p = p + 1;
        for(let k = -p; k < delta; ++k)fp[k + offset] = snake(k, fp[k - 1 + offset], fp[k + 1 + offset], offset, A, B);
        for(let k = delta + p; k > delta; --k)fp[k + offset] = snake(k, fp[k - 1 + offset], fp[k + 1 + offset], offset, A, B);
        fp[delta + offset] = snake(delta, fp[delta - 1 + offset], fp[delta + 1 + offset], offset, A, B);
    }
    return [
        ...prefixCommon.map((c)=>({
                type: $a88bf7f985947f6a$export$ff2b1aa476090d9e.common,
                value: c
            })),
        ...backTrace(A, B, fp[delta + offset], swapped),
        ...suffixCommon.map((c)=>({
                type: $a88bf7f985947f6a$export$ff2b1aa476090d9e.common,
                value: c
            }))
    ];
}
function $a88bf7f985947f6a$export$fd2a3824b632fe8d(A, B) {
    function unescape(string) {
        // unescape invisible characters.
        // ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#escape_sequences
        return string.replaceAll("\b", "\\b").replaceAll("\f", "\\f").replaceAll("\t", "\\t").replaceAll("\v", "\\v").replaceAll(/\r\n|\r|\n/g, (str)=>str === "\r" ? "\\r" : str === "\n" ? "\\n\n" : "\\r\\n\r\n");
    }
    function tokenize(string, { wordDiff: wordDiff = false } = {}) {
        if (wordDiff) {
            // Split string on whitespace symbols
            const tokens = string.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/);
            // Extended Latin character set
            const words = /^[a-zA-Z\u{C0}-\u{FF}\u{D8}-\u{F6}\u{F8}-\u{2C6}\u{2C8}-\u{2D7}\u{2DE}-\u{2FF}\u{1E00}-\u{1EFF}]+$/u;
            // Join boundary splits that we do not consider to be boundaries and merge empty strings surrounded by word chars
            for(let i = 0; i < tokens.length - 1; i++)if (!tokens[i + 1] && tokens[i + 2] && words.test(tokens[i]) && words.test(tokens[i + 2])) {
                tokens[i] += tokens[i + 2];
                tokens.splice(i + 1, 2);
                i--;
            }
            return tokens.filter((token)=>token);
        } else {
            // Split string on new lines symbols
            const tokens = [], lines = string.split(/(\n|\r\n)/);
            // Ignore final empty token when text ends with a newline
            if (!lines[lines.length - 1]) lines.pop();
            // Merge the content and line separators into single tokens
            for(let i = 0; i < lines.length; i++)if (i % 2) tokens[tokens.length - 1] += lines[i];
            else tokens.push(lines[i]);
            return tokens;
        }
    }
    // Create details by filtering relevant word-diff for current line
    // and merge "space-diff" if surrounded by word-diff for cleaner displays
    function createDetails(line, tokens) {
        return tokens.filter(({ type: type })=>type === line.type || type === $a88bf7f985947f6a$export$ff2b1aa476090d9e.common).map((result, i, t)=>{
            if (result.type === $a88bf7f985947f6a$export$ff2b1aa476090d9e.common && t[i - 1] && t[i - 1]?.type === t[i + 1]?.type && /\s+/.test(result.value)) result.type = t[i - 1].type;
            return result;
        });
    }
    // Compute multi-line diff
    const diffResult = $a88bf7f985947f6a$export$a37e3c603d7117e5(tokenize(`${unescape(A)}\n`), tokenize(`${unescape(B)}\n`));
    const added = [], removed = [];
    for (const result of diffResult){
        if (result.type === $a88bf7f985947f6a$export$ff2b1aa476090d9e.added) added.push(result);
        if (result.type === $a88bf7f985947f6a$export$ff2b1aa476090d9e.removed) removed.push(result);
    }
    // Compute word-diff
    const aLines = added.length < removed.length ? added : removed;
    const bLines = aLines === removed ? added : removed;
    for (const a of aLines){
        let tokens = [], b;
        // Search another diff line with at least one common token
        while(bLines.length){
            b = bLines.shift();
            tokens = $a88bf7f985947f6a$export$a37e3c603d7117e5(tokenize(a.value, {
                wordDiff: true
            }), tokenize(b?.value ?? "", {
                wordDiff: true
            }));
            if (tokens.some(({ type: type, value: value })=>type === $a88bf7f985947f6a$export$ff2b1aa476090d9e.common && value.trim().length)) break;
        }
        // Register word-diff details
        a.details = createDetails(a, tokens);
        if (b) b.details = createDetails(b, tokens);
    }
    return diffResult;
}
/**
 * Colors the output of assertion diffs
 * @param diffType Difference type, either added or removed
 */ function $a88bf7f985947f6a$var$createColor(diffType, { background: background = false } = {}) {
    // TODO(@littledivy): Remove this when we can detect
    // true color terminals.
    // https://github.com/denoland/deno_std/issues/2575
    background = false;
    switch(diffType){
        case $a88bf7f985947f6a$export$ff2b1aa476090d9e.added:
            return (s)=>background ? (0, $3oZDH.bgGreen)((0, $3oZDH.white)(s)) : (0, $3oZDH.green)((0, $3oZDH.bold)(s));
        case $a88bf7f985947f6a$export$ff2b1aa476090d9e.removed:
            return (s)=>background ? (0, $3oZDH.bgRed)((0, $3oZDH.white)(s)) : (0, $3oZDH.red)((0, $3oZDH.bold)(s));
        default:
            return 0, $3oZDH.white;
    }
}
/**
 * Prefixes `+` or `-` in diff output
 * @param diffType Difference type, either added or removed
 */ function $a88bf7f985947f6a$var$createSign(diffType) {
    switch(diffType){
        case $a88bf7f985947f6a$export$ff2b1aa476090d9e.added:
            return "+   ";
        case $a88bf7f985947f6a$export$ff2b1aa476090d9e.removed:
            return "-   ";
        default:
            return "    ";
    }
}
function $a88bf7f985947f6a$export$5fd34988382c25bd(diffResult, { stringDiff: stringDiff = false } = {}) {
    const messages = [], diffMessages = [];
    messages.push("");
    messages.push("");
    messages.push(`    ${(0, $3oZDH.gray)((0, $3oZDH.bold)("[Diff]"))} ${(0, $3oZDH.red)((0, $3oZDH.bold)("Actual"))} / ${(0, $3oZDH.green)((0, $3oZDH.bold)("Expected"))}`);
    messages.push("");
    messages.push("");
    diffResult.forEach((result)=>{
        const c = $a88bf7f985947f6a$var$createColor(result.type);
        const line = result.details?.map((detail)=>detail.type !== $a88bf7f985947f6a$export$ff2b1aa476090d9e.common ? $a88bf7f985947f6a$var$createColor(detail.type, {
                background: true
            })(detail.value) : detail.value).join("") ?? result.value;
        diffMessages.push(c(`${$a88bf7f985947f6a$var$createSign(result.type)}${line}`));
    });
    messages.push(...stringDiff ? [
        diffMessages.join("")
    ] : diffMessages);
    messages.push("");
    return messages;
}

});

parcelRegister("4PcZK", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $3836015a90cb0a7c$export$d9468344d3651243; });
// Copyright 2018-2022 the Deno authors. All rights reserved. MIT license.
// This module is browser compatible.
/**
 * Converts the input into a string. Objects, Sets and Maps are sorted so as to
 * make tests less flaky
 * @param v Value to be formatted
 */ 
var $dDyES = parcelRequire("dDyES");
function $3836015a90cb0a7c$export$d9468344d3651243(v) {
    // deno-lint-ignore no-explicit-any
    const { Deno: Deno } = $dDyES.dntGlobalThis;
    return typeof Deno?.inspect === "function" ? Deno.inspect(v, {
        depth: Infinity,
        sorted: true,
        trailingComma: true,
        compact: false,
        iterableLimit: Infinity,
        // getters should be true in assertEquals.
        getters: true
    }) : `"${String(v).replace(/(?=["\\])/g, "\\")}"`;
}

});


parcelRegister("f3Mwk", function(module, exports) {

$parcel$export(module.exports, "reset", function () { return $af6cc5f6d59bc88b$export$aad8462122ac592b; });
$parcel$export(module.exports, "shift", function () { return $af6cc5f6d59bc88b$export$fba63a578e423eb; });
$parcel$export(module.exports, "evaluate", function () { return $af6cc5f6d59bc88b$export$fef61f332f2c0afc; });
// deno-lint-ignore-file no-explicit-any
function* $af6cc5f6d59bc88b$export$aad8462122ac592b(block) {
    return yield {
        type: "reset",
        block: block
    };
}
function* $af6cc5f6d59bc88b$export$fba63a578e423eb(block) {
    return yield {
        type: "shift",
        block: block
    };
}
function $af6cc5f6d59bc88b$var$createStack() {
    let list = [];
    return {
        reducing: false,
        push (...thunks) {
            return list.push(...thunks);
        },
        pop () {
            return list.pop();
        }
    };
}
function $af6cc5f6d59bc88b$export$fef61f332f2c0afc(iterator) {
    let stack = $af6cc5f6d59bc88b$var$createStack();
    stack.push({
        method: "next",
        iterator: iterator()[Symbol.iterator]()
    });
    return $af6cc5f6d59bc88b$var$reduce(stack);
}
function $af6cc5f6d59bc88b$var$reduce(stack) {
    try {
        stack.reducing = true;
        for(let current = stack.pop(); current; current = stack.pop())try {
            let next = $af6cc5f6d59bc88b$var$getNext(current);
            stack.value = next.value;
            if (!next.done) {
                let control = next.value;
                if (control.type === "reset") stack.push({
                    ...current,
                    method: "next",
                    get value () {
                        return stack.value;
                    }
                }, {
                    method: "next",
                    iterator: control.block()[Symbol.iterator]()
                });
                else {
                    let thunk = current;
                    let resolve = $af6cc5f6d59bc88b$var$oneshot((value)=>{
                        stack.push({
                            method: "next",
                            iterator: thunk.iterator,
                            value: value
                        });
                        return $af6cc5f6d59bc88b$var$reduce(stack);
                    });
                    resolve.tail = $af6cc5f6d59bc88b$var$oneshot((value)=>{
                        stack.push({
                            method: "next",
                            iterator: thunk.iterator,
                            value: value
                        });
                        if (!stack.reducing) $af6cc5f6d59bc88b$var$reduce(stack);
                    });
                    let reject = $af6cc5f6d59bc88b$var$oneshot((error)=>{
                        stack.push({
                            method: "throw",
                            iterator: thunk.iterator,
                            value: error
                        });
                        return $af6cc5f6d59bc88b$var$reduce(stack);
                    });
                    reject.tail = $af6cc5f6d59bc88b$var$oneshot((error)=>{
                        stack.push({
                            method: "throw",
                            iterator: thunk.iterator,
                            value: error
                        });
                        if (!stack.reducing) $af6cc5f6d59bc88b$var$reduce(stack);
                    });
                    stack.push({
                        method: "next",
                        iterator: control.block(resolve, reject)[Symbol.iterator](),
                        value: void 0
                    });
                }
            }
        } catch (error) {
            let top = stack.pop();
            if (top) stack.push({
                ...top,
                method: "throw",
                value: error
            });
            else throw error;
        }
    } finally{
        stack.reducing = false;
    }
    return stack.value;
}
function $af6cc5f6d59bc88b$var$getNext(thunk) {
    let { iterator: iterator } = thunk;
    if (thunk.method === "next") return iterator.next(thunk.value);
    else {
        let value = thunk.value;
        if (iterator.throw) return iterator.throw(value);
        else throw value;
    }
}
function $af6cc5f6d59bc88b$var$oneshot(fn) {
    let continued = false;
    let failure;
    let result;
    return (value)=>{
        if (!continued) {
            continued = true;
            try {
                return result = fn(value);
            } catch (error) {
                failure = {
                    error: error
                };
                throw error;
            }
        } else if (failure) throw failure.error;
        else return result;
    };
}

});




parcelRegister("6wugg", function(module, exports) {

$parcel$export(module.exports, "suspend", function () { return $4bfd347b8bee32e9$export$a1428c8f7ba796e8; });
$parcel$export(module.exports, "action", function () { return $4bfd347b8bee32e9$export$31eb53bd5b582a97; });
$parcel$export(module.exports, "spawn", function () { return $4bfd347b8bee32e9$export$1713f5ac2bf0caf5; });
$parcel$export(module.exports, "resource", function () { return $4bfd347b8bee32e9$export$23e0665cffcf8918; });
$parcel$export(module.exports, "getframe", function () { return $4bfd347b8bee32e9$export$f7af4c888be6a04c; });
parcelRequire("KLiMo");
var $f3Mwk = parcelRequire("f3Mwk");

var $7VNZT = parcelRequire("7VNZT");

var $2EoHU = parcelRequire("2EoHU");
function $4bfd347b8bee32e9$export$a1428c8f7ba796e8() {
    return $4bfd347b8bee32e9$var$instruction($4bfd347b8bee32e9$var$Suspend);
}
function $4bfd347b8bee32e9$var$Suspend(frame) {
    return (0, $7VNZT.shiftSync)((k)=>{
        if (frame.aborted) k.tail((0, $2EoHU.Ok)(void 0));
    });
}
function $4bfd347b8bee32e9$export$31eb53bd5b582a97(operation) {
    return $4bfd347b8bee32e9$var$instruction(function Action(frame) {
        return (0, $f3Mwk.shift)(function*(k) {
            let settle = yield* (0, $f3Mwk.reset)(function*() {
                let result = yield* (0, $7VNZT.shiftSync)((k)=>k.tail);
                let destruction = yield* child.destroy();
                if (!destruction.ok) k.tail(destruction);
                else k.tail(result);
            });
            let resolve = (value)=>settle((0, $2EoHU.Ok)(value));
            let reject = (error)=>settle((0, $2EoHU.Err)(error));
            let child = frame.createChild(function*() {
                yield* operation(resolve, reject);
                yield* $4bfd347b8bee32e9$export$a1428c8f7ba796e8();
            });
            yield* (0, $f3Mwk.reset)(function*() {
                let result = yield* child;
                if (!result.ok) k.tail(result);
            });
            child.enter();
        });
    });
}
function $4bfd347b8bee32e9$export$1713f5ac2bf0caf5(operation) {
    return $4bfd347b8bee32e9$var$instruction(function Spawn(frame) {
        return (0, $f3Mwk.shift)(function(k) {
            let child = frame.createChild(operation);
            child.enter();
            k.tail((0, $2EoHU.Ok)(child.getTask()));
            return (0, $f3Mwk.reset)(function*() {
                let result = yield* child;
                if (!result.ok) yield* frame.crash(result.error);
            });
        });
    });
}
function $4bfd347b8bee32e9$export$23e0665cffcf8918(operation) {
    return $4bfd347b8bee32e9$var$instruction((frame)=>(0, $f3Mwk.shift)(function(k) {
            function provide(value) {
                k.tail((0, $2EoHU.Ok)(value));
                return $4bfd347b8bee32e9$export$a1428c8f7ba796e8();
            }
            let child = frame.createChild(()=>operation(provide));
            child.enter();
            return (0, $f3Mwk.reset)(function*() {
                let result = yield* child;
                if (!result.ok) {
                    k.tail(result);
                    yield* frame.crash(result.error);
                }
            });
        }));
}
function $4bfd347b8bee32e9$export$f7af4c888be6a04c() {
    return $4bfd347b8bee32e9$var$instruction((frame)=>(0, $7VNZT.shiftSync)((k)=>k.tail((0, $2EoHU.Ok)(frame))));
}
// An optimized iterator that yields the instruction on the first call
// to next, then returns its value on the second. Equivalent to:
// {
//  *[Symbol.iterator]() { return yield instruction; }
// }
function $4bfd347b8bee32e9$var$instruction(i) {
    return {
        [Symbol.iterator] () {
            let entered = false;
            return {
                next (value) {
                    if (!entered) {
                        entered = true;
                        return {
                            done: false,
                            value: i
                        };
                    } else return {
                        done: true,
                        value: value
                    };
                },
                throw (error) {
                    throw error;
                }
            };
        }
    };
}

});
parcelRegister("7VNZT", function(module, exports) {

$parcel$export(module.exports, "shiftSync", function () { return $5c64a3aef6ee43cb$export$d89aa26af2d36129; });
parcelRequire("KLiMo");
var $f3Mwk = parcelRequire("f3Mwk");
function $5c64a3aef6ee43cb$export$d89aa26af2d36129(block) {
    return (0, $f3Mwk.shift)((resolve, reject)=>{
        return {
            [Symbol.iterator]: ()=>({
                    next () {
                        let value = block(resolve, reject);
                        return {
                            done: true,
                            value: value
                        };
                    }
                })
        };
    });
}

});


parcelRegister("lPibo", function(module, exports) {

$parcel$export(module.exports, "createContext", function () { return $fe3c7722facb74f9$export$fd42f52fd3ae1109; });

var $1zY4N = parcelRequire("1zY4N");

var $kanWf = parcelRequire("kanWf");
function $fe3c7722facb74f9$export$fd42f52fd3ae1109(key, defaultValue) {
    let context = (0, $1zY4N.create)(`Context`, {
        key: key
    }, {
        defaultValue: defaultValue,
        *get () {
            let scope = yield* (0, $kanWf.useScope)();
            return scope.get(context);
        },
        *set (value) {
            let scope = yield* (0, $kanWf.useScope)();
            return scope.set(context, value);
        },
        *[Symbol.iterator] () {
            let value = yield* context.get();
            if (typeof value === "undefined") throw new $fe3c7722facb74f9$var$MissingContextError(`missing required context: '${key}'`);
            else return value;
        }
    });
    return context;
}
class $fe3c7722facb74f9$var$MissingContextError extends Error {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "MissingContextError"
        });
    }
}

});
parcelRegister("1zY4N", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $1267a9440faab277$export$185802fd694ee1f5; });
function $1267a9440faab277$export$185802fd694ee1f5(tag, attrs, prototype) {
    let properties = {};
    for (let [key, value] of Object.entries(attrs))properties[key] = {
        enumerable: true,
        value: value
    };
    return Object.create({
        ...prototype,
        [Symbol.toStringTag]: tag
    }, properties);
}

});

parcelRegister("kanWf", function(module, exports) {

$parcel$export(module.exports, "useScope", function () { return $eae74f85e81b3de0$export$6982c44819621294; });
$parcel$export(module.exports, "createScope", function () { return $eae74f85e81b3de0$export$41a9651decfe2bde; });
parcelRequire("KLiMo");
var $f3Mwk = parcelRequire("f3Mwk");

var $1zY4N = parcelRequire("1zY4N");

var $ey8L0 = parcelRequire("ey8L0");

var $6wugg = parcelRequire("6wugg");
function* $eae74f85e81b3de0$export$6982c44819621294() {
    let frame = yield* (0, $6wugg.getframe)();
    let [scope] = $eae74f85e81b3de0$export$41a9651decfe2bde(frame);
    return scope;
}
function $eae74f85e81b3de0$export$41a9651decfe2bde(frame) {
    let parent = frame ?? (0, $ey8L0.createFrame)({
        operation: (0, $6wugg.suspend)
    });
    let scope = (0, $1zY4N.create)("Scope", {}, {
        run (operation) {
            if (parent.exited) {
                let error = new Error(`cannot call run() on a scope that has already been exited`);
                error.name = "InactiveScopeError";
                throw error;
            }
            let frame = parent.createChild(operation);
            frame.enter();
            (0, $f3Mwk.evaluate)(function*() {
                let result = yield* frame;
                if (!result.ok) yield* parent.crash(result.error);
            });
            return frame.getTask();
        },
        get (context) {
            let { key: key, defaultValue: defaultValue } = context;
            return parent.context[key] ?? defaultValue;
        },
        set (context, value) {
            let { key: key } = context;
            parent.context[key] = value;
            return value;
        }
    });
    parent.enter();
    return [
        scope,
        parent.getTask().halt
    ];
}

});
parcelRegister("ey8L0", function(module, exports) {

$parcel$export(module.exports, "createFrame", function () { return $a97b08abd3973a8b$export$52b3fe9f41f5650c; });
parcelRequire("KLiMo");
var $f3Mwk = parcelRequire("f3Mwk");

var $7VNZT = parcelRequire("7VNZT");

var $gZbok = parcelRequire("gZbok");

var $2EoHU = parcelRequire("2EoHU");

var $giIC3 = parcelRequire("giIC3");

var $lTo4E = parcelRequire("lTo4E");

var $1zY4N = parcelRequire("1zY4N");
let $a97b08abd3973a8b$var$ids = 0;
function $a97b08abd3973a8b$export$52b3fe9f41f5650c(options) {
    return (0, $f3Mwk.evaluate)(function*() {
        let { operation: operation, parent: parent } = options;
        let children = new Set();
        let context = Object.create(parent ?? {});
        let thunks = [
            {
                done: false,
                value: $a97b08abd3973a8b$var$$next(void 0)
            }
        ];
        let crash = void 0;
        let interrupt = ()=>{};
        let [setResults, results] = yield* (0, $giIC3.createValue)();
        let frame = yield* (0, $7VNZT.shiftSync)((k)=>{
            let self = (0, $1zY4N.create)("Frame", {
                id: $a97b08abd3973a8b$var$ids++,
                context: context
            }, {
                createChild (operation) {
                    let child = $a97b08abd3973a8b$export$52b3fe9f41f5650c({
                        operation: operation,
                        parent: self.context
                    });
                    children.add(child);
                    (0, $f3Mwk.evaluate)(function*() {
                        yield* child;
                        children.delete(child);
                    });
                    return child;
                },
                getTask () {
                    let task = (0, $lTo4E.createTask)(self);
                    self.getTask = ()=>task;
                    return task;
                },
                enter () {
                    k.tail(self);
                },
                crash (error) {
                    abort(error);
                    return results;
                },
                destroy () {
                    abort();
                    return results;
                },
                [Symbol.iterator]: results[Symbol.iterator]
            });
            let abort = (reason)=>{
                if (!self.aborted) {
                    self.aborted = true;
                    crash = reason;
                    thunks.unshift({
                        done: false,
                        value: $a97b08abd3973a8b$var$$abort()
                    });
                    interrupt();
                }
            };
            return self;
        });
        let iterator = (0, $gZbok.lazy)(()=>operation()[Symbol.iterator]());
        let thunk = thunks.pop();
        while(!thunk.done){
            let getNext = thunk.value;
            try {
                let next = getNext(iterator());
                if (next.done) thunks.unshift({
                    done: true,
                    value: (0, $2EoHU.Ok)(next.value)
                });
                else {
                    let instruction = next.value;
                    let outcome = yield* (0, $f3Mwk.shift)(function*(k) {
                        interrupt = ()=>k.tail({
                                type: "interrupted"
                            });
                        try {
                            k.tail({
                                type: "settled",
                                result: yield* instruction(frame)
                            });
                        } catch (error) {
                            k.tail({
                                type: "settled",
                                result: (0, $2EoHU.Err)(error)
                            });
                        }
                    });
                    if (outcome.type === "settled") {
                        if (outcome.result.ok) thunks.unshift({
                            done: false,
                            value: $a97b08abd3973a8b$var$$next(outcome.result.value)
                        });
                        else thunks.unshift({
                            done: false,
                            value: $a97b08abd3973a8b$var$$throw(outcome.result.error)
                        });
                    }
                }
            } catch (error) {
                thunks.unshift({
                    done: true,
                    value: (0, $2EoHU.Err)(error)
                });
            }
            thunk = thunks.pop();
        }
        frame.exited = true;
        let result = thunk.value;
        let exit;
        if (!result.ok) exit = {
            type: "result",
            result: result
        };
        else if (crash) exit = {
            type: "crashed",
            error: crash
        };
        else if (frame.aborted) exit = {
            type: "aborted"
        };
        else exit = {
            type: "result",
            result: result
        };
        let destruction = (0, $2EoHU.Ok)(void 0);
        while(children.size !== 0)for (let child of [
            ...children
        ].reverse()){
            let teardown = yield* child.destroy();
            if (!teardown.ok) destruction = teardown;
        }
        if (!destruction.ok) setResults({
            ok: false,
            error: destruction.error,
            exit: exit,
            destruction: destruction
        });
        else {
            if (exit.type === "aborted") setResults({
                ok: true,
                value: void 0,
                exit: exit,
                destruction: destruction
            });
            else if (exit.type === "result") {
                let { result: result } = exit;
                if (result.ok) setResults({
                    ok: true,
                    value: void 0,
                    exit: exit,
                    destruction: destruction
                });
                else setResults({
                    ok: false,
                    error: result.error,
                    exit: exit,
                    destruction: destruction
                });
            } else setResults({
                ok: false,
                error: exit.error,
                exit: exit,
                destruction: destruction
            });
        }
    });
}
// deno-lint-ignore no-explicit-any
const $a97b08abd3973a8b$var$$next = (value)=>function $next(i) {
        return i.next(value);
    };
const $a97b08abd3973a8b$var$$throw = (error)=>function $throw(i) {
        if (i.throw) return i.throw(error);
        else throw error;
    };
const $a97b08abd3973a8b$var$$abort = (value)=>function $abort(i) {
        if (i.return) return i.return(value);
        else return {
            done: true,
            value: value
        };
    };

});
parcelRegister("gZbok", function(module, exports) {

$parcel$export(module.exports, "lazy", function () { return $c5db2deb2288f1d4$export$488013bae63b21da; });
function $c5db2deb2288f1d4$export$488013bae63b21da(create) {
    let thunk = ()=>{
        let value = create();
        thunk = ()=>value;
        return value;
    };
    return ()=>thunk();
}

});

parcelRegister("giIC3", function(module, exports) {

$parcel$export(module.exports, "createValue", function () { return $bde0eef29f838035$export$7f75b77267f1fa35; });
parcelRequire("KLiMo");
var $f3Mwk = parcelRequire("f3Mwk");

var $7VNZT = parcelRequire("7VNZT");
function* $bde0eef29f838035$export$7f75b77267f1fa35() {
    let result = void 0;
    let listeners = new Set();
    let resolve = yield* (0, $f3Mwk.reset)(function*() {
        let value = yield* (0, $7VNZT.shiftSync)((k)=>k.tail);
        result = {
            value: value
        };
        for (let listener of listeners){
            listeners.delete(listener);
            listener(value);
        }
    });
    let event = {
        [Symbol.iterator] () {
            if (result) return $bde0eef29f838035$export$92d6409d68f0739a(result.value);
            else return (0, $7VNZT.shiftSync)((k)=>{
                listeners.add(k.tail);
            })[Symbol.iterator]();
        }
    };
    return [
        resolve,
        event
    ];
}
function $bde0eef29f838035$export$92d6409d68f0739a(value) {
    return {
        next () {
            return {
                done: true,
                value: value
            };
        }
    };
}

});

parcelRegister("lTo4E", function(module, exports) {

$parcel$export(module.exports, "createTask", function () { return $ff0168a1e047905c$export$f7292ab7796be73c; });
parcelRequire("KLiMo");
var $f3Mwk = parcelRequire("f3Mwk");

var $2EoHU = parcelRequire("2EoHU");

var $6wugg = parcelRequire("6wugg");

var $1zY4N = parcelRequire("1zY4N");
function $ff0168a1e047905c$export$f7292ab7796be73c(frame) {
    let promise;
    let awaitResult = (resolve, reject)=>{
        (0, $f3Mwk.evaluate)(function*() {
            let result = $ff0168a1e047905c$var$getResult((yield* frame));
            if (result.ok) resolve(result.value);
            else reject(result.error);
        });
    };
    let getPromise = ()=>{
        promise = new Promise((resolve, reject)=>{
            awaitResult(resolve, reject);
        });
        getPromise = ()=>promise;
        return promise;
    };
    let task = (0, $1zY4N.create)("Task", {}, {
        *[Symbol.iterator] () {
            let frameResult = (0, $f3Mwk.evaluate)(()=>frame);
            if (frameResult) {
                let result = $ff0168a1e047905c$var$getResult(frameResult);
                if (result.ok) return result.value;
                else throw result.error;
            } else return yield* (0, $6wugg.action)(function*(resolve, reject) {
                awaitResult(resolve, reject);
            });
        },
        then: (...args)=>getPromise().then(...args),
        catch: (...args)=>getPromise().catch(...args),
        finally: (...args)=>getPromise().finally(...args),
        halt () {
            let haltPromise;
            let getHaltPromise = ()=>{
                haltPromise = new Promise((resolve, reject)=>{
                    awaitHaltResult(resolve, reject);
                });
                getHaltPromise = ()=>haltPromise;
                frame.destroy();
                return haltPromise;
            };
            let awaitHaltResult = (resolve, reject)=>{
                (0, $f3Mwk.evaluate)(function*() {
                    let { destruction: destruction } = yield* frame;
                    if (destruction.ok) resolve();
                    else reject(destruction.error);
                });
            };
            return (0, $1zY4N.create)("Future", {}, {
                *[Symbol.iterator] () {
                    let result = (0, $f3Mwk.evaluate)(()=>frame);
                    if (result) {
                        if (!result.ok) throw result.error;
                    } else yield* (0, $6wugg.action)(function*(resolve, reject) {
                        awaitHaltResult(resolve, reject);
                        frame.destroy();
                    });
                },
                then: (...args)=>getHaltPromise().then(...args),
                catch: (...args)=>getHaltPromise().catch(...args),
                finally: (...args)=>getHaltPromise().finally(...args)
            });
        }
    });
    return task;
}
function $ff0168a1e047905c$var$getResult(result) {
    if (!result.ok) return result;
    else if (result.exit.type === "aborted") return (0, $2EoHU.Err)(Error("halted"));
    else if (result.exit.type === "crashed") return (0, $2EoHU.Err)(result.exit.error);
    else return result.exit.result;
}

});





parcelRegister("3jbA0", function(module, exports) {

$parcel$export(module.exports, "lift", function () { return $268c20ec3e8abaa7$export$590e8b2c435046d9; });
/**
 * Convert a simple function into an {@link Operation}
 *
 * @example
 * ```js
 * let log = lift((message) => console.log(message));
 *
 * export function* run() {
 *   yield* log("hello world");
 *   yield* log("done");
 * }
 * ```
 *
 * @returns a function returning an operation that invokes `fn` when evaluated
 */ function $268c20ec3e8abaa7$export$590e8b2c435046d9(fn) {
    return (...args)=>{
        return {
            [Symbol.iterator] () {
                let value = fn(...args);
                return {
                    next: ()=>({
                            done: true,
                            value: value
                        })
                };
            }
        };
    };
}

});


parcelRegister("15Qbp", function(module, exports) {

$parcel$export(module.exports, "call", function () { return $0cbebc8a3b09e265$export$848feb93d8f32b9b; });

var $6wugg = parcelRequire("6wugg");

var $cUhaT = parcelRequire("cUhaT");
function $0cbebc8a3b09e265$export$848feb93d8f32b9b(callable) {
    return (0, $6wugg.action)(function*(resolve, reject) {
        try {
            if (typeof callable === "function") {
                let fn = callable;
                resolve((yield* $0cbebc8a3b09e265$var$toop(fn())));
            } else resolve((yield* $0cbebc8a3b09e265$var$toop(callable)));
        } catch (error) {
            reject(error);
        }
    });
}
function $0cbebc8a3b09e265$var$toop(op) {
    if ($0cbebc8a3b09e265$var$isPromise(op)) return $0cbebc8a3b09e265$var$expect(op);
    else if ($0cbebc8a3b09e265$var$isIterable(op)) {
        let iter = op[Symbol.iterator]();
        if ($0cbebc8a3b09e265$var$isInstructionIterator(iter)) // operation
        return op;
        else // We are assuming that if an iterator does *not* have `.throw` then
        // it must be a built-in iterator and we should return the value as-is.
        return $0cbebc8a3b09e265$var$bare(op);
    } else return $0cbebc8a3b09e265$var$bare(op);
}
function $0cbebc8a3b09e265$var$bare(val) {
    return {
        [Symbol.iterator] () {
            return {
                next: ()=>({
                        done: true,
                        value: val
                    })
            };
        }
    };
}
function $0cbebc8a3b09e265$var$expect(promise) {
    return (0, $cUhaT.pause)((resolve, reject)=>{
        promise.then(resolve, reject);
        return ()=>{};
    });
}
function $0cbebc8a3b09e265$var$isFunc(f) {
    return typeof f === "function";
}
function $0cbebc8a3b09e265$var$isPromise(p) {
    if (!p) return false;
    return $0cbebc8a3b09e265$var$isFunc(p.then);
}
// iterator must implement both `.next` and `.throw`
// built-in iterators are not considered iterators to `call()`
function $0cbebc8a3b09e265$var$isInstructionIterator(it) {
    if (!it) return false;
    return $0cbebc8a3b09e265$var$isFunc(it.next) && $0cbebc8a3b09e265$var$isFunc(it.throw);
}
function $0cbebc8a3b09e265$var$isIterable(it) {
    if (!it) return false;
    return typeof it[Symbol.iterator] === "function";
}

});

parcelRegister("bFL3r", function(module, exports) {
$parcel$export(module.exports, "createScope", function () { return (parcelRequire("kanWf")).createScope; });

$parcel$export(module.exports, "run", function () { return $87f8061576ccf244$export$889ea624f2cb2c57; });

var $ey8L0 = parcelRequire("ey8L0");
parcelRequire("kanWf");
function $87f8061576ccf244$export$889ea624f2cb2c57(operation) {
    let frame = (0, $ey8L0.createFrame)({
        operation: operation
    });
    frame.enter();
    return frame.getTask();
}

});

parcelRegister("4PPHq", function(module, exports) {

$parcel$export(module.exports, "sleep", function () { return $3854073ef6f5bbd1$export$e772c8ff12451969; });

var $6wugg = parcelRequire("6wugg");
function $3854073ef6f5bbd1$export$e772c8ff12451969(duration) {
    return (0, $6wugg.action)(function* sleep(resolve) {
        let timeoutId = setTimeout(resolve, duration);
        try {
            yield* (0, $6wugg.suspend)();
        } finally{
            clearTimeout(timeoutId);
        }
    });
}

});

parcelRegister("j7yHE", function(module, exports) {

$parcel$export(module.exports, "first", function () { return $deb99718949defda$export$43128fadae87b74a; });
function* $deb99718949defda$export$43128fadae87b74a(stream) {
    let subscription = yield* stream.subscribe();
    let result = yield* subscription.next();
    if (!result.done) return result.value;
}

});

parcelRegister("cZInJ", function(module, exports) {

var $6wugg = parcelRequire("6wugg");

var $15Qbp = parcelRequire("15Qbp");
function $975d9bd49ec28e84$export$3570f33b1a1f3329(promise) {
    return (0, $6wugg.action)(function*(resolve, reject) {
        promise.then(resolve, reject);
    });
}
function $975d9bd49ec28e84$export$ec068583843480e7(iter) {
    return {
        next: ()=>(0, $15Qbp.call)(()=>iter.next())
    };
}
function $975d9bd49ec28e84$export$4938110305e6185f(iterable) {
    return {
        *subscribe () {
            return $975d9bd49ec28e84$export$ec068583843480e7(iterable[Symbol.asyncIterator]());
        }
    };
}

});

parcelRegister("fnVfN", function(module, exports) {

$parcel$export(module.exports, "useAbortSignal", function () { return $b3356a6585e589e8$export$9f0051d5a1cbe3b9; });

var $6wugg = parcelRequire("6wugg");
function $b3356a6585e589e8$export$9f0051d5a1cbe3b9() {
    return (0, $6wugg.resource)(function* AbortSignal(provide) {
        let controller = new AbortController();
        try {
            yield* provide(controller.signal);
        } finally{
            controller.abort();
        }
    });
}

});

parcelRegister("e0p8q", function(module, exports) {
function $a324900697c613b5$export$871de8747c9eaa88(op) {
    return function(stream) {
        return {
            subscribe () {
                return {
                    *[Symbol.iterator] () {
                        let subscription = yield* stream.subscribe();
                        return {
                            *next () {
                                let next = yield* subscription.next();
                                if (next.done) return next;
                                else return {
                                    ...next,
                                    value: yield* op(next.value)
                                };
                            }
                        };
                    }
                };
            }
        };
    };
}

});

parcelRegister("46GC1", function(module, exports) {
function $2fd8c6ddba71c3ab$export$3dea766d36a8935f(predicate) {
    return function(stream) {
        return {
            subscribe () {
                return {
                    *[Symbol.iterator] () {
                        let subscription = yield* stream.subscribe();
                        return {
                            *next () {
                                while(true){
                                    let next = yield* subscription.next();
                                    if (next.done) return next;
                                    else if (yield* predicate(next.value)) return next;
                                }
                            }
                        };
                    }
                };
            }
        };
    };
}

});

parcelRegister("jq6WH", function(module, exports) {
function $e235d555d813ea9d$export$a4627e546088548d(a, ...fns) {
    for (const fn of fns)a = fn(a);
    return a;
}

});

parcelRegister("ciUsu", function(module, exports) {
// deno-lint-ignore-file no-explicit-any ban-types

var $5bXcR = parcelRequire("5bXcR");

var $6wugg = parcelRequire("6wugg");
parcelRequire("cgAOK");
var $j7yHE = parcelRequire("j7yHE");
function $8f52f5ef7f41fc47$export$d2de3aaeafa91619(target, name) {
    return (0, $j7yHE.first)($8f52f5ef7f41fc47$export$af631764ddc44097(target, name));
}
function $8f52f5ef7f41fc47$export$af631764ddc44097(target, name) {
    return {
        subscribe () {
            return (0, $6wugg.resource)(function*(provide) {
                let { send: send, subscribe: subscribe } = (0, $5bXcR.createSignal)();
                target.addEventListener(name, send);
                try {
                    yield* provide((yield* subscribe()));
                } finally{
                    target.removeEventListener(name, send);
                }
            });
        }
    };
}

});

parcelRegister("4oBLs", function(module, exports) {

var $dDyES = parcelRequire("dDyES");

var $lPibo = parcelRequire("lPibo");

var $6wugg = parcelRequire("6wugg");

var $bFL3r = parcelRequire("bFL3r");

var $4TNnu = parcelRequire("4TNnu");
function* $3336b28769eec796$export$5c525e238923a57d(status, message) {
    let escape = yield* $3336b28769eec796$var$ExitContext;
    escape({
        status: status,
        message: message
    });
}
async function $3336b28769eec796$export$f22da7240b7add18(body) {
    let hardexit = (_status)=>{};
    let result = await (0, $bFL3r.run)(()=>(0, $6wugg.action)(function*(resolve) {
            // action will return shutdown immediately upon resolve, so stash
            // this function in the exit context so it can be called anywhere.
            yield* $3336b28769eec796$var$ExitContext.set(resolve);
            try {
                let interrupt = ()=>resolve({
                        status: 130,
                        signal: "SIGINT"
                    });
                yield* $3336b28769eec796$var$withHost({
                    *deno () {
                        hardexit = (status)=>Deno.exit(status);
                        try {
                            Deno.addSignalListener("SIGINT", interrupt);
                            yield* body(Deno.args.slice());
                        } finally{
                            Deno.removeSignalListener("SIGINT", interrupt);
                        }
                    },
                    *node () {
                        //@ts-expect-error type-checked by Deno, run on Node
                        hardexit = (status)=>$parcel$global.process.exit(status);
                        try {
                            //@ts-expect-error type-checked by Deno, run on Node
                            $4TNnu.on("SIGINT", interrupt);
                            //@ts-expect-error type-checked by Deno, run on Node
                            yield* body($parcel$global.process.argv.slice(2));
                        } finally{
                            //@ts-expect-error this runs on Node
                            $4TNnu.off("SIGINT", interrupt);
                        }
                    },
                    *browser () {
                        try {
                            self.addEventListener("unload", interrupt);
                            yield* body([]);
                        } finally{
                            self.removeEventListener("unload", interrupt);
                        }
                    }
                });
                yield* $3336b28769eec796$export$5c525e238923a57d(0);
            } catch (error) {
                resolve({
                    status: 1,
                    error: error
                });
            }
        }));
    if (result.message) {
        if (result.status === 0) console.log(result.message);
        else console.error(result.message);
    }
    if (result.error) console.error(result.error);
    hardexit(result.status);
}
const $3336b28769eec796$var$ExitContext = (0, $lPibo.createContext)("exit");
function* $3336b28769eec796$var$withHost(op) {
    let global1 = $dDyES.dntGlobalThis;
    if (typeof global1.Deno !== "undefined") return yield* op.deno();
    else if (Object.prototype.toString.call(//@ts-expect-error dev env is deno, but this is safe to run.
    typeof $4TNnu !== "undefined" ? $4TNnu : 0) === "[object process]") return yield* op.node();
    else return yield* op.browser();
}

});
parcelRegister("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = 'browser';
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ''; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$391299e0893a3dfa$var$process.cwd = function() {
    return '/';
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});


parcelRegister("36Me7", function(module, exports) {

var $6wugg = parcelRequire("6wugg");

var $15Qbp = parcelRequire("15Qbp");
function $2437576f29cb7b3d$export$84bf76cd7afc7469(ops) {
    return (0, $15Qbp.call)(function*() {
        let tasks = [];
        for (let operation of ops)tasks.push((yield* (0, $6wugg.spawn)(()=>operation)));
        let results = [];
        for (let task of tasks)results.push((yield* task));
        return results;
    });
}

});

parcelRegister("kGwWV", function(module, exports) {

$parcel$export(module.exports, "each", function () { return $f0f149f62b9d8446$export$79b2f7037acddd43; });

var $lPibo = parcelRequire("lPibo");
function $f0f149f62b9d8446$export$79b2f7037acddd43(stream) {
    return {
        *[Symbol.iterator] () {
            let subscription = yield* stream.subscribe();
            let current = yield* subscription.next();
            let stack = yield* $f0f149f62b9d8446$var$EachStack.get();
            if (!stack) stack = yield* $f0f149f62b9d8446$var$EachStack.set([]);
            let context = {
                subscription: subscription,
                current: current
            };
            stack.push(context);
            let iterator = {
                next () {
                    if (context.stale) {
                        let error = new Error(`for each loop did not use each.next() operation before continuing`);
                        error.name = "IterationError";
                        throw error;
                    } else {
                        context.stale = true;
                        return context.current;
                    }
                },
                return () {
                    stack.pop();
                    return {
                        done: true,
                        value: void 0
                    };
                }
            };
            return {
                [Symbol.iterator]: ()=>iterator
            };
        }
    };
}
$f0f149f62b9d8446$export$79b2f7037acddd43.next = function next() {
    return {
        name: "each.next()",
        *[Symbol.iterator] () {
            let stack = yield* $f0f149f62b9d8446$var$EachStack;
            let context = stack[stack.length - 1];
            if (!context) {
                let error = new Error(`cannot call next() outside of an iteration`);
                error.name = "IterationError";
                throw error;
            }
            let current = yield* context.subscription.next();
            delete context.stale;
            context.current = current;
            if (current.done) stack.pop();
        }
    };
};
const $f0f149f62b9d8446$var$EachStack = (0, $lPibo.createContext)("each");

});

parcelRegister("8Qg8J", function(module, exports) {

$parcel$export(module.exports, "ensure", function () { return $66ffb316a61948a6$export$c291509e8e0abb43; });

var $6wugg = parcelRequire("6wugg");
function $66ffb316a61948a6$export$c291509e8e0abb43(fn) {
    return (0, $6wugg.resource)(function*(provide) {
        try {
            yield* provide();
        } finally{
            let result = fn();
            if (result && typeof result[Symbol.iterator] === "function") yield* result;
        }
    });
}

});

parcelRegister("j6X2g", function(module, exports) {

$parcel$export(module.exports, "race", function () { return $de9c5f18002ce4a4$export$236c05de452bec2; });

var $6wugg = parcelRequire("6wugg");
function $de9c5f18002ce4a4$export$236c05de452bec2(operations) {
    return (0, $6wugg.action)(function*(resolve, reject) {
        for (let operation of operations)yield* (0, $6wugg.spawn)(function*() {
            try {
                resolve((yield* operation));
            } catch (error) {
                reject(error);
            }
        });
    });
}

});



parcelRegister("2YcCh", function(module, exports) {
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("7KgLo")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("cPVO8")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("i2TPN")).useSelector; });
$parcel$export(module.exports, "useStore", function () { return (parcelRequire("jfISs")).useStore; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hVYK3 = parcelRequire("hVYK3");

var $h2bFT = parcelRequire("h2bFT");
parcelRequire("1ecAZ");
var $6afFj = parcelRequire("6afFj");

var $eZbJQ = parcelRequire("eZbJQ");

var $i2TPN = parcelRequire("i2TPN");

var $bMTs6 = parcelRequire("bMTs6");
parcelRequire("Tllxm");
(0, $i2TPN.initializeUseSelector)((0, $h2bFT.useSyncExternalStoreWithSelector));
(0, $bMTs6.initializeConnect)((0, $hVYK3.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $eZbJQ.setBatch)((0, $6afFj.unstable_batchedUpdates));

});
parcelRegister("hVYK3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1JHgz"));

});
parcelRegister("1JHgz", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $143b8e347aaa867b$export$306c0aa65ff9ec16; }, function (v) { return $143b8e347aaa867b$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $143b8e347aaa867b$export$306c0aa65ff9ec16;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
function $143b8e347aaa867b$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $143b8e347aaa867b$var$objectIs = "function" === typeof Object.is ? Object.is : $143b8e347aaa867b$var$is, $143b8e347aaa867b$var$useState = $bh6RR.useState, $143b8e347aaa867b$var$useEffect = $bh6RR.useEffect, $143b8e347aaa867b$var$useLayoutEffect = $bh6RR.useLayoutEffect, $143b8e347aaa867b$var$useDebugValue = $bh6RR.useDebugValue;
function $143b8e347aaa867b$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $143b8e347aaa867b$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $143b8e347aaa867b$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $143b8e347aaa867b$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $143b8e347aaa867b$var$useEffect(function() {
        $143b8e347aaa867b$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $143b8e347aaa867b$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $143b8e347aaa867b$var$useDebugValue(value);
    return value;
}
function $143b8e347aaa867b$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$143b8e347aaa867b$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $143b8e347aaa867b$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $143b8e347aaa867b$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $143b8e347aaa867b$var$useSyncExternalStore$1 : $143b8e347aaa867b$var$useSyncExternalStore$2;
$143b8e347aaa867b$export$306c0aa65ff9ec16 = void 0 !== $bh6RR.useSyncExternalStore ? $bh6RR.useSyncExternalStore : $143b8e347aaa867b$var$shim;

});


parcelRegister("h2bFT", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8chtt"));

});
parcelRegister("8chtt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $5f7cffc733698205$export$bf730a2d8bf68b42; }, function (v) { return $5f7cffc733698205$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5f7cffc733698205$export$bf730a2d8bf68b42;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $hVYK3 = parcelRequire("hVYK3");
function $5f7cffc733698205$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $5f7cffc733698205$var$objectIs = "function" === typeof Object.is ? Object.is : $5f7cffc733698205$var$is, $5f7cffc733698205$var$useSyncExternalStore = $hVYK3.useSyncExternalStore, $5f7cffc733698205$var$useRef = $bh6RR.useRef, $5f7cffc733698205$var$useEffect = $bh6RR.useEffect, $5f7cffc733698205$var$useMemo = $bh6RR.useMemo, $5f7cffc733698205$var$useDebugValue = $bh6RR.useDebugValue;
$5f7cffc733698205$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $5f7cffc733698205$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $5f7cffc733698205$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($5f7cffc733698205$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $5f7cffc733698205$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $5f7cffc733698205$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $5f7cffc733698205$var$useDebugValue(value);
    return value;
};

});


parcelRegister("1ecAZ", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("6afFj")).unstable_batchedUpdates; });

var $6afFj = parcelRequire("6afFj");

});

parcelRegister("eZbJQ", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $ae8fde2d4fd50c23$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $ae8fde2d4fd50c23$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $ae8fde2d4fd50c23$var$defaultNoopBatch(callback) {
    callback();
}
let $ae8fde2d4fd50c23$var$batch = $ae8fde2d4fd50c23$var$defaultNoopBatch; // Allow injecting another batching function later
const $ae8fde2d4fd50c23$export$4b9874722d0da7bc = (newBatch)=>$ae8fde2d4fd50c23$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $ae8fde2d4fd50c23$export$fc47d4c0ba3bd2c6 = ()=>$ae8fde2d4fd50c23$var$batch;

});

parcelRegister("i2TPN", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", function () { return $d233b978eda8b50e$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $d233b978eda8b50e$export$2105062e25df4afe; });

var $bh6RR = parcelRequire("bh6RR");

var $cnH71 = parcelRequire("cnH71");

var $5G6M3 = parcelRequire("5G6M3");

var $9xHUU = parcelRequire("9xHUU");
let $d233b978eda8b50e$var$useSyncExternalStoreWithSelector = (0, $9xHUU.notInitialized);
const $d233b978eda8b50e$export$e2e6e3f3f3b782e3 = (fn)=>{
    $d233b978eda8b50e$var$useSyncExternalStoreWithSelector = fn;
};
const $d233b978eda8b50e$var$refEquality = (a, b)=>a === b;
function $d233b978eda8b50e$export$2b53f90d2bd1cbfb(context = (0, $5G6M3.ReactReduxContext)) {
    const useReduxContext = context === (0, $5G6M3.ReactReduxContext) ? (0, $cnH71.useReduxContext) : (0, $cnH71.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $d233b978eda8b50e$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $bh6RR.useRef)(true);
        const wrappedSelector = (0, $bh6RR.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $d233b978eda8b50e$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $bh6RR.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $d233b978eda8b50e$export$2105062e25df4afe = /*#__PURE__*/ $d233b978eda8b50e$export$2b53f90d2bd1cbfb();

});
parcelRegister("cnH71", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", function () { return $9039133c4c4ae942$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $9039133c4c4ae942$export$c1275ca9a6fd3ec5; });

var $bh6RR = parcelRequire("bh6RR");

var $5G6M3 = parcelRequire("5G6M3");
function $9039133c4c4ae942$export$d4d6226d5fc61558(context = (0, $5G6M3.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $bh6RR.useContext)(context);
        return contextValue;
    };
}
const $9039133c4c4ae942$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $9039133c4c4ae942$export$d4d6226d5fc61558();

});
parcelRegister("5G6M3", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $4226212f2ef0bb60$export$cc80c08dc91f1c00; });

var $bh6RR = parcelRequire("bh6RR");
const $4226212f2ef0bb60$var$ContextKey = Symbol.for(`react-redux-context`);
const $4226212f2ef0bb60$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $4226212f2ef0bb60$var$getContext() {
    var _gT$ContextKey;
    if (!$bh6RR.createContext) return {};
    const contextMap = (_gT$ContextKey = $4226212f2ef0bb60$var$gT[$4226212f2ef0bb60$var$ContextKey]) != null ? _gT$ContextKey : $4226212f2ef0bb60$var$gT[$4226212f2ef0bb60$var$ContextKey] = new Map();
    let realContext = contextMap.get($bh6RR.createContext);
    if (!realContext) {
        realContext = $bh6RR.createContext(null);
        contextMap.set($bh6RR.createContext, realContext);
    }
    return realContext;
}
const $4226212f2ef0bb60$export$cc80c08dc91f1c00 = /*#__PURE__*/ $4226212f2ef0bb60$var$getContext();
var $4226212f2ef0bb60$export$2e2bcd8739ae039 = $4226212f2ef0bb60$export$cc80c08dc91f1c00;

});


parcelRegister("9xHUU", function(module, exports) {

$parcel$export(module.exports, "notInitialized", function () { return $6f294317b66fbd47$export$20656a4825650bd0; });
const $6f294317b66fbd47$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("bMTs6", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", function () { return $894f310e0274e651$export$36d45daa6a4925b8; });

var $4WYaH = parcelRequire("4WYaH");

var $hCIyK = parcelRequire("hCIyK");

var $adG4d = parcelRequire("adG4d");

var $bh6RR = parcelRequire("bh6RR");

var $5KBvo = parcelRequire("5KBvo");

var $jdKss = parcelRequire("jdKss");

var $e7Iu5 = parcelRequire("e7Iu5");

var $2QBZs = parcelRequire("2QBZs");

var $4rjJ7 = parcelRequire("4rjJ7");

var $831kJ = parcelRequire("831kJ");

var $8Hls7 = parcelRequire("8Hls7");

var $5jjlV = parcelRequire("5jjlV");
parcelRequire("38g8Y");

var $5G6M3 = parcelRequire("5G6M3");

var $9xHUU = parcelRequire("9xHUU");
const $894f310e0274e651$var$_excluded = [
    "reactReduxForwardedRef"
];
let $894f310e0274e651$var$useSyncExternalStore = (0, $9xHUU.notInitialized);
const $894f310e0274e651$export$36d45daa6a4925b8 = (fn)=>{
    $894f310e0274e651$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $894f310e0274e651$var$EMPTY_ARRAY = [
    null,
    0
];
const $894f310e0274e651$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $894f310e0274e651$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $894f310e0274e651$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $8Hls7.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $894f310e0274e651$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $894f310e0274e651$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $894f310e0274e651$var$initStateUpdates = ()=>$894f310e0274e651$var$EMPTY_ARRAY;
function $894f310e0274e651$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $894f310e0274e651$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $894f310e0274e651$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $894f310e0274e651$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $5jjlV.default), areStatePropsEqual: areStatePropsEqual = (0, $5jjlV.default), areMergedPropsEqual: areMergedPropsEqual = (0, $5jjlV.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $5G6M3.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $2QBZs.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $e7Iu5.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $4rjJ7.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $bh6RR.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $hCIyK.default)(props, $894f310e0274e651$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $bh6RR.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $5KBvo.isContextConsumer)(/*#__PURE__*/ $bh6RR.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $bh6RR.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $bh6RR.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $jdKss.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $bh6RR.useMemo(()=>{
                if (!shouldHandleStateChanges) return $894f310e0274e651$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $831kJ.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $bh6RR.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $4WYaH.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $bh6RR.useRef();
            const lastWrapperProps = $bh6RR.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $bh6RR.useRef();
            const renderIsScheduled = $bh6RR.useRef(false);
            const isProcessingDispatch = $bh6RR.useRef(false);
            const isMounted = $bh6RR.useRef(false);
            const latestSubscriptionCallbackError = $bh6RR.useRef();
            (0, $8Hls7.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $bh6RR.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $bh6RR.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $894f310e0274e651$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $894f310e0274e651$var$useIsomorphicLayoutEffectWithArgs($894f310e0274e651$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $894f310e0274e651$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $8Hls7.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $bh6RR.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $bh6RR.createElement(WrappedComponent, (0, $4WYaH.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $bh6RR.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $bh6RR.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $bh6RR.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $bh6RR.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $bh6RR.createElement(Connect, (0, $4WYaH.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $894f310e0274e651$export$2e2bcd8739ae039 = $894f310e0274e651$var$connect;

});
parcelRegister("4WYaH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39ab41060f0dd572$export$2e2bcd8739ae039; });
function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    return $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $39ab41060f0dd572$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hCIyK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd488cd9c287f883$export$2e2bcd8739ae039; });
function $cd488cd9c287f883$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("adG4d", function(module, exports) {
'use strict';

var $lhF4u = parcelRequire("lhF4u");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $770bbfe5492d7fd4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $770bbfe5492d7fd4$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $770bbfe5492d7fd4$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$TYPE_STATICS = {};
$770bbfe5492d7fd4$var$TYPE_STATICS[$lhF4u.ForwardRef] = $770bbfe5492d7fd4$var$FORWARD_REF_STATICS;
$770bbfe5492d7fd4$var$TYPE_STATICS[$lhF4u.Memo] = $770bbfe5492d7fd4$var$MEMO_STATICS;
function $770bbfe5492d7fd4$var$getStatics(component) {
    // React v16.11 and below
    if ($lhF4u.isMemo(component)) return $770bbfe5492d7fd4$var$MEMO_STATICS;
     // React v16.12 and above
    return $770bbfe5492d7fd4$var$TYPE_STATICS[component['$$typeof']] || $770bbfe5492d7fd4$var$REACT_STATICS;
}
var $770bbfe5492d7fd4$var$defineProperty = Object.defineProperty;
var $770bbfe5492d7fd4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $770bbfe5492d7fd4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $770bbfe5492d7fd4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $770bbfe5492d7fd4$var$getPrototypeOf = Object.getPrototypeOf;
var $770bbfe5492d7fd4$var$objectPrototype = Object.prototype;
function $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($770bbfe5492d7fd4$var$objectPrototype) {
            var inheritedComponent = $770bbfe5492d7fd4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $770bbfe5492d7fd4$var$objectPrototype) $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $770bbfe5492d7fd4$var$getOwnPropertyNames(sourceComponent);
        if ($770bbfe5492d7fd4$var$getOwnPropertySymbols) keys = keys.concat($770bbfe5492d7fd4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $770bbfe5492d7fd4$var$getStatics(targetComponent);
        var sourceStatics = $770bbfe5492d7fd4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$770bbfe5492d7fd4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $770bbfe5492d7fd4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $770bbfe5492d7fd4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $770bbfe5492d7fd4$var$hoistNonReactStatics;

});
parcelRegister("lhF4u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g4WQO"));

});
parcelRegister("g4WQO", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $bb4aab9d21a68c2e$export$2b8d127b894957b9; }, function (v) { return $bb4aab9d21a68c2e$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $bb4aab9d21a68c2e$export$cea3a54a6425200c; }, function (v) { return $bb4aab9d21a68c2e$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $bb4aab9d21a68c2e$export$a7c73072b1a182ae; }, function (v) { return $bb4aab9d21a68c2e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $bb4aab9d21a68c2e$export$9f27bc3417b4524d; }, function (v) { return $bb4aab9d21a68c2e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $bb4aab9d21a68c2e$export$db77ccec0bb4ccac; }, function (v) { return $bb4aab9d21a68c2e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35; }, function (v) { return $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bb4aab9d21a68c2e$export$ffb0004e005737fa; }, function (v) { return $bb4aab9d21a68c2e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $bb4aab9d21a68c2e$export$b624eff549462981; }, function (v) { return $bb4aab9d21a68c2e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $bb4aab9d21a68c2e$export$7897aa7841a5380c; }, function (v) { return $bb4aab9d21a68c2e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $bb4aab9d21a68c2e$export$602eac185826482c; }, function (v) { return $bb4aab9d21a68c2e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $bb4aab9d21a68c2e$export$e2c29f18771995cb; }, function (v) { return $bb4aab9d21a68c2e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bb4aab9d21a68c2e$export$5f8d39834fd61797; }, function (v) { return $bb4aab9d21a68c2e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bb4aab9d21a68c2e$export$74bf444e3cd11ea5; }, function (v) { return $bb4aab9d21a68c2e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $bb4aab9d21a68c2e$export$92387174baf9b227; }, function (v) { return $bb4aab9d21a68c2e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $bb4aab9d21a68c2e$export$ec112efeb987d9c6; }, function (v) { return $bb4aab9d21a68c2e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $bb4aab9d21a68c2e$export$b706b080d889d2c9; }, function (v) { return $bb4aab9d21a68c2e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $bb4aab9d21a68c2e$export$5be5a87408f70ddc; }, function (v) { return $bb4aab9d21a68c2e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d; }, function (v) { return $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $bb4aab9d21a68c2e$export$455c2e768291efa6; }, function (v) { return $bb4aab9d21a68c2e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $bb4aab9d21a68c2e$export$9522e17588c12572; }, function (v) { return $bb4aab9d21a68c2e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $bb4aab9d21a68c2e$export$2110ac352bb060b9; }, function (v) { return $bb4aab9d21a68c2e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $bb4aab9d21a68c2e$export$56885ab8b9c456ab; }, function (v) { return $bb4aab9d21a68c2e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $bb4aab9d21a68c2e$export$d927fcb6adf8f9de; }, function (v) { return $bb4aab9d21a68c2e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $bb4aab9d21a68c2e$export$b82d16f27459e05a; }, function (v) { return $bb4aab9d21a68c2e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $bb4aab9d21a68c2e$export$522c17b4f5e123e8; }, function (v) { return $bb4aab9d21a68c2e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6; }, function (v) { return $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $bb4aab9d21a68c2e$export$9b621391a187a31a; }, function (v) { return $bb4aab9d21a68c2e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $bb4aab9d21a68c2e$export$f5bbd400c2f4426f; }, function (v) { return $bb4aab9d21a68c2e$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb4aab9d21a68c2e$export$2b8d127b894957b9;
var $bb4aab9d21a68c2e$export$cea3a54a6425200c;
var $bb4aab9d21a68c2e$export$a7c73072b1a182ae;
var $bb4aab9d21a68c2e$export$9f27bc3417b4524d;
var $bb4aab9d21a68c2e$export$db77ccec0bb4ccac;
var $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35;
var $bb4aab9d21a68c2e$export$ffb0004e005737fa;
var $bb4aab9d21a68c2e$export$b624eff549462981;
var $bb4aab9d21a68c2e$export$7897aa7841a5380c;
var $bb4aab9d21a68c2e$export$602eac185826482c;
var $bb4aab9d21a68c2e$export$e2c29f18771995cb;
var $bb4aab9d21a68c2e$export$5f8d39834fd61797;
var $bb4aab9d21a68c2e$export$74bf444e3cd11ea5;
var $bb4aab9d21a68c2e$export$92387174baf9b227;
var $bb4aab9d21a68c2e$export$ec112efeb987d9c6;
var $bb4aab9d21a68c2e$export$b706b080d889d2c9;
var $bb4aab9d21a68c2e$export$5be5a87408f70ddc;
var $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d;
var $bb4aab9d21a68c2e$export$455c2e768291efa6;
var $bb4aab9d21a68c2e$export$9522e17588c12572;
var $bb4aab9d21a68c2e$export$2110ac352bb060b9;
var $bb4aab9d21a68c2e$export$56885ab8b9c456ab;
var $bb4aab9d21a68c2e$export$d927fcb6adf8f9de;
var $bb4aab9d21a68c2e$export$b82d16f27459e05a;
var $bb4aab9d21a68c2e$export$522c17b4f5e123e8;
var $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6;
var $bb4aab9d21a68c2e$export$9b621391a187a31a;
var $bb4aab9d21a68c2e$export$f5bbd400c2f4426f;
'use strict';
var $bb4aab9d21a68c2e$var$b = "function" === typeof Symbol && Symbol.for, $bb4aab9d21a68c2e$var$c = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.element") : 60103, $bb4aab9d21a68c2e$var$d = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.portal") : 60106, $bb4aab9d21a68c2e$var$e = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.fragment") : 60107, $bb4aab9d21a68c2e$var$f = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.strict_mode") : 60108, $bb4aab9d21a68c2e$var$g = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.profiler") : 60114, $bb4aab9d21a68c2e$var$h = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.provider") : 60109, $bb4aab9d21a68c2e$var$k = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.context") : 60110, $bb4aab9d21a68c2e$var$l = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.async_mode") : 60111, $bb4aab9d21a68c2e$var$m = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $bb4aab9d21a68c2e$var$n = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.forward_ref") : 60112, $bb4aab9d21a68c2e$var$p = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.suspense") : 60113, $bb4aab9d21a68c2e$var$q = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.suspense_list") : 60120, $bb4aab9d21a68c2e$var$r = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.memo") : 60115, $bb4aab9d21a68c2e$var$t = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.lazy") : 60116, $bb4aab9d21a68c2e$var$v = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.block") : 60121, $bb4aab9d21a68c2e$var$w = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.fundamental") : 60117, $bb4aab9d21a68c2e$var$x = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.responder") : 60118, $bb4aab9d21a68c2e$var$y = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.scope") : 60119;
function $bb4aab9d21a68c2e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $bb4aab9d21a68c2e$var$c:
                switch(a = a.type, a){
                    case $bb4aab9d21a68c2e$var$l:
                    case $bb4aab9d21a68c2e$var$m:
                    case $bb4aab9d21a68c2e$var$e:
                    case $bb4aab9d21a68c2e$var$g:
                    case $bb4aab9d21a68c2e$var$f:
                    case $bb4aab9d21a68c2e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $bb4aab9d21a68c2e$var$k:
                            case $bb4aab9d21a68c2e$var$n:
                            case $bb4aab9d21a68c2e$var$t:
                            case $bb4aab9d21a68c2e$var$r:
                            case $bb4aab9d21a68c2e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $bb4aab9d21a68c2e$var$d:
                return u;
        }
    }
}
function $bb4aab9d21a68c2e$var$A(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$m;
}
$bb4aab9d21a68c2e$export$2b8d127b894957b9 = $bb4aab9d21a68c2e$var$l;
$bb4aab9d21a68c2e$export$cea3a54a6425200c = $bb4aab9d21a68c2e$var$m;
$bb4aab9d21a68c2e$export$a7c73072b1a182ae = $bb4aab9d21a68c2e$var$k;
$bb4aab9d21a68c2e$export$9f27bc3417b4524d = $bb4aab9d21a68c2e$var$h;
$bb4aab9d21a68c2e$export$db77ccec0bb4ccac = $bb4aab9d21a68c2e$var$c;
$bb4aab9d21a68c2e$export$8392c0c9d3dcbd35 = $bb4aab9d21a68c2e$var$n;
$bb4aab9d21a68c2e$export$ffb0004e005737fa = $bb4aab9d21a68c2e$var$e;
$bb4aab9d21a68c2e$export$b624eff549462981 = $bb4aab9d21a68c2e$var$t;
$bb4aab9d21a68c2e$export$7897aa7841a5380c = $bb4aab9d21a68c2e$var$r;
$bb4aab9d21a68c2e$export$602eac185826482c = $bb4aab9d21a68c2e$var$d;
$bb4aab9d21a68c2e$export$e2c29f18771995cb = $bb4aab9d21a68c2e$var$g;
$bb4aab9d21a68c2e$export$5f8d39834fd61797 = $bb4aab9d21a68c2e$var$f;
$bb4aab9d21a68c2e$export$74bf444e3cd11ea5 = $bb4aab9d21a68c2e$var$p;
$bb4aab9d21a68c2e$export$92387174baf9b227 = function(a) {
    return $bb4aab9d21a68c2e$var$A(a) || $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$l;
};
$bb4aab9d21a68c2e$export$ec112efeb987d9c6 = $bb4aab9d21a68c2e$var$A;
$bb4aab9d21a68c2e$export$b706b080d889d2c9 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$k;
};
$bb4aab9d21a68c2e$export$5be5a87408f70ddc = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$h;
};
$bb4aab9d21a68c2e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bb4aab9d21a68c2e$var$c;
};
$bb4aab9d21a68c2e$export$455c2e768291efa6 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$n;
};
$bb4aab9d21a68c2e$export$9522e17588c12572 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$e;
};
$bb4aab9d21a68c2e$export$2110ac352bb060b9 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$t;
};
$bb4aab9d21a68c2e$export$56885ab8b9c456ab = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$r;
};
$bb4aab9d21a68c2e$export$d927fcb6adf8f9de = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$d;
};
$bb4aab9d21a68c2e$export$b82d16f27459e05a = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$g;
};
$bb4aab9d21a68c2e$export$522c17b4f5e123e8 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$f;
};
$bb4aab9d21a68c2e$export$1aabd8a0274ecfd6 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$p;
};
$bb4aab9d21a68c2e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $bb4aab9d21a68c2e$var$e || a === $bb4aab9d21a68c2e$var$m || a === $bb4aab9d21a68c2e$var$g || a === $bb4aab9d21a68c2e$var$f || a === $bb4aab9d21a68c2e$var$p || a === $bb4aab9d21a68c2e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $bb4aab9d21a68c2e$var$t || a.$$typeof === $bb4aab9d21a68c2e$var$r || a.$$typeof === $bb4aab9d21a68c2e$var$h || a.$$typeof === $bb4aab9d21a68c2e$var$k || a.$$typeof === $bb4aab9d21a68c2e$var$n || a.$$typeof === $bb4aab9d21a68c2e$var$w || a.$$typeof === $bb4aab9d21a68c2e$var$x || a.$$typeof === $bb4aab9d21a68c2e$var$y || a.$$typeof === $bb4aab9d21a68c2e$var$v);
};
$bb4aab9d21a68c2e$export$f5bbd400c2f4426f = $bb4aab9d21a68c2e$var$z;

});



parcelRegister("5KBvo", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fcHEU"));

});
parcelRegister("fcHEU", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $b119d7ba76d4c605$export$a7c73072b1a182ae; }, function (v) { return $b119d7ba76d4c605$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b119d7ba76d4c605$export$9f27bc3417b4524d; }, function (v) { return $b119d7ba76d4c605$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b119d7ba76d4c605$export$db77ccec0bb4ccac; }, function (v) { return $b119d7ba76d4c605$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b119d7ba76d4c605$export$8392c0c9d3dcbd35; }, function (v) { return $b119d7ba76d4c605$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b119d7ba76d4c605$export$ffb0004e005737fa; }, function (v) { return $b119d7ba76d4c605$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b119d7ba76d4c605$export$b624eff549462981; }, function (v) { return $b119d7ba76d4c605$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b119d7ba76d4c605$export$7897aa7841a5380c; }, function (v) { return $b119d7ba76d4c605$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b119d7ba76d4c605$export$602eac185826482c; }, function (v) { return $b119d7ba76d4c605$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b119d7ba76d4c605$export$e2c29f18771995cb; }, function (v) { return $b119d7ba76d4c605$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b119d7ba76d4c605$export$5f8d39834fd61797; }, function (v) { return $b119d7ba76d4c605$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b119d7ba76d4c605$export$74bf444e3cd11ea5; }, function (v) { return $b119d7ba76d4c605$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $b119d7ba76d4c605$export$998bcd577473dd93; }, function (v) { return $b119d7ba76d4c605$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b119d7ba76d4c605$export$92387174baf9b227; }, function (v) { return $b119d7ba76d4c605$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b119d7ba76d4c605$export$ec112efeb987d9c6; }, function (v) { return $b119d7ba76d4c605$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b119d7ba76d4c605$export$b706b080d889d2c9; }, function (v) { return $b119d7ba76d4c605$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b119d7ba76d4c605$export$5be5a87408f70ddc; }, function (v) { return $b119d7ba76d4c605$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b119d7ba76d4c605$export$45a5e7f76e0caa8d; }, function (v) { return $b119d7ba76d4c605$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b119d7ba76d4c605$export$455c2e768291efa6; }, function (v) { return $b119d7ba76d4c605$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b119d7ba76d4c605$export$9522e17588c12572; }, function (v) { return $b119d7ba76d4c605$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b119d7ba76d4c605$export$2110ac352bb060b9; }, function (v) { return $b119d7ba76d4c605$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b119d7ba76d4c605$export$56885ab8b9c456ab; }, function (v) { return $b119d7ba76d4c605$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b119d7ba76d4c605$export$d927fcb6adf8f9de; }, function (v) { return $b119d7ba76d4c605$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b119d7ba76d4c605$export$b82d16f27459e05a; }, function (v) { return $b119d7ba76d4c605$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b119d7ba76d4c605$export$522c17b4f5e123e8; }, function (v) { return $b119d7ba76d4c605$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b119d7ba76d4c605$export$1aabd8a0274ecfd6; }, function (v) { return $b119d7ba76d4c605$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $b119d7ba76d4c605$export$3d6c20d97e46b957; }, function (v) { return $b119d7ba76d4c605$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b119d7ba76d4c605$export$9b621391a187a31a; }, function (v) { return $b119d7ba76d4c605$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b119d7ba76d4c605$export$f5bbd400c2f4426f; }, function (v) { return $b119d7ba76d4c605$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b119d7ba76d4c605$export$a7c73072b1a182ae;
var $b119d7ba76d4c605$export$9f27bc3417b4524d;
var $b119d7ba76d4c605$export$db77ccec0bb4ccac;
var $b119d7ba76d4c605$export$8392c0c9d3dcbd35;
var $b119d7ba76d4c605$export$ffb0004e005737fa;
var $b119d7ba76d4c605$export$b624eff549462981;
var $b119d7ba76d4c605$export$7897aa7841a5380c;
var $b119d7ba76d4c605$export$602eac185826482c;
var $b119d7ba76d4c605$export$e2c29f18771995cb;
var $b119d7ba76d4c605$export$5f8d39834fd61797;
var $b119d7ba76d4c605$export$74bf444e3cd11ea5;
var $b119d7ba76d4c605$export$998bcd577473dd93;
var $b119d7ba76d4c605$export$92387174baf9b227;
var $b119d7ba76d4c605$export$ec112efeb987d9c6;
var $b119d7ba76d4c605$export$b706b080d889d2c9;
var $b119d7ba76d4c605$export$5be5a87408f70ddc;
var $b119d7ba76d4c605$export$45a5e7f76e0caa8d;
var $b119d7ba76d4c605$export$455c2e768291efa6;
var $b119d7ba76d4c605$export$9522e17588c12572;
var $b119d7ba76d4c605$export$2110ac352bb060b9;
var $b119d7ba76d4c605$export$56885ab8b9c456ab;
var $b119d7ba76d4c605$export$d927fcb6adf8f9de;
var $b119d7ba76d4c605$export$b82d16f27459e05a;
var $b119d7ba76d4c605$export$522c17b4f5e123e8;
var $b119d7ba76d4c605$export$1aabd8a0274ecfd6;
var $b119d7ba76d4c605$export$3d6c20d97e46b957;
var $b119d7ba76d4c605$export$9b621391a187a31a;
var $b119d7ba76d4c605$export$f5bbd400c2f4426f;
'use strict';
var $b119d7ba76d4c605$var$b = Symbol.for("react.element"), $b119d7ba76d4c605$var$c = Symbol.for("react.portal"), $b119d7ba76d4c605$var$d = Symbol.for("react.fragment"), $b119d7ba76d4c605$var$e = Symbol.for("react.strict_mode"), $b119d7ba76d4c605$var$f = Symbol.for("react.profiler"), $b119d7ba76d4c605$var$g = Symbol.for("react.provider"), $b119d7ba76d4c605$var$h = Symbol.for("react.context"), $b119d7ba76d4c605$var$k = Symbol.for("react.server_context"), $b119d7ba76d4c605$var$l = Symbol.for("react.forward_ref"), $b119d7ba76d4c605$var$m = Symbol.for("react.suspense"), $b119d7ba76d4c605$var$n = Symbol.for("react.suspense_list"), $b119d7ba76d4c605$var$p = Symbol.for("react.memo"), $b119d7ba76d4c605$var$q = Symbol.for("react.lazy"), $b119d7ba76d4c605$var$t = Symbol.for("react.offscreen"), $b119d7ba76d4c605$var$u;
$b119d7ba76d4c605$var$u = Symbol.for("react.module.reference");
function $b119d7ba76d4c605$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $b119d7ba76d4c605$var$b:
                switch(a = a.type, a){
                    case $b119d7ba76d4c605$var$d:
                    case $b119d7ba76d4c605$var$f:
                    case $b119d7ba76d4c605$var$e:
                    case $b119d7ba76d4c605$var$m:
                    case $b119d7ba76d4c605$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b119d7ba76d4c605$var$k:
                            case $b119d7ba76d4c605$var$h:
                            case $b119d7ba76d4c605$var$l:
                            case $b119d7ba76d4c605$var$q:
                            case $b119d7ba76d4c605$var$p:
                            case $b119d7ba76d4c605$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $b119d7ba76d4c605$var$c:
                return r;
        }
    }
}
$b119d7ba76d4c605$export$a7c73072b1a182ae = $b119d7ba76d4c605$var$h;
$b119d7ba76d4c605$export$9f27bc3417b4524d = $b119d7ba76d4c605$var$g;
$b119d7ba76d4c605$export$db77ccec0bb4ccac = $b119d7ba76d4c605$var$b;
$b119d7ba76d4c605$export$8392c0c9d3dcbd35 = $b119d7ba76d4c605$var$l;
$b119d7ba76d4c605$export$ffb0004e005737fa = $b119d7ba76d4c605$var$d;
$b119d7ba76d4c605$export$b624eff549462981 = $b119d7ba76d4c605$var$q;
$b119d7ba76d4c605$export$7897aa7841a5380c = $b119d7ba76d4c605$var$p;
$b119d7ba76d4c605$export$602eac185826482c = $b119d7ba76d4c605$var$c;
$b119d7ba76d4c605$export$e2c29f18771995cb = $b119d7ba76d4c605$var$f;
$b119d7ba76d4c605$export$5f8d39834fd61797 = $b119d7ba76d4c605$var$e;
$b119d7ba76d4c605$export$74bf444e3cd11ea5 = $b119d7ba76d4c605$var$m;
$b119d7ba76d4c605$export$998bcd577473dd93 = $b119d7ba76d4c605$var$n;
$b119d7ba76d4c605$export$92387174baf9b227 = function() {
    return !1;
};
$b119d7ba76d4c605$export$ec112efeb987d9c6 = function() {
    return !1;
};
$b119d7ba76d4c605$export$b706b080d889d2c9 = function(a) {
    return $b119d7ba76d4c605$var$v(a) === $b119d7ba76d4c605$var$h;
};
$b119d7ba76d4c605$export$5be5a87408f70ddc = function(a) {
    return $b119d7ba76d4c605$var$v(a) === $b119d7ba76d4c605$var$g;
};
$b119d7ba76d4c605$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b119d7ba76d4c605$var$b;
};
$b119d7ba76d4c605$export$455c2e768291efa6 = function(a) {
    return $b119d7ba76d4c605$var$v(a) === $b119d7ba76d4c605$var$l;
};
$b119d7ba76d4c605$export$9522e17588c12572 = function(a) {
    return $b119d7ba76d4c605$var$v(a) === $b119d7ba76d4c605$var$d;
};
$b119d7ba76d4c605$export$2110ac352bb060b9 = function(a) {
    return $b119d7ba76d4c605$var$v(a) === $b119d7ba76d4c605$var$q;
};
$b119d7ba76d4c605$export$56885ab8b9c456ab = function(a) {
    return $b119d7ba76d4c605$var$v(a) === $b119d7ba76d4c605$var$p;
};
$b119d7ba76d4c605$export$d927fcb6adf8f9de = function(a) {
    return $b119d7ba76d4c605$var$v(a) === $b119d7ba76d4c605$var$c;
};
$b119d7ba76d4c605$export$b82d16f27459e05a = function(a) {
    return $b119d7ba76d4c605$var$v(a) === $b119d7ba76d4c605$var$f;
};
$b119d7ba76d4c605$export$522c17b4f5e123e8 = function(a) {
    return $b119d7ba76d4c605$var$v(a) === $b119d7ba76d4c605$var$e;
};
$b119d7ba76d4c605$export$1aabd8a0274ecfd6 = function(a) {
    return $b119d7ba76d4c605$var$v(a) === $b119d7ba76d4c605$var$m;
};
$b119d7ba76d4c605$export$3d6c20d97e46b957 = function(a) {
    return $b119d7ba76d4c605$var$v(a) === $b119d7ba76d4c605$var$n;
};
$b119d7ba76d4c605$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b119d7ba76d4c605$var$d || a === $b119d7ba76d4c605$var$f || a === $b119d7ba76d4c605$var$e || a === $b119d7ba76d4c605$var$m || a === $b119d7ba76d4c605$var$n || a === $b119d7ba76d4c605$var$t || "object" === typeof a && null !== a && (a.$$typeof === $b119d7ba76d4c605$var$q || a.$$typeof === $b119d7ba76d4c605$var$p || a.$$typeof === $b119d7ba76d4c605$var$g || a.$$typeof === $b119d7ba76d4c605$var$h || a.$$typeof === $b119d7ba76d4c605$var$l || a.$$typeof === $b119d7ba76d4c605$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$b119d7ba76d4c605$export$f5bbd400c2f4426f = $b119d7ba76d4c605$var$v;

});


parcelRegister("jdKss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfe344d056efd9e5$export$2e2bcd8739ae039; });

var $hCIyK = parcelRequire("hCIyK");
parcelRequire("5xsCg");
const $dfe344d056efd9e5$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $dfe344d056efd9e5$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $dfe344d056efd9e5$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $hCIyK.default)(_ref, $dfe344d056efd9e5$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $dfe344d056efd9e5$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("5xsCg", function(module, exports) {

var $38g8Y = parcelRequire("38g8Y");
function $40863b681fb8abc8$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $38g8Y.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $40863b681fb8abc8$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $40863b681fb8abc8$var$verify(mapStateToProps, 'mapStateToProps');
    $40863b681fb8abc8$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $40863b681fb8abc8$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("38g8Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $247ea447f80a69a7$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $247ea447f80a69a7$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("e7Iu5", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $a48439c47c716dfe$export$b69a785ceac019a6; });

var $f9VJQ = parcelRequire("f9VJQ");

var $a0cUR = parcelRequire("a0cUR");

var $jdCcV = parcelRequire("jdCcV");
function $a48439c47c716dfe$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $a0cUR.wrapMapToPropsConstant)((dispatch)=>(0, $f9VJQ.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $a0cUR.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $a0cUR.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $jdCcV.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("f9VJQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0947be80994ca72$export$2e2bcd8739ae039; });
function $b0947be80994ca72$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("a0cUR", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $7483ec5b6e4fa933$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $7483ec5b6e4fa933$export$8d46c7f53c8c602f; });
parcelRequire("lSvT7");
function $7483ec5b6e4fa933$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $7483ec5b6e4fa933$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $7483ec5b6e4fa933$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $7483ec5b6e4fa933$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $7483ec5b6e4fa933$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("lSvT7", function(module, exports) {

var $2avM5 = parcelRequire("2avM5");

var $38g8Y = parcelRequire("38g8Y");
function $fed76069b28adc29$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $2avM5.default)(value)) (0, $38g8Y.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("2avM5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $194529bb606f8ebb$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $194529bb606f8ebb$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("jdCcV", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", function () { return $dfdcde683956b223$export$19ef7b929f7e2559; });
function $dfdcde683956b223$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("2QBZs", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $212de82656571c82$export$e00e93951827eda7; });

var $a0cUR = parcelRequire("a0cUR");

var $jdCcV = parcelRequire("jdCcV");
function $212de82656571c82$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $a0cUR.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $a0cUR.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $jdCcV.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("4rjJ7", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", function () { return $33b8fc5dd5e6dc08$export$17457cf6fa742f84; });

var $4WYaH = parcelRequire("4WYaH");
parcelRequire("lSvT7");

var $jdCcV = parcelRequire("jdCcV");
function $33b8fc5dd5e6dc08$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $4WYaH.default)({}, ownProps, stateProps, dispatchProps);
}
function $33b8fc5dd5e6dc08$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $33b8fc5dd5e6dc08$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$33b8fc5dd5e6dc08$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $33b8fc5dd5e6dc08$export$5b105939c84b5234(mergeProps) : (0, $jdCcV.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("831kJ", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $5dbfa351521e3ff8$export$d567d2b9af322f8f; });

var $eZbJQ = parcelRequire("eZbJQ");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $5dbfa351521e3ff8$var$createListenerCollection() {
    const batch = (0, $eZbJQ.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $5dbfa351521e3ff8$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $5dbfa351521e3ff8$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $5dbfa351521e3ff8$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $5dbfa351521e3ff8$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $5dbfa351521e3ff8$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("8Hls7", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $6552fae9dc190050$export$700979bc83e7db82; });

var $bh6RR = parcelRequire("bh6RR");
const $6552fae9dc190050$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $6552fae9dc190050$export$700979bc83e7db82 = $6552fae9dc190050$export$71594e8a50f746f4 ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;

});

parcelRegister("5jjlV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dddbd200375677a$export$2e2bcd8739ae039; });
function $3dddbd200375677a$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $3dddbd200375677a$export$2e2bcd8739ae039(objA, objB) {
    if ($3dddbd200375677a$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$3dddbd200375677a$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("Tllxm", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("7KgLo")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("cPVO8")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("i2TPN")).useSelector; });
$parcel$export(module.exports, "useStore", function () { return (parcelRequire("jfISs")).useStore; });

var $7KgLo = parcelRequire("7KgLo");

var $bMTs6 = parcelRequire("bMTs6");

var $5G6M3 = parcelRequire("5G6M3");

var $cPVO8 = parcelRequire("cPVO8");

var $i2TPN = parcelRequire("i2TPN");

var $jfISs = parcelRequire("jfISs");

var $5jjlV = parcelRequire("5jjlV");
parcelRequire("7tcZy");

});
parcelRegister("7KgLo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a39d52b42a17e44$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $5G6M3 = parcelRequire("5G6M3");

var $831kJ = parcelRequire("831kJ");

var $8Hls7 = parcelRequire("8Hls7");
function $5a39d52b42a17e44$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $bh6RR.useMemo(()=>{
        const subscription = (0, $831kJ.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $bh6RR.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $8Hls7.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $5G6M3.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $bh6RR.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $5a39d52b42a17e44$export$2e2bcd8739ae039 = $5a39d52b42a17e44$var$Provider;

});

parcelRegister("cPVO8", function(module, exports) {

$parcel$export(module.exports, "useDispatch", function () { return $958716d738923964$export$8ad76b76a4c905f8; });

var $5G6M3 = parcelRequire("5G6M3");

var $jfISs = parcelRequire("jfISs");
function $958716d738923964$export$bc9b55530897c558(context = (0, $5G6M3.ReactReduxContext)) {
    const useStore = context === (0, $5G6M3.ReactReduxContext) ? (0, $jfISs.useStore) : (0, $jfISs.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $958716d738923964$export$8ad76b76a4c905f8 = /*#__PURE__*/ $958716d738923964$export$bc9b55530897c558();

});
parcelRegister("jfISs", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $e0423ab7a910578e$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $e0423ab7a910578e$export$6ccbb43953eebf8; });

var $5G6M3 = parcelRequire("5G6M3");

var $cnH71 = parcelRequire("cnH71");
function $e0423ab7a910578e$export$671dba69185d0304(context = (0, $5G6M3.ReactReduxContext)) {
    const useReduxContext = context === (0, $5G6M3.ReactReduxContext) ? (0, $cnH71.useReduxContext) : (0, $cnH71.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $e0423ab7a910578e$export$6ccbb43953eebf8 = /*#__PURE__*/ $e0423ab7a910578e$export$671dba69185d0304();

});


parcelRegister("7tcZy", function(module, exports) {

});



parcelRegister("1rr1p", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $10cd4606b1558238$export$595d22ed68ca2841; });

var $EH0Jb = parcelRequire("EH0Jb");
function $10cd4606b1558238$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $10cd4606b1558238$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $10cd4606b1558238$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $10cd4606b1558238$export$595d22ed68ca2841 = /* #__PURE__ */ $10cd4606b1558238$export$5943f4447f6ef248((0, $EH0Jb.defaultMemoize));
var $10cd4606b1558238$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $10cd4606b1558238$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("EH0Jb", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", function () { return $07a51993ef90d3c6$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $07a51993ef90d3c6$var$NOT_FOUND = 'NOT_FOUND';
function $07a51993ef90d3c6$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $07a51993ef90d3c6$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $07a51993ef90d3c6$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $07a51993ef90d3c6$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $07a51993ef90d3c6$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $07a51993ef90d3c6$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $07a51993ef90d3c6$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $07a51993ef90d3c6$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $07a51993ef90d3c6$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $07a51993ef90d3c6$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $07a51993ef90d3c6$var$createSingletonCache(comparator) : $07a51993ef90d3c6$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $07a51993ef90d3c6$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("9YKpI", function(module, exports) {

$parcel$export(module.exports, "enablePatches", function () { return $4fe0feaa500ab97c$export$d3a6659991a0696c; });
$parcel$export(module.exports, "produceWithPatches", function () { return $4fe0feaa500ab97c$export$4da66d41c9492c78; });
// src/utils/env.ts
var $4fe0feaa500ab97c$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $4fe0feaa500ab97c$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $4fe0feaa500ab97c$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $4fe0feaa500ab97c$var$errors = [];
function $4fe0feaa500ab97c$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $4fe0feaa500ab97c$var$getPrototypeOf = Object.getPrototypeOf;
function $4fe0feaa500ab97c$export$541ac630993a4c84(value) {
    return !!value && !!value[$4fe0feaa500ab97c$var$DRAFT_STATE];
}
function $4fe0feaa500ab97c$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $4fe0feaa500ab97c$var$isPlainObject(value) || Array.isArray(value) || !!value[$4fe0feaa500ab97c$export$6ee2082928bcb0ee] || !!value.constructor?.[$4fe0feaa500ab97c$export$6ee2082928bcb0ee] || $4fe0feaa500ab97c$var$isMap(value) || $4fe0feaa500ab97c$var$isSet(value);
}
var $4fe0feaa500ab97c$var$objectCtorString = Object.prototype.constructor.toString();
function $4fe0feaa500ab97c$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $4fe0feaa500ab97c$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $4fe0feaa500ab97c$var$objectCtorString;
}
function $4fe0feaa500ab97c$export$22e8af3f75a010e3(value) {
    if (!$4fe0feaa500ab97c$export$541ac630993a4c84(value)) $4fe0feaa500ab97c$var$die(15, value);
    return value[$4fe0feaa500ab97c$var$DRAFT_STATE].base_;
}
function $4fe0feaa500ab97c$var$each(obj, iter) {
    if ($4fe0feaa500ab97c$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $4fe0feaa500ab97c$var$getArchtype(thing) {
    const state = thing[$4fe0feaa500ab97c$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $4fe0feaa500ab97c$var$isMap(thing) ? 2 /* Map */  : $4fe0feaa500ab97c$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $4fe0feaa500ab97c$var$has(thing, prop) {
    return $4fe0feaa500ab97c$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $4fe0feaa500ab97c$var$get(thing, prop) {
    return $4fe0feaa500ab97c$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $4fe0feaa500ab97c$var$set(thing, propOrOldValue, value) {
    const t = $4fe0feaa500ab97c$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $4fe0feaa500ab97c$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $4fe0feaa500ab97c$var$isMap(target) {
    return target instanceof Map;
}
function $4fe0feaa500ab97c$var$isSet(target) {
    return target instanceof Set;
}
function $4fe0feaa500ab97c$var$latest(state) {
    return state.copy_ || state.base_;
}
function $4fe0feaa500ab97c$var$shallowCopy(base, strict) {
    if ($4fe0feaa500ab97c$var$isMap(base)) return new Map(base);
    if ($4fe0feaa500ab97c$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $4fe0feaa500ab97c$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$4fe0feaa500ab97c$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($4fe0feaa500ab97c$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $4fe0feaa500ab97c$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $4fe0feaa500ab97c$export$792f3d81ea979f55(obj, deep = false) {
    if ($4fe0feaa500ab97c$var$isFrozen(obj) || $4fe0feaa500ab97c$export$541ac630993a4c84(obj) || !$4fe0feaa500ab97c$export$16e3aed3edb85946(obj)) return obj;
    if ($4fe0feaa500ab97c$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $4fe0feaa500ab97c$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$4fe0feaa500ab97c$export$792f3d81ea979f55(value, true));
    return obj;
}
function $4fe0feaa500ab97c$var$dontMutateFrozenCollections() {
    $4fe0feaa500ab97c$var$die(2);
}
function $4fe0feaa500ab97c$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $4fe0feaa500ab97c$var$plugins = {};
function $4fe0feaa500ab97c$var$getPlugin(pluginKey) {
    const plugin = $4fe0feaa500ab97c$var$plugins[pluginKey];
    if (!plugin) $4fe0feaa500ab97c$var$die(0, pluginKey);
    return plugin;
}
function $4fe0feaa500ab97c$var$loadPlugin(pluginKey, implementation) {
    if (!$4fe0feaa500ab97c$var$plugins[pluginKey]) $4fe0feaa500ab97c$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $4fe0feaa500ab97c$var$currentScope;
function $4fe0feaa500ab97c$var$getCurrentScope() {
    return $4fe0feaa500ab97c$var$currentScope;
}
function $4fe0feaa500ab97c$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $4fe0feaa500ab97c$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $4fe0feaa500ab97c$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $4fe0feaa500ab97c$var$revokeScope(scope) {
    $4fe0feaa500ab97c$var$leaveScope(scope);
    scope.drafts_.forEach($4fe0feaa500ab97c$var$revokeDraft);
    scope.drafts_ = null;
}
function $4fe0feaa500ab97c$var$leaveScope(scope) {
    if (scope === $4fe0feaa500ab97c$var$currentScope) $4fe0feaa500ab97c$var$currentScope = scope.parent_;
}
function $4fe0feaa500ab97c$var$enterScope(immer2) {
    return $4fe0feaa500ab97c$var$currentScope = $4fe0feaa500ab97c$var$createScope($4fe0feaa500ab97c$var$currentScope, immer2);
}
function $4fe0feaa500ab97c$var$revokeDraft(draft) {
    const state = draft[$4fe0feaa500ab97c$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $4fe0feaa500ab97c$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$4fe0feaa500ab97c$var$DRAFT_STATE].modified_) {
            $4fe0feaa500ab97c$var$revokeScope(scope);
            $4fe0feaa500ab97c$var$die(4);
        }
        if ($4fe0feaa500ab97c$export$16e3aed3edb85946(result)) {
            result = $4fe0feaa500ab97c$var$finalize(scope, result);
            if (!scope.parent_) $4fe0feaa500ab97c$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $4fe0feaa500ab97c$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$4fe0feaa500ab97c$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $4fe0feaa500ab97c$var$finalize(scope, baseDraft, []);
    $4fe0feaa500ab97c$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $4fe0feaa500ab97c$export$45b790e32b2810ee ? result : void 0;
}
function $4fe0feaa500ab97c$var$finalize(rootScope, value, path) {
    if ($4fe0feaa500ab97c$var$isFrozen(value)) return value;
    const state = value[$4fe0feaa500ab97c$var$DRAFT_STATE];
    if (!state) {
        $4fe0feaa500ab97c$var$each(value, (key, childValue)=>$4fe0feaa500ab97c$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $4fe0feaa500ab97c$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $4fe0feaa500ab97c$var$each(resultEach, (key, childValue)=>$4fe0feaa500ab97c$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $4fe0feaa500ab97c$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $4fe0feaa500ab97c$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $4fe0feaa500ab97c$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($4fe0feaa500ab97c$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$4fe0feaa500ab97c$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $4fe0feaa500ab97c$var$finalize(rootScope, childValue, path);
        $4fe0feaa500ab97c$var$set(targetObject, prop, res);
        if ($4fe0feaa500ab97c$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($4fe0feaa500ab97c$export$16e3aed3edb85946(childValue) && !$4fe0feaa500ab97c$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $4fe0feaa500ab97c$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $4fe0feaa500ab97c$var$maybeFreeze(rootScope, childValue);
    }
}
function $4fe0feaa500ab97c$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $4fe0feaa500ab97c$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $4fe0feaa500ab97c$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $4fe0feaa500ab97c$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $4fe0feaa500ab97c$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $4fe0feaa500ab97c$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $4fe0feaa500ab97c$var$objectTraps = {
    get (state, prop) {
        if (prop === $4fe0feaa500ab97c$var$DRAFT_STATE) return state;
        const source = $4fe0feaa500ab97c$var$latest(state);
        if (!$4fe0feaa500ab97c$var$has(source, prop)) return $4fe0feaa500ab97c$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$4fe0feaa500ab97c$export$16e3aed3edb85946(value)) return value;
        if (value === $4fe0feaa500ab97c$var$peek(state.base_, prop)) {
            $4fe0feaa500ab97c$var$prepareCopy(state);
            return state.copy_[prop] = $4fe0feaa500ab97c$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $4fe0feaa500ab97c$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($4fe0feaa500ab97c$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $4fe0feaa500ab97c$var$getDescriptorFromProto($4fe0feaa500ab97c$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $4fe0feaa500ab97c$var$peek($4fe0feaa500ab97c$var$latest(state), prop);
            const currentState = current2?.[$4fe0feaa500ab97c$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($4fe0feaa500ab97c$var$is(value, current2) && (value !== void 0 || $4fe0feaa500ab97c$var$has(state.base_, prop))) return true;
            $4fe0feaa500ab97c$var$prepareCopy(state);
            $4fe0feaa500ab97c$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($4fe0feaa500ab97c$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $4fe0feaa500ab97c$var$prepareCopy(state);
            $4fe0feaa500ab97c$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $4fe0feaa500ab97c$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $4fe0feaa500ab97c$var$die(11);
    },
    getPrototypeOf (state) {
        return $4fe0feaa500ab97c$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $4fe0feaa500ab97c$var$die(12);
    }
};
var $4fe0feaa500ab97c$var$arrayTraps = {};
$4fe0feaa500ab97c$var$each($4fe0feaa500ab97c$var$objectTraps, (key, fn)=>{
    $4fe0feaa500ab97c$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$4fe0feaa500ab97c$var$arrayTraps.deleteProperty = function(state, prop) {
    return $4fe0feaa500ab97c$var$arrayTraps.set.call(this, state, prop, void 0);
};
$4fe0feaa500ab97c$var$arrayTraps.set = function(state, prop, value) {
    return $4fe0feaa500ab97c$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $4fe0feaa500ab97c$var$peek(draft, prop) {
    const state = draft[$4fe0feaa500ab97c$var$DRAFT_STATE];
    const source = state ? $4fe0feaa500ab97c$var$latest(state) : draft;
    return source[prop];
}
function $4fe0feaa500ab97c$var$readPropFromProto(state, source, prop) {
    const desc = $4fe0feaa500ab97c$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $4fe0feaa500ab97c$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $4fe0feaa500ab97c$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $4fe0feaa500ab97c$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $4fe0feaa500ab97c$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $4fe0feaa500ab97c$var$markChanged(state.parent_);
    }
}
function $4fe0feaa500ab97c$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $4fe0feaa500ab97c$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $4fe0feaa500ab97c$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $4fe0feaa500ab97c$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $4fe0feaa500ab97c$var$die(7);
            let result;
            if ($4fe0feaa500ab97c$export$16e3aed3edb85946(base)) {
                const scope = $4fe0feaa500ab97c$var$enterScope(this);
                const proxy = $4fe0feaa500ab97c$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $4fe0feaa500ab97c$var$revokeScope(scope);
                    else $4fe0feaa500ab97c$var$leaveScope(scope);
                }
                $4fe0feaa500ab97c$var$usePatchesInScope(scope, patchListener);
                return $4fe0feaa500ab97c$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $4fe0feaa500ab97c$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $4fe0feaa500ab97c$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $4fe0feaa500ab97c$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $4fe0feaa500ab97c$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof config?.autoFreeze === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof config?.useStrictShallowCopy === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$4fe0feaa500ab97c$export$16e3aed3edb85946(base)) $4fe0feaa500ab97c$var$die(8);
        if ($4fe0feaa500ab97c$export$541ac630993a4c84(base)) base = $4fe0feaa500ab97c$export$97aac956da55dae9(base);
        const scope = $4fe0feaa500ab97c$var$enterScope(this);
        const proxy = $4fe0feaa500ab97c$var$createProxy(base, void 0);
        proxy[$4fe0feaa500ab97c$var$DRAFT_STATE].isManual_ = true;
        $4fe0feaa500ab97c$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$4fe0feaa500ab97c$var$DRAFT_STATE];
        if (!state || !state.isManual_) $4fe0feaa500ab97c$var$die(9);
        const { scope_: scope } = state;
        $4fe0feaa500ab97c$var$usePatchesInScope(scope, patchListener);
        return $4fe0feaa500ab97c$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $4fe0feaa500ab97c$var$getPlugin("Patches").applyPatches_;
        if ($4fe0feaa500ab97c$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $4fe0feaa500ab97c$var$createProxy(value, parent) {
    const draft = $4fe0feaa500ab97c$var$isMap(value) ? $4fe0feaa500ab97c$var$getPlugin("MapSet").proxyMap_(value, parent) : $4fe0feaa500ab97c$var$isSet(value) ? $4fe0feaa500ab97c$var$getPlugin("MapSet").proxySet_(value, parent) : $4fe0feaa500ab97c$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $4fe0feaa500ab97c$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $4fe0feaa500ab97c$export$97aac956da55dae9(value) {
    if (!$4fe0feaa500ab97c$export$541ac630993a4c84(value)) $4fe0feaa500ab97c$var$die(10, value);
    return $4fe0feaa500ab97c$var$currentImpl(value);
}
function $4fe0feaa500ab97c$var$currentImpl(value) {
    if (!$4fe0feaa500ab97c$export$16e3aed3edb85946(value) || $4fe0feaa500ab97c$var$isFrozen(value)) return value;
    const state = value[$4fe0feaa500ab97c$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $4fe0feaa500ab97c$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $4fe0feaa500ab97c$var$shallowCopy(value, true);
    $4fe0feaa500ab97c$var$each(copy, (key, childValue)=>{
        $4fe0feaa500ab97c$var$set(copy, key, $4fe0feaa500ab97c$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $4fe0feaa500ab97c$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $4fe0feaa500ab97c$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $4fe0feaa500ab97c$var$get(base_, key);
            const value = $4fe0feaa500ab97c$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $4fe0feaa500ab97c$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $4fe0feaa500ab97c$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $4fe0feaa500ab97c$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $4fe0feaa500ab97c$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $4fe0feaa500ab97c$var$die(errorOffset + 3);
                base = $4fe0feaa500ab97c$var$get(base, p);
                if (typeof base !== "object") $4fe0feaa500ab97c$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $4fe0feaa500ab97c$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $4fe0feaa500ab97c$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $4fe0feaa500ab97c$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$4fe0feaa500ab97c$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($4fe0feaa500ab97c$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($4fe0feaa500ab97c$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($4fe0feaa500ab97c$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($4fe0feaa500ab97c$var$has(obj, $4fe0feaa500ab97c$export$6ee2082928bcb0ee)) cloned[$4fe0feaa500ab97c$export$6ee2082928bcb0ee] = obj[$4fe0feaa500ab97c$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($4fe0feaa500ab97c$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $4fe0feaa500ab97c$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $4fe0feaa500ab97c$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$4fe0feaa500ab97c$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $4fe0feaa500ab97c$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $4fe0feaa500ab97c$var$latest(this[$4fe0feaa500ab97c$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $4fe0feaa500ab97c$var$latest(this[$4fe0feaa500ab97c$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$4fe0feaa500ab97c$var$latest(state).has(key) || $4fe0feaa500ab97c$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $4fe0feaa500ab97c$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $4fe0feaa500ab97c$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($4fe0feaa500ab97c$var$latest(state).size) {
                prepareMapCopy(state);
                $4fe0feaa500ab97c$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $4fe0feaa500ab97c$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            $4fe0feaa500ab97c$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $4fe0feaa500ab97c$var$latest(state).get(key);
            if (state.finalized_ || !$4fe0feaa500ab97c$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $4fe0feaa500ab97c$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $4fe0feaa500ab97c$var$latest(this[$4fe0feaa500ab97c$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($4fe0feaa500ab97c$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$4fe0feaa500ab97c$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $4fe0feaa500ab97c$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $4fe0feaa500ab97c$var$latest(this[$4fe0feaa500ab97c$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $4fe0feaa500ab97c$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $4fe0feaa500ab97c$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($4fe0feaa500ab97c$var$latest(state).size) {
                prepareSetCopy(state);
                $4fe0feaa500ab97c$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$4fe0feaa500ab97c$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($4fe0feaa500ab97c$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($4fe0feaa500ab97c$export$16e3aed3edb85946(value)) {
                    const draft = $4fe0feaa500ab97c$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $4fe0feaa500ab97c$var$die(3, JSON.stringify($4fe0feaa500ab97c$var$latest(state)));
    }
    $4fe0feaa500ab97c$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $4fe0feaa500ab97c$var$immer = new $4fe0feaa500ab97c$export$aaadc6ff0f822719();
var $4fe0feaa500ab97c$export$b46cabe22e78bc00 = $4fe0feaa500ab97c$var$immer.produce;
var $4fe0feaa500ab97c$export$4da66d41c9492c78 = $4fe0feaa500ab97c$var$immer.produceWithPatches.bind($4fe0feaa500ab97c$var$immer);
var $4fe0feaa500ab97c$export$573f26f60825c493 = $4fe0feaa500ab97c$var$immer.setAutoFreeze.bind($4fe0feaa500ab97c$var$immer);
var $4fe0feaa500ab97c$export$333ce65961cbe047 = $4fe0feaa500ab97c$var$immer.setUseStrictShallowCopy.bind($4fe0feaa500ab97c$var$immer);
var $4fe0feaa500ab97c$export$a8b8e03e6bbe5473 = $4fe0feaa500ab97c$var$immer.applyPatches.bind($4fe0feaa500ab97c$var$immer);
var $4fe0feaa500ab97c$export$3c3214997190395f = $4fe0feaa500ab97c$var$immer.createDraft.bind($4fe0feaa500ab97c$var$immer);
var $4fe0feaa500ab97c$export$c60f5e69c521b528 = $4fe0feaa500ab97c$var$immer.finishDraft.bind($4fe0feaa500ab97c$var$immer);
function $4fe0feaa500ab97c$export$c05b21e3257751e5(value) {
    return value;
}
function $4fe0feaa500ab97c$export$20f911b3f8cf0b74(value) {
    return value;
}

});


parcelRegister("zQfHN", function(module, exports) {
$parcel$export(module.exports, "select", function () { return (parcelRequire("eAyML")).select; });
$parcel$export(module.exports, "updateStore", function () { return (parcelRequire("eAyML")).updateStore; });
$parcel$export(module.exports, "createStore", function () { return (parcelRequire("kfNOd")).createStore; });
$parcel$export(module.exports, "slice", function () { return (parcelRequire("llQUJ")).slice; });
$parcel$export(module.exports, "createSchema", function () { return (parcelRequire("60ukP")).createSchema; });
$parcel$export(module.exports, "createLocalStorageAdapter", function () { return (parcelRequire("1lCWl")).createLocalStorageAdapter; });
$parcel$export(module.exports, "createPersistor", function () { return (parcelRequire("1lCWl")).createPersistor; });
$parcel$export(module.exports, "PERSIST_LOADER_ID", function () { return (parcelRequire("1lCWl")).PERSIST_LOADER_ID; });
$parcel$export(module.exports, "persistStoreMdw", function () { return (parcelRequire("1lCWl")).persistStoreMdw; });

$parcel$export(module.exports, "createSelector", function () { return (parcelRequire("1rr1p")).createSelector; });
parcelRequire("dRfRF");
parcelRequire("eAyML");
parcelRequire("kfNOd");
parcelRequire("64QgT");
parcelRequire("c3MnJ");
var $1rr1p = parcelRequire("1rr1p");
parcelRequire("llQUJ");
parcelRequire("60ukP");
parcelRequire("iatmP");
parcelRequire("1lCWl");

});
parcelRegister("dRfRF", function(module, exports) {

$parcel$export(module.exports, "StoreUpdateContext", function () { return $a16c87f4728a1caa$export$cb74d7de2955c74e; });
$parcel$export(module.exports, "StoreContext", function () { return $a16c87f4728a1caa$export$554ccc96b126a426; });
parcelRequire("c3MnJ");
var $7NKgG = parcelRequire("7NKgG");
var $lPibo = parcelRequire("lPibo");
const $a16c87f4728a1caa$export$cb74d7de2955c74e = (0, $lPibo.createContext)("starfx:store:update", (0, $7NKgG.createChannel)());
const $a16c87f4728a1caa$export$554ccc96b126a426 = (0, $lPibo.createContext)("starfx:store");

});

parcelRegister("eAyML", function(module, exports) {

$parcel$export(module.exports, "updateStore", function () { return $a9ef6923cb3a8bb7$export$168a0875d66dd4b7; });
$parcel$export(module.exports, "select", function () { return $a9ef6923cb3a8bb7$export$2e6c959c16ff56b8; });

var $dRfRF = parcelRequire("dRfRF");
parcelRequire("edM9Q");
var $bXLEQ = parcelRequire("bXLEQ");
var $3Z7bJ = parcelRequire("3Z7bJ");

var $krVVU = parcelRequire("krVVU");
function* $a9ef6923cb3a8bb7$export$168a0875d66dd4b7(updater) {
    const store = yield* (0, $dRfRF.StoreContext);
    // had to cast the store since StoreContext has a generic store type
    const st = store;
    const ctx = yield* st.update(updater);
    return ctx;
}
function* $a9ef6923cb3a8bb7$export$2e6c959c16ff56b8(selectorFn, p) {
    const store = yield* (0, $dRfRF.StoreContext);
    return selectorFn(store.getState(), p);
}
function* $a9ef6923cb3a8bb7$export$726ad895f805666b(loaders, action) {
    const id = (0, $krVVU.getIdFromAction)(action);
    const selector = (s)=>loaders.selectById(s, {
            id: id
        });
    // check for done state on init
    let loader = yield* $a9ef6923cb3a8bb7$export$2e6c959c16ff56b8(selector);
    if (loader.isSuccess || loader.isError) return loader;
    while(true){
        yield* (0, $krVVU.take)("*");
        loader = yield* $a9ef6923cb3a8bb7$export$2e6c959c16ff56b8(selector);
        if (loader.isSuccess || loader.isError) return loader;
    }
}
function* $a9ef6923cb3a8bb7$export$d79c9cdb0ec11aff(loaders, actions) {
    const group = yield* (0, $bXLEQ.parallel)(actions.map((action)=>$a9ef6923cb3a8bb7$export$726ad895f805666b(loaders, action)));
    return yield* group;
}
function $a9ef6923cb3a8bb7$export$74dcb84a2bfca58f(loader) {
    return (id)=>{
        return function*(op) {
            yield* $a9ef6923cb3a8bb7$export$168a0875d66dd4b7(loader.start({
                id: id
            }));
            const result = yield* (0, $3Z7bJ.safe)(op);
            if (result.ok) yield* $a9ef6923cb3a8bb7$export$168a0875d66dd4b7(loader.success({
                id: id
            }));
            else yield* $a9ef6923cb3a8bb7$export$168a0875d66dd4b7(loader.error({
                id: id,
                message: result.error.message
            }));
            return result;
        };
    };
}

});
parcelRegister("edM9Q", function(module, exports) {
$parcel$export(module.exports, "parallel", function () { return (parcelRequire("bXLEQ")).parallel; });
$parcel$export(module.exports, "safe", function () { return (parcelRequire("3Z7bJ")).safe; });
$parcel$export(module.exports, "keepAlive", function () { return (parcelRequire("11819")).keepAlive; });
$parcel$export(module.exports, "supervise", function () { return (parcelRequire("11819")).supervise; });
parcelRequire("bXLEQ");
parcelRequire("3Z7bJ");
parcelRequire("96z8T");
parcelRequire("2tkE8");
parcelRequire("11819");

});
parcelRegister("bXLEQ", function(module, exports) {

$parcel$export(module.exports, "parallel", function () { return $8b5a2c41842819db$export$451942af9381149c; });
parcelRequire("c3MnJ");
var $7NKgG = parcelRequire("7NKgG");
var $6wugg = parcelRequire("6wugg");

var $3Z7bJ = parcelRequire("3Z7bJ");
function $8b5a2c41842819db$export$451942af9381149c(operations) {
    const sequence = (0, $7NKgG.createChannel)();
    const immediate = (0, $7NKgG.createChannel)();
    const results = [];
    return (0, $6wugg.resource)(function*(provide) {
        const task = yield* (0, $6wugg.spawn)(function*() {
            const tasks = [];
            for (const op of operations)tasks.push((yield* (0, $6wugg.spawn)(function*() {
                const result = yield* (0, $3Z7bJ.safe)(op);
                yield* immediate.send(result);
                return result;
            })));
            for (const tsk of tasks){
                const res = yield* tsk;
                results.push(res);
                yield* sequence.send(res);
            }
            yield* sequence.close();
            yield* immediate.close();
        });
        function* wait() {
            yield* task;
            return results;
        }
        yield* provide({
            sequence: sequence,
            immediate: immediate,
            *[Symbol.iterator] () {
                return yield* wait();
            }
        });
    });
}

});
parcelRegister("3Z7bJ", function(module, exports) {

$parcel$export(module.exports, "safe", function () { return $2e6ca502d73cc344$export$170b8c323eee7bec; });
parcelRequire("c3MnJ");
var $15Qbp = parcelRequire("15Qbp");
var $2EoHU = parcelRequire("2EoHU");
function* $2e6ca502d73cc344$export$170b8c323eee7bec(operator) {
    try {
        const value = yield* (0, $15Qbp.call)(operator);
        return (0, $2EoHU.Ok)(value);
    } catch (error) {
        return (0, $2EoHU.Err)(error);
    }
}

});


parcelRegister("96z8T", function(module, exports) {
parcelRequire("c3MnJ");
var $6wugg = parcelRequire("6wugg");
var $15Qbp = parcelRequire("15Qbp");
function $6a0fef24b8037a47$export$6f596c448600bda8(opMap) {
    return (0, $6wugg.resource)(function* Race(provide) {
        const keys = Object.keys(opMap);
        const taskMap = {};
        const resultMap = {};
        const winner = yield* (0, $6wugg.action)(function*(resolve) {
            for(let i = 0; i < keys.length; i += 1){
                const key = keys[i];
                yield* (0, $6wugg.spawn)(function*() {
                    const task = yield* (0, $6wugg.spawn)(function*() {
                        yield* (0, $15Qbp.call)(opMap[key]);
                    });
                    taskMap[key] = task;
                    resultMap[key] = yield* task;
                    resolve(task);
                });
            }
        });
        for(let i = 0; i < keys.length; i += 1){
            const key = keys[i];
            const task = taskMap[key];
            if (task === winner) continue;
            yield* (0, $6wugg.spawn)(()=>task.halt());
        }
        yield* provide(resultMap);
    });
}

});

parcelRegister("2tkE8", function(module, exports) {
parcelRequire("c3MnJ");
var $15Qbp = parcelRequire("15Qbp");
var $fnVfN = parcelRequire("fnVfN");
function* $1cce4e248f604056$export$b5fe3f66a567bec0(url, opts) {
    const signal = yield* (0, $fnVfN.useAbortSignal)();
    const response = yield* (0, $15Qbp.call)(fetch(url, {
        signal: signal,
        ...opts
    }));
    return response;
}
function* $1cce4e248f604056$export$7b419323e6ed4f31(response) {
    const result = yield* (0, $15Qbp.call)(response.json());
    return result;
}

});

parcelRegister("11819", function(module, exports) {

$parcel$export(module.exports, "supervise", function () { return $0bdc1a926f7abc39$export$54b8dc42dcff4ab1; });
$parcel$export(module.exports, "keepAlive", function () { return $0bdc1a926f7abc39$export$a1c7a439f47575e5; });
parcelRequire("c3MnJ");
var $4PPHq = parcelRequire("4PPHq");

var $3Z7bJ = parcelRequire("3Z7bJ");

var $bXLEQ = parcelRequire("bXLEQ");

var $krVVU = parcelRequire("krVVU");
function $0bdc1a926f7abc39$export$c6a89c826df6a93(attempt, max = 10) {
    if (attempt > max) return -1;
    // 20ms, 40ms, 80ms, 160ms, 320ms, 640ms, 1280ms, 2560ms, 5120ms, 10240ms
    return 2 ** attempt * 10;
}
function $0bdc1a926f7abc39$export$54b8dc42dcff4ab1(op, backoff = $0bdc1a926f7abc39$export$c6a89c826df6a93) {
    return function*() {
        let attempt = 1;
        let waitFor = backoff(attempt);
        while(waitFor >= 0){
            const res = yield* (0, $3Z7bJ.safe)(op);
            if (res.ok) attempt = 0;
            else {
                yield* (0, $krVVU.put)({
                    type: `${(0, $krVVU.API_ACTION_PREFIX)}supervise`,
                    payload: res.error,
                    meta: `Exception caught, waiting ${waitFor}ms before restarting operation`
                });
                yield* (0, $4PPHq.sleep)(waitFor);
            }
            attempt += 1;
            waitFor = backoff(attempt);
        }
    };
}
function* $0bdc1a926f7abc39$export$a1c7a439f47575e5(ops, backoff) {
    const group = yield* (0, $bXLEQ.parallel)(ops.map((op)=>$0bdc1a926f7abc39$export$54b8dc42dcff4ab1(op, backoff)));
    const results = yield* group;
    return results;
}

});
parcelRegister("krVVU", function(module, exports) {

$parcel$export(module.exports, "ActionContext", function () { return $ee33449314334f09$export$e04e17a44f37debc; });
$parcel$export(module.exports, "emit", function () { return $ee33449314334f09$export$8f35fbd5db0f3634; });
$parcel$export(module.exports, "put", function () { return $ee33449314334f09$export$327f7b26ebf455db; });
$parcel$export(module.exports, "take", function () { return $ee33449314334f09$export$b7df5d561049483a; });
$parcel$export(module.exports, "takeEvery", function () { return $ee33449314334f09$export$4e24be1e1c9d5c69; });
$parcel$export(module.exports, "getIdFromAction", function () { return $ee33449314334f09$export$a80507456c3d7015; });
$parcel$export(module.exports, "API_ACTION_PREFIX", function () { return $ee33449314334f09$export$1d9ab5b7176f68a1; });
$parcel$export(module.exports, "createAction", function () { return $ee33449314334f09$export$309c7a02b0b0bc62; });
parcelRequire("c3MnJ");
var $15Qbp = parcelRequire("15Qbp");
var $lPibo = parcelRequire("lPibo");
var $5bXcR = parcelRequire("5bXcR");
var $kGwWV = parcelRequire("kGwWV");
var $6wugg = parcelRequire("6wugg");

var $3rc5D = parcelRequire("3rc5D");

var $3jseN = parcelRequire("3jseN");
const $ee33449314334f09$export$e04e17a44f37debc = (0, $lPibo.createContext)("starfx:action", (0, $5bXcR.createSignal)());
function $ee33449314334f09$export$bc923229a7fa61e7(pattern) {
    return {
        *subscribe () {
            const actions = yield* $ee33449314334f09$export$e04e17a44f37debc;
            const match = (0, $3rc5D.matcher)(pattern);
            yield* (0, $5bXcR.SignalQueueFactory).set(()=>(0, $3jseN.createFilterQueue)(match));
            return yield* actions.subscribe();
        }
    };
}
function $ee33449314334f09$export$8f35fbd5db0f3634({ signal: signal, action: action }) {
    if (Array.isArray(action)) {
        if (action.length === 0) return;
        action.map((a)=>signal.send(a));
    } else signal.send(action);
}
function* $ee33449314334f09$export$327f7b26ebf455db(action) {
    const signal = yield* $ee33449314334f09$export$e04e17a44f37debc;
    return $ee33449314334f09$export$8f35fbd5db0f3634({
        signal: signal,
        action: action
    });
}
function* $ee33449314334f09$export$b7df5d561049483a(pattern) {
    const fd = $ee33449314334f09$export$bc923229a7fa61e7(pattern);
    for (const action of yield* (0, $kGwWV.each)(fd))return action;
    return {
        type: "take failed, this should not be possible"
    };
}
function* $ee33449314334f09$export$4e24be1e1c9d5c69(pattern, op) {
    const fd = $ee33449314334f09$export$bc923229a7fa61e7(pattern);
    for (const action of yield* (0, $kGwWV.each)(fd)){
        yield* (0, $6wugg.spawn)(()=>op(action));
        yield* (0, $kGwWV.each).next();
    }
}
function* $ee33449314334f09$export$ca010cea618a298a(pattern, op) {
    const fd = $ee33449314334f09$export$bc923229a7fa61e7(pattern);
    let lastTask;
    for (const action of yield* (0, $kGwWV.each)(fd)){
        if (lastTask) yield* lastTask.halt();
        lastTask = yield* (0, $6wugg.spawn)(()=>op(action));
        yield* (0, $kGwWV.each).next();
    }
}
function* $ee33449314334f09$export$ab18f80dcccecca4(pattern, op) {
    while(true){
        const action = yield* $ee33449314334f09$export$b7df5d561049483a(pattern);
        yield* (0, $15Qbp.call)(()=>op(action));
    }
}
function* $ee33449314334f09$export$9bbfceb27f687c1b(predicate) {
    const init = yield* (0, $15Qbp.call)(predicate);
    if (init) return;
    while(true){
        yield* $ee33449314334f09$export$b7df5d561049483a("*");
        const result = yield* (0, $15Qbp.call)(()=>predicate);
        if (result) return;
    }
}
function $ee33449314334f09$export$a80507456c3d7015(action) {
    return typeof action === "function" ? action.toString() : action.payload.key;
}
const $ee33449314334f09$export$1d9ab5b7176f68a1 = "";
function $ee33449314334f09$export$309c7a02b0b0bc62(actionType) {
    if (!actionType) throw new Error("createAction requires non-empty string");
    const fn = (payload)=>({
            type: actionType,
            payload: payload
        });
    fn.toString = ()=>actionType;
    return fn;
}

});
parcelRegister("3rc5D", function(module, exports) {

$parcel$export(module.exports, "matcher", function () { return $280d458296694891$export$dd4ef95c8562f248; });
function $280d458296694891$export$dd4ef95c8562f248(pattern) {
    if (pattern === "*") return function(input) {
        return !!input;
    };
    if (typeof pattern === "string") return function(input) {
        return pattern === input.type;
    };
    if (Array.isArray(pattern)) return function(input) {
        return pattern.some((p)=>$280d458296694891$export$dd4ef95c8562f248(p)(input));
    };
    if (typeof pattern === "function" && Object.hasOwn(pattern, "toString")) return function(input) {
        return pattern.toString() === input.type;
    };
    if (typeof pattern === "function") return function(input) {
        return pattern(input);
    };
    throw new Error("invalid pattern");
}

});

parcelRegister("3jseN", function(module, exports) {

$parcel$export(module.exports, "createFilterQueue", function () { return $26990cde62236bf8$export$ce0e383e19adfb92; });
parcelRequire("c3MnJ");
var $dURZw = parcelRequire("dURZw");
function $26990cde62236bf8$export$ce0e383e19adfb92(predicate) {
    const queue = (0, $dURZw.createQueue)();
    return {
        ...queue,
        add (value) {
            if (predicate(value)) queue.add(value);
        }
    };
}

});





parcelRegister("kfNOd", function(module, exports) {

$parcel$export(module.exports, "IdContext", function () { return $ebebd866df416702$export$26537912ea160acd; });
$parcel$export(module.exports, "createStore", function () { return $ebebd866df416702$export$f51a9068ac82ea43; });

var $krVVU = parcelRequire("krVVU");

var $7ht0o = parcelRequire("7ht0o");
parcelRequire("c3MnJ");
var $lPibo = parcelRequire("lPibo");
var $kanWf = parcelRequire("kanWf");
var $5bXcR = parcelRequire("5bXcR");
var $9YKpI = parcelRequire("9YKpI");
var $2EoHU = parcelRequire("2EoHU");

var $dRfRF = parcelRequire("dRfRF");

var $c4i6D = parcelRequire("c4i6D");
const $ebebd866df416702$var$stubMsg = "This is merely a stub, not implemented";
let $ebebd866df416702$var$id = 0;
// https://github.com/reduxjs/redux/blob/4a6d2fb227ba119d3498a43fab8f53fe008be64c/src/createStore.ts#L344
function $ebebd866df416702$var$observable() {
    return {
        subscribe: (_observer)=>{
            throw new Error($ebebd866df416702$var$stubMsg);
        },
        [Symbol.observable] () {
            return this;
        }
    };
}
const $ebebd866df416702$export$26537912ea160acd = (0, $lPibo.createContext)("starfx:id", 0);
function $ebebd866df416702$export$f51a9068ac82ea43({ initialState: initialState, scope: initScope, middleware: middleware = [] }) {
    let scope;
    if (initScope) scope = initScope;
    else {
        const tuple = (0, $kanWf.createScope)();
        scope = tuple[0];
    }
    let state = initialState;
    const listeners = new Set();
    (0, $9YKpI.enablePatches)();
    const signal = (0, $5bXcR.createSignal)();
    scope.set((0, $krVVU.ActionContext), signal);
    scope.set($ebebd866df416702$export$26537912ea160acd, $ebebd866df416702$var$id++);
    function getScope() {
        return scope;
    }
    function getState() {
        return state;
    }
    function subscribe(fn) {
        listeners.add(fn);
        return ()=>listeners.delete(fn);
    }
    function* updateMdw(ctx, next) {
        const upds = [];
        if (Array.isArray(ctx.updater)) upds.push(...ctx.updater);
        else upds.push(ctx.updater);
        const [nextState, patches, _] = (0, $9YKpI.produceWithPatches)(getState(), (draft)=>{
            // TODO: check for return value inside updater
            // deno-lint-ignore no-explicit-any
            upds.forEach((updater)=>updater(draft));
        });
        ctx.patches = patches;
        // set the state!
        state = nextState;
        yield* next();
    }
    function* logMdw(ctx, next) {
        dispatch({
            type: `${(0, $krVVU.API_ACTION_PREFIX)}store`,
            payload: ctx
        });
        yield* next();
    }
    function* notifyChannelMdw(_, next) {
        const chan = yield* (0, $dRfRF.StoreUpdateContext);
        yield* chan.send();
        yield* next();
    }
    function* notifyListenersMdw(_, next) {
        listeners.forEach((f)=>f());
        yield* next();
    }
    function createUpdater() {
        const fn = (0, $7ht0o.compose)([
            updateMdw,
            ...middleware,
            logMdw,
            notifyChannelMdw,
            notifyListenersMdw
        ]);
        return fn;
    }
    const mdw = createUpdater();
    function* update(updater) {
        const ctx = {
            updater: updater,
            patches: [],
            result: (0, $2EoHU.Ok)(undefined)
        };
        yield* mdw(ctx);
        if (!ctx.result.ok) dispatch({
            type: `${(0, $krVVU.API_ACTION_PREFIX)}store`,
            payload: ctx.result.error
        });
        return ctx;
    }
    function dispatch(action) {
        (0, $krVVU.emit)({
            signal: signal,
            action: action
        });
    }
    function getInitialState() {
        return initialState;
    }
    function* reset(ignoreList = []) {
        return yield* update((s)=>{
            const keep = ignoreList.reduce((acc, key)=>{
                acc[key] = s[key];
                return acc;
            }, {
                ...initialState
            });
            Object.keys(s).forEach((key)=>{
                s[key] = keep[key];
            });
        });
    }
    const store = {
        getScope: getScope,
        getState: getState,
        subscribe: subscribe,
        update: update,
        reset: reset,
        run: (0, $c4i6D.createRun)(scope),
        dispatch: // instead of actions relating to store mutation, they
        // refer to pieces of business logic -- that can also mutate state
        dispatch,
        // stubs so `react-redux` is happy
        // deno-lint-ignore no-explicit-any
        replaceReducer (_nextReducer) {
            throw new Error($ebebd866df416702$var$stubMsg);
        },
        getInitialState: getInitialState,
        [Symbol.observable]: $ebebd866df416702$var$observable
    };
    // deno-lint-ignore no-explicit-any
    store.getScope().set((0, $dRfRF.StoreContext), store);
    return store;
}
const $ebebd866df416702$export$7d8a5b498da695ac = $ebebd866df416702$export$f51a9068ac82ea43;

});
parcelRegister("7ht0o", function(module, exports) {

$parcel$export(module.exports, "compose", function () { return $54d09ecd297a113f$export$f672e0b6f7222cd7; });
function $54d09ecd297a113f$export$f672e0b6f7222cd7(middleware) {
    if (!Array.isArray(middleware)) throw new TypeError("Middleware stack must be an array!");
    for (const fn of middleware){
        if (typeof fn !== "function") throw new TypeError("Middleware must be composed of functions!");
    }
    return function* composeFn(context, mdw) {
        // last called middleware #
        let index = -1;
        function* dispatch(i) {
            if (i <= index) throw new Error("next() called multiple times");
            index = i;
            let fn = middleware[i];
            if (i === middleware.length) fn = mdw;
            if (!fn) return;
            const nxt = dispatch.bind(null, i + 1);
            yield* fn(context, nxt);
        }
        yield* dispatch(0);
    };
}

});

parcelRegister("c4i6D", function(module, exports) {

$parcel$export(module.exports, "createRun", function () { return $8c93e74009248f12$export$b2f97e9fd8e074ef; });
parcelRequire("edM9Q");
var $bXLEQ = parcelRequire("bXLEQ");
var $3Z7bJ = parcelRequire("3Z7bJ");
function $8c93e74009248f12$export$b2f97e9fd8e074ef(scope) {
    function run(op) {
        if (Array.isArray(op)) return scope.run(function*() {
            const group = yield* (0, $bXLEQ.parallel)(op);
            const result = yield* group;
            return result;
        });
        return scope.run(()=>(0, $3Z7bJ.safe)(op));
    }
    return run;
}

});


parcelRegister("64QgT", function(module, exports) {

});

parcelRegister("llQUJ", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $f8b49abfb7cd9f87$export$58adb3bec8346d0f; });

var $i8gJF = parcelRequire("i8gJF");

var $11WYw = parcelRequire("11WYw");

var $kyfVo = parcelRequire("kyfVo");

var $ayc00 = parcelRequire("ayc00");

var $hXdgV = parcelRequire("hXdgV");

var $hWc7O = parcelRequire("hWc7O");
const $f8b49abfb7cd9f87$export$58adb3bec8346d0f = {
    str: $i8gJF.str,
    num: $11WYw.num,
    table: $kyfVo.table,
    any: $ayc00.any,
    obj: $hXdgV.obj,
    loaders: $hWc7O.loaders,
    /**
     * @deprecated Use `slice.loaders` instead
     */ loader: (0, $hWc7O.loaders)
};

});
parcelRegister("i8gJF", function(module, exports) {

$parcel$export(module.exports, "str", function () { return $d335f4b18ac06f40$export$42d51816ce590c93; });
function $d335f4b18ac06f40$export$2812b0928b741607({ name: name, initialState: initialState = "" }) {
    return {
        schema: "str",
        name: name,
        initialState: initialState,
        set: (value)=>(state)=>{
                // deno-lint-ignore no-explicit-any
                state[name] = value;
            },
        reset: ()=>(state)=>{
                // deno-lint-ignore no-explicit-any
                state[name] = initialState;
            },
        select: (state)=>{
            // deno-lint-ignore no-explicit-any
            return state[name];
        }
    };
}
function $d335f4b18ac06f40$export$42d51816ce590c93(initialState) {
    return (name)=>$d335f4b18ac06f40$export$2812b0928b741607({
            name: name,
            initialState: initialState
        });
}

});

parcelRegister("11WYw", function(module, exports) {

$parcel$export(module.exports, "num", function () { return $0c03a1acfab2a982$export$61cc6a0be4938a2a; });
function $0c03a1acfab2a982$export$95a1a587349fdfe0({ name: name, initialState: initialState = 0 }) {
    return {
        name: name,
        schema: "num",
        initialState: initialState,
        set: (value)=>(state)=>{
                // deno-lint-ignore no-explicit-any
                state[name] = value;
            },
        increment: (by = 1)=>(state)=>{
                // deno-lint-ignore no-explicit-any
                state[name] += by;
            },
        decrement: (by = 1)=>(state)=>{
                // deno-lint-ignore no-explicit-any
                state[name] -= by;
            },
        reset: ()=>(state)=>{
                // deno-lint-ignore no-explicit-any
                state[name] = initialState;
            },
        select: (state)=>{
            // deno-lint-ignore no-explicit-any
            return state[name];
        }
    };
}
function $0c03a1acfab2a982$export$61cc6a0be4938a2a(initialState) {
    return (name)=>$0c03a1acfab2a982$export$95a1a587349fdfe0({
            name: name,
            initialState: initialState
        });
}

});

parcelRegister("kyfVo", function(module, exports) {

$parcel$export(module.exports, "table", function () { return $ef6355f12eb9b13b$export$9852986a3ec5f6a0; });
parcelRequire("c3MnJ");
var $1rr1p = parcelRequire("1rr1p");
const $ef6355f12eb9b13b$var$excludesFalse = (n)=>Boolean(n);
function $ef6355f12eb9b13b$var$mustSelectEntity(defaultEntity) {
    const isFn = typeof defaultEntity === "function";
    return function selectEntity(selectById) {
        return (state, { id: id })=>{
            if (isFn) {
                const entity = defaultEntity;
                return selectById(state, {
                    id: id
                }) || entity();
            }
            return selectById(state, {
                id: id
            }) || defaultEntity;
        };
    };
}
function $ef6355f12eb9b13b$var$tableSelectors(selectTable, empty) {
    const must = empty ? $ef6355f12eb9b13b$var$mustSelectEntity(empty) : null;
    const tableAsList = (data)=>Object.values(data).filter($ef6355f12eb9b13b$var$excludesFalse);
    const findById = (data, { id: id })=>data[id];
    const findByIds = (data, { ids: ids })=>ids.map((id)=>data[id]).filter($ef6355f12eb9b13b$var$excludesFalse);
    const selectById = (state, { id: id })=>{
        const data = selectTable(state);
        return findById(data, {
            id: id
        });
    };
    const sbi = must ? must(selectById) : selectById;
    return {
        findById: must ? must(findById) : findById,
        findByIds: findByIds,
        tableAsList: tableAsList,
        selectTable: selectTable,
        selectTableAsList: (0, $1rr1p.createSelector)(selectTable, (data)=>tableAsList(data)),
        selectById: sbi,
        selectByIds: (0, $1rr1p.createSelector)(selectTable, (_, p)=>p.ids, (data, ids)=>findByIds(data, {
                ids: ids
            }))
    };
}
function $ef6355f12eb9b13b$export$33bbb3ec7652e187({ name: name, empty: empty, initialState: initialState = {} }) {
    const selectors = $ef6355f12eb9b13b$var$tableSelectors((s)=>s[name], empty);
    return {
        schema: "table",
        name: name,
        initialState: initialState,
        empty: typeof empty === "function" ? empty() : empty,
        add: (entities)=>(s)=>{
                const state = selectors.selectTable(s);
                Object.keys(entities).forEach((id)=>{
                    state[id] = entities[id];
                });
            },
        set: (entities)=>(s)=>{
                // deno-lint-ignore no-explicit-any
                s[name] = entities;
            },
        remove: (ids)=>(s)=>{
                const state = selectors.selectTable(s);
                ids.forEach((id)=>{
                    delete state[id];
                });
            },
        patch: (entities)=>(s)=>{
                const state = selectors.selectTable(s);
                Object.keys(entities).forEach((id)=>{
                    state[id] = {
                        ...state[id],
                        ...entities[id]
                    };
                });
            },
        merge: (entities)=>(s)=>{
                const state = selectors.selectTable(s);
                Object.keys(entities).forEach((id)=>{
                    const entity = entities[id];
                    Object.keys(entity).forEach((prop)=>{
                        const val = entity[prop];
                        if (Array.isArray(val)) {
                            // deno-lint-ignore no-explicit-any
                            const list = val;
                            // deno-lint-ignore no-explicit-any
                            state[id][prop].push(...list);
                        } else // deno-lint-ignore no-explicit-any
                        state[id][prop] = entities[id][prop];
                    });
                });
            },
        reset: ()=>(s)=>{
                // deno-lint-ignore no-explicit-any
                s[name] = initialState;
            },
        ...selectors
    };
}
function $ef6355f12eb9b13b$export$9852986a3ec5f6a0({ initialState: initialState, empty: empty } = {}) {
    return (name)=>$ef6355f12eb9b13b$export$33bbb3ec7652e187({
            name: name,
            empty: empty,
            initialState: initialState
        });
}

});

parcelRegister("ayc00", function(module, exports) {

$parcel$export(module.exports, "any", function () { return $7ae6631e9a1d039a$export$4154a199d7d90455; });
function $7ae6631e9a1d039a$export$5585fc1d9a6e93e2({ name: name, initialState: initialState }) {
    return {
        schema: "any",
        name: name,
        initialState: initialState,
        set: (value)=>(state)=>{
                // deno-lint-ignore no-explicit-any
                state[name] = value;
            },
        reset: ()=>(state)=>{
                // deno-lint-ignore no-explicit-any
                state[name] = initialState;
            },
        select: (state)=>{
            // deno-lint-ignore no-explicit-any
            return state[name];
        }
    };
}
function $7ae6631e9a1d039a$export$4154a199d7d90455(initialState) {
    return (name)=>$7ae6631e9a1d039a$export$5585fc1d9a6e93e2({
            name: name,
            initialState: initialState
        });
}

});

parcelRegister("hXdgV", function(module, exports) {

$parcel$export(module.exports, "obj", function () { return $d1223de1b4f8c545$export$d29f2533ab4f8bcf; });
function $d1223de1b4f8c545$export$ad1552835d16e4ca({ name: name, initialState: initialState }) {
    return {
        schema: "obj",
        name: name,
        initialState: initialState,
        set: (value)=>(state)=>{
                // deno-lint-ignore no-explicit-any
                state[name] = value;
            },
        reset: ()=>(state)=>{
                // deno-lint-ignore no-explicit-any
                state[name] = initialState;
            },
        update: (prop)=>(state)=>{
                // deno-lint-ignore no-explicit-any
                state[name][prop.key] = prop.value;
            },
        select: (state)=>{
            // deno-lint-ignore no-explicit-any
            return state[name];
        }
    };
}
function $d1223de1b4f8c545$export$d29f2533ab4f8bcf(initialState) {
    return (name)=>$d1223de1b4f8c545$export$ad1552835d16e4ca({
            name: name,
            initialState: initialState
        });
}

});

parcelRegister("hWc7O", function(module, exports) {

$parcel$export(module.exports, "loaders", function () { return $d0f142387d39bc94$export$c1150d502d9297b5; });
parcelRequire("c3MnJ");
var $1rr1p = parcelRequire("1rr1p");
const $d0f142387d39bc94$var$excludesFalse = (n)=>Boolean(n);
function $d0f142387d39bc94$export$e3c55d9523c18bab(li = {}) {
    return {
        id: "",
        status: "idle",
        message: "",
        lastRun: 0,
        lastSuccess: 0,
        meta: {},
        ...li
    };
}
function $d0f142387d39bc94$export$68251d7daaae34cc(l = {}) {
    const loading = $d0f142387d39bc94$export$e3c55d9523c18bab(l);
    return {
        ...loading,
        isIdle: loading.status === "idle",
        isError: loading.status === "error",
        isSuccess: loading.status === "success",
        isLoading: loading.status === "loading",
        isInitialLoading: (loading.status === "idle" || loading.status === "loading") && loading.lastSuccess === 0
    };
}
function $d0f142387d39bc94$var$loaderSelectors(selectTable) {
    const empty = $d0f142387d39bc94$export$68251d7daaae34cc();
    const tableAsList = (data)=>Object.values(data).filter($d0f142387d39bc94$var$excludesFalse);
    const findById = (data, { id: id })=>$d0f142387d39bc94$export$68251d7daaae34cc(data[id]) || empty;
    const findByIds = (data, { ids: ids })=>ids.map((id)=>$d0f142387d39bc94$export$68251d7daaae34cc(data[id])).filter($d0f142387d39bc94$var$excludesFalse);
    const selectById = (0, $1rr1p.createSelector)(selectTable, (_, p)=>p.id, (loaders, id)=>findById(loaders, {
            id: id
        }));
    return {
        findById: findById,
        findByIds: findByIds,
        selectTable: selectTable,
        selectTableAsList: (0, $1rr1p.createSelector)(selectTable, (data)=>tableAsList(data)),
        selectById: selectById,
        selectByIds: (0, $1rr1p.createSelector)(selectTable, (_, p)=>p.ids, (loaders, ids)=>findByIds(loaders, {
                ids: ids
            }))
    };
}
const $d0f142387d39bc94$var$ts = ()=>new Date().getTime();
const $d0f142387d39bc94$export$102bdb6af9defe31 = ({ name: name, initialState: initialState = {} })=>{
    const selectors = $d0f142387d39bc94$var$loaderSelectors((s)=>s[name]);
    return {
        schema: "loader",
        name: name,
        initialState: initialState,
        start: (e)=>(s)=>{
                const table = selectors.selectTable(s);
                const loader = table[e.id];
                table[e.id] = $d0f142387d39bc94$export$e3c55d9523c18bab({
                    ...loader,
                    ...e,
                    status: "loading",
                    lastRun: $d0f142387d39bc94$var$ts()
                });
            },
        success: (e)=>(s)=>{
                const table = selectors.selectTable(s);
                const loader = table[e.id];
                table[e.id] = $d0f142387d39bc94$export$e3c55d9523c18bab({
                    ...loader,
                    ...e,
                    status: "success",
                    lastSuccess: $d0f142387d39bc94$var$ts()
                });
            },
        error: (e)=>(s)=>{
                const table = selectors.selectTable(s);
                const loader = table[e.id];
                table[e.id] = $d0f142387d39bc94$export$e3c55d9523c18bab({
                    ...loader,
                    ...e,
                    status: "error"
                });
            },
        reset: ()=>(s)=>{
                // deno-lint-ignore no-explicit-any
                s[name] = initialState;
            },
        resetByIds: (ids)=>(s)=>{
                const table = selectors.selectTable(s);
                ids.forEach((id)=>{
                    delete table[id];
                });
            },
        ...selectors
    };
};
function $d0f142387d39bc94$export$c1150d502d9297b5(initialState) {
    return (name)=>$d0f142387d39bc94$export$102bdb6af9defe31({
            name: name,
            initialState: initialState
        });
}

});


parcelRegister("60ukP", function(module, exports) {

$parcel$export(module.exports, "createSchema", function () { return $0120f09d1f0041aa$export$5f4ce795563f4211; });

var $eAyML = parcelRequire("eAyML");

var $llQUJ = parcelRequire("llQUJ");
const $0120f09d1f0041aa$var$defaultSchema = function() {
    return {
        cache: (0, $llQUJ.slice).table(),
        loaders: (0, $llQUJ.slice).loaders()
    };
};
function $0120f09d1f0041aa$export$5f4ce795563f4211(slices = $0120f09d1f0041aa$var$defaultSchema()) {
    const db = Object.keys(slices).reduce((acc, key)=>{
        // deno-lint-ignore no-explicit-any
        acc[key] = slices[key](key);
        return acc;
    }, {});
    const initialState = Object.keys(db).reduce((acc, key)=>{
        // deno-lint-ignore no-explicit-any
        acc[key] = db[key].initialState;
        return acc;
    }, {});
    function* update(ups) {
        return yield* (0, $eAyML.updateStore)(ups);
    }
    db.update = update;
    return [
        db,
        initialState
    ];
}

});

parcelRegister("iatmP", function(module, exports) {
parcelRequire("c3MnJ");
var $6wugg = parcelRequire("6wugg");
function $d39ff0e377766b8e$export$f5171a93cac7ea9d(queue) {
    let notifying = false;
    return function* batchMdw(_, next) {
        if (!notifying) {
            notifying = true;
            yield* (0, $6wugg.action)(function*(resolve) {
                queue(()=>{
                    notifying = false;
                    resolve();
                });
            });
            yield* next();
        }
    };
}

});

parcelRegister("1lCWl", function(module, exports) {

$parcel$export(module.exports, "PERSIST_LOADER_ID", function () { return $0fb5f54bd1fac71b$export$a9853c901d529856; });
$parcel$export(module.exports, "createLocalStorageAdapter", function () { return $0fb5f54bd1fac71b$export$aa1edfda5283325f; });
$parcel$export(module.exports, "createPersistor", function () { return $0fb5f54bd1fac71b$export$a7e75b14fa48bb5; });
$parcel$export(module.exports, "persistStoreMdw", function () { return $0fb5f54bd1fac71b$export$ff029f90c48282b6; });
parcelRequire("c3MnJ");
var $2EoHU = parcelRequire("2EoHU");

var $eAyML = parcelRequire("eAyML");
const $0fb5f54bd1fac71b$export$a9853c901d529856 = "@@starfx/persist";
function $0fb5f54bd1fac71b$export$99c68a89351e15c0() {
    const transformers = {
        in: function(currentState) {
            return currentState;
        },
        out: function(currentState) {
            return currentState;
        }
    };
    const inTransformer = function(state) {
        return transformers.in(state);
    };
    const outTransformer = function(state) {
        return transformers.out(state);
    };
    return {
        in: inTransformer,
        out: outTransformer
    };
}
function $0fb5f54bd1fac71b$export$aa1edfda5283325f() {
    return {
        getItem: function*(key) {
            const storage = localStorage.getItem(key) || "{}";
            return (0, $2EoHU.Ok)(JSON.parse(storage));
        },
        setItem: function*(key, s) {
            const state = JSON.stringify(s);
            try {
                localStorage.setItem(key, state);
            } catch (err) {
                return (0, $2EoHU.Err)(err);
            }
            return (0, $2EoHU.Ok)(undefined);
        },
        removeItem: function*(key) {
            localStorage.removeItem(key);
            return (0, $2EoHU.Ok)(undefined);
        }
    };
}
function $0fb5f54bd1fac71b$export$f8f4cfaff2fff0d8(original, persisted) {
    return {
        ...original,
        ...persisted
    };
}
function $0fb5f54bd1fac71b$export$a7e75b14fa48bb5({ adapter: adapter, key: key = "starfx", reconciler: reconciler = $0fb5f54bd1fac71b$export$f8f4cfaff2fff0d8, allowlist: allowlist = [], transform: transform }) {
    function* rehydrate() {
        const persistedState = yield* adapter.getItem(key);
        if (!persistedState.ok) return (0, $2EoHU.Err)(persistedState.error);
        let stateFromStorage = persistedState.value;
        if (transform) try {
            stateFromStorage = transform.out(persistedState.value);
        } catch (err) {
            console.error("Persistor outbound transformer error:", err);
        }
        const state = yield* (0, $eAyML.select)((s)=>s);
        const nextState = reconciler(state, stateFromStorage);
        yield* (0, $eAyML.updateStore)(function(state) {
            Object.keys(nextState).forEach((key)=>{
                state[key] = nextState[key];
            });
        });
        return (0, $2EoHU.Ok)(undefined);
    }
    return {
        key: key,
        adapter: adapter,
        allowlist: allowlist,
        reconciler: reconciler,
        rehydrate: rehydrate,
        transform: transform
    };
}
function $0fb5f54bd1fac71b$export$ff029f90c48282b6({ allowlist: allowlist, adapter: adapter, key: key, transform: transform }) {
    return function*(_, next) {
        yield* next();
        const state = yield* (0, $eAyML.select)((s)=>s);
        let transformedState = state;
        if (transform) try {
            transformedState = transform.in(state);
        } catch (err) {
            console.error("Persistor inbound transformer error:", err);
        }
        // empty allowlist list means save entire state
        if (allowlist.length === 0) {
            yield* adapter.setItem(key, transformedState);
            return;
        }
        const allowedState = allowlist.reduce((acc, key)=>{
            if (key in transformedState) acc[key] = transformedState[key];
            return acc;
        }, {});
        yield* adapter.setItem(key, allowedState);
    };
}

});



parcelRegister("gN5ZC", function(module, exports) {

$parcel$export(module.exports, "RouterProvider", function () { return $917ecb6ef7853f65$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "shouldClientNavigate", function () { return $917ecb6ef7853f65$export$efa8c9099e530235; });
$parcel$export(module.exports, "openLink", function () { return $917ecb6ef7853f65$export$95185d699e05d4d7; });
$parcel$export(module.exports, "useRouter", function () { return $917ecb6ef7853f65$export$9a302a45f65d0572; });
$parcel$export(module.exports, "useSyntheticLinkProps", function () { return $917ecb6ef7853f65$export$bdc77b0c0a3a85d6; });
$parcel$export(module.exports, "useLinkProps", function () { return $917ecb6ef7853f65$export$7e924b3091a3bd18; });

var $50qTn = parcelRequire("50qTn");

var $be6XU = parcelRequire("be6XU");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $917ecb6ef7853f65$var$$ea8dcbcb9ea1b556$var$RouterContext = (0, $bh6RR.createContext)({
    isNative: true,
    open: $917ecb6ef7853f65$var$$ea8dcbcb9ea1b556$var$openSyntheticLink,
    useHref: (href)=>href
});
function $917ecb6ef7853f65$export$323e4fc2fa4753fb(props) {
    let { children: children, navigate: navigate, useHref: useHref } = props;
    let ctx = (0, $bh6RR.useMemo)(()=>({
            isNative: false,
            open: (target, modifiers, href, routerOptions)=>{
                $917ecb6ef7853f65$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>{
                    if ($917ecb6ef7853f65$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);
                    else $917ecb6ef7853f65$export$95185d699e05d4d7(link, modifiers);
                });
            },
            useHref: useHref || ((href)=>href)
        }), [
        navigate,
        useHref
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($917ecb6ef7853f65$var$$ea8dcbcb9ea1b556$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $917ecb6ef7853f65$export$9a302a45f65d0572() {
    return (0, $bh6RR.useContext)($917ecb6ef7853f65$var$$ea8dcbcb9ea1b556$var$RouterContext);
}
function $917ecb6ef7853f65$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    let target = link.getAttribute('target');
    return (!target || target === '_self') && link.origin === location.origin && !link.hasAttribute('download') && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $917ecb6ef7853f65$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
    var _window_event_type, _window_event;
    let { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey } = modifiers;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ((0, $be6XU.isFirefox)() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith('key')) && target.target === '_blank') {
        if ((0, $be6XU.isMac)()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    let event = (0, $be6XU.isWebKit)() && (0, $be6XU.isMac)() && !(0, $be6XU.isIPad)() && true ? new KeyboardEvent('keydown', {
        keyIdentifier: 'Enter',
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent('click', {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        bubbles: true,
        cancelable: true
    });
    $917ecb6ef7853f65$export$95185d699e05d4d7.isOpening = setOpening;
    (0, $50qTn.focusWithoutScrolling)(target);
    target.dispatchEvent(event);
    $917ecb6ef7853f65$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$917ecb6ef7853f65$export$95185d699e05d4d7.isOpening = false;
function $917ecb6ef7853f65$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute('data-href')) {
        let link = document.createElement('a');
        link.href = target.getAttribute('data-href');
        if (target.hasAttribute('data-target')) link.target = target.getAttribute('data-target');
        if (target.hasAttribute('data-rel')) link.rel = target.getAttribute('data-rel');
        if (target.hasAttribute('data-download')) link.download = target.getAttribute('data-download');
        if (target.hasAttribute('data-ping')) link.ping = target.getAttribute('data-ping');
        if (target.hasAttribute('data-referrer-policy')) link.referrerPolicy = target.getAttribute('data-referrer-policy');
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $917ecb6ef7853f65$var$$ea8dcbcb9ea1b556$var$openSyntheticLink(target, modifiers) {
    $917ecb6ef7853f65$var$$ea8dcbcb9ea1b556$var$getSyntheticLink(target, (link)=>$917ecb6ef7853f65$export$95185d699e05d4d7(link, modifiers));
}
function $917ecb6ef7853f65$export$bdc77b0c0a3a85d6(props) {
    let router = $917ecb6ef7853f65$export$9a302a45f65d0572();
    var _props_href;
    const href = router.useHref((_props_href = props.href) !== null && _props_href !== void 0 ? _props_href : '');
    return {
        'data-href': props.href ? href : undefined,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $917ecb6ef7853f65$export$51437d503373d223(props) {
    return {
        'data-href': props.href,
        'data-target': props.target,
        'data-rel': props.rel,
        'data-download': props.download,
        'data-ping': props.ping,
        'data-referrer-policy': props.referrerPolicy
    };
}
function $917ecb6ef7853f65$export$7e924b3091a3bd18(props) {
    let router = $917ecb6ef7853f65$export$9a302a45f65d0572();
    var _props_href;
    const href = router.useHref((_props_href = props === null || props === void 0 ? void 0 : props.href) !== null && _props_href !== void 0 ? _props_href : '');
    return {
        href: (props === null || props === void 0 ? void 0 : props.href) ? href : undefined,
        target: props === null || props === void 0 ? void 0 : props.target,
        rel: props === null || props === void 0 ? void 0 : props.rel,
        download: props === null || props === void 0 ? void 0 : props.download,
        ping: props === null || props === void 0 ? void 0 : props.ping,
        referrerPolicy: props === null || props === void 0 ? void 0 : props.referrerPolicy
    };
}

});
parcelRegister("50qTn", function(module, exports) {

$parcel$export(module.exports, "focusWithoutScrolling", function () { return $547a0a3002499be0$export$de79e2c695e052f3; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $547a0a3002499be0$export$de79e2c695e052f3(element) {
    if ($547a0a3002499be0$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $547a0a3002499be0$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $547a0a3002499be0$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $547a0a3002499be0$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $547a0a3002499be0$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($547a0a3002499be0$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $547a0a3002499be0$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement('div');
            focusElem.focus({
                get preventScroll () {
                    $547a0a3002499be0$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch  {
        // Ignore
        }
    }
    return $547a0a3002499be0$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $547a0a3002499be0$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $547a0a3002499be0$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}

});

parcelRegister("be6XU", function(module, exports) {

$parcel$export(module.exports, "isMac", function () { return $044deaf774a1813e$export$9ac100e40613ea10; });
$parcel$export(module.exports, "isIPhone", function () { return $044deaf774a1813e$export$186c6964ca17d99; });
$parcel$export(module.exports, "isIPad", function () { return $044deaf774a1813e$export$7bef049ce92e4224; });
$parcel$export(module.exports, "isIOS", function () { return $044deaf774a1813e$export$fedb369cb70207f1; });
$parcel$export(module.exports, "isAppleDevice", function () { return $044deaf774a1813e$export$e1865c3bedcd822b; });
$parcel$export(module.exports, "isWebKit", function () { return $044deaf774a1813e$export$78551043582a6a98; });
$parcel$export(module.exports, "isAndroid", function () { return $044deaf774a1813e$export$a11b0059900ceec8; });
$parcel$export(module.exports, "isFirefox", function () { return $044deaf774a1813e$export$b7d78993b74f766d; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $044deaf774a1813e$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === 'undefined' || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $044deaf774a1813e$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $044deaf774a1813e$var$$c87311424ea30a05$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $044deaf774a1813e$export$9ac100e40613ea10 = $044deaf774a1813e$var$$c87311424ea30a05$var$cached(function() {
    return $044deaf774a1813e$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
});
const $044deaf774a1813e$export$186c6964ca17d99 = $044deaf774a1813e$var$$c87311424ea30a05$var$cached(function() {
    return $044deaf774a1813e$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
const $044deaf774a1813e$export$7bef049ce92e4224 = $044deaf774a1813e$var$$c87311424ea30a05$var$cached(function() {
    return $044deaf774a1813e$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $044deaf774a1813e$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $044deaf774a1813e$export$fedb369cb70207f1 = $044deaf774a1813e$var$$c87311424ea30a05$var$cached(function() {
    return $044deaf774a1813e$export$186c6964ca17d99() || $044deaf774a1813e$export$7bef049ce92e4224();
});
const $044deaf774a1813e$export$e1865c3bedcd822b = $044deaf774a1813e$var$$c87311424ea30a05$var$cached(function() {
    return $044deaf774a1813e$export$9ac100e40613ea10() || $044deaf774a1813e$export$fedb369cb70207f1();
});
const $044deaf774a1813e$export$78551043582a6a98 = $044deaf774a1813e$var$$c87311424ea30a05$var$cached(function() {
    return $044deaf774a1813e$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$044deaf774a1813e$export$6446a186d09e379e();
});
const $044deaf774a1813e$export$6446a186d09e379e = $044deaf774a1813e$var$$c87311424ea30a05$var$cached(function() {
    return $044deaf774a1813e$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
const $044deaf774a1813e$export$a11b0059900ceec8 = $044deaf774a1813e$var$$c87311424ea30a05$var$cached(function() {
    return $044deaf774a1813e$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
});
const $044deaf774a1813e$export$b7d78993b74f766d = $044deaf774a1813e$var$$c87311424ea30a05$var$cached(function() {
    return $044deaf774a1813e$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
});

});


parcelRegister("9SfKt", function(module, exports) {

$parcel$export(module.exports, "tv", function () { return $73055f8a9e3c55f7$export$984d890fc49ac622; });

var $hkG3E = parcelRequire("hkG3E");

var $cZXNZ = parcelRequire("cZXNZ");
var $73055f8a9e3c55f7$export$f84bd70098573c5c = {
    twMerge: !0,
    twMergeConfig: {},
    responsiveVariants: !1
}, $73055f8a9e3c55f7$export$b2b720306681cd4b = (s)=>s || void 0, $73055f8a9e3c55f7$export$bdb9d1405dbffd0f = (...s)=>$73055f8a9e3c55f7$export$b2b720306681cd4b((0, $hkG3E.e)(s).filter(Boolean).join(" ")), $73055f8a9e3c55f7$var$R = null, $73055f8a9e3c55f7$var$v = {}, $73055f8a9e3c55f7$var$q = !1, $73055f8a9e3c55f7$export$1343a74baacb0543 = (...s)=>(b$1)=>b$1.twMerge ? ((!$73055f8a9e3c55f7$var$R || $73055f8a9e3c55f7$var$q) && ($73055f8a9e3c55f7$var$q = !1, $73055f8a9e3c55f7$var$R = (0, $hkG3E.b)($73055f8a9e3c55f7$var$v) ? (0, $cZXNZ.twMerge) : (0, $cZXNZ.extendTailwindMerge)({
            ...$73055f8a9e3c55f7$var$v,
            extend: {
                theme: $73055f8a9e3c55f7$var$v.theme,
                classGroups: $73055f8a9e3c55f7$var$v.classGroups,
                conflictingClassGroupModifiers: $73055f8a9e3c55f7$var$v.conflictingClassGroupModifiers,
                conflictingClassGroups: $73055f8a9e3c55f7$var$v.conflictingClassGroups,
                ...$73055f8a9e3c55f7$var$v.extend
            }
        })), $73055f8a9e3c55f7$export$b2b720306681cd4b($73055f8a9e3c55f7$var$R($73055f8a9e3c55f7$export$bdb9d1405dbffd0f(s)))) : $73055f8a9e3c55f7$export$bdb9d1405dbffd0f(s), $73055f8a9e3c55f7$var$_ = (s, b)=>{
    for(let e in b)s.hasOwnProperty(e) ? s[e] = $73055f8a9e3c55f7$export$bdb9d1405dbffd0f(s[e], b[e]) : s[e] = b[e];
    return s;
}, $73055f8a9e3c55f7$export$984d890fc49ac622 = (s, b$1)=>{
    let { extend: e = null, slots: O = {}, variants: U = {}, compoundVariants: W = [], compoundSlots: C = [], defaultVariants: z = {} } = s, m = {
        ...$73055f8a9e3c55f7$export$f84bd70098573c5c,
        ...b$1
    }, k = e != null && e.base ? $73055f8a9e3c55f7$export$bdb9d1405dbffd0f(e.base, s == null ? void 0 : s.base) : s == null ? void 0 : s.base, g$1 = e != null && e.variants && !(0, $hkG3E.b)(e.variants) ? (0, $hkG3E.g)(U, e.variants) : U, w = e != null && e.defaultVariants && !(0, $hkG3E.b)(e.defaultVariants) ? {
        ...e.defaultVariants,
        ...z
    } : z;
    !(0, $hkG3E.b)(m.twMergeConfig) && !(0, $hkG3E.c)(m.twMergeConfig, $73055f8a9e3c55f7$var$v) && ($73055f8a9e3c55f7$var$q = !0, $73055f8a9e3c55f7$var$v = m.twMergeConfig);
    let S = (0, $hkG3E.b)(e == null ? void 0 : e.slots), T = (0, $hkG3E.b)(O) ? {} : {
        base: $73055f8a9e3c55f7$export$bdb9d1405dbffd0f(s == null ? void 0 : s.base, S && (e == null ? void 0 : e.base)),
        ...O
    }, j = S ? T : $73055f8a9e3c55f7$var$_({
        ...e == null ? void 0 : e.slots
    }, (0, $hkG3E.b)(T) ? {
        base: s == null ? void 0 : s.base
    } : T), h$1 = (0, $hkG3E.b)(e == null ? void 0 : e.compoundVariants) ? W : (0, $hkG3E.f)(e == null ? void 0 : e.compoundVariants, W), V = (l)=>{
        if ((0, $hkG3E.b)(g$1) && (0, $hkG3E.b)(O) && S) return $73055f8a9e3c55f7$export$1343a74baacb0543(k, l == null ? void 0 : l.class, l == null ? void 0 : l.className)(m);
        if (h$1 && !Array.isArray(h$1)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof h$1}`);
        if (C && !Array.isArray(C)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof C}`);
        let P = (a, n, t = [], i)=>{
            let r = t;
            if (typeof n == "string") r = r.concat((0, $hkG3E.h)(n).split(" ").map((o)=>`${a}:${o}`));
            else if (Array.isArray(n)) r = r.concat(n.reduce((o, c)=>o.concat(`${a}:${c}`), []));
            else if (typeof n == "object" && typeof i == "string") {
                for(let o in n)if (n.hasOwnProperty(o) && o === i) {
                    let c = n[o];
                    if (c && typeof c == "string") {
                        let u = (0, $hkG3E.h)(c);
                        r[i] ? r[i] = r[i].concat(u.split(" ").map((f)=>`${a}:${f}`)) : r[i] = u.split(" ").map((f)=>`${a}:${f}`);
                    } else Array.isArray(c) && c.length > 0 && (r[i] = c.reduce((u, f)=>u.concat(`${a}:${f}`), []));
                }
            }
            return r;
        }, D = (a$1, n = g$1, t = null, i = null)=>{
            var L;
            let r = n[a$1];
            if (!r || (0, $hkG3E.b)(r)) return null;
            let o = (L = i == null ? void 0 : i[a$1]) != null ? L : l == null ? void 0 : l[a$1];
            if (o === null) return null;
            let c = (0, $hkG3E.a)(o), u = Array.isArray(m.responsiveVariants) && m.responsiveVariants.length > 0 || m.responsiveVariants === !0, f = w == null ? void 0 : w[a$1], d = [];
            if (typeof c == "object" && u) for (let [E, Q] of Object.entries(c)){
                let ne = r[Q];
                if (E === "initial") {
                    f = Q;
                    continue;
                }
                Array.isArray(m.responsiveVariants) && !m.responsiveVariants.includes(E) || (d = P(E, ne, d, t));
            }
            let $ = c != null && typeof c != "object" ? c : (0, $hkG3E.a)(f), A = r[$ || "false"];
            return typeof d == "object" && typeof t == "string" && d[t] ? $73055f8a9e3c55f7$var$_(d, A) : d.length > 0 ? (d.push(A), t === "base" ? d.join(" ") : d) : A;
        }, p = ()=>g$1 ? Object.keys(g$1).map((a)=>D(a, g$1)) : null, ee = (a, n)=>{
            if (!g$1 || typeof g$1 != "object") return null;
            let t = new Array;
            for(let i in g$1){
                let r = D(i, g$1, a, n), o = a === "base" && typeof r == "string" ? r : r && r[a];
                o && (t[t.length] = o);
            }
            return t;
        }, H = {};
        for(let a in l)l[a] !== void 0 && (H[a] = l[a]);
        let I = (a, n)=>{
            var i;
            let t = typeof (l == null ? void 0 : l[a]) == "object" ? {
                [a]: (i = l[a]) == null ? void 0 : i.initial
            } : {};
            return {
                ...w,
                ...H,
                ...t,
                ...n
            };
        }, J = (a = [], n)=>{
            let t = [];
            for (let { class: i, className: r, ...o } of a){
                let c = !0;
                for (let [u, f] of Object.entries(o)){
                    let d = I(u, n)[u];
                    if (Array.isArray(f)) {
                        if (!f.includes(d)) {
                            c = !1;
                            break;
                        }
                    } else {
                        let $ = (A)=>A == null || A === !1;
                        if ($(f) && $(d)) continue;
                        if (d !== f) {
                            c = !1;
                            break;
                        }
                    }
                }
                c && (i && t.push(i), r && t.push(r));
            }
            return t;
        }, te = (a)=>{
            let n = J(h$1, a);
            if (!Array.isArray(n)) return n;
            let t = {};
            for (let i of n)if (typeof i == "string" && (t.base = $73055f8a9e3c55f7$export$1343a74baacb0543(t.base, i)(m)), typeof i == "object") for (let [r, o] of Object.entries(i))t[r] = $73055f8a9e3c55f7$export$1343a74baacb0543(t[r], o)(m);
            return t;
        }, ae = (a)=>{
            if (C.length < 1) return null;
            let n = {};
            for (let { slots: t = [], class: i, className: r, ...o } of C){
                if (!(0, $hkG3E.b)(o)) {
                    let c = !0;
                    for (let u of Object.keys(o)){
                        let f = I(u, a)[u];
                        if (f === void 0 || (Array.isArray(o[u]) ? !o[u].includes(f) : o[u] !== f)) {
                            c = !1;
                            break;
                        }
                    }
                    if (!c) continue;
                }
                for (let c of t)n[c] = n[c] || [], n[c].push([
                    i,
                    r
                ]);
            }
            return n;
        };
        if (!(0, $hkG3E.b)(O) || !S) {
            let a = {};
            if (typeof j == "object" && !(0, $hkG3E.b)(j)) for (let n of Object.keys(j))a[n] = (t)=>{
                var i, r;
                return $73055f8a9e3c55f7$export$1343a74baacb0543(j[n], ee(n, t), ((i = te(t)) != null ? i : [])[n], ((r = ae(t)) != null ? r : [])[n], t == null ? void 0 : t.class, t == null ? void 0 : t.className)(m);
            };
            return a;
        }
        return $73055f8a9e3c55f7$export$1343a74baacb0543(k, p(), J(h$1), l == null ? void 0 : l.class, l == null ? void 0 : l.className)(m);
    }, K = ()=>{
        if (!(!g$1 || typeof g$1 != "object")) return Object.keys(g$1);
    };
    return V.variantKeys = K(), V.extend = e, V.base = k, V.slots = j, V.variants = g$1, V.defaultVariants = w, V.compoundSlots = C, V.compoundVariants = h$1, V;
}, $73055f8a9e3c55f7$export$cc73e0e70ed8b709 = (s)=>(b, e)=>$73055f8a9e3c55f7$export$984d890fc49ac622(b, e ? (0, $hkG3E.g)(s, e) : s);

});
parcelRegister("hkG3E", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $c9e4edbbe616dde7$export$407448d2b89b1813; });
$parcel$export(module.exports, "b", function () { return $c9e4edbbe616dde7$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "c", function () { return $c9e4edbbe616dde7$export$db3b6bfb95261072; });
$parcel$export(module.exports, "e", function () { return $c9e4edbbe616dde7$export$f1e1789686576879; });
$parcel$export(module.exports, "f", function () { return $c9e4edbbe616dde7$export$2d1720544b23b823; });
$parcel$export(module.exports, "g", function () { return $c9e4edbbe616dde7$export$39b482c5e57630a8; });
$parcel$export(module.exports, "h", function () { return $c9e4edbbe616dde7$export$dda1d9f60106f0e9; });
var $c9e4edbbe616dde7$export$407448d2b89b1813 = (e)=>typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, $c9e4edbbe616dde7$export$8b22cf2602fb60ce = (e)=>!e || typeof e != "object" || Object.keys(e).length === 0, $c9e4edbbe616dde7$export$db3b6bfb95261072 = (e, o)=>JSON.stringify(e) === JSON.stringify(o), $c9e4edbbe616dde7$export$4368d992c4eafac0 = (e)=>typeof e == "boolean";
function $c9e4edbbe616dde7$var$i(e, o) {
    e.forEach(function(r) {
        Array.isArray(r) ? $c9e4edbbe616dde7$var$i(r, o) : o.push(r);
    });
}
function $c9e4edbbe616dde7$export$f1e1789686576879(e) {
    let o = [];
    return $c9e4edbbe616dde7$var$i(e, o), o;
}
var $c9e4edbbe616dde7$export$2d1720544b23b823 = (...e)=>$c9e4edbbe616dde7$export$f1e1789686576879(e).filter(Boolean), $c9e4edbbe616dde7$export$39b482c5e57630a8 = (e, o)=>{
    let r = {}, c = Object.keys(e), f = Object.keys(o);
    for (let t of c)if (f.includes(t)) {
        let s = e[t], n = o[t];
        Array.isArray(s) || Array.isArray(n) ? r[t] = $c9e4edbbe616dde7$export$2d1720544b23b823(n, s) : typeof s == "object" && typeof n == "object" ? r[t] = $c9e4edbbe616dde7$export$39b482c5e57630a8(s, n) : r[t] = n + " " + s;
    } else r[t] = e[t];
    for (let t of f)c.includes(t) || (r[t] = o[t]);
    return r;
}, $c9e4edbbe616dde7$export$dda1d9f60106f0e9 = (e)=>!e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim();

});

parcelRegister("cZXNZ", function(module, exports) {

$parcel$export(module.exports, "extendTailwindMerge", function () { return $58783ce43eb3c126$export$c8d8406b6cd2243e; });
$parcel$export(module.exports, "twMerge", function () { return $58783ce43eb3c126$export$b4660bb6000dfbc9; });
const $58783ce43eb3c126$var$CLASS_PART_SEPARATOR = '-';
const $58783ce43eb3c126$var$createClassGroupUtils = (config)=>{
    const classMap = $58783ce43eb3c126$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        const classParts = className.split($58783ce43eb3c126$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === '' && classParts.length !== 1) classParts.shift();
        return $58783ce43eb3c126$var$getGroupRecursive(classParts, classMap) || $58783ce43eb3c126$var$getGroupIdForArbitraryProperty(className);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        const conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [
            ...conflicts,
            ...conflictingClassGroupModifiers[classGroupId]
        ];
        return conflicts;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
const $58783ce43eb3c126$var$getGroupRecursive = (classParts, classPartObject)=>{
    if (classParts.length === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[0];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    const classGroupFromNextClassPart = nextClassPartObject ? $58783ce43eb3c126$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    const classRest = classParts.join($58783ce43eb3c126$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(({ validator: validator })=>validator(classRest))?.classGroupId;
};
const $58783ce43eb3c126$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
const $58783ce43eb3c126$var$getGroupIdForArbitraryProperty = (className)=>{
    if ($58783ce43eb3c126$var$arbitraryPropertyRegex.test(className)) {
        const arbitraryPropertyClassName = $58783ce43eb3c126$var$arbitraryPropertyRegex.exec(className)[1];
        const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(':'));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return 'arbitrary..' + property;
    }
};
/**
 * Exported for testing only
 */ const $58783ce43eb3c126$var$createClassMap = (config)=>{
    const { theme: theme, prefix: prefix } = config;
    const classMap = {
        nextPart: new Map(),
        validators: []
    };
    const prefixedClassGroupEntries = $58783ce43eb3c126$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(([classGroupId, classGroup])=>{
        $58783ce43eb3c126$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
};
const $58783ce43eb3c126$var$processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    classGroup.forEach((classDefinition)=>{
        if (typeof classDefinition === 'string') {
            const classPartObjectToEdit = classDefinition === '' ? classPartObject : $58783ce43eb3c126$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === 'function') {
            if ($58783ce43eb3c126$var$isThemeGetter(classDefinition)) {
                $58783ce43eb3c126$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(([key, classGroup])=>{
            $58783ce43eb3c126$var$processClassesRecursively(classGroup, $58783ce43eb3c126$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
};
const $58783ce43eb3c126$var$getPart = (classPartObject, path)=>{
    let currentClassPartObject = classPartObject;
    path.split($58783ce43eb3c126$var$CLASS_PART_SEPARATOR).forEach((pathPart)=>{
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
};
const $58783ce43eb3c126$var$isThemeGetter = (func)=>func.isThemeGetter;
const $58783ce43eb3c126$var$getPrefixedClassGroupEntries = (classGroupEntries, prefix)=>{
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(([classGroupId, classGroup])=>{
        const prefixedClassGroup = classGroup.map((classDefinition)=>{
            if (typeof classDefinition === 'string') return prefix + classDefinition;
            if (typeof classDefinition === 'object') return Object.fromEntries(Object.entries(classDefinition).map(([key, value])=>[
                    prefix + key,
                    value
                ]));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
};
// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
const $58783ce43eb3c126$var$createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = new Map();
    let previousCache = new Map();
    const update = (key, value)=>{
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    };
    return {
        get (key) {
            let value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
};
const $58783ce43eb3c126$var$IMPORTANT_MODIFIER = '!';
const $58783ce43eb3c126$var$createParseClassName = (config)=>{
    const { separator: separator, experimentalParseClassName: experimentalParseClassName } = config;
    const isSeparatorSingleCharacter = separator.length === 1;
    const firstSeparatorCharacter = separator[0];
    const separatorLength = separator.length;
    // parseClassName inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    const parseClassName = (className)=>{
        const modifiers = [];
        let bracketDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        for(let index = 0; index < className.length; index++){
            let currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        const hasImportantModifier = baseClassNameWithImportantModifier.startsWith($58783ce43eb3c126$var$IMPORTANT_MODIFIER);
        const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
    if (experimentalParseClassName) return (className)=>experimentalParseClassName({
            className: className,
            parseClassName: parseClassName
        });
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const $58783ce43eb3c126$var$sortModifiers = (modifiers)=>{
    if (modifiers.length <= 1) return modifiers;
    const sortedModifiers = [];
    let unsortedModifiers = [];
    modifiers.forEach((modifier)=>{
        const isArbitraryVariant = modifier[0] === '[';
        if (isArbitraryVariant) {
            sortedModifiers.push(...unsortedModifiers.sort(), modifier);
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push(...unsortedModifiers.sort());
    return sortedModifiers;
};
const $58783ce43eb3c126$var$createConfigUtils = (config)=>({
        cache: $58783ce43eb3c126$var$createLruCache(config.cacheSize),
        parseClassName: $58783ce43eb3c126$var$createParseClassName(config),
        ...$58783ce43eb3c126$var$createClassGroupUtils(config)
    });
const $58783ce43eb3c126$var$SPLIT_CLASSES_REGEX = /\s+/;
const $58783ce43eb3c126$var$mergeClassList = (classList, configUtils)=>{
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split($58783ce43eb3c126$var$SPLIT_CLASSES_REGEX);
    let result = '';
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        const variantModifier = $58783ce43eb3c126$var$sortModifiers(modifiers).join(':');
        const modifierId = hasImportantModifier ? variantModifier + $58783ce43eb3c126$var$IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.includes(classId)) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $58783ce43eb3c126$export$a8bbfb445e1f163f() {
    let index = 0;
    let argument;
    let resolvedValue;
    let string = '';
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $58783ce43eb3c126$var$toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
}
const $58783ce43eb3c126$var$toValue = (mix)=>{
    if (typeof mix === 'string') return mix;
    let resolvedValue;
    let string = '';
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $58783ce43eb3c126$var$toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
function $58783ce43eb3c126$export$ea2d4fba4d1bd27f(createConfigFirst, ...createConfigRest) {
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $58783ce43eb3c126$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $58783ce43eb3c126$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall($58783ce43eb3c126$export$a8bbfb445e1f163f.apply(null, arguments));
    };
}
const $58783ce43eb3c126$export$e176af7b8eefe933 = (key)=>{
    const themeGetter = (theme)=>theme[key] || [];
    themeGetter.isThemeGetter = true;
    return themeGetter;
};
const $58783ce43eb3c126$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const $58783ce43eb3c126$var$fractionRegex = /^\d+\/\d+$/;
const $58783ce43eb3c126$var$stringLengths = /*#__PURE__*/ new Set([
    'px',
    'full',
    'screen'
]);
const $58783ce43eb3c126$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $58783ce43eb3c126$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $58783ce43eb3c126$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $58783ce43eb3c126$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $58783ce43eb3c126$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const $58783ce43eb3c126$var$isLength = (value)=>$58783ce43eb3c126$var$isNumber(value) || $58783ce43eb3c126$var$stringLengths.has(value) || $58783ce43eb3c126$var$fractionRegex.test(value);
const $58783ce43eb3c126$var$isArbitraryLength = (value)=>$58783ce43eb3c126$var$getIsArbitraryValue(value, 'length', $58783ce43eb3c126$var$isLengthOnly);
const $58783ce43eb3c126$var$isNumber = (value)=>Boolean(value) && !Number.isNaN(Number(value));
const $58783ce43eb3c126$var$isArbitraryNumber = (value)=>$58783ce43eb3c126$var$getIsArbitraryValue(value, 'number', $58783ce43eb3c126$var$isNumber);
const $58783ce43eb3c126$var$isInteger = (value)=>Boolean(value) && Number.isInteger(Number(value));
const $58783ce43eb3c126$var$isPercent = (value)=>value.endsWith('%') && $58783ce43eb3c126$var$isNumber(value.slice(0, -1));
const $58783ce43eb3c126$var$isArbitraryValue = (value)=>$58783ce43eb3c126$var$arbitraryValueRegex.test(value);
const $58783ce43eb3c126$var$isTshirtSize = (value)=>$58783ce43eb3c126$var$tshirtUnitRegex.test(value);
const $58783ce43eb3c126$var$sizeLabels = /*#__PURE__*/ new Set([
    'length',
    'size',
    'percentage'
]);
const $58783ce43eb3c126$var$isArbitrarySize = (value)=>$58783ce43eb3c126$var$getIsArbitraryValue(value, $58783ce43eb3c126$var$sizeLabels, $58783ce43eb3c126$var$isNever);
const $58783ce43eb3c126$var$isArbitraryPosition = (value)=>$58783ce43eb3c126$var$getIsArbitraryValue(value, 'position', $58783ce43eb3c126$var$isNever);
const $58783ce43eb3c126$var$imageLabels = /*#__PURE__*/ new Set([
    'image',
    'url'
]);
const $58783ce43eb3c126$var$isArbitraryImage = (value)=>$58783ce43eb3c126$var$getIsArbitraryValue(value, $58783ce43eb3c126$var$imageLabels, $58783ce43eb3c126$var$isImage);
const $58783ce43eb3c126$var$isArbitraryShadow = (value)=>$58783ce43eb3c126$var$getIsArbitraryValue(value, '', $58783ce43eb3c126$var$isShadow);
const $58783ce43eb3c126$var$isAny = ()=>true;
const $58783ce43eb3c126$var$getIsArbitraryValue = (value, label, testValue)=>{
    const result = $58783ce43eb3c126$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return typeof label === 'string' ? result[1] === label : label.has(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const $58783ce43eb3c126$var$isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $58783ce43eb3c126$var$lengthUnitRegex.test(value) && !$58783ce43eb3c126$var$colorFunctionRegex.test(value);
const $58783ce43eb3c126$var$isNever = ()=>false;
const $58783ce43eb3c126$var$isShadow = (value)=>$58783ce43eb3c126$var$shadowRegex.test(value);
const $58783ce43eb3c126$var$isImage = (value)=>$58783ce43eb3c126$var$imageRegex.test(value);
const $58783ce43eb3c126$export$6f98703d2f5d4276 = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $58783ce43eb3c126$var$isAny,
    isArbitraryImage: $58783ce43eb3c126$var$isArbitraryImage,
    isArbitraryLength: $58783ce43eb3c126$var$isArbitraryLength,
    isArbitraryNumber: $58783ce43eb3c126$var$isArbitraryNumber,
    isArbitraryPosition: $58783ce43eb3c126$var$isArbitraryPosition,
    isArbitraryShadow: $58783ce43eb3c126$var$isArbitraryShadow,
    isArbitrarySize: $58783ce43eb3c126$var$isArbitrarySize,
    isArbitraryValue: $58783ce43eb3c126$var$isArbitraryValue,
    isInteger: $58783ce43eb3c126$var$isInteger,
    isLength: $58783ce43eb3c126$var$isLength,
    isNumber: $58783ce43eb3c126$var$isNumber,
    isPercent: $58783ce43eb3c126$var$isPercent,
    isTshirtSize: $58783ce43eb3c126$var$isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
const $58783ce43eb3c126$export$ed30944e0fe6ae5c = ()=>{
    const colors = $58783ce43eb3c126$export$e176af7b8eefe933('colors');
    const spacing = $58783ce43eb3c126$export$e176af7b8eefe933('spacing');
    const blur = $58783ce43eb3c126$export$e176af7b8eefe933('blur');
    const brightness = $58783ce43eb3c126$export$e176af7b8eefe933('brightness');
    const borderColor = $58783ce43eb3c126$export$e176af7b8eefe933('borderColor');
    const borderRadius = $58783ce43eb3c126$export$e176af7b8eefe933('borderRadius');
    const borderSpacing = $58783ce43eb3c126$export$e176af7b8eefe933('borderSpacing');
    const borderWidth = $58783ce43eb3c126$export$e176af7b8eefe933('borderWidth');
    const contrast = $58783ce43eb3c126$export$e176af7b8eefe933('contrast');
    const grayscale = $58783ce43eb3c126$export$e176af7b8eefe933('grayscale');
    const hueRotate = $58783ce43eb3c126$export$e176af7b8eefe933('hueRotate');
    const invert = $58783ce43eb3c126$export$e176af7b8eefe933('invert');
    const gap = $58783ce43eb3c126$export$e176af7b8eefe933('gap');
    const gradientColorStops = $58783ce43eb3c126$export$e176af7b8eefe933('gradientColorStops');
    const gradientColorStopPositions = $58783ce43eb3c126$export$e176af7b8eefe933('gradientColorStopPositions');
    const inset = $58783ce43eb3c126$export$e176af7b8eefe933('inset');
    const margin = $58783ce43eb3c126$export$e176af7b8eefe933('margin');
    const opacity = $58783ce43eb3c126$export$e176af7b8eefe933('opacity');
    const padding = $58783ce43eb3c126$export$e176af7b8eefe933('padding');
    const saturate = $58783ce43eb3c126$export$e176af7b8eefe933('saturate');
    const scale = $58783ce43eb3c126$export$e176af7b8eefe933('scale');
    const sepia = $58783ce43eb3c126$export$e176af7b8eefe933('sepia');
    const skew = $58783ce43eb3c126$export$e176af7b8eefe933('skew');
    const space = $58783ce43eb3c126$export$e176af7b8eefe933('space');
    const translate = $58783ce43eb3c126$export$e176af7b8eefe933('translate');
    const getOverscroll = ()=>[
            'auto',
            'contain',
            'none'
        ];
    const getOverflow = ()=>[
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    const getSpacingWithAutoAndArbitrary = ()=>[
            'auto',
            $58783ce43eb3c126$var$isArbitraryValue,
            spacing
        ];
    const getSpacingWithArbitrary = ()=>[
            $58783ce43eb3c126$var$isArbitraryValue,
            spacing
        ];
    const getLengthWithEmptyAndArbitrary = ()=>[
            '',
            $58783ce43eb3c126$var$isLength,
            $58783ce43eb3c126$var$isArbitraryLength
        ];
    const getNumberWithAutoAndArbitrary = ()=>[
            'auto',
            $58783ce43eb3c126$var$isNumber,
            $58783ce43eb3c126$var$isArbitraryValue
        ];
    const getPositions = ()=>[
            'bottom',
            'center',
            'left',
            'left-bottom',
            'left-top',
            'right',
            'right-bottom',
            'right-top',
            'top'
        ];
    const getLineStyles = ()=>[
            'solid',
            'dashed',
            'dotted',
            'double',
            'none'
        ];
    const getBlendModes = ()=>[
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    const getAlign = ()=>[
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch'
        ];
    const getZeroAndEmpty = ()=>[
            '',
            '0',
            $58783ce43eb3c126$var$isArbitraryValue
        ];
    const getBreaks = ()=>[
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    const getNumberAndArbitrary = ()=>[
            $58783ce43eb3c126$var$isNumber,
            $58783ce43eb3c126$var$isArbitraryValue
        ];
    return {
        cacheSize: 500,
        separator: ':',
        theme: {
            colors: [
                $58783ce43eb3c126$var$isAny
            ],
            spacing: [
                $58783ce43eb3c126$var$isLength,
                $58783ce43eb3c126$var$isArbitraryLength
            ],
            blur: [
                'none',
                '',
                $58783ce43eb3c126$var$isTshirtSize,
                $58783ce43eb3c126$var$isArbitraryValue
            ],
            brightness: getNumberAndArbitrary(),
            borderColor: [
                colors
            ],
            borderRadius: [
                'none',
                '',
                'full',
                $58783ce43eb3c126$var$isTshirtSize,
                $58783ce43eb3c126$var$isArbitraryValue
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmptyAndArbitrary(),
            contrast: getNumberAndArbitrary(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                $58783ce43eb3c126$var$isPercent,
                $58783ce43eb3c126$var$isArbitraryLength
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumberAndArbitrary(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumberAndArbitrary(),
            scale: getNumberAndArbitrary(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        'video',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                'container'
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $58783ce43eb3c126$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: [
                        ...getPositions(),
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        'auto',
                        $58783ce43eb3c126$var$isInteger,
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'wrap',
                        'wrap-reverse',
                        'nowrap'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        '1',
                        'auto',
                        'initial',
                        'none',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        'first',
                        'last',
                        'none',
                        $58783ce43eb3c126$var$isInteger,
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': [
                        $58783ce43eb3c126$var$isAny
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: [
                        'auto',
                        {
                            span: [
                                'full',
                                $58783ce43eb3c126$var$isInteger,
                                $58783ce43eb3c126$var$isArbitraryValue
                            ]
                        },
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': [
                        $58783ce43eb3c126$var$isAny
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: [
                        'auto',
                        {
                            span: [
                                $58783ce43eb3c126$var$isInteger,
                                $58783ce43eb3c126$var$isArbitraryValue
                            ]
                        },
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': [
                        'auto',
                        'min',
                        'max',
                        'fr',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': [
                        'auto',
                        'min',
                        'max',
                        'fr',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: [
                        'normal',
                        ...getAlign()
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': [
                        'start',
                        'end',
                        'center',
                        'stretch'
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto',
                        'start',
                        'end',
                        'center',
                        'stretch'
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal',
                        ...getAlign(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: [
                        'start',
                        'end',
                        'center',
                        'baseline',
                        'stretch'
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto',
                        'start',
                        'end',
                        'center',
                        'stretch',
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': [
                        ...getAlign(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': [
                        'start',
                        'end',
                        'center',
                        'baseline',
                        'stretch'
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto',
                        'start',
                        'end',
                        'center',
                        'stretch'
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ 'space-x': [
                {
                    'space-x': [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ 'space-y': [
                {
                    'space-y': [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        'auto',
                        'min',
                        'max',
                        'fit',
                        'svw',
                        'lvw',
                        'dvw',
                        $58783ce43eb3c126$var$isArbitraryValue,
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        $58783ce43eb3c126$var$isArbitraryValue,
                        spacing,
                        'min',
                        'max',
                        'fit'
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        $58783ce43eb3c126$var$isArbitraryValue,
                        spacing,
                        'none',
                        'full',
                        'min',
                        'max',
                        'fit',
                        'prose',
                        {
                            screen: [
                                $58783ce43eb3c126$var$isTshirtSize
                            ]
                        },
                        $58783ce43eb3c126$var$isTshirtSize
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        $58783ce43eb3c126$var$isArbitraryValue,
                        spacing,
                        'auto',
                        'min',
                        'max',
                        'fit',
                        'svh',
                        'lvh',
                        'dvh'
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        $58783ce43eb3c126$var$isArbitraryValue,
                        spacing,
                        'min',
                        'max',
                        'fit',
                        'svh',
                        'lvh',
                        'dvh'
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        $58783ce43eb3c126$var$isArbitraryValue,
                        spacing,
                        'min',
                        'max',
                        'fit',
                        'svh',
                        'lvh',
                        'dvh'
                    ]
                }
            ],
            /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */ size: [
                {
                    size: [
                        $58783ce43eb3c126$var$isArbitraryValue,
                        spacing,
                        'auto',
                        'min',
                        'max',
                        'fit'
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        $58783ce43eb3c126$var$isTshirtSize,
                        $58783ce43eb3c126$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        'thin',
                        'extralight',
                        'light',
                        'normal',
                        'medium',
                        'semibold',
                        'bold',
                        'extrabold',
                        'black',
                        $58783ce43eb3c126$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        $58783ce43eb3c126$var$isAny
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractions'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        'tighter',
                        'tight',
                        'normal',
                        'wide',
                        'wider',
                        'widest',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        'none',
                        $58783ce43eb3c126$var$isNumber,
                        $58783ce43eb3c126$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        'none',
                        'tight',
                        'snug',
                        'normal',
                        'relaxed',
                        'loose',
                        $58783ce43eb3c126$var$isLength,
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'none',
                        'disc',
                        'decimal',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ 'placeholder-opacity': [
                {
                    'placeholder-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ 'text-opacity': [
                {
                    'text-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: [
                        ...getLineStyles(),
                        'wavy'
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        'auto',
                        'from-font',
                        $58783ce43eb3c126$var$isLength,
                        $58783ce43eb3c126$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        'auto',
                        $58783ce43eb3c126$var$isLength,
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ 'bg-opacity': [
                {
                    'bg-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: [
                        ...getPositions(),
                        $58783ce43eb3c126$var$isArbitraryPosition
                    ]
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: [
                        'no-repeat',
                        {
                            repeat: [
                                '',
                                'x',
                                'y',
                                'round',
                                'space'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: [
                        'auto',
                        'cover',
                        'contain',
                        $58783ce43eb3c126$var$isArbitrarySize
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            'gradient-to': [
                                't',
                                'tr',
                                'r',
                                'br',
                                'b',
                                'bl',
                                'l',
                                'tl'
                            ]
                        },
                        $58783ce43eb3c126$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ 'border-opacity': [
                {
                    'border-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: [
                        ...getLineStyles(),
                        'hidden'
                    ]
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ 'divide-x': [
                {
                    'divide-x': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ 'divide-y': [
                {
                    'divide-y': [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ 'divide-opacity': [
                {
                    'divide-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ 'divide-style': [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-s': [
                {
                    'border-s': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-e': [
                {
                    'border-e': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: [
                        '',
                        ...getLineStyles()
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        $58783ce43eb3c126$var$isLength,
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        $58783ce43eb3c126$var$isLength,
                        $58783ce43eb3c126$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ 'ring-w': [
                {
                    ring: getLengthWithEmptyAndArbitrary()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ 'ring-color': [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ 'ring-opacity': [
                {
                    'ring-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        $58783ce43eb3c126$var$isLength,
                        $58783ce43eb3c126$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ 'ring-offset-color': [
                {
                    'ring-offset': [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        '',
                        'inner',
                        'none',
                        $58783ce43eb3c126$var$isTshirtSize,
                        $58783ce43eb3c126$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ 'shadow-color': [
                {
                    shadow: [
                        $58783ce43eb3c126$var$isAny
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': [
                        ...getBlendModes(),
                        'plus-lighter',
                        'plus-darker'
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        '',
                        'none'
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        '',
                        'none',
                        $58783ce43eb3c126$var$isTshirtSize,
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        '',
                        'none'
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        'none',
                        'all',
                        '',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'in',
                        'out',
                        'in-out',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        'spin',
                        'ping',
                        'pulse',
                        'bounce',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        '',
                        'gpu',
                        'none'
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        $58783ce43eb3c126$var$isInteger,
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: [
                        'center',
                        'top',
                        'top-right',
                        'right',
                        'bottom-right',
                        'bottom',
                        'bottom-left',
                        'left',
                        'top-left',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        'auto',
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        'y',
                        'x',
                        ''
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        $58783ce43eb3c126$var$isArbitraryValue
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        'none'
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        $58783ce43eb3c126$var$isLength,
                        $58783ce43eb3c126$var$isArbitraryLength,
                        $58783ce43eb3c126$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        'none'
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'right',
                'left'
            ],
            'inset-y': [
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'pr',
                'pl'
            ],
            py: [
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'mr',
                'ml'
            ],
            my: [
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-s',
                'border-w-e',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-s',
                'border-color-e',
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-t',
                'border-color-b'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        }
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const $58783ce43eb3c126$export$5d86b86a654a7039 = (baseConfig, { cacheSize: cacheSize, prefix: prefix, separator: separator, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} })=>{
    $58783ce43eb3c126$var$overrideProperty(baseConfig, 'cacheSize', cacheSize);
    $58783ce43eb3c126$var$overrideProperty(baseConfig, 'prefix', prefix);
    $58783ce43eb3c126$var$overrideProperty(baseConfig, 'separator', separator);
    $58783ce43eb3c126$var$overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    for(const configKey in override)$58783ce43eb3c126$var$overrideConfigProperties(baseConfig[configKey], override[configKey]);
    for(const key in extend)$58783ce43eb3c126$var$mergeConfigProperties(baseConfig[key], extend[key]);
    return baseConfig;
};
const $58783ce43eb3c126$var$overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const $58783ce43eb3c126$var$overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)$58783ce43eb3c126$var$overrideProperty(baseObject, key, overrideObject[key]);
};
const $58783ce43eb3c126$var$mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject){
        const mergeValue = mergeObject[key];
        if (mergeValue !== undefined) baseObject[key] = (baseObject[key] || []).concat(mergeValue);
    }
};
const $58783ce43eb3c126$export$c8d8406b6cd2243e = (configExtension, ...createConfig)=>typeof configExtension === 'function' ? $58783ce43eb3c126$export$ea2d4fba4d1bd27f($58783ce43eb3c126$export$ed30944e0fe6ae5c, configExtension, ...createConfig) : $58783ce43eb3c126$export$ea2d4fba4d1bd27f(()=>$58783ce43eb3c126$export$5d86b86a654a7039($58783ce43eb3c126$export$ed30944e0fe6ae5c(), configExtension), ...createConfig);
const $58783ce43eb3c126$export$b4660bb6000dfbc9 = /*#__PURE__*/ $58783ce43eb3c126$export$ea2d4fba4d1bd27f($58783ce43eb3c126$export$ed30944e0fe6ae5c);

});


parcelRegister("iUesJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc38aceacd32c739$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bh6RR = parcelRequire("bh6RR");

var $cIa9A = parcelRequire("cIa9A");

var $atyYq = parcelRequire("atyYq");
const $dc38aceacd32c739$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $bh6RR.forwardRef)(({ className: className, ...props }, ref)=>(0, $bh6RR.createElement)((0, $atyYq.default), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $cIa9A.mergeClasses)(`lucide-${(0, $cIa9A.toKebabCase)(iconName)}`, className),
            ...props
        }));
    Component.displayName = `${iconName}`;
    return Component;
};

});
parcelRegister("cIa9A", function(module, exports) {

$parcel$export(module.exports, "toKebabCase", function () { return $9411786a7b88786c$export$73bda83cddbc7187; });
$parcel$export(module.exports, "mergeClasses", function () { return $9411786a7b88786c$export$3d46f4579dba46e5; });
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $9411786a7b88786c$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $9411786a7b88786c$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();

});

parcelRegister("atyYq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a07bdd374c49cc2$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bh6RR = parcelRequire("bh6RR");

var $kgZRq = parcelRequire("kgZRq");

var $cIa9A = parcelRequire("cIa9A");
const $7a07bdd374c49cc2$export$2e2bcd8739ae039 = (0, $bh6RR.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    return (0, $bh6RR.createElement)("svg", {
        ref: ref,
        ...(0, $kgZRq.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $cIa9A.mergeClasses)("lucide", className),
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $bh6RR.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});

});
parcelRegister("kgZRq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec254981854797b3$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $ec254981854797b3$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

});



parcelRegister("qqvI6", function(module, exports) {

$parcel$export(module.exports, "schema", function () { return $e1b8934b4acbbdcd$export$4902baddc787debb; });
$parcel$export(module.exports, "initialState", function () { return $e1b8934b4acbbdcd$export$d4c72bab9d6cc13a; });

var $lk1iJ = parcelRequire("lk1iJ");
parcelRequire("9St7S");
var $60ukP = parcelRequire("60ukP");
var $llQUJ = parcelRequire("llQUJ");

var $jgRo0 = parcelRequire("jgRo0");
const $e1b8934b4acbbdcd$var$addYear = (0, (/*@__PURE__*/$parcel$interopDefault($lk1iJ)))(365);
const $e1b8934b4acbbdcd$var$defaultSettings = {
    examples: false,
    import: true,
    accounts: false,
    transactions: false,
    planning: true,
    financialindependence: false,
    flow: false,
    taxes: false
};
const $e1b8934b4acbbdcd$var$referenceDate = new Date();
const $e1b8934b4acbbdcd$var$defaultChartBarRange = {
    start: $e1b8934b4acbbdcd$var$referenceDate,
    end: $e1b8934b4acbbdcd$var$addYear($e1b8934b4acbbdcd$var$referenceDate)
};
const [$e1b8934b4acbbdcd$export$4902baddc787debb, $e1b8934b4acbbdcd$export$d4c72bab9d6cc13a] = (0, $60ukP.createSchema)({
    cache: (0, $llQUJ.slice).table({
        empty: {}
    }),
    loaders: (0, $llQUJ.slice).loaders(),
    auth: (0, $llQUJ.slice).obj({
        user: null
    }),
    settings: (0, $llQUJ.slice).obj($e1b8934b4acbbdcd$var$defaultSettings),
    transactions: (0, $llQUJ.slice).table({
        empty: (0, $jgRo0.emptyTransaction)
    }),
    accounts: (0, $llQUJ.slice).table({
        empty: (0, $jgRo0.emptyAccount)
    }),
    chartRange: (0, $llQUJ.slice).obj($e1b8934b4acbbdcd$var$defaultChartBarRange),
    incomeReceived: (0, $llQUJ.slice).table(),
    incomeExpected: (0, $llQUJ.slice).table()
});

});
parcelRegister("lk1iJ", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $f85c7997c5b64f1e$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f85c7997c5b64f1e$var$_index = $f85c7997c5b64f1e$require$_interopRequireDefault((parcelRequire("kPEam")));

var $f85c7997c5b64f1e$var$_index2 = $f85c7997c5b64f1e$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $f85c7997c5b64f1e$var$_default = (0, $f85c7997c5b64f1e$var$_index2.default)($f85c7997c5b64f1e$var$_index.default, 2);
module.exports.default = $f85c7997c5b64f1e$var$_default;
module.exports = module.exports.default;

});
parcelRegister("2ZnTs", function(module, exports) {
function $22d3d00379a62cb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $22d3d00379a62cb8$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kPEam", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $f2a7ba342d02a4d5$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2a7ba342d02a4d5$var$addDays;

var $f2a7ba342d02a4d5$var$_index = $f2a7ba342d02a4d5$require$_interopRequireDefault((parcelRequire("8WZx9")));

var $f2a7ba342d02a4d5$var$_index2 = $f2a7ba342d02a4d5$require$_interopRequireDefault((parcelRequire("99U8H")));

var $f2a7ba342d02a4d5$var$_index3 = $f2a7ba342d02a4d5$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $f2a7ba342d02a4d5$var$addDays(dirtyDate, dirtyAmount) {
    (0, $f2a7ba342d02a4d5$var$_index3.default)(2, arguments);
    var date = (0, $f2a7ba342d02a4d5$var$_index2.default)(dirtyDate);
    var amount = (0, $f2a7ba342d02a4d5$var$_index.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("8WZx9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $684378d1860d5f25$var$toInteger;
function $684378d1860d5f25$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("99U8H", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $6ab080651a5f52b8$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ab080651a5f52b8$var$toDate;

var $6ab080651a5f52b8$var$_typeof2 = $6ab080651a5f52b8$require$_interopRequireDefault((parcelRequire("crtHL")));

var $6ab080651a5f52b8$var$_index = $6ab080651a5f52b8$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $6ab080651a5f52b8$var$toDate(argument) {
    (0, $6ab080651a5f52b8$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $6ab080651a5f52b8$var$_typeof2.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("crtHL", function(module, exports) {
function $90ef0c6889924fa4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $90ef0c6889924fa4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $90ef0c6889924fa4$var$_typeof(o);
}
module.exports = $90ef0c6889924fa4$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kMAIB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f214c5d8a83db1e7$var$requiredArgs;
function $f214c5d8a83db1e7$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("jKO47", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $03b61542a2fc12cb$var$convertToFP;
function $03b61542a2fc12cb$var$convertToFP(fn, arity) {
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (a.length >= arity) return fn.apply(null, a.slice(0, arity).reverse());
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return $03b61542a2fc12cb$var$convertToFP(fn, arity, a.concat(args));
    };
}
module.exports = module.exports.default;

});


parcelRegister("9St7S", function(module, exports) {
$parcel$export(module.exports, "parallel", function () { return (parcelRequire("bXLEQ")).parallel; });
$parcel$export(module.exports, "createThunks", function () { return (parcelRequire("eGylm")).createThunks; });
$parcel$export(module.exports, "createLocalStorageAdapter", function () { return (parcelRequire("1lCWl")).createLocalStorageAdapter; });
$parcel$export(module.exports, "createPersistor", function () { return (parcelRequire("1lCWl")).createPersistor; });
$parcel$export(module.exports, "createSchema", function () { return (parcelRequire("60ukP")).createSchema; });
$parcel$export(module.exports, "createSelector", function () { return (parcelRequire("1rr1p")).createSelector; });
$parcel$export(module.exports, "createStore", function () { return (parcelRequire("kfNOd")).createStore; });
$parcel$export(module.exports, "PERSIST_LOADER_ID", function () { return (parcelRequire("1lCWl")).PERSIST_LOADER_ID; });
$parcel$export(module.exports, "persistStoreMdw", function () { return (parcelRequire("1lCWl")).persistStoreMdw; });
$parcel$export(module.exports, "select", function () { return (parcelRequire("eAyML")).select; });
$parcel$export(module.exports, "slice", function () { return (parcelRequire("llQUJ")).slice; });
$parcel$export(module.exports, "updateStore", function () { return (parcelRequire("eAyML")).updateStore; });
$parcel$export(module.exports, "mdw", function () { return (parcelRequire("aye7b")).mdw; });
$parcel$export(module.exports, "put", function () { return (parcelRequire("krVVU")).put; });
$parcel$export(module.exports, "take", function () { return (parcelRequire("krVVU")).take; });

$parcel$export(module.exports, "call", function () { return (parcelRequire("15Qbp")).call; });
$parcel$export(module.exports, "ensure", function () { return (parcelRequire("8Qg8J")).ensure; });
$parcel$export(module.exports, "Err", function () { return (parcelRequire("2EoHU")).Err; });
$parcel$export(module.exports, "Ok", function () { return (parcelRequire("2EoHU")).Ok; });
$parcel$export(module.exports, "resource", function () { return (parcelRequire("6wugg")).resource; });
parcelRequire("iUKqV");
parcelRequire("edM9Q");
parcelRequire("askiZ");
parcelRequire("zQfHN");
parcelRequire("aye7b");
parcelRequire("cSaCm");
parcelRequire("7ht0o");
parcelRequire("krVVU");
parcelRequire("8xJb2");
parcelRequire("c3MnJ");
var $15Qbp = parcelRequire("15Qbp");
var $8Qg8J = parcelRequire("8Qg8J");
var $2EoHU = parcelRequire("2EoHU");
var $6wugg = parcelRequire("6wugg");

});
parcelRegister("askiZ", function(module, exports) {

$parcel$export(module.exports, "createThunks", function () { return (parcelRequire("eGylm")).createThunks; });

var $eGylm = parcelRequire("eGylm");
parcelRequire("7SGTO");
parcelRequire("9sCIU");
parcelRequire("6Jz6i");
const $79cc451e05bf994c$export$a504d53a5b99e1b9 = (0, $eGylm.createThunks);

});
parcelRegister("eGylm", function(module, exports) {

$parcel$export(module.exports, "createThunks", function () { return $ab0fa0da96a5cb02$export$54caf29b17528115; });

var $krVVU = parcelRequire("krVVU");

var $7ht0o = parcelRequire("7ht0o");
parcelRequire("c3MnJ");
var $8Qg8J = parcelRequire("8Qg8J");
var $2EoHU = parcelRequire("2EoHU");
parcelRequire("edM9Q");
var $11819 = parcelRequire("11819");

var $kfNOd = parcelRequire("kfNOd");

var $6Jz6i = parcelRequire("6Jz6i");

var $8DZSE = parcelRequire("8DZSE");
let $ab0fa0da96a5cb02$var$id = 0;
function $ab0fa0da96a5cb02$export$54caf29b17528115({ supervisor: supervisor = (0, $krVVU.takeEvery) } = {
    supervisor: (0, $krVVU.takeEvery)
}) {
    let signal = undefined;
    let storeId = undefined;
    const middleware = [];
    const visors = {};
    const middlewareMap = {};
    let dynamicMiddlewareMap = {};
    const actionMap = {};
    const thunkId = $ab0fa0da96a5cb02$var$id++;
    const storeMap = new Map();
    function* defaultMiddleware(_, next) {
        yield* next();
    }
    const createType = (post)=>`${0, $krVVU.API_ACTION_PREFIX}${post}`;
    function* onApi(action) {
        const { name: name, key: key, options: options } = action.payload;
        const actionFn = actionMap[name];
        const ctx = {
            action: action,
            name: name,
            key: key,
            payload: options,
            actionFn: actionFn,
            result: (0, $2EoHU.Ok)(undefined)
        };
        const fn = (0, $7ht0o.compose)(middleware);
        yield* fn(ctx);
        return ctx;
    }
    function create(name, ...args) {
        if (Object.hasOwn(visors, name)) {
            const msg = `[${name}] already exists, do you have two thunks with the same name?`;
            console.warn(msg);
        }
        const type = createType(name);
        const action = (payload)=>{
            return {
                type: type,
                payload: payload
            };
        };
        let req = null;
        let fn = null;
        if (args.length === 2) {
            req = args[0];
            fn = args[1];
        }
        if (args.length === 1) {
            if ((0, $8DZSE.isFn)(args[0]) || Array.isArray(args[0])) fn = args[0];
            else req = args[0];
        }
        if (req && !(0, $8DZSE.isObject)(req)) throw new Error("Options must be an object");
        if (fn && Array.isArray(fn)) fn = (0, $7ht0o.compose)(fn);
        if (fn && !(0, $8DZSE.isFn)(fn)) throw new Error("Middleware must be a function");
        middlewareMap[name] = fn || defaultMiddleware;
        const tt = req ? req.supervisor : supervisor;
        function* curVisor() {
            yield* tt(type, onApi);
        }
        visors[name] = curVisor;
        // If signal is already referenced, register immediately, otherwise defer
        for (const [storeId, storeSignal] of storeMap.entries())storeSignal.send({
            type: `${(0, $krVVU.API_ACTION_PREFIX)}REGISTER_THUNK_${storeId}_${thunkId}`,
            payload: curVisor
        });
        const errMsg = `[${name}] is being called before its thunk has been registered. ` + "Run `store.run(thunks.register)` where `thunks` is the name of your `createThunks` or `createApi` variable.";
        const actionFn = (options)=>{
            if (!signal) console.warn(errMsg);
            const key = (0, $6Jz6i.createKey)(name, options);
            return action({
                name: name,
                key: key,
                options: options
            });
        };
        actionFn.run = (action)=>{
            if (action && Object.hasOwn(action, "type")) return onApi(action);
            return onApi(actionFn(action));
        };
        actionFn.use = (fn)=>{
            const cur = middlewareMap[name];
            if (cur) dynamicMiddlewareMap[name] = (0, $7ht0o.compose)([
                cur,
                fn
            ]);
            else dynamicMiddlewareMap[name] = fn;
        };
        actionFn.toString = ()=>type;
        actionFn._success = {};
        actionFn._error = {};
        actionMap[name] = actionFn;
        return actionFn;
    }
    function* watcher(action) {
        yield* (0, $11819.supervise)(action.payload)();
    }
    function* register() {
        storeId = yield* (0, $kfNOd.IdContext);
        if (storeId && storeMap.has(storeId)) {
            console.warn("This thunk instance is already registered.");
            return;
        }
        signal = yield* (0, $krVVU.ActionContext);
        storeMap.set(storeId, signal);
        yield* (0, $8Qg8J.ensure)(function*() {
            if (storeId) storeMap.delete(storeId);
        });
        // Register any thunks created after signal is available
        yield* (0, $11819.keepAlive)(Object.values(visors));
        // Spawn a watcher for further thunk matchingPairs
        yield* (0, $krVVU.takeEvery)(`${(0, $krVVU.API_ACTION_PREFIX)}REGISTER_THUNK_${storeId}_${thunkId}`, watcher);
    }
    function routes() {
        function* router(ctx, next) {
            const match = dynamicMiddlewareMap[ctx.name] || middlewareMap[ctx.name];
            if (!match) {
                yield* next();
                return;
            }
            const result = yield* match(ctx, next);
            return result;
        }
        return router;
    }
    function resetMdw() {
        dynamicMiddlewareMap = {};
    }
    return {
        use: (fn)=>{
            middleware.push(fn);
        },
        create: create,
        routes: routes,
        /**
         * @deprecated use `register()` instead
         */ bootup: register,
        reset: resetMdw,
        register: register
    };
}

});
parcelRegister("6Jz6i", function(module, exports) {

$parcel$export(module.exports, "createKey", function () { return $4e722c42d44efcdd$export$e2280c1995141b13; });

var $8DZSE = parcelRequire("8DZSE");
// deno-lint-ignore no-explicit-any
const $4e722c42d44efcdd$var$deepSortObject = (opts)=>{
    if (!(0, $8DZSE.isObject)(opts)) return opts;
    return Object.keys(opts).sort().reduce((res, key)=>{
        res[`${key}`] = opts[key];
        if (opts[key] && (0, $8DZSE.isObject)(opts[key])) res[`${key}`] = $4e722c42d44efcdd$var$deepSortObject(opts[key]);
        return res;
    }, {});
};
function $4e722c42d44efcdd$var$padStart(hash, len) {
    while(hash.length < len)hash = "0" + hash;
    return hash;
}
// https://gist.github.com/iperelivskiy/4110988
const $4e722c42d44efcdd$var$tinySimpleHash = (s)=>{
    let h = 9;
    for(let i = 0; i < s.length;)h = Math.imul(h ^ s.charCodeAt(i++), 9 ** 9);
    return h ^ h >>> 9;
};
const $4e722c42d44efcdd$export$e2280c1995141b13 = (name, payload)=>{
    const normJsonString = typeof payload !== "undefined" ? JSON.stringify($4e722c42d44efcdd$var$deepSortObject(payload)) : "";
    const hash = normJsonString ? $4e722c42d44efcdd$var$padStart($4e722c42d44efcdd$var$tinySimpleHash(normJsonString).toString(16), 8) : "";
    return hash ? `${name}|${hash}` : name;
};

});
parcelRegister("8DZSE", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $64b1f76542075641$export$8793edee2d425525; });
$parcel$export(module.exports, "isFn", function () { return $64b1f76542075641$export$8ca3e64ec0f98f12; });
$parcel$export(module.exports, "isObject", function () { return $64b1f76542075641$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "mergeRequest", function () { return $64b1f76542075641$export$f81908f47e085928; });
function* $64b1f76542075641$export$8793edee2d425525() {}
const $64b1f76542075641$export$8ca3e64ec0f98f12 = (fn)=>fn && typeof fn === "function";
const $64b1f76542075641$export$a6cdc56e425d0d0a = (obj)=>typeof obj === "object" && obj !== null;
const $64b1f76542075641$export$eee1781d075786ae = (cur, next)=>{
    if (!cur && !next) return {};
    if (!cur && next) return next;
    if (cur && !next) return cur;
    return {
        ...cur,
        ...next
    };
};
const $64b1f76542075641$export$f81908f47e085928 = (cur, next)=>{
    const defaultReq = {
        url: "",
        method: "GET",
        headers: $64b1f76542075641$export$eee1781d075786ae()
    };
    if (!cur && !next) return {
        ...defaultReq,
        headers: $64b1f76542075641$export$eee1781d075786ae()
    };
    if (!cur && next) return {
        ...defaultReq,
        ...next
    };
    if (cur && !next) return {
        ...defaultReq,
        ...cur
    };
    return {
        ...defaultReq,
        ...cur,
        ...next,
        headers: $64b1f76542075641$export$eee1781d075786ae(cur?.headers, next?.headers)
    };
};

});



parcelRegister("7SGTO", function(module, exports) {

var $eGylm = parcelRequire("eGylm");
function $5bceda7275b38ebc$export$9cdc2b9a8d94c842(baseThunk) {
    const thunks = baseThunk || (0, $eGylm.createThunks)();
    const uri = (prename)=>{
        const create = thunks.create;
        let name = prename;
        let remainder = "";
        if (Array.isArray(name)) {
            if (name.length === 0) throw new Error("createApi requires a non-empty array for the name of the endpoint");
            name = prename[0];
            if (name.length > 1) {
                const [_, ...other] = prename;
                remainder = ` ${other.join("|")}`;
            }
        }
        const tmpl = (method)=>`${name} [${method}]${remainder}`;
        return {
            get: (...args)=>create(tmpl("GET"), ...args),
            post: (...args)=>create(tmpl("POST"), ...args),
            put: (...args)=>create(tmpl("PUT"), ...args),
            patch: (...args)=>create(tmpl("PATCH"), ...args),
            delete: (...args)=>create(tmpl("DELETE"), ...args),
            options: (...args)=>create(tmpl("OPTIONS"), ...args),
            head: (...args)=>create(tmpl("HEAD"), ...args),
            connect: (...args)=>create(tmpl("CONNECT"), ...args),
            trace: (...args)=>create(tmpl("TRACE"), ...args)
        };
    };
    return {
        use: thunks.use,
        /**
         * @deprecated use `register()` instead
         */ bootup: thunks.register,
        register: thunks.register,
        create: thunks.create,
        routes: thunks.routes,
        reset: thunks.reset,
        cache: ()=>{
            return function* onCache(ctx, next) {
                ctx.cache = true;
                yield* next();
            };
        },
        request: (req)=>{
            return function* onRequest(ctx, next) {
                ctx.request = ctx.req(req);
                yield* next();
            };
        },
        uri: uri,
        get: (name, ...args)=>uri(name).get(...args),
        post: (name, ...args)=>uri(name).post(...args),
        put: (name, ...args)=>uri(name).put(...args),
        patch: (name, ...args)=>uri(name).patch(...args),
        delete: (name, ...args)=>uri(name).delete(...args),
        options: (name, ...args)=>uri(name).options(...args),
        head: (name, ...args)=>uri(name).head(...args),
        connect: (name, ...args)=>uri(name).connect(...args),
        trace: (name, ...args)=>uri(name).trace(...args)
    };
}

});

parcelRegister("9sCIU", function(module, exports) {

});


parcelRegister("aye7b", function(module, exports) {

$parcel$export(module.exports, "mdw", function () { return $7ae8074467c95beb$export$f404c74d7072cf49; });

var $8PEvk = parcelRequire("8PEvk");

var $deRq2 = parcelRequire("deRq2");
const $7ae8074467c95beb$export$f404c74d7072cf49 = {
    ...$8PEvk,
    ...$deRq2
};

});
parcelRegister("8PEvk", function(module, exports) {

$parcel$export(module.exports, "err", function () { return $66e281734d2e07e6$export$8048b892d651b310; });
$parcel$export(module.exports, "customKey", function () { return $66e281734d2e07e6$export$630d68c9c7797604; });
$parcel$export(module.exports, "queryCtx", function () { return $66e281734d2e07e6$export$99bd6deee5428227; });
$parcel$export(module.exports, "actions", function () { return $66e281734d2e07e6$export$e324594224ef24da; });
$parcel$export(module.exports, "perf", function () { return $66e281734d2e07e6$export$c6cae3b10bb768dc; });
$parcel$export(module.exports, "fetch", function () { return $66e281734d2e07e6$export$e7aa7bc5c1b3cfb3; });
$parcel$export(module.exports, "predicate", function () { return $66e281734d2e07e6$export$5fc51e445ce24faf; });
parcelRequire("edM9Q");
var $3Z7bJ = parcelRequire("3Z7bJ");

var $7ht0o = parcelRequire("7ht0o");

var $8DZSE = parcelRequire("8DZSE");

var $kJV4W = parcelRequire("kJV4W");
parcelRequire("c3MnJ");
var $15Qbp = parcelRequire("15Qbp");

var $krVVU = parcelRequire("krVVU");
function* $66e281734d2e07e6$export$8048b892d651b310(ctx, next) {
    ctx.result = yield* (0, $3Z7bJ.safe)(next);
    if (!ctx.result.ok) {
        const message = `Error: ${ctx.result.error.message}.  Check the endpoint [${ctx.name}]`;
        console.error(message, ctx);
        yield* (0, $krVVU.put)({
            type: "error:query",
            payload: {
                message: message,
                ctx: ctx
            }
        });
    }
}
function* $66e281734d2e07e6$export$630d68c9c7797604(ctx, next) {
    if (ctx?.key && ctx?.action?.payload?.key && ctx.key !== ctx.action.payload.key) {
        const newKey = ctx.name.split("|")[0] + "|" + ctx.key;
        ctx.key = newKey;
        ctx.action.payload.key = newKey;
    }
    yield* next();
}
function* $66e281734d2e07e6$export$99bd6deee5428227(ctx, next) {
    if (!ctx.req) ctx.req = (r)=>(0, $8DZSE.mergeRequest)(ctx.request, r);
    if (!ctx.request) ctx.request = ctx.req();
    if (!ctx.response) ctx.response = null;
    if (!ctx.json) ctx.json = {
        ok: false,
        error: {}
    };
    if (!ctx.actions) ctx.actions = [];
    if (!ctx.bodyType) ctx.bodyType = "json";
    yield* next();
}
function* $66e281734d2e07e6$export$e324594224ef24da(ctx, next) {
    if (!ctx.actions) ctx.actions = [];
    yield* next();
    if (ctx.actions.length === 0) return;
    yield* (0, $krVVU.put)(ctx.actions);
}
function* $66e281734d2e07e6$export$c6cae3b10bb768dc(ctx, next) {
    const t0 = performance.now();
    yield* next();
    const t1 = performance.now();
    ctx.performance = t1 - t0;
}
function $66e281734d2e07e6$export$e7aa7bc5c1b3cfb3({ baseUrl: baseUrl = "" } = {
    baseUrl: ""
}) {
    return (0, $7ht0o.compose)([
        $kJV4W.composeUrl(baseUrl),
        $kJV4W.payload,
        $kJV4W.request,
        $kJV4W.json
    ]);
}
function $66e281734d2e07e6$export$5fc51e445ce24faf(predicate) {
    return (mdw)=>{
        return function*(ctx, next) {
            const valid = yield* (0, $15Qbp.call)(()=>predicate(ctx));
            if (!valid) {
                yield* next();
                return;
            }
            yield* mdw(ctx, next);
        };
    };
}
$parcel$exportWildcard(module.exports, $kJV4W);

});
parcelRegister("kJV4W", function(module, exports) {

$parcel$export(module.exports, "nameParser", function () { return $f194493dc142a363$export$bd82084565fd3254; });
$parcel$export(module.exports, "headers", function () { return $f194493dc142a363$export$838e2a576d4d6ff6; });
$parcel$export(module.exports, "json", function () { return $f194493dc142a363$export$7b419323e6ed4f31; });
$parcel$export(module.exports, "composeUrl", function () { return $f194493dc142a363$export$e9f6bf8cdc487328; });
$parcel$export(module.exports, "payload", function () { return $f194493dc142a363$export$5e805c3762185b4c; });
$parcel$export(module.exports, "response", function () { return $f194493dc142a363$export$785bb8ef7fad1f74; });
$parcel$export(module.exports, "request", function () { return $f194493dc142a363$export$b5fe3f66a567bec0; });
$parcel$export(module.exports, "fetchRetry", function () { return $f194493dc142a363$export$782df2acbe10b22c; });
parcelRequire("c3MnJ");
var $4PPHq = parcelRequire("4PPHq");
parcelRequire("edM9Q");
var $3Z7bJ = parcelRequire("3Z7bJ");

var $8DZSE = parcelRequire("8DZSE");
function* $f194493dc142a363$export$bd82084565fd3254(ctx, next) {
    const httpMethods = [
        "get",
        "head",
        "post",
        "put",
        "delete",
        "connect",
        "options",
        "trace",
        "patch"
    ];
    const options = ctx.payload || {};
    if (!(0, $8DZSE.isObject)(options)) {
        yield* next();
        return;
    }
    let url = Object.keys(options).reduce((acc, key)=>{
        return acc.replace(`:${key}`, options[key]);
    }, ctx.name);
    let method = "";
    httpMethods.forEach((curMethod)=>{
        const pattern = new RegExp(`\\s*\\[` + curMethod + `\\]\\s*\\w*`, "i");
        const tmpUrl = url.replace(pattern, "");
        if (tmpUrl.length !== url.length) method = curMethod.toLocaleUpperCase();
        url = tmpUrl;
    }, url);
    if (ctx.req().url === "") ctx.request = ctx.req({
        url: url
    });
    if (method) ctx.request = ctx.req({
        method: method
    });
    yield* next();
}
function* $f194493dc142a363$export$838e2a576d4d6ff6(ctx, next) {
    if (!ctx.request) {
        yield* next();
        return;
    }
    const cur = ctx.req();
    if (!Object.hasOwn(cur.headers, "Content-Type")) ctx.request = ctx.req({
        headers: {
            "Content-Type": "application/json"
        }
    });
    yield* next();
}
function* $f194493dc142a363$export$7b419323e6ed4f31(ctx, next) {
    if (!ctx.response) {
        yield* next();
        return;
    }
    if (ctx.response.status === 204) {
        ctx.json = {
            ok: true,
            value: {}
        };
        yield* next();
        return;
    }
    const data = yield* (0, $3Z7bJ.safe)(()=>{
        const resp = ctx.response;
        if (!resp) throw new Error("response is falsy");
        return resp[ctx.bodyType]();
    });
    if (data.ok) {
        if (ctx.response.ok) ctx.json = {
            ok: true,
            value: data.value
        };
        else ctx.json = {
            ok: false,
            error: data.value
        };
    } else {
        const dta = {
            message: data.error.message
        };
        ctx.json = {
            ok: false,
            error: dta
        };
    }
    yield* next();
}
function $f194493dc142a363$export$e9f6bf8cdc487328(baseUrl = "") {
    return function*(ctx, next) {
        const req = ctx.req();
        ctx.request = ctx.req({
            url: `${baseUrl}${req.url}`
        });
        yield* next();
    };
}
function* $f194493dc142a363$export$5e805c3762185b4c(ctx, next) {
    const payload = ctx.payload;
    if (!payload) {
        yield* next();
        return;
    }
    const keys = Object.keys(payload);
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        if (!ctx.name.includes(`:${key}`)) continue;
        const val = payload[key];
        if (!val) {
            const data = `found :${key} in endpoint name (${ctx.name}) but payload has falsy value (${val})`;
            ctx.json = {
                ok: false,
                error: data
            };
            return;
        }
    }
    yield* next();
}
function $f194493dc142a363$export$785bb8ef7fad1f74(response) {
    return function* responseMdw(ctx, next) {
        if (response) ctx.response = response;
        yield* next();
    };
}
function* $f194493dc142a363$export$b5fe3f66a567bec0(ctx, next) {
    // if there is already a response then we want to bail so we don't
    // override it.
    if (ctx.response) {
        yield* next();
        return;
    }
    const { url: url, ...req } = ctx.req();
    const request = new Request(url, req);
    const result = yield* (0, $3Z7bJ.safe)(fetch(request));
    if (result.ok) ctx.response = result.value;
    else throw result.error;
    yield* next();
}
function $f194493dc142a363$var$backoffExp(attempt) {
    if (attempt > 5) return -1;
    // 1s, 1s, 1s, 2s, 4s
    return Math.max(2 ** attempt * 125, 1000);
}
function $f194493dc142a363$export$782df2acbe10b22c(backoff = $f194493dc142a363$var$backoffExp) {
    return function*(ctx, next) {
        yield* next();
        if (!ctx.response) return;
        if (ctx.response.ok) return;
        let attempt = 1;
        let waitFor = backoff(attempt);
        while(waitFor >= 1){
            yield* (0, $4PPHq.sleep)(waitFor);
            // reset response so `request` mdw actually runs
            ctx.response = null;
            yield* (0, $3Z7bJ.safe)(()=>$f194493dc142a363$export$b5fe3f66a567bec0(ctx, (0, $8DZSE.noop)));
            yield* (0, $3Z7bJ.safe)(()=>$f194493dc142a363$export$7b419323e6ed4f31(ctx, (0, $8DZSE.noop)));
            if (ctx.response && ctx.response.ok) return;
            attempt += 1;
            waitFor = backoff(attempt);
        }
    };
}

});


parcelRegister("deRq2", function(module, exports) {

$parcel$export(module.exports, "api", function () { return $9a360515259d3307$export$644d8ea042df96a6; });
$parcel$export(module.exports, "loaderApi", function () { return $9a360515259d3307$export$fe23da0ba15bd37; });
$parcel$export(module.exports, "cache", function () { return $9a360515259d3307$export$69a3209f1a06c04d; });
$parcel$export(module.exports, "loader", function () { return $9a360515259d3307$export$f4c5de44377d2946; });

var $7ht0o = parcelRequire("7ht0o");
parcelRequire("zQfHN");
var $eAyML = parcelRequire("eAyML");

var $8PEvk = parcelRequire("8PEvk");

var $kJV4W = parcelRequire("kJV4W");
function $9a360515259d3307$export$644d8ea042df96a6(props) {
    return (0, $7ht0o.compose)([
        (0, $8PEvk.err),
        (0, $8PEvk.actions),
        (0, $8PEvk.queryCtx),
        (0, $8PEvk.customKey),
        (0, $kJV4W.nameParser),
        $9a360515259d3307$export$fe23da0ba15bd37(props),
        $9a360515259d3307$export$69a3209f1a06c04d(props.schema)
    ]);
}
function $9a360515259d3307$export$69a3209f1a06c04d(schema) {
    return function* cache(ctx, next) {
        ctx.cacheData = yield* (0, $eAyML.select)(schema.cache.selectById, {
            id: ctx.key
        });
        yield* next();
        if (!ctx.cache) return;
        let data;
        if (ctx.json.ok) data = ctx.json.value;
        else data = ctx.json.error;
        yield* (0, $eAyML.updateStore)(schema.cache.add({
            [ctx.key]: data
        }));
        ctx.cacheData = data;
    };
}
function $9a360515259d3307$export$f4c5de44377d2946(schema) {
    return function*(ctx, next) {
        yield* (0, $eAyML.updateStore)([
            schema.loaders.start({
                id: ctx.name
            }),
            schema.loaders.start({
                id: ctx.key
            })
        ]);
        if (!ctx.loader) ctx.loader = {};
        try {
            yield* next();
            if (!ctx.loader) ctx.loader = {};
            yield* (0, $eAyML.updateStore)([
                schema.loaders.success({
                    id: ctx.name,
                    ...ctx.loader
                }),
                schema.loaders.success({
                    id: ctx.key,
                    ...ctx.loader
                })
            ]);
        } catch (err) {
            if (!ctx.loader) ctx.loader = {};
            yield* (0, $eAyML.updateStore)([
                schema.loaders.error({
                    id: ctx.name,
                    message: err.message,
                    ...ctx.loader
                }),
                schema.loaders.error({
                    id: ctx.key,
                    message: err.message,
                    ...ctx.loader
                })
            ]);
        } finally{
            const loaders = yield* (0, $eAyML.select)((s)=>schema.loaders.selectByIds(s, {
                    ids: [
                        ctx.name,
                        ctx.key
                    ]
                }));
            const ids = loaders.filter((loader)=>loader.status === "loading").map((loader)=>loader.id);
            if (ids.length > 0) yield* (0, $eAyML.updateStore)(schema.loaders.resetByIds(ids));
        }
    };
}
function $9a360515259d3307$var$defaultErrorFn(ctx) {
    const jso = ctx.json;
    if (jso.ok) return "";
    return jso.error?.message || "";
}
function $9a360515259d3307$export$fe23da0ba15bd37({ schema: schema, errorFn: errorFn = $9a360515259d3307$var$defaultErrorFn }) {
    return function* trackLoading(ctx, next) {
        try {
            yield* (0, $eAyML.updateStore)([
                schema.loaders.start({
                    id: ctx.name
                }),
                schema.loaders.start({
                    id: ctx.key
                })
            ]);
            if (!ctx.loader) ctx.loader = {};
            yield* next();
            if (!ctx.response) {
                yield* (0, $eAyML.updateStore)(schema.loaders.resetByIds([
                    ctx.name,
                    ctx.key
                ]));
                return;
            }
            if (!ctx.loader) ctx.loader = {};
            if (!ctx.response.ok) {
                yield* (0, $eAyML.updateStore)([
                    schema.loaders.error({
                        id: ctx.name,
                        message: errorFn(ctx),
                        ...ctx.loader
                    }),
                    schema.loaders.error({
                        id: ctx.key,
                        message: errorFn(ctx),
                        ...ctx.loader
                    })
                ]);
                return;
            }
            yield* (0, $eAyML.updateStore)([
                schema.loaders.success({
                    id: ctx.name,
                    ...ctx.loader
                }),
                schema.loaders.success({
                    id: ctx.key,
                    ...ctx.loader
                })
            ]);
        } catch (err) {
            const message = err?.message || "unknown exception";
            yield* (0, $eAyML.updateStore)([
                schema.loaders.error({
                    id: ctx.name,
                    message: message,
                    ...ctx.loader
                }),
                schema.loaders.error({
                    id: ctx.key,
                    message: message,
                    ...ctx.loader
                })
            ]);
        } finally{
            const loaders = yield* (0, $eAyML.select)((s)=>schema.loaders.selectByIds(s, {
                    ids: [
                        ctx.name,
                        ctx.key
                    ]
                }));
            const ids = loaders.filter((loader)=>loader.status === "loading").map((loader)=>loader.id);
            yield* (0, $eAyML.updateStore)(schema.loaders.resetByIds(ids));
        }
    };
}

});


parcelRegister("cSaCm", function(module, exports) {

});

parcelRegister("8xJb2", function(module, exports) {

var $krVVU = parcelRequire("krVVU");
parcelRequire("c3MnJ");
var $15Qbp = parcelRequire("15Qbp");
var $j6X2g = parcelRequire("j6X2g");
var $4PPHq = parcelRequire("4PPHq");
var $6wugg = parcelRequire("6wugg");
const $63847305ad07cb93$var$MS = 1000;
const $63847305ad07cb93$var$SECONDS = 1 * $63847305ad07cb93$var$MS;
const $63847305ad07cb93$var$MINUTES = 60 * $63847305ad07cb93$var$SECONDS;
function $63847305ad07cb93$export$e0c10349b2c5e1d4(parentTimer = 5 * $63847305ad07cb93$var$SECONDS, cancelType) {
    return function* poller(actionType, op) {
        const cancel = cancelType || actionType;
        function* fire(action, timer) {
            while(true){
                yield* op(action);
                yield* (0, $4PPHq.sleep)(timer);
            }
        }
        while(true){
            const action = yield* (0, $krVVU.take)(actionType);
            const timer = action.payload?.timer || parentTimer;
            yield* (0, $j6X2g.race)([
                fire(action, timer),
                (0, $krVVU.take)(`${cancel}`)
            ]);
        }
    };
}
const $63847305ad07cb93$export$469d51fb8d268227 = (0, $krVVU.createAction)("clear-timers");
function $63847305ad07cb93$export$9dc4ecf953986f04(timer1 = 5 * $63847305ad07cb93$var$MINUTES) {
    return function* onTimer(actionType, op) {
        const map = {};
        function* activate(action) {
            yield* (0, $15Qbp.call)(()=>op(action));
            const idA = (0, $krVVU.getIdFromAction)(action);
            const matchFn = (act)=>{
                if (act.type !== `${$63847305ad07cb93$export$469d51fb8d268227}`) return false;
                if (!act.payload) return false;
                const ids = Array.isArray(act.payload) ? act.payload : [
                    act.payload
                ];
                return ids.some((id)=>{
                    if (id === "*") return true;
                    if (typeof id === "string") return idA === id;
                    else return idA === (0, $krVVU.getIdFromAction)(id);
                });
            };
            yield* (0, $j6X2g.race)([
                (0, $4PPHq.sleep)(timer1),
                (0, $krVVU.take)(matchFn)
            ]);
            delete map[action.payload.key];
        }
        while(true){
            const action = yield* (0, $krVVU.take)(`${actionType}`);
            const key = action.payload.key;
            if (!map[key]) {
                const task = yield* (0, $6wugg.spawn)(function*() {
                    yield* activate(action);
                });
                map[key] = task;
            }
        }
    };
}

});


parcelRegister("jgRo0", function(module, exports) {

$parcel$export(module.exports, "emptyAccount", function () { return $4262236d7ee18f1e$export$6358d1c404871453; });
$parcel$export(module.exports, "emptyTransaction", function () { return $4262236d7ee18f1e$export$23ace8c6513ad25; });

var $8xOSr = parcelRequire("8xOSr");

var $6HqIz = parcelRequire("6HqIz");
const $4262236d7ee18f1e$export$6358d1c404871453 = {
    id: 'initial',
    name: 'initial',
    starting: (0, $6HqIz.dinero)({
        amount: 0,
        currency: (0, $8xOSr.USD)
    }),
    interest: {
        amount: 0,
        scale: 1
    },
    vehicle: 'operating'
};
const $4262236d7ee18f1e$export$23ace8c6513ad25 = {
    id: '0',
    valueType: 'static',
    raccount: '',
    description: '',
    category: 'job',
    type: 'income',
    start: '',
    ending: '',
    rtype: '',
    cycle: 0,
    value: (0, $6HqIz.dinero)({
        amount: 0,
        currency: (0, $8xOSr.USD)
    }),
    occurrences: 0,
    beginAfterOccurrences: 0,
    dailyRate: (0, $6HqIz.dinero)({
        amount: 0,
        currency: (0, $8xOSr.USD)
    })
};

});
parcelRegister("8xOSr", function(module, exports) {

$parcel$export(module.exports, "USD", function () { return $6388dee96bd715d3$export$21abe75bbf5aa63c; });
/**
 * United States dollar.
 */ var $6388dee96bd715d3$export$21abe75bbf5aa63c = {
    code: 'USD',
    base: 10,
    exponent: 2
};

});

parcelRegister("6HqIz", function(module, exports) {

$parcel$export(module.exports, "dinero", function () { return $4e0b7bda4ea2078f$export$d19701748df0f687; });
/* eslint-disable functional/no-expression-statement */ 
var $935TU = parcelRequire("935TU");

var $17TDA = parcelRequire("17TDA");
var $baeIf = parcelRequire("baeIf");
var $3GfaA = parcelRequire("3GfaA");
var $4e0b7bda4ea2078f$export$d19701748df0f687 = (0, $baeIf.createDinero)({
    calculator: (0, $935TU.calculator),
    onCreate: function onCreate(_ref) {
        var amount = _ref.amount, scale = _ref.scale;
        (0, $17TDA.assert)(Number.isInteger(amount), (0, $3GfaA.INVALID_AMOUNT_MESSAGE));
        (0, $17TDA.assert)(Number.isInteger(scale), (0, $3GfaA.INVALID_SCALE_MESSAGE));
    }
});

});
parcelRegister("935TU", function(module, exports) {

$parcel$export(module.exports, "calculator", function () { return $6968f8a0c50a9b94$export$25f84be31b76e92; });

var $1eIYp = parcelRequire("1eIYp");
var $169Ca = parcelRequire("169Ca");
var $bA9It = parcelRequire("bA9It");
var $dobOb = parcelRequire("dobOb");
var $gSEX8 = parcelRequire("gSEX8");
var $1et4c = parcelRequire("1et4c");
var $82TNn = parcelRequire("82TNn");
var $7uSXO = parcelRequire("7uSXO");
var $i2dEm = parcelRequire("i2dEm");
var $jHVe0 = parcelRequire("jHVe0");
var $6968f8a0c50a9b94$export$25f84be31b76e92 = {
    add: (0, $1eIYp.add),
    compare: (0, $169Ca.compare),
    decrement: (0, $bA9It.decrement),
    increment: (0, $dobOb.increment),
    integerDivide: (0, $gSEX8.integerDivide),
    modulo: (0, $1et4c.modulo),
    multiply: (0, $82TNn.multiply),
    power: (0, $7uSXO.power),
    subtract: (0, $i2dEm.subtract),
    zero: (0, $jHVe0.zero)
};

});
parcelRegister("1eIYp", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $0e69fbfe611ab0d8$export$e16d8520af44a096; });
/**
 * Returns the sum of two numbers.
 *
 * @param augend - The number to add to.
 * @param addend - The number to add.
 *
 * @returns The sum of the two numbers.
 */ var $0e69fbfe611ab0d8$export$e16d8520af44a096 = function add(augend, addend) {
    return augend + addend;
};

});

parcelRegister("169Ca", function(module, exports) {

$parcel$export(module.exports, "compare", function () { return $0ccdcf41b2dba7a1$export$398604a469f7de9a; });

var $h378L = parcelRequire("h378L");
var $0ccdcf41b2dba7a1$export$398604a469f7de9a = function compare(a, b) {
    if (a < b) return (0, $h378L.ComparisonOperator).LT;
    if (a > b) return (0, $h378L.ComparisonOperator).GT;
    return (0, $h378L.ComparisonOperator).EQ;
};

});
parcelRegister("h378L", function(module, exports) {

$parcel$export(module.exports, "ComparisonOperator", function () { return $c6984166dce32e3f$export$e99d6c94ff657bc9; });
/* eslint-disable functional/no-mixed-type */ var $c6984166dce32e3f$export$e99d6c94ff657bc9;
(function(ComparisonOperator) {
    ComparisonOperator[ComparisonOperator["LT"] = -1] = "LT";
    ComparisonOperator[ComparisonOperator["EQ"] = 0] = "EQ";
    ComparisonOperator[ComparisonOperator["GT"] = 1] = "GT";
})($c6984166dce32e3f$export$e99d6c94ff657bc9 || ($c6984166dce32e3f$export$e99d6c94ff657bc9 = {}));

});


parcelRegister("bA9It", function(module, exports) {

$parcel$export(module.exports, "decrement", function () { return $86ea97f331747ee1$export$8f85cc9753f280aa; });
/**
 * Returns an decremented number.
 *
 * @param value - The number to decrement.
 *
 * @returns The decremented number.
 */ var $86ea97f331747ee1$export$8f85cc9753f280aa = function decrement(value) {
    return value - 1;
};

});

parcelRegister("dobOb", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $9bf6ad22796ad253$export$a2647aa13413c947; });
/**
 * Returns an incremented number.
 *
 * @param value - The number to increment.
 *
 * @returns The incremented number.
 */ var $9bf6ad22796ad253$export$a2647aa13413c947 = function increment(value) {
    return value + 1;
};

});

parcelRegister("gSEX8", function(module, exports) {

$parcel$export(module.exports, "integerDivide", function () { return $c4a174d51abe8aaa$export$e466e21ee5950aaf; });
/**
 * Returns the quotient of two numbers with no fractional part.
 *
 * @param dividend - The number to divide.
 * @param divisor - The number to divide with.
 *
 * @returns The quotient of the two numbers.
 */ var $c4a174d51abe8aaa$export$e466e21ee5950aaf = function integerDivide(dividend, divisor) {
    return Math.trunc(dividend / divisor);
};

});

parcelRegister("1et4c", function(module, exports) {

$parcel$export(module.exports, "modulo", function () { return $0e5da54fff6987e8$export$ba467bec01d66def; });
/**
 * Returns the remainder of two numbers.
 *
 * @param dividend - The number to divide.
 * @param divisor - The number to divide with.
 *
 * @returns The remainder of the two numbers.
 */ var $0e5da54fff6987e8$export$ba467bec01d66def = function modulo(dividend, divisor) {
    return dividend % divisor;
};

});

parcelRegister("82TNn", function(module, exports) {

$parcel$export(module.exports, "multiply", function () { return $5db9ca73271373f4$export$2060d2db72cce88f; });
/**
 * Returns the product of two numbers.
 *
 * @param multiplicand - The number to multiply.
 * @param multiplier - The number to multiply with.
 *
 * @returns The product of the two numbers.
 */ var $5db9ca73271373f4$export$2060d2db72cce88f = function multiply(multiplicand, multiplier) {
    return multiplicand * multiplier;
};

});

parcelRegister("7uSXO", function(module, exports) {

$parcel$export(module.exports, "power", function () { return $5755f865259a9540$export$836601bcef5ff40; });
/**
 * Returns an number to the power of an exponent.
 *
 * @param base - The base number.
 * @param exponent - The exponent to raise the base to.
 *
 * @returns The base to the power of the exponent.
 */ var $5755f865259a9540$export$836601bcef5ff40 = function power(base, exponent) {
    return Math.pow(base, exponent);
};

});

parcelRegister("i2dEm", function(module, exports) {

$parcel$export(module.exports, "subtract", function () { return $0363673be032126a$export$4e2d2ead65e5f7e3; });
/**
 * Returns the difference between two numbers.
 *
 * @param minuend - The number to subtract from.
 * @param subtrahend - The number to subtract.
 *
 * @returns The difference of the two numbers.
 */ var $0363673be032126a$export$4e2d2ead65e5f7e3 = function subtract(minuend, subtrahend) {
    return minuend - subtrahend;
};

});

parcelRegister("jHVe0", function(module, exports) {

$parcel$export(module.exports, "zero", function () { return $e58e6c203a741ddd$export$7f9972325ebfd559; });
/**
 * Return zero as a number.
 *
 * @returns Zero as a number.
 */ function $e58e6c203a741ddd$export$7f9972325ebfd559() {
    return 0;
}

});


parcelRegister("17TDA", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $0d219a596414125f$export$a7a9523472993e97; });
/* eslint-disable functional/no-throw-statement, valid-jsdoc */ /**
 * Assert a condition.
 *
 * @param condition - The condition to verify.
 * @param message - The error message to throw.
 *
 * @throws If the condition isn't met.
 */ function $0d219a596414125f$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error("[Dinero.js] ".concat(message));
}

});

parcelRegister("baeIf", function(module, exports) {

$parcel$export(module.exports, "createDinero", function () { return $820c0a801dbca779$export$7d8b30ba682ca797; });
/* eslint-disable functional/no-mixed-type, functional/no-return-void, functional/no-expression-statement */ function $820c0a801dbca779$export$7d8b30ba682ca797(_ref) {
    var calculator = _ref.calculator, onCreate = _ref.onCreate, _ref$formatter = _ref.formatter, formatter = _ref$formatter === void 0 ? {
        toNumber: Number,
        toString: String
    } : _ref$formatter;
    return function dinero(_ref2) {
        var amount = _ref2.amount, _ref2$currency = _ref2.currency, code = _ref2$currency.code, base = _ref2$currency.base, exponent = _ref2$currency.exponent, _ref2$scale = _ref2.scale, scale = _ref2$scale === void 0 ? exponent : _ref2$scale;
        var currency = {
            code: code,
            base: base,
            exponent: exponent
        };
        onCreate === null || onCreate === void 0 || onCreate({
            amount: amount,
            currency: currency,
            scale: scale
        });
        return {
            calculator: calculator,
            formatter: formatter,
            create: dinero,
            toJSON: function toJSON() {
                return {
                    amount: amount,
                    currency: currency,
                    scale: scale
                };
            }
        };
    };
}

});

parcelRegister("3GfaA", function(module, exports) {

$parcel$export(module.exports, "INVALID_AMOUNT_MESSAGE", function () { return $2ae10fbdfc3fc81f$export$e27f261d364932eb; });
$parcel$export(module.exports, "INVALID_SCALE_MESSAGE", function () { return $2ae10fbdfc3fc81f$export$6ea6c533eb222651; });
$parcel$export(module.exports, "INVALID_RATIOS_MESSAGE", function () { return $2ae10fbdfc3fc81f$export$f38d191a1e558a4d; });
$parcel$export(module.exports, "UNEQUAL_CURRENCIES_MESSAGE", function () { return $2ae10fbdfc3fc81f$export$b89a7c181fdad771; });
$parcel$export(module.exports, "NON_DECIMAL_CURRENCY_MESSAGE", function () { return $2ae10fbdfc3fc81f$export$8e529f3fe7bbf42; });
var $2ae10fbdfc3fc81f$export$e27f261d364932eb = 'Amount is invalid.';
var $2ae10fbdfc3fc81f$export$6ea6c533eb222651 = 'Scale is invalid.';
var $2ae10fbdfc3fc81f$export$f38d191a1e558a4d = 'Ratios are invalid.';
var $2ae10fbdfc3fc81f$export$13345bd9e924e673 = 'Objects must have the same scale.';
var $2ae10fbdfc3fc81f$export$b89a7c181fdad771 = 'Objects must have the same currency.';
var $2ae10fbdfc3fc81f$export$8e529f3fe7bbf42 = 'Currency is not decimal.';

});




parcelRegister("9cr7a", function(module, exports) {

$parcel$export(module.exports, "ButtonContext", function () { return $4abbf458d8258ee9$export$24d547caef80ccd1; });
$parcel$export(module.exports, "Button", function () { return $4abbf458d8258ee9$export$353f5b6fc5456de1; });

var $dgWhj = parcelRequire("dgWhj");

var $chL8V = parcelRequire("chL8V");

var $lvrF1 = parcelRequire("lvrF1");

var $hAxtE = parcelRequire("hAxtE");
var $Dyv4Q = parcelRequire("Dyv4Q");
var $5Gawp = parcelRequire("5Gawp");
var $i91F7 = parcelRequire("i91F7");
var $gxMV2 = parcelRequire("gxMV2");

var $73EHL = parcelRequire("73EHL");

var $bG0JH = parcelRequire("bG0JH");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4abbf458d8258ee9$var$$d2b4bc8c273e7be6$var$additionalButtonHTMLAttributes = new Set([
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'name',
    'value'
]);
const $4abbf458d8258ee9$export$24d547caef80ccd1 = (0, $bh6RR.createContext)({});
function $4abbf458d8258ee9$var$$d2b4bc8c273e7be6$var$Button(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $4abbf458d8258ee9$export$24d547caef80ccd1);
    props = $4abbf458d8258ee9$var$$d2b4bc8c273e7be6$var$disablePendingProps(props);
    let ctx = props;
    let { isPending: isPending } = ctx;
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $Dyv4Q.useButton)(props, ref);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $5Gawp.useFocusRing)(props);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)({
        ...props,
        isDisabled: props.isDisabled || isPending
    });
    let renderValues = {
        isHovered: isHovered,
        isPressed: (ctx.isPressed || isPressed) && !isPending,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        isDisabled: props.isDisabled || false,
        isPending: isPending !== null && isPending !== void 0 ? isPending : false
    };
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        values: renderValues,
        defaultClassName: 'react-aria-Button'
    });
    let buttonId = (0, $gxMV2.useId)(buttonProps.id);
    let progressId = (0, $gxMV2.useId)();
    let ariaLabelledby = buttonProps['aria-labelledby'];
    if (isPending) {
        // aria-labelledby wins over aria-label
        // https://www.w3.org/TR/accname-1.2/#computation-steps
        if (ariaLabelledby) ariaLabelledby = `${ariaLabelledby} ${progressId}`;
        else if (buttonProps['aria-label']) ariaLabelledby = `${buttonId} ${progressId}`;
    }
    let wasPending = (0, $bh6RR.useRef)(isPending);
    (0, $bh6RR.useEffect)(()=>{
        let message = {
            'aria-labelledby': ariaLabelledby || buttonId
        };
        if (!wasPending.current && isFocused && isPending) (0, $lvrF1.announce)(message, 'assertive');
        else if (wasPending.current && isFocused && !isPending) (0, $lvrF1.announce)(message, 'assertive');
        wasPending.current = isPending;
    }, [
        isPending,
        isFocused,
        ariaLabelledby,
        buttonId
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
        ...(0, $bG0JH.filterDOMProps)(props, {
            propNames: $4abbf458d8258ee9$var$$d2b4bc8c273e7be6$var$additionalButtonHTMLAttributes
        }),
        ...(0, $hAxtE.mergeProps)(buttonProps, focusProps, hoverProps),
        ...renderProps,
        id: buttonId,
        ref: ref,
        "aria-labelledby": ariaLabelledby,
        slot: props.slot || undefined,
        "aria-disabled": isPending ? 'true' : buttonProps['aria-disabled'],
        "data-disabled": props.isDisabled || undefined,
        "data-pressed": renderValues.isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-pending": isPending || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $chL8V.ProgressBarContext).Provider, {
        value: {
            id: progressId
        }
    }, renderProps.children));
}
function $4abbf458d8258ee9$var$$d2b4bc8c273e7be6$var$disablePendingProps(props) {
    // Don't allow interaction while isPending is true
    if (props.isPending) {
        props.onPress = undefined;
        props.onPressStart = undefined;
        props.onPressEnd = undefined;
        props.onPressChange = undefined;
        props.onPressUp = undefined;
        props.onKeyDown = undefined;
        props.onKeyUp = undefined;
        props.onClick = undefined;
        props.href = undefined;
    }
    return props;
}
/**
 * A button allows a user to perform an action, with mouse, touch, and keyboard interactions.
 */ const $4abbf458d8258ee9$export$353f5b6fc5456de1 = (0, $73EHL.createHideableComponent)($4abbf458d8258ee9$var$$d2b4bc8c273e7be6$var$Button);

});
parcelRegister("dgWhj", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SLOT", function () { return $56ba1c1d79a3b777$export$c62b8e45d58ddad9; });
$parcel$export(module.exports, "Provider", function () { return $56ba1c1d79a3b777$export$2881499e37b75b9a; });
$parcel$export(module.exports, "useRenderProps", function () { return $56ba1c1d79a3b777$export$4d86445c2cf5e3; });
$parcel$export(module.exports, "composeRenderProps", function () { return $56ba1c1d79a3b777$export$c245e6201fed2f75; });
$parcel$export(module.exports, "useSlottedContext", function () { return $56ba1c1d79a3b777$export$fabf2dc03a41866e; });
$parcel$export(module.exports, "useContextProps", function () { return $56ba1c1d79a3b777$export$29f1550f4b0d4415; });
$parcel$export(module.exports, "useSlot", function () { return $56ba1c1d79a3b777$export$9d4c57ee4c6ffdd8; });
$parcel$export(module.exports, "useEnterAnimation", function () { return $56ba1c1d79a3b777$export$6d3443f2c48bfc20; });
$parcel$export(module.exports, "useExitAnimation", function () { return $56ba1c1d79a3b777$export$45fda7c47f93fd48; });
$parcel$export(module.exports, "removeDataAttributes", function () { return $56ba1c1d79a3b777$export$ef03459518577ad4; });

var $hAxtE = parcelRequire("hAxtE");
var $AizmU = parcelRequire("AizmU");
var $f2PTm = parcelRequire("f2PTm");
var $jyDr8 = parcelRequire("jyDr8");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $56ba1c1d79a3b777$export$c62b8e45d58ddad9 = Symbol('default');
function $56ba1c1d79a3b777$export$2881499e37b75b9a({ values: values, children: children }) {
    for (let [Context, value] of values)children = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Context.Provider, {
        value: value
    }, children);
    return children;
}
function $56ba1c1d79a3b777$export$4d86445c2cf5e3(props) {
    let { className: className, style: style, children: children, defaultClassName: defaultClassName, defaultChildren: defaultChildren, defaultStyle: defaultStyle, values: values } = props;
    return (0, $bh6RR.useMemo)(()=>{
        let computedClassName;
        let computedStyle;
        let computedChildren;
        if (typeof className === 'function') computedClassName = className({
            ...values,
            defaultClassName: defaultClassName
        });
        else computedClassName = className;
        if (typeof style === 'function') computedStyle = style({
            ...values,
            defaultStyle: defaultStyle || {}
        });
        else computedStyle = style;
        if (typeof children === 'function') computedChildren = children({
            ...values,
            defaultChildren: defaultChildren
        });
        else if (children == null) computedChildren = defaultChildren;
        else computedChildren = children;
        return {
            className: computedClassName !== null && computedClassName !== void 0 ? computedClassName : defaultClassName,
            style: computedStyle || defaultStyle ? {
                ...defaultStyle,
                ...computedStyle
            } : undefined,
            children: computedChildren !== null && computedChildren !== void 0 ? computedChildren : defaultChildren,
            'data-rac': ''
        };
    }, [
        className,
        style,
        children,
        defaultClassName,
        defaultChildren,
        defaultStyle,
        values
    ]);
}
function $56ba1c1d79a3b777$export$c245e6201fed2f75(value, wrap) {
    return (renderProps)=>wrap(typeof value === 'function' ? value(renderProps) : value, renderProps);
}
function $56ba1c1d79a3b777$export$fabf2dc03a41866e(context, slot) {
    let ctx = (0, $bh6RR.useContext)(context);
    if (slot === null) return null;
    if (ctx && typeof ctx === 'object' && 'slots' in ctx && ctx.slots) {
        let availableSlots = new Intl.ListFormat().format(Object.keys(ctx.slots).map((p)=>`"${p}"`));
        if (!slot && !ctx.slots[$56ba1c1d79a3b777$export$c62b8e45d58ddad9]) throw new Error(`A slot prop is required. Valid slot names are ${availableSlots}.`);
        let slotKey = slot || $56ba1c1d79a3b777$export$c62b8e45d58ddad9;
        if (!ctx.slots[slotKey]) throw new Error(`Invalid slot "${slot}". Valid slot names are ${availableSlots}.`);
        return ctx.slots[slotKey];
    }
    // @ts-ignore
    return ctx;
}
function $56ba1c1d79a3b777$export$29f1550f4b0d4415(props, ref, context) {
    let ctx = $56ba1c1d79a3b777$export$fabf2dc03a41866e(context, props.slot) || {};
    // @ts-ignore - TS says "Type 'unique symbol' cannot be used as an index type." but not sure why.
    let { ref: contextRef, ...contextProps } = ctx;
    let mergedRef = (0, $jyDr8.useObjectRef)((0, $bh6RR.useMemo)(()=>(0, $AizmU.mergeRefs)(ref, contextRef), [
        ref,
        contextRef
    ]));
    let mergedProps = (0, $hAxtE.mergeProps)(contextProps, props);
    // mergeProps does not merge `style`. Adding this there might be a breaking change.
    if ('style' in contextProps && contextProps.style && 'style' in props && props.style) {
        if (typeof contextProps.style === 'function' || typeof props.style === 'function') mergedProps.style = (renderProps)=>{
            let contextStyle = typeof contextProps.style === 'function' ? contextProps.style(renderProps) : contextProps.style;
            let defaultStyle = {
                ...renderProps.defaultStyle,
                ...contextStyle
            };
            let style = typeof props.style === 'function' ? props.style({
                ...renderProps,
                defaultStyle: defaultStyle
            }) : props.style;
            return {
                ...defaultStyle,
                ...style
            };
        };
        else mergedProps.style = {
            ...contextProps.style,
            ...props.style
        };
    }
    return [
        mergedProps,
        mergedRef
    ];
}
function $56ba1c1d79a3b777$export$9d4c57ee4c6ffdd8() {
    // Assume we do have the slot in the initial render.
    let [hasSlot, setHasSlot] = (0, $bh6RR.useState)(true);
    let hasRun = (0, $bh6RR.useRef)(false);
    // A callback ref which will run when the slotted element mounts.
    // This should happen before the useLayoutEffect below.
    let ref = (0, $bh6RR.useCallback)((el)=>{
        hasRun.current = true;
        setHasSlot(!!el);
    }, []);
    (0, $f2PTm.useLayoutEffect)(()=>{
        if (!hasRun.current) setHasSlot(false);
    }, []);
    return [
        ref,
        hasSlot
    ];
}
function $56ba1c1d79a3b777$export$6d3443f2c48bfc20(ref, isReady = true) {
    let [isEntering, setEntering] = (0, $bh6RR.useState)(true);
    $56ba1c1d79a3b777$var$$64fa3d84918910a7$var$useAnimation(ref, isEntering && isReady, (0, $bh6RR.useCallback)(()=>setEntering(false), []));
    return isEntering && isReady;
}
function $56ba1c1d79a3b777$export$45fda7c47f93fd48(ref, isOpen) {
    // State to trigger a re-render after animation is complete, which causes the element to be removed from the DOM.
    // Ref to track the state we're in, so we don't immediately reset isExiting to true after the animation.
    let [isExiting, setExiting] = (0, $bh6RR.useState)(false);
    let [exitState, setExitState] = (0, $bh6RR.useState)('idle');
    // If isOpen becomes false, set isExiting to true.
    if (!isOpen && ref.current && exitState === 'idle') {
        isExiting = true;
        setExiting(true);
        setExitState('exiting');
    }
    // If we exited, and the element has been removed, reset exit state to idle.
    if (!ref.current && exitState === 'exited') setExitState('idle');
    $56ba1c1d79a3b777$var$$64fa3d84918910a7$var$useAnimation(ref, isExiting, (0, $bh6RR.useCallback)(()=>{
        setExitState('exited');
        setExiting(false);
    }, []));
    return isExiting;
}
function $56ba1c1d79a3b777$var$$64fa3d84918910a7$var$useAnimation(ref, isActive, onEnd) {
    let prevAnimation = (0, $bh6RR.useRef)(null);
    if (isActive && ref.current) // We could move this to another effect that runs every render, but this would be unnecessarily slow.
    // We only need the computed style right before the animation becomes active.
    // eslint-disable-next-line rulesdir/pure-render
    prevAnimation.current = window.getComputedStyle(ref.current).animation;
    (0, $f2PTm.useLayoutEffect)(()=>{
        if (isActive && ref.current) {
            // Make sure there's actually an animation, and it wasn't there before we triggered the update.
            let computedStyle = window.getComputedStyle(ref.current);
            if (computedStyle.animationName && computedStyle.animationName !== 'none' && computedStyle.animation !== prevAnimation.current) {
                let onAnimationEnd = (e)=>{
                    if (e.target === ref.current) {
                        element.removeEventListener('animationend', onAnimationEnd);
                        (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).flushSync(()=>{
                            onEnd();
                        });
                    }
                };
                let element = ref.current;
                element.addEventListener('animationend', onAnimationEnd);
                return ()=>{
                    element.removeEventListener('animationend', onAnimationEnd);
                };
            } else onEnd();
        }
    }, [
        ref,
        isActive,
        onEnd
    ]);
}
function $56ba1c1d79a3b777$export$ef03459518577ad4(props) {
    const prefix = /^(data-.*)$/;
    let filteredProps = {};
    for(const prop in props)if (!prefix.test(prop)) filteredProps[prop] = props[prop];
    return filteredProps;
}

});
parcelRegister("hAxtE", function(module, exports) {

$parcel$export(module.exports, "mergeProps", function () { return $6a714361f781a275$export$9d1611c77c2fe928; });

var $jQZLC = parcelRequire("jQZLC");

var $gxMV2 = parcelRequire("gxMV2");

var $aPsoC = parcelRequire("aPsoC");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6a714361f781a275$export$9d1611c77c2fe928(...args) {
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    let result = {
        ...args[0]
    };
    for(let i = 1; i < args.length; i++){
        let props = args[i];
        for(let key in props){
            let a = result[key];
            let b = props[key];
            // Chain events
            if (typeof a === 'function' && typeof b === 'function' && // This is a lot faster than a regex.
            key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = (0, $jQZLC.chain)(a, b);
            else if ((key === 'className' || key === 'UNSAFE_className') && typeof a === 'string' && typeof b === 'string') result[key] = (0, $aPsoC.default)(a, b);
            else if (key === 'id' && a && b) result.id = (0, $gxMV2.mergeIds)(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}

});
parcelRegister("jQZLC", function(module, exports) {

$parcel$export(module.exports, "chain", function () { return $a567ca1c9bcad096$export$e08e3b67e392101e; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $a567ca1c9bcad096$export$e08e3b67e392101e(...callbacks) {
    return (...args)=>{
        for (let callback of callbacks)if (typeof callback === 'function') callback(...args);
    };
}

});

parcelRegister("gxMV2", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $01c0db07fa38ad2d$export$f680877a34711e37; });
$parcel$export(module.exports, "mergeIds", function () { return $01c0db07fa38ad2d$export$cd8c9cb68f842629; });
$parcel$export(module.exports, "useSlotId", function () { return $01c0db07fa38ad2d$export$b4cc09c592e8fdb8; });

var $f2PTm = parcelRequire("f2PTm");

var $62NsE = parcelRequire("62NsE");

var $bh6RR = parcelRequire("bh6RR");

var $gFA2q = parcelRequire("gFA2q");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let $01c0db07fa38ad2d$var$$bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $01c0db07fa38ad2d$var$$bdb11010cef70236$var$idsUpdaterMap = new Map();
function $01c0db07fa38ad2d$export$f680877a34711e37(defaultId) {
    let [value, setValue] = (0, $bh6RR.useState)(defaultId);
    let nextId = (0, $bh6RR.useRef)(null);
    let res = (0, $gFA2q.useSSRSafeId)(value);
    let updateValue = (0, $bh6RR.useCallback)((val)=>{
        nextId.current = val;
    }, []);
    if ($01c0db07fa38ad2d$var$$bdb11010cef70236$var$canUseDOM) {
        // TS not smart enough to know that `has` means the value exists
        if ($01c0db07fa38ad2d$var$$bdb11010cef70236$var$idsUpdaterMap.has(res) && !$01c0db07fa38ad2d$var$$bdb11010cef70236$var$idsUpdaterMap.get(res).includes(updateValue)) $01c0db07fa38ad2d$var$$bdb11010cef70236$var$idsUpdaterMap.set(res, [
            ...$01c0db07fa38ad2d$var$$bdb11010cef70236$var$idsUpdaterMap.get(res),
            updateValue
        ]);
        else $01c0db07fa38ad2d$var$$bdb11010cef70236$var$idsUpdaterMap.set(res, [
            updateValue
        ]);
    }
    (0, $f2PTm.useLayoutEffect)(()=>{
        let r = res;
        return ()=>{
            $01c0db07fa38ad2d$var$$bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    (0, $bh6RR.useEffect)(()=>{
        let newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $01c0db07fa38ad2d$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    let setIdsA = $01c0db07fa38ad2d$var$$bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdsA) {
        setIdsA.forEach((fn)=>fn(idB));
        return idB;
    }
    let setIdsB = $01c0db07fa38ad2d$var$$bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdsB) {
        setIdsB.forEach((fn)=>fn(idA));
        return idA;
    }
    return idB;
}
function $01c0db07fa38ad2d$export$b4cc09c592e8fdb8(depArray = []) {
    let id = $01c0db07fa38ad2d$export$f680877a34711e37();
    let [resolvedId, setResolvedId] = (0, $62NsE.useValueEffect)(id);
    let updateId = (0, $bh6RR.useCallback)(()=>{
        setResolvedId(function*() {
            yield id;
            yield document.getElementById(id) ? id : undefined;
        });
    }, [
        id,
        setResolvedId
    ]);
    (0, $f2PTm.useLayoutEffect)(updateId, [
        id,
        updateId,
        ...depArray
    ]);
    return resolvedId;
}

});
parcelRegister("f2PTm", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $8143119cf7df61d7$export$e5c5a5f917a5871c; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $8143119cf7df61d7$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useLayoutEffect : ()=>{};

});

parcelRegister("62NsE", function(module, exports) {

$parcel$export(module.exports, "useValueEffect", function () { return $19ff285a6d5faf2e$export$14d238f342723f25; });

var $i7SiA = parcelRequire("i7SiA");

var $f2PTm = parcelRequire("f2PTm");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $19ff285a6d5faf2e$export$14d238f342723f25(defaultValue) {
    let [value, setValue] = (0, $bh6RR.useState)(defaultValue);
    let effect = (0, $bh6RR.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    let nextRef = (0, $i7SiA.useEffectEvent)(()=>{
        if (!effect.current) return;
        // Run the generator to the next yield.
        let newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value === newValue.value) nextRef();
        else setValue(newValue.value);
    });
    (0, $f2PTm.useLayoutEffect)(()=>{
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef();
    });
    let queue = (0, $i7SiA.useEffectEvent)((fn)=>{
        effect.current = fn(value);
        nextRef();
    });
    return [
        value,
        queue
    ];
}

});
parcelRegister("i7SiA", function(module, exports) {

$parcel$export(module.exports, "useEffectEvent", function () { return $1aa12b0ceb0b0035$export$7f54fc3180508a52; });

var $f2PTm = parcelRequire("f2PTm");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1aa12b0ceb0b0035$export$7f54fc3180508a52(fn) {
    const ref = (0, $bh6RR.useRef)(null);
    (0, $f2PTm.useLayoutEffect)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $bh6RR.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}

});


parcelRegister("gFA2q", function(module, exports) {

$parcel$export(module.exports, "useIsSSR", function () { return $ac08273585353e91$export$535bd6ca7f90a273; });
$parcel$export(module.exports, "useSSRSafeId", function () { return $ac08273585353e91$export$619500959fc48b26; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $ac08273585353e91$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $ac08273585353e91$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext($ac08273585353e91$var$$b5e257d569688ac6$var$defaultContext);
const $ac08273585353e91$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(false);
// This is only used in React < 18.
function $ac08273585353e91$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $bh6RR.useContext)($ac08273585353e91$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $ac08273585353e91$var$$b5e257d569688ac6$var$useCounter(cur === $ac08273585353e91$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $bh6RR.useState)(true);
    let value = (0, $bh6RR.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $ac08273585353e91$var$$b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $bh6RR.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($ac08273585353e91$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($ac08273585353e91$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $ac08273585353e91$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $ac08273585353e91$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))['useId'] === 'function') {
        if (!$ac08273585353e91$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn('In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.');
            $ac08273585353e91$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($ac08273585353e91$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $ac08273585353e91$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $ac08273585353e91$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $ac08273585353e91$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $bh6RR.useContext)($ac08273585353e91$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $bh6RR.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $ac08273585353e91$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $ac08273585353e91$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $ac08273585353e91$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $ac08273585353e91$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $bh6RR.useContext)($ac08273585353e91$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $ac08273585353e91$var$$b5e257d569688ac6$var$defaultContext && !$ac08273585353e91$var$$b5e257d569688ac6$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    let counter = $ac08273585353e91$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $ac08273585353e91$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useId();
    let [didSSR] = (0, $bh6RR.useState)($ac08273585353e91$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$ac08273585353e91$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $ac08273585353e91$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))['useId'] === 'function' ? $ac08273585353e91$var$$b5e257d569688ac6$var$useModernSSRSafeId : $ac08273585353e91$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $ac08273585353e91$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $ac08273585353e91$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $ac08273585353e91$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $ac08273585353e91$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))['useSyncExternalStore']($ac08273585353e91$var$$b5e257d569688ac6$var$subscribe, $ac08273585353e91$var$$b5e257d569688ac6$var$getSnapshot, $ac08273585353e91$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $bh6RR.useContext)($ac08273585353e91$var$$b5e257d569688ac6$var$IsSSRContext);
}

});


parcelRegister("aPsoC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa1a2e608fb826ea$export$2e2bcd8739ae039; });
function $fa1a2e608fb826ea$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $fa1a2e608fb826ea$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $fa1a2e608fb826ea$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $fa1a2e608fb826ea$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fa1a2e608fb826ea$export$2e2bcd8739ae039 = $fa1a2e608fb826ea$export$4f5d2d50c9deca37;

});


parcelRegister("AizmU", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", function () { return $608db2b0bed6f0de$export$c9058316764c140e; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $608db2b0bed6f0de$export$c9058316764c140e(...refs) {
    if (refs.length === 1 && refs[0]) return refs[0];
    return (value)=>{
        for (let ref of refs){
            if (typeof ref === 'function') ref(value);
            else if (ref != null) ref.current = value;
        }
    };
}

});

parcelRegister("jyDr8", function(module, exports) {

$parcel$export(module.exports, "useObjectRef", function () { return $bd1d4e9f3d17068a$export$4338b53315abf666; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bd1d4e9f3d17068a$export$4338b53315abf666(forwardedRef) {
    const objRef = (0, $bh6RR.useRef)(null);
    return (0, $bh6RR.useMemo)(()=>({
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (typeof forwardedRef === 'function') forwardedRef(value);
                else if (forwardedRef) forwardedRef.current = value;
            }
        }), [
        forwardedRef
    ]);
}

});


parcelRegister("chL8V", function(module, exports) {

$parcel$export(module.exports, "ProgressBarContext", function () { return $7f5c4394d19b6bdc$export$e9f3bf65a26ce129; });

var $dgWhj = parcelRequire("dgWhj");

var $kubwK = parcelRequire("kubwK");

var $6Ogd0 = parcelRequire("6Ogd0");

var $96djM = parcelRequire("96djM");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $7f5c4394d19b6bdc$export$e9f3bf65a26ce129 = (0, $bh6RR.createContext)(null);
function $7f5c4394d19b6bdc$var$$0393f8ab869a0f1a$var$ProgressBar(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $7f5c4394d19b6bdc$export$e9f3bf65a26ce129);
    let { value: value = 0, minValue: minValue = 0, maxValue: maxValue = 100, isIndeterminate: isIndeterminate = false } = props;
    value = (0, $96djM.clamp)(value, minValue, maxValue);
    let [labelRef, label] = (0, $dgWhj.useSlot)();
    let { progressBarProps: progressBarProps, labelProps: labelProps } = (0, $6Ogd0.useProgressBar)({
        ...props,
        label: label
    });
    // Calculate the width of the progress bar as a percentage
    let percentage = isIndeterminate ? undefined : (value - minValue) / (maxValue - minValue) * 100;
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ProgressBar',
        values: {
            percentage: percentage,
            valueText: progressBarProps['aria-valuetext'],
            isIndeterminate: isIndeterminate
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...progressBarProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $kubwK.LabelContext).Provider, {
        value: {
            ...labelProps,
            ref: labelRef,
            elementType: 'span'
        }
    }, renderProps.children));
}
/**
 * Progress bars show either determinate or indeterminate progress of an operation
 * over time.
 */ const $7f5c4394d19b6bdc$export$c17561cb55d4db30 = (0, $bh6RR.forwardRef)($7f5c4394d19b6bdc$var$$0393f8ab869a0f1a$var$ProgressBar);

});
parcelRegister("kubwK", function(module, exports) {

$parcel$export(module.exports, "LabelContext", function () { return $226ba70baac8b9c7$export$75b6ee27786ba447; });
$parcel$export(module.exports, "Label", function () { return $226ba70baac8b9c7$export$b04be29aa201d4f5; });

var $dgWhj = parcelRequire("dgWhj");

var $73EHL = parcelRequire("73EHL");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $226ba70baac8b9c7$export$75b6ee27786ba447 = (0, $bh6RR.createContext)({});
function $226ba70baac8b9c7$var$$01b77f81d0f07f68$var$Label(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $226ba70baac8b9c7$export$75b6ee27786ba447);
    let { elementType: ElementType = 'label', ...labelProps } = props;
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ElementType, {
        className: "react-aria-Label",
        ...labelProps,
        ref: ref
    });
}
const $226ba70baac8b9c7$export$b04be29aa201d4f5 = (0, $73EHL.createHideableComponent)($226ba70baac8b9c7$var$$01b77f81d0f07f68$var$Label);

});
parcelRegister("73EHL", function(module, exports) {

$parcel$export(module.exports, "Hidden", function () { return $b29ddaa7e8395bd1$export$8dc98ba7eadeaa56; });
$parcel$export(module.exports, "createHideableComponent", function () { return $b29ddaa7e8395bd1$export$86427a43e3e48ebb; });
$parcel$export(module.exports, "useIsHidden", function () { return $b29ddaa7e8395bd1$export$b5d7cc18bb8d2b59; });

var $6afFj = parcelRequire("6afFj");

var $bh6RR = parcelRequire("bh6RR");

var $gFA2q = parcelRequire("gFA2q");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // React doesn't understand the <template> element, which doesn't have children like a normal element.
// It will throw an error during hydration when it expects the firstChild to contain content rendered
// on the server, when in reality, the browser will have placed this inside the `content` document fragment.
// This monkey patches the firstChild property for our special hidden template elements to work around this error.
// See https://github.com/facebook/react/issues/19932
if (typeof HTMLTemplateElement !== 'undefined') {
    const getFirstChild = Object.getOwnPropertyDescriptor(Node.prototype, 'firstChild').get;
    Object.defineProperty(HTMLTemplateElement.prototype, 'firstChild', {
        configurable: true,
        enumerable: true,
        get: function() {
            if (this.dataset.reactAriaHidden) return this.content.firstChild;
            else return getFirstChild.call(this);
        }
    });
}
const $b29ddaa7e8395bd1$export$94b6d0abf7d33e8c = (0, $bh6RR.createContext)(false);
// Portal to nowhere
const $b29ddaa7e8395bd1$var$$f39a9eba43920ace$var$hiddenFragment = typeof DocumentFragment !== 'undefined' ? new DocumentFragment() : null;
function $b29ddaa7e8395bd1$export$8dc98ba7eadeaa56(props) {
    let isHidden = (0, $bh6RR.useContext)($b29ddaa7e8395bd1$export$94b6d0abf7d33e8c);
    let isSSR = (0, $gFA2q.useIsSSR)();
    if (isHidden) return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, props.children);
    let children = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b29ddaa7e8395bd1$export$94b6d0abf7d33e8c.Provider, {
        value: true
    }, props.children);
    // In SSR, portals are not supported by React. Instead, render into a <template>
    // element, which the browser will never display to the user. In addition, the
    // content is not part of the DOM tree, so it won't affect ids or other accessibility attributes.
    return isSSR ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("template", {
        "data-react-aria-hidden": true
    }, children) : (0, $6afFj.createPortal)(children, $b29ddaa7e8395bd1$var$$f39a9eba43920ace$var$hiddenFragment);
}
function $b29ddaa7e8395bd1$export$86427a43e3e48ebb(fn) {
    let Wrapper = (props, ref)=>{
        let isHidden = (0, $bh6RR.useContext)($b29ddaa7e8395bd1$export$94b6d0abf7d33e8c);
        if (isHidden) return null;
        return fn(props, ref);
    };
    // @ts-ignore - for react dev tools
    Wrapper.displayName = fn.displayName || fn.name;
    return (0, $bh6RR.forwardRef)(Wrapper);
}
function $b29ddaa7e8395bd1$export$b5d7cc18bb8d2b59() {
    return (0, $bh6RR.useContext)($b29ddaa7e8395bd1$export$94b6d0abf7d33e8c);
}

});


parcelRegister("6Ogd0", function(module, exports) {

$parcel$export(module.exports, "useProgressBar", function () { return $ac88b6df32416433$export$ed5abd763a836edc; });

var $96djM = parcelRequire("96djM");
var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");

var $7D5kx = parcelRequire("7D5kx");

var $fD2WS = parcelRequire("fD2WS");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ac88b6df32416433$export$ed5abd763a836edc(props) {
    let { value: value = 0, minValue: minValue = 0, maxValue: maxValue = 100, valueLabel: valueLabel, isIndeterminate: isIndeterminate, formatOptions: formatOptions = {
        style: 'percent'
    } } = props;
    let domProps = (0, $bG0JH.filterDOMProps)(props, {
        labelable: true
    });
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $7D5kx.useLabel)({
        ...props,
        // Progress bar is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    value = (0, $96djM.clamp)(value, minValue, maxValue);
    let percentage = (value - minValue) / (maxValue - minValue);
    let formatter = (0, $fD2WS.useNumberFormatter)(formatOptions);
    if (!isIndeterminate && !valueLabel) {
        let valueToFormat = formatOptions.style === 'percent' ? percentage : value;
        valueLabel = formatter.format(valueToFormat);
    }
    return {
        progressBarProps: (0, $hAxtE.mergeProps)(domProps, {
            ...fieldProps,
            'aria-valuenow': isIndeterminate ? undefined : value,
            'aria-valuemin': minValue,
            'aria-valuemax': maxValue,
            'aria-valuetext': isIndeterminate ? undefined : valueLabel,
            role: 'progressbar'
        }),
        labelProps: labelProps
    };
}

});
parcelRegister("96djM", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $9c4ea170a8da7cc7$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "snapValueToStep", function () { return $9c4ea170a8da7cc7$export$cb6e0bb50bc19463; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $9c4ea170a8da7cc7$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
    let newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $9c4ea170a8da7cc7$export$e1a7b8e69ef6c52f(value, step) {
    let roundedValue = value;
    let stepString = step.toString();
    let pointIndex = stepString.indexOf('.');
    let precision = pointIndex >= 0 ? stepString.length - pointIndex : 0;
    if (precision > 0) {
        let pow = Math.pow(10, precision);
        roundedValue = Math.round(roundedValue * pow) / pow;
    }
    return roundedValue;
}
function $9c4ea170a8da7cc7$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    let remainder = (value - (isNaN(min) ? 0 : min)) % step;
    let snappedValue = $9c4ea170a8da7cc7$export$e1a7b8e69ef6c52f(Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder, step);
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor($9c4ea170a8da7cc7$export$e1a7b8e69ef6c52f((max - min) / step, step)) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor($9c4ea170a8da7cc7$export$e1a7b8e69ef6c52f(max / step, step)) * step;
    // correct floating point behavior by rounding to step precision
    snappedValue = $9c4ea170a8da7cc7$export$e1a7b8e69ef6c52f(snappedValue, step);
    return snappedValue;
}
function $9c4ea170a8da7cc7$export$b6268554fba451f(value, digits, base = 10) {
    const pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

});

parcelRegister("bG0JH", function(module, exports) {

$parcel$export(module.exports, "filterDOMProps", function () { return $c1770860787be901$export$457c3d6518dd4c6f; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c1770860787be901$var$$65484d02dcb7eb3e$var$DOMPropNames = new Set([
    'id'
]);
const $c1770860787be901$var$$65484d02dcb7eb3e$var$labelablePropNames = new Set([
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-details'
]);
// See LinkDOMProps in dom.d.ts.
const $c1770860787be901$var$$65484d02dcb7eb3e$var$linkPropNames = new Set([
    'href',
    'hrefLang',
    'target',
    'rel',
    'download',
    'ping',
    'referrerPolicy'
]);
const $c1770860787be901$var$$65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $c1770860787be901$export$457c3d6518dd4c6f(props, opts = {}) {
    let { labelable: labelable, isLink: isLink, propNames: propNames } = opts;
    let filteredProps = {};
    for(const prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($c1770860787be901$var$$65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $c1770860787be901$var$$65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $c1770860787be901$var$$65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $c1770860787be901$var$$65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}

});

parcelRegister("7D5kx", function(module, exports) {

$parcel$export(module.exports, "useLabel", function () { return $2236dbebad66db9c$export$8467354a121f1b9f; });

var $gxMV2 = parcelRequire("gxMV2");
var $5oX0L = parcelRequire("5oX0L");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2236dbebad66db9c$export$8467354a121f1b9f(props) {
    let { id: id, label: label, 'aria-labelledby': ariaLabelledby, 'aria-label': ariaLabel, labelElementType: labelElementType = 'label' } = props;
    id = (0, $gxMV2.useId)(id);
    let labelId = (0, $gxMV2.useId)();
    let labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === 'label' ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn('If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility');
    let fieldProps = (0, $5oX0L.useLabels)({
        id: id,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}

});
parcelRegister("5oX0L", function(module, exports) {

$parcel$export(module.exports, "useLabels", function () { return $1df89b5962f9622d$export$d6875122194c7b44; });

var $gxMV2 = parcelRequire("gxMV2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1df89b5962f9622d$export$d6875122194c7b44(props, defaultLabel) {
    let { id: id, 'aria-label': label, 'aria-labelledby': labelledBy } = props;
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = (0, $gxMV2.useId)(id);
    if (labelledBy && label) {
        let ids = new Set([
            id,
            ...labelledBy.trim().split(/\s+/)
        ]);
        labelledBy = [
            ...ids
        ].join(' ');
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(' ');
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        'aria-label': label,
        'aria-labelledby': labelledBy
    };
}

});


parcelRegister("fD2WS", function(module, exports) {

$parcel$export(module.exports, "useNumberFormatter", function () { return $b3914dae9cfc69b8$export$b7a616150fdb9f44; });

var $c8uzR = parcelRequire("c8uzR");

var $2OQFI = parcelRequire("2OQFI");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b3914dae9cfc69b8$export$b7a616150fdb9f44(options = {}) {
    let { locale: locale } = (0, $c8uzR.useLocale)();
    return (0, $bh6RR.useMemo)(()=>new (0, $2OQFI.NumberFormatter)(locale, options), [
        locale,
        options
    ]);
}

});
parcelRegister("c8uzR", function(module, exports) {

$parcel$export(module.exports, "useLocale", function () { return $ed9da9bb90444d91$export$43bb16f9c6d9e3f7; });

var $2oJe5 = parcelRequire("2oJe5");

var $79YFh = parcelRequire("79YFh");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ed9da9bb90444d91$var$$18f2051aff69b9bf$var$I18nContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $ed9da9bb90444d91$export$a54013f0d02a8f82(props) {
    let { locale: locale, children: children } = props;
    let defaultLocale = (0, $79YFh.useDefaultLocale)();
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>{
        if (!locale) return defaultLocale;
        return {
            locale: locale,
            direction: (0, $2oJe5.isRTL)(locale) ? 'rtl' : 'ltr'
        };
    }, [
        defaultLocale,
        locale
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($ed9da9bb90444d91$var$$18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $ed9da9bb90444d91$export$43bb16f9c6d9e3f7() {
    let defaultLocale = (0, $79YFh.useDefaultLocale)();
    let context = (0, $bh6RR.useContext)($ed9da9bb90444d91$var$$18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}

});
parcelRegister("2oJe5", function(module, exports) {

$parcel$export(module.exports, "isRTL", function () { return $451fae195d5cf80d$export$702d680b21cbd764; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $451fae195d5cf80d$var$$148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    'Arab',
    'Syrc',
    'Samr',
    'Mand',
    'Thaa',
    'Mend',
    'Nkoo',
    'Adlm',
    'Rohg',
    'Hebr'
]);
const $451fae195d5cf80d$var$$148a7a147e38ea7f$var$RTL_LANGS = new Set([
    'ae',
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'he',
    'ku',
    'mzn',
    'nqo',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi'
]);
function $451fae195d5cf80d$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    if (Intl.Locale) {
        let locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        let textInfo = typeof locale.getTextInfo === 'function' ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === 'rtl';
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $451fae195d5cf80d$var$$148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    let lang = localeString.split('-')[0];
    return $451fae195d5cf80d$var$$148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}

});

parcelRegister("79YFh", function(module, exports) {

$parcel$export(module.exports, "useDefaultLocale", function () { return $77377a5754f0fc19$export$188ec29ebc2bdc3a; });

var $2oJe5 = parcelRequire("2oJe5");

var $bh6RR = parcelRequire("bh6RR");

var $gFA2q = parcelRequire("gFA2q");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
const $77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
function $77377a5754f0fc19$export$f09106e7c6677ec5() {
    let locale = typeof window !== 'undefined' && window[$77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
    try {
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch  {
        locale = 'en-US';
    }
    return {
        locale: locale,
        direction: (0, $2oJe5.isRTL)(locale) ? 'rtl' : 'ltr'
    };
}
let $77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$currentLocale = $77377a5754f0fc19$export$f09106e7c6677ec5();
let $77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$listeners = new Set();
function $77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$updateLocale() {
    $77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$currentLocale = $77377a5754f0fc19$export$f09106e7c6677ec5();
    for (let listener of $77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$listeners)listener($77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$currentLocale);
}
function $77377a5754f0fc19$export$188ec29ebc2bdc3a() {
    let isSSR = (0, $gFA2q.useIsSSR)();
    let [defaultLocale, setDefaultLocale] = (0, $bh6RR.useState)($77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$currentLocale);
    (0, $bh6RR.useEffect)(()=>{
        if ($77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener('languagechange', $77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$updateLocale);
        $77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return ()=>{
            $77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener('languagechange', $77377a5754f0fc19$var$$1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: 'en-US',
        direction: 'ltr'
    };
    return defaultLocale;
}

});


parcelRegister("2OQFI", function(module, exports) {

$parcel$export(module.exports, "NumberFormatter", function () { return $f78d9f073a2285bb$export$cc77c4ff7e8673c5; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$formatterCache = new Map();
let $f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    $f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat('de-DE', {
        signDisplay: 'exceptZero'
    }).resolvedOptions().signDisplay === 'exceptZero';
// eslint-disable-next-line no-empty
} catch  {}
let $f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    $f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat('de-DE', {
        style: 'unit',
        unit: 'degree'
    }).resolvedOptions().style === 'unit';
// eslint-disable-next-line no-empty
} catch  {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
const $f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            'ja-JP': " \u5EA6",
            'zh-TW': "\u5EA6",
            'sl-SI': " \xb0"
        }
    }
};
class $f78d9f073a2285bb$export$cc77c4ff7e8673c5 {
    /** Formats a number value as a string, according to the locale and options provided to the constructor. */ format(value) {
        let res = '';
        if (!$f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $f78d9f073a2285bb$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
        else res = this.numberFormatter.format(value);
        if (this.options.style === 'unit' && !$f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$supportsUnit) {
            var _UNITS_unit;
            let { unit: unit, unitDisplay: unitDisplay = 'short', locale: locale } = this.resolvedOptions();
            if (!unit) return res;
            let values = (_UNITS_unit = $f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
            res += values[locale] || values.default;
        }
        return res;
    }
    /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ formatToParts(value) {
        // TODO: implement signDisplay for formatToParts
        return this.numberFormatter.formatToParts(value);
    }
    /** Formats a number range as a string. */ formatRange(start, end) {
        if (typeof this.numberFormatter.formatRange === 'function') return this.numberFormatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.format(start)} \u{2013} ${this.format(end)}`;
    }
    /** Formats a number range as an array of parts. */ formatRangeToParts(start, end) {
        if (typeof this.numberFormatter.formatRangeToParts === 'function') return this.numberFormatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.numberFormatter.formatToParts(start);
        let endParts = this.numberFormatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })),
            {
                type: 'literal',
                value: " \u2013 ",
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let options = this.numberFormatter.resolvedOptions();
        if (!$f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = {
            ...options,
            signDisplay: this.options.signDisplay
        };
        if (!$f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === 'unit') options = {
            ...options,
            style: 'unit',
            unit: this.options.unit,
            unitDisplay: this.options.unitDisplay
        };
        return options;
    }
    constructor(locale, options = {}){
        this.numberFormatter = $f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
}
function $f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options = {}) {
    let { numberingSystem: numberingSystem } = options;
    if (numberingSystem && locale.includes('-nu-')) {
        if (!locale.includes('-u-')) locale += '-u-';
        locale += `-nu-${numberingSystem}`;
    }
    if (options.style === 'unit' && !$f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$supportsUnit) {
        var _UNITS_unit;
        let { unit: unit, unitDisplay: unitDisplay = 'short' } = options;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = $f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
        options = {
            ...options,
            style: 'decimal'
        };
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if ($f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    let numberFormatter = new Intl.NumberFormat(locale, options);
    $f78d9f073a2285bb$var$$488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $f78d9f073a2285bb$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === 'auto') return numberFormat.format(num);
    else if (signDisplay === 'never') return numberFormat.format(Math.abs(num));
    else {
        let needsPositiveSign = false;
        if (signDisplay === 'always') needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === 'exceptZero') {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            let negative = numberFormat.format(-num);
            let noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            let minus = negative.replace(noSign, '').replace(/\u200e|\u061C/, '');
            if ([
                ...minus
            ].length !== 1) console.warn('@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case');
            let positive = negative.replace(noSign, '!!!').replace(minus, '+').replace('!!!', noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}

});




parcelRegister("lvrF1", function(module, exports) {

$parcel$export(module.exports, "announce", function () { return $02b8a1de85f2d250$export$a9b970dcc4ae71a9; });
$parcel$export(module.exports, "clearAnnouncer", function () { return $02b8a1de85f2d250$export$d10ae4f68404609a; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* Inspired by https://github.com/AlmeroSteyn/react-aria-live */ const $02b8a1de85f2d250$var$$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7000;
let $02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer = null;
function $02b8a1de85f2d250$export$a9b970dcc4ae71a9(message, assertiveness = 'assertive', timeout = $02b8a1de85f2d250$var$$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
    if (!$02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer) {
        $02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer = new $02b8a1de85f2d250$var$$319e236875307eab$var$LiveAnnouncer();
        // wait for the live announcer regions to be added to the dom, then announce
        // otherwise Safari won't announce the message if it's added too quickly
        // found most times less than 100ms were not consistent when announcing with Safari
        // IS_REACT_ACT_ENVIRONMENT is used by React 18. Previous versions checked for the `jest` global.
        // https://github.com/reactwg/react-18/discussions/102
        // if we're in a test environment, announce without waiting
        // @ts-ignore
        if (!(typeof IS_REACT_ACT_ENVIRONMENT === 'boolean' ? IS_REACT_ACT_ENVIRONMENT : typeof jest !== 'undefined')) setTimeout(()=>{
            if ($02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer === null || $02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer === void 0 ? void 0 : $02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer.isAttached()) $02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer === null || $02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer === void 0 || $02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
        }, 100);
        else $02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
    } else $02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
}
function $02b8a1de85f2d250$export$d10ae4f68404609a(assertiveness) {
    if ($02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer) $02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer.clear(assertiveness);
}
function $02b8a1de85f2d250$export$d8686216b8b81b2f() {
    if ($02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer) {
        $02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer.destroy();
        $02b8a1de85f2d250$var$$319e236875307eab$var$liveAnnouncer = null;
    }
}
// LiveAnnouncer is implemented using vanilla DOM, not React. That's because as of React 18
// ReactDOM.render is deprecated, and the replacement, ReactDOM.createRoot is moved into a
// subpath import `react-dom/client`. That makes it hard for us to support multiple React versions.
// As a global API, we can't use portals without introducing a breaking API change. LiveAnnouncer
// is simple enough to implement without React, so that's what we do here.
// See this discussion for more details: https://github.com/reactwg/react-18/discussions/125#discussioncomment-2382638
class $02b8a1de85f2d250$var$$319e236875307eab$var$LiveAnnouncer {
    isAttached() {
        var _this_node;
        return (_this_node = this.node) === null || _this_node === void 0 ? void 0 : _this_node.isConnected;
    }
    createLog(ariaLive) {
        let node = document.createElement('div');
        node.setAttribute('role', 'log');
        node.setAttribute('aria-live', ariaLive);
        node.setAttribute('aria-relevant', 'additions');
        return node;
    }
    destroy() {
        if (!this.node) return;
        document.body.removeChild(this.node);
        this.node = null;
    }
    announce(message, assertiveness = 'assertive', timeout = $02b8a1de85f2d250$var$$319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
        var _this_assertiveLog, _this_politeLog;
        if (!this.node) return;
        let node = document.createElement('div');
        if (typeof message === 'object') {
            // To read an aria-labelledby, the element must have an appropriate role, such as img.
            node.setAttribute('role', 'img');
            node.setAttribute('aria-labelledby', message['aria-labelledby']);
        } else node.textContent = message;
        if (assertiveness === 'assertive') (_this_assertiveLog = this.assertiveLog) === null || _this_assertiveLog === void 0 || _this_assertiveLog.appendChild(node);
        else (_this_politeLog = this.politeLog) === null || _this_politeLog === void 0 || _this_politeLog.appendChild(node);
        if (message !== '') setTimeout(()=>{
            node.remove();
        }, timeout);
    }
    clear(assertiveness) {
        if (!this.node) return;
        if ((!assertiveness || assertiveness === 'assertive') && this.assertiveLog) this.assertiveLog.innerHTML = '';
        if ((!assertiveness || assertiveness === 'polite') && this.politeLog) this.politeLog.innerHTML = '';
    }
    constructor(){
        this.node = null;
        this.assertiveLog = null;
        this.politeLog = null;
        if (typeof document !== 'undefined') {
            this.node = document.createElement('div');
            this.node.dataset.liveAnnouncer = 'true';
            // copied from VisuallyHidden
            Object.assign(this.node.style, {
                border: 0,
                clip: 'rect(0 0 0 0)',
                clipPath: 'inset(50%)',
                height: '1px',
                margin: '-1px',
                overflow: 'hidden',
                padding: 0,
                position: 'absolute',
                width: '1px',
                whiteSpace: 'nowrap'
            });
            this.assertiveLog = this.createLog('assertive');
            this.node.appendChild(this.assertiveLog);
            this.politeLog = this.createLog('polite');
            this.node.appendChild(this.politeLog);
            document.body.prepend(this.node);
        }
    }
}

});

parcelRegister("Dyv4Q", function(module, exports) {

$parcel$export(module.exports, "useButton", function () { return $14d9b60c240a9a61$export$ea18c227d4417cc3; });

var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");

var $6HV86 = parcelRequire("6HV86");

var $b3OV8 = parcelRequire("b3OV8");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $14d9b60c240a9a61$export$ea18c227d4417cc3(props, ref) {
    let { elementType: elementType = 'button', isDisabled: isDisabled, onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, onPressChange: onPressChange, preventFocusOnPress: preventFocusOnPress, allowFocusWhenDisabled: allowFocusWhenDisabled, onClick: deprecatedOnClick, href: href, target: target, rel: rel, type: type = 'button' } = props;
    let additionalProps;
    if (elementType === 'button') additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: 'button',
        tabIndex: isDisabled ? undefined : 0,
        href: elementType === 'a' && !isDisabled ? href : undefined,
        target: elementType === 'a' ? target : undefined,
        type: elementType === 'input' ? type : undefined,
        disabled: elementType === 'input' ? isDisabled : undefined,
        'aria-disabled': !isDisabled || elementType === 'input' ? undefined : isDisabled,
        rel: elementType === 'a' ? rel : undefined
    };
    let { pressProps: pressProps, isPressed: isPressed } = (0, $b3OV8.usePress)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        ref: ref
    });
    let { focusableProps: focusableProps } = (0, $6HV86.useFocusable)(props, ref);
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    let buttonProps = (0, $hAxtE.mergeProps)(focusableProps, pressProps, (0, $bG0JH.filterDOMProps)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: (0, $hAxtE.mergeProps)(additionalProps, buttonProps, {
            'aria-haspopup': props['aria-haspopup'],
            'aria-expanded': props['aria-expanded'],
            'aria-controls': props['aria-controls'],
            'aria-pressed': props['aria-pressed'],
            onClick: (e)=>{
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn('onClick is deprecated, please use onPress');
                }
            }
        })
    };
}

});
parcelRegister("6HV86", function(module, exports) {

$parcel$export(module.exports, "useFocusable", function () { return $5dac525f7664525e$export$4c014de7c8940b4c; });

var $bQDsd = parcelRequire("bQDsd");

var $hAxtE = parcelRequire("hAxtE");
var $jyDr8 = parcelRequire("jyDr8");
var $f4N4u = parcelRequire("f4N4u");

var $bh6RR = parcelRequire("bh6RR");

var $3IQLS = parcelRequire("3IQLS");
var $jxA49 = parcelRequire("jxA49");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $5dac525f7664525e$var$$e6afbd83fe6ebbd2$var$FocusableContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $5dac525f7664525e$var$$e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    let context = (0, $bh6RR.useContext)($5dac525f7664525e$var$$e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, $f4N4u.useSyncRef)(context, ref);
    // eslint-disable-next-line
    let { ref: _, ...otherProps } = context;
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $5dac525f7664525e$var$$e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    let { children: children, ...otherProps } = props;
    let objRef = (0, $jyDr8.useObjectRef)(ref);
    let context = {
        ...otherProps,
        ref: objRef
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($5dac525f7664525e$var$$e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
let $5dac525f7664525e$export$13f3202a3e5ddd5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef($5dac525f7664525e$var$$e6afbd83fe6ebbd2$var$FocusableProvider);
function $5dac525f7664525e$export$4c014de7c8940b4c(props, domRef) {
    let { focusProps: focusProps } = (0, $3IQLS.useFocus)(props);
    let { keyboardProps: keyboardProps } = (0, $jxA49.useKeyboard)(props);
    let interactions = (0, $hAxtE.mergeProps)(focusProps, keyboardProps);
    let domProps = $5dac525f7664525e$var$$e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    let interactionProps = props.isDisabled ? {} : domProps;
    let autoFocusRef = (0, $bh6RR.useRef)(props.autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current && domRef.current) (0, $bQDsd.focusSafely)(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, $hAxtE.mergeProps)({
            ...interactions,
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }, interactionProps)
    };
}

});
parcelRegister("bQDsd", function(module, exports) {

$parcel$export(module.exports, "focusSafely", function () { return $d86ced332b2818aa$export$80f3e147d781571c; });

var $50qTn = parcelRequire("50qTn");
var $evWQs = parcelRequire("evWQs");
var $lXlUU = parcelRequire("lXlUU");

var $8tXMg = parcelRequire("8tXMg");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d86ced332b2818aa$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $evWQs.getOwnerDocument)(element);
    if ((0, $8tXMg.getInteractionModality)() === 'virtual') {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $lXlUU.runAfterTransition)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $50qTn.focusWithoutScrolling)(element);
        });
    } else (0, $50qTn.focusWithoutScrolling)(element);
}

});
parcelRegister("evWQs", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", function () { return $56dd1de415e8947a$export$b204af158042fbac; });
$parcel$export(module.exports, "getOwnerWindow", function () { return $56dd1de415e8947a$export$f21a1ffae260145a; });
const $56dd1de415e8947a$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $56dd1de415e8947a$export$f21a1ffae260145a = (el)=>{
    if (el && 'window' in el && el.window === el) return el;
    const doc = $56dd1de415e8947a$export$b204af158042fbac(el);
    return doc.defaultView || window;
};

});

parcelRegister("lXlUU", function(module, exports) {

$parcel$export(module.exports, "runAfterTransition", function () { return $eb3aea2686dd7d0a$export$24490316f764c430; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === 'undefined') return;
    function isTransitionEvent(event) {
        return 'propertyName' in event;
    }
    let onTransitionStart = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Add the transitioning property to the list for this element.
        let transitions = $eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener('transitioncancel', onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Remove property from list of transitioning properties.
        let properties = $eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener('transitioncancel', onTransitionEnd);
            $eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener('transitionrun', onTransitionStart);
    document.body.addEventListener('transitionend', onTransitionEnd);
}
if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') $eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener('DOMContentLoaded', $eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $eb3aea2686dd7d0a$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $eb3aea2686dd7d0a$var$$bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}

});

parcelRegister("8tXMg", function(module, exports) {

$parcel$export(module.exports, "isFocusVisible", function () { return $0a8f1aa1c6481d29$export$b9b3dfddab17db27; });
$parcel$export(module.exports, "getInteractionModality", function () { return $0a8f1aa1c6481d29$export$630ff653c5ada6a9; });
$parcel$export(module.exports, "setInteractionModality", function () { return $0a8f1aa1c6481d29$export$8397ddfc504fdb9a; });
$parcel$export(module.exports, "useInteractionModality", function () { return $0a8f1aa1c6481d29$export$98e20ec92f614cfe; });
$parcel$export(module.exports, "useFocusVisibleListener", function () { return $0a8f1aa1c6481d29$export$ec71b4b83ac08ec3; });

var $evWQs = parcelRequire("evWQs");
var $be6XU = parcelRequire("be6XU");
var $fRn3Q = parcelRequire("fRn3Q");

var $bh6RR = parcelRequire("bh6RR");

var $gFA2q = parcelRequire("gFA2q");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$currentModality = null;
let $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $0a8f1aa1c6481d29$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $be6XU.isMac)() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$currentModality = 'keyboard';
        $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$triggerChangeHandlers('keyboard', e);
    }
}
function $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$currentModality = 'pointer';
    if (e.type === 'mousedown' || e.type === 'pointerdown') {
        $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$triggerChangeHandlers('pointer', e);
    }
}
function $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $fRn3Q.isVirtualClick)(e)) {
        $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$currentModality = 'virtual';
    }
}
function $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$currentModality = 'virtual';
        $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$triggerChangeHandlers('virtual', e);
    }
    $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === 'undefined' || $0a8f1aa1c6481d29$export$d90243b58daecda7.get((0, $evWQs.getOwnerWindow)(element))) return;
    const windowObject = (0, $evWQs.getOwnerWindow)(element);
    const documentObject = (0, $evWQs.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener('keydown', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener('keyup', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener('click', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener('focus', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener('blur', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.addEventListener('pointerdown', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('pointermove', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('pointerup', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener('mousedown', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('mousemove', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('mouseup', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener('beforeunload', ()=>{
        $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $0a8f1aa1c6481d29$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $evWQs.getOwnerWindow)(element);
    const documentObject = (0, $evWQs.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener('DOMContentLoaded', loadListener);
    if (!$0a8f1aa1c6481d29$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $0a8f1aa1c6481d29$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener('keydown', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('keyup', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('click', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener('focus', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener('blur', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.removeEventListener('pointerdown', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointermove', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointerup', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener('mousedown', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('mousemove', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('mouseup', $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $0a8f1aa1c6481d29$export$d90243b58daecda7.delete(windowObject);
};
function $0a8f1aa1c6481d29$export$2f1888112f558a7d(element) {
    const documentObject = (0, $evWQs.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== 'loading') $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener('DOMContentLoaded', loadListener);
    }
    return ()=>$0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== 'undefined') $0a8f1aa1c6481d29$export$2f1888112f558a7d();
function $0a8f1aa1c6481d29$export$b9b3dfddab17db27() {
    return $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$currentModality !== 'pointer';
}
function $0a8f1aa1c6481d29$export$630ff653c5ada6a9() {
    return $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$currentModality;
}
function $0a8f1aa1c6481d29$export$8397ddfc504fdb9a(modality) {
    $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$currentModality = modality;
    $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $0a8f1aa1c6481d29$export$98e20ec92f614cfe() {
    $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $bh6RR.useState)($0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$currentModality);
    (0, $bh6RR.useEffect)(()=>{
        let handler = ()=>{
            setModality($0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$currentModality);
        };
        $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $gFA2q.useIsSSR)() ? null : modality;
}
const $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== 'undefined' ? (0, $evWQs.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== 'undefined' ? (0, $evWQs.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== 'undefined' ? (0, $evWQs.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== 'undefined' ? (0, $evWQs.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === 'keyboard' && e instanceof IKeyboardEvent && !$0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $0a8f1aa1c6481d29$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(autoFocus || $0a8f1aa1c6481d29$export$b9b3dfddab17db27());
    $0a8f1aa1c6481d29$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $0a8f1aa1c6481d29$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $bh6RR.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($0a8f1aa1c6481d29$export$b9b3dfddab17db27());
        };
        $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $0a8f1aa1c6481d29$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});
parcelRegister("fRn3Q", function(module, exports) {

$parcel$export(module.exports, "isVirtualClick", function () { return $2a1ee504b07ad6f6$export$60278871457622de; });
$parcel$export(module.exports, "isVirtualPointerEvent", function () { return $2a1ee504b07ad6f6$export$29bf1b5f2c56cf63; });

var $be6XU = parcelRequire("be6XU");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2a1ee504b07ad6f6$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $be6XU.isAndroid)() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $2a1ee504b07ad6f6$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $be6XU.isAndroid)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse';
}

});



parcelRegister("f4N4u", function(module, exports) {

$parcel$export(module.exports, "useSyncRef", function () { return $bd7d5a9b12a0a5cb$export$4debdb1a3f0fa79e; });

var $f2PTm = parcelRequire("f2PTm");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bd7d5a9b12a0a5cb$export$4debdb1a3f0fa79e(context, ref) {
    (0, $f2PTm.useLayoutEffect)(()=>{
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return ()=>{
                if (context.ref) context.ref.current = null;
            };
        }
    });
}

});

parcelRegister("3IQLS", function(module, exports) {

$parcel$export(module.exports, "useFocus", function () { return $3e217408b290fbf5$export$f8168d8dd8fd66e6; });

var $iX0pr = parcelRequire("iX0pr");

var $bh6RR = parcelRequire("bh6RR");

var $evWQs = parcelRequire("evWQs");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $3e217408b290fbf5$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $bh6RR.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $iX0pr.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $evWQs.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("iX0pr", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", function () { return $3095f83b002739b5$export$715c682d09d639cc; });

var $bh6RR = parcelRequire("bh6RR");

var $i7SiA = parcelRequire("i7SiA");
var $f2PTm = parcelRequire("f2PTm");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $3095f83b002739b5$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $3095f83b002739b5$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $bh6RR.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $f2PTm.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $i7SiA.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $bh6RR.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $3095f83b002739b5$export$905e7fc544a71f36('blur', e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener('focusout', onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent('blur', {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent('focusout', {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    'disabled'
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});


parcelRegister("jxA49", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", function () { return $94bed3e43935bcc9$export$8f71654801c2f7cd; });

var $8WtIB = parcelRequire("8WtIB");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $94bed3e43935bcc9$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: (0, $8WtIB.createEventHandler)(props.onKeyDown),
            onKeyUp: (0, $8WtIB.createEventHandler)(props.onKeyUp)
        }
    };
}

});
parcelRegister("8WtIB", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", function () { return $7d665fd866a647c0$export$48d1ea6320830260; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7d665fd866a647c0$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    let shouldStopPropagation = true;
    return (e)=>{
        let event = {
            ...e,
            preventDefault () {
                e.preventDefault();
            },
            isDefaultPrevented () {
                return e.isDefaultPrevented();
            },
            stopPropagation () {
                console.error('stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.');
            },
            continuePropagation () {
                shouldStopPropagation = false;
            }
        };
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}

});



parcelRegister("b3OV8", function(module, exports) {

$parcel$export(module.exports, "usePress", function () { return $90840aefb9830627$export$45712eceda6fad21; });

var $e4uYM = parcelRequire("e4uYM");

var $6zN4N = parcelRequire("6zN4N");

var $2iPDq = parcelRequire("2iPDq");

var $f9kyn = parcelRequire("f9kyn");

var $lgPAm = parcelRequire("lgPAm");

var $jQZLC = parcelRequire("jQZLC");
var $50qTn = parcelRequire("50qTn");
var $evWQs = parcelRequire("evWQs");
var $be6XU = parcelRequire("be6XU");
var $fRn3Q = parcelRequire("fRn3Q");
var $hAxtE = parcelRequire("hAxtE");
var $gN5ZC = parcelRequire("gN5ZC");
var $i7SiA = parcelRequire("i7SiA");
var $foRcG = parcelRequire("foRcG");
var $f4N4u = parcelRequire("f4N4u");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $90840aefb9830627$var$$f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    let context = (0, $bh6RR.useContext)((0, $6zN4N.PressResponderContext));
    if (context) {
        let { register: register, ...contextProps } = context;
        props = (0, $hAxtE.mergeProps)(contextProps, props);
        register();
    }
    (0, $f4N4u.useSyncRef)(context, props.ref);
    return props;
}
var $90840aefb9830627$var$$f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
class $90840aefb9830627$var$$f6c31cce2adf654f$var$PressEvent {
    continuePropagation() {
        (0, $lgPAm._)(this, $90840aefb9830627$var$$f6c31cce2adf654f$var$_shouldStopPropagation, false);
    }
    get shouldStopPropagation() {
        return (0, $2iPDq._)(this, $90840aefb9830627$var$$f6c31cce2adf654f$var$_shouldStopPropagation);
    }
    constructor(type, pointerType, originalEvent, state){
        (0, $f9kyn._)(this, $90840aefb9830627$var$$f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, $lgPAm._)(this, $90840aefb9830627$var$$f6c31cce2adf654f$var$_shouldStopPropagation, true);
        var _state_target;
        let currentTarget = (_state_target = state === null || state === void 0 ? void 0 : state.target) !== null && _state_target !== void 0 ? _state_target : originalEvent.currentTarget;
        const rect = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.getBoundingClientRect();
        let x, y = 0;
        let clientX, clientY = null;
        if (originalEvent.clientX != null && originalEvent.clientY != null) {
            clientX = originalEvent.clientX;
            clientY = originalEvent.clientY;
        }
        if (rect) {
            if (clientX != null && clientY != null) {
                x = clientX - rect.left;
                y = clientY - rect.top;
            } else {
                x = rect.width / 2;
                y = rect.height / 2;
            }
        }
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
        this.x = x;
        this.y = y;
    }
}
const $90840aefb9830627$var$$f6c31cce2adf654f$var$LINK_CLICKED = Symbol('linkClicked');
function $90840aefb9830627$export$45712eceda6fad21(props) {
    let { onPress: onPress, onPressChange: onPressChange, onPressStart: onPressStart, onPressEnd: onPressEnd, onPressUp: onPressUp, isDisabled: isDisabled, isPressed: isPressedProp, preventFocusOnPress: preventFocusOnPress, shouldCancelOnPointerExit: shouldCancelOnPointerExit, allowTextSelectionOnPress: allowTextSelectionOnPress, ref: _, ...domProps } = $90840aefb9830627$var$$f6c31cce2adf654f$var$usePressResponderContext(props);
    let [isPressed, setPressed] = (0, $bh6RR.useState)(false);
    let ref = (0, $bh6RR.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $foRcG.useGlobalListeners)();
    let triggerPressStart = (0, $i7SiA.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        let shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            let event = new $90840aefb9830627$var$$f6c31cce2adf654f$var$PressEvent('pressstart', pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    let triggerPressEnd = (0, $i7SiA.useEffectEvent)((originalEvent, pointerType, wasPressed = true)=>{
        let state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        let shouldStopPropagation = true;
        if (onPressEnd) {
            let event = new $90840aefb9830627$var$$f6c31cce2adf654f$var$PressEvent('pressend', pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            let event = new $90840aefb9830627$var$$f6c31cce2adf654f$var$PressEvent('press', pointerType, originalEvent);
            onPress(event);
            shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    let triggerPressUp = (0, $i7SiA.useEffectEvent)((originalEvent, pointerType)=>{
        let state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            let event = new $90840aefb9830627$var$$f6c31cce2adf654f$var$PressEvent('pressup', pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    let cancel = (0, $i7SiA.useEffectEvent)((e)=>{
        let state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($90840aefb9830627$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) (0, $e4uYM.restoreTextSelection)(state.target);
        }
    });
    let cancelOnPointerExit = (0, $i7SiA.useEffectEvent)((e)=>{
        if (shouldCancelOnPointerExit) cancel(e);
    });
    let pressProps = (0, $bh6RR.useMemo)(()=>{
        let state = ref.current;
        let pressProps = {
            onKeyDown (e) {
                if ($90840aefb9830627$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($90840aefb9830627$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    let shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, 'keyboard');
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        let originalTarget = e.currentTarget;
                        let pressUp = (e)=>{
                            if ($90840aefb9830627$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($90840aefb9830627$var$$f6c31cce2adf654f$var$createEvent(state.target, e), 'keyboard');
                        };
                        addGlobalListener((0, $evWQs.getOwnerDocument)(e.currentTarget), 'keyup', (0, $jQZLC.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, $be6XU.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === 'Meta') state.metaKeyEvents = new Map();
            },
            onClick (e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, $gN5ZC.openLink).isOpening) {
                    let shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === 'virtual' || (0, $fRn3Q.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, $50qTn.focusWithoutScrolling)(e.currentTarget);
                        let stopPressStart = triggerPressStart(e, 'virtual');
                        let stopPressUp = triggerPressUp(e, 'virtual');
                        let stopPressEnd = triggerPressEnd(e, 'virtual');
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        let onKeyUp = (e)=>{
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $90840aefb9830627$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($90840aefb9830627$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                let target = e.target;
                triggerPressEnd($90840aefb9830627$var$$f6c31cce2adf654f$var$createEvent(state.target, e), 'keyboard', state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== 'Enter' && $90840aefb9830627$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$90840aefb9830627$var$$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$90840aefb9830627$var$$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, $gN5ZC.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === 'Meta' && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                let events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                for (let event of events.values())(_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent('keyup', event));
            }
        };
        if (typeof PointerEvent !== 'undefined') {
            pressProps.onPointerDown = (e)=>{
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, $fRn3Q.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = 'virtual';
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($90840aefb9830627$var$$f6c31cce2adf654f$var$shouldPreventDefaultDown(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                let shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, $50qTn.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) (0, $e4uYM.disableTextSelection)(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, $evWQs.getOwnerDocument)(e.currentTarget), 'pointermove', onPointerMove, false);
                    addGlobalListener((0, $evWQs.getOwnerDocument)(e.currentTarget), 'pointerup', onPointerUp, false);
                    addGlobalListener((0, $evWQs.getOwnerDocument)(e.currentTarget), 'pointercancel', onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($90840aefb9830627$var$$f6c31cce2adf654f$var$shouldPreventDefaultDown(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = (e)=>{
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === 'virtual') return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $90840aefb9830627$var$$f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            let onPointerMove = (e)=>{
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $90840aefb9830627$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($90840aefb9830627$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($90840aefb9830627$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($90840aefb9830627$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($90840aefb9830627$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($90840aefb9830627$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) (0, $e4uYM.restoreTextSelection)(state.target);
                    // Prevent subsequent touchend event from triggering onClick on unrelated elements on Android. See below.
                    // Both 'touch' and 'pen' pointerTypes trigger onTouchEnd, but 'mouse' does not.
                    if ('ontouchend' in state.target && e.pointerType !== 'mouse') addGlobalListener(state.target, 'touchend', onTouchEnd, {
                        once: true
                    });
                }
            };
            // This is a workaround for an Android Chrome/Firefox issue where click events are fired on an incorrect element
            // if the original target is removed during onPointerUp (before onClick).
            // https://github.com/adobe/react-spectrum/issues/1513
            // https://issues.chromium.org/issues/40732224
            // Note: this event must be registered directly on the element, not via React props in order to work.
            // https://github.com/facebook/react/issues/9809
            let onTouchEnd = (e)=>{
                // Don't preventDefault if we actually want the default (e.g. submit/link click).
                if ($90840aefb9830627$var$$f6c31cce2adf654f$var$shouldPreventDefaultUp(e.currentTarget)) e.preventDefault();
            };
            let onPointerCancel = (e)=>{
                cancel(e);
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = (e)=>{
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($90840aefb9830627$var$$f6c31cce2adf654f$var$shouldPreventDefaultDown(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, $fRn3Q.isVirtualClick)(e.nativeEvent) ? 'virtual' : 'mouse';
                if (!isDisabled && !preventFocusOnPress) (0, $50qTn.focusWithoutScrolling)(e.currentTarget);
                let shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $evWQs.getOwnerDocument)(e.currentTarget), 'mouseup', onMouseUp, false);
            };
            pressProps.onMouseEnter = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || 'mouse');
            };
            let onMouseUp = (e)=>{
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $90840aefb9830627$var$$f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($90840aefb9830627$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($90840aefb9830627$var$$f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                let touch = $90840aefb9830627$var$$f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = 'touch';
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, $50qTn.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) (0, $e4uYM.disableTextSelection)(state.target);
                let shouldStopPropagation = triggerPressStart($90840aefb9830627$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, $evWQs.getOwnerWindow)(e.currentTarget), 'scroll', onScroll, true);
            };
            pressProps.onTouchMove = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $90840aefb9830627$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $90840aefb9830627$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart($90840aefb9830627$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd($90840aefb9830627$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit($90840aefb9830627$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e));
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                let touch = $90840aefb9830627$var$$f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                let shouldStopPropagation = true;
                if (touch && $90840aefb9830627$var$$f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp($90840aefb9830627$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
                    shouldStopPropagation = triggerPressEnd($90840aefb9830627$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd($90840aefb9830627$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) (0, $e4uYM.restoreTextSelection)(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel($90840aefb9830627$var$$f6c31cce2adf654f$var$createTouchEvent(state.target, e));
            };
            let onScroll = (e)=>{
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = (e)=>{
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            var _ref_current_target;
            if (!allowTextSelectionOnPress) (0, $e4uYM.restoreTextSelection)((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, $hAxtE.mergeProps)(domProps, pressProps)
    };
}
function $90840aefb9830627$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === 'A' && target.hasAttribute('href');
}
function $90840aefb9830627$var$$f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    const { key: key, code: code } = event;
    const element = currentTarget;
    const role = element.getAttribute('role');
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === 'Enter' || key === ' ' || key === 'Spacebar' || code === 'Space') && !(element instanceof (0, $evWQs.getOwnerWindow)(element).HTMLInputElement && !$90840aefb9830627$var$$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, $evWQs.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === 'link' || !role && $90840aefb9830627$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== 'Enter');
}
function $90840aefb9830627$var$$f6c31cce2adf654f$var$getTouchFromEvent(event) {
    const { targetTouches: targetTouches } = event;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $90840aefb9830627$var$$f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    const changedTouches = event.changedTouches;
    for(let i = 0; i < changedTouches.length; i++){
        const touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $90840aefb9830627$var$$f6c31cce2adf654f$var$createTouchEvent(target, e) {
    let clientX = 0;
    let clientY = 0;
    if (e.targetTouches && e.targetTouches.length === 1) {
        clientX = e.targetTouches[0].clientX;
        clientY = e.targetTouches[0].clientY;
    }
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $90840aefb9830627$var$$f6c31cce2adf654f$var$createEvent(target, e) {
    let clientX = e.clientX;
    let clientY = e.clientY;
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        clientX: clientX,
        clientY: clientY
    };
}
function $90840aefb9830627$var$$f6c31cce2adf654f$var$getPointClientRect(point) {
    let offsetX = 0;
    let offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $90840aefb9830627$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $90840aefb9830627$var$$f6c31cce2adf654f$var$isOverTarget(point, target) {
    let rect = target.getBoundingClientRect();
    let pointRect = $90840aefb9830627$var$$f6c31cce2adf654f$var$getPointClientRect(point);
    return $90840aefb9830627$var$$f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $90840aefb9830627$var$$f6c31cce2adf654f$var$shouldPreventDefaultDown(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute('draggable');
}
function $90840aefb9830627$var$$f6c31cce2adf654f$var$shouldPreventDefaultUp(target) {
    if (target instanceof HTMLInputElement) return false;
    if (target instanceof HTMLButtonElement) return target.type !== 'submit' && target.type !== 'reset';
    if ($90840aefb9830627$var$$f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
function $90840aefb9830627$var$$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$90840aefb9830627$var$$f6c31cce2adf654f$var$isValidInputKey(target, key);
    return $90840aefb9830627$var$$f6c31cce2adf654f$var$shouldPreventDefaultUp(target);
}
const $90840aefb9830627$var$$f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function $90840aefb9830627$var$$f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === 'checkbox' || target.type === 'radio' ? key === ' ' : $90840aefb9830627$var$$f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}

});
parcelRegister("e4uYM", function(module, exports) {

$parcel$export(module.exports, "disableTextSelection", function () { return $370d11962c17742d$export$16a4697467175487; });
$parcel$export(module.exports, "restoreTextSelection", function () { return $370d11962c17742d$export$b0d6fa1ab32e3295; });

var $evWQs = parcelRequire("evWQs");
var $be6XU = parcelRequire("be6XU");
var $lXlUU = parcelRequire("lXlUU");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
let $370d11962c17742d$var$$14c0b72509d70225$var$state = 'default';
let $370d11962c17742d$var$$14c0b72509d70225$var$savedUserSelect = '';
let $370d11962c17742d$var$$14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $370d11962c17742d$export$16a4697467175487(target) {
    if ((0, $be6XU.isIOS)()) {
        if ($370d11962c17742d$var$$14c0b72509d70225$var$state === 'default') {
            const documentObject = (0, $evWQs.getOwnerDocument)(target);
            $370d11962c17742d$var$$14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = 'none';
        }
        $370d11962c17742d$var$$14c0b72509d70225$var$state = 'disabled';
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $370d11962c17742d$var$$14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = 'none';
    }
}
function $370d11962c17742d$export$b0d6fa1ab32e3295(target) {
    if ((0, $be6XU.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($370d11962c17742d$var$$14c0b72509d70225$var$state !== 'disabled') return;
        $370d11962c17742d$var$$14c0b72509d70225$var$state = 'restoring';
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(()=>{
            (0, $lXlUU.runAfterTransition)(()=>{
                // Avoid race conditions
                if ($370d11962c17742d$var$$14c0b72509d70225$var$state === 'restoring') {
                    const documentObject = (0, $evWQs.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === 'none') documentObject.documentElement.style.webkitUserSelect = $370d11962c17742d$var$$14c0b72509d70225$var$savedUserSelect || '';
                    $370d11962c17742d$var$$14c0b72509d70225$var$savedUserSelect = '';
                    $370d11962c17742d$var$$14c0b72509d70225$var$state = 'default';
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $370d11962c17742d$var$$14c0b72509d70225$var$modifiedElementMap.has(target)) {
            let targetOldUserSelect = $370d11962c17742d$var$$14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === 'none') target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute('style') === '') target.removeAttribute('style');
            $370d11962c17742d$var$$14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}

});

parcelRegister("6zN4N", function(module, exports) {

$parcel$export(module.exports, "PressResponderContext", function () { return $9a391e6d8ac20bb0$export$5165eccb35aaadb5; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9a391e6d8ac20bb0$export$5165eccb35aaadb5 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    register: ()=>{}
});
$9a391e6d8ac20bb0$export$5165eccb35aaadb5.displayName = 'PressResponderContext';

});

parcelRegister("2iPDq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1ad550d5c291b3dc$export$71511d61b312f219; });

var $30qZj = parcelRequire("30qZj");

var $beDys = parcelRequire("beDys");
function $1ad550d5c291b3dc$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $beDys._)(receiver, privateMap, "get");
    return (0, $30qZj._)(receiver, descriptor);
}

});
parcelRegister("30qZj", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $23064e67de588bbb$export$71511d61b312f219; });
function $23064e67de588bbb$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

});

parcelRegister("beDys", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $82dfaf3e78086f9a$export$71511d61b312f219; });
function $82dfaf3e78086f9a$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

});


parcelRegister("f9kyn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b077a3c21f489735$export$71511d61b312f219; });

var $8uPsV = parcelRequire("8uPsV");
function $b077a3c21f489735$export$71511d61b312f219(obj, privateMap, value) {
    (0, $8uPsV._)(obj, privateMap);
    privateMap.set(obj, value);
}

});
parcelRegister("8uPsV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $62f90c0da26e8f0e$export$71511d61b312f219; });
function $62f90c0da26e8f0e$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

});


parcelRegister("lgPAm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f7c31b625f5de596$export$71511d61b312f219; });

var $lp604 = parcelRequire("lp604");

var $beDys = parcelRequire("beDys");
function $f7c31b625f5de596$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $beDys._)(receiver, privateMap, "set");
    (0, $lp604._)(receiver, descriptor, value);
    return value;
}

});
parcelRegister("lp604", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f950964663165d03$export$71511d61b312f219; });
function $f950964663165d03$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

});


parcelRegister("foRcG", function(module, exports) {

$parcel$export(module.exports, "useGlobalListeners", function () { return $0062b6399d9ff432$export$4eaf04e54aa8eed6; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0062b6399d9ff432$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $bh6RR.useRef)(new Map());
    let addGlobalListener = (0, $bh6RR.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    let removeGlobalListener = (0, $bh6RR.useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $bh6RR.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}

});



parcelRegister("5Gawp", function(module, exports) {

$parcel$export(module.exports, "useFocusRing", function () { return $2994900c3246b3a8$export$4e328f61c538687f; });

var $8tXMg = parcelRequire("8tXMg");
var $3IQLS = parcelRequire("3IQLS");
var $fmkmo = parcelRequire("fmkmo");

var $bh6RR = parcelRequire("bh6RR");
function $2994900c3246b3a8$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $bh6RR.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $8tXMg.isFocusVisible)()
    });
    let [isFocused, setFocused] = (0, $bh6RR.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $bh6RR.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $bh6RR.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $bh6RR.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $8tXMg.useFocusVisibleListener)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $3IQLS.useFocus)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $fmkmo.useFocusWithin)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}

});
parcelRegister("fmkmo", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", function () { return $e72a27dfea2d290a$export$420e68273165f4ec; });

var $iX0pr = parcelRequire("iX0pr");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $e72a27dfea2d290a$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $bh6RR.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $bh6RR.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $iX0pr.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $bh6RR.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});


parcelRegister("i91F7", function(module, exports) {

$parcel$export(module.exports, "useHover", function () { return $75d36c9a40d773dd$export$ae780daf29e6d456; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $75d36c9a40d773dd$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $75d36c9a40d773dd$var$$6179b936705e76d3$var$hoverCount = 0;
function $75d36c9a40d773dd$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $75d36c9a40d773dd$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $75d36c9a40d773dd$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $75d36c9a40d773dd$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === 'touch') $75d36c9a40d773dd$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $75d36c9a40d773dd$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === 'undefined') return;
    if (typeof PointerEvent !== 'undefined') document.addEventListener('pointerup', $75d36c9a40d773dd$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener('touchend', $75d36c9a40d773dd$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $75d36c9a40d773dd$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $75d36c9a40d773dd$var$$6179b936705e76d3$var$hoverCount--;
        if ($75d36c9a40d773dd$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== 'undefined') document.removeEventListener('pointerup', $75d36c9a40d773dd$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener('touchend', $75d36c9a40d773dd$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $75d36c9a40d773dd$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $bh6RR.useState)(false);
    let state = (0, $bh6RR.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: '',
        target: null
    }).current;
    (0, $bh6RR.useEffect)($75d36c9a40d773dd$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $bh6RR.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === 'touch' || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: 'hoverstart',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = '';
            state.target = null;
            if (pointerType === 'touch' || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: 'hoverend',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== 'undefined') {
            hoverProps.onPointerEnter = (e)=>{
                if ($75d36c9a40d773dd$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$75d36c9a40d773dd$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, 'mouse');
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, 'mouse');
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $bh6RR.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}

});


parcelRegister("eqvPU", function(module, exports) {

$parcel$export(module.exports, "CollectionBuilder", function () { return $4b914e23d62e1272$export$bf788dd355e3a401; });
$parcel$export(module.exports, "createLeafComponent", function () { return $4b914e23d62e1272$export$18af5c7a9e9b3664; });
$parcel$export(module.exports, "createBranchComponent", function () { return $4b914e23d62e1272$export$e953bb1cd0f19726; });
$parcel$export(module.exports, "Collection", function () { return $4b914e23d62e1272$export$fb8073518f34e6ec; });

var $1dNHT = parcelRequire("1dNHT");

var $2H42j = parcelRequire("2H42j");

var $72X2K = parcelRequire("72X2K");

var $73EHL = parcelRequire("73EHL");

var $6afFj = parcelRequire("6afFj");

var $bh6RR = parcelRequire("bh6RR");

var $gFA2q = parcelRequire("gFA2q");

var $f2PTm = parcelRequire("f2PTm");

var $hVYK3 = parcelRequire("hVYK3");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4b914e23d62e1272$var$$e1995378a142960e$var$ShallowRenderContext = (0, $bh6RR.createContext)(false);
const $4b914e23d62e1272$var$$e1995378a142960e$var$CollectionDocumentContext = (0, $bh6RR.createContext)(null);
function $4b914e23d62e1272$export$bf788dd355e3a401(props) {
    // If a document was provided above us, we're already in a hidden tree. Just render the content.
    let doc = (0, $bh6RR.useContext)($4b914e23d62e1272$var$$e1995378a142960e$var$CollectionDocumentContext);
    if (doc) // even though the actual implementation since React 16 did.
    // We must return ReactElement so that TS does not complain that <CollectionBuilder>
    // is not a valid JSX element with React 16 and 17 types.
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20544
    return props.content;
    // Otherwise, render a hidden copy of the children so that we can build the collection before constructing the state.
    // This should always come before the real DOM content so we have built the collection by the time it renders during SSR.
    // This is fine. CollectionDocumentContext never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let { collection: collection, document: document } = $4b914e23d62e1272$var$$e1995378a142960e$var$useCollectionDocument(props.createCollection);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $73EHL.Hidden), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($4b914e23d62e1272$var$$e1995378a142960e$var$CollectionDocumentContext.Provider, {
        value: document
    }, props.content)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($4b914e23d62e1272$var$$e1995378a142960e$var$CollectionInner, {
        render: props.children,
        collection: collection
    }));
}
function $4b914e23d62e1272$var$$e1995378a142960e$var$CollectionInner({ collection: collection, render: render }) {
    return render(collection);
}
// React 16 and 17 don't support useSyncExternalStore natively, and the shim provided by React does not support getServerSnapshot.
// This wrapper uses the shim, but additionally calls getServerSnapshot during SSR (according to SSRProvider).
function $4b914e23d62e1272$var$$e1995378a142960e$var$useSyncExternalStoreFallback(subscribe, getSnapshot, getServerSnapshot) {
    let isSSR = (0, $gFA2q.useIsSSR)();
    let isSSRRef = (0, $bh6RR.useRef)(isSSR);
    // This is read immediately inside the wrapper, which also runs during render.
    // We just need a ref to avoid invalidating the callback itself, which
    // would cause React to re-run the callback more than necessary.
    // eslint-disable-next-line rulesdir/pure-render
    isSSRRef.current = isSSR;
    let getSnapshotWrapper = (0, $bh6RR.useCallback)(()=>{
        return isSSRRef.current ? getServerSnapshot() : getSnapshot();
    }, [
        getSnapshot,
        getServerSnapshot
    ]);
    return (0, $hVYK3.useSyncExternalStore)(subscribe, getSnapshotWrapper);
}
const $4b914e23d62e1272$var$$e1995378a142960e$var$useSyncExternalStore = typeof (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))['useSyncExternalStore'] === 'function' ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)))['useSyncExternalStore'] : $4b914e23d62e1272$var$$e1995378a142960e$var$useSyncExternalStoreFallback;
function $4b914e23d62e1272$var$$e1995378a142960e$var$useCollectionDocument(createCollection) {
    // The document instance is mutable, and should never change between renders.
    // useSyncExternalStore is used to subscribe to updates, which vends immutable Collection objects.
    let [document] = (0, $bh6RR.useState)(()=>new (0, $2H42j.Document)((createCollection === null || createCollection === void 0 ? void 0 : createCollection()) || new (0, $1dNHT.BaseCollection)()));
    let subscribe = (0, $bh6RR.useCallback)((fn)=>document.subscribe(fn), [
        document
    ]);
    let getSnapshot = (0, $bh6RR.useCallback)(()=>{
        let collection = document.getCollection();
        if (document.isSSR) // We do this _after_ getting the collection above so that the collection still has content in it from SSR
        // during the current render, before React has finished the client render.
        document.resetAfterSSR();
        return collection;
    }, [
        document
    ]);
    let getServerSnapshot = (0, $bh6RR.useCallback)(()=>{
        document.isSSR = true;
        return document.getCollection();
    }, [
        document
    ]);
    let collection = $4b914e23d62e1272$var$$e1995378a142960e$var$useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    (0, $f2PTm.useLayoutEffect)(()=>{
        document.isMounted = true;
        return ()=>{
            // Mark unmounted so we can skip all of the collection updates caused by 
            // React calling removeChild on every item in the collection.
            document.isMounted = false;
        };
    }, [
        document
    ]);
    return {
        collection: collection,
        document: document
    };
}
const $4b914e23d62e1272$var$$e1995378a142960e$var$SSRContext = (0, $bh6RR.createContext)(null);
function $4b914e23d62e1272$var$$e1995378a142960e$var$useSSRCollectionNode(Type, props, ref, rendered, children, render) {
    // During SSR, portals are not supported, so the collection children will be wrapped in an SSRContext.
    // Since SSR occurs only once, we assume that the elements are rendered in order and never re-render.
    // Therefore we can create elements in our collection document during render so that they are in the
    // collection by the time we need to use the collection to render to the real DOM.
    // After hydration, we switch to client rendering using the portal.
    let itemRef = (0, $bh6RR.useCallback)((element)=>{
        element === null || element === void 0 || element.setProps(props, ref, rendered, render);
    }, [
        props,
        ref,
        rendered,
        render
    ]);
    let parentNode = (0, $bh6RR.useContext)($4b914e23d62e1272$var$$e1995378a142960e$var$SSRContext);
    if (parentNode) {
        // Guard against double rendering in strict mode.
        let element = parentNode.ownerDocument.nodesByProps.get(props);
        if (!element) {
            element = parentNode.ownerDocument.createElement(Type);
            element.setProps(props, ref, rendered, render);
            parentNode.appendChild(element);
            parentNode.ownerDocument.updateCollection();
            parentNode.ownerDocument.nodesByProps.set(props, element);
        }
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($4b914e23d62e1272$var$$e1995378a142960e$var$SSRContext.Provider, {
            value: element
        }, children) : null;
    }
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Type, {
        ref: itemRef
    }, children);
}
function $4b914e23d62e1272$export$18af5c7a9e9b3664(type, render) {
    let Component = ({ node: node })=>render(node.props, node.props.ref, node);
    let Result = (0, $bh6RR.forwardRef)((props, ref)=>{
        let isShallow = (0, $bh6RR.useContext)($4b914e23d62e1272$var$$e1995378a142960e$var$ShallowRenderContext);
        if (!isShallow) {
            if (render.length >= 3) throw new Error(render.name + ' cannot be rendered outside a collection.');
            return render(props, ref);
        }
        return $4b914e23d62e1272$var$$e1995378a142960e$var$useSSRCollectionNode(type, props, ref, 'children' in props ? props.children : null, null, (node)=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, {
                node: node
            }));
    });
    // @ts-ignore
    Result.displayName = render.name;
    return Result;
}
function $4b914e23d62e1272$export$e953bb1cd0f19726(type, render, useChildren = $4b914e23d62e1272$var$$e1995378a142960e$var$useCollectionChildren) {
    let Component = ({ node: node })=>render(node.props, node.props.ref, node);
    let Result = (0, $bh6RR.forwardRef)((props, ref)=>{
        let children = useChildren(props);
        var _useSSRCollectionNode;
        return (_useSSRCollectionNode = $4b914e23d62e1272$var$$e1995378a142960e$var$useSSRCollectionNode(type, props, ref, null, children, (node)=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, {
                node: node
            }))) !== null && _useSSRCollectionNode !== void 0 ? _useSSRCollectionNode : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null);
    });
    // @ts-ignore
    Result.displayName = render.name;
    return Result;
}
function $4b914e23d62e1272$var$$e1995378a142960e$var$useCollectionChildren(options) {
    return (0, $72X2K.useCachedChildren)({
        ...options,
        addIdAndValue: true
    });
}
const $4b914e23d62e1272$var$$e1995378a142960e$var$CollectionContext = (0, $bh6RR.createContext)(null);
function $4b914e23d62e1272$export$fb8073518f34e6ec(props) {
    let ctx = (0, $bh6RR.useContext)($4b914e23d62e1272$var$$e1995378a142960e$var$CollectionContext);
    let dependencies = ((ctx === null || ctx === void 0 ? void 0 : ctx.dependencies) || []).concat(props.dependencies);
    let idScope = props.idScope || (ctx === null || ctx === void 0 ? void 0 : ctx.idScope);
    let children = $4b914e23d62e1272$var$$e1995378a142960e$var$useCollectionChildren({
        ...props,
        idScope: idScope,
        dependencies: dependencies
    });
    let doc = (0, $bh6RR.useContext)($4b914e23d62e1272$var$$e1995378a142960e$var$CollectionDocumentContext);
    if (doc) children = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($4b914e23d62e1272$var$$e1995378a142960e$var$CollectionRoot, null, children);
    // Propagate dependencies and idScope to child collections.
    ctx = (0, $bh6RR.useMemo)(()=>({
            dependencies: dependencies,
            idScope: idScope
        }), [
        idScope,
        ...dependencies
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($4b914e23d62e1272$var$$e1995378a142960e$var$CollectionContext.Provider, {
        value: ctx
    }, children);
}
function $4b914e23d62e1272$var$$e1995378a142960e$var$CollectionRoot({ children: children }) {
    let doc = (0, $bh6RR.useContext)($4b914e23d62e1272$var$$e1995378a142960e$var$CollectionDocumentContext);
    let wrappedChildren = (0, $bh6RR.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($4b914e23d62e1272$var$$e1995378a142960e$var$CollectionDocumentContext.Provider, {
            value: null
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($4b914e23d62e1272$var$$e1995378a142960e$var$ShallowRenderContext.Provider, {
            value: true
        }, children)), [
        children
    ]);
    // During SSR, we render the content directly, and append nodes to the document during render.
    // The collection children return null so that nothing is actually rendered into the HTML.
    return (0, $gFA2q.useIsSSR)() ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($4b914e23d62e1272$var$$e1995378a142960e$var$SSRContext.Provider, {
        value: doc
    }, wrappedChildren) : (0, $6afFj.createPortal)(wrappedChildren, doc);
}

});
parcelRegister("1dNHT", function(module, exports) {

$parcel$export(module.exports, "CollectionNode", function () { return $455957c6ad365b38$export$d68d59712b04d9d1; });
$parcel$export(module.exports, "BaseCollection", function () { return $455957c6ad365b38$export$408d25a4e12db025; });
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $455957c6ad365b38$export$d68d59712b04d9d1 {
    get childNodes() {
        throw new Error('childNodes is not supported');
    }
    clone() {
        let node = new $455957c6ad365b38$export$d68d59712b04d9d1(this.type, this.key);
        node.value = this.value;
        node.level = this.level;
        node.hasChildNodes = this.hasChildNodes;
        node.rendered = this.rendered;
        node.textValue = this.textValue;
        node['aria-label'] = this['aria-label'];
        node.index = this.index;
        node.parentKey = this.parentKey;
        node.prevKey = this.prevKey;
        node.nextKey = this.nextKey;
        node.firstChildKey = this.firstChildKey;
        node.lastChildKey = this.lastChildKey;
        node.props = this.props;
        node.render = this.render;
        return node;
    }
    constructor(type, key){
        this.value = null;
        this.level = 0;
        this.hasChildNodes = false;
        this.rendered = null;
        this.textValue = '';
        this['aria-label'] = undefined;
        this.index = 0;
        this.parentKey = null;
        this.prevKey = null;
        this.nextKey = null;
        this.firstChildKey = null;
        this.lastChildKey = null;
        this.props = {};
        this.type = type;
        this.key = key;
    }
}
class $455957c6ad365b38$export$408d25a4e12db025 {
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    *[Symbol.iterator]() {
        let node = this.firstKey != null ? this.keyMap.get(this.firstKey) : undefined;
        while(node){
            yield node;
            node = node.nextKey != null ? this.keyMap.get(node.nextKey) : undefined;
        }
    }
    getChildren(key) {
        let keyMap = this.keyMap;
        return {
            *[Symbol.iterator] () {
                let parent = keyMap.get(key);
                let node = (parent === null || parent === void 0 ? void 0 : parent.firstChildKey) != null ? keyMap.get(parent.firstChildKey) : null;
                while(node){
                    yield node;
                    node = node.nextKey != null ? keyMap.get(node.nextKey) : undefined;
                }
            }
        };
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        if (!node) return null;
        if (node.prevKey != null) {
            node = this.keyMap.get(node.prevKey);
            while(node && node.type !== 'item' && node.lastChildKey != null)node = this.keyMap.get(node.lastChildKey);
            var _node_key;
            return (_node_key = node === null || node === void 0 ? void 0 : node.key) !== null && _node_key !== void 0 ? _node_key : null;
        }
        return node.parentKey;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        if (!node) return null;
        if (node.type !== 'item' && node.firstChildKey != null) return node.firstChildKey;
        while(node){
            if (node.nextKey != null) return node.nextKey;
            if (node.parentKey != null) node = this.keyMap.get(node.parentKey);
            else return null;
        }
        return null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        let node = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
        while((node === null || node === void 0 ? void 0 : node.lastChildKey) != null)node = this.keyMap.get(node.lastChildKey);
        var _node_key;
        return (_node_key = node === null || node === void 0 ? void 0 : node.key) !== null && _node_key !== void 0 ? _node_key : null;
    }
    getItem(key) {
        var _this_keyMap_get;
        return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
    }
    at() {
        throw new Error('Not implemented');
    }
    clone() {
        // We need to clone using this.constructor so that subclasses have the right prototype.
        // TypeScript isn't happy about this yet.
        // https://github.com/microsoft/TypeScript/issues/3841
        let Constructor = this.constructor;
        let collection = new Constructor();
        collection.keyMap = new Map(this.keyMap);
        collection.firstKey = this.firstKey;
        collection.lastKey = this.lastKey;
        return collection;
    }
    addNode(node) {
        if (this.frozen) throw new Error('Cannot add a node to a frozen collection');
        this.keyMap.set(node.key, node);
    }
    removeNode(key) {
        if (this.frozen) throw new Error('Cannot remove a node to a frozen collection');
        this.keyMap.delete(key);
    }
    commit(firstKey, lastKey, isSSR = false) {
        if (this.frozen) throw new Error('Cannot commit a frozen collection');
        this.firstKey = firstKey;
        this.lastKey = lastKey;
        this.frozen = !isSSR;
    }
    constructor(){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.frozen = false;
    }
}

});

parcelRegister("2H42j", function(module, exports) {

$parcel$export(module.exports, "Document", function () { return $86caac5932084389$export$b34a105447964f9f; });

var $1dNHT = parcelRequire("1dNHT");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $86caac5932084389$export$410b0c854570d131 {
    *[Symbol.iterator]() {
        let node = this.firstChild;
        while(node){
            yield node;
            node = node.nextSibling;
        }
    }
    get firstChild() {
        return this._firstChild;
    }
    set firstChild(firstChild) {
        this._firstChild = firstChild;
        this.ownerDocument.markDirty(this);
    }
    get lastChild() {
        return this._lastChild;
    }
    set lastChild(lastChild) {
        this._lastChild = lastChild;
        this.ownerDocument.markDirty(this);
    }
    get previousSibling() {
        return this._previousSibling;
    }
    set previousSibling(previousSibling) {
        this._previousSibling = previousSibling;
        this.ownerDocument.markDirty(this);
    }
    get nextSibling() {
        return this._nextSibling;
    }
    set nextSibling(nextSibling) {
        this._nextSibling = nextSibling;
        this.ownerDocument.markDirty(this);
    }
    get parentNode() {
        return this._parentNode;
    }
    set parentNode(parentNode) {
        this._parentNode = parentNode;
        this.ownerDocument.markDirty(this);
    }
    get isConnected() {
        var _this_parentNode;
        return ((_this_parentNode = this.parentNode) === null || _this_parentNode === void 0 ? void 0 : _this_parentNode.isConnected) || false;
    }
    appendChild(child) {
        this.ownerDocument.startTransaction();
        if (child.parentNode) child.parentNode.removeChild(child);
        if (this.firstChild == null) this.firstChild = child;
        if (this.lastChild) {
            this.lastChild.nextSibling = child;
            child.index = this.lastChild.index + 1;
            child.previousSibling = this.lastChild;
        } else {
            child.previousSibling = null;
            child.index = 0;
        }
        child.parentNode = this;
        child.nextSibling = null;
        this.lastChild = child;
        this.ownerDocument.markDirty(this);
        if (child.hasSetProps) // Otherwise wait until then so we have the correct id for the node.
        this.ownerDocument.addNode(child);
        this.ownerDocument.endTransaction();
        this.ownerDocument.queueUpdate();
    }
    insertBefore(newNode, referenceNode) {
        if (referenceNode == null) return this.appendChild(newNode);
        this.ownerDocument.startTransaction();
        if (newNode.parentNode) newNode.parentNode.removeChild(newNode);
        newNode.nextSibling = referenceNode;
        newNode.previousSibling = referenceNode.previousSibling;
        newNode.index = referenceNode.index;
        if (this.firstChild === referenceNode) this.firstChild = newNode;
        else if (referenceNode.previousSibling) referenceNode.previousSibling.nextSibling = newNode;
        referenceNode.previousSibling = newNode;
        newNode.parentNode = referenceNode.parentNode;
        let node = referenceNode;
        while(node){
            node.index++;
            node = node.nextSibling;
        }
        if (newNode.hasSetProps) this.ownerDocument.addNode(newNode);
        this.ownerDocument.endTransaction();
        this.ownerDocument.queueUpdate();
    }
    removeChild(child) {
        if (child.parentNode !== this || !this.ownerDocument.isMounted) return;
        this.ownerDocument.startTransaction();
        let node = child.nextSibling;
        while(node){
            node.index--;
            node = node.nextSibling;
        }
        if (child.nextSibling) child.nextSibling.previousSibling = child.previousSibling;
        if (child.previousSibling) child.previousSibling.nextSibling = child.nextSibling;
        if (this.firstChild === child) this.firstChild = child.nextSibling;
        if (this.lastChild === child) this.lastChild = child.previousSibling;
        child.parentNode = null;
        child.nextSibling = null;
        child.previousSibling = null;
        child.index = 0;
        this.ownerDocument.removeNode(child);
        this.ownerDocument.endTransaction();
        this.ownerDocument.queueUpdate();
    }
    addEventListener() {}
    removeEventListener() {}
    constructor(ownerDocument){
        this._firstChild = null;
        this._lastChild = null;
        this._previousSibling = null;
        this._nextSibling = null;
        this._parentNode = null;
        this.ownerDocument = ownerDocument;
    }
}
class $86caac5932084389$export$dc064fe9e59310fd extends $86caac5932084389$export$410b0c854570d131 {
    get index() {
        return this._index;
    }
    set index(index) {
        this._index = index;
        this.ownerDocument.markDirty(this);
    }
    get level() {
        if (this.parentNode instanceof $86caac5932084389$export$dc064fe9e59310fd) return this.parentNode.level + (this.node.type === 'item' ? 1 : 0);
        return 0;
    }
    updateNode() {
        var _this_previousSibling, _this_nextSibling, _this_firstChild, _this_lastChild;
        let node = this.ownerDocument.getMutableNode(this);
        node.index = this.index;
        node.level = this.level;
        node.parentKey = this.parentNode instanceof $86caac5932084389$export$dc064fe9e59310fd ? this.parentNode.node.key : null;
        var _this_previousSibling_node_key;
        node.prevKey = (_this_previousSibling_node_key = (_this_previousSibling = this.previousSibling) === null || _this_previousSibling === void 0 ? void 0 : _this_previousSibling.node.key) !== null && _this_previousSibling_node_key !== void 0 ? _this_previousSibling_node_key : null;
        var _this_nextSibling_node_key;
        node.nextKey = (_this_nextSibling_node_key = (_this_nextSibling = this.nextSibling) === null || _this_nextSibling === void 0 ? void 0 : _this_nextSibling.node.key) !== null && _this_nextSibling_node_key !== void 0 ? _this_nextSibling_node_key : null;
        node.hasChildNodes = !!this.firstChild;
        var _this_firstChild_node_key;
        node.firstChildKey = (_this_firstChild_node_key = (_this_firstChild = this.firstChild) === null || _this_firstChild === void 0 ? void 0 : _this_firstChild.node.key) !== null && _this_firstChild_node_key !== void 0 ? _this_firstChild_node_key : null;
        var _this_lastChild_node_key;
        node.lastChildKey = (_this_lastChild_node_key = (_this_lastChild = this.lastChild) === null || _this_lastChild === void 0 ? void 0 : _this_lastChild.node.key) !== null && _this_lastChild_node_key !== void 0 ? _this_lastChild_node_key : null;
    }
    setProps(obj, ref, rendered, render) {
        let node = this.ownerDocument.getMutableNode(this);
        let { value: value, textValue: textValue, id: id, ...props } = obj;
        props.ref = ref;
        node.props = props;
        node.rendered = rendered;
        node.render = render;
        node.value = value;
        node.textValue = textValue || (typeof props.children === 'string' ? props.children : '') || obj['aria-label'] || '';
        if (id != null && id !== node.key) {
            if (this.hasSetProps) throw new Error('Cannot change the id of an item');
            node.key = id;
        }
        // If this is the first time props have been set, end the transaction started in the constructor
        // so this node can be emitted.
        if (!this.hasSetProps) {
            this.ownerDocument.addNode(this);
            this.ownerDocument.endTransaction();
            this.hasSetProps = true;
        }
        this.ownerDocument.queueUpdate();
    }
    get style() {
        return {};
    }
    hasAttribute() {}
    setAttribute() {}
    setAttributeNS() {}
    removeAttribute() {}
    constructor(type, ownerDocument){
        super(ownerDocument), this.nodeType = 8 // COMMENT_NODE (we'd use ELEMENT_NODE but React DevTools will fail to get its dimensions)
        , this._index = 0, this.hasSetProps = false;
        this.node = new (0, $1dNHT.CollectionNode)(type, `react-aria-${++ownerDocument.nodeId}`);
        // Start a transaction so that no updates are emitted from the collection
        // until the props for this node are set. We don't know the real id for the
        // node until then, so we need to avoid emitting collections in an inconsistent state.
        this.ownerDocument.startTransaction();
    }
}
class $86caac5932084389$export$b34a105447964f9f extends $86caac5932084389$export$410b0c854570d131 {
    get isConnected() {
        return this.isMounted;
    }
    createElement(type) {
        return new $86caac5932084389$export$dc064fe9e59310fd(type, this);
    }
    /**
   * Lazily gets a mutable instance of a Node. If the node has already
   * been cloned during this update cycle, it just returns the existing one.
   */ getMutableNode(element) {
        let node = element.node;
        if (!this.mutatedNodes.has(element)) {
            node = element.node.clone();
            this.mutatedNodes.add(element);
            element.node = node;
        }
        this.markDirty(element);
        return node;
    }
    getMutableCollection() {
        if (!this.isSSR && !this.collectionMutated) {
            this.collection = this.collection.clone();
            this.collectionMutated = true;
        }
        return this.collection;
    }
    markDirty(node) {
        this.dirtyNodes.add(node);
    }
    startTransaction() {
        this.transactionCount++;
    }
    endTransaction() {
        this.transactionCount--;
    }
    addNode(element) {
        let collection = this.getMutableCollection();
        if (!collection.getItem(element.node.key)) {
            collection.addNode(element.node);
            for (let child of element)this.addNode(child);
        }
        this.markDirty(element);
    }
    removeNode(node) {
        for (let child of node)this.removeNode(child);
        let collection = this.getMutableCollection();
        collection.removeNode(node.node.key);
        this.markDirty(node);
    }
    /** Finalizes the collection update, updating all nodes and freezing the collection. */ getCollection() {
        if (this.transactionCount > 0) return this.collection;
        this.updateCollection();
        return this.collection;
    }
    updateCollection() {
        for (let element of this.dirtyNodes)if (element instanceof $86caac5932084389$export$dc064fe9e59310fd && element.isConnected) element.updateNode();
        this.dirtyNodes.clear();
        if (this.mutatedNodes.size || this.collectionMutated) {
            var _this_firstChild, _this_lastChild;
            let collection = this.getMutableCollection();
            for (let element of this.mutatedNodes)if (element.isConnected) collection.addNode(element.node);
            var _this_firstChild_node_key, _this_lastChild_node_key;
            collection.commit((_this_firstChild_node_key = (_this_firstChild = this.firstChild) === null || _this_firstChild === void 0 ? void 0 : _this_firstChild.node.key) !== null && _this_firstChild_node_key !== void 0 ? _this_firstChild_node_key : null, (_this_lastChild_node_key = (_this_lastChild = this.lastChild) === null || _this_lastChild === void 0 ? void 0 : _this_lastChild.node.key) !== null && _this_lastChild_node_key !== void 0 ? _this_lastChild_node_key : null, this.isSSR);
            this.mutatedNodes.clear();
        }
        this.collectionMutated = false;
    }
    queueUpdate() {
        // Don't emit any updates if there is a transaction in progress.
        // queueUpdate should be called again after the transaction.
        if (this.dirtyNodes.size === 0 || this.transactionCount > 0) return;
        for (let fn of this.subscriptions)fn();
    }
    subscribe(fn) {
        this.subscriptions.add(fn);
        return ()=>this.subscriptions.delete(fn);
    }
    resetAfterSSR() {
        if (this.isSSR) {
            this.isSSR = false;
            this.firstChild = null;
            this.lastChild = null;
            this.nodeId = 0;
        }
    }
    constructor(collection){
        // @ts-ignore
        super(null), this.nodeType = 11 // DOCUMENT_FRAGMENT_NODE
        , this.ownerDocument = this, this.dirtyNodes = new Set(), this.isSSR = false, this.nodeId = 0, this.nodesByProps = new WeakMap(), this.isMounted = true, this.mutatedNodes = new Set(), this.subscriptions = new Set(), this.transactionCount = 0;
        this.collection = collection;
        this.collectionMutated = true;
    }
}

});

parcelRegister("72X2K", function(module, exports) {

$parcel$export(module.exports, "useCachedChildren", function () { return $e434379d9053ab9d$export$727c8fc270210f13; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e434379d9053ab9d$export$727c8fc270210f13(props) {
    let { children: children, items: items, idScope: idScope, addIdAndValue: addIdAndValue, dependencies: dependencies = [] } = props;
    // Invalidate the cache whenever the parent value changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let cache = (0, $bh6RR.useMemo)(()=>new WeakMap(), dependencies);
    return (0, $bh6RR.useMemo)(()=>{
        if (items && typeof children === 'function') {
            let res = [];
            for (let item of items){
                let rendered = cache.get(item);
                if (!rendered) {
                    rendered = children(item);
                    var _rendered_props_id, _ref;
                    // @ts-ignore
                    let key = (_ref = (_rendered_props_id = rendered.props.id) !== null && _rendered_props_id !== void 0 ? _rendered_props_id : item.key) !== null && _ref !== void 0 ? _ref : item.id;
                    if (key == null) throw new Error('Could not determine key for item');
                    if (idScope) key = idScope + ':' + key;
                    // Note: only works if wrapped Item passes through id...
                    rendered = (0, $bh6RR.cloneElement)(rendered, addIdAndValue ? {
                        key: key,
                        id: key,
                        value: item
                    } : {
                        key: key
                    });
                    cache.set(item, rendered);
                }
                res.push(rendered);
            }
            return res;
        } else if (typeof children !== 'function') return children;
    }, [
        children,
        items,
        cache,
        idScope,
        addIdAndValue
    ]);
}

});


parcelRegister("7jgDZ", function(module, exports) {

$parcel$export(module.exports, "HeaderContext", function () { return $888bd643f29def62$export$e0e4026c12a8bdbb; });
$parcel$export(module.exports, "Header", function () { return $888bd643f29def62$export$8b251419efc915eb; });

var $dgWhj = parcelRequire("dgWhj");

var $eqvPU = parcelRequire("eqvPU");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $888bd643f29def62$export$e0e4026c12a8bdbb = (0, $bh6RR.createContext)({});
const $888bd643f29def62$export$8b251419efc915eb = (0, $eqvPU.createLeafComponent)('header', function Header(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $888bd643f29def62$export$e0e4026c12a8bdbb);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("header", {
        className: "react-aria-Header",
        ...props,
        ref: ref
    }, props.children);
});

});

parcelRegister("juOz0", function(module, exports) {

$parcel$export(module.exports, "SectionContext", function () { return $0c558b9efb3e751d$export$d40e14dec8b060a8; });
$parcel$export(module.exports, "Section", function () { return $0c558b9efb3e751d$export$6e2c8f0811a474ce; });
$parcel$export(module.exports, "DefaultCollectionRenderer", function () { return $0c558b9efb3e751d$export$a164736487e3f0ae; });
$parcel$export(module.exports, "CollectionRendererContext", function () { return $0c558b9efb3e751d$export$4feb769f8ddf26c5; });
$parcel$export(module.exports, "usePersistedKeys", function () { return $0c558b9efb3e751d$export$90e00781bc59d8f9; });

var $eqvPU = parcelRequire("eqvPU");
var $72X2K = parcelRequire("72X2K");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0c558b9efb3e751d$export$d40e14dec8b060a8 = (0, $bh6RR.createContext)(null);
const $0c558b9efb3e751d$export$6e2c8f0811a474ce = (0, $eqvPU.createBranchComponent)('section', (props, ref, section)=>{
    let { name: name, render: render } = (0, $bh6RR.useContext)($0c558b9efb3e751d$export$d40e14dec8b060a8);
    console.warn(`<Section> is deprecated. Please use <${name}> instead.`);
    return render(props, ref, section, 'react-aria-Section');
});
const $0c558b9efb3e751d$export$a164736487e3f0ae = {
    CollectionRoot ({ collection: collection, renderDropIndicator: renderDropIndicator }) {
        return $0c558b9efb3e751d$var$$7135fc7d473fd974$var$useCollectionRender(collection, null, renderDropIndicator);
    },
    CollectionBranch ({ collection: collection, parent: parent, renderDropIndicator: renderDropIndicator }) {
        return $0c558b9efb3e751d$var$$7135fc7d473fd974$var$useCollectionRender(collection, parent, renderDropIndicator);
    }
};
function $0c558b9efb3e751d$var$$7135fc7d473fd974$var$useCollectionRender(collection, parent, renderDropIndicator) {
    return (0, $72X2K.useCachedChildren)({
        items: parent ? collection.getChildren(parent.key) : collection,
        dependencies: [
            renderDropIndicator
        ],
        children (node) {
            var _collection_getItem;
            let rendered = node.render(node);
            if (!renderDropIndicator || node.type !== 'item') return rendered;
            let key = node.key;
            let keyAfter = collection.getKeyAfter(key);
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, renderDropIndicator({
                type: 'item',
                key: key,
                dropPosition: 'before'
            }), rendered, (keyAfter == null || ((_collection_getItem = collection.getItem(keyAfter)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.type) !== 'item') && renderDropIndicator({
                type: 'item',
                key: key,
                dropPosition: 'after'
            }));
        }
    });
}
const $0c558b9efb3e751d$export$4feb769f8ddf26c5 = (0, $bh6RR.createContext)($0c558b9efb3e751d$export$a164736487e3f0ae);
function $0c558b9efb3e751d$export$90e00781bc59d8f9(focusedKey) {
    return (0, $bh6RR.useMemo)(()=>focusedKey != null ? new Set([
            focusedKey
        ]) : null, [
        focusedKey
    ]);
}

});

parcelRegister("kRr6x", function(module, exports) {

$parcel$export(module.exports, "DialogContext", function () { return $bccc8fc5635f5a15$export$8b93a07348a7730c; });
$parcel$export(module.exports, "OverlayTriggerStateContext", function () { return $bccc8fc5635f5a15$export$d2f961adcb0afbe; });
$parcel$export(module.exports, "Dialog", function () { return $bccc8fc5635f5a15$export$3ddf2d174ce01153; });

var $9cr7a = parcelRequire("9cr7a");

var $dgWhj = parcelRequire("dgWhj");

var $hzBE3 = parcelRequire("hzBE3");

var $6W801 = parcelRequire("6W801");

var $eA2Db = parcelRequire("eA2Db");

var $a87Wk = parcelRequire("a87Wk");
var $gxMV2 = parcelRequire("gxMV2");
var $kMGia = parcelRequire("kMGia");

var $bG0JH = parcelRequire("bG0JH");

var $2YwY2 = parcelRequire("2YwY2");

var $3obwd = parcelRequire("3obwd");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bccc8fc5635f5a15$export$8b93a07348a7730c = (0, $bh6RR.createContext)(null);
const $bccc8fc5635f5a15$export$d2f961adcb0afbe = (0, $bh6RR.createContext)(null);
function $bccc8fc5635f5a15$export$2e1e1122cf0cba88(props) {
    // Use useMenuTriggerState instead of useOverlayTriggerState in case a menu is embedded in the dialog.
    // This is needed to handle submenus.
    let state = (0, $2YwY2.useMenuTriggerState)(props);
    let buttonRef = (0, $bh6RR.useRef)(null);
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $kMGia.useOverlayTrigger)({
        type: 'dialog'
    }, state, buttonRef);
    // Label dialog by the trigger as a fallback if there is no title slot.
    // This is done in RAC instead of hooks because otherwise we cannot distinguish
    // between context and props. Normally aria-labelledby overrides the title
    // but when sent by context we want the title to win.
    triggerProps.id = (0, $gxMV2.useId)();
    overlayProps['aria-labelledby'] = triggerProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                $bccc8fc5635f5a15$export$d2f961adcb0afbe,
                state
            ],
            [
                (0, $eA2Db.RootMenuTriggerStateContext),
                state
            ],
            [
                $bccc8fc5635f5a15$export$8b93a07348a7730c,
                overlayProps
            ],
            [
                (0, $6W801.PopoverContext),
                {
                    trigger: 'DialogTrigger',
                    triggerRef: buttonRef
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3obwd.PressResponder), {
        ...triggerProps,
        ref: buttonRef,
        isPressed: state.isOpen
    }, props.children));
}
function $bccc8fc5635f5a15$var$$de32f1b87079253c$var$Dialog(props, ref) {
    let originalAriaLabelledby = props['aria-labelledby'];
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $bccc8fc5635f5a15$export$8b93a07348a7730c);
    let { dialogProps: dialogProps, titleProps: titleProps } = (0, $a87Wk.useDialog)({
        ...props,
        // Only pass aria-labelledby from props, not context.
        // Context is used as a fallback below.
        'aria-labelledby': originalAriaLabelledby
    }, ref);
    let state = (0, $bh6RR.useContext)($bccc8fc5635f5a15$export$d2f961adcb0afbe);
    if (!dialogProps['aria-label'] && !dialogProps['aria-labelledby']) {
        // If aria-labelledby exists on props, we know it came from context.
        // Use that as a fallback in case there is no title slot.
        if (props['aria-labelledby']) dialogProps['aria-labelledby'] = props['aria-labelledby'];
        else console.warn('If a Dialog does not contain a <Heading slot="title">, it must have an aria-label or aria-labelledby attribute for accessibility.');
    }
    let renderProps = (0, $dgWhj.useRenderProps)({
        defaultClassName: 'react-aria-Dialog',
        className: props.className,
        style: props.style,
        children: props.children,
        values: {
            close: (state === null || state === void 0 ? void 0 : state.close) || (()=>{})
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("section", {
        ...(0, $bG0JH.filterDOMProps)(props),
        ...dialogProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                (0, $hzBE3.HeadingContext),
                {
                    slots: {
                        [(0, $dgWhj.DEFAULT_SLOT)]: {},
                        title: {
                            ...titleProps,
                            level: 2
                        }
                    }
                }
            ],
            [
                (0, $9cr7a.ButtonContext),
                {
                    slots: {
                        [(0, $dgWhj.DEFAULT_SLOT)]: {},
                        close: {
                            onPress: ()=>state === null || state === void 0 ? void 0 : state.close()
                        }
                    }
                }
            ]
        ]
    }, renderProps.children));
}
/**
 * A dialog is an overlay shown above other content in an application.
 */ const $bccc8fc5635f5a15$export$3ddf2d174ce01153 = (0, $bh6RR.forwardRef)($bccc8fc5635f5a15$var$$de32f1b87079253c$var$Dialog);

});
parcelRegister("hzBE3", function(module, exports) {

$parcel$export(module.exports, "CheckboxContext", function () { return $356d95a28cf7a447$export$b085522c77523c51; });
$parcel$export(module.exports, "HeadingContext", function () { return $356d95a28cf7a447$export$d688439359537581; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $356d95a28cf7a447$export$b085522c77523c51 = (0, $bh6RR.createContext)(null);
const $356d95a28cf7a447$export$ebe63fadcdce34ed = (0, $bh6RR.createContext)(null);
const $356d95a28cf7a447$export$44644b8a16031b5b = (0, $bh6RR.createContext)(null);
const $356d95a28cf7a447$export$717b2c0a523a0b53 = (0, $bh6RR.createContext)(null);
const $356d95a28cf7a447$export$265015d6dc85bf21 = (0, $bh6RR.createContext)(null);
const $356d95a28cf7a447$export$d688439359537581 = (0, $bh6RR.createContext)({});

});

parcelRegister("6W801", function(module, exports) {

$parcel$export(module.exports, "PopoverContext", function () { return $546621bde9c2d060$export$9b9a0cd73afb7ca4; });
$parcel$export(module.exports, "Popover", function () { return $546621bde9c2d060$export$5b6b19405a83ff9d; });

var $dgWhj = parcelRequire("dgWhj");

var $bf3Og = parcelRequire("bf3Og");

var $kRr6x = parcelRequire("kRr6x");

var $knoqV = parcelRequire("knoqV");
var $aAM1f = parcelRequire("aAM1f");
var $6M2SS = parcelRequire("6M2SS");

var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");
var $f2PTm = parcelRequire("f2PTm");

var $l2K9U = parcelRequire("l2K9U");

var $bh6RR = parcelRequire("bh6RR");

var $73EHL = parcelRequire("73EHL");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $546621bde9c2d060$export$9b9a0cd73afb7ca4 = (0, $bh6RR.createContext)(null);
function $546621bde9c2d060$var$$07b14b47974efb58$var$Popover(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $546621bde9c2d060$export$9b9a0cd73afb7ca4);
    let contextState = (0, $bh6RR.useContext)((0, $kRr6x.OverlayTriggerStateContext));
    let localState = (0, $l2K9U.useOverlayTriggerState)(props);
    let state = props.isOpen != null || props.defaultOpen != null || !contextState ? localState : contextState;
    let isExiting = (0, $dgWhj.useExitAnimation)(ref, state.isOpen) || props.isExiting || false;
    let isHidden = (0, $73EHL.useIsHidden)();
    // If we are in a hidden tree, we still need to preserve our children.
    if (isHidden) {
        let children = props.children;
        if (typeof children === 'function') children = children({
            trigger: props.trigger || null,
            placement: 'bottom',
            isEntering: false,
            isExiting: false,
            defaultChildren: null
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, children);
    }
    if (state && !state.isOpen && !isExiting) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($546621bde9c2d060$var$$07b14b47974efb58$var$PopoverInner, {
        ...props,
        triggerRef: props.triggerRef,
        state: state,
        popoverRef: ref,
        isExiting: isExiting
    });
}
/**
 * A popover is an overlay element positioned relative to a trigger.
 */ const $546621bde9c2d060$export$5b6b19405a83ff9d = (0, $bh6RR.forwardRef)($546621bde9c2d060$var$$07b14b47974efb58$var$Popover);
function $546621bde9c2d060$var$$07b14b47974efb58$var$PopoverInner({ state: state, isExiting: isExiting, UNSTABLE_portalContainer: UNSTABLE_portalContainer, ...props }) {
    // Calculate the arrow size internally (and remove props.arrowSize from PopoverProps)
    // Referenced from: packages/@react-spectrum/tooltip/src/TooltipTrigger.tsx
    let arrowRef = (0, $bh6RR.useRef)(null);
    let [arrowWidth, setArrowWidth] = (0, $bh6RR.useState)(0);
    (0, $f2PTm.useLayoutEffect)(()=>{
        if (arrowRef.current && state.isOpen) setArrowWidth(arrowRef.current.getBoundingClientRect().width);
    }, [
        state.isOpen,
        arrowRef
    ]);
    var _props_offset;
    let { popoverProps: popoverProps, underlayProps: underlayProps, arrowProps: arrowProps, placement: placement } = (0, $6M2SS.usePopover)({
        ...props,
        offset: (_props_offset = props.offset) !== null && _props_offset !== void 0 ? _props_offset : 8,
        arrowSize: arrowWidth
    }, state);
    let ref = props.popoverRef;
    let isEntering = (0, $dgWhj.useEnterAnimation)(ref, !!placement) || props.isEntering || false;
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Popover',
        values: {
            trigger: props.trigger || null,
            placement: placement,
            isEntering: isEntering,
            isExiting: isExiting
        }
    });
    let style = {
        ...popoverProps.style,
        ...renderProps.style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $aAM1f.Overlay), {
        ...props,
        isExiting: isExiting,
        portalContainer: UNSTABLE_portalContainer
    }, !props.isNonModal && state.isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        "data-testid": "underlay",
        ...underlayProps,
        style: {
            position: 'fixed',
            inset: 0
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...(0, $hAxtE.mergeProps)((0, $bG0JH.filterDOMProps)(props), popoverProps),
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        style: style,
        "data-trigger": props.trigger,
        "data-placement": placement,
        "data-entering": isEntering || undefined,
        "data-exiting": isExiting || undefined
    }, !props.isNonModal && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $knoqV.DismissButton), {
        onDismiss: state.close
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bf3Og.OverlayArrowContext).Provider, {
        value: {
            ...arrowProps,
            placement: placement,
            ref: arrowRef
        }
    }, renderProps.children), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $knoqV.DismissButton), {
        onDismiss: state.close
    })));
}

});
parcelRegister("bf3Og", function(module, exports) {

$parcel$export(module.exports, "OverlayArrowContext", function () { return $4f4d71bf922f61b0$export$2de4954e8ae13b9f; });
$parcel$export(module.exports, "OverlayArrow", function () { return $4f4d71bf922f61b0$export$746d02f47f4d381; });

var $dgWhj = parcelRequire("dgWhj");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4f4d71bf922f61b0$export$2de4954e8ae13b9f = (0, $bh6RR.createContext)({
    placement: 'bottom'
});
function $4f4d71bf922f61b0$var$$44f671af83e7d9e0$var$OverlayArrow(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $4f4d71bf922f61b0$export$2de4954e8ae13b9f);
    let placement = props.placement;
    let style = {
        position: 'absolute',
        transform: placement === 'top' || placement === 'bottom' ? 'translateX(-50%)' : 'translateY(-50%)'
    };
    if (placement != null) style[placement] = '100%';
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-OverlayArrow',
        values: {
            placement: placement
        }
    });
    // remove undefined values from renderProps.style object so that it can be
    // spread merged with the other style object
    if (renderProps.style) Object.keys(renderProps.style).forEach((key)=>renderProps.style[key] === undefined && delete renderProps.style[key]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...props,
        ...renderProps,
        style: {
            ...style,
            ...renderProps.style
        },
        ref: ref,
        "data-placement": placement
    });
}
/**
 * An OverlayArrow renders a custom arrow element relative to an overlay element
 * such as a popover or tooltip such that it aligns with a trigger element.
 */ const $4f4d71bf922f61b0$export$746d02f47f4d381 = (0, $bh6RR.forwardRef)($4f4d71bf922f61b0$var$$44f671af83e7d9e0$var$OverlayArrow);

});

parcelRegister("knoqV", function(module, exports) {

$parcel$export(module.exports, "DismissButton", function () { return $9b81237526b7e023$export$2317d149ed6f78c4; });

var $c8VyA = parcelRequire("c8VyA");

var $bh6RR = parcelRequire("bh6RR");

var $5oX0L = parcelRequire("5oX0L");

var $kbHlJ = parcelRequire("kbHlJ");

var $lhOYy = parcelRequire("lhOYy");
function $9b81237526b7e023$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9b81237526b7e023$export$2317d149ed6f78c4(props) {
    let { onDismiss: onDismiss, ...otherProps } = props;
    let stringFormatter = (0, $kbHlJ.useLocalizedStringFormatter)($9b81237526b7e023$var$$parcel$interopDefault((0, $c8VyA.default)), '@react-aria/overlays');
    let labels = (0, $5oX0L.useLabels)(otherProps, stringFormatter.format('dismiss'));
    let onClick = ()=>{
        if (onDismiss) onDismiss();
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $lhOYy.VisuallyHidden), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
        ...labels,
        tabIndex: -1,
        onClick: onClick,
        style: {
            width: 1,
            height: 1
        }
    }));
}

});
parcelRegister("c8VyA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc9748deb311e5f9$export$2e2bcd8739ae039; });

var $eb42i = parcelRequire("eb42i");

var $fkH2B = parcelRequire("fkH2B");

var $7g9rD = parcelRequire("7g9rD");

var $kCToO = parcelRequire("kCToO");

var $kekQg = parcelRequire("kekQg");

var $2wTcm = parcelRequire("2wTcm");

var $3avSj = parcelRequire("3avSj");

var $c5fRM = parcelRequire("c5fRM");

var $cdTKg = parcelRequire("cdTKg");

var $6Tymt = parcelRequire("6Tymt");

var $cx8zC = parcelRequire("cx8zC");

var $fy2MH = parcelRequire("fy2MH");

var $CEvVO = parcelRequire("CEvVO");

var $igxDM = parcelRequire("igxDM");

var $i2452 = parcelRequire("i2452");

var $JC8dO = parcelRequire("JC8dO");

var $gbVW8 = parcelRequire("gbVW8");

var $lGhqz = parcelRequire("lGhqz");

var $gnH4k = parcelRequire("gnH4k");

var $60HN5 = parcelRequire("60HN5");

var $1cCrc = parcelRequire("1cCrc");

var $6j19z = parcelRequire("6j19z");

var $cMDdo = parcelRequire("cMDdo");

var $lV8d9 = parcelRequire("lV8d9");

var $dbFNE = parcelRequire("dbFNE");

var $3Bk6n = parcelRequire("3Bk6n");

var $9mKtx = parcelRequire("9mKtx");

var $aLYXp = parcelRequire("aLYXp");

var $cvs8M = parcelRequire("cvs8M");

var $77eqd = parcelRequire("77eqd");

var $aNKzx = parcelRequire("aNKzx");

var $hqWOZ = parcelRequire("hqWOZ");

var $fcbWn = parcelRequire("fcbWn");

var $7tscI = parcelRequire("7tscI");
var $cc9748deb311e5f9$export$2e2bcd8739ae039 = {};
$cc9748deb311e5f9$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $eb42i.default),
    "bg-BG": (0, $fkH2B.default),
    "cs-CZ": (0, $7g9rD.default),
    "da-DK": (0, $kCToO.default),
    "de-DE": (0, $kekQg.default),
    "el-GR": (0, $2wTcm.default),
    "en-US": (0, $3avSj.default),
    "es-ES": (0, $c5fRM.default),
    "et-EE": (0, $cdTKg.default),
    "fi-FI": (0, $6Tymt.default),
    "fr-FR": (0, $cx8zC.default),
    "he-IL": (0, $fy2MH.default),
    "hr-HR": (0, $CEvVO.default),
    "hu-HU": (0, $igxDM.default),
    "it-IT": (0, $i2452.default),
    "ja-JP": (0, $JC8dO.default),
    "ko-KR": (0, $gbVW8.default),
    "lt-LT": (0, $lGhqz.default),
    "lv-LV": (0, $gnH4k.default),
    "nb-NO": (0, $60HN5.default),
    "nl-NL": (0, $1cCrc.default),
    "pl-PL": (0, $6j19z.default),
    "pt-BR": (0, $cMDdo.default),
    "pt-PT": (0, $lV8d9.default),
    "ro-RO": (0, $dbFNE.default),
    "ru-RU": (0, $3Bk6n.default),
    "sk-SK": (0, $9mKtx.default),
    "sl-SI": (0, $aLYXp.default),
    "sr-SP": (0, $cvs8M.default),
    "sv-SE": (0, $77eqd.default),
    "tr-TR": (0, $aNKzx.default),
    "uk-UA": (0, $hqWOZ.default),
    "zh-CN": (0, $fcbWn.default),
    "zh-TW": (0, $7tscI.default)
};

});
parcelRegister("eb42i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcb5101b7193b9c7$export$2e2bcd8739ae039; });
var $fcb5101b7193b9c7$export$2e2bcd8739ae039 = {};
$fcb5101b7193b9c7$export$2e2bcd8739ae039 = {
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};

});

parcelRegister("fkH2B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8d1951adb82dec7$export$2e2bcd8739ae039; });
var $e8d1951adb82dec7$export$2e2bcd8739ae039 = {};
$e8d1951adb82dec7$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};

});

parcelRegister("7g9rD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39a33e7941853f1d$export$2e2bcd8739ae039; });
var $39a33e7941853f1d$export$2e2bcd8739ae039 = {};
$39a33e7941853f1d$export$2e2bcd8739ae039 = {
    "dismiss": `Odstranit`
};

});

parcelRegister("kCToO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4273611400b169cf$export$2e2bcd8739ae039; });
var $4273611400b169cf$export$2e2bcd8739ae039 = {};
$4273611400b169cf$export$2e2bcd8739ae039 = {
    "dismiss": `Luk`
};

});

parcelRegister("kekQg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c401dae3bdc6b17$export$2e2bcd8739ae039; });
var $3c401dae3bdc6b17$export$2e2bcd8739ae039 = {};
$3c401dae3bdc6b17$export$2e2bcd8739ae039 = {
    "dismiss": `Schlie\xdfen`
};

});

parcelRegister("2wTcm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a9352a7c15fc631$export$2e2bcd8739ae039; });
var $9a9352a7c15fc631$export$2e2bcd8739ae039 = {};
$9a9352a7c15fc631$export$2e2bcd8739ae039 = {
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};

});

parcelRegister("3avSj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edb6068a83e7b11f$export$2e2bcd8739ae039; });
var $edb6068a83e7b11f$export$2e2bcd8739ae039 = {};
$edb6068a83e7b11f$export$2e2bcd8739ae039 = {
    "dismiss": `Dismiss`
};

});

parcelRegister("c5fRM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $130e91ca26b2bdb8$export$2e2bcd8739ae039; });
var $130e91ca26b2bdb8$export$2e2bcd8739ae039 = {};
$130e91ca26b2bdb8$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};

});

parcelRegister("cdTKg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59dfd6dd511414d4$export$2e2bcd8739ae039; });
var $59dfd6dd511414d4$export$2e2bcd8739ae039 = {};
$59dfd6dd511414d4$export$2e2bcd8739ae039 = {
    "dismiss": `L\xf5peta`
};

});

parcelRegister("6Tymt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f085d0cacea9754$export$2e2bcd8739ae039; });
var $1f085d0cacea9754$export$2e2bcd8739ae039 = {};
$1f085d0cacea9754$export$2e2bcd8739ae039 = {
    "dismiss": `Hylk\xe4\xe4`
};

});

parcelRegister("cx8zC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9056a45900a4fd5b$export$2e2bcd8739ae039; });
var $9056a45900a4fd5b$export$2e2bcd8739ae039 = {};
$9056a45900a4fd5b$export$2e2bcd8739ae039 = {
    "dismiss": `Rejeter`
};

});

parcelRegister("fy2MH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c59c4d617be08a90$export$2e2bcd8739ae039; });
var $c59c4d617be08a90$export$2e2bcd8739ae039 = {};
$c59c4d617be08a90$export$2e2bcd8739ae039 = {
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};

});

parcelRegister("CEvVO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b0a530c4345fd6c$export$2e2bcd8739ae039; });
var $3b0a530c4345fd6c$export$2e2bcd8739ae039 = {};
$3b0a530c4345fd6c$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};

});

parcelRegister("igxDM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d864089803ca07d5$export$2e2bcd8739ae039; });
var $d864089803ca07d5$export$2e2bcd8739ae039 = {};
$d864089803ca07d5$export$2e2bcd8739ae039 = {
    "dismiss": `Elutas\xedt\xe1s`
};

});

parcelRegister("i2452", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d595b2edb28c827$export$2e2bcd8739ae039; });
var $3d595b2edb28c827$export$2e2bcd8739ae039 = {};
$3d595b2edb28c827$export$2e2bcd8739ae039 = {
    "dismiss": `Ignora`
};

});

parcelRegister("JC8dO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba48105a966eaf20$export$2e2bcd8739ae039; });
var $ba48105a966eaf20$export$2e2bcd8739ae039 = {};
$ba48105a966eaf20$export$2e2bcd8739ae039 = {
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};

});

parcelRegister("gbVW8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa84b9ba769178c6$export$2e2bcd8739ae039; });
var $fa84b9ba769178c6$export$2e2bcd8739ae039 = {};
$fa84b9ba769178c6$export$2e2bcd8739ae039 = {
    "dismiss": `\u{BB34}\u{C2DC}`
};

});

parcelRegister("lGhqz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90119a5cceb3aed1$export$2e2bcd8739ae039; });
var $90119a5cceb3aed1$export$2e2bcd8739ae039 = {};
$90119a5cceb3aed1$export$2e2bcd8739ae039 = {
    "dismiss": `Atmesti`
};

});

parcelRegister("gnH4k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2edfa93eb7e73eef$export$2e2bcd8739ae039; });
var $2edfa93eb7e73eef$export$2e2bcd8739ae039 = {};
$2edfa93eb7e73eef$export$2e2bcd8739ae039 = {
    "dismiss": `Ner\u{101}d\u{12B}t`
};

});

parcelRegister("60HN5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ae5a84f3845d8c1$export$2e2bcd8739ae039; });
var $0ae5a84f3845d8c1$export$2e2bcd8739ae039 = {};
$0ae5a84f3845d8c1$export$2e2bcd8739ae039 = {
    "dismiss": `Lukk`
};

});

parcelRegister("1cCrc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $489796e912ff8c6b$export$2e2bcd8739ae039; });
var $489796e912ff8c6b$export$2e2bcd8739ae039 = {};
$489796e912ff8c6b$export$2e2bcd8739ae039 = {
    "dismiss": `Negeren`
};

});

parcelRegister("6j19z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f79b71efb4b3b61$export$2e2bcd8739ae039; });
var $1f79b71efb4b3b61$export$2e2bcd8739ae039 = {};
$1f79b71efb4b3b61$export$2e2bcd8739ae039 = {
    "dismiss": `Zignoruj`
};

});

parcelRegister("cMDdo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da17948d74e09500$export$2e2bcd8739ae039; });
var $da17948d74e09500$export$2e2bcd8739ae039 = {};
$da17948d74e09500$export$2e2bcd8739ae039 = {
    "dismiss": `Descartar`
};

});

parcelRegister("lV8d9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f183d815fcb10479$export$2e2bcd8739ae039; });
var $f183d815fcb10479$export$2e2bcd8739ae039 = {};
$f183d815fcb10479$export$2e2bcd8739ae039 = {
    "dismiss": `Dispensar`
};

});

parcelRegister("dbFNE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49736ff577b523a8$export$2e2bcd8739ae039; });
var $49736ff577b523a8$export$2e2bcd8739ae039 = {};
$49736ff577b523a8$export$2e2bcd8739ae039 = {
    "dismiss": `Revocare`
};

});

parcelRegister("3Bk6n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee7fe65519ffe9e2$export$2e2bcd8739ae039; });
var $ee7fe65519ffe9e2$export$2e2bcd8739ae039 = {};
$ee7fe65519ffe9e2$export$2e2bcd8739ae039 = {
    "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};

});

parcelRegister("9mKtx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f9c62b9ee82c144$export$2e2bcd8739ae039; });
var $3f9c62b9ee82c144$export$2e2bcd8739ae039 = {};
$3f9c62b9ee82c144$export$2e2bcd8739ae039 = {
    "dismiss": `Zru\u{161}i\u{165}`
};

});

parcelRegister("aLYXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74544e2dbd5b3994$export$2e2bcd8739ae039; });
var $74544e2dbd5b3994$export$2e2bcd8739ae039 = {};
$74544e2dbd5b3994$export$2e2bcd8739ae039 = {
    "dismiss": `Opusti`
};

});

parcelRegister("cvs8M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6064f95667ffd8ab$export$2e2bcd8739ae039; });
var $6064f95667ffd8ab$export$2e2bcd8739ae039 = {};
$6064f95667ffd8ab$export$2e2bcd8739ae039 = {
    "dismiss": `Odbaci`
};

});

parcelRegister("77eqd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $047781c97fb65e0a$export$2e2bcd8739ae039; });
var $047781c97fb65e0a$export$2e2bcd8739ae039 = {};
$047781c97fb65e0a$export$2e2bcd8739ae039 = {
    "dismiss": `Avvisa`
};

});

parcelRegister("aNKzx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7dfd86bd6854ace6$export$2e2bcd8739ae039; });
var $7dfd86bd6854ace6$export$2e2bcd8739ae039 = {};
$7dfd86bd6854ace6$export$2e2bcd8739ae039 = {
    "dismiss": `Kapat`
};

});

parcelRegister("hqWOZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8289eef4b7a31fc$export$2e2bcd8739ae039; });
var $e8289eef4b7a31fc$export$2e2bcd8739ae039 = {};
$e8289eef4b7a31fc$export$2e2bcd8739ae039 = {
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};

});

parcelRegister("fcbWn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1969bef58c4f691f$export$2e2bcd8739ae039; });
var $1969bef58c4f691f$export$2e2bcd8739ae039 = {};
$1969bef58c4f691f$export$2e2bcd8739ae039 = {
    "dismiss": `\u{53D6}\u{6D88}`
};

});

parcelRegister("7tscI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17ff93fe93837226$export$2e2bcd8739ae039; });
var $17ff93fe93837226$export$2e2bcd8739ae039 = {};
$17ff93fe93837226$export$2e2bcd8739ae039 = {
    "dismiss": `\u{95DC}\u{9589}`
};

});


parcelRegister("kbHlJ", function(module, exports) {

$parcel$export(module.exports, "useLocalizedStringDictionary", function () { return $b906771d03b1626e$export$87b761675e8eaa10; });
$parcel$export(module.exports, "useLocalizedStringFormatter", function () { return $b906771d03b1626e$export$f12b703ca79dfbb1; });

var $c8uzR = parcelRequire("c8uzR");

var $jq9MO = parcelRequire("jq9MO");
var $72apB = parcelRequire("72apB");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b906771d03b1626e$var$$fca6afa0e843324b$var$cache = new WeakMap();
function $b906771d03b1626e$var$$fca6afa0e843324b$var$getCachedDictionary(strings) {
    let dictionary = $b906771d03b1626e$var$$fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, $jq9MO.LocalizedStringDictionary)(strings);
        $b906771d03b1626e$var$$fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $b906771d03b1626e$export$87b761675e8eaa10(strings, packageName) {
    return packageName && (0, $jq9MO.LocalizedStringDictionary).getGlobalDictionaryForPackage(packageName) || $b906771d03b1626e$var$$fca6afa0e843324b$var$getCachedDictionary(strings);
}
function $b906771d03b1626e$export$f12b703ca79dfbb1(strings, packageName) {
    let { locale: locale } = (0, $c8uzR.useLocale)();
    let dictionary = $b906771d03b1626e$export$87b761675e8eaa10(strings, packageName);
    return (0, $bh6RR.useMemo)(()=>new (0, $72apB.LocalizedStringFormatter)(locale, dictionary), [
        locale,
        dictionary
    ]);
}

});
parcelRegister("jq9MO", function(module, exports) {

$parcel$export(module.exports, "LocalizedStringDictionary", function () { return $66e6f8d0bba3de41$export$c17fa47878dc55b6; });
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $66e6f8d0bba3de41$var$$5b160d28a433310d$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
const $66e6f8d0bba3de41$var$$5b160d28a433310d$var$stringsSymbol = Symbol.for('react-aria.i18n.strings');
let $66e6f8d0bba3de41$var$$5b160d28a433310d$var$cachedGlobalStrings = undefined;
class $66e6f8d0bba3de41$export$c17fa47878dc55b6 {
    /** Returns a localized string for the given key and locale. */ getStringForLocale(key, locale) {
        let strings = this.getStringsForLocale(locale);
        let string = strings[key];
        if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
        return string;
    }
    /** Returns all localized strings for the given locale. */ getStringsForLocale(locale) {
        let strings = this.strings[locale];
        if (!strings) {
            strings = $66e6f8d0bba3de41$var$$5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
            this.strings[locale] = strings;
        }
        return strings;
    }
    static getGlobalDictionaryForPackage(packageName) {
        if (typeof window === 'undefined') return null;
        let locale = window[$66e6f8d0bba3de41$var$$5b160d28a433310d$var$localeSymbol];
        if ($66e6f8d0bba3de41$var$$5b160d28a433310d$var$cachedGlobalStrings === undefined) {
            let globalStrings = window[$66e6f8d0bba3de41$var$$5b160d28a433310d$var$stringsSymbol];
            if (!globalStrings) return null;
            $66e6f8d0bba3de41$var$$5b160d28a433310d$var$cachedGlobalStrings = {};
            for(let pkg in globalStrings)$66e6f8d0bba3de41$var$$5b160d28a433310d$var$cachedGlobalStrings[pkg] = new $66e6f8d0bba3de41$export$c17fa47878dc55b6({
                [locale]: globalStrings[pkg]
            }, locale);
        }
        let dictionary = $66e6f8d0bba3de41$var$$5b160d28a433310d$var$cachedGlobalStrings === null || $66e6f8d0bba3de41$var$$5b160d28a433310d$var$cachedGlobalStrings === void 0 ? void 0 : $66e6f8d0bba3de41$var$$5b160d28a433310d$var$cachedGlobalStrings[packageName];
        if (!dictionary) throw new Error(`Strings for package "${packageName}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
        return dictionary;
    }
    constructor(messages, defaultLocale = 'en-US'){
        // Clone messages so we don't modify the original object.
        // Filter out entries with falsy values which may have been caused by applying optimize-locales-plugin.
        this.strings = Object.fromEntries(Object.entries(messages).filter(([, v])=>v));
        this.defaultLocale = defaultLocale;
    }
}
function $66e6f8d0bba3de41$var$$5b160d28a433310d$var$getStringsForLocale(locale, strings, defaultLocale = 'en-US') {
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    let language = $66e6f8d0bba3de41$var$$5b160d28a433310d$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(let key in strings){
        if (key.startsWith(language + '-')) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $66e6f8d0bba3de41$var$$5b160d28a433310d$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).language;
    return locale.split('-')[0];
}

});

parcelRegister("72apB", function(module, exports) {

$parcel$export(module.exports, "LocalizedStringFormatter", function () { return $d6b70445f906064f$export$2f817fcdc4b89ae0; });
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $d6b70445f906064f$var$$6db58dc88e78b024$var$pluralRulesCache = new Map();
const $d6b70445f906064f$var$$6db58dc88e78b024$var$numberFormatCache = new Map();
class $d6b70445f906064f$export$2f817fcdc4b89ae0 {
    /** Formats a localized string for the given key with the provided variables. */ format(key, variables) {
        let message = this.strings.getStringForLocale(key, this.locale);
        return typeof message === 'function' ? message(variables, this) : message;
    }
    plural(count, options, type = 'cardinal') {
        let opt = options['=' + count];
        if (opt) return typeof opt === 'function' ? opt() : opt;
        let key = this.locale + ':' + type;
        let pluralRules = $d6b70445f906064f$var$$6db58dc88e78b024$var$pluralRulesCache.get(key);
        if (!pluralRules) {
            pluralRules = new Intl.PluralRules(this.locale, {
                type: type
            });
            $d6b70445f906064f$var$$6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
        }
        let selected = pluralRules.select(count);
        opt = options[selected] || options.other;
        return typeof opt === 'function' ? opt() : opt;
    }
    number(value) {
        let numberFormat = $d6b70445f906064f$var$$6db58dc88e78b024$var$numberFormatCache.get(this.locale);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat(this.locale);
            $d6b70445f906064f$var$$6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
        }
        return numberFormat.format(value);
    }
    select(options, value) {
        let opt = options[value] || options.other;
        return typeof opt === 'function' ? opt() : opt;
    }
    constructor(locale, strings){
        this.locale = locale;
        this.strings = strings;
    }
}

});


parcelRegister("lhOYy", function(module, exports) {

$parcel$export(module.exports, "useVisuallyHidden", function () { return $00cb3d273a06f4d8$export$a966af930f325cab; });
$parcel$export(module.exports, "VisuallyHidden", function () { return $00cb3d273a06f4d8$export$439d29a4e110a164; });

var $hAxtE = parcelRequire("hAxtE");

var $bh6RR = parcelRequire("bh6RR");

var $fmkmo = parcelRequire("fmkmo");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $00cb3d273a06f4d8$var$$5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: '1px',
    whiteSpace: 'nowrap'
};
function $00cb3d273a06f4d8$export$a966af930f325cab(props = {}) {
    let { style: style, isFocusable: isFocusable } = props;
    let [isFocused, setFocused] = (0, $bh6RR.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $fmkmo.useFocusWithin)({
        isDisabled: !isFocusable,
        onFocusWithinChange: (val)=>setFocused(val)
    });
    // If focused, don't hide the element.
    let combinedStyles = (0, $bh6RR.useMemo)(()=>{
        if (isFocused) return style;
        else if (style) return {
            ...$00cb3d273a06f4d8$var$$5c3e21d68f1c4674$var$styles,
            ...style
        };
        else return $00cb3d273a06f4d8$var$$5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: {
            ...focusWithinProps,
            style: combinedStyles
        }
    };
}
function $00cb3d273a06f4d8$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: children, elementType: Element = 'div', isFocusable: isFocusable, style: style, ...otherProps } = props;
    let { visuallyHiddenProps: visuallyHiddenProps } = $00cb3d273a06f4d8$export$a966af930f325cab(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Element, (0, $hAxtE.mergeProps)(otherProps, visuallyHiddenProps), children);
}

});


parcelRegister("aAM1f", function(module, exports) {

$parcel$export(module.exports, "Overlay", function () { return $8dc6e3bc73e48471$export$c6fdb837b070b4ff; });
$parcel$export(module.exports, "useOverlayFocusContain", function () { return $8dc6e3bc73e48471$export$14c98a7594375490; });

var $a9Buj = parcelRequire("a9Buj");

var $3obwd = parcelRequire("3obwd");

var $2NhrA = parcelRequire("2NhrA");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $gFA2q = parcelRequire("gFA2q");

var $f2PTm = parcelRequire("f2PTm");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $8dc6e3bc73e48471$export$a2200b96afd16271 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
function $8dc6e3bc73e48471$export$c6fdb837b070b4ff(props) {
    let isSSR = (0, $gFA2q.useIsSSR)();
    let { portalContainer: portalContainer = isSSR ? null : document.body, isExiting: isExiting } = props;
    let [contain, setContain] = (0, $bh6RR.useState)(false);
    let contextValue = (0, $bh6RR.useMemo)(()=>({
            contain: contain,
            setContain: setContain
        }), [
        contain,
        setContain
    ]);
    let { getContainer: getContainer } = (0, $a9Buj.useUNSTABLE_PortalContext)();
    if (!props.portalContainer && getContainer) portalContainer = getContainer();
    if (!portalContainer) return null;
    let contents = props.children;
    if (!props.disableFocusManagement) contents = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2NhrA.FocusScope), {
        restoreFocus: true,
        contain: contain && !isExiting
    }, contents);
    contents = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($8dc6e3bc73e48471$export$a2200b96afd16271.Provider, {
        value: contextValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3obwd.ClearPressResponder), null, contents));
    return (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).createPortal(contents, portalContainer);
}
function $8dc6e3bc73e48471$export$14c98a7594375490() {
    let ctx = (0, $bh6RR.useContext)($8dc6e3bc73e48471$export$a2200b96afd16271);
    let setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
    (0, $f2PTm.useLayoutEffect)(()=>{
        setContain === null || setContain === void 0 || setContain(true);
    }, [
        setContain
    ]);
}

});
parcelRegister("a9Buj", function(module, exports) {

$parcel$export(module.exports, "useUNSTABLE_PortalContext", function () { return $7f86ac4f91f2394d$export$574e9b0fb070c3b0; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $7f86ac4f91f2394d$export$60d741e20e0aa309 = (0, $bh6RR.createContext)({});
function $7f86ac4f91f2394d$export$db995ea7163b4b67(props) {
    let { getContainer: getContainer } = props;
    let { getContainer: ctxGetContainer } = $7f86ac4f91f2394d$export$574e9b0fb070c3b0();
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($7f86ac4f91f2394d$export$60d741e20e0aa309.Provider, {
        value: {
            getContainer: getContainer === null ? undefined : getContainer !== null && getContainer !== void 0 ? getContainer : ctxGetContainer
        }
    }, props.children);
}
function $7f86ac4f91f2394d$export$574e9b0fb070c3b0() {
    var _useContext;
    return (_useContext = (0, $bh6RR.useContext)($7f86ac4f91f2394d$export$60d741e20e0aa309)) !== null && _useContext !== void 0 ? _useContext : {};
}

});

parcelRegister("3obwd", function(module, exports) {

$parcel$export(module.exports, "PressResponder", function () { return $3993ffa318a0e764$export$3351871ee4b288b8; });
$parcel$export(module.exports, "ClearPressResponder", function () { return $3993ffa318a0e764$export$cf75428e0b9ed1ea; });

var $6zN4N = parcelRequire("6zN4N");

var $hAxtE = parcelRequire("hAxtE");
var $jyDr8 = parcelRequire("jyDr8");
var $f4N4u = parcelRequire("f4N4u");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3993ffa318a0e764$export$3351871ee4b288b8 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(({ children: children, ...props }, ref)=>{
    let isRegistered = (0, $bh6RR.useRef)(false);
    let prevContext = (0, $bh6RR.useContext)((0, $6zN4N.PressResponderContext));
    ref = (0, $jyDr8.useObjectRef)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    let context = (0, $hAxtE.mergeProps)(prevContext || {}, {
        ...props,
        ref: ref,
        register () {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    });
    (0, $f4N4u.useSyncRef)(prevContext, ref);
    (0, $bh6RR.useEffect)(()=>{
        if (!isRegistered.current) {
            console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
            isRegistered.current = true; // only warn once in strict mode.
        }
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6zN4N.PressResponderContext).Provider, {
        value: context
    }, children);
});
function $3993ffa318a0e764$export$cf75428e0b9ed1ea({ children: children }) {
    let context = (0, $bh6RR.useMemo)(()=>({
            register: ()=>{}
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6zN4N.PressResponderContext).Provider, {
        value: context
    }, children);
}

});

parcelRegister("2NhrA", function(module, exports) {

$parcel$export(module.exports, "FocusScope", function () { return $053e67c27bee2745$export$20e40289641fbbb6; });
$parcel$export(module.exports, "getFocusableTreeWalker", function () { return $053e67c27bee2745$export$2d6ec8fc375ceafa; });
$parcel$export(module.exports, "isElementInChildOfActiveScope", function () { return $053e67c27bee2745$export$1258395f99bf9cbf; });
$parcel$export(module.exports, "createFocusManager", function () { return $053e67c27bee2745$export$c5251b9e124bf29; });

var $bQDsd = parcelRequire("bQDsd");

var $2QYti = parcelRequire("2QYti");

var $evWQs = parcelRequire("evWQs");
var $f2PTm = parcelRequire("f2PTm");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $053e67c27bee2745$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
const $053e67c27bee2745$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT = 'react-aria-focus-scope-restore';
let $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope = null;
function $053e67c27bee2745$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $bh6RR.useRef)(null);
    let endRef = (0, $bh6RR.useRef)(null);
    let scopeRef = (0, $bh6RR.useRef)([]);
    let { parentNode: parentNode } = (0, $bh6RR.useContext)($053e67c27bee2745$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $bh6RR.useMemo)(()=>new $053e67c27bee2745$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $f2PTm.useLayoutEffect)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $053e67c27bee2745$export$d06fae2ee68b101e.root;
        if ($053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope && !$053e67c27bee2745$var$$9bf71ea28793e738$var$isAncestorScope($053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode($053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $053e67c27bee2745$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $f2PTm.useLayoutEffect)(()=>{
        let node = $053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $f2PTm.useLayoutEffect)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        let stopPropagation = (e)=>e.stopPropagation();
        while(node && node !== endRef.current){
            nodes.push(node);
            // Stop custom restore focus event from propagating to parent focus scopes.
            node.addEventListener($053e67c27bee2745$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
        return ()=>{
            for (let node of nodes)node.removeEventListener($053e67c27bee2745$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation);
        };
    }, [
        children
    ]);
    $053e67c27bee2745$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $053e67c27bee2745$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $053e67c27bee2745$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $053e67c27bee2745$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        const activeElement = (0, $evWQs.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $053e67c27bee2745$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $f2PTm.useLayoutEffect)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope || $053e67c27bee2745$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode(parentScope))) $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $053e67c27bee2745$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $bh6RR.useMemo)(()=>$053e67c27bee2745$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $bh6RR.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($053e67c27bee2745$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $053e67c27bee2745$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $bh6RR.useContext)($053e67c27bee2745$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $evWQs.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $053e67c27bee2745$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $053e67c27bee2745$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $evWQs.getOwnerDocument)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $053e67c27bee2745$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $053e67c27bee2745$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $053e67c27bee2745$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $053e67c27bee2745$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $053e67c27bee2745$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $053e67c27bee2745$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $053e67c27bee2745$var$$9bf71ea28793e738$var$focusableElements = [
    'input:not([disabled]):not([type=hidden])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]'
];
const $053e67c27bee2745$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $053e67c27bee2745$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]),') + ',[tabindex]:not([disabled]):not([hidden])';
$053e67c27bee2745$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $053e67c27bee2745$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $053e67c27bee2745$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $053e67c27bee2745$export$4c063cf1350e6fed(element) {
    return element.matches($053e67c27bee2745$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode($053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $bh6RR.useRef)(undefined);
    let raf = (0, $bh6RR.useRef)(undefined);
    (0, $f2PTm.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $evWQs.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$053e67c27bee2745$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $053e67c27bee2745$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $053e67c27bee2745$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope || $053e67c27bee2745$var$$9bf71ea28793e738$var$isAncestorScope($053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($053e67c27bee2745$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope && $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope.current) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusFirstInScope($053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($053e67c27bee2745$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $053e67c27bee2745$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope.current) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusFirstInScope($053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener('keydown', onKeyDown, false);
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener('focusout', onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener('keydown', onKeyDown, false);
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener('focusout', onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $f2PTm.useLayoutEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest('[data-react-aria-top-layer]')) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $053e67c27bee2745$export$d06fae2ee68b101e.traverse($053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $053e67c27bee2745$export$1258395f99bf9cbf(element) {
    return $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInChildScope(element, $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope);
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $bQDsd.focusSafely)(element);
    } catch  {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch  {
    // ignore
    }
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$getFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $053e67c27bee2745$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $053e67c27bee2745$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $053e67c27bee2745$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $053e67c27bee2745$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    return nextNode;
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement($053e67c27bee2745$var$$9bf71ea28793e738$var$getFirstInScope(scope, tabbable));
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current) {
            $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $evWQs.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $f2PTm.useLayoutEffect)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $evWQs.getOwnerDocument)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode($053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $bh6RR.useRef)(typeof document !== 'undefined' ? (0, $evWQs.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $f2PTm.useLayoutEffect)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $evWQs.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope || $053e67c27bee2745$var$$9bf71ea28793e738$var$isAncestorScope($053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $053e67c27bee2745$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener('focusin', onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener('focusin', onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener('focusin', onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener('focusin', onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $f2PTm.useLayoutEffect)(()=>{
        const ownerDocument = (0, $evWQs.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$053e67c27bee2745$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInChildScope(focusedElement, scopeRef) || !$053e67c27bee2745$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef)) return;
            let treeNode = $053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $053e67c27bee2745$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInChildScope(nextElement, scopeRef)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInChildScope(nextElement, scopeRef));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $f2PTm.useLayoutEffect)(()=>{
        const ownerDocument = (0, $evWQs.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && (ownerDocument.activeElement && $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef) || ownerDocument.activeElement === ownerDocument.body && $053e67c27bee2745$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $053e67c27bee2745$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $053e67c27bee2745$var$$9bf71ea28793e738$var$restoreFocusToElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $053e67c27bee2745$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                let node = $053e67c27bee2745$var$$9bf71ea28793e738$var$getFirstInScope(treeNode.scopeRef.current, true);
                                $053e67c27bee2745$var$$9bf71ea28793e738$var$restoreFocusToElement(node);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$restoreFocusToElement(node) {
    // Dispatch a custom event that parent elements can intercept to customize focus restoration.
    // For example, virtualized collection components reuse DOM elements, so the original element
    // might still exist in the DOM but representing a different item.
    if (node.dispatchEvent(new CustomEvent($053e67c27bee2745$var$$9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, {
        bubbles: true,
        cancelable: true
    }))) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(node);
}
function $053e67c27bee2745$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $053e67c27bee2745$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $053e67c27bee2745$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $evWQs.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $2QYti.isElementVisible)(node) && (!scope || $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $053e67c27bee2745$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $evWQs.getOwnerDocument)(root).activeElement;
            let walker = $053e67c27bee2745$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $evWQs.getOwnerDocument)(root).activeElement;
            let walker = $053e67c27bee2745$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $053e67c27bee2745$var$$9bf71ea28793e738$var$last(walker);
                if (next) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $053e67c27bee2745$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $053e67c27bee2745$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $053e67c27bee2745$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $053e67c27bee2745$var$$9bf71ea28793e738$var$last(walker);
            if (next) $053e67c27bee2745$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $053e67c27bee2745$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $053e67c27bee2745$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $053e67c27bee2745$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $053e67c27bee2745$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $053e67c27bee2745$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $053e67c27bee2745$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $053e67c27bee2745$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $053e67c27bee2745$export$d06fae2ee68b101e = new $053e67c27bee2745$var$$9bf71ea28793e738$var$Tree();

});
parcelRegister("2QYti", function(module, exports) {

$parcel$export(module.exports, "isElementVisible", function () { return $23afd1a48534524c$export$e989c0fffaa6b27a; });

var $evWQs = parcelRequire("evWQs");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $23afd1a48534524c$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $evWQs.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== 'none' && computedVisibility !== 'hidden' && computedVisibility !== 'collapse';
    }
    return isVisible;
}
function $23afd1a48534524c$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute('hidden') && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute('data-react-aria-prevent-focus') && (element.nodeName === 'DETAILS' && childElement && childElement.nodeName !== 'SUMMARY' ? element.hasAttribute('open') : true);
}
function $23afd1a48534524c$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== '#comment' && $23afd1a48534524c$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $23afd1a48534524c$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $23afd1a48534524c$export$e989c0fffaa6b27a(element.parentElement, element));
}

});



parcelRegister("6M2SS", function(module, exports) {

$parcel$export(module.exports, "usePopover", function () { return $98a2f82bb3eab6a2$export$542a6fd13ac93354; });

var $ak7U8 = parcelRequire("ak7U8");

var $lE55s = parcelRequire("lE55s");

var $igoBt = parcelRequire("igoBt");

var $3bzcI = parcelRequire("3bzcI");

var $hAxtE = parcelRequire("hAxtE");
var $f2PTm = parcelRequire("f2PTm");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $98a2f82bb3eab6a2$export$542a6fd13ac93354(props, state) {
    let { triggerRef: triggerRef, popoverRef: popoverRef, isNonModal: isNonModal, isKeyboardDismissDisabled: isKeyboardDismissDisabled, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside, ...otherProps } = props;
    let { overlayProps: overlayProps, underlayProps: underlayProps } = (0, $igoBt.useOverlay)({
        // If popover is in the top layer, it should not prevent other popovers from being dismissed.
        isOpen: state.isOpen && !otherProps['data-react-aria-top-layer'],
        onClose: state.close,
        shouldCloseOnBlur: true,
        isDismissable: !isNonModal,
        isKeyboardDismissDisabled: isKeyboardDismissDisabled,
        shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
    }, popoverRef);
    let { overlayProps: positionProps, arrowProps: arrowProps, placement: placement } = (0, $lE55s.useOverlayPosition)({
        ...otherProps,
        targetRef: triggerRef,
        overlayRef: popoverRef,
        isOpen: state.isOpen,
        onClose: isNonModal ? state.close : undefined
    });
    (0, $3bzcI.usePreventScroll)({
        isDisabled: isNonModal || !state.isOpen
    });
    (0, $f2PTm.useLayoutEffect)(()=>{
        if (state.isOpen && !isNonModal && popoverRef.current) return (0, $ak7U8.ariaHideOutside)([
            popoverRef.current
        ]);
    }, [
        isNonModal,
        state.isOpen,
        popoverRef
    ]);
    return {
        popoverProps: (0, $hAxtE.mergeProps)(overlayProps, positionProps),
        arrowProps: arrowProps,
        underlayProps: underlayProps,
        placement: placement
    };
}

});
parcelRegister("ak7U8", function(module, exports) {

$parcel$export(module.exports, "ariaHideOutside", function () { return $5a6168a40a28ca06$export$1c3ebcada18427bf; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $5a6168a40a28ca06$var$$5e3802645cc19319$var$refCountMap = new WeakMap();
let $5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack = [];
function $5a6168a40a28ca06$export$1c3ebcada18427bf(targets, root = document.body) {
    let visibleNodes = new Set(targets);
    let hiddenNodes = new Set();
    let walk = (root)=>{
        // Keep live announcer and top layer elements (e.g. toasts) visible.
        for (let element of root.querySelectorAll('[data-live-announcer], [data-react-aria-top-layer]'))visibleNodes.add(element);
        let acceptNode = (node)=>{
            // Skip this node and its children if it is one of the target nodes, or a live announcer.
            // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
            // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
            // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
            if (visibleNodes.has(node) || node.parentElement && hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute('role') !== 'row') return NodeFilter.FILTER_REJECT;
            // Skip this node but continue to children if one of the targets is inside the node.
            for (let target of visibleNodes){
                if (node.contains(target)) return NodeFilter.FILTER_SKIP;
            }
            return NodeFilter.FILTER_ACCEPT;
        };
        let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
            acceptNode: acceptNode
        });
        // TreeWalker does not include the root.
        let acceptRoot = acceptNode(root);
        if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
        if (acceptRoot !== NodeFilter.FILTER_REJECT) {
            let node = walker.nextNode();
            while(node != null){
                hide(node);
                node = walker.nextNode();
            }
        }
    };
    let hide = (node)=>{
        var _refCountMap_get;
        let refCount = (_refCountMap_get = $5a6168a40a28ca06$var$$5e3802645cc19319$var$refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
        // If already aria-hidden, and the ref count is zero, then this element
        // was already hidden and there's nothing for us to do.
        if (node.getAttribute('aria-hidden') === 'true' && refCount === 0) return;
        if (refCount === 0) node.setAttribute('aria-hidden', 'true');
        hiddenNodes.add(node);
        $5a6168a40a28ca06$var$$5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
    };
    // If there is already a MutationObserver listening from a previous call,
    // disconnect it so the new on takes over.
    if ($5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack.length) $5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack[$5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack.length - 1].disconnect();
    walk(root);
    let observer = new MutationObserver((changes)=>{
        for (let change of changes){
            if (change.type !== 'childList' || change.addedNodes.length === 0) continue;
            // If the parent element of the added nodes is not within one of the targets,
            // and not already inside a hidden node, hide all of the new children.
            if (![
                ...visibleNodes,
                ...hiddenNodes
            ].some((node)=>node.contains(change.target))) {
                for (let node of change.removedNodes)if (node instanceof Element) {
                    visibleNodes.delete(node);
                    hiddenNodes.delete(node);
                }
                for (let node of change.addedNodes){
                    if ((node instanceof HTMLElement || node instanceof SVGElement) && (node.dataset.liveAnnouncer === 'true' || node.dataset.reactAriaTopLayer === 'true')) visibleNodes.add(node);
                    else if (node instanceof Element) walk(node);
                }
            }
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
    let observerWrapper = {
        observe () {
            observer.observe(root, {
                childList: true,
                subtree: true
            });
        },
        disconnect () {
            observer.disconnect();
        }
    };
    $5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack.push(observerWrapper);
    return ()=>{
        observer.disconnect();
        for (let node of hiddenNodes){
            let count = $5a6168a40a28ca06$var$$5e3802645cc19319$var$refCountMap.get(node);
            if (count == null) continue;
            if (count === 1) {
                node.removeAttribute('aria-hidden');
                $5a6168a40a28ca06$var$$5e3802645cc19319$var$refCountMap.delete(node);
            } else $5a6168a40a28ca06$var$$5e3802645cc19319$var$refCountMap.set(node, count - 1);
        }
        // Remove this observer from the stack, and start the previous one.
        if (observerWrapper === $5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack[$5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack.length - 1]) {
            $5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack.pop();
            if ($5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack.length) $5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack[$5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack.length - 1].observe();
        } else $5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack.splice($5a6168a40a28ca06$var$$5e3802645cc19319$var$observerStack.indexOf(observerWrapper), 1);
    };
}

});

parcelRegister("lE55s", function(module, exports) {

$parcel$export(module.exports, "useOverlayPosition", function () { return $ebe567a089a43f88$export$d39e1813b3bdd0e1; });

var $caswF = parcelRequire("caswF");

var $6H0Es = parcelRequire("6H0Es");

var $bh6RR = parcelRequire("bh6RR");

var $f2PTm = parcelRequire("f2PTm");
var $7KwSx = parcelRequire("7KwSx");

var $c8uzR = parcelRequire("c8uzR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport = typeof document !== 'undefined' ? window.visualViewport : null;
function $ebe567a089a43f88$export$d39e1813b3bdd0e1(props) {
    let { direction: direction } = (0, $c8uzR.useLocale)();
    let { arrowSize: arrowSize = 0, targetRef: targetRef, overlayRef: overlayRef, scrollRef: scrollRef = overlayRef, placement: placement = 'bottom', containerPadding: containerPadding = 12, shouldFlip: shouldFlip = true, boundaryElement: boundaryElement = typeof document !== 'undefined' ? document.body : null, offset: offset = 0, crossOffset: crossOffset = 0, shouldUpdatePosition: shouldUpdatePosition = true, isOpen: isOpen = true, onClose: onClose, maxHeight: maxHeight, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = props;
    let [position, setPosition] = (0, $bh6RR.useState)(null);
    let deps = [
        shouldUpdatePosition,
        placement,
        overlayRef.current,
        targetRef.current,
        scrollRef.current,
        containerPadding,
        shouldFlip,
        boundaryElement,
        offset,
        crossOffset,
        isOpen,
        direction,
        maxHeight,
        arrowBoundaryOffset,
        arrowSize
    ];
    // Note, the position freezing breaks if body sizes itself dynamicly with the visual viewport but that might
    // just be a non-realistic use case
    // Upon opening a overlay, record the current visual viewport scale so we can freeze the overlay styles
    let lastScale = (0, $bh6RR.useRef)($ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === null || $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport.scale);
    (0, $bh6RR.useEffect)(()=>{
        if (isOpen) lastScale.current = $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === null || $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport.scale;
    }, [
        isOpen
    ]);
    let updatePosition = (0, $bh6RR.useCallback)(()=>{
        if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !boundaryElement) return;
        if (($ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === null || $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport.scale) !== lastScale.current) return;
        // Determine a scroll anchor based on the focused element.
        // This stores the offset of the anchor element from the scroll container
        // so it can be restored after repositioning. This way if the overlay height
        // changes, the focused element appears to stay in the same position.
        let anchor = null;
        if (scrollRef.current && scrollRef.current.contains(document.activeElement)) {
            var _document_activeElement;
            let anchorRect = (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.getBoundingClientRect();
            let scrollRect = scrollRef.current.getBoundingClientRect();
            var _anchorRect_top;
            // Anchor from the top if the offset is in the top half of the scrollable element,
            // otherwise anchor from the bottom.
            anchor = {
                type: 'top',
                offset: ((_anchorRect_top = anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.top) !== null && _anchorRect_top !== void 0 ? _anchorRect_top : 0) - scrollRect.top
            };
            if (anchor.offset > scrollRect.height / 2) {
                anchor.type = 'bottom';
                var _anchorRect_bottom;
                anchor.offset = ((_anchorRect_bottom = anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.bottom) !== null && _anchorRect_bottom !== void 0 ? _anchorRect_bottom : 0) - scrollRect.bottom;
            }
        }
        // Always reset the overlay's previous max height if not defined by the user so that we can compensate for
        // RAC collections populating after a second render and properly set a correct max height + positioning when it populates.
        let overlay = overlayRef.current;
        if (!maxHeight && overlayRef.current) {
            var _window_visualViewport;
            overlay.style.top = '0px';
            overlay.style.bottom = '';
            var _window_visualViewport_height;
            overlay.style.maxHeight = ((_window_visualViewport_height = (_window_visualViewport = window.visualViewport) === null || _window_visualViewport === void 0 ? void 0 : _window_visualViewport.height) !== null && _window_visualViewport_height !== void 0 ? _window_visualViewport_height : window.innerHeight) + 'px';
        }
        let position = (0, $caswF.calculatePosition)({
            placement: $ebe567a089a43f88$var$$2a41e45df1593e64$var$translateRTL(placement, direction),
            overlayNode: overlayRef.current,
            targetNode: targetRef.current,
            scrollNode: scrollRef.current || overlayRef.current,
            padding: containerPadding,
            shouldFlip: shouldFlip,
            boundaryElement: boundaryElement,
            offset: offset,
            crossOffset: crossOffset,
            maxHeight: maxHeight,
            arrowSize: arrowSize,
            arrowBoundaryOffset: arrowBoundaryOffset
        });
        if (!position.position) return;
        // Modify overlay styles directly so positioning happens immediately without the need of a second render
        // This is so we don't have to delay autoFocus scrolling or delay applying preventScroll for popovers
        overlay.style.top = '';
        overlay.style.bottom = '';
        overlay.style.left = '';
        overlay.style.right = '';
        Object.keys(position.position).forEach((key)=>overlay.style[key] = position.position[key] + 'px');
        overlay.style.maxHeight = position.maxHeight != null ? position.maxHeight + 'px' : '';
        // Restore scroll position relative to anchor element.
        if (anchor && document.activeElement && scrollRef.current) {
            let anchorRect = document.activeElement.getBoundingClientRect();
            let scrollRect = scrollRef.current.getBoundingClientRect();
            let newOffset = anchorRect[anchor.type] - scrollRect[anchor.type];
            scrollRef.current.scrollTop += newOffset - anchor.offset;
        }
        // Trigger a set state for a second render anyway for arrow positioning
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    (0, $f2PTm.useLayoutEffect)(updatePosition, deps);
    // Update position on window resize
    $ebe567a089a43f88$var$$2a41e45df1593e64$var$useResize(updatePosition);
    (0, $7KwSx.useResizeObserver)({
        ref: overlayRef,
        onResize: updatePosition
    });
    (0, $7KwSx.useResizeObserver)({
        ref: targetRef,
        onResize: updatePosition
    });
    // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
    // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
    let isResizing = (0, $bh6RR.useRef)(false);
    (0, $f2PTm.useLayoutEffect)(()=>{
        let timeout;
        let onResize = ()=>{
            isResizing.current = true;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                isResizing.current = false;
            }, 500);
            updatePosition();
        };
        // Only reposition the overlay if a scroll event happens immediately as a result of resize (aka the virtual keyboard has appears)
        // We don't want to reposition the overlay if the user has pinch zoomed in and is scrolling the viewport around.
        let onScroll = ()=>{
            if (isResizing.current) onResize();
        };
        $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === null || $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === void 0 || $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport.addEventListener('resize', onResize);
        $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === null || $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === void 0 || $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport.addEventListener('scroll', onScroll);
        return ()=>{
            $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === null || $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === void 0 || $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport.removeEventListener('resize', onResize);
            $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === null || $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport === void 0 || $ebe567a089a43f88$var$$2a41e45df1593e64$var$visualViewport.removeEventListener('scroll', onScroll);
        };
    }, [
        updatePosition
    ]);
    let close = (0, $bh6RR.useCallback)(()=>{
        if (!isResizing.current) onClose === null || onClose === void 0 || onClose();
    }, [
        onClose,
        isResizing
    ]);
    (0, $6H0Es.useCloseOnScroll)({
        triggerRef: targetRef,
        isOpen: isOpen,
        onClose: onClose && close
    });
    var _position_maxHeight, _position_placement;
    return {
        overlayProps: {
            style: {
                position: 'absolute',
                zIndex: 100000,
                ...position === null || position === void 0 ? void 0 : position.position,
                maxHeight: (_position_maxHeight = position === null || position === void 0 ? void 0 : position.maxHeight) !== null && _position_maxHeight !== void 0 ? _position_maxHeight : '100vh'
            }
        },
        placement: (_position_placement = position === null || position === void 0 ? void 0 : position.placement) !== null && _position_placement !== void 0 ? _position_placement : null,
        arrowProps: {
            'aria-hidden': 'true',
            role: 'presentation',
            style: {
                left: position === null || position === void 0 ? void 0 : position.arrowOffsetLeft,
                top: position === null || position === void 0 ? void 0 : position.arrowOffsetTop
            }
        },
        updatePosition: updatePosition
    };
}
function $ebe567a089a43f88$var$$2a41e45df1593e64$var$useResize(onResize) {
    (0, $f2PTm.useLayoutEffect)(()=>{
        window.addEventListener('resize', onResize, false);
        return ()=>{
            window.removeEventListener('resize', onResize, false);
        };
    }, [
        onResize
    ]);
}
function $ebe567a089a43f88$var$$2a41e45df1593e64$var$translateRTL(position, direction) {
    if (direction === 'rtl') return position.replace('start', 'right').replace('end', 'left');
    return position.replace('start', 'left').replace('end', 'right');
}

});
parcelRegister("caswF", function(module, exports) {

$parcel$export(module.exports, "calculatePosition", function () { return $146ded1a5dbf1996$export$b3ceb0cbf1056d98; });

var $96djM = parcelRequire("96djM");
var $be6XU = parcelRequire("be6XU");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS = {
    top: 'top',
    bottom: 'top',
    left: 'left',
    right: 'left'
};
const $146ded1a5dbf1996$var$$edcf132a9284368a$var$FLIPPED_DIRECTION = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $146ded1a5dbf1996$var$$edcf132a9284368a$var$CROSS_AXIS = {
    top: 'left',
    left: 'top'
};
const $146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS_SIZE = {
    top: 'height',
    left: 'width'
};
const $146ded1a5dbf1996$var$$edcf132a9284368a$var$TOTAL_SIZE = {
    width: 'totalWidth',
    height: 'totalHeight'
};
const $146ded1a5dbf1996$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
let $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport = typeof document !== 'undefined' ? window.visualViewport : null;
function $146ded1a5dbf1996$var$$edcf132a9284368a$var$getContainerDimensions(containerNode) {
    let width = 0, height = 0, totalWidth = 0, totalHeight = 0, top = 0, left = 0;
    let scroll = {};
    var _visualViewport_scale;
    let isPinchZoomedIn = ((_visualViewport_scale = $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport === null || $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport.scale) !== null && _visualViewport_scale !== void 0 ? _visualViewport_scale : 1) > 1;
    if (containerNode.tagName === 'BODY') {
        let documentElement = document.documentElement;
        totalWidth = documentElement.clientWidth;
        totalHeight = documentElement.clientHeight;
        var _visualViewport_width;
        width = (_visualViewport_width = $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport === null || $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport.width) !== null && _visualViewport_width !== void 0 ? _visualViewport_width : totalWidth;
        var _visualViewport_height;
        height = (_visualViewport_height = $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport === null || $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : totalHeight;
        scroll.top = documentElement.scrollTop || containerNode.scrollTop;
        scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
        // The goal of the below is to get a top/left value that represents the top/left of the visual viewport with
        // respect to the layout viewport origin. This combined with the scrollTop/scrollLeft will allow us to calculate
        // coordinates/values with respect to the visual viewport or with respect to the layout viewport.
        if ($146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport) {
            top = $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport.offsetTop;
            left = $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport.offsetLeft;
        }
    } else {
        ({ width: width, height: height, top: top, left: left } = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getOffset(containerNode));
        scroll.top = containerNode.scrollTop;
        scroll.left = containerNode.scrollLeft;
        totalWidth = width;
        totalHeight = height;
    }
    if ((0, $be6XU.isWebKit)() && (containerNode.tagName === 'BODY' || containerNode.tagName === 'HTML') && isPinchZoomedIn) {
        // Safari will report a non-zero scrollTop/Left for the non-scrolling body/HTML element when pinch zoomed in unlike other browsers.
        // Set to zero for parity calculations so we get consistent positioning of overlays across all browsers.
        // Also switch to visualViewport.pageTop/pageLeft so that we still accomodate for scroll positioning for body/HTML elements that are actually scrollable
        // before pinch zoom happens
        scroll.top = 0;
        scroll.left = 0;
        var _visualViewport_pageTop;
        top = (_visualViewport_pageTop = $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport === null || $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport.pageTop) !== null && _visualViewport_pageTop !== void 0 ? _visualViewport_pageTop : 0;
        var _visualViewport_pageLeft;
        left = (_visualViewport_pageLeft = $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport === null || $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $146ded1a5dbf1996$var$$edcf132a9284368a$var$visualViewport.pageLeft) !== null && _visualViewport_pageLeft !== void 0 ? _visualViewport_pageLeft : 0;
    }
    return {
        width: width,
        height: height,
        totalWidth: totalWidth,
        totalHeight: totalHeight,
        scroll: scroll,
        top: top,
        left: left
    };
}
function $146ded1a5dbf1996$var$$edcf132a9284368a$var$getScroll(node) {
    return {
        top: node.scrollTop,
        left: node.scrollLeft,
        width: node.scrollWidth,
        height: node.scrollHeight
    };
}
// Determines the amount of space required when moving the overlay to ensure it remains in the boundary
function $146ded1a5dbf1996$var$$edcf132a9284368a$var$getDelta(axis, offset, size, // positioned within (most of the time this is the <body>).
boundaryDimensions, // positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding, containerOffsetWithBoundary) {
    var _containerDimensions_scroll_axis;
    let containerScroll = (_containerDimensions_scroll_axis = containerDimensions.scroll[axis]) !== null && _containerDimensions_scroll_axis !== void 0 ? _containerDimensions_scroll_axis : 0;
    // The height/width of the boundary. Matches the axis along which we are adjusting the overlay position
    let boundarySize = boundaryDimensions[$146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS_SIZE[axis]];
    // Calculate the edges of the boundary (accomodating for the boundary padding) and the edges of the overlay.
    // Note that these values are with respect to the visual viewport (aka 0,0 is the top left of the viewport)
    let boundaryStartEdge = boundaryDimensions.scroll[$146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS[axis]] + padding;
    let boundaryEndEdge = boundarySize + boundaryDimensions.scroll[$146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS[axis]] - padding;
    let startEdgeOffset = offset - containerScroll + containerOffsetWithBoundary[axis] - boundaryDimensions[$146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS[axis]];
    let endEdgeOffset = offset - containerScroll + size + containerOffsetWithBoundary[axis] - boundaryDimensions[$146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS[axis]];
    // If any of the overlay edges falls outside of the boundary, shift the overlay the required amount to align one of the overlay's
    // edges with the closest boundary edge.
    if (startEdgeOffset < boundaryStartEdge) return boundaryStartEdge - startEdgeOffset;
    else if (endEdgeOffset > boundaryEndEdge) return Math.max(boundaryEndEdge - endEdgeOffset, boundaryStartEdge - startEdgeOffset);
    else return 0;
}
function $146ded1a5dbf1996$var$$edcf132a9284368a$var$getMargins(node) {
    let style = window.getComputedStyle(node);
    return {
        top: parseInt(style.marginTop, 10) || 0,
        bottom: parseInt(style.marginBottom, 10) || 0,
        left: parseInt(style.marginLeft, 10) || 0,
        right: parseInt(style.marginRight, 10) || 0
    };
}
function $146ded1a5dbf1996$var$$edcf132a9284368a$var$parsePlacement(input) {
    if ($146ded1a5dbf1996$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]) return $146ded1a5dbf1996$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
    let [placement, crossPlacement] = input.split(' ');
    let axis = $146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS[placement] || 'right';
    let crossAxis = $146ded1a5dbf1996$var$$edcf132a9284368a$var$CROSS_AXIS[axis];
    if (!$146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS[crossPlacement]) crossPlacement = 'center';
    let size = $146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS_SIZE[axis];
    let crossSize = $146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS_SIZE[crossAxis];
    $146ded1a5dbf1996$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input] = {
        placement: placement,
        crossPlacement: crossPlacement,
        axis: axis,
        crossAxis: crossAxis,
        size: size,
        crossSize: crossSize
    };
    return $146ded1a5dbf1996$var$$edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
}
function $146ded1a5dbf1996$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset) {
    let { placement: placement, crossPlacement: crossPlacement, axis: axis, crossAxis: crossAxis, size: size, crossSize: crossSize } = placementInfo;
    let position = {};
    var _childOffset_crossAxis;
    // button position
    position[crossAxis] = (_childOffset_crossAxis = childOffset[crossAxis]) !== null && _childOffset_crossAxis !== void 0 ? _childOffset_crossAxis : 0;
    var _childOffset_crossSize, _overlaySize_crossSize, _childOffset_crossSize1, _overlaySize_crossSize1;
    if (crossPlacement === 'center') // at this point the overlay center should match the button center
    position[crossAxis] += (((_childOffset_crossSize = childOffset[crossSize]) !== null && _childOffset_crossSize !== void 0 ? _childOffset_crossSize : 0) - ((_overlaySize_crossSize = overlaySize[crossSize]) !== null && _overlaySize_crossSize !== void 0 ? _overlaySize_crossSize : 0)) / 2;
    else if (crossPlacement !== crossAxis) // at this point the overlay bottom should match the button bottom
    position[crossAxis] += ((_childOffset_crossSize1 = childOffset[crossSize]) !== null && _childOffset_crossSize1 !== void 0 ? _childOffset_crossSize1 : 0) - ((_overlaySize_crossSize1 = overlaySize[crossSize]) !== null && _overlaySize_crossSize1 !== void 0 ? _overlaySize_crossSize1 : 0);
    /* else {
    the overlay top should match the button top
  } */ position[crossAxis] += crossOffset;
    // overlay top overlapping arrow with button bottom
    const minPosition = childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
    // overlay bottom overlapping arrow with button top
    const maxPosition = childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
    position[crossAxis] = (0, $96djM.clamp)(position[crossAxis], minPosition, maxPosition);
    // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
    if (placement === axis) {
        // If the container is positioned (non-static), then we use the container's actual
        // height, as `bottom` will be relative to this height.  But if the container is static,
        // then it can only be the `document.body`, and `bottom` will be relative to _its_
        // container, which should be as large as boundaryDimensions.
        const containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[$146ded1a5dbf1996$var$$edcf132a9284368a$var$TOTAL_SIZE[size]];
        position[$146ded1a5dbf1996$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
    } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
    return position;
}
function $146ded1a5dbf1996$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlayHeight, heightGrowthDirection) {
    const containerHeight = isContainerPositioned ? containerOffsetWithBoundary.height : boundaryDimensions[$146ded1a5dbf1996$var$$edcf132a9284368a$var$TOTAL_SIZE.height];
    var _position_bottom;
    // For cases where position is set via "bottom" instead of "top", we need to calculate the true overlay top with respect to the boundary. Reverse calculate this with the same method
    // used in computePosition.
    let overlayTop = position.top != null ? containerOffsetWithBoundary.top + position.top : containerOffsetWithBoundary.top + (containerHeight - ((_position_bottom = position.bottom) !== null && _position_bottom !== void 0 ? _position_bottom : 0) - overlayHeight);
    var _boundaryDimensions_scroll_top, _margins_top, _margins_bottom, _boundaryDimensions_scroll_top1, _margins_top1, _margins_bottom1;
    let maxHeight = heightGrowthDirection !== 'top' ? Math.max(0, boundaryDimensions.height + boundaryDimensions.top + ((_boundaryDimensions_scroll_top = boundaryDimensions.scroll.top) !== null && _boundaryDimensions_scroll_top !== void 0 ? _boundaryDimensions_scroll_top : 0) - overlayTop // this is the top of the overlay
     - (((_margins_top = margins.top) !== null && _margins_top !== void 0 ? _margins_top : 0) + ((_margins_bottom = margins.bottom) !== null && _margins_bottom !== void 0 ? _margins_bottom : 0) + padding // save additional space for margin and padding
    )) : Math.max(0, overlayTop + overlayHeight // this is the bottom of the overlay
     - (boundaryDimensions.top + ((_boundaryDimensions_scroll_top1 = boundaryDimensions.scroll.top) !== null && _boundaryDimensions_scroll_top1 !== void 0 ? _boundaryDimensions_scroll_top1 : 0 // this is the top of the boundary
    )) - (((_margins_top1 = margins.top) !== null && _margins_top1 !== void 0 ? _margins_top1 : 0) + ((_margins_bottom1 = margins.bottom) !== null && _margins_bottom1 !== void 0 ? _margins_bottom1 : 0) + padding // save additional space for margin and padding
    ));
    return Math.min(boundaryDimensions.height - padding * 2, maxHeight);
}
function $146ded1a5dbf1996$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
    let { placement: placement, axis: axis, size: size } = placementInfo;
    var _boundaryDimensions_scroll_axis, _margins_axis;
    if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - ((_boundaryDimensions_scroll_axis = boundaryDimensions.scroll[axis]) !== null && _boundaryDimensions_scroll_axis !== void 0 ? _boundaryDimensions_scroll_axis : 0) + containerOffsetWithBoundary[axis] - ((_margins_axis = margins[axis]) !== null && _margins_axis !== void 0 ? _margins_axis : 0) - margins[$146ded1a5dbf1996$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
    var _margins_axis1;
    return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - ((_margins_axis1 = margins[axis]) !== null && _margins_axis1 !== void 0 ? _margins_axis1 : 0) - margins[$146ded1a5dbf1996$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $146ded1a5dbf1996$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset) {
    let placementInfo = $146ded1a5dbf1996$var$$edcf132a9284368a$var$parsePlacement(placementInput);
    let { size: size, crossAxis: crossAxis, crossSize: crossSize, placement: placement, crossPlacement: crossPlacement } = placementInfo;
    let position = $146ded1a5dbf1996$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    let normalizedOffset = offset;
    let space = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
    // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
    if (flip && scrollSize[size] > space) {
        let flippedPlacementInfo = $146ded1a5dbf1996$var$$edcf132a9284368a$var$parsePlacement(`${$146ded1a5dbf1996$var$$edcf132a9284368a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
        let flippedPosition = $146ded1a5dbf1996$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
        let flippedSpace = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
        // If the available space for the flipped position is greater than the original available space, flip.
        if (flippedSpace > space) {
            placementInfo = flippedPlacementInfo;
            position = flippedPosition;
            normalizedOffset = offset;
        }
    }
    // Determine the direction the height of the overlay can grow so that we can choose how to calculate the max height
    let heightGrowthDirection = 'bottom';
    if (placementInfo.axis === 'top') {
        if (placementInfo.placement === 'top') heightGrowthDirection = 'top';
        else if (placementInfo.placement === 'bottom') heightGrowthDirection = 'bottom';
    } else if (placementInfo.crossAxis === 'top') {
        if (placementInfo.crossPlacement === 'top') heightGrowthDirection = 'bottom';
        else if (placementInfo.crossPlacement === 'bottom') heightGrowthDirection = 'top';
    }
    let delta = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let maxHeight = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlaySize.height, heightGrowthDirection);
    if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
    overlaySize.height = Math.min(overlaySize.height, maxHeight);
    position = $146ded1a5dbf1996$var$$edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    delta = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
    position[crossAxis] += delta;
    let arrowPosition = {};
    // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
    // Prefer the arrow being in the center of the trigger/overlay anchor element
    // childOffset[crossAxis] + .5 * childOffset[crossSize] = absolute position with respect to the trigger's coordinate system that would place the arrow in the center of the trigger
    // position[crossAxis] - margins[AXIS[crossAxis]] = value use to transform the position to a value with respect to the overlay's coordinate system. A child element's (aka arrow) position absolute's "0"
    // is positioned after the margin of its parent (aka overlay) so we need to subtract it to get the proper coordinate transform
    let preferredArrowPosition = childOffset[crossAxis] + .5 * childOffset[crossSize] - position[crossAxis] - margins[$146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS[crossAxis]];
    // Min/Max position limits for the arrow with respect to the overlay
    const arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
    var _margins_left, _margins_right, _margins_top, _margins_bottom;
    // overlaySize[crossSize] - margins = true size of the overlay
    const overlayMargin = $146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS[crossAxis] === 'left' ? ((_margins_left = margins.left) !== null && _margins_left !== void 0 ? _margins_left : 0) + ((_margins_right = margins.right) !== null && _margins_right !== void 0 ? _margins_right : 0) : ((_margins_top = margins.top) !== null && _margins_top !== void 0 ? _margins_top : 0) + ((_margins_bottom = margins.bottom) !== null && _margins_bottom !== void 0 ? _margins_bottom : 0);
    const arrowMaxPosition = overlaySize[crossSize] - overlayMargin - arrowSize / 2 - arrowBoundaryOffset;
    // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
    // Same margin accomodation done here as well as for the preferredArrowPosition
    const arrowOverlappingChildMinEdge = childOffset[crossAxis] + arrowSize / 2 - (position[crossAxis] + margins[$146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS[crossAxis]]);
    const arrowOverlappingChildMaxEdge = childOffset[crossAxis] + childOffset[crossSize] - arrowSize / 2 - (position[crossAxis] + margins[$146ded1a5dbf1996$var$$edcf132a9284368a$var$AXIS[crossAxis]]);
    // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
    const arrowPositionOverlappingChild = (0, $96djM.clamp)(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
    arrowPosition[crossAxis] = (0, $96djM.clamp)(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
    return {
        position: position,
        maxHeight: maxHeight,
        arrowOffsetLeft: arrowPosition.left,
        arrowOffsetTop: arrowPosition.top,
        placement: placementInfo.placement
    };
}
function $146ded1a5dbf1996$export$b3ceb0cbf1056d98(opts) {
    let { placement: placement, targetNode: targetNode, overlayNode: overlayNode, scrollNode: scrollNode, padding: padding, shouldFlip: shouldFlip, boundaryElement: boundaryElement, offset: offset, crossOffset: crossOffset, maxHeight: maxHeight, arrowSize: arrowSize = 0, arrowBoundaryOffset: arrowBoundaryOffset = 0 } = opts;
    let container = overlayNode instanceof HTMLElement ? $146ded1a5dbf1996$var$$edcf132a9284368a$var$getContainingBlock(overlayNode) : document.documentElement;
    let isViewportContainer = container === document.documentElement;
    const containerPositionStyle = window.getComputedStyle(container).position;
    let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== 'static';
    let childOffset = isViewportContainer ? $146ded1a5dbf1996$var$$edcf132a9284368a$var$getOffset(targetNode) : $146ded1a5dbf1996$var$$edcf132a9284368a$var$getPosition(targetNode, container);
    if (!isViewportContainer) {
        let { marginTop: marginTop, marginLeft: marginLeft } = window.getComputedStyle(targetNode);
        childOffset.top += parseInt(marginTop, 10) || 0;
        childOffset.left += parseInt(marginLeft, 10) || 0;
    }
    let overlaySize = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getOffset(overlayNode);
    let margins = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getMargins(overlayNode);
    var _margins_left, _margins_right;
    overlaySize.width += ((_margins_left = margins.left) !== null && _margins_left !== void 0 ? _margins_left : 0) + ((_margins_right = margins.right) !== null && _margins_right !== void 0 ? _margins_right : 0);
    var _margins_top, _margins_bottom;
    overlaySize.height += ((_margins_top = margins.top) !== null && _margins_top !== void 0 ? _margins_top : 0) + ((_margins_bottom = margins.bottom) !== null && _margins_bottom !== void 0 ? _margins_bottom : 0);
    let scrollSize = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getScroll(scrollNode);
    let boundaryDimensions = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getContainerDimensions(boundaryElement);
    let containerDimensions = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getContainerDimensions(container);
    // If the container is the HTML element wrapping the body element, the retrieved scrollTop/scrollLeft will be equal to the
    // body element's scroll. Set the container's scroll values to 0 since the overlay's edge position value in getDelta don't then need to be further offset
    // by the container scroll since they are essentially the same containing element and thus in the same coordinate system
    let containerOffsetWithBoundary = boundaryElement.tagName === 'BODY' ? $146ded1a5dbf1996$var$$edcf132a9284368a$var$getOffset(container) : $146ded1a5dbf1996$var$$edcf132a9284368a$var$getPosition(container, boundaryElement);
    if (container.tagName === 'HTML' && boundaryElement.tagName === 'BODY') {
        containerDimensions.scroll.top = 0;
        containerDimensions.scroll.left = 0;
    }
    return $146ded1a5dbf1996$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset);
}
function $146ded1a5dbf1996$var$$edcf132a9284368a$var$getOffset(node) {
    let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
    let { scrollTop: scrollTop, scrollLeft: scrollLeft, clientTop: clientTop, clientLeft: clientLeft } = document.documentElement;
    return {
        top: top + scrollTop - clientTop,
        left: left + scrollLeft - clientLeft,
        width: width,
        height: height
    };
}
function $146ded1a5dbf1996$var$$edcf132a9284368a$var$getPosition(node, parent) {
    let style = window.getComputedStyle(node);
    let offset;
    if (style.position === 'fixed') {
        let { top: top, left: left, width: width, height: height } = node.getBoundingClientRect();
        offset = {
            top: top,
            left: left,
            width: width,
            height: height
        };
    } else {
        offset = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getOffset(node);
        let parentOffset = $146ded1a5dbf1996$var$$edcf132a9284368a$var$getOffset(parent);
        let parentStyle = window.getComputedStyle(parent);
        parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
        parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
        offset.top -= parentOffset.top;
        offset.left -= parentOffset.left;
    }
    offset.top -= parseInt(style.marginTop, 10) || 0;
    offset.left -= parseInt(style.marginLeft, 10) || 0;
    return offset;
}
// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function $146ded1a5dbf1996$var$$edcf132a9284368a$var$getContainingBlock(node) {
    // The offsetParent of an element in most cases equals the containing block.
    // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
    let offsetParent = node.offsetParent;
    // The offsetParent algorithm terminates at the document body,
    // even if the body is not a containing block. Double check that
    // and use the documentElement if so.
    if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === 'static' && !$146ded1a5dbf1996$var$$edcf132a9284368a$var$isContainingBlock(offsetParent)) offsetParent = document.documentElement;
    // TODO(later): handle table elements?
    // The offsetParent can be null if the element has position: fixed, or a few other cases.
    // We have to walk up the tree manually in this case because fixed positioned elements
    // are still positioned relative to their containing block, which is not always the viewport.
    if (offsetParent == null) {
        offsetParent = node.parentElement;
        while(offsetParent && !$146ded1a5dbf1996$var$$edcf132a9284368a$var$isContainingBlock(offsetParent))offsetParent = offsetParent.parentElement;
    }
    // Fall back to the viewport.
    return offsetParent || document.documentElement;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function $146ded1a5dbf1996$var$$edcf132a9284368a$var$isContainingBlock(node) {
    let style = window.getComputedStyle(node);
    return style.transform !== 'none' || /transform|perspective/.test(style.willChange) || style.filter !== 'none' || style.contain === 'paint' || 'backdropFilter' in style && style.backdropFilter !== 'none' || 'WebkitBackdropFilter' in style && style.WebkitBackdropFilter !== 'none';
}

});

parcelRegister("6H0Es", function(module, exports) {

$parcel$export(module.exports, "onCloseMap", function () { return $e106a4ab3eecd0e0$export$f6211563215e3b37; });
$parcel$export(module.exports, "useCloseOnScroll", function () { return $e106a4ab3eecd0e0$export$18fc8428861184da; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e106a4ab3eecd0e0$export$f6211563215e3b37 = new WeakMap();
function $e106a4ab3eecd0e0$export$18fc8428861184da(opts) {
    let { triggerRef: triggerRef, isOpen: isOpen, onClose: onClose } = opts;
    (0, $bh6RR.useEffect)(()=>{
        if (!isOpen || onClose === null) return;
        let onScroll = (e)=>{
            // Ignore if scrolling an scrollable region outside the trigger's tree.
            let target = e.target;
            // window is not a Node and doesn't have contain, but window contains everything
            if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
            // Ignore scroll events on any input or textarea as the cursor position can cause it to scroll
            // such as in a combobox. Clicking the dropdown button places focus on the input, and if the
            // text inside the input extends beyond the 'end', then it will scroll so the cursor is visible at the end.
            if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
            let onCloseHandler = onClose || $e106a4ab3eecd0e0$export$f6211563215e3b37.get(triggerRef.current);
            if (onCloseHandler) onCloseHandler();
        };
        window.addEventListener('scroll', onScroll, true);
        return ()=>{
            window.removeEventListener('scroll', onScroll, true);
        };
    }, [
        isOpen,
        onClose,
        triggerRef
    ]);
}

});

parcelRegister("7KwSx", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", function () { return $5a52e779f66c2ad9$export$683480f191c0e3ea; });

var $bh6RR = parcelRequire("bh6RR");
function $5a52e779f66c2ad9$var$$9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== 'undefined';
}
function $5a52e779f66c2ad9$export$683480f191c0e3ea(options) {
    const { ref: ref, box: box, onResize: onResize } = options;
    (0, $bh6RR.useEffect)(()=>{
        let element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$5a52e779f66c2ad9$var$$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener('resize', onResize, false);
            return ()=>{
                window.removeEventListener('resize', onResize, false);
            };
        } else {
            const resizeObserverInstance = new window.ResizeObserver((entries)=>{
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element, {
                box: box
            });
            return ()=>{
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref,
        box
    ]);
}

});


parcelRegister("igoBt", function(module, exports) {

$parcel$export(module.exports, "useOverlay", function () { return $bf42e266e7813245$export$ea8f71083e90600f; });

var $2NhrA = parcelRequire("2NhrA");

var $bh6RR = parcelRequire("bh6RR");

var $fmkmo = parcelRequire("fmkmo");
var $jYz1K = parcelRequire("jYz1K");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bf42e266e7813245$var$$a11501f3d1d39e6c$var$visibleOverlays = [];
function $bf42e266e7813245$export$ea8f71083e90600f(props, ref) {
    let { onClose: onClose, shouldCloseOnBlur: shouldCloseOnBlur, isOpen: isOpen, isDismissable: isDismissable = false, isKeyboardDismissDisabled: isKeyboardDismissDisabled = false, shouldCloseOnInteractOutside: shouldCloseOnInteractOutside } = props;
    (0, $bh6RR.useEffect)(()=>{
        if (isOpen) $bf42e266e7813245$var$$a11501f3d1d39e6c$var$visibleOverlays.push(ref);
        return ()=>{
            let index = $bf42e266e7813245$var$$a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
            if (index >= 0) $bf42e266e7813245$var$$a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
        };
    }, [
        isOpen,
        ref
    ]);
    // Only hide the overlay when it is the topmost visible overlay in the stack
    let onHide = ()=>{
        if ($bf42e266e7813245$var$$a11501f3d1d39e6c$var$visibleOverlays[$bf42e266e7813245$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose) onClose();
    };
    let onInteractOutsideStart = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($bf42e266e7813245$var$$a11501f3d1d39e6c$var$visibleOverlays[$bf42e266e7813245$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };
    let onInteractOutside = (e)=>{
        if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
            if ($bf42e266e7813245$var$$a11501f3d1d39e6c$var$visibleOverlays[$bf42e266e7813245$var$$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
                e.stopPropagation();
                e.preventDefault();
            }
            onHide();
        }
    };
    // Handle the escape key
    let onKeyDown = (e)=>{
        if (e.key === 'Escape' && !isKeyboardDismissDisabled && !e.nativeEvent.isComposing) {
            e.stopPropagation();
            e.preventDefault();
            onHide();
        }
    };
    (0, $jYz1K.useInteractOutside)({
        ref: ref,
        onInteractOutside: isDismissable && isOpen ? onInteractOutside : undefined,
        onInteractOutsideStart: onInteractOutsideStart
    });
    let { focusWithinProps: focusWithinProps } = (0, $fmkmo.useFocusWithin)({
        isDisabled: !shouldCloseOnBlur,
        onBlurWithin: (e)=>{
            // Do not close if relatedTarget is null, which means focus is lost to the body.
            // That can happen when switching tabs, or due to a VoiceOver/Chrome bug with Control+Option+Arrow navigation.
            // Clicking on the body to close the overlay should already be handled by useInteractOutside.
            // https://github.com/adobe/react-spectrum/issues/4130
            // https://github.com/adobe/react-spectrum/issues/4922
            //
            // If focus is moving into a child focus scope (e.g. menu inside a dialog),
            // do not close the outer overlay. At this point, the active scope should
            // still be the outer overlay, since blur events run before focus.
            if (!e.relatedTarget || (0, $2NhrA.isElementInChildOfActiveScope)(e.relatedTarget)) return;
            if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose === null || onClose === void 0 || onClose();
        }
    });
    let onPointerDownUnderlay = (e)=>{
        // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
        if (e.target === e.currentTarget) e.preventDefault();
    };
    return {
        overlayProps: {
            onKeyDown: onKeyDown,
            ...focusWithinProps
        },
        underlayProps: {
            onPointerDown: onPointerDownUnderlay
        }
    };
}

});
parcelRegister("jYz1K", function(module, exports) {

$parcel$export(module.exports, "useInteractOutside", function () { return $fb79f83bfe192e54$export$872b660ac5a1ff98; });

var $evWQs = parcelRequire("evWQs");
var $i7SiA = parcelRequire("i7SiA");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $fb79f83bfe192e54$export$872b660ac5a1ff98(props) {
    let { ref: ref, onInteractOutside: onInteractOutside, isDisabled: isDisabled, onInteractOutsideStart: onInteractOutsideStart } = props;
    let stateRef = (0, $bh6RR.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    let onPointerDown = (0, $i7SiA.useEffectEvent)((e)=>{
        if (onInteractOutside && $fb79f83bfe192e54$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    let triggerInteractOutside = (0, $i7SiA.useEffectEvent)((e)=>{
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, $bh6RR.useEffect)(()=>{
        let state = stateRef.current;
        if (isDisabled) return;
        const element = ref.current;
        const documentObject = (0, $evWQs.getOwnerDocument)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== 'undefined') {
            let onPointerUp = (e)=>{
                if (state.isPointerDown && $fb79f83bfe192e54$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            documentObject.addEventListener('pointerdown', onPointerDown, true);
            documentObject.addEventListener('pointerup', onPointerUp, true);
            return ()=>{
                documentObject.removeEventListener('pointerdown', onPointerDown, true);
                documentObject.removeEventListener('pointerup', onPointerUp, true);
            };
        } else {
            let onMouseUp = (e)=>{
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && $fb79f83bfe192e54$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            let onTouchEnd = (e)=>{
                state.ignoreEmulatedMouseEvents = true;
                if (state.isPointerDown && $fb79f83bfe192e54$var$$e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            documentObject.addEventListener('mousedown', onPointerDown, true);
            documentObject.addEventListener('mouseup', onMouseUp, true);
            documentObject.addEventListener('touchstart', onPointerDown, true);
            documentObject.addEventListener('touchend', onTouchEnd, true);
            return ()=>{
                documentObject.removeEventListener('mousedown', onPointerDown, true);
                documentObject.removeEventListener('mouseup', onMouseUp, true);
                documentObject.removeEventListener('touchstart', onPointerDown, true);
                documentObject.removeEventListener('touchend', onTouchEnd, true);
            };
        }
    }, [
        ref,
        isDisabled,
        onPointerDown,
        triggerInteractOutside
    ]);
}
function $fb79f83bfe192e54$var$$e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    if (event.target) {
        // if the event target is no longer in the document, ignore
        const ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (event.target.closest('[data-react-aria-top-layer]')) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}

});


parcelRegister("3bzcI", function(module, exports) {

$parcel$export(module.exports, "usePreventScroll", function () { return $8e15137fba81083a$export$ee0f7cc6afcd1c18; });

var $jQZLC = parcelRequire("jQZLC");
var $eF7Zd = parcelRequire("eF7Zd");
var $be6XU = parcelRequire("be6XU");
var $f2PTm = parcelRequire("f2PTm");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $8e15137fba81083a$var$$49c51c25361d4cd2$var$visualViewport = typeof document !== 'undefined' && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
const $8e15137fba81083a$var$$49c51c25361d4cd2$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $8e15137fba81083a$var$$49c51c25361d4cd2$var$preventScrollCount = 0;
let $8e15137fba81083a$var$$49c51c25361d4cd2$var$restore;
function $8e15137fba81083a$export$ee0f7cc6afcd1c18(options = {}) {
    let { isDisabled: isDisabled } = options;
    (0, $f2PTm.useLayoutEffect)(()=>{
        if (isDisabled) return;
        $8e15137fba81083a$var$$49c51c25361d4cd2$var$preventScrollCount++;
        if ($8e15137fba81083a$var$$49c51c25361d4cd2$var$preventScrollCount === 1) {
            if ((0, $be6XU.isIOS)()) $8e15137fba81083a$var$$49c51c25361d4cd2$var$restore = $8e15137fba81083a$var$$49c51c25361d4cd2$var$preventScrollMobileSafari();
            else $8e15137fba81083a$var$$49c51c25361d4cd2$var$restore = $8e15137fba81083a$var$$49c51c25361d4cd2$var$preventScrollStandard();
        }
        return ()=>{
            $8e15137fba81083a$var$$49c51c25361d4cd2$var$preventScrollCount--;
            if ($8e15137fba81083a$var$$49c51c25361d4cd2$var$preventScrollCount === 0) $8e15137fba81083a$var$$49c51c25361d4cd2$var$restore();
        };
    }, [
        isDisabled
    ]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $8e15137fba81083a$var$$49c51c25361d4cd2$var$preventScrollStandard() {
    return (0, $jQZLC.chain)($8e15137fba81083a$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, 'paddingRight', `${window.innerWidth - document.documentElement.clientWidth}px`), $8e15137fba81083a$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, 'overflow', 'hidden'));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Set `overscroll-behavior: contain` on nested scrollable regions so they do not scroll the page when at
//    the top or bottom. Work around a bug where this does not work when the element does not actually overflow
//    by preventing default in a `touchmove` event.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $8e15137fba81083a$var$$49c51c25361d4cd2$var$preventScrollMobileSafari() {
    let scrollable;
    let restoreScrollableStyles;
    let onTouchStart = (e)=>{
        // Store the nearest scrollable parent element from the element that the user touched.
        scrollable = (0, $eF7Zd.getScrollParent)(e.target, true);
        if (scrollable === document.documentElement && scrollable === document.body) return;
        // Prevent scrolling up when at the top and scrolling down when at the bottom
        // of a nested scrollable area, otherwise mobile Safari will start scrolling
        // the window instead.
        if (scrollable instanceof HTMLElement && window.getComputedStyle(scrollable).overscrollBehavior === 'auto') restoreScrollableStyles = $8e15137fba81083a$var$$49c51c25361d4cd2$var$setStyle(scrollable, 'overscrollBehavior', 'contain');
    };
    let onTouchMove = (e)=>{
        // Prevent scrolling the window.
        if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
            e.preventDefault();
            return;
        }
        // overscroll-behavior should prevent scroll chaining, but currently does not
        // if the element doesn't actually overflow. https://bugs.webkit.org/show_bug.cgi?id=243452
        // This checks that both the width and height do not overflow, otherwise we might
        // block horizontal scrolling too. In that case, adding `touch-action: pan-x` to
        // the element will prevent vertical page scrolling. We can't add that automatically
        // because it must be set before the touchstart event.
        if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth) e.preventDefault();
    };
    let onTouchEnd = (e)=>{
        let target = e.target;
        // Apply this change if we're not already focused on the target element
        if ($8e15137fba81083a$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) && target !== document.activeElement) {
            e.preventDefault();
            setupStyles();
            // Apply a transform to trick Safari into thinking the input is at the top of the page
            // so it doesn't try to scroll it into view. When tapping on an input, this needs to
            // be done before the "focus" event, so we have to focus the element ourselves.
            target.style.transform = 'translateY(-2000px)';
            target.focus();
            requestAnimationFrame(()=>{
                target.style.transform = '';
            });
        }
        if (restoreScrollableStyles) restoreScrollableStyles();
    };
    let onFocus = (e)=>{
        let target = e.target;
        if ($8e15137fba81083a$var$$49c51c25361d4cd2$var$willOpenKeyboard(target)) {
            setupStyles();
            // Transform also needs to be applied in the focus event in cases where focus moves
            // other than tapping on an input directly, e.g. the next/previous buttons in the
            // software keyboard. In these cases, it seems applying the transform in the focus event
            // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
            target.style.transform = 'translateY(-2000px)';
            requestAnimationFrame(()=>{
                target.style.transform = '';
                // This will have prevented the browser from scrolling the focused element into view,
                // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
                if ($8e15137fba81083a$var$$49c51c25361d4cd2$var$visualViewport) {
                    if ($8e15137fba81083a$var$$49c51c25361d4cd2$var$visualViewport.height < window.innerHeight) // to wait for the transform to be removed.
                    requestAnimationFrame(()=>{
                        $8e15137fba81083a$var$$49c51c25361d4cd2$var$scrollIntoView(target);
                    });
                    else // measure the correct position to scroll to.
                    $8e15137fba81083a$var$$49c51c25361d4cd2$var$visualViewport.addEventListener('resize', ()=>$8e15137fba81083a$var$$49c51c25361d4cd2$var$scrollIntoView(target), {
                        once: true
                    });
                }
            });
        }
    };
    let restoreStyles = null;
    let setupStyles = ()=>{
        if (restoreStyles) return;
        let onWindowScroll = ()=>{
            // Last resort. If the window scrolled, scroll it back to the top.
            // It should always be at the top because the body will have a negative margin (see below).
            window.scrollTo(0, 0);
        };
        // Record the original scroll position so we can restore it.
        // Then apply a negative margin to the body to offset it by the scroll position. This will
        // enable us to scroll the window to the top, which is required for the rest of this to work.
        let scrollX = window.pageXOffset;
        let scrollY = window.pageYOffset;
        restoreStyles = (0, $jQZLC.chain)($8e15137fba81083a$var$$49c51c25361d4cd2$var$addEvent(window, 'scroll', onWindowScroll), $8e15137fba81083a$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, 'paddingRight', `${window.innerWidth - document.documentElement.clientWidth}px`), $8e15137fba81083a$var$$49c51c25361d4cd2$var$setStyle(document.documentElement, 'overflow', 'hidden'), $8e15137fba81083a$var$$49c51c25361d4cd2$var$setStyle(document.body, 'marginTop', `-${scrollY}px`), ()=>{
            window.scrollTo(scrollX, scrollY);
        });
        // Scroll to the top. The negative margin on the body will make this appear the same.
        window.scrollTo(0, 0);
    };
    let removeEvents = (0, $jQZLC.chain)($8e15137fba81083a$var$$49c51c25361d4cd2$var$addEvent(document, 'touchstart', onTouchStart, {
        passive: false,
        capture: true
    }), $8e15137fba81083a$var$$49c51c25361d4cd2$var$addEvent(document, 'touchmove', onTouchMove, {
        passive: false,
        capture: true
    }), $8e15137fba81083a$var$$49c51c25361d4cd2$var$addEvent(document, 'touchend', onTouchEnd, {
        passive: false,
        capture: true
    }), $8e15137fba81083a$var$$49c51c25361d4cd2$var$addEvent(document, 'focus', onFocus, true));
    return ()=>{
        // Restore styles and scroll the page back to where it was.
        restoreScrollableStyles === null || restoreScrollableStyles === void 0 || restoreScrollableStyles();
        restoreStyles === null || restoreStyles === void 0 || restoreStyles();
        removeEvents();
    };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $8e15137fba81083a$var$$49c51c25361d4cd2$var$setStyle(element, style, value) {
    let cur = element.style[style];
    element.style[style] = value;
    return ()=>{
        element.style[style] = cur;
    };
}
// Adds an event listener to an element, and returns a function to remove it.
function $8e15137fba81083a$var$$49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
    // internal function, so it's ok to ignore the difficult to fix type error
    // @ts-ignore
    target.addEventListener(event, handler, options);
    return ()=>{
        // @ts-ignore
        target.removeEventListener(event, handler, options);
    };
}
function $8e15137fba81083a$var$$49c51c25361d4cd2$var$scrollIntoView(target) {
    let root = document.scrollingElement || document.documentElement;
    let nextTarget = target;
    while(nextTarget && nextTarget !== root){
        // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
        let scrollable = (0, $eF7Zd.getScrollParent)(nextTarget);
        if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== nextTarget) {
            let scrollableTop = scrollable.getBoundingClientRect().top;
            let targetTop = nextTarget.getBoundingClientRect().top;
            if (targetTop > scrollableTop + nextTarget.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
        }
        nextTarget = scrollable.parentElement;
    }
}
function $8e15137fba81083a$var$$49c51c25361d4cd2$var$willOpenKeyboard(target) {
    return target instanceof HTMLInputElement && !$8e15137fba81083a$var$$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}

});
parcelRegister("eF7Zd", function(module, exports) {

$parcel$export(module.exports, "getScrollParent", function () { return $ad7431e4c9da4ac2$export$cfa2225e87938781; });

var $2w5A8 = parcelRequire("2w5A8");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ad7431e4c9da4ac2$export$cfa2225e87938781(node, checkForOverflow) {
    let scrollableNode = node;
    if ((0, $2w5A8.isScrollable)(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
    while(scrollableNode && !(0, $2w5A8.isScrollable)(scrollableNode, checkForOverflow))scrollableNode = scrollableNode.parentElement;
    return scrollableNode || document.scrollingElement || document.documentElement;
}

});
parcelRegister("2w5A8", function(module, exports) {

$parcel$export(module.exports, "isScrollable", function () { return $46120fc0602bd194$export$2bb74740c4e19def; });
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $46120fc0602bd194$export$2bb74740c4e19def(node, checkForOverflow) {
    if (!node) return false;
    let style = window.getComputedStyle(node);
    let isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
    if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
    return isScrollable;
}

});




parcelRegister("l2K9U", function(module, exports) {

$parcel$export(module.exports, "useOverlayTriggerState", function () { return $f93f2205975c01c3$export$61c6a8c84e605fb6; });

var $bh6RR = parcelRequire("bh6RR");

var $ljfvU = parcelRequire("ljfvU");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f93f2205975c01c3$export$61c6a8c84e605fb6(props) {
    let [isOpen, setOpen] = (0, $ljfvU.useControlledState)(props.isOpen, props.defaultOpen || false, props.onOpenChange);
    const open = (0, $bh6RR.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const close = (0, $bh6RR.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const toggle = (0, $bh6RR.useCallback)(()=>{
        setOpen(!isOpen);
    }, [
        setOpen,
        isOpen
    ]);
    return {
        isOpen: isOpen,
        setOpen: setOpen,
        open: open,
        close: close,
        toggle: toggle
    };
}

});
parcelRegister("ljfvU", function(module, exports) {

$parcel$export(module.exports, "useControlledState", function () { return $94bdc7aa7135632b$export$40bfa8c7b0832715; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $94bdc7aa7135632b$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    let [stateValue, setStateValue] = (0, $bh6RR.useState)(value || defaultValue);
    let isControlledRef = (0, $bh6RR.useRef)(value !== undefined);
    let isControlled = value !== undefined;
    (0, $bh6RR.useEffect)(()=>{
        let wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? 'controlled' : 'uncontrolled'} to ${isControlled ? 'controlled' : 'uncontrolled'}.`);
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    let currentValue = isControlled ? value : stateValue;
    let setValue = (0, $bh6RR.useCallback)((value, ...args)=>{
        let onChangeCaller = (value, ...onChangeArgs)=>{
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange(value, ...onChangeArgs);
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === 'function') {
            console.warn('We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320');
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            let updateFunction = (oldValue, ...functionArgs)=>{
                let interceptedValue = value(isControlled ? currentValue : oldValue, ...functionArgs);
                onChangeCaller(interceptedValue, ...args);
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller(value, ...args);
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}

});



parcelRegister("eA2Db", function(module, exports) {

$parcel$export(module.exports, "RootMenuTriggerStateContext", function () { return $75dd08e223316876$export$795aec4671cbae19; });
$parcel$export(module.exports, "MenuTrigger", function () { return $75dd08e223316876$export$27d2ad3c5815583e; });
$parcel$export(module.exports, "Menu", function () { return $75dd08e223316876$export$d9b273488cd8ce6f; });
$parcel$export(module.exports, "MenuSection", function () { return $75dd08e223316876$export$4b1545b4f2016d26; });
$parcel$export(module.exports, "MenuItem", function () { return $75dd08e223316876$export$2ce376c2cc3355c8; });

var $juOz0 = parcelRequire("juOz0");

var $dgWhj = parcelRequire("dgWhj");

var $7jgDZ = parcelRequire("7jgDZ");

var $d9Jdi = parcelRequire("d9Jdi");

var $kRr6x = parcelRequire("kRr6x");

var $6W801 = parcelRequire("6W801");

var $5lycU = parcelRequire("5lycU");

var $5Oi9Z = parcelRequire("5Oi9Z");

var $2NhrA = parcelRequire("2NhrA");
var $hAxtE = parcelRequire("hAxtE");
var $5Gawp = parcelRequire("5Gawp");
var $dYofy = parcelRequire("dYofy");
var $gC9Fb = parcelRequire("gC9Fb");
var $fJh19 = parcelRequire("fJh19");
var $ddC4A = parcelRequire("ddC4A");

var $2YwY2 = parcelRequire("2YwY2");
var $3P7Fm = parcelRequire("3P7Fm");

var $eqvPU = parcelRequire("eqvPU");

var $bG0JH = parcelRequire("bG0JH");
var $jyDr8 = parcelRequire("jyDr8");
var $7KwSx = parcelRequire("7KwSx");

var $5XVcz = parcelRequire("5XVcz");
var $8K87f = parcelRequire("8K87f");

var $3obwd = parcelRequire("3obwd");
var $i91F7 = parcelRequire("i91F7");

var $bh6RR = parcelRequire("bh6RR");

var $5UBZb = parcelRequire("5UBZb");

var $jA5nP = parcelRequire("jA5nP");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $75dd08e223316876$export$c7e742effb1c51e2 = (0, $bh6RR.createContext)(null);
const $75dd08e223316876$export$24aad8519b95b41b = (0, $bh6RR.createContext)(null);
const $75dd08e223316876$export$795aec4671cbae19 = (0, $bh6RR.createContext)(null);
const $75dd08e223316876$var$$3674c52c6b3c5bce$var$SelectionManagerContext = (0, $bh6RR.createContext)(null);
function $75dd08e223316876$export$27d2ad3c5815583e(props) {
    let state = (0, $2YwY2.useMenuTriggerState)(props);
    let ref = (0, $bh6RR.useRef)(null);
    let { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $ddC4A.useMenuTrigger)({
        ...props,
        type: 'menu'
    }, state, ref);
    // Allows menu width to match button
    let [buttonWidth, setButtonWidth] = (0, $bh6RR.useState)(null);
    let onResize = (0, $bh6RR.useCallback)(()=>{
        if (ref.current) setButtonWidth(ref.current.offsetWidth + 'px');
    }, [
        ref
    ]);
    (0, $7KwSx.useResizeObserver)({
        ref: ref,
        onResize: onResize
    });
    let scrollRef = (0, $bh6RR.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                $75dd08e223316876$export$c7e742effb1c51e2,
                {
                    ...menuProps,
                    ref: scrollRef
                }
            ],
            [
                (0, $kRr6x.OverlayTriggerStateContext),
                state
            ],
            [
                $75dd08e223316876$export$795aec4671cbae19,
                state
            ],
            [
                (0, $6W801.PopoverContext),
                {
                    trigger: 'MenuTrigger',
                    triggerRef: ref,
                    scrollRef: scrollRef,
                    placement: 'bottom start',
                    style: {
                        '--trigger-width': buttonWidth
                    }
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3obwd.PressResponder), {
        ...menuTriggerProps,
        ref: ref,
        isPressed: state.isOpen
    }, props.children));
}
const $75dd08e223316876$var$$3674c52c6b3c5bce$var$SubmenuTriggerContext = (0, $bh6RR.createContext)(null);
const $75dd08e223316876$export$ecabc99eeffab7ca = (0, $eqvPU.createBranchComponent)('submenutrigger', (props, ref, item)=>{
    let { CollectionBranch: CollectionBranch } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let state = (0, $bh6RR.useContext)($75dd08e223316876$export$24aad8519b95b41b);
    let rootMenuTriggerState = (0, $bh6RR.useContext)($75dd08e223316876$export$795aec4671cbae19);
    let submenuTriggerState = (0, $5UBZb.useSubmenuTriggerState)({
        triggerKey: item.key
    }, rootMenuTriggerState);
    let submenuRef = (0, $bh6RR.useRef)(null);
    let itemRef = (0, $jyDr8.useObjectRef)(ref);
    let { parentMenuRef: parentMenuRef } = (0, $bh6RR.useContext)($75dd08e223316876$var$$3674c52c6b3c5bce$var$SubmenuTriggerContext);
    let { submenuTriggerProps: submenuTriggerProps, submenuProps: submenuProps, popoverProps: popoverProps } = (0, $jA5nP.useSubmenuTrigger)({
        parentMenuRef: parentMenuRef,
        submenuRef: submenuRef,
        delay: props.delay
    }, submenuTriggerState, itemRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                $75dd08e223316876$var$$3674c52c6b3c5bce$var$MenuItemContext,
                {
                    ...submenuTriggerProps,
                    onAction: undefined,
                    ref: itemRef
                }
            ],
            [
                $75dd08e223316876$export$c7e742effb1c51e2,
                submenuProps
            ],
            [
                (0, $kRr6x.OverlayTriggerStateContext),
                submenuTriggerState
            ],
            [
                (0, $6W801.PopoverContext),
                {
                    ref: submenuRef,
                    trigger: 'SubmenuTrigger',
                    triggerRef: itemRef,
                    placement: 'end top',
                    // Prevent parent popover from hiding submenu.
                    // @ts-ignore
                    'data-react-aria-top-layer': true,
                    ...popoverProps
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    }), props.children[1]);
}, (props)=>props.children[0]);
function $75dd08e223316876$var$$3674c52c6b3c5bce$var$Menu(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $75dd08e223316876$export$c7e742effb1c51e2);
    // Delay rendering the actual menu until we have the collection so that auto focus works properly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eqvPU.CollectionBuilder), {
        content: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eqvPU.Collection), props)
    }, (collection)=>collection.size > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($75dd08e223316876$var$$3674c52c6b3c5bce$var$MenuInner, {
            props: props,
            collection: collection,
            menuRef: ref
        }));
}
function $75dd08e223316876$var$$3674c52c6b3c5bce$var$MenuInner({ props: props, collection: collection, menuRef: ref }) {
    let state = (0, $3P7Fm.useTreeState)({
        ...props,
        collection: collection,
        children: undefined
    });
    let triggerState = (0, $bh6RR.useContext)($75dd08e223316876$export$795aec4671cbae19);
    let { isVirtualized: isVirtualized, CollectionRoot: CollectionRoot } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let { menuProps: menuProps } = (0, $dYofy.useMenu)({
        ...props,
        isVirtualized: isVirtualized,
        onClose: props.onClose || (triggerState === null || triggerState === void 0 ? void 0 : triggerState.close)
    }, state, ref);
    let renderProps = (0, $dgWhj.useRenderProps)({
        defaultClassName: 'react-aria-Menu',
        className: props.className,
        style: props.style,
        values: {}
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2NhrA.FocusScope), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...(0, $bG0JH.filterDOMProps)(props),
        ...menuProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        onScroll: props.onScroll
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                $75dd08e223316876$export$24aad8519b95b41b,
                state
            ],
            [
                (0, $5lycU.SeparatorContext),
                {
                    elementType: 'div'
                }
            ],
            [
                (0, $juOz0.SectionContext),
                {
                    name: 'MenuSection',
                    render: $75dd08e223316876$var$$3674c52c6b3c5bce$var$MenuSection
                }
            ],
            [
                $75dd08e223316876$var$$3674c52c6b3c5bce$var$SubmenuTriggerContext,
                {
                    parentMenuRef: ref
                }
            ],
            [
                $75dd08e223316876$var$$3674c52c6b3c5bce$var$MenuItemContext,
                null
            ],
            [
                $75dd08e223316876$var$$3674c52c6b3c5bce$var$SelectionManagerContext,
                state.selectionManager
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionRoot, {
        collection: collection,
        persistedKeys: (0, $juOz0.usePersistedKeys)(state.selectionManager.focusedKey),
        scrollRef: ref
    }))));
}
/**
 * A menu displays a list of actions or options that a user can choose.
 */ const $75dd08e223316876$export$d9b273488cd8ce6f = (0, $bh6RR.forwardRef)($75dd08e223316876$var$$3674c52c6b3c5bce$var$Menu);
// A subclass of SelectionManager that forwards focus-related properties to the parent,
// but has its own local selection state.
class $75dd08e223316876$var$$3674c52c6b3c5bce$var$GroupSelectionManager extends (0, $5XVcz.SelectionManager) {
    get focusedKey() {
        return this.parent.focusedKey;
    }
    get isFocused() {
        return this.parent.isFocused;
    }
    setFocusedKey(key, childFocusStrategy) {
        return this.parent.setFocusedKey(key, childFocusStrategy);
    }
    setFocused(isFocused) {
        this.parent.setFocused(isFocused);
    }
    get childFocusStrategy() {
        return this.parent.childFocusStrategy;
    }
    constructor(parent, state){
        super(parent.collection, state);
        this.parent = parent;
    }
}
function $75dd08e223316876$var$$3674c52c6b3c5bce$var$MenuSection(props, ref, section, className = 'react-aria-MenuSection') {
    var _section_props, _section_props1;
    let state = (0, $bh6RR.useContext)($75dd08e223316876$export$24aad8519b95b41b);
    let { CollectionBranch: CollectionBranch } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let [headingRef, heading] = (0, $dgWhj.useSlot)();
    var _section_props_arialabel;
    let { headingProps: headingProps, groupProps: groupProps } = (0, $fJh19.useMenuSection)({
        heading: heading,
        'aria-label': (_section_props_arialabel = section.props['aria-label']) !== null && _section_props_arialabel !== void 0 ? _section_props_arialabel : undefined
    });
    let renderProps = (0, $dgWhj.useRenderProps)({
        defaultClassName: className,
        className: (_section_props = section.props) === null || _section_props === void 0 ? void 0 : _section_props.className,
        style: (_section_props1 = section.props) === null || _section_props1 === void 0 ? void 0 : _section_props1.style,
        values: {}
    });
    let parent = (0, $bh6RR.useContext)($75dd08e223316876$var$$3674c52c6b3c5bce$var$SelectionManagerContext);
    let selectionState = (0, $8K87f.useMultipleSelectionState)(props);
    let manager = props.selectionMode != null ? new $75dd08e223316876$var$$3674c52c6b3c5bce$var$GroupSelectionManager(parent, selectionState) : parent;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("section", {
        ...(0, $bG0JH.filterDOMProps)(props),
        ...groupProps,
        ...renderProps,
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                (0, $7jgDZ.HeaderContext),
                {
                    ...headingProps,
                    ref: headingRef
                }
            ],
            [
                $75dd08e223316876$var$$3674c52c6b3c5bce$var$SelectionManagerContext,
                manager
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: section
    })));
}
/**
 * A MenuSection represents a section within a Menu.
 */ const $75dd08e223316876$export$4b1545b4f2016d26 = (0, $eqvPU.createBranchComponent)('section', $75dd08e223316876$var$$3674c52c6b3c5bce$var$MenuSection);
const $75dd08e223316876$var$$3674c52c6b3c5bce$var$MenuItemContext = (0, $bh6RR.createContext)(null);
const $75dd08e223316876$export$2ce376c2cc3355c8 = (0, $eqvPU.createLeafComponent)('item', function MenuItem(props, forwardedRef, item) {
    var _useSlottedContext;
    [props, forwardedRef] = (0, $dgWhj.useContextProps)(props, forwardedRef, $75dd08e223316876$var$$3674c52c6b3c5bce$var$MenuItemContext);
    let id = (_useSlottedContext = (0, $dgWhj.useSlottedContext)($75dd08e223316876$var$$3674c52c6b3c5bce$var$MenuItemContext)) === null || _useSlottedContext === void 0 ? void 0 : _useSlottedContext.id;
    let state = (0, $bh6RR.useContext)($75dd08e223316876$export$24aad8519b95b41b);
    let ref = (0, $jyDr8.useObjectRef)(forwardedRef);
    let selectionManager = (0, $bh6RR.useContext)($75dd08e223316876$var$$3674c52c6b3c5bce$var$SelectionManagerContext);
    let { menuItemProps: menuItemProps, labelProps: labelProps, descriptionProps: descriptionProps, keyboardShortcutProps: keyboardShortcutProps, ...states } = (0, $gC9Fb.useMenuItem)({
        ...props,
        id: id,
        key: item.key,
        selectionManager: selectionManager
    }, state, ref);
    let { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $5Gawp.useFocusRing)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)({
        isDisabled: states.isDisabled
    });
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-MenuItem',
        values: {
            ...states,
            isHovered: isHovered,
            isFocusVisible: isFocusVisible,
            selectionMode: selectionManager.selectionMode,
            selectionBehavior: selectionManager.selectionBehavior,
            hasSubmenu: !!props['aria-haspopup'],
            isOpen: props['aria-expanded'] === 'true'
        }
    });
    let ElementType = props.href ? 'a' : 'div';
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ElementType, {
        ...(0, $hAxtE.mergeProps)(menuItemProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-selected": states.isSelected || undefined,
        "data-selection-mode": selectionManager.selectionMode === 'none' ? undefined : selectionManager.selectionMode,
        "data-has-submenu": !!props['aria-haspopup'] || undefined,
        "data-open": props['aria-expanded'] === 'true' || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                (0, $5Oi9Z.TextContext),
                {
                    slots: {
                        label: labelProps,
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, $d9Jdi.KeyboardContext),
                keyboardShortcutProps
            ]
        ]
    }, renderProps.children));
});

});
parcelRegister("d9Jdi", function(module, exports) {

$parcel$export(module.exports, "KeyboardContext", function () { return $b240c839bb2205fa$export$744d98a3b8a94e1c; });

var $dgWhj = parcelRequire("dgWhj");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b240c839bb2205fa$export$744d98a3b8a94e1c = (0, $bh6RR.createContext)({});
function $b240c839bb2205fa$var$$63df2425e2108aa8$var$Keyboard(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $b240c839bb2205fa$export$744d98a3b8a94e1c);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("kbd", {
        dir: "ltr",
        ...props,
        ref: ref
    });
}
const $b240c839bb2205fa$export$16e4d70cc375e707 = (0, $bh6RR.forwardRef)($b240c839bb2205fa$var$$63df2425e2108aa8$var$Keyboard);

});

parcelRegister("5lycU", function(module, exports) {

$parcel$export(module.exports, "SeparatorContext", function () { return $46bcf9c9623862c9$export$6615d83f6de245ce; });
$parcel$export(module.exports, "Separator", function () { return $46bcf9c9623862c9$export$1ff3c3f08ae963c0; });

var $dgWhj = parcelRequire("dgWhj");

var $jxfsn = parcelRequire("jxfsn");

var $eqvPU = parcelRequire("eqvPU");

var $bG0JH = parcelRequire("bG0JH");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $46bcf9c9623862c9$export$6615d83f6de245ce = (0, $bh6RR.createContext)({});
const $46bcf9c9623862c9$export$1ff3c3f08ae963c0 = (0, $eqvPU.createLeafComponent)('separator', function Separator(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $46bcf9c9623862c9$export$6615d83f6de245ce);
    let { elementType: elementType, orientation: orientation, style: style, className: className } = props;
    let Element = elementType || 'hr';
    if (Element === 'hr' && orientation === 'vertical') Element = 'div';
    let { separatorProps: separatorProps } = (0, $jxfsn.useSeparator)({
        elementType: elementType,
        orientation: orientation
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Element, {
        ...(0, $bG0JH.filterDOMProps)(props),
        ...separatorProps,
        style: style,
        className: className !== null && className !== void 0 ? className : 'react-aria-Separator',
        ref: ref,
        slot: props.slot || undefined
    });
});

});
parcelRegister("jxfsn", function(module, exports) {

$parcel$export(module.exports, "useSeparator", function () { return $2a6d9e161cd1a43f$export$52210f68a14655d0; });

var $bG0JH = parcelRequire("bG0JH");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2a6d9e161cd1a43f$export$52210f68a14655d0(props) {
    let domProps = (0, $bG0JH.filterDOMProps)(props, {
        labelable: true
    });
    let ariaOrientation;
    // if orientation is horizontal, aria-orientation default is horizontal, so we leave it undefined
    // if it's vertical, we need to specify it
    if (props.orientation === 'vertical') ariaOrientation = 'vertical';
    // hr elements implicitly have role = separator and a horizontal orientation
    if (props.elementType !== 'hr') return {
        separatorProps: {
            ...domProps,
            role: 'separator',
            'aria-orientation': ariaOrientation
        }
    };
    return {
        separatorProps: domProps
    };
}

});


parcelRegister("5Oi9Z", function(module, exports) {

$parcel$export(module.exports, "TextContext", function () { return $c60ad8e98bb00d55$export$9afb8bc826b033ea; });
$parcel$export(module.exports, "Text", function () { return $c60ad8e98bb00d55$export$5f1af8db9871e1d6; });

var $dgWhj = parcelRequire("dgWhj");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c60ad8e98bb00d55$export$9afb8bc826b033ea = (0, $bh6RR.createContext)({});
function $c60ad8e98bb00d55$var$$514c0188e459b4c0$var$Text(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $c60ad8e98bb00d55$export$9afb8bc826b033ea);
    let { elementType: ElementType = 'span', ...domProps } = props;
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ElementType, {
        className: "react-aria-Text",
        ...domProps,
        ref: ref
    });
}
const $c60ad8e98bb00d55$export$5f1af8db9871e1d6 = (0, $bh6RR.forwardRef)($c60ad8e98bb00d55$var$$514c0188e459b4c0$var$Text);

});

parcelRegister("dYofy", function(module, exports) {

$parcel$export(module.exports, "menuData", function () { return $902e2fa0a7870694$export$6f49b4016bfc8d56; });
$parcel$export(module.exports, "useMenu", function () { return $902e2fa0a7870694$export$38eaa17faae8f579; });

var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");

var $fADQn = parcelRequire("fADQn");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $902e2fa0a7870694$export$6f49b4016bfc8d56 = new WeakMap();
function $902e2fa0a7870694$export$38eaa17faae8f579(props, state, ref) {
    let { shouldFocusWrap: shouldFocusWrap = true, onKeyDown: onKeyDown, onKeyUp: onKeyUp, ...otherProps } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let domProps = (0, $bG0JH.filterDOMProps)(props, {
        labelable: true
    });
    let { listProps: listProps } = (0, $fADQn.useSelectableList)({
        ...otherProps,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap,
        linkBehavior: 'override'
    });
    $902e2fa0a7870694$export$6f49b4016bfc8d56.set(state, {
        onClose: props.onClose,
        onAction: props.onAction
    });
    return {
        menuProps: (0, $hAxtE.mergeProps)(domProps, {
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        }, {
            role: 'menu',
            ...listProps,
            onKeyDown: (e)=>{
                var _listProps_onKeyDown;
                // don't clear the menu selected keys if the user is presses escape since escape closes the menu
                if (e.key !== 'Escape') (_listProps_onKeyDown = listProps.onKeyDown) === null || _listProps_onKeyDown === void 0 || _listProps_onKeyDown.call(listProps, e);
            }
        })
    };
}

});
parcelRegister("fADQn", function(module, exports) {

$parcel$export(module.exports, "useSelectableList", function () { return $029c9345c1d11376$export$b95089534ab7c1fd; });

var $bLdgI = parcelRequire("bLdgI");

var $36LQn = parcelRequire("36LQn");

var $7caxR = parcelRequire("7caxR");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $029c9345c1d11376$export$b95089534ab7c1fd(props) {
    let { selectionManager: selectionManager, collection: collection, disabledKeys: disabledKeys, ref: ref, keyboardDelegate: keyboardDelegate, layoutDelegate: layoutDelegate } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $7caxR.useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let disabledBehavior = selectionManager.disabledBehavior;
    let delegate = (0, $bh6RR.useMemo)(()=>keyboardDelegate || new (0, $36LQn.ListKeyboardDelegate)({
            collection: collection,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            collator: collator,
            layoutDelegate: layoutDelegate
        }), [
        keyboardDelegate,
        layoutDelegate,
        collection,
        disabledKeys,
        ref,
        collator,
        disabledBehavior
    ]);
    let { collectionProps: collectionProps } = (0, $bLdgI.useSelectableCollection)({
        ...props,
        ref: ref,
        selectionManager: selectionManager,
        keyboardDelegate: delegate
    });
    return {
        listProps: collectionProps
    };
}

});
parcelRegister("bLdgI", function(module, exports) {

$parcel$export(module.exports, "useSelectableCollection", function () { return $35db9d9cb16f7e1a$export$d6daf82dcd84e87c; });

var $6PcGA = parcelRequire("6PcGA");

var $144PK = parcelRequire("144PK");

var $6afFj = parcelRequire("6afFj");

var $bh6RR = parcelRequire("bh6RR");

var $bQDsd = parcelRequire("bQDsd");
var $2NhrA = parcelRequire("2NhrA");

var $50qTn = parcelRequire("50qTn");
var $hAxtE = parcelRequire("hAxtE");
var $2FItP = parcelRequire("2FItP");
var $ekRZn = parcelRequire("ekRZn");
var $gN5ZC = parcelRequire("gN5ZC");

var $8tXMg = parcelRequire("8tXMg");

var $c8uzR = parcelRequire("c8uzR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $35db9d9cb16f7e1a$export$d6daf82dcd84e87c(options) {
    let { selectionManager: manager, keyboardDelegate: delegate, ref: ref, autoFocus: autoFocus = false, shouldFocusWrap: shouldFocusWrap = false, disallowEmptySelection: disallowEmptySelection = false, disallowSelectAll: disallowSelectAll = false, selectOnFocus: selectOnFocus = manager.selectionBehavior === 'replace', disallowTypeAhead: disallowTypeAhead = false, shouldUseVirtualFocus: shouldUseVirtualFocus, allowsTabNavigation: allowsTabNavigation = false, isVirtualized: isVirtualized, scrollRef: scrollRef = ref, linkBehavior: linkBehavior = 'action' } = options;
    let { direction: direction } = (0, $c8uzR.useLocale)();
    let router = (0, $gN5ZC.useRouter)();
    let onKeyDown = (e)=>{
        var _ref_current;
        // Prevent option + tab from doing anything since it doesn't move focus to the cells, only buttons/checkboxes
        if (e.altKey && e.key === 'Tab') e.preventDefault();
        // Keyboard events bubble through portals. Don't handle keyboard events
        // for elements outside the collection (e.g. menus).
        if (!((_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.contains(e.target))) return;
        const navigateToKey = (key, childFocus)=>{
            if (key != null) {
                if (manager.isLink(key) && linkBehavior === 'selection' && selectOnFocus && !(0, $6PcGA.isNonContiguousSelectionModifier)(e)) {
                    var _scrollRef_current;
                    (0, $6afFj.flushSync)(()=>{
                        manager.setFocusedKey(key, childFocus);
                    });
                    let item = (_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.querySelector(`[data-key="${CSS.escape(key.toString())}"]`);
                    let itemProps = manager.getItemProps(key);
                    if (item) router.open(item, e, itemProps.href, itemProps.routerOptions);
                    return;
                }
                manager.setFocusedKey(key, childFocus);
                if (manager.isLink(key) && linkBehavior === 'override') return;
                if (e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(key);
                else if (selectOnFocus && !(0, $6PcGA.isNonContiguousSelectionModifier)(e)) manager.replaceSelection(key);
            }
        };
        switch(e.key){
            case 'ArrowDown':
                if (delegate.getKeyBelow) {
                    var _delegate_getKeyBelow, _delegate_getFirstKey, _delegate_getFirstKey1;
                    let nextKey = manager.focusedKey != null ? (_delegate_getKeyBelow = delegate.getKeyBelow) === null || _delegate_getKeyBelow === void 0 ? void 0 : _delegate_getKeyBelow.call(delegate, manager.focusedKey) : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getFirstKey1 = delegate.getFirstKey) === null || _delegate_getFirstKey1 === void 0 ? void 0 : _delegate_getFirstKey1.call(delegate, manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'ArrowUp':
                if (delegate.getKeyAbove) {
                    var _delegate_getKeyAbove, _delegate_getLastKey, _delegate_getLastKey1;
                    let nextKey = manager.focusedKey != null ? (_delegate_getKeyAbove = delegate.getKeyAbove) === null || _delegate_getKeyAbove === void 0 ? void 0 : _delegate_getKeyAbove.call(delegate, manager.focusedKey) : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate);
                    if (nextKey == null && shouldFocusWrap) nextKey = (_delegate_getLastKey1 = delegate.getLastKey) === null || _delegate_getLastKey1 === void 0 ? void 0 : _delegate_getLastKey1.call(delegate, manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'ArrowLeft':
                if (delegate.getKeyLeftOf) {
                    var _delegate_getKeyLeftOf, _delegate_getFirstKey2, _delegate_getLastKey2;
                    let nextKey = manager.focusedKey != null ? (_delegate_getKeyLeftOf = delegate.getKeyLeftOf) === null || _delegate_getKeyLeftOf === void 0 ? void 0 : _delegate_getKeyLeftOf.call(delegate, manager.focusedKey) : null;
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === 'rtl' ? (_delegate_getFirstKey2 = delegate.getFirstKey) === null || _delegate_getFirstKey2 === void 0 ? void 0 : _delegate_getFirstKey2.call(delegate, manager.focusedKey) : (_delegate_getLastKey2 = delegate.getLastKey) === null || _delegate_getLastKey2 === void 0 ? void 0 : _delegate_getLastKey2.call(delegate, manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey, direction === 'rtl' ? 'first' : 'last');
                    }
                }
                break;
            case 'ArrowRight':
                if (delegate.getKeyRightOf) {
                    var _delegate_getKeyRightOf, _delegate_getLastKey3, _delegate_getFirstKey3;
                    let nextKey = manager.focusedKey != null ? (_delegate_getKeyRightOf = delegate.getKeyRightOf) === null || _delegate_getKeyRightOf === void 0 ? void 0 : _delegate_getKeyRightOf.call(delegate, manager.focusedKey) : null;
                    if (nextKey == null && shouldFocusWrap) nextKey = direction === 'rtl' ? (_delegate_getLastKey3 = delegate.getLastKey) === null || _delegate_getLastKey3 === void 0 ? void 0 : _delegate_getLastKey3.call(delegate, manager.focusedKey) : (_delegate_getFirstKey3 = delegate.getFirstKey) === null || _delegate_getFirstKey3 === void 0 ? void 0 : _delegate_getFirstKey3.call(delegate, manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey, direction === 'rtl' ? 'last' : 'first');
                    }
                }
                break;
            case 'Home':
                if (delegate.getFirstKey) {
                    e.preventDefault();
                    let firstKey = delegate.getFirstKey(manager.focusedKey, (0, $6PcGA.isCtrlKeyPressed)(e));
                    manager.setFocusedKey(firstKey);
                    if (firstKey != null) {
                        if ((0, $6PcGA.isCtrlKeyPressed)(e) && e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(firstKey);
                        else if (selectOnFocus) manager.replaceSelection(firstKey);
                    }
                }
                break;
            case 'End':
                if (delegate.getLastKey) {
                    e.preventDefault();
                    let lastKey = delegate.getLastKey(manager.focusedKey, (0, $6PcGA.isCtrlKeyPressed)(e));
                    manager.setFocusedKey(lastKey);
                    if (lastKey != null) {
                        if ((0, $6PcGA.isCtrlKeyPressed)(e) && e.shiftKey && manager.selectionMode === 'multiple') manager.extendSelection(lastKey);
                        else if (selectOnFocus) manager.replaceSelection(lastKey);
                    }
                }
                break;
            case 'PageDown':
                if (delegate.getKeyPageBelow && manager.focusedKey != null) {
                    let nextKey = delegate.getKeyPageBelow(manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'PageUp':
                if (delegate.getKeyPageAbove && manager.focusedKey != null) {
                    let nextKey = delegate.getKeyPageAbove(manager.focusedKey);
                    if (nextKey != null) {
                        e.preventDefault();
                        navigateToKey(nextKey);
                    }
                }
                break;
            case 'a':
                if ((0, $6PcGA.isCtrlKeyPressed)(e) && manager.selectionMode === 'multiple' && disallowSelectAll !== true) {
                    e.preventDefault();
                    manager.selectAll();
                }
                break;
            case 'Escape':
                if (!disallowEmptySelection && manager.selectedKeys.size !== 0) {
                    e.stopPropagation();
                    e.preventDefault();
                    manager.clearSelection();
                }
                break;
            case 'Tab':
                if (!allowsTabNavigation) {
                    // There may be elements that are "tabbable" inside a collection (e.g. in a grid cell).
                    // However, collections should be treated as a single tab stop, with arrow key navigation internally.
                    // We don't control the rendering of these, so we can't override the tabIndex to prevent tabbing.
                    // Instead, we handle the Tab key, and move focus manually to the first/last tabbable element
                    // in the collection, so that the browser default behavior will apply starting from that element
                    // rather than the currently focused one.
                    if (e.shiftKey) ref.current.focus();
                    else {
                        let walker = (0, $2NhrA.getFocusableTreeWalker)(ref.current, {
                            tabbable: true
                        });
                        let next = undefined;
                        let last;
                        do {
                            last = walker.lastChild();
                            if (last) next = last;
                        }while (last);
                        if (next && !next.contains(document.activeElement)) (0, $50qTn.focusWithoutScrolling)(next);
                    }
                    break;
                }
        }
    };
    // Store the scroll position so we can restore it later.
    /// TODO: should this happen all the time??
    let scrollPos = (0, $bh6RR.useRef)({
        top: 0,
        left: 0
    });
    (0, $ekRZn.useEvent)(scrollRef, 'scroll', isVirtualized ? undefined : ()=>{
        var _scrollRef_current, _scrollRef_current1;
        var _scrollRef_current_scrollTop, _scrollRef_current_scrollLeft;
        scrollPos.current = {
            top: (_scrollRef_current_scrollTop = (_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.scrollTop) !== null && _scrollRef_current_scrollTop !== void 0 ? _scrollRef_current_scrollTop : 0,
            left: (_scrollRef_current_scrollLeft = (_scrollRef_current1 = scrollRef.current) === null || _scrollRef_current1 === void 0 ? void 0 : _scrollRef_current1.scrollLeft) !== null && _scrollRef_current_scrollLeft !== void 0 ? _scrollRef_current_scrollLeft : 0
        };
    });
    let onFocus = (e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
        if (manager.focusedKey == null) {
            var _delegate_getLastKey, _delegate_getFirstKey;
            let navigateToFirstKey = (key)=>{
                if (key != null) {
                    manager.setFocusedKey(key);
                    if (selectOnFocus) manager.replaceSelection(key);
                }
            };
            // If the user hasn't yet interacted with the collection, there will be no focusedKey set.
            // Attempt to detect whether the user is tabbing forward or backward into the collection
            // and either focus the first or last item accordingly.
            let relatedTarget = e.relatedTarget;
            var _manager_lastSelectedKey, _manager_firstSelectedKey;
            if (relatedTarget && e.currentTarget.compareDocumentPosition(relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) navigateToFirstKey((_manager_lastSelectedKey = manager.lastSelectedKey) !== null && _manager_lastSelectedKey !== void 0 ? _manager_lastSelectedKey : (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate));
            else navigateToFirstKey((_manager_firstSelectedKey = manager.firstSelectedKey) !== null && _manager_firstSelectedKey !== void 0 ? _manager_firstSelectedKey : (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate));
        } else if (!isVirtualized && scrollRef.current) {
            // Restore the scroll position to what it was before.
            scrollRef.current.scrollTop = scrollPos.current.top;
            scrollRef.current.scrollLeft = scrollPos.current.left;
        }
        if (manager.focusedKey != null && scrollRef.current) {
            // Refocus and scroll the focused item into view if it exists within the scrollable region.
            let element = scrollRef.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (element) {
                // This prevents a flash of focus on the first/last element in the collection, or the collection itself.
                if (!element.contains(document.activeElement)) (0, $50qTn.focusWithoutScrolling)(element);
                let modality = (0, $8tXMg.getInteractionModality)();
                if (modality === 'keyboard') (0, $2FItP.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
    };
    let onBlur = (e)=>{
        // Don't set blurred and then focused again if moving focus within the collection.
        if (!e.currentTarget.contains(e.relatedTarget)) manager.setFocused(false);
    };
    const autoFocusRef = (0, $bh6RR.useRef)(autoFocus);
    (0, $bh6RR.useEffect)(()=>{
        if (autoFocusRef.current) {
            var _delegate_getFirstKey, _delegate_getLastKey;
            let focusedKey = null;
            var _delegate_getFirstKey1;
            // Check focus strategy to determine which item to focus
            if (autoFocus === 'first') focusedKey = (_delegate_getFirstKey1 = (_delegate_getFirstKey = delegate.getFirstKey) === null || _delegate_getFirstKey === void 0 ? void 0 : _delegate_getFirstKey.call(delegate)) !== null && _delegate_getFirstKey1 !== void 0 ? _delegate_getFirstKey1 : null;
            var _delegate_getLastKey1;
            if (autoFocus === 'last') focusedKey = (_delegate_getLastKey1 = (_delegate_getLastKey = delegate.getLastKey) === null || _delegate_getLastKey === void 0 ? void 0 : _delegate_getLastKey.call(delegate)) !== null && _delegate_getLastKey1 !== void 0 ? _delegate_getLastKey1 : null;
            // If there are any selected keys, make the first one the new focus target
            let selectedKeys = manager.selectedKeys;
            if (selectedKeys.size) {
                for (let key of selectedKeys)if (manager.canSelectItem(key)) {
                    focusedKey = key;
                    break;
                }
            }
            manager.setFocused(true);
            manager.setFocusedKey(focusedKey);
            // If no default focus key is selected, focus the collection itself.
            if (focusedKey == null && !shouldUseVirtualFocus && ref.current) (0, $bQDsd.focusSafely)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Scroll the focused element into view when the focusedKey changes.
    let lastFocusedKey = (0, $bh6RR.useRef)(manager.focusedKey);
    (0, $bh6RR.useEffect)(()=>{
        if (manager.isFocused && manager.focusedKey != null && (manager.focusedKey !== lastFocusedKey.current || autoFocusRef.current) && scrollRef.current && ref.current) {
            let modality = (0, $8tXMg.getInteractionModality)();
            let element = ref.current.querySelector(`[data-key="${CSS.escape(manager.focusedKey.toString())}"]`);
            if (!element) // The collection may initially be empty (e.g. virtualizer), so wait until the element exists.
            return;
            if (modality === 'keyboard' || autoFocusRef.current) {
                (0, $2FItP.scrollIntoView)(scrollRef.current, element);
                // Avoid scroll in iOS VO, since it may cause overlay to close (i.e. RAC submenu)
                if (modality !== 'virtual') (0, $2FItP.scrollIntoViewport)(element, {
                    containingElement: ref.current
                });
            }
        }
        // If the focused key becomes null (e.g. the last item is deleted), focus the whole collection.
        if (!shouldUseVirtualFocus && manager.isFocused && manager.focusedKey == null && lastFocusedKey.current != null && ref.current) (0, $bQDsd.focusSafely)(ref.current);
        lastFocusedKey.current = manager.focusedKey;
        autoFocusRef.current = false;
    });
    (0, $ekRZn.useEvent)(ref, 'react-aria-focus-scope-restore', (e)=>{
        e.preventDefault();
        manager.setFocused(true);
    });
    let handlers = {
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown (e) {
            // Ignore events that bubbled through portals.
            if (scrollRef.current === e.target) e.preventDefault();
        }
    };
    let { typeSelectProps: typeSelectProps } = (0, $144PK.useTypeSelect)({
        keyboardDelegate: delegate,
        selectionManager: manager
    });
    if (!disallowTypeAhead) handlers = (0, $hAxtE.mergeProps)(typeSelectProps, handlers);
    // If nothing is focused within the collection, make the collection itself tabbable.
    // This will be marshalled to either the first or last item depending on where focus came from.
    // If using virtual focus, don't set a tabIndex at all so that VoiceOver on iOS 14 doesn't try
    // to move real DOM focus to the element anyway.
    let tabIndex = undefined;
    if (!shouldUseVirtualFocus) tabIndex = manager.focusedKey == null ? 0 : -1;
    return {
        collectionProps: {
            ...handlers,
            tabIndex: tabIndex
        }
    };
}

});
parcelRegister("6PcGA", function(module, exports) {

$parcel$export(module.exports, "isNonContiguousSelectionModifier", function () { return $a8790758423c8d7b$export$d3e3bd3e26688c04; });
$parcel$export(module.exports, "isCtrlKeyPressed", function () { return $a8790758423c8d7b$export$16792effe837dba3; });

var $be6XU = parcelRequire("be6XU");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a8790758423c8d7b$export$d3e3bd3e26688c04(e) {
    // Ctrl + Arrow Up/Arrow Down has a system wide meaning on macOS, so use Alt instead.
    // On Windows and Ubuntu, Alt + Space has a system wide meaning.
    return (0, $be6XU.isAppleDevice)() ? e.altKey : e.ctrlKey;
}
function $a8790758423c8d7b$export$16792effe837dba3(e) {
    if ((0, $be6XU.isMac)()) return e.metaKey;
    return e.ctrlKey;
}

});

parcelRegister("144PK", function(module, exports) {

$parcel$export(module.exports, "useTypeSelect", function () { return $c6f7e60df949e6f1$export$e32c88dfddc6e1d8; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Controls how long to wait before clearing the typeahead buffer.
 */ const $c6f7e60df949e6f1$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1000; // 1 second
function $c6f7e60df949e6f1$export$e32c88dfddc6e1d8(options) {
    let { keyboardDelegate: keyboardDelegate, selectionManager: selectionManager, onTypeSelect: onTypeSelect } = options;
    let state = (0, $bh6RR.useRef)({
        search: '',
        timeout: undefined
    }).current;
    let onKeyDown = (e)=>{
        let character = $c6f7e60df949e6f1$var$$fb3050f43d946246$var$getStringForKey(e.key);
        if (!character || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) return;
        // Do not propagate the Spacebar event if it's meant to be part of the search.
        // When we time out, the search term becomes empty, hence the check on length.
        // Trimming is to account for the case of pressing the Spacebar more than once,
        // which should cycle through the selection/deselection of the focused item.
        if (character === ' ' && state.search.trim().length > 0) {
            e.preventDefault();
            if (!('continuePropagation' in e)) e.stopPropagation();
        }
        state.search += character;
        if (keyboardDelegate.getKeyForSearch != null) {
            // Use the delegate to find a key to focus.
            // Prioritize items after the currently focused item, falling back to searching the whole list.
            let key = keyboardDelegate.getKeyForSearch(state.search, selectionManager.focusedKey);
            // If no key found, search from the top.
            if (key == null) key = keyboardDelegate.getKeyForSearch(state.search);
            if (key != null) {
                selectionManager.setFocusedKey(key);
                if (onTypeSelect) onTypeSelect(key);
            }
        }
        clearTimeout(state.timeout);
        state.timeout = setTimeout(()=>{
            state.search = '';
        }, $c6f7e60df949e6f1$var$$fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    };
    return {
        typeSelectProps: {
            // Using a capturing listener to catch the keydown event before
            // other hooks in order to handle the Spacebar event.
            onKeyDownCapture: keyboardDelegate.getKeyForSearch ? onKeyDown : undefined
        }
    };
}
function $c6f7e60df949e6f1$var$$fb3050f43d946246$var$getStringForKey(key) {
    // If the key is of length 1, it is an ASCII value.
    // Otherwise, if there are no ASCII characters in the key name,
    // it is a Unicode character.
    // See https://www.w3.org/TR/uievents-key/
    if (key.length === 1 || !/^[A-Z]/i.test(key)) return key;
    return '';
}

});

parcelRegister("2FItP", function(module, exports) {

$parcel$export(module.exports, "scrollIntoView", function () { return $258d4be938b65370$export$53a0910f038337bd; });
$parcel$export(module.exports, "scrollIntoViewport", function () { return $258d4be938b65370$export$c826860796309d1b; });

var $jcpvy = parcelRequire("jcpvy");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $258d4be938b65370$export$53a0910f038337bd(scrollView, element) {
    let offsetX = $258d4be938b65370$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, 'left');
    let offsetY = $258d4be938b65370$var$$2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, 'top');
    let width = element.offsetWidth;
    let height = element.offsetHeight;
    let x = scrollView.scrollLeft;
    let y = scrollView.scrollTop;
    // Account for top/left border offsetting the scroll top/Left
    let { borderTopWidth: borderTopWidth, borderLeftWidth: borderLeftWidth } = getComputedStyle(scrollView);
    let borderAdjustedX = scrollView.scrollLeft + parseInt(borderLeftWidth, 10);
    let borderAdjustedY = scrollView.scrollTop + parseInt(borderTopWidth, 10);
    // Ignore end/bottom border via clientHeight/Width instead of offsetHeight/Width
    let maxX = borderAdjustedX + scrollView.clientWidth;
    let maxY = borderAdjustedY + scrollView.clientHeight;
    if (offsetX <= x) x = offsetX - parseInt(borderLeftWidth, 10);
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= borderAdjustedY) y = offsetY - parseInt(borderTopWidth, 10);
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $258d4be938b65370$var$$2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    const prop = axis === 'left' ? 'offsetLeft' : 'offsetTop';
    let sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}
function $258d4be938b65370$export$c826860796309d1b(targetElement, opts) {
    if (targetElement && document.contains(targetElement)) {
        let root = document.scrollingElement || document.documentElement;
        let isScrollPrevented = window.getComputedStyle(root).overflow === 'hidden';
        // If scrolling is not currently prevented then we aren’t in a overlay nor is a overlay open, just use element.scrollIntoView to bring the element into view
        if (!isScrollPrevented) {
            var // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            _targetElement_scrollIntoView;
            let { left: originalLeft, top: originalTop } = targetElement.getBoundingClientRect();
            targetElement === null || targetElement === void 0 || (_targetElement_scrollIntoView = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView === void 0 || _targetElement_scrollIntoView.call(targetElement, {
                block: 'nearest'
            });
            let { left: newLeft, top: newTop } = targetElement.getBoundingClientRect();
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                var _opts_containingElement_scrollIntoView, _opts_containingElement, _targetElement_scrollIntoView1;
                opts === null || opts === void 0 || (_opts_containingElement = opts.containingElement) === null || _opts_containingElement === void 0 || (_opts_containingElement_scrollIntoView = _opts_containingElement.scrollIntoView) === null || _opts_containingElement_scrollIntoView === void 0 || _opts_containingElement_scrollIntoView.call(_opts_containingElement, {
                    block: 'center',
                    inline: 'center'
                });
                (_targetElement_scrollIntoView1 = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView1 === void 0 || _targetElement_scrollIntoView1.call(targetElement, {
                    block: 'nearest'
                });
            }
        } else {
            let scrollParents = (0, $jcpvy.getScrollParents)(targetElement);
            // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
            for (let scrollParent of scrollParents)$258d4be938b65370$export$53a0910f038337bd(scrollParent, targetElement);
        }
    }
}

});
parcelRegister("jcpvy", function(module, exports) {

$parcel$export(module.exports, "getScrollParents", function () { return $1e04e5d715134a04$export$94ed1c92c7beeb22; });

var $2w5A8 = parcelRequire("2w5A8");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1e04e5d715134a04$export$94ed1c92c7beeb22(node, checkForOverflow) {
    const scrollParents = [];
    while(node && node !== document.documentElement){
        if ((0, $2w5A8.isScrollable)(node, checkForOverflow)) scrollParents.push(node);
        node = node.parentElement;
    }
    return scrollParents;
}

});


parcelRegister("ekRZn", function(module, exports) {

$parcel$export(module.exports, "useEvent", function () { return $20b1d95225fe2f29$export$90fc3a17d93f704c; });

var $i7SiA = parcelRequire("i7SiA");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $20b1d95225fe2f29$export$90fc3a17d93f704c(ref, event, handler, options) {
    let handleEvent = (0, $i7SiA.useEffectEvent)(handler);
    let isDisabled = handler == null;
    (0, $bh6RR.useEffect)(()=>{
        if (isDisabled || !ref.current) return;
        let element = ref.current;
        element.addEventListener(event, handleEvent, options);
        return ()=>{
            element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled,
        handleEvent
    ]);
}

});


parcelRegister("36LQn", function(module, exports) {

$parcel$export(module.exports, "ListKeyboardDelegate", function () { return $a2c87b6f3c10a234$export$a05409b8bb224a5a; });

var $alJC6 = parcelRequire("alJC6");

var $2w5A8 = parcelRequire("2w5A8");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $a2c87b6f3c10a234$export$a05409b8bb224a5a {
    isDisabled(item) {
        var _item_props;
        return this.disabledBehavior === 'all' && (((_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || this.disabledKeys.has(item.key));
    }
    findNextNonDisabled(key, getNext) {
        let nextKey = key;
        while(nextKey != null){
            let item = this.collection.getItem(nextKey);
            if ((item === null || item === void 0 ? void 0 : item.type) === 'item' && !this.isDisabled(item)) return nextKey;
            nextKey = getNext(nextKey);
        }
        return null;
    }
    getNextKey(key) {
        let nextKey = key;
        nextKey = this.collection.getKeyAfter(nextKey);
        return this.findNextNonDisabled(nextKey, (key)=>this.collection.getKeyAfter(key));
    }
    getPreviousKey(key) {
        let nextKey = key;
        nextKey = this.collection.getKeyBefore(nextKey);
        return this.findNextNonDisabled(nextKey, (key)=>this.collection.getKeyBefore(key));
    }
    findKey(key, nextKey, shouldSkip) {
        let tempKey = key;
        let itemRect = this.layoutDelegate.getItemRect(tempKey);
        if (!itemRect || tempKey == null) return null;
        // Find the item above or below in the same column.
        let prevRect = itemRect;
        do {
            tempKey = nextKey(tempKey);
            if (tempKey == null) break;
            itemRect = this.layoutDelegate.getItemRect(tempKey);
        }while (itemRect && shouldSkip(prevRect, itemRect) && tempKey != null);
        return tempKey;
    }
    isSameRow(prevRect, itemRect) {
        return prevRect.y === itemRect.y || prevRect.x !== itemRect.x;
    }
    isSameColumn(prevRect, itemRect) {
        return prevRect.x === itemRect.x || prevRect.y !== itemRect.y;
    }
    getKeyBelow(key) {
        if (this.layout === 'grid' && this.orientation === 'vertical') return this.findKey(key, (key)=>this.getNextKey(key), this.isSameRow);
        else return this.getNextKey(key);
    }
    getKeyAbove(key) {
        if (this.layout === 'grid' && this.orientation === 'vertical') return this.findKey(key, (key)=>this.getPreviousKey(key), this.isSameRow);
        else return this.getPreviousKey(key);
    }
    getNextColumn(key, right) {
        return right ? this.getPreviousKey(key) : this.getNextKey(key);
    }
    getKeyRightOf(key) {
        // This is a temporary solution for CardView until we refactor useSelectableCollection.
        // https://github.com/orgs/adobe/projects/19/views/32?pane=issue&itemId=77825042
        let layoutDelegateMethod = this.direction === 'ltr' ? 'getKeyRightOf' : 'getKeyLeftOf';
        if (this.layoutDelegate[layoutDelegateMethod]) {
            key = this.layoutDelegate[layoutDelegateMethod](key);
            return this.findNextNonDisabled(key, (key)=>this.layoutDelegate[layoutDelegateMethod](key));
        }
        if (this.layout === 'grid') {
            if (this.orientation === 'vertical') return this.getNextColumn(key, this.direction === 'rtl');
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === 'rtl'), this.isSameColumn);
        } else if (this.orientation === 'horizontal') return this.getNextColumn(key, this.direction === 'rtl');
        return null;
    }
    getKeyLeftOf(key) {
        let layoutDelegateMethod = this.direction === 'ltr' ? 'getKeyLeftOf' : 'getKeyRightOf';
        if (this.layoutDelegate[layoutDelegateMethod]) {
            key = this.layoutDelegate[layoutDelegateMethod](key);
            return this.findNextNonDisabled(key, (key)=>this.layoutDelegate[layoutDelegateMethod](key));
        }
        if (this.layout === 'grid') {
            if (this.orientation === 'vertical') return this.getNextColumn(key, this.direction === 'ltr');
            else return this.findKey(key, (key)=>this.getNextColumn(key, this.direction === 'ltr'), this.isSameColumn);
        } else if (this.orientation === 'horizontal') return this.getNextColumn(key, this.direction === 'ltr');
        return null;
    }
    getFirstKey() {
        let key = this.collection.getFirstKey();
        return this.findNextNonDisabled(key, (key)=>this.collection.getKeyAfter(key));
    }
    getLastKey() {
        let key = this.collection.getLastKey();
        return this.findNextNonDisabled(key, (key)=>this.collection.getKeyBefore(key));
    }
    getKeyPageAbove(key) {
        let menu = this.ref.current;
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        if (menu && !(0, $2w5A8.isScrollable)(menu)) return this.getFirstKey();
        let nextKey = key;
        if (this.orientation === 'horizontal') {
            let pageX = Math.max(0, itemRect.x + itemRect.width - this.layoutDelegate.getVisibleRect().width);
            while(itemRect && itemRect.x > pageX && nextKey != null){
                nextKey = this.getKeyAbove(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        } else {
            let pageY = Math.max(0, itemRect.y + itemRect.height - this.layoutDelegate.getVisibleRect().height);
            while(itemRect && itemRect.y > pageY && nextKey != null){
                nextKey = this.getKeyAbove(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        }
        return nextKey !== null && nextKey !== void 0 ? nextKey : this.getFirstKey();
    }
    getKeyPageBelow(key) {
        let menu = this.ref.current;
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        if (menu && !(0, $2w5A8.isScrollable)(menu)) return this.getLastKey();
        let nextKey = key;
        if (this.orientation === 'horizontal') {
            let pageX = Math.min(this.layoutDelegate.getContentSize().width, itemRect.y - itemRect.width + this.layoutDelegate.getVisibleRect().width);
            while(itemRect && itemRect.x < pageX && nextKey != null){
                nextKey = this.getKeyBelow(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        } else {
            let pageY = Math.min(this.layoutDelegate.getContentSize().height, itemRect.y - itemRect.height + this.layoutDelegate.getVisibleRect().height);
            while(itemRect && itemRect.y < pageY && nextKey != null){
                nextKey = this.getKeyBelow(nextKey);
                itemRect = nextKey == null ? null : this.layoutDelegate.getItemRect(nextKey);
            }
        }
        return nextKey !== null && nextKey !== void 0 ? nextKey : this.getLastKey();
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey || this.getFirstKey();
        while(key != null){
            let item = collection.getItem(key);
            if (!item) return null;
            let substring = item.textValue.slice(0, search.length);
            if (item.textValue && this.collator.compare(substring, search) === 0) return key;
            key = this.getNextKey(key);
        }
        return null;
    }
    constructor(...args){
        if (args.length === 1) {
            let opts = args[0];
            this.collection = opts.collection;
            this.ref = opts.ref;
            this.collator = opts.collator;
            this.disabledKeys = opts.disabledKeys || new Set();
            this.disabledBehavior = opts.disabledBehavior || 'all';
            this.orientation = opts.orientation || 'vertical';
            this.direction = opts.direction;
            this.layout = opts.layout || 'stack';
            this.layoutDelegate = opts.layoutDelegate || new (0, $alJC6.DOMLayoutDelegate)(opts.ref);
        } else {
            this.collection = args[0];
            this.disabledKeys = args[1];
            this.ref = args[2];
            this.collator = args[3];
            this.layout = 'stack';
            this.orientation = 'vertical';
            this.disabledBehavior = 'all';
            this.layoutDelegate = new (0, $alJC6.DOMLayoutDelegate)(this.ref);
        }
        // If this is a vertical stack, remove the left/right methods completely
        // so they aren't called by useDroppableCollection.
        if (this.layout === 'stack' && this.orientation === 'vertical') {
            this.getKeyLeftOf = undefined;
            this.getKeyRightOf = undefined;
        }
    }
}

});
parcelRegister("alJC6", function(module, exports) {

$parcel$export(module.exports, "DOMLayoutDelegate", function () { return $dbcd5883044affc5$export$8f5ed9ff9f511381; });
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $dbcd5883044affc5$export$8f5ed9ff9f511381 {
    getItemRect(key) {
        let container = this.ref.current;
        if (!container) return null;
        let item = key != null ? container.querySelector(`[data-key="${CSS.escape(key.toString())}"]`) : null;
        if (!item) return null;
        let containerRect = container.getBoundingClientRect();
        let itemRect = item.getBoundingClientRect();
        return {
            x: itemRect.left - containerRect.left + container.scrollLeft,
            y: itemRect.top - containerRect.top + container.scrollTop,
            width: itemRect.width,
            height: itemRect.height
        };
    }
    getContentSize() {
        let container = this.ref.current;
        var _container_scrollWidth, _container_scrollHeight;
        return {
            width: (_container_scrollWidth = container === null || container === void 0 ? void 0 : container.scrollWidth) !== null && _container_scrollWidth !== void 0 ? _container_scrollWidth : 0,
            height: (_container_scrollHeight = container === null || container === void 0 ? void 0 : container.scrollHeight) !== null && _container_scrollHeight !== void 0 ? _container_scrollHeight : 0
        };
    }
    getVisibleRect() {
        let container = this.ref.current;
        var _container_scrollLeft, _container_scrollTop, _container_offsetWidth, _container_offsetHeight;
        return {
            x: (_container_scrollLeft = container === null || container === void 0 ? void 0 : container.scrollLeft) !== null && _container_scrollLeft !== void 0 ? _container_scrollLeft : 0,
            y: (_container_scrollTop = container === null || container === void 0 ? void 0 : container.scrollTop) !== null && _container_scrollTop !== void 0 ? _container_scrollTop : 0,
            width: (_container_offsetWidth = container === null || container === void 0 ? void 0 : container.offsetWidth) !== null && _container_offsetWidth !== void 0 ? _container_offsetWidth : 0,
            height: (_container_offsetHeight = container === null || container === void 0 ? void 0 : container.offsetHeight) !== null && _container_offsetHeight !== void 0 ? _container_offsetHeight : 0
        };
    }
    constructor(ref){
        this.ref = ref;
    }
}

});


parcelRegister("7caxR", function(module, exports) {

$parcel$export(module.exports, "useCollator", function () { return $35a682afedc3a284$export$a16aca283550c30d; });

var $c8uzR = parcelRequire("c8uzR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $35a682afedc3a284$var$$325a3faab7a68acd$var$cache = new Map();
function $35a682afedc3a284$export$a16aca283550c30d(options) {
    let { locale: locale } = (0, $c8uzR.useLocale)();
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if ($35a682afedc3a284$var$$325a3faab7a68acd$var$cache.has(cacheKey)) return $35a682afedc3a284$var$$325a3faab7a68acd$var$cache.get(cacheKey);
    let formatter = new Intl.Collator(locale, options);
    $35a682afedc3a284$var$$325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}

});



parcelRegister("gC9Fb", function(module, exports) {

$parcel$export(module.exports, "useMenuItem", function () { return $76a46621f96cc643$export$9d32628fc2aea7da; });

var $dYofy = parcelRequire("dYofy");

var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");
var $gN5ZC = parcelRequire("gN5ZC");
var $gxMV2 = parcelRequire("gxMV2");

var $2stCI = parcelRequire("2stCI");

var $8tXMg = parcelRequire("8tXMg");
var $3IQLS = parcelRequire("3IQLS");
var $i91F7 = parcelRequire("i91F7");
var $jxA49 = parcelRequire("jxA49");
var $b3OV8 = parcelRequire("b3OV8");

var $gYN2y = parcelRequire("gYN2y");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $76a46621f96cc643$export$9d32628fc2aea7da(props, state, ref) {
    let { id: id, key: key, closeOnSelect: closeOnSelect, isVirtualized: isVirtualized, 'aria-haspopup': hasPopup, onPressStart: pressStartProp, onPressUp: pressUpProp, onPress: onPress, onPressChange: onPressChange, onPressEnd: onPressEnd, onHoverStart: hoverStartProp, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onFocus: onFocus, onFocusChange: onFocusChange, onBlur: onBlur, selectionManager: selectionManager = state.selectionManager } = props;
    let isTrigger = !!hasPopup;
    let isTriggerExpanded = isTrigger && props['aria-expanded'] === 'true';
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : selectionManager.isDisabled(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : selectionManager.isSelected(key);
    let data = (0, $dYofy.menuData).get(state);
    let item = state.collection.getItem(key);
    let onClose = props.onClose || data.onClose;
    let router = (0, $gN5ZC.useRouter)();
    let performAction = (e)=>{
        var _item_props;
        if (isTrigger) return;
        if (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.onAction) item.props.onAction();
        else if (props.onAction) props.onAction(key);
        if (data.onAction) {
            // Must reassign to variable otherwise `this` binding gets messed up. Something to do with WeakMap.
            let onAction = data.onAction;
            onAction(key);
        }
        if (e.target instanceof HTMLAnchorElement && item) router.open(e.target, e, item.props.href, item.props.routerOptions);
    };
    let role = 'menuitem';
    if (!isTrigger) {
        if (selectionManager.selectionMode === 'single') role = 'menuitemradio';
        else if (selectionManager.selectionMode === 'multiple') role = 'menuitemcheckbox';
    }
    let labelId = (0, $gxMV2.useSlotId)();
    let descriptionId = (0, $gxMV2.useSlotId)();
    let keyboardId = (0, $gxMV2.useSlotId)();
    let ariaProps = {
        id: id,
        'aria-disabled': isDisabled || undefined,
        role: role,
        'aria-label': props['aria-label'],
        'aria-labelledby': labelId,
        'aria-describedby': [
            descriptionId,
            keyboardId
        ].filter(Boolean).join(' ') || undefined,
        'aria-controls': props['aria-controls'],
        'aria-haspopup': hasPopup,
        'aria-expanded': props['aria-expanded']
    };
    if (selectionManager.selectionMode !== 'none' && !isTrigger) ariaProps['aria-checked'] = isSelected;
    if (isVirtualized) {
        ariaProps['aria-posinset'] = item === null || item === void 0 ? void 0 : item.index;
        ariaProps['aria-setsize'] = (0, $2stCI.getItemCount)(state.collection);
    }
    let onPressStart = (e)=>{
        if (e.pointerType === 'keyboard') performAction(e);
        pressStartProp === null || pressStartProp === void 0 || pressStartProp(e);
    };
    let onPressUp = (e)=>{
        if (e.pointerType !== 'keyboard') {
            performAction(e);
            // Pressing a menu item should close by default in single selection mode but not multiple
            // selection mode, except if overridden by the closeOnSelect prop.
            if (!isTrigger && onClose && (closeOnSelect !== null && closeOnSelect !== void 0 ? closeOnSelect : selectionManager.selectionMode !== 'multiple' || selectionManager.isLink(key))) onClose();
        }
        pressUpProp === null || pressUpProp === void 0 || pressUpProp(e);
    };
    let { itemProps: itemProps, isFocused: isFocused } = (0, $gYN2y.useSelectableItem)({
        selectionManager: selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true,
        allowsDifferentPressOrigin: true,
        // Disable all handling of links in useSelectable item
        // because we handle it ourselves. The behavior of menus
        // is slightly different from other collections because
        // actions are performed on key down rather than key up.
        linkBehavior: 'none'
    });
    let { pressProps: pressProps, isPressed: isPressed } = (0, $b3OV8.usePress)({
        onPressStart: onPressStart,
        onPress: onPress,
        onPressUp: onPressUp,
        onPressChange: onPressChange,
        onPressEnd: onPressEnd,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps } = (0, $i91F7.useHover)({
        isDisabled: isDisabled,
        onHoverStart (e) {
            // Hovering over an already expanded sub dialog trigger should keep focus in the dialog.
            if (!(0, $8tXMg.isFocusVisible)() && !(isTriggerExpanded && hasPopup === 'dialog')) {
                selectionManager.setFocused(true);
                selectionManager.setFocusedKey(key);
            }
            hoverStartProp === null || hoverStartProp === void 0 || hoverStartProp(e);
        },
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd
    });
    let { keyboardProps: keyboardProps } = (0, $jxA49.useKeyboard)({
        onKeyDown: (e)=>{
            // Ignore repeating events, which may have started on the menu trigger before moving
            // focus to the menu item. We want to wait for a second complete key press sequence.
            if (e.repeat) {
                e.continuePropagation();
                return;
            }
            switch(e.key){
                case ' ':
                    if (!isDisabled && selectionManager.selectionMode === 'none' && !isTrigger && closeOnSelect !== false && onClose) onClose();
                    break;
                case 'Enter':
                    // The Enter key should always close on select, except if overridden.
                    if (!isDisabled && closeOnSelect !== false && !isTrigger && onClose) onClose();
                    break;
                default:
                    if (!isTrigger) e.continuePropagation();
                    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
                    break;
            }
        },
        onKeyUp: onKeyUp
    });
    let { focusProps: focusProps } = (0, $3IQLS.useFocus)({
        onBlur: onBlur,
        onFocus: onFocus,
        onFocusChange: onFocusChange
    });
    let domProps = (0, $bG0JH.filterDOMProps)(item === null || item === void 0 ? void 0 : item.props);
    delete domProps.id;
    let linkProps = (0, $gN5ZC.useLinkProps)(item === null || item === void 0 ? void 0 : item.props);
    return {
        menuItemProps: {
            ...ariaProps,
            ...(0, $hAxtE.mergeProps)(domProps, linkProps, isTrigger ? {
                onFocus: itemProps.onFocus,
                'data-key': itemProps['data-key']
            } : itemProps, pressProps, hoverProps, keyboardProps, focusProps),
            // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
            tabIndex: itemProps.tabIndex != null && isTriggerExpanded ? -1 : itemProps.tabIndex
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        },
        isFocused: isFocused,
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled
    };
}

});
parcelRegister("2stCI", function(module, exports) {

$parcel$export(module.exports, "getItemCount", function () { return $fcfd640a0af06a54$export$77d5aafae4e095b2; });

var $6z78f = parcelRequire("6z78f");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $fcfd640a0af06a54$var$$453cc9f0df89c0a5$var$cache = new WeakMap();
function $fcfd640a0af06a54$export$77d5aafae4e095b2(collection) {
    let count = $fcfd640a0af06a54$var$$453cc9f0df89c0a5$var$cache.get(collection);
    if (count != null) return count;
    // TS isn't smart enough to know we've ensured count is a number, so use a new variable
    let counter = 0;
    let countItems = (items)=>{
        for (let item of items)if (item.type === 'section') countItems((0, $6z78f.getChildNodes)(item, collection));
        else counter++;
    };
    countItems(collection);
    $fcfd640a0af06a54$var$$453cc9f0df89c0a5$var$cache.set(collection, counter);
    return counter;
}

});
parcelRegister("6z78f", function(module, exports) {

$parcel$export(module.exports, "getChildNodes", function () { return $f447a2190cf771ba$export$1005530eda016c13; });
$parcel$export(module.exports, "getFirstItem", function () { return $f447a2190cf771ba$export$fbdeaa6a76694f71; });
$parcel$export(module.exports, "getNthItem", function () { return $f447a2190cf771ba$export$5f3398f8733f90e2; });
$parcel$export(module.exports, "getLastItem", function () { return $f447a2190cf771ba$export$7475b2c64539e4cf; });
$parcel$export(module.exports, "compareNodeOrder", function () { return $f447a2190cf771ba$export$8c434b3a7a4dad6; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f447a2190cf771ba$export$1005530eda016c13(node, collection) {
    // New API: call collection.getChildren with the node key.
    if (typeof collection.getChildren === 'function') return collection.getChildren(node.key);
    // Old API: access childNodes directly.
    return node.childNodes;
}
function $f447a2190cf771ba$export$fbdeaa6a76694f71(iterable) {
    return $f447a2190cf771ba$export$5f3398f8733f90e2(iterable, 0);
}
function $f447a2190cf771ba$export$5f3398f8733f90e2(iterable, index) {
    if (index < 0) return undefined;
    let i = 0;
    for (let item of iterable){
        if (i === index) return item;
        i++;
    }
}
function $f447a2190cf771ba$export$7475b2c64539e4cf(iterable) {
    let lastItem = undefined;
    for (let value of iterable)lastItem = value;
    return lastItem;
}
function $f447a2190cf771ba$export$8c434b3a7a4dad6(collection, a, b) {
    // If the two nodes have the same parent, compare their indices.
    if (a.parentKey === b.parentKey) return a.index - b.index;
    // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
    // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
    // ancestor of the same level
    let aAncestors = [
        ...$f447a2190cf771ba$var$$c5a24bc478652b5f$var$getAncestors(collection, a),
        a
    ];
    let bAncestors = [
        ...$f447a2190cf771ba$var$$c5a24bc478652b5f$var$getAncestors(collection, b),
        b
    ];
    let firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex((a, i)=>a !== bAncestors[i]);
    if (firstNonMatchingAncestor !== -1) {
        // Compare the indices of two children within the common ancestor.
        a = aAncestors[firstNonMatchingAncestor];
        b = bAncestors[firstNonMatchingAncestor];
        return a.index - b.index;
    }
    // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
    if (aAncestors.findIndex((node)=>node === b) >= 0) return 1;
    else if (bAncestors.findIndex((node)=>node === a) >= 0) return -1;
    // 🤷
    return -1;
}
function $f447a2190cf771ba$var$$c5a24bc478652b5f$var$getAncestors(collection, node) {
    let parents = [];
    let currNode = node;
    while((currNode === null || currNode === void 0 ? void 0 : currNode.parentKey) != null){
        currNode = collection.getItem(currNode.parentKey);
        if (currNode) parents.unshift(currNode);
    }
    return parents;
}

});


parcelRegister("gYN2y", function(module, exports) {

$parcel$export(module.exports, "useSelectableItem", function () { return $336fe6a3f234be17$export$ecf600387e221c37; });

var $6PcGA = parcelRequire("6PcGA");

var $bQDsd = parcelRequire("bQDsd");

var $hAxtE = parcelRequire("hAxtE");
var $gN5ZC = parcelRequire("gN5ZC");

var $aYkGx = parcelRequire("aYkGx");
var $b3OV8 = parcelRequire("b3OV8");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $336fe6a3f234be17$export$ecf600387e221c37(options) {
    let { selectionManager: manager, key: key, ref: ref, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldUseVirtualFocus: shouldUseVirtualFocus, focus: focus, isDisabled: isDisabled, onAction: onAction, allowsDifferentPressOrigin: allowsDifferentPressOrigin, linkBehavior: linkBehavior = 'action' } = options;
    let router = (0, $gN5ZC.useRouter)();
    let onSelect = (e)=>{
        if (e.pointerType === 'keyboard' && (0, $6PcGA.isNonContiguousSelectionModifier)(e)) manager.toggleSelection(key);
        else {
            if (manager.selectionMode === 'none') return;
            if (manager.isLink(key)) {
                if (linkBehavior === 'selection' && ref.current) {
                    let itemProps = manager.getItemProps(key);
                    router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
                    // Always set selected keys back to what they were so that select and combobox close.
                    manager.setSelectedKeys(manager.selectedKeys);
                    return;
                } else if (linkBehavior === 'override' || linkBehavior === 'none') return;
            }
            if (manager.selectionMode === 'single') {
                if (manager.isSelected(key) && !manager.disallowEmptySelection) manager.toggleSelection(key);
                else manager.replaceSelection(key);
            } else if (e && e.shiftKey) manager.extendSelection(key);
            else if (manager.selectionBehavior === 'toggle' || e && ((0, $6PcGA.isCtrlKeyPressed)(e) || e.pointerType === 'touch' || e.pointerType === 'virtual')) manager.toggleSelection(key);
            else manager.replaceSelection(key);
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        let isFocused = key === manager.focusedKey;
        if (isFocused && manager.isFocused && !shouldUseVirtualFocus) {
            if (focus) focus();
            else if (document.activeElement !== ref.current && ref.current) (0, $bQDsd.focusSafely)(ref.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        key,
        manager.focusedKey,
        manager.childFocusStrategy,
        manager.isFocused,
        shouldUseVirtualFocus
    ]);
    isDisabled = isDisabled || manager.isDisabled(key);
    // Set tabIndex to 0 if the element is focused, or -1 otherwise so that only the last focused
    // item is tabbable.  If using virtual focus, don't set a tabIndex at all so that VoiceOver
    // on iOS 14 doesn't try to move real DOM focus to the item anyway.
    let itemProps = {};
    if (!shouldUseVirtualFocus && !isDisabled) itemProps = {
        tabIndex: key === manager.focusedKey ? 0 : -1,
        onFocus (e) {
            if (e.target === ref.current) manager.setFocusedKey(key);
        }
    };
    else if (isDisabled) itemProps.onMouseDown = (e)=>{
        // Prevent focus going to the body when clicking on a disabled item.
        e.preventDefault();
    };
    // With checkbox selection, onAction (i.e. navigation) becomes primary, and occurs on a single click of the row.
    // Clicking the checkbox enters selection mode, after which clicking anywhere on any row toggles selection for that row.
    // With highlight selection, onAction is secondary, and occurs on double click. Single click selects the row.
    // With touch, onAction occurs on single tap, and long press enters selection mode.
    let isLinkOverride = manager.isLink(key) && linkBehavior === 'override';
    let hasLinkAction = manager.isLink(key) && linkBehavior !== 'selection' && linkBehavior !== 'none';
    let allowsSelection = !isDisabled && manager.canSelectItem(key) && !isLinkOverride;
    let allowsActions = (onAction || hasLinkAction) && !isDisabled;
    let hasPrimaryAction = allowsActions && (manager.selectionBehavior === 'replace' ? !allowsSelection : !allowsSelection || manager.isEmpty);
    let hasSecondaryAction = allowsActions && allowsSelection && manager.selectionBehavior === 'replace';
    let hasAction = hasPrimaryAction || hasSecondaryAction;
    let modality = (0, $bh6RR.useRef)(null);
    let longPressEnabled = hasAction && allowsSelection;
    let longPressEnabledOnPressStart = (0, $bh6RR.useRef)(false);
    let hadPrimaryActionOnPressStart = (0, $bh6RR.useRef)(false);
    let performAction = (e)=>{
        if (onAction) onAction();
        if (hasLinkAction && ref.current) {
            let itemProps = manager.getItemProps(key);
            router.open(ref.current, e, itemProps.href, itemProps.routerOptions);
        }
    };
    // By default, selection occurs on pointer down. This can be strange if selecting an
    // item causes the UI to disappear immediately (e.g. menus).
    // If shouldSelectOnPressUp is true, we use onPressUp instead of onPressStart.
    // onPress requires a pointer down event on the same element as pointer up. For menus,
    // we want to be able to have the pointer down on the trigger that opens the menu and
    // the pointer up on the menu item rather than requiring a separate press.
    // For keyboard events, selection still occurs on key down.
    let itemPressProps = {};
    if (shouldSelectOnPressUp) {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            if (e.pointerType === 'keyboard' && (!hasAction || $336fe6a3f234be17$var$$880e95eb8b93ba9a$var$isSelectionKey())) onSelect(e);
        };
        // If allowsDifferentPressOrigin, make selection happen on pressUp (e.g. open menu on press down, selection on menu item happens on press up.)
        // Otherwise, have selection happen onPress (prevents listview row selection when clicking on interactable elements in the row)
        if (!allowsDifferentPressOrigin) itemPressProps.onPress = (e)=>{
            if (hasPrimaryAction || hasSecondaryAction && e.pointerType !== 'mouse') {
                if (e.pointerType === 'keyboard' && !$336fe6a3f234be17$var$$880e95eb8b93ba9a$var$isActionKey()) return;
                performAction(e);
            } else if (e.pointerType !== 'keyboard' && allowsSelection) onSelect(e);
        };
        else {
            itemPressProps.onPressUp = hasPrimaryAction ? undefined : (e)=>{
                if (e.pointerType !== 'keyboard' && allowsSelection) onSelect(e);
            };
            itemPressProps.onPress = hasPrimaryAction ? performAction : undefined;
        }
    } else {
        itemPressProps.onPressStart = (e)=>{
            modality.current = e.pointerType;
            longPressEnabledOnPressStart.current = longPressEnabled;
            hadPrimaryActionOnPressStart.current = hasPrimaryAction;
            // Select on mouse down unless there is a primary action which will occur on mouse up.
            // For keyboard, select on key down. If there is an action, the Space key selects on key down,
            // and the Enter key performs onAction on key up.
            if (allowsSelection && (e.pointerType === 'mouse' && !hasPrimaryAction || e.pointerType === 'keyboard' && (!allowsActions || $336fe6a3f234be17$var$$880e95eb8b93ba9a$var$isSelectionKey()))) onSelect(e);
        };
        itemPressProps.onPress = (e)=>{
            // Selection occurs on touch up. Primary actions always occur on pointer up.
            // Both primary and secondary actions occur on Enter key up. The only exception
            // is secondary actions, which occur on double click with a mouse.
            if (e.pointerType === 'touch' || e.pointerType === 'pen' || e.pointerType === 'virtual' || e.pointerType === 'keyboard' && hasAction && $336fe6a3f234be17$var$$880e95eb8b93ba9a$var$isActionKey() || e.pointerType === 'mouse' && hadPrimaryActionOnPressStart.current) {
                if (hasAction) performAction(e);
                else if (allowsSelection) onSelect(e);
            }
        };
    }
    itemProps['data-key'] = key;
    itemPressProps.preventFocusOnPress = shouldUseVirtualFocus;
    let { pressProps: pressProps, isPressed: isPressed } = (0, $b3OV8.usePress)(itemPressProps);
    // Double clicking with a mouse with selectionBehavior = 'replace' performs an action.
    let onDoubleClick = hasSecondaryAction ? (e)=>{
        if (modality.current === 'mouse') {
            e.stopPropagation();
            e.preventDefault();
            performAction(e);
        }
    } : undefined;
    // Long pressing an item with touch when selectionBehavior = 'replace' switches the selection behavior
    // to 'toggle'. This changes the single tap behavior from performing an action (i.e. navigating) to
    // selecting, and may toggle the appearance of a UI affordance like checkboxes on each item.
    let { longPressProps: longPressProps } = (0, $aYkGx.useLongPress)({
        isDisabled: !longPressEnabled,
        onLongPress (e) {
            if (e.pointerType === 'touch') {
                onSelect(e);
                manager.setSelectionBehavior('toggle');
            }
        }
    });
    // Prevent native drag and drop on long press if we also select on long press.
    // Once the user is in selection mode, they can long press again to drag.
    // Use a capturing listener to ensure this runs before useDrag, regardless of
    // the order the props get merged.
    let onDragStartCapture = (e)=>{
        if (modality.current === 'touch' && longPressEnabledOnPressStart.current) e.preventDefault();
    };
    // Prevent default on link clicks so that we control exactly
    // when they open (to match selection behavior).
    let onClick = manager.isLink(key) ? (e)=>{
        if (!(0, $gN5ZC.openLink).isOpening) e.preventDefault();
    } : undefined;
    return {
        itemProps: (0, $hAxtE.mergeProps)(itemProps, allowsSelection || hasPrimaryAction ? pressProps : {}, longPressEnabled ? longPressProps : {}, {
            onDoubleClick: onDoubleClick,
            onDragStartCapture: onDragStartCapture,
            onClick: onClick
        }),
        isPressed: isPressed,
        isSelected: manager.isSelected(key),
        isFocused: manager.isFocused && manager.focusedKey === key,
        isDisabled: isDisabled,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}
function $336fe6a3f234be17$var$$880e95eb8b93ba9a$var$isActionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === 'Enter';
}
function $336fe6a3f234be17$var$$880e95eb8b93ba9a$var$isSelectionKey() {
    let event = window.event;
    return (event === null || event === void 0 ? void 0 : event.key) === ' ' || (event === null || event === void 0 ? void 0 : event.code) === 'Space';
}

});
parcelRegister("aYkGx", function(module, exports) {

$parcel$export(module.exports, "useLongPress", function () { return $e2812b8f334f3c5f$export$c24ed0104d07eab9; });

var $b3OV8 = parcelRequire("b3OV8");

var $hAxtE = parcelRequire("hAxtE");
var $eHR6B = parcelRequire("eHR6B");
var $foRcG = parcelRequire("foRcG");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $e2812b8f334f3c5f$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $e2812b8f334f3c5f$export$c24ed0104d07eab9(props) {
    let { isDisabled: isDisabled, onLongPressStart: onLongPressStart, onLongPressEnd: onLongPressEnd, onLongPress: onLongPress, threshold: threshold = $e2812b8f334f3c5f$var$$8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: accessibilityDescription } = props;
    const timeRef = (0, $bh6RR.useRef)(undefined);
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $foRcG.useGlobalListeners)();
    let { pressProps: pressProps } = (0, $b3OV8.usePress)({
        isDisabled: isDisabled,
        onPressStart (e) {
            e.continuePropagation();
            if (e.pointerType === 'mouse' || e.pointerType === 'touch') {
                if (onLongPressStart) onLongPressStart({
                    ...e,
                    type: 'longpressstart'
                });
                timeRef.current = setTimeout(()=>{
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent('pointercancel', {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress({
                        ...e,
                        type: 'longpress'
                    });
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === 'touch') {
                    let onContextMenu = (e)=>{
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, 'contextmenu', onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, 'pointerup', ()=>{
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(()=>{
                            removeGlobalListener(e.target, 'contextmenu', onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd (e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === 'mouse' || e.pointerType === 'touch')) onLongPressEnd({
                ...e,
                type: 'longpressend'
            });
        }
    });
    let descriptionProps = (0, $eHR6B.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, $hAxtE.mergeProps)(pressProps, descriptionProps)
    };
}

});
parcelRegister("eHR6B", function(module, exports) {

$parcel$export(module.exports, "useDescription", function () { return $77561e4148b2c71f$export$f8aeda7b10753fa1; });

var $f2PTm = parcelRequire("f2PTm");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $77561e4148b2c71f$var$$ef06256079686ba0$var$descriptionId = 0;
const $77561e4148b2c71f$var$$ef06256079686ba0$var$descriptionNodes = new Map();
function $77561e4148b2c71f$export$f8aeda7b10753fa1(description) {
    let [id, setId] = (0, $bh6RR.useState)();
    (0, $f2PTm.useLayoutEffect)(()=>{
        if (!description) return;
        let desc = $77561e4148b2c71f$var$$ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            let id = `react-aria-description-${$77561e4148b2c71f$var$$ef06256079686ba0$var$descriptionId++}`;
            setId(id);
            let node = document.createElement('div');
            node.id = id;
            node.style.display = 'none';
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $77561e4148b2c71f$var$$ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return ()=>{
            if (desc && --desc.refCount === 0) {
                desc.element.remove();
                $77561e4148b2c71f$var$$ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        'aria-describedby': description ? id : undefined
    };
}

});




parcelRegister("fJh19", function(module, exports) {

$parcel$export(module.exports, "useMenuSection", function () { return $cd5383602bcc6517$export$73f7a44322579622; });

var $gxMV2 = parcelRequire("gxMV2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $cd5383602bcc6517$export$73f7a44322579622(props) {
    let { heading: heading, 'aria-label': ariaLabel } = props;
    let headingId = (0, $gxMV2.useId)();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Techincally, menus cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a label for the nested group.
            id: headingId,
            role: 'presentation'
        } : {},
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}

});

parcelRegister("ddC4A", function(module, exports) {

$parcel$export(module.exports, "useMenuTrigger", function () { return $bc67d2960490d817$export$dc9c12ed27dd1b49; });

var $dTVh2 = parcelRequire("dTVh2");

var $gxMV2 = parcelRequire("gxMV2");

var $kbHlJ = parcelRequire("kbHlJ");

var $aYkGx = parcelRequire("aYkGx");

var $kMGia = parcelRequire("kMGia");
function $bc67d2960490d817$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bc67d2960490d817$export$dc9c12ed27dd1b49(props, state, ref) {
    let { type: type = 'menu', isDisabled: isDisabled, trigger: trigger = 'press' } = props;
    let menuTriggerId = (0, $gxMV2.useId)();
    let { triggerProps: triggerProps, overlayProps: overlayProps } = (0, $kMGia.useOverlayTrigger)({
        type: type
    }, state, ref);
    let onKeyDown = (e)=>{
        if (isDisabled) return;
        if (trigger === 'longPress' && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case 'Enter':
            case ' ':
                if (trigger === 'longPress') return;
            // fallthrough
            case 'ArrowDown':
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!('continuePropagation' in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle('first');
                break;
            case 'ArrowUp':
                if (!('continuePropagation' in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle('last');
                break;
            default:
                // Allow other keys.
                if ('continuePropagation' in e) e.continuePropagation();
        }
    };
    let stringFormatter = (0, $kbHlJ.useLocalizedStringFormatter)($bc67d2960490d817$var$$parcel$interopDefault((0, $dTVh2.default)), '@react-aria/menu');
    let { longPressProps: longPressProps } = (0, $aYkGx.useLongPress)({
        isDisabled: isDisabled || trigger !== 'longPress',
        accessibilityDescription: stringFormatter.format('longPressMessage'),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open('first');
        }
    });
    let pressProps = {
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== 'touch' && e.pointerType !== 'keyboard' && !isDisabled) // Otherwise, the menu itself will be focused.
            state.open(e.pointerType === 'virtual' ? 'first' : null);
        },
        onPress (e) {
            if (e.pointerType === 'touch' && !isDisabled) state.toggle();
        }
    };
    // omit onPress from triggerProps since we override it above.
    delete triggerProps.onPress;
    return {
        // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
        menuTriggerProps: {
            ...triggerProps,
            ...trigger === 'press' ? pressProps : longPressProps,
            id: menuTriggerId,
            onKeyDown: onKeyDown
        },
        menuProps: {
            ...overlayProps,
            'aria-labelledby': menuTriggerId,
            autoFocus: state.focusStrategy || true,
            onClose: state.close
        }
    };
}

});
parcelRegister("dTVh2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $026ed8fe1f8e81e1$export$2e2bcd8739ae039; });

var $izVAt = parcelRequire("izVAt");

var $i5Edl = parcelRequire("i5Edl");

var $8eqnx = parcelRequire("8eqnx");

var $jxwkm = parcelRequire("jxwkm");

var $dM4ec = parcelRequire("dM4ec");

var $g4CAh = parcelRequire("g4CAh");

var $lWFQN = parcelRequire("lWFQN");

var $2ycc3 = parcelRequire("2ycc3");

var $65a9G = parcelRequire("65a9G");

var $gOFkL = parcelRequire("gOFkL");

var $67rgt = parcelRequire("67rgt");

var $5AMgh = parcelRequire("5AMgh");

var $f1xN6 = parcelRequire("f1xN6");

var $g4eJs = parcelRequire("g4eJs");

var $ewm1i = parcelRequire("ewm1i");

var $h9Q6l = parcelRequire("h9Q6l");

var $eIiFf = parcelRequire("eIiFf");

var $60YXZ = parcelRequire("60YXZ");

var $eRjMo = parcelRequire("eRjMo");

var $6XNNg = parcelRequire("6XNNg");

var $4iP1T = parcelRequire("4iP1T");

var $kLhnK = parcelRequire("kLhnK");

var $aLTpQ = parcelRequire("aLTpQ");

var $jWQII = parcelRequire("jWQII");

var $6xUN1 = parcelRequire("6xUN1");

var $2S38J = parcelRequire("2S38J");

var $jWi2G = parcelRequire("jWi2G");

var $iVodi = parcelRequire("iVodi");

var $3YxZS = parcelRequire("3YxZS");

var $gRwiR = parcelRequire("gRwiR");

var $75s1l = parcelRequire("75s1l");

var $jDNHS = parcelRequire("jDNHS");

var $lsafa = parcelRequire("lsafa");

var $gt4Ke = parcelRequire("gt4Ke");
var $026ed8fe1f8e81e1$export$2e2bcd8739ae039 = {};
$026ed8fe1f8e81e1$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $izVAt.default),
    "bg-BG": (0, $i5Edl.default),
    "cs-CZ": (0, $8eqnx.default),
    "da-DK": (0, $jxwkm.default),
    "de-DE": (0, $dM4ec.default),
    "el-GR": (0, $g4CAh.default),
    "en-US": (0, $lWFQN.default),
    "es-ES": (0, $2ycc3.default),
    "et-EE": (0, $65a9G.default),
    "fi-FI": (0, $gOFkL.default),
    "fr-FR": (0, $67rgt.default),
    "he-IL": (0, $5AMgh.default),
    "hr-HR": (0, $f1xN6.default),
    "hu-HU": (0, $g4eJs.default),
    "it-IT": (0, $ewm1i.default),
    "ja-JP": (0, $h9Q6l.default),
    "ko-KR": (0, $eIiFf.default),
    "lt-LT": (0, $60YXZ.default),
    "lv-LV": (0, $eRjMo.default),
    "nb-NO": (0, $6XNNg.default),
    "nl-NL": (0, $4iP1T.default),
    "pl-PL": (0, $kLhnK.default),
    "pt-BR": (0, $aLTpQ.default),
    "pt-PT": (0, $jWQII.default),
    "ro-RO": (0, $6xUN1.default),
    "ru-RU": (0, $2S38J.default),
    "sk-SK": (0, $jWi2G.default),
    "sl-SI": (0, $iVodi.default),
    "sr-SP": (0, $3YxZS.default),
    "sv-SE": (0, $gRwiR.default),
    "tr-TR": (0, $75s1l.default),
    "uk-UA": (0, $jDNHS.default),
    "zh-CN": (0, $lsafa.default),
    "zh-TW": (0, $gt4Ke.default)
};

});
parcelRegister("izVAt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $991fef5c5cdd6e1d$export$2e2bcd8739ae039; });
var $991fef5c5cdd6e1d$export$2e2bcd8739ae039 = {};
$991fef5c5cdd6e1d$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{627}\u{64B} \u{623}\u{648} \u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} Alt + \u{627}\u{644}\u{633}\u{647}\u{645} \u{644}\u{623}\u{633}\u{641}\u{644} \u{644}\u{641}\u{62A}\u{62D} \u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629}`
};

});

parcelRegister("i5Edl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c87986901c0d4399$export$2e2bcd8739ae039; });
var $c87986901c0d4399$export$2e2bcd8739ae039 = {};
$c87986901c0d4399$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Alt+ \u{441}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{43D}\u{430}\u{434}\u{43E}\u{43B}\u{443}, \u{437}\u{430} \u{434}\u{430} \u{43E}\u{442}\u{432}\u{43E}\u{440}\u{438}\u{442}\u{435} \u{43C}\u{435}\u{43D}\u{44E}\u{442}\u{43E}`
};

});

parcelRegister("8eqnx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f48a5d1b9ddc887$export$2e2bcd8739ae039; });
var $8f48a5d1b9ddc887$export$2e2bcd8739ae039 = {};
$8f48a5d1b9ddc887$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dlouh\xfdm stiskem nebo stisknut\xedm kl\xe1ves Alt + \u{161}ipka dol\u{16F} otev\u{159}ete nab\xeddku`
};

});

parcelRegister("jxwkm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9954e0b73acb608$export$2e2bcd8739ae039; });
var $c9954e0b73acb608$export$2e2bcd8739ae039 = {};
$c9954e0b73acb608$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt tryk eller tryk p\xe5 Alt + pil ned for at \xe5bne menuen`
};

});

parcelRegister("dM4ec", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f63fc9648dde901$export$2e2bcd8739ae039; });
var $6f63fc9648dde901$export$2e2bcd8739ae039 = {};
$6f63fc9648dde901$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dr\xfccken Sie lange oder dr\xfccken Sie Alt + Nach-unten, um das Men\xfc zu \xf6ffnen`
};

});

parcelRegister("g4CAh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b97a9c4e027e0b93$export$2e2bcd8739ae039; });
var $b97a9c4e027e0b93$export$2e2bcd8739ae039 = {};
$b97a9c4e027e0b93$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{3A0}\u{3B9}\u{3AD}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3AE} \u{3C0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Alt + \u{3BA}\u{3AC}\u{3C4}\u{3C9} \u{3B2}\u{3AD}\u{3BB}\u{3BF}\u{3C2} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3BF}\u{3AF}\u{3BE}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3BF} \u{3BC}\u{3B5}\u{3BD}\u{3BF}\u{3CD}`
};

});

parcelRegister("lWFQN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6079b7ca37e6a1ae$export$2e2bcd8739ae039; });
var $6079b7ca37e6a1ae$export$2e2bcd8739ae039 = {};
$6079b7ca37e6a1ae$export$2e2bcd8739ae039 = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};

});

parcelRegister("2ycc3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03e8ed45cec6e041$export$2e2bcd8739ae039; });
var $03e8ed45cec6e041$export$2e2bcd8739ae039 = {};
$03e8ed45cec6e041$export$2e2bcd8739ae039 = {
    "longPressMessage": `Mantenga pulsado o pulse Alt + flecha abajo para abrir el men\xfa`
};

});

parcelRegister("65a9G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22b7ecbf357559fd$export$2e2bcd8739ae039; });
var $22b7ecbf357559fd$export$2e2bcd8739ae039 = {};
$22b7ecbf357559fd$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfc\xfc avamiseks vajutage pikalt v\xf5i vajutage klahve Alt + allanool`
};

});

parcelRegister("gOFkL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5984c255b765a44$export$2e2bcd8739ae039; });
var $d5984c255b765a44$export$2e2bcd8739ae039 = {};
$d5984c255b765a44$export$2e2bcd8739ae039 = {
    "longPressMessage": `Avaa valikko painamalla pohjassa tai n\xe4pp\xe4inyhdistelm\xe4ll\xe4 Alt + Alanuoli`
};

});

parcelRegister("67rgt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $451b2fbf8081aa6b$export$2e2bcd8739ae039; });
var $451b2fbf8081aa6b$export$2e2bcd8739ae039 = {};
$451b2fbf8081aa6b$export$2e2bcd8739ae039 = {
    "longPressMessage": `Appuyez de mani\xe8re prolong\xe9e ou appuyez sur Alt\xa0+\xa0Fl\xe8che vers le bas pour ouvrir le menu.`
};

});

parcelRegister("5AMgh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d489d1bd1fe02c56$export$2e2bcd8739ae039; });
var $d489d1bd1fe02c56$export$2e2bcd8739ae039 = {};
$d489d1bd1fe02c56$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{5DC}\u{5D7}\u{5E5} \u{5DC}\u{5D7}\u{5D9}\u{5E6}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5D0}\u{5D5} \u{5D4}\u{5E7}\u{5E9} Alt + ArrowDown \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E4}\u{5EA}\u{5D5}\u{5D7} \u{5D0}\u{5EA} \u{5D4}\u{5EA}\u{5E4}\u{5E8}\u{5D9}\u{5D8}`
};

});

parcelRegister("f1xN6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96f6259573c6b67b$export$2e2bcd8739ae039; });
var $96f6259573c6b67b$export$2e2bcd8739ae039 = {};
$96f6259573c6b67b$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika`
};

});

parcelRegister("g4eJs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6062471232bd3ffe$export$2e2bcd8739ae039; });
var $6062471232bd3ffe$export$2e2bcd8739ae039 = {};
$6062471232bd3ffe$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nyomja meg hosszan, vagy nyomja meg az Alt + lefele ny\xedl gombot a men\xfc megnyit\xe1s\xe1hoz`
};

});

parcelRegister("ewm1i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7eca46e25e346dc$export$2e2bcd8739ae039; });
var $d7eca46e25e346dc$export$2e2bcd8739ae039 = {};
$d7eca46e25e346dc$export$2e2bcd8739ae039 = {
    "longPressMessage": `Premere a lungo o premere Alt + Freccia gi\xf9 per aprire il menu`
};

});

parcelRegister("h9Q6l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81d62cf30caa3ada$export$2e2bcd8739ae039; });
var $81d62cf30caa3ada$export$2e2bcd8739ae039 = {};
$81d62cf30caa3ada$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{62BC}\u{3057}\u{307E}\u{305F}\u{306F} Alt+\u{4E0B}\u{77E2}\u{5370}\u{30AD}\u{30FC}\u{3067}\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{3092}\u{958B}\u{304F}`
};

});

parcelRegister("eIiFf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3266173aa57aaac$export$2e2bcd8739ae039; });
var $a3266173aa57aaac$export$2e2bcd8739ae039 = {};
$a3266173aa57aaac$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{AE38}\u{AC8C} \u{B204}\u{B974}\u{AC70}\u{B098} Alt + \u{C544}\u{B798}\u{CABD} \u{D654}\u{C0B4}\u{D45C}\u{B97C} \u{B20C}\u{B7EC} \u{BA54}\u{B274} \u{C5F4}\u{AE30}`
};

});

parcelRegister("60YXZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70b433e19c0c83c6$export$2e2bcd8739ae039; });
var $70b433e19c0c83c6$export$2e2bcd8739ae039 = {};
$70b433e19c0c83c6$export$2e2bcd8739ae039 = {
    "longPressMessage": `Nor\u{117}dami atidaryti meniu, nuspaud\u{119} palaikykite arba paspauskite \u{201E}Alt + ArrowDown\u{201C}.`
};

});

parcelRegister("eRjMo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14eb4b9c39ccff40$export$2e2bcd8739ae039; });
var $14eb4b9c39ccff40$export$2e2bcd8739ae039 = {};
$14eb4b9c39ccff40$export$2e2bcd8739ae039 = {
    "longPressMessage": `Lai atv\u{113}rtu izv\u{113}lni, turiet nospiestu vai nospiediet tausti\u{146}u kombin\u{101}ciju Alt + lejupv\u{113}rst\u{101} bulti\u{146}a`
};

});

parcelRegister("6XNNg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e29376c33dcd78b7$export$2e2bcd8739ae039; });
var $e29376c33dcd78b7$export$2e2bcd8739ae039 = {};
$e29376c33dcd78b7$export$2e2bcd8739ae039 = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen`
};

});

parcelRegister("4iP1T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75e61c054c320e88$export$2e2bcd8739ae039; });
var $75e61c054c320e88$export$2e2bcd8739ae039 = {};
$75e61c054c320e88$export$2e2bcd8739ae039 = {
    "longPressMessage": `Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen`
};

});

parcelRegister("kLhnK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c59a29d631cf3aea$export$2e2bcd8739ae039; });
var $c59a29d631cf3aea$export$2e2bcd8739ae039 = {};
$c59a29d631cf3aea$export$2e2bcd8739ae039 = {
    "longPressMessage": `Naci\u{15B}nij i przytrzymaj lub naci\u{15B}nij klawisze Alt + Strza\u{142}ka w d\xf3\u{142}, aby otworzy\u{107} menu`
};

});

parcelRegister("aLTpQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3c9ba5ccf8cf590$export$2e2bcd8739ae039; });
var $b3c9ba5ccf8cf590$export$2e2bcd8739ae039 = {};
$b3c9ba5ccf8cf590$export$2e2bcd8739ae039 = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};

});

parcelRegister("jWQII", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24ec36ebdaeee644$export$2e2bcd8739ae039; });
var $24ec36ebdaeee644$export$2e2bcd8739ae039 = {};
$24ec36ebdaeee644$export$2e2bcd8739ae039 = {
    "longPressMessage": `Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu`
};

});

parcelRegister("6xUN1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $501a351a13982b3f$export$2e2bcd8739ae039; });
var $501a351a13982b3f$export$2e2bcd8739ae039 = {};
$501a351a13982b3f$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ap\u{103}sa\u{21B}i lung sau ap\u{103}sa\u{21B}i pe Alt + s\u{103}geat\u{103} \xeen jos pentru a deschide meniul`
};

});

parcelRegister("2S38J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6bc4f0a5632c870$export$2e2bcd8739ae039; });
var $e6bc4f0a5632c870$export$2e2bcd8739ae039 = {};
$e6bc4f0a5632c870$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} Alt + \u{421}\u{442}\u{440}\u{435}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44E}`
};

});

parcelRegister("jWi2G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13ebcb076fa97ff7$export$2e2bcd8739ae039; });
var $13ebcb076fa97ff7$export$2e2bcd8739ae039 = {};
$13ebcb076fa97ff7$export$2e2bcd8739ae039 = {
    "longPressMessage": `Ponuku otvor\xedte dlh\xfdm stla\u{10D}en\xedm alebo stla\u{10D}en\xedm kl\xe1vesu Alt + kl\xe1vesu so \u{161}\xedpkou nadol`
};

});

parcelRegister("iVodi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf5db440069871ab$export$2e2bcd8739ae039; });
var $cf5db440069871ab$export$2e2bcd8739ae039 = {};
$cf5db440069871ab$export$2e2bcd8739ae039 = {
    "longPressMessage": `Za odprtje menija pritisnite in dr\u{17E}ite gumb ali pritisnite Alt+pu\u{161}\u{10D}ica navzdol`
};

});

parcelRegister("3YxZS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3630bd13c52a18de$export$2e2bcd8739ae039; });
var $3630bd13c52a18de$export$2e2bcd8739ae039 = {};
$3630bd13c52a18de$export$2e2bcd8739ae039 = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni`
};

});

parcelRegister("gRwiR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80e95f282c491f9a$export$2e2bcd8739ae039; });
var $80e95f282c491f9a$export$2e2bcd8739ae039 = {};
$80e95f282c491f9a$export$2e2bcd8739ae039 = {
    "longPressMessage": `H\xe5ll nedtryckt eller tryck p\xe5 Alt + pil ned\xe5t f\xf6r att \xf6ppna menyn`
};

});

parcelRegister("75s1l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33596cb9d741805e$export$2e2bcd8739ae039; });
var $33596cb9d741805e$export$2e2bcd8739ae039 = {};
$33596cb9d741805e$export$2e2bcd8739ae039 = {
    "longPressMessage": `Men\xfcy\xfc a\xe7mak i\xe7in uzun bas\u{131}n veya Alt + A\u{15F}a\u{11F}\u{131} Ok tu\u{15F}una bas\u{131}n`
};

});

parcelRegister("jDNHS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3daaee939694b300$export$2e2bcd8739ae039; });
var $3daaee939694b300$export$2e2bcd8739ae039 = {};
$3daaee939694b300$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{414}\u{43E}\u{432}\u{433}\u{43E} \u{430}\u{431}\u{43E} \u{437}\u{432}\u{438}\u{447}\u{430}\u{439}\u{43D}\u{43E} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} \u{43A}\u{43E}\u{43C}\u{431}\u{456}\u{43D}\u{430}\u{446}\u{456}\u{44E} \u{43A}\u{43B}\u{430}\u{432}\u{456}\u{448} Alt \u{456} \u{441}\u{442}\u{440}\u{456}\u{43B}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}, \u{449}\u{43E}\u{431} \u{432}\u{456}\u{434}\u{43A}\u{440}\u{438}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{44E}`
};

});

parcelRegister("lsafa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d30af4827a7861e5$export$2e2bcd8739ae039; });
var $d30af4827a7861e5$export$2e2bcd8739ae039 = {};
$d30af4827a7861e5$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{957F}\u{6309}\u{6216}\u{6309} Alt + \u{5411}\u{4E0B}\u{65B9}\u{5411}\u{952E}\u{4EE5}\u{6253}\u{5F00}\u{83DC}\u{5355}`
};

});

parcelRegister("gt4Ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $185417faebbfbbd4$export$2e2bcd8739ae039; });
var $185417faebbfbbd4$export$2e2bcd8739ae039 = {};
$185417faebbfbbd4$export$2e2bcd8739ae039 = {
    "longPressMessage": `\u{9577}\u{6309}\u{6216}\u{6309} Alt+\u{5411}\u{4E0B}\u{9375}\u{4EE5}\u{958B}\u{555F}\u{529F}\u{80FD}\u{8868}`
};

});


parcelRegister("kMGia", function(module, exports) {

$parcel$export(module.exports, "useOverlayTrigger", function () { return $5bd3491ea7040374$export$f9d5c8beee7d008d; });

var $6H0Es = parcelRequire("6H0Es");

var $bh6RR = parcelRequire("bh6RR");

var $gxMV2 = parcelRequire("gxMV2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5bd3491ea7040374$export$f9d5c8beee7d008d(props, state, ref) {
    let { type: type } = props;
    let { isOpen: isOpen } = state;
    (0, $bh6RR.useEffect)(()=>{
        if (ref && ref.current) (0, $6H0Es.onCloseMap).set(ref.current, state.close);
    });
    // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    // However, we only add it for menus for now because screen readers often
    // announce it as a menu even for other values.
    let ariaHasPopup = undefined;
    if (type === 'menu') ariaHasPopup = true;
    else if (type === 'listbox') ariaHasPopup = 'listbox';
    let overlayId = (0, $gxMV2.useId)();
    return {
        triggerProps: {
            'aria-haspopup': ariaHasPopup,
            'aria-expanded': isOpen,
            'aria-controls': isOpen ? overlayId : undefined,
            onPress: state.toggle
        },
        overlayProps: {
            id: overlayId
        }
    };
}

});


parcelRegister("2YwY2", function(module, exports) {

$parcel$export(module.exports, "useMenuTriggerState", function () { return $3538dc81b57d35cd$export$79fefeb1c2091ac3; });

var $l2K9U = parcelRequire("l2K9U");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3538dc81b57d35cd$export$79fefeb1c2091ac3(props) {
    let overlayTriggerState = (0, $l2K9U.useOverlayTriggerState)(props);
    let [focusStrategy, setFocusStrategy] = (0, $bh6RR.useState)(null);
    let [expandedKeysStack, setExpandedKeysStack] = (0, $bh6RR.useState)([]);
    let closeAll = ()=>{
        setExpandedKeysStack([]);
        overlayTriggerState.close();
    };
    let openSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            if (level > oldStack.length) return oldStack;
            return [
                ...oldStack.slice(0, level),
                triggerKey
            ];
        });
    };
    let closeSubmenu = (triggerKey, level)=>{
        setExpandedKeysStack((oldStack)=>{
            let key = oldStack[level];
            if (key === triggerKey) return oldStack.slice(0, level);
            else return oldStack;
        });
    };
    return {
        focusStrategy: focusStrategy,
        ...overlayTriggerState,
        open (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        },
        close () {
            closeAll();
        },
        expandedKeysStack: expandedKeysStack,
        openSubmenu: openSubmenu,
        closeSubmenu: closeSubmenu
    };
}

});

parcelRegister("3P7Fm", function(module, exports) {

$parcel$export(module.exports, "useTreeState", function () { return $abee2f93b1bb0a0e$export$728d6ba534403756; });

var $iJYui = parcelRequire("iJYui");

var $5XVcz = parcelRequire("5XVcz");
var $8K87f = parcelRequire("8K87f");

var $bh6RR = parcelRequire("bh6RR");

var $6ACFn = parcelRequire("6ACFn");

var $ljfvU = parcelRequire("ljfvU");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $abee2f93b1bb0a0e$export$728d6ba534403756(props) {
    let { onExpandedChange: onExpandedChange } = props;
    let [expandedKeys, setExpandedKeys] = (0, $ljfvU.useControlledState)(props.expandedKeys ? new Set(props.expandedKeys) : undefined, props.defaultExpandedKeys ? new Set(props.defaultExpandedKeys) : new Set(), onExpandedChange);
    let selectionState = (0, $8K87f.useMultipleSelectionState)(props);
    let disabledKeys = (0, $bh6RR.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let tree = (0, $6ACFn.useCollection)(props, (0, $bh6RR.useCallback)((nodes)=>new (0, $iJYui.TreeCollection)(nodes, {
            expandedKeys: expandedKeys
        }), [
        expandedKeys
    ]), null);
    (0, $bh6RR.useEffect)(()=>{
        if (selectionState.focusedKey != null && !tree.getItem(selectionState.focusedKey)) selectionState.setFocusedKey(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tree,
        selectionState.focusedKey
    ]);
    let onToggle = (key)=>{
        setExpandedKeys($abee2f93b1bb0a0e$var$$875d6693e12af071$var$toggleKey(expandedKeys, key));
    };
    return {
        collection: tree,
        expandedKeys: expandedKeys,
        disabledKeys: disabledKeys,
        toggleKey: onToggle,
        setExpandedKeys: setExpandedKeys,
        selectionManager: new (0, $5XVcz.SelectionManager)(tree, selectionState)
    };
}
function $abee2f93b1bb0a0e$var$$875d6693e12af071$var$toggleKey(set, key) {
    let res = new Set(set);
    if (res.has(key)) res.delete(key);
    else res.add(key);
    return res;
}

});
parcelRegister("iJYui", function(module, exports) {

$parcel$export(module.exports, "TreeCollection", function () { return $55c5a441aecef2d7$export$863faf230ee2118a; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $55c5a441aecef2d7$export$863faf230ee2118a {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        var _node_prevKey;
        return node ? (_node_prevKey = node.prevKey) !== null && _node_prevKey !== void 0 ? _node_prevKey : null : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        var _node_nextKey;
        return node ? (_node_nextKey = node.nextKey) !== null && _node_nextKey !== void 0 ? _node_nextKey : null : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        var _this_keyMap_get;
        return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    constructor(nodes, { expandedKeys: expandedKeys } = {}){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.iterable = nodes;
        expandedKeys = expandedKeys || new Set();
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && (node.type === 'section' || expandedKeys.has(node.key))) for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last = null;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === 'item') node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        var _last_key;
        this.lastKey = (_last_key = last === null || last === void 0 ? void 0 : last.key) !== null && _last_key !== void 0 ? _last_key : null;
    }
}

});

parcelRegister("5XVcz", function(module, exports) {

$parcel$export(module.exports, "SelectionManager", function () { return $24ecfa917e53ec4b$export$6c8a5aaad13c9852; });

var $kI6Nk = parcelRequire("kI6Nk");

var $6z78f = parcelRequire("6z78f");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $24ecfa917e53ec4b$export$6c8a5aaad13c9852 {
    /**
   * The type of selection that is allowed in the collection.
   */ get selectionMode() {
        return this.state.selectionMode;
    }
    /**
   * Whether the collection allows empty selection.
   */ get disallowEmptySelection() {
        return this.state.disallowEmptySelection;
    }
    /**
   * The selection behavior for the collection.
   */ get selectionBehavior() {
        return this.state.selectionBehavior;
    }
    /**
   * Sets the selection behavior for the collection.
   */ setSelectionBehavior(selectionBehavior) {
        this.state.setSelectionBehavior(selectionBehavior);
    }
    /**
   * Whether the collection is currently focused.
   */ get isFocused() {
        return this.state.isFocused;
    }
    /**
   * Sets whether the collection is focused.
   */ setFocused(isFocused) {
        this.state.setFocused(isFocused);
    }
    /**
   * The current focused key in the collection.
   */ get focusedKey() {
        return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */ get childFocusStrategy() {
        return this.state.childFocusStrategy;
    }
    /**
   * Sets the focused key.
   */ setFocusedKey(key, childFocusStrategy) {
        if (key == null || this.collection.getItem(key)) this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
   * The currently selected keys in the collection.
   */ get selectedKeys() {
        return this.state.selectedKeys === 'all' ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
   * The raw selection value for the collection.
   * Either 'all' for select all, or a set of keys.
   */ get rawSelection() {
        return this.state.selectedKeys;
    }
    /**
   * Returns whether a key is selected.
   */ isSelected(key) {
        if (this.state.selectionMode === 'none') return false;
        let mappedKey = this.getKey(key);
        if (mappedKey == null) return false;
        return this.state.selectedKeys === 'all' ? this.canSelectItem(mappedKey) : this.state.selectedKeys.has(mappedKey);
    }
    /**
   * Whether the selection is empty.
   */ get isEmpty() {
        return this.state.selectedKeys !== 'all' && this.state.selectedKeys.size === 0;
    }
    /**
   * Whether all items in the collection are selected.
   */ get isSelectAll() {
        if (this.isEmpty) return false;
        if (this.state.selectedKeys === 'all') return true;
        if (this._isSelectAll != null) return this._isSelectAll;
        let allKeys = this.getSelectAllKeys();
        let selectedKeys = this.state.selectedKeys;
        this._isSelectAll = allKeys.every((k)=>selectedKeys.has(k));
        return this._isSelectAll;
    }
    get firstSelectedKey() {
        let first = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!first || item && (0, $6z78f.compareNodeOrder)(this.collection, item, first) < 0) first = item;
        }
        var _first_key;
        return (_first_key = first === null || first === void 0 ? void 0 : first.key) !== null && _first_key !== void 0 ? _first_key : null;
    }
    get lastSelectedKey() {
        let last = null;
        for (let key of this.state.selectedKeys){
            let item = this.collection.getItem(key);
            if (!last || item && (0, $6z78f.compareNodeOrder)(this.collection, item, last) > 0) last = item;
        }
        var _last_key;
        return (_last_key = last === null || last === void 0 ? void 0 : last.key) !== null && _last_key !== void 0 ? _last_key : null;
    }
    get disabledKeys() {
        return this.state.disabledKeys;
    }
    get disabledBehavior() {
        return this.state.disabledBehavior;
    }
    /**
   * Extends the selection to the given key.
   */ extendSelection(toKey) {
        if (this.selectionMode === 'none') return;
        if (this.selectionMode === 'single') {
            this.replaceSelection(toKey);
            return;
        }
        let mappedToKey = this.getKey(toKey);
        if (mappedToKey == null) return;
        let selection;
        // Only select the one key if coming from a select all.
        if (this.state.selectedKeys === 'all') selection = new (0, $kI6Nk.Selection)([
            mappedToKey
        ], mappedToKey, mappedToKey);
        else {
            let selectedKeys = this.state.selectedKeys;
            var _selectedKeys_anchorKey;
            let anchorKey = (_selectedKeys_anchorKey = selectedKeys.anchorKey) !== null && _selectedKeys_anchorKey !== void 0 ? _selectedKeys_anchorKey : mappedToKey;
            selection = new (0, $kI6Nk.Selection)(selectedKeys, anchorKey, mappedToKey);
            var _selectedKeys_currentKey;
            for (let key of this.getKeyRange(anchorKey, (_selectedKeys_currentKey = selectedKeys.currentKey) !== null && _selectedKeys_currentKey !== void 0 ? _selectedKeys_currentKey : mappedToKey))selection.delete(key);
            for (let key of this.getKeyRange(mappedToKey, anchorKey))if (this.canSelectItem(key)) selection.add(key);
        }
        this.state.setSelectedKeys(selection);
    }
    getKeyRange(from, to) {
        let fromItem = this.collection.getItem(from);
        let toItem = this.collection.getItem(to);
        if (fromItem && toItem) {
            if ((0, $6z78f.compareNodeOrder)(this.collection, fromItem, toItem) <= 0) return this.getKeyRangeInternal(from, to);
            return this.getKeyRangeInternal(to, from);
        }
        return [];
    }
    getKeyRangeInternal(from, to) {
        var _this_layoutDelegate;
        if ((_this_layoutDelegate = this.layoutDelegate) === null || _this_layoutDelegate === void 0 ? void 0 : _this_layoutDelegate.getKeyRange) return this.layoutDelegate.getKeyRange(from, to);
        let keys = [];
        let key = from;
        while(key != null){
            let item = this.collection.getItem(key);
            if (item && (item.type === 'item' || item.type === 'cell' && this.allowsCellSelection)) keys.push(key);
            if (key === to) return keys;
            key = this.collection.getKeyAfter(key);
        }
        return [];
    }
    getKey(key) {
        let item = this.collection.getItem(key);
        if (!item) return key;
        // If cell selection is allowed, just return the key.
        if (item.type === 'cell' && this.allowsCellSelection) return key;
        // Find a parent item to select
        while(item && item.type !== 'item' && item.parentKey != null)item = this.collection.getItem(item.parentKey);
        if (!item || item.type !== 'item') return null;
        return item.key;
    }
    /**
   * Toggles whether the given key is selected.
   */ toggleSelection(key) {
        if (this.selectionMode === 'none') return;
        if (this.selectionMode === 'single' && !this.isSelected(key)) {
            this.replaceSelection(key);
            return;
        }
        let mappedKey = this.getKey(key);
        if (mappedKey == null) return;
        let keys = new (0, $kI6Nk.Selection)(this.state.selectedKeys === 'all' ? this.getSelectAllKeys() : this.state.selectedKeys);
        if (keys.has(mappedKey)) keys.delete(mappedKey);
        else if (this.canSelectItem(mappedKey)) {
            keys.add(mappedKey);
            keys.anchorKey = mappedKey;
            keys.currentKey = mappedKey;
        }
        if (this.disallowEmptySelection && keys.size === 0) return;
        this.state.setSelectedKeys(keys);
    }
    /**
   * Replaces the selection with only the given key.
   */ replaceSelection(key) {
        if (this.selectionMode === 'none') return;
        let mappedKey = this.getKey(key);
        if (mappedKey == null) return;
        let selection = this.canSelectItem(mappedKey) ? new (0, $kI6Nk.Selection)([
            mappedKey
        ], mappedKey, mappedKey) : new (0, $kI6Nk.Selection)();
        this.state.setSelectedKeys(selection);
    }
    /**
   * Replaces the selection with the given keys.
   */ setSelectedKeys(keys) {
        if (this.selectionMode === 'none') return;
        let selection = new (0, $kI6Nk.Selection)();
        for (let key of keys){
            let mappedKey = this.getKey(key);
            if (mappedKey != null) {
                selection.add(mappedKey);
                if (this.selectionMode === 'single') break;
            }
        }
        this.state.setSelectedKeys(selection);
    }
    getSelectAllKeys() {
        let keys = [];
        let addKeys = (key)=>{
            while(key != null){
                if (this.canSelectItem(key)) {
                    var _getFirstItem;
                    let item = this.collection.getItem(key);
                    if ((item === null || item === void 0 ? void 0 : item.type) === 'item') keys.push(key);
                    var _getFirstItem_key;
                    // Add child keys. If cell selection is allowed, then include item children too.
                    if ((item === null || item === void 0 ? void 0 : item.hasChildNodes) && (this.allowsCellSelection || item.type !== 'item')) addKeys((_getFirstItem_key = (_getFirstItem = (0, $6z78f.getFirstItem)((0, $6z78f.getChildNodes)(item, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key) !== null && _getFirstItem_key !== void 0 ? _getFirstItem_key : null);
                }
                key = this.collection.getKeyAfter(key);
            }
        };
        addKeys(this.collection.getFirstKey());
        return keys;
    }
    /**
   * Selects all items in the collection.
   */ selectAll() {
        if (!this.isSelectAll && this.selectionMode === 'multiple') this.state.setSelectedKeys('all');
    }
    /**
   * Removes all keys from the selection.
   */ clearSelection() {
        if (!this.disallowEmptySelection && (this.state.selectedKeys === 'all' || this.state.selectedKeys.size > 0)) this.state.setSelectedKeys(new (0, $kI6Nk.Selection)());
    }
    /**
   * Toggles between select all and an empty selection.
   */ toggleSelectAll() {
        if (this.isSelectAll) this.clearSelection();
        else this.selectAll();
    }
    select(key, e) {
        if (this.selectionMode === 'none') return;
        if (this.selectionMode === 'single') {
            if (this.isSelected(key) && !this.disallowEmptySelection) this.toggleSelection(key);
            else this.replaceSelection(key);
        } else if (this.selectionBehavior === 'toggle' || e && (e.pointerType === 'touch' || e.pointerType === 'virtual')) this.toggleSelection(key);
        else this.replaceSelection(key);
    }
    /**
   * Returns whether the current selection is equal to the given selection.
   */ isSelectionEqual(selection) {
        if (selection === this.state.selectedKeys) return true;
        // Check if the set of keys match.
        let selectedKeys = this.selectedKeys;
        if (selection.size !== selectedKeys.size) return false;
        for (let key of selection){
            if (!selectedKeys.has(key)) return false;
        }
        for (let key of selectedKeys){
            if (!selection.has(key)) return false;
        }
        return true;
    }
    canSelectItem(key) {
        var _item_props;
        if (this.state.selectionMode === 'none' || this.state.disabledKeys.has(key)) return false;
        let item = this.collection.getItem(key);
        if (!item || (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || item.type === 'cell' && !this.allowsCellSelection) return false;
        return true;
    }
    isDisabled(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return this.state.disabledBehavior === 'all' && (this.state.disabledKeys.has(key) || !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.isDisabled));
    }
    isLink(key) {
        var _this_collection_getItem_props, _this_collection_getItem;
        return !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.href);
    }
    getItemProps(key) {
        var _this_collection_getItem;
        return (_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : _this_collection_getItem.props;
    }
    constructor(collection, state, options){
        this.collection = collection;
        this.state = state;
        var _options_allowsCellSelection;
        this.allowsCellSelection = (_options_allowsCellSelection = options === null || options === void 0 ? void 0 : options.allowsCellSelection) !== null && _options_allowsCellSelection !== void 0 ? _options_allowsCellSelection : false;
        this._isSelectAll = null;
        this.layoutDelegate = (options === null || options === void 0 ? void 0 : options.layoutDelegate) || null;
    }
}

});
parcelRegister("kI6Nk", function(module, exports) {

$parcel$export(module.exports, "Selection", function () { return $914ab8b48b1b382c$export$52baac22726c72bf; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $914ab8b48b1b382c$export$52baac22726c72bf extends Set {
    constructor(keys, anchorKey, currentKey){
        super(keys);
        if (keys instanceof $914ab8b48b1b382c$export$52baac22726c72bf) {
            this.anchorKey = anchorKey !== null && anchorKey !== void 0 ? anchorKey : keys.anchorKey;
            this.currentKey = currentKey !== null && currentKey !== void 0 ? currentKey : keys.currentKey;
        } else {
            this.anchorKey = anchorKey !== null && anchorKey !== void 0 ? anchorKey : null;
            this.currentKey = currentKey !== null && currentKey !== void 0 ? currentKey : null;
        }
    }
}

});


parcelRegister("8K87f", function(module, exports) {

$parcel$export(module.exports, "useMultipleSelectionState", function () { return $4511b7d38918bb49$export$253fe78d46329472; });

var $kI6Nk = parcelRequire("kI6Nk");

var $ljfvU = parcelRequire("ljfvU");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4511b7d38918bb49$var$$7af3f5b51489e0b5$var$equalSets(setA, setB) {
    if (setA.size !== setB.size) return false;
    for (let item of setA){
        if (!setB.has(item)) return false;
    }
    return true;
}
function $4511b7d38918bb49$export$253fe78d46329472(props) {
    let { selectionMode: selectionMode = 'none', disallowEmptySelection: disallowEmptySelection = false, allowDuplicateSelectionEvents: allowDuplicateSelectionEvents, selectionBehavior: selectionBehaviorProp = 'toggle', disabledBehavior: disabledBehavior = 'all' } = props;
    // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
    // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).
    let isFocusedRef = (0, $bh6RR.useRef)(false);
    let [, setFocused] = (0, $bh6RR.useState)(false);
    let focusedKeyRef = (0, $bh6RR.useRef)(null);
    let childFocusStrategyRef = (0, $bh6RR.useRef)(null);
    let [, setFocusedKey] = (0, $bh6RR.useState)(null);
    let selectedKeysProp = (0, $bh6RR.useMemo)(()=>$4511b7d38918bb49$var$$7af3f5b51489e0b5$var$convertSelection(props.selectedKeys), [
        props.selectedKeys
    ]);
    let defaultSelectedKeys = (0, $bh6RR.useMemo)(()=>$4511b7d38918bb49$var$$7af3f5b51489e0b5$var$convertSelection(props.defaultSelectedKeys, new (0, $kI6Nk.Selection)()), [
        props.defaultSelectedKeys
    ]);
    let [selectedKeys, setSelectedKeys] = (0, $ljfvU.useControlledState)(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange);
    let disabledKeysProp = (0, $bh6RR.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let [selectionBehavior, setSelectionBehavior] = (0, $bh6RR.useState)(selectionBehaviorProp);
    // If the selectionBehavior prop is set to replace, but the current state is toggle (e.g. due to long press
    // to enter selection mode on touch), and the selection becomes empty, reset the selection behavior.
    if (selectionBehaviorProp === 'replace' && selectionBehavior === 'toggle' && typeof selectedKeys === 'object' && selectedKeys.size === 0) setSelectionBehavior('replace');
    // If the selectionBehavior prop changes, update the state as well.
    let lastSelectionBehavior = (0, $bh6RR.useRef)(selectionBehaviorProp);
    (0, $bh6RR.useEffect)(()=>{
        if (selectionBehaviorProp !== lastSelectionBehavior.current) {
            setSelectionBehavior(selectionBehaviorProp);
            lastSelectionBehavior.current = selectionBehaviorProp;
        }
    }, [
        selectionBehaviorProp
    ]);
    return {
        selectionMode: selectionMode,
        disallowEmptySelection: disallowEmptySelection,
        selectionBehavior: selectionBehavior,
        setSelectionBehavior: setSelectionBehavior,
        get isFocused () {
            return isFocusedRef.current;
        },
        setFocused (f) {
            isFocusedRef.current = f;
            setFocused(f);
        },
        get focusedKey () {
            return focusedKeyRef.current;
        },
        get childFocusStrategy () {
            return childFocusStrategyRef.current;
        },
        setFocusedKey (k, childFocusStrategy = 'first') {
            focusedKeyRef.current = k;
            childFocusStrategyRef.current = childFocusStrategy;
            setFocusedKey(k);
        },
        selectedKeys: selectedKeys,
        setSelectedKeys (keys) {
            if (allowDuplicateSelectionEvents || !$4511b7d38918bb49$var$$7af3f5b51489e0b5$var$equalSets(keys, selectedKeys)) setSelectedKeys(keys);
        },
        disabledKeys: disabledKeysProp,
        disabledBehavior: disabledBehavior
    };
}
function $4511b7d38918bb49$var$$7af3f5b51489e0b5$var$convertSelection(selection, defaultValue) {
    if (!selection) return defaultValue;
    return selection === 'all' ? 'all' : new (0, $kI6Nk.Selection)(selection);
}

});

parcelRegister("6ACFn", function(module, exports) {

$parcel$export(module.exports, "useCollection", function () { return $961b4ee15e93548b$export$6cd28814d92fa9c9; });

var $de7LE = parcelRequire("de7LE");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $961b4ee15e93548b$export$6cd28814d92fa9c9(props, factory, context) {
    let builder = (0, $bh6RR.useMemo)(()=>new (0, $de7LE.CollectionBuilder)(), []);
    let { children: children, items: items, collection: collection } = props;
    let result = (0, $bh6RR.useMemo)(()=>{
        if (collection) return collection;
        let nodes = builder.build({
            children: children,
            items: items
        }, context);
        return factory(nodes);
    }, [
        builder,
        children,
        items,
        collection,
        context,
        factory
    ]);
    return result;
}

});
parcelRegister("de7LE", function(module, exports) {

$parcel$export(module.exports, "CollectionBuilder", function () { return $09d5b200675a5753$export$bf788dd355e3a401; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $09d5b200675a5753$export$bf788dd355e3a401 {
    build(props, context) {
        this.context = context;
        return $09d5b200675a5753$var$$eb2240fc39a57fa5$var$iterable(()=>this.iterateCollection(props));
    }
    *iterateCollection(props) {
        let { children: children, items: items } = props;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).isValidElement(children) && children.type === (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment) yield* this.iterateCollection({
            children: children.props.children,
            items: items
        });
        else if (typeof children === 'function') {
            if (!items) throw new Error('props.children was a function but props.items is missing');
            let index = 0;
            for (let item of items){
                yield* this.getFullNode({
                    value: item,
                    index: index
                }, {
                    renderer: children
                });
                index++;
            }
        } else {
            let items = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.forEach(children, (child)=>{
                if (child) items.push(child);
            });
            let index = 0;
            for (let item of items){
                let nodes = this.getFullNode({
                    element: item,
                    index: index
                }, {});
                for (let node of nodes){
                    index++;
                    yield node;
                }
            }
        }
    }
    getKey(item, partialNode, state, parentKey) {
        if (item.key != null) return item.key;
        if (partialNode.type === 'cell' && partialNode.key != null) return `${parentKey}${partialNode.key}`;
        let v = partialNode.value;
        if (v != null) {
            var _v_key;
            let key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
            if (key == null) throw new Error('No key found for item');
            return key;
        }
        return parentKey ? `${parentKey}.${partialNode.index}` : `$.${partialNode.index}`;
    }
    getChildState(state, partialNode) {
        return {
            renderer: partialNode.renderer || state.renderer
        };
    }
    *getFullNode(partialNode, state, parentKey, parentNode) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).isValidElement(partialNode.element) && partialNode.element.type === (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment) {
            let children = [];
            (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.forEach(partialNode.element.props.children, (child)=>{
                children.push(child);
            });
            var _partialNode_index;
            let index = (_partialNode_index = partialNode.index) !== null && _partialNode_index !== void 0 ? _partialNode_index : 0;
            for (const child of children)yield* this.getFullNode({
                element: child,
                index: index++
            }, state, parentKey, parentNode);
            return;
        }
        // If there's a value instead of an element on the node, and a parent renderer function is available,
        // use it to render an element for the value.
        let element = partialNode.element;
        if (!element && partialNode.value && state && state.renderer) {
            let cached = this.cache.get(partialNode.value);
            if (cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context))) {
                cached.index = partialNode.index;
                cached.parentKey = parentNode ? parentNode.key : null;
                yield cached;
                return;
            }
            element = state.renderer(partialNode.value);
        }
        // If there's an element with a getCollectionNode function on its type, then it's a supported component.
        // Call this function to get a partial node, and recursively build a full node from there.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).isValidElement(element)) {
            let type = element.type;
            if (typeof type !== 'function' && typeof type.getCollectionNode !== 'function') {
                let name = element.type;
                throw new Error(`Unknown element <${name}> in collection.`);
            }
            let childNodes = type.getCollectionNode(element.props, this.context);
            var _partialNode_index1;
            let index = (_partialNode_index1 = partialNode.index) !== null && _partialNode_index1 !== void 0 ? _partialNode_index1 : 0;
            let result = childNodes.next();
            while(!result.done && result.value){
                let childNode = result.value;
                partialNode.index = index;
                var _childNode_key;
                let nodeKey = (_childNode_key = childNode.key) !== null && _childNode_key !== void 0 ? _childNode_key : null;
                if (nodeKey == null) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
                let nodes = this.getFullNode({
                    ...childNode,
                    key: nodeKey,
                    index: index,
                    wrapper: $09d5b200675a5753$var$$eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
                }, this.getChildState(state, childNode), parentKey ? `${parentKey}${element.key}` : element.key, parentNode);
                let children = [
                    ...nodes
                ];
                for (let node of children){
                    var _childNode_value, _ref;
                    // Cache the node based on its value
                    node.value = (_ref = (_childNode_value = childNode.value) !== null && _childNode_value !== void 0 ? _childNode_value : partialNode.value) !== null && _ref !== void 0 ? _ref : null;
                    if (node.value) this.cache.set(node.value, node);
                    var _parentNode_type;
                    // The partial node may have specified a type for the child in order to specify a constraint.
                    // Verify that the full node that was built recursively matches this type.
                    if (partialNode.type && node.type !== partialNode.type) throw new Error(`Unsupported type <${$09d5b200675a5753$var$$eb2240fc39a57fa5$var$capitalize(node.type)}> in <${$09d5b200675a5753$var$$eb2240fc39a57fa5$var$capitalize((_parentNode_type = parentNode === null || parentNode === void 0 ? void 0 : parentNode.type) !== null && _parentNode_type !== void 0 ? _parentNode_type : 'unknown parent type')}>. Only <${$09d5b200675a5753$var$$eb2240fc39a57fa5$var$capitalize(partialNode.type)}> is supported.`);
                    index++;
                    yield node;
                }
                result = childNodes.next(children);
            }
            return;
        }
        // Ignore invalid elements
        if (partialNode.key == null || partialNode.type == null) return;
        // Create full node
        let builder = this;
        var _partialNode_value, _partialNode_textValue;
        let node = {
            type: partialNode.type,
            props: partialNode.props,
            key: partialNode.key,
            parentKey: parentNode ? parentNode.key : null,
            value: (_partialNode_value = partialNode.value) !== null && _partialNode_value !== void 0 ? _partialNode_value : null,
            level: parentNode ? parentNode.level + 1 : 0,
            index: partialNode.index,
            rendered: partialNode.rendered,
            textValue: (_partialNode_textValue = partialNode.textValue) !== null && _partialNode_textValue !== void 0 ? _partialNode_textValue : '',
            'aria-label': partialNode['aria-label'],
            wrapper: partialNode.wrapper,
            shouldInvalidate: partialNode.shouldInvalidate,
            hasChildNodes: partialNode.hasChildNodes || false,
            childNodes: $09d5b200675a5753$var$$eb2240fc39a57fa5$var$iterable(function*() {
                if (!partialNode.hasChildNodes || !partialNode.childNodes) return;
                let index = 0;
                for (let child of partialNode.childNodes()){
                    // Ensure child keys are globally unique by prepending the parent node's key
                    if (child.key != null) // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                    // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                    // children having a key of `abc`.
                    child.key = `${node.key}${child.key}`;
                    let nodes = builder.getFullNode({
                        ...child,
                        index: index
                    }, builder.getChildState(state, child), node.key, node);
                    for (let node of nodes){
                        index++;
                        yield node;
                    }
                }
            })
        };
        yield node;
    }
    constructor(){
        this.cache = new WeakMap();
    }
}
// Wraps an iterator function as an iterable object, and caches the results.
function $09d5b200675a5753$var$$eb2240fc39a57fa5$var$iterable(iterator) {
    let cache = [];
    let iterable = null;
    return {
        *[Symbol.iterator] () {
            for (let item of cache)yield item;
            if (!iterable) iterable = iterator();
            for (let item of iterable){
                cache.push(item);
                yield item;
            }
        }
    };
}
function $09d5b200675a5753$var$$eb2240fc39a57fa5$var$compose(outer, inner) {
    if (outer && inner) return (element)=>outer(inner(element));
    if (outer) return outer;
    if (inner) return inner;
}
function $09d5b200675a5753$var$$eb2240fc39a57fa5$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}

});



parcelRegister("5UBZb", function(module, exports) {

$parcel$export(module.exports, "useSubmenuTriggerState", function () { return $162721d869e50f80$export$cfc51cf86138bf98; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $162721d869e50f80$export$cfc51cf86138bf98(props, state) {
    let { triggerKey: triggerKey } = props;
    let { expandedKeysStack: expandedKeysStack, openSubmenu: openSubmenu, closeSubmenu: closeSubmenu, close: closeAll } = state;
    let [submenuLevel] = (0, $bh6RR.useState)(expandedKeysStack === null || expandedKeysStack === void 0 ? void 0 : expandedKeysStack.length);
    let isOpen = (0, $bh6RR.useMemo)(()=>expandedKeysStack[submenuLevel] === triggerKey, [
        expandedKeysStack,
        triggerKey,
        submenuLevel
    ]);
    let [focusStrategy, setFocusStrategy] = (0, $bh6RR.useState)(null);
    let open = (0, $bh6RR.useCallback)((focusStrategy)=>{
        setFocusStrategy(focusStrategy !== null && focusStrategy !== void 0 ? focusStrategy : null);
        openSubmenu(triggerKey, submenuLevel);
    }, [
        openSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let close = (0, $bh6RR.useCallback)(()=>{
        setFocusStrategy(null);
        closeSubmenu(triggerKey, submenuLevel);
    }, [
        closeSubmenu,
        submenuLevel,
        triggerKey
    ]);
    let toggle = (0, $bh6RR.useCallback)((focusStrategy)=>{
        setFocusStrategy(focusStrategy !== null && focusStrategy !== void 0 ? focusStrategy : null);
        if (isOpen) close();
        else open(focusStrategy);
    }, [
        close,
        open,
        isOpen
    ]);
    return (0, $bh6RR.useMemo)(()=>({
            focusStrategy: focusStrategy,
            isOpen: isOpen,
            open: open,
            close: close,
            closeAll: closeAll,
            submenuLevel: submenuLevel,
            // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
            // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
            setOpen: ()=>{},
            toggle: toggle
        }), [
        isOpen,
        open,
        close,
        closeAll,
        focusStrategy,
        toggle,
        submenuLevel
    ]);
}

});

parcelRegister("jA5nP", function(module, exports) {

$parcel$export(module.exports, "useSubmenuTrigger", function () { return $09adcff5f7245e06$export$7138b0d059a6e743; });

var $6YCNf = parcelRequire("6YCNf");

var $bh6RR = parcelRequire("bh6RR");

var $i7SiA = parcelRequire("i7SiA");
var $gxMV2 = parcelRequire("gxMV2");
var $f2PTm = parcelRequire("f2PTm");

var $c8uzR = parcelRequire("c8uzR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $09adcff5f7245e06$export$7138b0d059a6e743(props, state, ref) {
    let { parentMenuRef: parentMenuRef, submenuRef: submenuRef, type: type = 'menu', isDisabled: isDisabled, delay: delay = 200 } = props;
    let submenuTriggerId = (0, $gxMV2.useId)();
    let overlayId = (0, $gxMV2.useId)();
    let { direction: direction } = (0, $c8uzR.useLocale)();
    let openTimeout = (0, $bh6RR.useRef)(undefined);
    let cancelOpenTimeout = (0, $bh6RR.useCallback)(()=>{
        if (openTimeout.current) {
            clearTimeout(openTimeout.current);
            openTimeout.current = undefined;
        }
    }, [
        openTimeout
    ]);
    let onSubmenuOpen = (0, $i7SiA.useEffectEvent)((focusStrategy)=>{
        cancelOpenTimeout();
        state.open(focusStrategy);
    });
    let onSubmenuClose = (0, $i7SiA.useEffectEvent)(()=>{
        cancelOpenTimeout();
        state.close();
    });
    (0, $f2PTm.useLayoutEffect)(()=>{
        return ()=>{
            cancelOpenTimeout();
        };
    }, [
        cancelOpenTimeout
    ]);
    let submenuKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowLeft':
                if (direction === 'ltr' && e.currentTarget.contains(e.target)) {
                    var _ref_current;
                    e.stopPropagation();
                    onSubmenuClose();
                    (_ref_current = ref.current) === null || _ref_current === void 0 || _ref_current.focus();
                }
                break;
            case 'ArrowRight':
                if (direction === 'rtl' && e.currentTarget.contains(e.target)) {
                    var _ref_current1;
                    e.stopPropagation();
                    onSubmenuClose();
                    (_ref_current1 = ref.current) === null || _ref_current1 === void 0 || _ref_current1.focus();
                }
                break;
            case 'Escape':
                e.stopPropagation();
                state.closeAll();
                break;
        }
    };
    var _state_focusStrategy;
    let submenuProps = {
        id: overlayId,
        'aria-labelledby': submenuTriggerId,
        submenuLevel: state.submenuLevel,
        ...type === 'menu' && {
            onClose: state.closeAll,
            autoFocus: (_state_focusStrategy = state.focusStrategy) !== null && _state_focusStrategy !== void 0 ? _state_focusStrategy : undefined,
            onKeyDown: submenuKeyDown
        }
    };
    let submenuTriggerKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowRight':
                if (!isDisabled) {
                    if (direction === 'ltr') {
                        if (!state.isOpen) onSubmenuOpen('first');
                        if (type === 'menu' && !!(submenuRef === null || submenuRef === void 0 ? void 0 : submenuRef.current) && document.activeElement === (ref === null || ref === void 0 ? void 0 : ref.current)) submenuRef.current.focus();
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            case 'ArrowLeft':
                if (!isDisabled) {
                    if (direction === 'rtl') {
                        if (!state.isOpen) onSubmenuOpen('first');
                        if (type === 'menu' && !!(submenuRef === null || submenuRef === void 0 ? void 0 : submenuRef.current) && document.activeElement === (ref === null || ref === void 0 ? void 0 : ref.current)) submenuRef.current.focus();
                    } else if (state.isOpen) onSubmenuClose();
                    else e.continuePropagation();
                }
                break;
            case 'Escape':
                state.closeAll();
                break;
            default:
                e.continuePropagation();
                break;
        }
    };
    let onPressStart = (e)=>{
        if (!isDisabled && (e.pointerType === 'virtual' || e.pointerType === 'keyboard')) onSubmenuOpen('first');
    };
    let onPress = (e)=>{
        if (!isDisabled && (e.pointerType === 'touch' || e.pointerType === 'mouse')) // press up happening on the newly opened tray items
        onSubmenuOpen();
    };
    let onHoverChange = (isHovered)=>{
        if (!isDisabled) {
            if (isHovered && !state.isOpen) {
                if (!openTimeout.current) openTimeout.current = setTimeout(()=>{
                    onSubmenuOpen();
                }, delay);
            } else if (!isHovered) cancelOpenTimeout();
        }
    };
    let onBlur = (e)=>{
        var _parentMenuRef_current;
        if (state.isOpen && ((_parentMenuRef_current = parentMenuRef.current) === null || _parentMenuRef_current === void 0 ? void 0 : _parentMenuRef_current.contains(e.relatedTarget))) onSubmenuClose();
    };
    let shouldCloseOnInteractOutside = (target)=>{
        if (target !== ref.current) return true;
        return false;
    };
    (0, $6YCNf.useSafelyMouseToSubmenu)({
        menuRef: parentMenuRef,
        submenuRef: submenuRef,
        isOpen: state.isOpen,
        isDisabled: isDisabled
    });
    return {
        submenuTriggerProps: {
            id: submenuTriggerId,
            'aria-controls': state.isOpen ? overlayId : undefined,
            'aria-haspopup': !isDisabled ? type : undefined,
            'aria-expanded': state.isOpen ? 'true' : 'false',
            onPressStart: onPressStart,
            onPress: onPress,
            onHoverChange: onHoverChange,
            onKeyDown: submenuTriggerKeyDown,
            onBlur: onBlur,
            isOpen: state.isOpen
        },
        submenuProps: submenuProps,
        popoverProps: {
            isNonModal: true,
            disableFocusManagement: true,
            shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
        }
    };
}

});
parcelRegister("6YCNf", function(module, exports) {

$parcel$export(module.exports, "useSafelyMouseToSubmenu", function () { return $854002fc0908ae5f$export$85ec83e04c95f50a; });

var $bh6RR = parcelRequire("bh6RR");

var $8tXMg = parcelRequire("8tXMg");

var $7KwSx = parcelRequire("7KwSx");
const $854002fc0908ae5f$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS = 2;
const $854002fc0908ae5f$var$$d275435c250248f8$var$THROTTLE_TIME = 50;
const $854002fc0908ae5f$var$$d275435c250248f8$var$TIMEOUT_TIME = 1000;
const $854002fc0908ae5f$var$$d275435c250248f8$var$ANGLE_PADDING = Math.PI / 12; // 15°
function $854002fc0908ae5f$export$85ec83e04c95f50a(options) {
    let { menuRef: menuRef, submenuRef: submenuRef, isOpen: isOpen, isDisabled: isDisabled } = options;
    let prevPointerPos = (0, $bh6RR.useRef)(undefined);
    let submenuRect = (0, $bh6RR.useRef)(undefined);
    let lastProcessedTime = (0, $bh6RR.useRef)(0);
    let timeout = (0, $bh6RR.useRef)(undefined);
    let autoCloseTimeout = (0, $bh6RR.useRef)(undefined);
    let submenuSide = (0, $bh6RR.useRef)(undefined);
    let movementsTowardsSubmenuCount = (0, $bh6RR.useRef)(2);
    let [preventPointerEvents, setPreventPointerEvents] = (0, $bh6RR.useState)(false);
    let updateSubmenuRect = ()=>{
        if (submenuRef.current) {
            submenuRect.current = submenuRef.current.getBoundingClientRect();
            submenuSide.current = undefined;
        }
    };
    (0, $7KwSx.useResizeObserver)({
        ref: submenuRef,
        onResize: updateSubmenuRect
    });
    let reset = ()=>{
        setPreventPointerEvents(false);
        movementsTowardsSubmenuCount.current = $854002fc0908ae5f$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS;
        prevPointerPos.current = undefined;
    };
    let modality = (0, $8tXMg.useInteractionModality)();
    (0, $bh6RR.useEffect)(()=>{
        if (preventPointerEvents && menuRef.current) menuRef.current.style.pointerEvents = 'none';
        else menuRef.current.style.pointerEvents = '';
    }, [
        menuRef,
        preventPointerEvents
    ]);
    (0, $bh6RR.useEffect)(()=>{
        let submenu = submenuRef.current;
        let menu = menuRef.current;
        if (isDisabled || !submenu || !isOpen || modality !== 'pointer' || !menu) {
            reset();
            return;
        }
        submenuRect.current = submenu.getBoundingClientRect();
        let onPointerMove = (e)=>{
            if (e.pointerType === 'touch' || e.pointerType === 'pen') return;
            let currentTime = Date.now();
            // Throttle
            if (currentTime - lastProcessedTime.current < $854002fc0908ae5f$var$$d275435c250248f8$var$THROTTLE_TIME) return;
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            let { clientX: mouseX, clientY: mouseY } = e;
            if (!prevPointerPos.current) {
                prevPointerPos.current = {
                    x: mouseX,
                    y: mouseY
                };
                return;
            }
            if (!submenuRect.current) return;
            if (!submenuSide.current) submenuSide.current = mouseX > submenuRect.current.right ? 'left' : 'right';
            // Pointer is outside of parent menu
            if (mouseX < menu.getBoundingClientRect().left || mouseX > menu.getBoundingClientRect().right || mouseY < menu.getBoundingClientRect().top || mouseY > menu.getBoundingClientRect().bottom) {
                reset();
                return;
            }
            /* Check if pointer is moving towards submenu.
        Uses the 2-argument arctangent (https://en.wikipedia.org/wiki/Atan2) to calculate:
          - angle between previous pointer and top of submenu
          - angle between previous pointer and bottom of submenu
          - angle between previous pointer and current pointer (delta)
        If the pointer delta angle value is between the top and bottom angle values, we know the pointer is moving towards the submenu.
      */ let prevMouseX = prevPointerPos.current.x;
            let prevMouseY = prevPointerPos.current.y;
            let toSubmenuX = submenuSide.current === 'right' ? submenuRect.current.left - prevMouseX : prevMouseX - submenuRect.current.right;
            let angleTop = Math.atan2(prevMouseY - submenuRect.current.top, toSubmenuX) + $854002fc0908ae5f$var$$d275435c250248f8$var$ANGLE_PADDING;
            let angleBottom = Math.atan2(prevMouseY - submenuRect.current.bottom, toSubmenuX) - $854002fc0908ae5f$var$$d275435c250248f8$var$ANGLE_PADDING;
            let anglePointer = Math.atan2(prevMouseY - mouseY, submenuSide.current === 'left' ? -(mouseX - prevMouseX) : mouseX - prevMouseX);
            let isMovingTowardsSubmenu = anglePointer < angleTop && anglePointer > angleBottom;
            movementsTowardsSubmenuCount.current = isMovingTowardsSubmenu ? Math.min(movementsTowardsSubmenuCount.current + 1, $854002fc0908ae5f$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS) : Math.max(movementsTowardsSubmenuCount.current - 1, 0);
            if (movementsTowardsSubmenuCount.current >= $854002fc0908ae5f$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS) setPreventPointerEvents(true);
            else setPreventPointerEvents(false);
            lastProcessedTime.current = currentTime;
            prevPointerPos.current = {
                x: mouseX,
                y: mouseY
            };
            // If the pointer is moving towards the submenu, start a timeout to close if no other movements are made after 500ms.
            if (isMovingTowardsSubmenu) timeout.current = setTimeout(()=>{
                reset();
                autoCloseTimeout.current = setTimeout(()=>{
                    // Fire a pointerover event to trigger the menu to close.
                    // Wait until pointer-events:none is no longer applied
                    let target = document.elementFromPoint(mouseX, mouseY);
                    if (target && menu.contains(target)) target.dispatchEvent(new PointerEvent('pointerover', {
                        bubbles: true,
                        cancelable: true
                    }));
                }, 100);
            }, $854002fc0908ae5f$var$$d275435c250248f8$var$TIMEOUT_TIME);
        };
        window.addEventListener('pointermove', onPointerMove);
        return ()=>{
            window.removeEventListener('pointermove', onPointerMove);
            clearTimeout(timeout.current);
            clearTimeout(autoCloseTimeout.current);
            movementsTowardsSubmenuCount.current = $854002fc0908ae5f$var$$d275435c250248f8$var$ALLOWED_INVALID_MOVEMENTS;
        };
    }, [
        isDisabled,
        isOpen,
        menuRef,
        modality,
        setPreventPointerEvents,
        submenuRef
    ]);
}

});



parcelRegister("a87Wk", function(module, exports) {

$parcel$export(module.exports, "useDialog", function () { return $5d6b64cc35a46685$export$d55e7ee900f34e93; });

var $bG0JH = parcelRequire("bG0JH");
var $gxMV2 = parcelRequire("gxMV2");

var $bQDsd = parcelRequire("bQDsd");

var $bh6RR = parcelRequire("bh6RR");

var $aAM1f = parcelRequire("aAM1f");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5d6b64cc35a46685$export$d55e7ee900f34e93(props, ref) {
    let { role: role = 'dialog' } = props;
    let titleId = (0, $gxMV2.useSlotId)();
    titleId = props['aria-label'] ? undefined : titleId;
    let isRefocusing = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        if (ref.current && !ref.current.contains(document.activeElement)) {
            (0, $bQDsd.focusSafely)(ref.current);
            // Safari on iOS does not move the VoiceOver cursor to the dialog
            // or announce that it has opened until it has rendered. A workaround
            // is to wait for half a second, then blur and re-focus the dialog.
            let timeout = setTimeout(()=>{
                if (document.activeElement === ref.current) {
                    isRefocusing.current = true;
                    if (ref.current) {
                        ref.current.blur();
                        (0, $bQDsd.focusSafely)(ref.current);
                    }
                    isRefocusing.current = false;
                }
            }, 500);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        ref
    ]);
    (0, $aAM1f.useOverlayFocusContain)();
    // We do not use aria-modal due to a Safari bug which forces the first focusable element to be focused
    // on mount when inside an iframe, no matter which element we programmatically focus.
    // See https://bugs.webkit.org/show_bug.cgi?id=211934.
    // useModal sets aria-hidden on all elements outside the dialog, so the dialog will behave as a modal
    // even without aria-modal on the dialog itself.
    return {
        dialogProps: {
            ...(0, $bG0JH.filterDOMProps)(props, {
                labelable: true
            }),
            role: role,
            tabIndex: -1,
            'aria-labelledby': props['aria-labelledby'] || titleId,
            // Prevent blur events from reaching useOverlay, which may cause
            // popovers to close. Since focus is contained within the dialog,
            // we don't want this to occur due to the above useEffect.
            onBlur: (e)=>{
                if (isRefocusing.current) e.stopPropagation();
            }
        },
        titleProps: {
            id: titleId
        }
    };
}

});


parcelRegister("8Nljb", function(module, exports) {

$parcel$export(module.exports, "transactionsWithAccounts", function () { return $dafe5574145b0e4c$export$d932f25aa031d653; });
$parcel$export(module.exports, "chartableData", function () { return $dafe5574145b0e4c$export$aaacb79d54303c9a; });
$parcel$export(module.exports, "transactionsInTimeline", function () { return $dafe5574145b0e4c$export$cf145a816d60ccc5; });
$parcel$export(module.exports, "transactionsByAccountId", function () { return $dafe5574145b0e4c$export$cce9b95417f7b379; });

var $25W9h = parcelRequire("25W9h");
parcelRequire("9St7S");
var $1rr1p = parcelRequire("1rr1p");

var $qqvI6 = parcelRequire("qqvI6");

var $7uN6s = parcelRequire("7uN6s");

var $gg4T5 = parcelRequire("gg4T5");

var $hBIc7 = parcelRequire("hBIc7");
const $dafe5574145b0e4c$export$c8f02353e2547bc9 = (0, $1rr1p.createSelector)((0, $qqvI6.schema).chartRange.select, (0, $qqvI6.schema).transactions.selectTableAsList, (chartRange, transactions)=>transactions.map((transaction)=>{
        if (transaction.rtype === 'none') return {
            ...transaction,
            seedDate: (0, $25W9h.default)(transaction.start),
            occurredInSeed: 0
        };
        const nextTransactionFn = (0, $7uN6s.nextTransaction)(transaction.rtype);
        const { date: date, occurred: occurredInSeed } = (0, $gg4T5.findSeed)({
            transaction: transaction,
            y: transaction.value,
            date: (0, $25W9h.default)(transaction.start),
            nextTransactionFn: nextTransactionFn,
            interval: chartRange,
            occurred: 0
        });
        return {
            ...transaction,
            seedDate: date,
            occurredInSeed: occurredInSeed
        };
    }));
const $dafe5574145b0e4c$export$d932f25aa031d653 = (0, $1rr1p.createSelector)((0, $qqvI6.schema).accounts.selectTable, $dafe5574145b0e4c$export$c8f02353e2547bc9, (accounts, transactions)=>{
    const tA = transactions.map((t)=>{
        const account = accounts?.[t.raccount] ?? {
            name: t.raccount
        };
        const accountTransferIn = !t.transferIn ? null : accounts?.[t.transferIn] ?? {
            name: t.transferIn
        };
        const merged = {
            ...t,
            raccount: account.name,
            raccountMeta: account,
            ...accountTransferIn ? {
                transferIn: accountTransferIn.name,
                transferInMeta: accountTransferIn
            } : {}
        };
        return merged;
    });
    return tA;
});
const $dafe5574145b0e4c$export$aaacb79d54303c9a = (0, $1rr1p.createSelector)((0, $hBIc7.eachDay), $dafe5574145b0e4c$export$d932f25aa031d653, (allDates, transactions)=>{
    return transactions.map((transaction)=>{
        const { data: data, allTransactionEvents: allTransactionEvents } = (0, $gg4T5.extrapolateTransactionOccurrences)({
            transaction: transaction,
            allDates: allDates
        });
        return {
            transaction: transaction,
            data: data,
            allTransactionEvents: allTransactionEvents
        };
    });
});
const $dafe5574145b0e4c$export$cf145a816d60ccc5 = (0, $1rr1p.createSelector)((0, $hBIc7.eachDay), $dafe5574145b0e4c$export$aaacb79d54303c9a, (allDates, transactionsWithStacks)=>{
    const datesWithTransactions = allDates.map((date)=>{
        const thisDay = {
            date: date,
            transactions: []
        };
        for (const transaction of transactionsWithStacks)if (transaction.allTransactionEvents.includes(date)) thisDay.transactions.push(transaction.transaction);
        return thisDay;
    });
    return datesWithTransactions;
});
const $dafe5574145b0e4c$export$cce9b95417f7b379 = (0, $1rr1p.createSelector)($dafe5574145b0e4c$export$d932f25aa031d653, (_, id)=>id, (transactions, accountId)=>{
    const transactionsByAccount = transactions.filter((t)=>{
        return t.raccountMeta.id === accountId || t.transferInMeta?.id === accountId;
    });
    return transactionsByAccount;
});

});
parcelRegister("25W9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1869277eefbd126c$export$2e2bcd8739ae039; });

var $6QTFS = parcelRequire("6QTFS");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $1869277eefbd126c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $6RzIO.default)(1, arguments);
    var additionalDigits = (0, $8d3vD.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $1869277eefbd126c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $1869277eefbd126c$var$parseYear(dateStrings.date, additionalDigits);
        date = $1869277eefbd126c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $1869277eefbd126c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $1869277eefbd126c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $1869277eefbd126c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $1869277eefbd126c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $1869277eefbd126c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $1869277eefbd126c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $1869277eefbd126c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($1869277eefbd126c$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($1869277eefbd126c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($1869277eefbd126c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $1869277eefbd126c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1869277eefbd126c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $1869277eefbd126c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($1869277eefbd126c$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $1869277eefbd126c$var$parseDateUnit(captures[1]);
    var month = $1869277eefbd126c$var$parseDateUnit(captures[2]) - 1;
    var day = $1869277eefbd126c$var$parseDateUnit(captures[3]);
    var week = $1869277eefbd126c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $1869277eefbd126c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$1869277eefbd126c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1869277eefbd126c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$1869277eefbd126c$var$validateDate(year, month, day) || !$1869277eefbd126c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $1869277eefbd126c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $1869277eefbd126c$var$parseTime(timeString) {
    var captures = timeString.match($1869277eefbd126c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $1869277eefbd126c$var$parseTimeUnit(captures[1]);
    var minutes = $1869277eefbd126c$var$parseTimeUnit(captures[2]);
    var seconds = $1869277eefbd126c$var$parseTimeUnit(captures[3]);
    if (!$1869277eefbd126c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $6QTFS.millisecondsInHour) + minutes * (0, $6QTFS.millisecondsInMinute) + seconds * 1000;
}
function $1869277eefbd126c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $1869277eefbd126c$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($1869277eefbd126c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$1869277eefbd126c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $6QTFS.millisecondsInHour) + minutes * (0, $6QTFS.millisecondsInMinute));
}
function $1869277eefbd126c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $1869277eefbd126c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1869277eefbd126c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1869277eefbd126c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($1869277eefbd126c$var$daysInMonths[month] || ($1869277eefbd126c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $1869277eefbd126c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($1869277eefbd126c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $1869277eefbd126c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $1869277eefbd126c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $1869277eefbd126c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});
parcelRegister("6QTFS", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", function () { return $4fd2c93311e78e29$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $4fd2c93311e78e29$export$7f72910d6dfd237a; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $4fd2c93311e78e29$export$397c2d5776aa9055; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4fd2c93311e78e29$export$dfd9b671c89acc8e = 7;
var $4fd2c93311e78e29$export$3913210603d8e9ae = 365.2425;
var $4fd2c93311e78e29$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4fd2c93311e78e29$export$91246f0b9bd9beff = 60000;
var $4fd2c93311e78e29$export$7f72910d6dfd237a = 3600000;
var $4fd2c93311e78e29$export$397c2d5776aa9055 = 1000;
var $4fd2c93311e78e29$export$4dec998e48f9c246 = -$4fd2c93311e78e29$export$81caae6e1cc7a622;
var $4fd2c93311e78e29$export$f2f5ae5a8e2d8f9f = 60;
var $4fd2c93311e78e29$export$3c58128db900d44e = 3;
var $4fd2c93311e78e29$export$80d7e435f744f319 = 12;
var $4fd2c93311e78e29$export$4db7641526e3241f = 4;
var $4fd2c93311e78e29$export$698aec755e92c695 = 3600;
var $4fd2c93311e78e29$export$a77c1a7ebebe2a5a = 60;
var $4fd2c93311e78e29$export$815a9362476d2fe3 = $4fd2c93311e78e29$export$698aec755e92c695 * 24;
var $4fd2c93311e78e29$export$34804a017b31e2fe = $4fd2c93311e78e29$export$815a9362476d2fe3 * 7;
var $4fd2c93311e78e29$export$7271e9e3478110d1 = $4fd2c93311e78e29$export$815a9362476d2fe3 * $4fd2c93311e78e29$export$3913210603d8e9ae;
var $4fd2c93311e78e29$export$8e6600bbdee7dabb = $4fd2c93311e78e29$export$7271e9e3478110d1 / 12;
var $4fd2c93311e78e29$export$be1dccf2de902d31 = $4fd2c93311e78e29$export$8e6600bbdee7dabb * 3;

});

parcelRegister("6RzIO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ff366e58c33ccee$export$2e2bcd8739ae039; });
function $4ff366e58c33ccee$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});

parcelRegister("8d3vD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fa2427dbbbb369e$export$2e2bcd8739ae039; });
function $5fa2427dbbbb369e$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});


parcelRegister("7uN6s", function(module, exports) {

$parcel$export(module.exports, "nextTransaction", function () { return $9a82590a240327ee$export$f861cde01703a24e; });
$parcel$export(module.exports, "transactionCompute", function () { return $9a82590a240327ee$export$6087fd2408f9ef05; });

var $8xOSr = parcelRequire("8xOSr");

var $lk1iJ = parcelRequire("lk1iJ");

var $2SYKD = parcelRequire("2SYKD");

var $ghBnB = parcelRequire("ghBnB");

var $48FJp = parcelRequire("48FJp");

var $lM7wo = parcelRequire("lM7wo");

var $fI0BP = parcelRequire("fI0BP");

var $9ckN5 = parcelRequire("9ckN5");

var $f36wL = parcelRequire("f36wL");

var $d57cD = parcelRequire("d57cD");

var $h8lj9 = parcelRequire("h8lj9");

var $9NEXi = parcelRequire("9NEXi");

var $atkEl = parcelRequire("atkEl");

var $esEa6 = parcelRequire("esEa6");
var $6HqIz = parcelRequire("6HqIz");
const $9a82590a240327ee$export$f861cde01703a24e = (rtype)=>{
    switch(rtype){
        case 'none':
            return $9a82590a240327ee$export$30dda56bab139396;
        case 'day':
            return $9a82590a240327ee$export$b0bf7a77fbf91a5c;
        case 'day of week':
            return $9a82590a240327ee$export$34c256f6e5f1e21e;
        case 'day of month':
            return $9a82590a240327ee$export$c38eea4d0f3eec41;
        case 'bimonthy':
            return $9a82590a240327ee$export$b3467bef541eecdb;
        case 'quarterly':
            return $9a82590a240327ee$export$5a64d67852f1228;
        case 'semiannually':
            return $9a82590a240327ee$export$6cfad7331ea83130;
        case 'annually':
            return $9a82590a240327ee$export$68a6348016f6d26c;
        default:
            return $9a82590a240327ee$export$30dda56bab139396;
    }
};
const $9a82590a240327ee$export$6087fd2408f9ef05 = ({ transaction: transaction })=>{
    switch(transaction.rtype){
        case 'none':
            return $9a82590a240327ee$var$transactionNoReoccurCompute({
                transaction: transaction
            });
        case 'day':
            return $9a82590a240327ee$var$transactionDailyReoccurCompute({
                transaction: transaction
            });
        case 'day of week':
            return $9a82590a240327ee$var$transactionDayOfWeekReoccurCompute({
                transaction: transaction
            });
        case 'day of month':
            return $9a82590a240327ee$var$transactionDayOfMonthReoccurCompute({
                transaction: transaction
            });
        case 'bimonthy':
            return $9a82590a240327ee$var$transactionBimonthlyReoccurCompute({
                transaction: transaction
            });
        case 'quarterly':
            return $9a82590a240327ee$var$transactionQuarterlyReoccurCompute({
                transaction: transaction
            });
        case 'semiannually':
            return $9a82590a240327ee$var$transactionSemiannuallyReoccurCompute({
                transaction: transaction
            });
        case 'annually':
            return $9a82590a240327ee$var$transactionAnnuallyReoccurCompute({
                transaction: transaction
            });
        default:
            return $9a82590a240327ee$var$transactionNoReoccurCompute({
                transaction: transaction
            });
    }
};
const $9a82590a240327ee$export$30dda56bab139396 = ({ transaction: transaction, seedDate: seedDate })=>{
    if (!transaction.start) throw new Error('transactionNoReoccur expects transaction.start');
    if (!transaction.value) throw new Error('transactionNoReoccur expects transaction.value');
    return {
        date: (0, (/*@__PURE__*/$parcel$interopDefault($9NEXi)))(transaction.start),
        y: transaction.value
    };
};
const $9a82590a240327ee$var$transactionNoReoccurCompute = ({ transaction: transaction })=>(0, $6HqIz.dinero)({
        amount: 0,
        currency: (0, $8xOSr.USD)
    });
const $9a82590a240327ee$export$b0bf7a77fbf91a5c = ({ transaction: transaction, seedDate: seedDate, occurrences: occurrences })=>{
    if (!transaction.value) throw new Error('transactionDailyReoccur expects transaction.value');
    if (!transaction.cycle) throw new Error('transactionDailyReoccur expects transaction.cycle');
    if (occurrences === undefined) throw new Error('transactionDailyReoccur expects occurrences');
    const parsedStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($9NEXi)))(transaction.start);
    return {
        date: (0, (/*@__PURE__*/$parcel$interopDefault($d57cD)))(parsedStartDate)(seedDate) ? (0, (/*@__PURE__*/$parcel$interopDefault($lk1iJ)))(transaction.cycle)(seedDate) : (0, (/*@__PURE__*/$parcel$interopDefault($lk1iJ)))(transaction.cycle)(parsedStartDate),
        y: transaction.value
    };
};
const $9a82590a240327ee$var$transactionDailyReoccurCompute = ({ transaction: transaction })=>(0, $esEa6.allocate)(transaction.value, [
        1,
        6
    ])[0];
const $9a82590a240327ee$export$34c256f6e5f1e21e = ({ transaction: transaction, seedDate: seedDate, occurrences: occurrences })=>{
    if (!transaction.value) throw new Error('transactionDayOfWeekReoccur expects transaction.value');
    if (!transaction.cycle) throw new Error('transactionDayOfWeekReoccur expects transaction.cycle');
    if (!transaction.start) throw new Error('transactionDayOfWeekReoccur expects transaction.start');
    if (occurrences === undefined) throw new Error('transactionDayOfWeekReoccur expects occurrences');
    // This adjusts the seedDate to the proper day of the week and
    // uses it as a "target". Then we figure out how many days to add
    // to the start date (so we reoccur based on the transaction start day)
    // by dividing by 7 days a week, rounding up and multiplying by 7.
    // This gives us an increment of weeks (in the form of days) to add
    // to the transaction start date that will return a day after the
    // seedDate and that lands on our required day of the week.
    const parsedStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($9NEXi)))(transaction.start);
    const seedDay = (0, (/*@__PURE__*/$parcel$interopDefault($f36wL)))(seedDate);
    const startDay = (0, (/*@__PURE__*/$parcel$interopDefault($f36wL)))(parsedStartDate);
    const dayAdjust = transaction.cycle >= seedDay ? transaction.cycle - seedDay : transaction.cycle - seedDay + 7;
    const dayCycles = (0, (/*@__PURE__*/$parcel$interopDefault($h8lj9)))(seedDate)(parsedStartDate) ? Math.ceil(((0, (/*@__PURE__*/$parcel$interopDefault($9ckN5)))(parsedStartDate)(seedDate) + dayAdjust) / 7) * 7 : transaction.cycle > startDay ? transaction.cycle - startDay : transaction.cycle - startDay + 7;
    return {
        date: (0, (/*@__PURE__*/$parcel$interopDefault($lk1iJ)))(dayCycles)(parsedStartDate),
        y: transaction.value
    };
};
const $9a82590a240327ee$var$transactionDayOfWeekReoccurCompute = ({ transaction: transaction })=>(0, $esEa6.allocate)(transaction.value, [
        1,
        6
    ])[0];
const $9a82590a240327ee$export$c38eea4d0f3eec41 = ({ transaction: transaction, seedDate: seedDate, occurrences: occurrences })=>{
    if (!transaction.value) throw new Error('transactionDayOfMonthReoccur expects transaction.value');
    if (!transaction.cycle) throw new Error('transactionDayOfMonthReoccur expects transaction.cycle');
    if (occurrences === undefined) throw new Error('transactionDayOfMonthReoccur expects occurrences');
    let monthlyDate;
    let isBeforeSeedDate = (0, (/*@__PURE__*/$parcel$interopDefault($h8lj9)))(seedDate);
    let cycleDate = (0, (/*@__PURE__*/$parcel$interopDefault($atkEl)))(transaction.cycle);
    if (isBeforeSeedDate(cycleDate(seedDate)) || occurrences !== undefined && occurrences !== 0) monthlyDate = cycleDate((0, (/*@__PURE__*/$parcel$interopDefault($2SYKD)))(1)(seedDate));
    else monthlyDate = cycleDate(seedDate);
    return {
        date: monthlyDate,
        y: transaction.value
    };
};
const $9a82590a240327ee$var$transactionDayOfMonthReoccurCompute = ({ transaction: transaction })=>(0, $esEa6.allocate)(transaction.value, [
        1,
        29
    ])[0];
const $9a82590a240327ee$export$b3467bef541eecdb = ({ transaction: transaction, seedDate: seedDate })=>{
    if (!transaction.value) throw new Error('transactionBimonthlyReoccur expects transaction.value');
    if (!transaction.cycle) throw new Error('transactionBimonthlyReoccur expects transaction.cycle');
    return {
        date: (0, (/*@__PURE__*/$parcel$interopDefault($2SYKD)))(2 * transaction.cycle)(seedDate),
        y: transaction.value
    };
};
const $9a82590a240327ee$var$transactionBimonthlyReoccurCompute = ({ transaction: transaction })=>(0, $esEa6.allocate)(transaction.value, [
        1,
        59
    ])[0];
const $9a82590a240327ee$export$5a64d67852f1228 = ({ transaction: transaction, seedDate: seedDate })=>{
    if (!transaction.value) throw new Error('transactionQuarterlyReoccur expects transaction.value');
    if (!transaction.cycle) throw new Error('transactionQuarterlyReoccur expects transaction.cycle');
    return {
        date: (0, (/*@__PURE__*/$parcel$interopDefault($ghBnB)))(transaction.cycle)(seedDate),
        y: transaction.value
    };
};
const $9a82590a240327ee$var$transactionQuarterlyReoccurCompute = ({ transaction: transaction })=>(0, $esEa6.allocate)(transaction.value, [
        1,
        89
    ])[0];
const $9a82590a240327ee$export$6cfad7331ea83130 = ({ transaction: transaction, seedDate: seedDate, occurrences: occurrences })=>{
    if (!transaction.value) throw new Error('transactionSemiannuallyReoccur expects transaction.value');
    if (!transaction.start) throw new Error('transactionSemiannuallyReoccur expects transaction.start');
    if (occurrences === undefined) throw new Error('transactionSemiannuallyReoccur expects occurrences');
    // Finds how many months are between when this started and the date in question
    // the next date should be a multiple of the 6 months, so divide by the 6
    // then round up (0 decimal places, 3 round up) then multiply by 6 again
    // to give us the number of months to add to the transaction start date to
    // produce an occurence on/after the seedDate. If there are no occurrences
    // yet, we are looking for the first date and we want a date on/after the seedDate.
    // If we have any occurrences, then seedDate will actually be the date of the
    // last occurrences so we add 6 to that to get the next occurence.
    const parsedStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($9NEXi)))(transaction.start);
    const monthDifference = Math.ceil((0, (/*@__PURE__*/$parcel$interopDefault($lM7wo)))(parsedStartDate)(seedDate) / 6) * 6 + (occurrences === 0 ? 0 : 6);
    const afterSeed = (0, (/*@__PURE__*/$parcel$interopDefault($d57cD)))(seedDate);
    const increment = afterSeed((0, (/*@__PURE__*/$parcel$interopDefault($2SYKD)))(monthDifference)(parsedStartDate)) ? 0 : 6;
    return {
        date: (0, (/*@__PURE__*/$parcel$interopDefault($2SYKD)))(monthDifference + increment)(parsedStartDate),
        y: transaction.value
    };
};
const $9a82590a240327ee$var$transactionSemiannuallyReoccurCompute = ({ transaction: transaction })=>(0, $esEa6.allocate)(transaction.value, [
        {
            amount: 1825,
            scale: 1
        },
        {
            amount: 1825,
            scale: 1
        }
    ])[0];
const $9a82590a240327ee$export$68a6348016f6d26c = ({ transaction: transaction, seedDate: seedDate, occurrences: occurrences })=>{
    if (!transaction.value) throw new Error('transactionAnnuallyReoccur expects transaction.value');
    if (!transaction.start) throw new Error('transactionAnnuallyReoccur expects transaction.start');
    if (occurrences === undefined) throw new Error('transactionAnnuallyReoccur expects occurrences');
    // Finds how many months are between when this started and the date in question
    // then round up (0 decimal places, 3 round up) to give us the number of years
    // to add to the transaction start date to produce an occurence on/after
    // the seedDate. If there are no occurrences yet, we are looking for
    // the first date and we want a date on/after the seedDate. If we have
    // any occurrences, then seedDate will actually be the date of the
    // last occurrences so we add 1 to that to get the next occurence.
    const parsedStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($9NEXi)))(transaction.start);
    const yearDifference = Math.ceil((0, (/*@__PURE__*/$parcel$interopDefault($fI0BP)))(parsedStartDate)(seedDate)) + (occurrences == 0 ? 0 : 1);
    return {
        date: (0, (/*@__PURE__*/$parcel$interopDefault($48FJp)))(yearDifference)(parsedStartDate),
        y: transaction.value
    };
};
const $9a82590a240327ee$var$transactionAnnuallyReoccurCompute = ({ transaction: transaction })=>(0, $esEa6.allocate)(transaction.value, [
        1,
        364
    ])[0];

});
parcelRegister("2SYKD", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $219fbfd235629d6e$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $219fbfd235629d6e$var$_index = $219fbfd235629d6e$require$_interopRequireDefault((parcelRequire("7imCx")));

var $219fbfd235629d6e$var$_index2 = $219fbfd235629d6e$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $219fbfd235629d6e$var$_default = (0, $219fbfd235629d6e$var$_index2.default)($219fbfd235629d6e$var$_index.default, 2);
module.exports.default = $219fbfd235629d6e$var$_default;
module.exports = module.exports.default;

});
parcelRegister("7imCx", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $54fbc2d1577a7d55$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54fbc2d1577a7d55$var$addMonths;

var $54fbc2d1577a7d55$var$_index = $54fbc2d1577a7d55$require$_interopRequireDefault((parcelRequire("8WZx9")));

var $54fbc2d1577a7d55$var$_index2 = $54fbc2d1577a7d55$require$_interopRequireDefault((parcelRequire("99U8H")));

var $54fbc2d1577a7d55$var$_index3 = $54fbc2d1577a7d55$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */ function $54fbc2d1577a7d55$var$addMonths(dirtyDate, dirtyAmount) {
    (0, $54fbc2d1577a7d55$var$_index3.default)(2, arguments);
    var date = (0, $54fbc2d1577a7d55$var$_index2.default)(dirtyDate);
    var amount = (0, $54fbc2d1577a7d55$var$_index.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}
module.exports = module.exports.default;

});


parcelRegister("ghBnB", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $bdab3ab5b0eb8656$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bdab3ab5b0eb8656$var$_index = $bdab3ab5b0eb8656$require$_interopRequireDefault((parcelRequire("4Daws")));

var $bdab3ab5b0eb8656$var$_index2 = $bdab3ab5b0eb8656$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $bdab3ab5b0eb8656$var$_default = (0, $bdab3ab5b0eb8656$var$_index2.default)($bdab3ab5b0eb8656$var$_index.default, 2);
module.exports.default = $bdab3ab5b0eb8656$var$_default;
module.exports = module.exports.default;

});
parcelRegister("4Daws", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $35f2f78158c10b49$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35f2f78158c10b49$var$addQuarters;

var $35f2f78158c10b49$var$_index = $35f2f78158c10b49$require$_interopRequireDefault((parcelRequire("8WZx9")));

var $35f2f78158c10b49$var$_index2 = $35f2f78158c10b49$require$_interopRequireDefault((parcelRequire("7imCx")));

var $35f2f78158c10b49$var$_index3 = $35f2f78158c10b49$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $35f2f78158c10b49$var$addQuarters(dirtyDate, dirtyAmount) {
    (0, $35f2f78158c10b49$var$_index3.default)(2, arguments);
    var amount = (0, $35f2f78158c10b49$var$_index.default)(dirtyAmount);
    var months = amount * 3;
    return (0, $35f2f78158c10b49$var$_index2.default)(dirtyDate, months);
}
module.exports = module.exports.default;

});


parcelRegister("48FJp", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $303847c0472874ff$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $303847c0472874ff$var$_index = $303847c0472874ff$require$_interopRequireDefault((parcelRequire("j84HM")));

var $303847c0472874ff$var$_index2 = $303847c0472874ff$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $303847c0472874ff$var$_default = (0, $303847c0472874ff$var$_index2.default)($303847c0472874ff$var$_index.default, 2);
module.exports.default = $303847c0472874ff$var$_default;
module.exports = module.exports.default;

});
parcelRegister("j84HM", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $ded26a030acb2f22$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ded26a030acb2f22$var$addYears;

var $ded26a030acb2f22$var$_index = $ded26a030acb2f22$require$_interopRequireDefault((parcelRequire("8WZx9")));

var $ded26a030acb2f22$var$_index2 = $ded26a030acb2f22$require$_interopRequireDefault((parcelRequire("7imCx")));

var $ded26a030acb2f22$var$_index3 = $ded26a030acb2f22$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $ded26a030acb2f22$var$addYears(dirtyDate, dirtyAmount) {
    (0, $ded26a030acb2f22$var$_index3.default)(2, arguments);
    var amount = (0, $ded26a030acb2f22$var$_index.default)(dirtyAmount);
    return (0, $ded26a030acb2f22$var$_index2.default)(dirtyDate, amount * 12);
}
module.exports = module.exports.default;

});


parcelRegister("lM7wo", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $fda3ea461be33b9b$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fda3ea461be33b9b$var$_index = $fda3ea461be33b9b$require$_interopRequireDefault((parcelRequire("9B3eF")));

var $fda3ea461be33b9b$var$_index2 = $fda3ea461be33b9b$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $fda3ea461be33b9b$var$_default = (0, $fda3ea461be33b9b$var$_index2.default)($fda3ea461be33b9b$var$_index.default, 2);
module.exports.default = $fda3ea461be33b9b$var$_default;
module.exports = module.exports.default;

});
parcelRegister("9B3eF", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $6fca14437c593a67$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6fca14437c593a67$var$differenceInCalendarMonths;

var $6fca14437c593a67$var$_index = $6fca14437c593a67$require$_interopRequireDefault((parcelRequire("99U8H")));

var $6fca14437c593a67$var$_index2 = $6fca14437c593a67$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $6fca14437c593a67$var$differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    (0, $6fca14437c593a67$var$_index2.default)(2, arguments);
    var dateLeft = (0, $6fca14437c593a67$var$_index.default)(dirtyDateLeft);
    var dateRight = (0, $6fca14437c593a67$var$_index.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}
module.exports = module.exports.default;

});


parcelRegister("fI0BP", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $b6fb700e047a7e11$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6fb700e047a7e11$var$_index = $b6fb700e047a7e11$require$_interopRequireDefault((parcelRequire("9TS6U")));

var $b6fb700e047a7e11$var$_index2 = $b6fb700e047a7e11$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $b6fb700e047a7e11$var$_default = (0, $b6fb700e047a7e11$var$_index2.default)($b6fb700e047a7e11$var$_index.default, 2);
module.exports.default = $b6fb700e047a7e11$var$_default;
module.exports = module.exports.default;

});
parcelRegister("9TS6U", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $7353394f400d2590$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7353394f400d2590$var$differenceInCalendarYears;

var $7353394f400d2590$var$_index = $7353394f400d2590$require$_interopRequireDefault((parcelRequire("99U8H")));

var $7353394f400d2590$var$_index2 = $7353394f400d2590$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $7353394f400d2590$var$differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
    (0, $7353394f400d2590$var$_index2.default)(2, arguments);
    var dateLeft = (0, $7353394f400d2590$var$_index.default)(dirtyDateLeft);
    var dateRight = (0, $7353394f400d2590$var$_index.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}
module.exports = module.exports.default;

});


parcelRegister("9ckN5", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $6b255cac1c4c8ba8$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b255cac1c4c8ba8$var$_index = $6b255cac1c4c8ba8$require$_interopRequireDefault((parcelRequire("jijwV")));

var $6b255cac1c4c8ba8$var$_index2 = $6b255cac1c4c8ba8$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $6b255cac1c4c8ba8$var$_default = (0, $6b255cac1c4c8ba8$var$_index2.default)($6b255cac1c4c8ba8$var$_index.default, 2);
module.exports.default = $6b255cac1c4c8ba8$var$_default;
module.exports = module.exports.default;

});
parcelRegister("jijwV", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $e0bed90974c6d8f3$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e0bed90974c6d8f3$var$differenceInDays;

var $e0bed90974c6d8f3$var$_index = $e0bed90974c6d8f3$require$_interopRequireDefault((parcelRequire("99U8H")));

var $e0bed90974c6d8f3$var$_index2 = $e0bed90974c6d8f3$require$_interopRequireDefault((parcelRequire("4rZnh")));

var $e0bed90974c6d8f3$var$_index3 = $e0bed90974c6d8f3$require$_interopRequireDefault((parcelRequire("kMAIB")));
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $e0bed90974c6d8f3$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */ function $e0bed90974c6d8f3$var$differenceInDays(dirtyDateLeft, dirtyDateRight) {
    (0, $e0bed90974c6d8f3$var$_index3.default)(2, arguments);
    var dateLeft = (0, $e0bed90974c6d8f3$var$_index.default)(dirtyDateLeft);
    var dateRight = (0, $e0bed90974c6d8f3$var$_index.default)(dirtyDateRight);
    var sign = $e0bed90974c6d8f3$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $e0bed90974c6d8f3$var$_index2.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($e0bed90974c6d8f3$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
module.exports = module.exports.default;

});
parcelRegister("4rZnh", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $33d94ab9ac4f6b56$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33d94ab9ac4f6b56$var$differenceInCalendarDays;

var $33d94ab9ac4f6b56$var$_index = $33d94ab9ac4f6b56$require$_interopRequireDefault((parcelRequire("kXZ8N")));

var $33d94ab9ac4f6b56$var$_index2 = $33d94ab9ac4f6b56$require$_interopRequireDefault((parcelRequire("4M0xa")));

var $33d94ab9ac4f6b56$var$_index3 = $33d94ab9ac4f6b56$require$_interopRequireDefault((parcelRequire("kMAIB")));
var $33d94ab9ac4f6b56$var$MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $33d94ab9ac4f6b56$var$differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, $33d94ab9ac4f6b56$var$_index3.default)(2, arguments);
    var startOfDayLeft = (0, $33d94ab9ac4f6b56$var$_index2.default)(dirtyDateLeft);
    var startOfDayRight = (0, $33d94ab9ac4f6b56$var$_index2.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $33d94ab9ac4f6b56$var$_index.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $33d94ab9ac4f6b56$var$_index.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $33d94ab9ac4f6b56$var$MILLISECONDS_IN_DAY);
}
module.exports = module.exports.default;

});
parcelRegister("kXZ8N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f438be9ee4c5a441$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $f438be9ee4c5a441$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("4M0xa", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $379c0f2073897d5d$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $379c0f2073897d5d$var$startOfDay;

var $379c0f2073897d5d$var$_index = $379c0f2073897d5d$require$_interopRequireDefault((parcelRequire("99U8H")));

var $379c0f2073897d5d$var$_index2 = $379c0f2073897d5d$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $379c0f2073897d5d$var$startOfDay(dirtyDate) {
    (0, $379c0f2073897d5d$var$_index2.default)(1, arguments);
    var date = (0, $379c0f2073897d5d$var$_index.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});




parcelRegister("f36wL", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $af4c330bae41266c$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af4c330bae41266c$var$_index = $af4c330bae41266c$require$_interopRequireDefault((parcelRequire("a1p34")));

var $af4c330bae41266c$var$_index2 = $af4c330bae41266c$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $af4c330bae41266c$var$_default = (0, $af4c330bae41266c$var$_index2.default)($af4c330bae41266c$var$_index.default, 1);
module.exports.default = $af4c330bae41266c$var$_default;
module.exports = module.exports.default;

});
parcelRegister("a1p34", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $74bd6d83e1a5b3f9$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74bd6d83e1a5b3f9$var$getDay;

var $74bd6d83e1a5b3f9$var$_index = $74bd6d83e1a5b3f9$require$_interopRequireDefault((parcelRequire("99U8H")));

var $74bd6d83e1a5b3f9$var$_index2 = $74bd6d83e1a5b3f9$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $74bd6d83e1a5b3f9$var$getDay(dirtyDate) {
    (0, $74bd6d83e1a5b3f9$var$_index2.default)(1, arguments);
    var date = (0, $74bd6d83e1a5b3f9$var$_index.default)(dirtyDate);
    var day = date.getDay();
    return day;
}
module.exports = module.exports.default;

});


parcelRegister("d57cD", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $9861544cd847c077$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9861544cd847c077$var$_index = $9861544cd847c077$require$_interopRequireDefault((parcelRequire("5FKPg")));

var $9861544cd847c077$var$_index2 = $9861544cd847c077$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $9861544cd847c077$var$_default = (0, $9861544cd847c077$var$_index2.default)($9861544cd847c077$var$_index.default, 2);
module.exports.default = $9861544cd847c077$var$_default;
module.exports = module.exports.default;

});
parcelRegister("5FKPg", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $42151ab4f365dee2$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $42151ab4f365dee2$var$isAfter;

var $42151ab4f365dee2$var$_index = $42151ab4f365dee2$require$_interopRequireDefault((parcelRequire("99U8H")));

var $42151ab4f365dee2$var$_index2 = $42151ab4f365dee2$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $42151ab4f365dee2$var$isAfter(dirtyDate, dirtyDateToCompare) {
    (0, $42151ab4f365dee2$var$_index2.default)(2, arguments);
    var date = (0, $42151ab4f365dee2$var$_index.default)(dirtyDate);
    var dateToCompare = (0, $42151ab4f365dee2$var$_index.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}
module.exports = module.exports.default;

});


parcelRegister("h8lj9", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $c793b6590a7cddce$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c793b6590a7cddce$var$_index = $c793b6590a7cddce$require$_interopRequireDefault((parcelRequire("bminh")));

var $c793b6590a7cddce$var$_index2 = $c793b6590a7cddce$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $c793b6590a7cddce$var$_default = (0, $c793b6590a7cddce$var$_index2.default)($c793b6590a7cddce$var$_index.default, 2);
module.exports.default = $c793b6590a7cddce$var$_default;
module.exports = module.exports.default;

});
parcelRegister("bminh", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $84500097fd3cdbb3$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84500097fd3cdbb3$var$isBefore;

var $84500097fd3cdbb3$var$_index = $84500097fd3cdbb3$require$_interopRequireDefault((parcelRequire("99U8H")));

var $84500097fd3cdbb3$var$_index2 = $84500097fd3cdbb3$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $84500097fd3cdbb3$var$isBefore(dirtyDate, dirtyDateToCompare) {
    (0, $84500097fd3cdbb3$var$_index2.default)(2, arguments);
    var date = (0, $84500097fd3cdbb3$var$_index.default)(dirtyDate);
    var dateToCompare = (0, $84500097fd3cdbb3$var$_index.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}
module.exports = module.exports.default;

});


parcelRegister("9NEXi", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $72287585948979e1$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72287585948979e1$var$_index = $72287585948979e1$require$_interopRequireDefault((parcelRequire("8C9qD")));

var $72287585948979e1$var$_index2 = $72287585948979e1$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $72287585948979e1$var$_default = (0, $72287585948979e1$var$_index2.default)($72287585948979e1$var$_index.default, 1);
module.exports.default = $72287585948979e1$var$_default;
module.exports = module.exports.default;

});
parcelRegister("8C9qD", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $019e577a8bcecdb5$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $019e577a8bcecdb5$var$parseISO;

var $iaTFx = parcelRequire("iaTFx");

var $019e577a8bcecdb5$var$_index2 = $019e577a8bcecdb5$require$_interopRequireDefault((parcelRequire("kMAIB")));

var $019e577a8bcecdb5$var$_index3 = $019e577a8bcecdb5$require$_interopRequireDefault((parcelRequire("8WZx9")));
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $019e577a8bcecdb5$var$parseISO(argument, options) {
    var _options$additionalDi;
    (0, $019e577a8bcecdb5$var$_index2.default)(1, arguments);
    var additionalDigits = (0, $019e577a8bcecdb5$var$_index3.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $019e577a8bcecdb5$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $019e577a8bcecdb5$var$parseYear(dateStrings.date, additionalDigits);
        date = $019e577a8bcecdb5$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $019e577a8bcecdb5$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $019e577a8bcecdb5$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $019e577a8bcecdb5$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $019e577a8bcecdb5$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $019e577a8bcecdb5$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $019e577a8bcecdb5$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $019e577a8bcecdb5$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($019e577a8bcecdb5$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($019e577a8bcecdb5$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($019e577a8bcecdb5$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $019e577a8bcecdb5$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $019e577a8bcecdb5$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $019e577a8bcecdb5$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($019e577a8bcecdb5$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $019e577a8bcecdb5$var$parseDateUnit(captures[1]);
    var month = $019e577a8bcecdb5$var$parseDateUnit(captures[2]) - 1;
    var day = $019e577a8bcecdb5$var$parseDateUnit(captures[3]);
    var week = $019e577a8bcecdb5$var$parseDateUnit(captures[4]);
    var dayOfWeek = $019e577a8bcecdb5$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$019e577a8bcecdb5$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $019e577a8bcecdb5$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$019e577a8bcecdb5$var$validateDate(year, month, day) || !$019e577a8bcecdb5$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $019e577a8bcecdb5$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $019e577a8bcecdb5$var$parseTime(timeString) {
    var captures = timeString.match($019e577a8bcecdb5$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $019e577a8bcecdb5$var$parseTimeUnit(captures[1]);
    var minutes = $019e577a8bcecdb5$var$parseTimeUnit(captures[2]);
    var seconds = $019e577a8bcecdb5$var$parseTimeUnit(captures[3]);
    if (!$019e577a8bcecdb5$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $iaTFx.millisecondsInHour + minutes * $iaTFx.millisecondsInMinute + seconds * 1000;
}
function $019e577a8bcecdb5$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $019e577a8bcecdb5$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($019e577a8bcecdb5$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$019e577a8bcecdb5$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $iaTFx.millisecondsInHour + minutes * $iaTFx.millisecondsInMinute);
}
function $019e577a8bcecdb5$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $019e577a8bcecdb5$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $019e577a8bcecdb5$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $019e577a8bcecdb5$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($019e577a8bcecdb5$var$daysInMonths[month] || ($019e577a8bcecdb5$var$isLeapYearIndex(year) ? 29 : 28));
}
function $019e577a8bcecdb5$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($019e577a8bcecdb5$var$isLeapYearIndex(year) ? 366 : 365);
}
function $019e577a8bcecdb5$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $019e577a8bcecdb5$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $019e577a8bcecdb5$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
module.exports = module.exports.default;

});
parcelRegister("iaTFx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.secondsInYear = module.exports.secondsInWeek = module.exports.secondsInQuarter = module.exports.secondsInMonth = module.exports.secondsInMinute = module.exports.secondsInHour = module.exports.secondsInDay = module.exports.quartersInYear = module.exports.monthsInYear = module.exports.monthsInQuarter = module.exports.minutesInHour = module.exports.minTime = module.exports.millisecondsInSecond = module.exports.millisecondsInMinute = module.exports.millisecondsInHour = module.exports.maxTime = module.exports.daysInYear = module.exports.daysInWeek = void 0;
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $d3b457dc6bd65fb2$var$daysInWeek = 7;
/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */ module.exports.daysInWeek = $d3b457dc6bd65fb2$var$daysInWeek;
var $d3b457dc6bd65fb2$var$daysInYear = 365.2425;
/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */ module.exports.daysInYear = $d3b457dc6bd65fb2$var$daysInYear;
var $d3b457dc6bd65fb2$var$maxTime = Math.pow(10, 8) * 86400000;
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */ module.exports.maxTime = $d3b457dc6bd65fb2$var$maxTime;
var $d3b457dc6bd65fb2$var$millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */ module.exports.millisecondsInMinute = $d3b457dc6bd65fb2$var$millisecondsInMinute;
var $d3b457dc6bd65fb2$var$millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */ module.exports.millisecondsInHour = $d3b457dc6bd65fb2$var$millisecondsInHour;
var $d3b457dc6bd65fb2$var$millisecondsInSecond = 1000;
/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */ module.exports.millisecondsInSecond = $d3b457dc6bd65fb2$var$millisecondsInSecond;
var $d3b457dc6bd65fb2$var$minTime = -$d3b457dc6bd65fb2$var$maxTime;
/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */ module.exports.minTime = $d3b457dc6bd65fb2$var$minTime;
var $d3b457dc6bd65fb2$var$minutesInHour = 60;
/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */ module.exports.minutesInHour = $d3b457dc6bd65fb2$var$minutesInHour;
var $d3b457dc6bd65fb2$var$monthsInQuarter = 3;
/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */ module.exports.monthsInQuarter = $d3b457dc6bd65fb2$var$monthsInQuarter;
var $d3b457dc6bd65fb2$var$monthsInYear = 12;
/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */ module.exports.monthsInYear = $d3b457dc6bd65fb2$var$monthsInYear;
var $d3b457dc6bd65fb2$var$quartersInYear = 4;
/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */ module.exports.quartersInYear = $d3b457dc6bd65fb2$var$quartersInYear;
var $d3b457dc6bd65fb2$var$secondsInHour = 3600;
/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */ module.exports.secondsInHour = $d3b457dc6bd65fb2$var$secondsInHour;
var $d3b457dc6bd65fb2$var$secondsInMinute = 60;
/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */ module.exports.secondsInMinute = $d3b457dc6bd65fb2$var$secondsInMinute;
var $d3b457dc6bd65fb2$var$secondsInDay = $d3b457dc6bd65fb2$var$secondsInHour * 24;
/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */ module.exports.secondsInDay = $d3b457dc6bd65fb2$var$secondsInDay;
var $d3b457dc6bd65fb2$var$secondsInWeek = $d3b457dc6bd65fb2$var$secondsInDay * 7;
/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */ module.exports.secondsInWeek = $d3b457dc6bd65fb2$var$secondsInWeek;
var $d3b457dc6bd65fb2$var$secondsInYear = $d3b457dc6bd65fb2$var$secondsInDay * $d3b457dc6bd65fb2$var$daysInYear;
/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */ module.exports.secondsInYear = $d3b457dc6bd65fb2$var$secondsInYear;
var $d3b457dc6bd65fb2$var$secondsInMonth = $d3b457dc6bd65fb2$var$secondsInYear / 12;
/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */ module.exports.secondsInMonth = $d3b457dc6bd65fb2$var$secondsInMonth;
var $d3b457dc6bd65fb2$var$secondsInQuarter = $d3b457dc6bd65fb2$var$secondsInMonth * 3;
module.exports.secondsInQuarter = $d3b457dc6bd65fb2$var$secondsInQuarter;

});



parcelRegister("atkEl", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $79fca1707262d254$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79fca1707262d254$var$_index = $79fca1707262d254$require$_interopRequireDefault((parcelRequire("kD5V0")));

var $79fca1707262d254$var$_index2 = $79fca1707262d254$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $79fca1707262d254$var$_default = (0, $79fca1707262d254$var$_index2.default)($79fca1707262d254$var$_index.default, 2);
module.exports.default = $79fca1707262d254$var$_default;
module.exports = module.exports.default;

});
parcelRegister("kD5V0", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $f04c0a77bdcc9340$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f04c0a77bdcc9340$var$setDate;

var $f04c0a77bdcc9340$var$_index = $f04c0a77bdcc9340$require$_interopRequireDefault((parcelRequire("8WZx9")));

var $f04c0a77bdcc9340$var$_index2 = $f04c0a77bdcc9340$require$_interopRequireDefault((parcelRequire("99U8H")));

var $f04c0a77bdcc9340$var$_index3 = $f04c0a77bdcc9340$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $f04c0a77bdcc9340$var$setDate(dirtyDate, dirtyDayOfMonth) {
    (0, $f04c0a77bdcc9340$var$_index3.default)(2, arguments);
    var date = (0, $f04c0a77bdcc9340$var$_index2.default)(dirtyDate);
    var dayOfMonth = (0, $f04c0a77bdcc9340$var$_index.default)(dirtyDayOfMonth);
    date.setDate(dayOfMonth);
    return date;
}
module.exports = module.exports.default;

});


parcelRegister("esEa6", function(module, exports) {

$parcel$export(module.exports, "allocate", function () { return $a872d585a9ba5364$export$19118764a8a1dde4; });

var $TdexE = parcelRequire("TdexE");
function $a872d585a9ba5364$export$19118764a8a1dde4() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var dineroObject = _ref[0], ratios = _ref[1];
    var calculator = dineroObject.calculator;
    var allocateFn = (0, $TdexE.safeAllocate)(calculator);
    return allocateFn(dineroObject, ratios);
}

});
parcelRegister("TdexE", function(module, exports) {

$parcel$export(module.exports, "safeAllocate", function () { return $0a5f67132f314543$export$2104e4e9e1547c02; });
/* eslint-disable functional/no-expression-statement */ 
var $3GfaA = parcelRequire("3GfaA");

var $17TDA = parcelRequire("17TDA");

var $hX6NP = parcelRequire("hX6NP");
var $Q8hIv = parcelRequire("Q8hIv");
var $8vAO4 = parcelRequire("8vAO4");
var $2hmcB = parcelRequire("2hmcB");
var $iDGQa = parcelRequire("iDGQa");
var $8yk8U = parcelRequire("8yk8U");

var $6S4GG = parcelRequire("6S4GG");
function $0a5f67132f314543$var$unsafeAllocate(calculator) {
    return function allocate() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], ratios = _ref[1];
        var _dineroObject$toJSON = dineroObject.toJSON(), amount = _dineroObject$toJSON.amount, currency = _dineroObject$toJSON.currency, scale = _dineroObject$toJSON.scale;
        var distributeFn = (0, $hX6NP.distribute)(calculator);
        var shares = distributeFn(amount, ratios.map(function(ratio) {
            return ratio.amount;
        }));
        return shares.map(function(share) {
            return dineroObject.create({
                amount: share,
                currency: currency,
                scale: scale
            });
        });
    };
}
function $0a5f67132f314543$export$2104e4e9e1547c02(calculator) {
    var allocateFn = $0a5f67132f314543$var$unsafeAllocate(calculator);
    var greaterThanOrEqualFn = (0, $iDGQa.greaterThanOrEqual)(calculator);
    var greaterThanFn = (0, $2hmcB.greaterThan)(calculator);
    var convertScaleFn = (0, $6S4GG.transformScale)(calculator);
    var maximumFn = (0, $8yk8U.maximum)(calculator);
    var equalFn = (0, $Q8hIv.equal)(calculator);
    var zero = calculator.zero();
    var ten = new Array(10).fill(null).reduce(calculator.increment, zero);
    return function allocate() {
        for(var _len2 = arguments.length, _ref2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)_ref2[_key2] = arguments[_key2];
        var dineroObject = _ref2[0], ratios = _ref2[1];
        var hasRatios = ratios.length > 0;
        var scaledRatios = ratios.map(function(ratio) {
            return (0, $8vAO4.getAmountAndScale)(ratio, zero);
        });
        var highestRatioScale = hasRatios ? maximumFn(scaledRatios.map(function(_ref3) {
            var scale = _ref3.scale;
            return scale;
        })) : zero;
        var normalizedRatios = scaledRatios.map(function(_ref4) {
            var amount = _ref4.amount, scale = _ref4.scale;
            var factor = equalFn(scale, highestRatioScale) ? zero : calculator.subtract(highestRatioScale, scale);
            return {
                amount: calculator.multiply(amount, calculator.power(ten, factor)),
                scale: scale
            };
        });
        var hasOnlyPositiveRatios = normalizedRatios.every(function(_ref5) {
            var amount = _ref5.amount;
            return greaterThanOrEqualFn(amount, zero);
        });
        var hasOneNonZeroRatio = normalizedRatios.some(function(_ref6) {
            var amount = _ref6.amount;
            return greaterThanFn(amount, zero);
        });
        var condition = hasRatios && hasOnlyPositiveRatios && hasOneNonZeroRatio;
        (0, $17TDA.assert)(condition, (0, $3GfaA.INVALID_RATIOS_MESSAGE));
        var _dineroObject$toJSON2 = dineroObject.toJSON(), scale = _dineroObject$toJSON2.scale;
        var newScale = calculator.add(scale, highestRatioScale);
        return allocateFn(convertScaleFn(dineroObject, newScale), normalizedRatios);
    };
}

});
parcelRegister("hX6NP", function(module, exports) {

$parcel$export(module.exports, "distribute", function () { return $d11d39360823aeb4$export$f02a9ddbe4480f19; });
/* eslint-disable functional/no-let, functional/no-loop-statement, functional/immutable-data, functional/no-expression-statement */ 
var $Q8hIv = parcelRequire("Q8hIv");

var $2hmcB = parcelRequire("2hmcB");

var $iDGQa = parcelRequire("iDGQa");

var $9jnce = parcelRequire("9jnce");
function $d11d39360823aeb4$export$f02a9ddbe4480f19(calculator) {
    return function(value, ratios) {
        var equalFn = (0, $Q8hIv.equal)(calculator);
        var greaterThanFn = (0, $2hmcB.greaterThan)(calculator);
        var lessThanFn = (0, $9jnce.lessThan)(calculator);
        var greaterThanOrEqualFn = (0, $iDGQa.greaterThanOrEqual)(calculator);
        var zero = calculator.zero();
        var one = calculator.increment(zero);
        var total = ratios.reduce(function(a, b) {
            return calculator.add(a, b);
        }, zero);
        if (equalFn(total, zero)) return ratios;
        var remainder = value;
        var shares = ratios.map(function(ratio) {
            var share = calculator.integerDivide(calculator.multiply(value, ratio), total) || zero;
            remainder = calculator.subtract(remainder, share);
            return share;
        });
        var isPositive = greaterThanOrEqualFn(value, zero);
        var compare = isPositive ? greaterThanFn : lessThanFn;
        var amount = isPositive ? one : calculator.decrement(zero);
        var i = 0;
        while(compare(remainder, zero)){
            if (!equalFn(ratios[i], zero)) {
                shares[i] = calculator.add(shares[i], amount);
                remainder = calculator.subtract(remainder, amount);
            }
            i++;
        }
        return shares;
    };
}

});
parcelRegister("Q8hIv", function(module, exports) {

$parcel$export(module.exports, "equal", function () { return $09cb489f85496aa8$export$411ce8e5a71e3069; });

var $h378L = parcelRequire("h378L");
function $09cb489f85496aa8$export$411ce8e5a71e3069(calculator) {
    return function(subject, comparator) {
        return calculator.compare(subject, comparator) === (0, $h378L.ComparisonOperator).EQ;
    };
}

});

parcelRegister("2hmcB", function(module, exports) {

$parcel$export(module.exports, "greaterThan", function () { return $1a8e6437a44ed017$export$f517ea36c68d4644; });

var $h378L = parcelRequire("h378L");
function $1a8e6437a44ed017$export$f517ea36c68d4644(calculator) {
    return function(subject, comparator) {
        return calculator.compare(subject, comparator) === (0, $h378L.ComparisonOperator).GT;
    };
}

});

parcelRegister("iDGQa", function(module, exports) {

$parcel$export(module.exports, "greaterThanOrEqual", function () { return $d91d19bb449a86f2$export$1d972cf4acc123bd; });

var $Q8hIv = parcelRequire("Q8hIv");

var $2hmcB = parcelRequire("2hmcB");
function $d91d19bb449a86f2$export$1d972cf4acc123bd(calculator) {
    return function(subject, comparator) {
        return (0, $2hmcB.greaterThan)(calculator)(subject, comparator) || (0, $Q8hIv.equal)(calculator)(subject, comparator);
    };
}

});

parcelRegister("9jnce", function(module, exports) {

$parcel$export(module.exports, "lessThan", function () { return $6c77e1b28b2550b1$export$9b050841a3a1b328; });

var $h378L = parcelRequire("h378L");
function $6c77e1b28b2550b1$export$9b050841a3a1b328(calculator) {
    return function(subject, comparator) {
        return calculator.compare(subject, comparator) === (0, $h378L.ComparisonOperator).LT;
    };
}

});


parcelRegister("8vAO4", function(module, exports) {

$parcel$export(module.exports, "getAmountAndScale", function () { return $631dc4fb30c9f09a$export$e360235ce2c77844; });

var $bIsT7 = parcelRequire("bIsT7");
function $631dc4fb30c9f09a$export$e360235ce2c77844(value, zero) {
    if ((0, $bIsT7.isScaledAmount)(value)) {
        var _value$scale;
        return {
            amount: value.amount,
            scale: (_value$scale = value === null || value === void 0 ? void 0 : value.scale) !== null && _value$scale !== void 0 ? _value$scale : zero
        };
    }
    return {
        amount: value,
        scale: zero
    };
}

});
parcelRegister("bIsT7", function(module, exports) {

$parcel$export(module.exports, "isScaledAmount", function () { return $887a365711415d57$export$7f825c2ffa1f2c9a; });
function $887a365711415d57$export$7f825c2ffa1f2c9a(amount) {
    return amount === null || amount === void 0 ? void 0 : amount.hasOwnProperty('amount');
}

});


parcelRegister("8yk8U", function(module, exports) {

$parcel$export(module.exports, "maximum", function () { return $63a11fa6170f7640$export$b25e0be55f42c9a; });

var $9jnce = parcelRequire("9jnce");
function $63a11fa6170f7640$export$b25e0be55f42c9a(calculator) {
    var lessThanFn = (0, $9jnce.lessThan)(calculator);
    return function(values) {
        return values.reduce(function(acc, curr) {
            return lessThanFn(acc, curr) ? curr : acc;
        });
    };
}

});

parcelRegister("6S4GG", function(module, exports) {

$parcel$export(module.exports, "transformScale", function () { return $500b6c090fa9c320$export$5a26e3b3d26ddeb7; });

var $dZFVh = parcelRequire("dZFVh");

var $bXvrv = parcelRequire("bXvrv");
var $2hmcB = parcelRequire("2hmcB");
function $500b6c090fa9c320$var$_slicedToArray(arr, i) {
    return $500b6c090fa9c320$var$_arrayWithHoles(arr) || $500b6c090fa9c320$var$_iterableToArrayLimit(arr, i) || $500b6c090fa9c320$var$_unsupportedIterableToArray(arr, i) || $500b6c090fa9c320$var$_nonIterableRest();
}
function $500b6c090fa9c320$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $500b6c090fa9c320$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $500b6c090fa9c320$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $500b6c090fa9c320$var$_arrayLikeToArray(o, minLen);
}
function $500b6c090fa9c320$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $500b6c090fa9c320$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $500b6c090fa9c320$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $500b6c090fa9c320$export$5a26e3b3d26ddeb7(calculator) {
    var greaterThanFn = (0, $2hmcB.greaterThan)(calculator);
    var computeBaseFn = (0, $bXvrv.computeBase)(calculator);
    return function transformScaleFn() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], newScale = _ref[1], _ref$ = _ref[2], divide = _ref$ === void 0 ? (0, $dZFVh.down) : _ref$;
        var _dineroObject$toJSON = dineroObject.toJSON(), amount = _dineroObject$toJSON.amount, currency = _dineroObject$toJSON.currency, scale = _dineroObject$toJSON.scale;
        var isLarger = greaterThanFn(newScale, scale);
        var operation = isLarger ? calculator.multiply : divide;
        var _ref2 = isLarger ? [
            newScale,
            scale
        ] : [
            scale,
            newScale
        ], _ref3 = $500b6c090fa9c320$var$_slicedToArray(_ref2, 2), a = _ref3[0], b = _ref3[1];
        var base = computeBaseFn(currency.base);
        var factor = calculator.power(base, calculator.subtract(a, b));
        return dineroObject.create({
            amount: operation(amount, factor, calculator),
            currency: currency,
            scale: newScale
        });
    };
}

});
parcelRegister("dZFVh", function(module, exports) {

$parcel$export(module.exports, "down", function () { return $a3017de087111070$export$5df884bdba3ad6a1; });

var $Q8hIv = parcelRequire("Q8hIv");
var $2hmcB = parcelRequire("2hmcB");
var $a3017de087111070$export$5df884bdba3ad6a1 = function down(amount, factor, calculator) {
    var greaterThanFn = (0, $2hmcB.greaterThan)(calculator);
    var equalFn = (0, $Q8hIv.equal)(calculator);
    var zero = calculator.zero();
    var isPositive = greaterThanFn(amount, zero);
    var quotient = calculator.integerDivide(amount, factor);
    var remainder = calculator.modulo(amount, factor);
    var isInteger = equalFn(remainder, zero);
    if (isPositive || isInteger) return quotient;
    return calculator.decrement(quotient);
};

});

parcelRegister("bXvrv", function(module, exports) {

$parcel$export(module.exports, "computeBase", function () { return $8b4d98408dddb89d$export$34f5795259ce9fbe; });

var $2fOuk = parcelRequire("2fOuk");
function $8b4d98408dddb89d$export$34f5795259ce9fbe(calculator) {
    return function(base) {
        if ((0, $2fOuk.isArray)(base)) return base.reduce(function(acc, curr) {
            return calculator.multiply(acc, curr);
        });
        return base;
    };
}

});
parcelRegister("2fOuk", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $1a4425617d5f5763$export$43bee75e5e14138e; });
function $1a4425617d5f5763$export$43bee75e5e14138e(maybeArray) {
    return Array.isArray(maybeArray);
}

});






parcelRegister("gg4T5", function(module, exports) {

$parcel$export(module.exports, "findSeed", function () { return $c41cd8a25844e459$export$1206b3761bbe44d9; });
$parcel$export(module.exports, "extrapolateTransactionOccurrences", function () { return $c41cd8a25844e459$export$39c5f6dc392c093a; });

var $igItr = parcelRequire("igItr");
var $gUIpT = parcelRequire("gUIpT");
var $gDyFX = parcelRequire("gDyFX");

var $7uN6s = parcelRequire("7uN6s");
const $c41cd8a25844e459$export$1206b3761bbe44d9 = ({ nextTransactionFn: nextTransactionFn, transaction: transaction, date: date, y: y, interval: interval, occurred: occurred })=>{
    // a transaction function has to run and mark an occurrence to have found the seed date
    //  so we don't blindly use the transaction start date as the seed except for daily as
    //  the start date dictates the start of a cycle
    if ((0, $gDyFX.default)(date, interval) && (occurred !== 0 || transaction.rtype === 'day')) return {
        date: date,
        nextY: y,
        occurred: occurred
    };
    const { date: nextDate, y: nextY } = nextTransactionFn({
        transaction: transaction,
        seedDate: date,
        occurrences: transaction.occurrences
    });
    return $c41cd8a25844e459$export$1206b3761bbe44d9({
        nextTransactionFn: nextTransactionFn,
        transaction: transaction,
        interval: interval,
        y: nextY,
        // to avoid getting stuck generating the same day over and over
        date: (0, $gUIpT.default)(date, nextDate) ? (0, $igItr.default)(nextDate, 1) : nextDate,
        occurred: occurred + 1
    });
};
function $c41cd8a25844e459$export$39c5f6dc392c093a({ allDates: allDates, transaction: transaction }) {
    const nextTransactionFn = (0, $7uN6s.nextTransaction)(transaction.rtype);
    const allTransactionEvents = [];
    const next = {
        transaction: transaction,
        occurrences: transaction.occurrences,
        date: transaction.seedDate,
        nextY: transaction.value
    };
    let occurred = transaction.occurredInSeed - 1; // we will capture once instance on first loop
    const stack = allDates.map((day)=>{
        let y = null;
        if ((0, $gUIpT.default)(day, next.date) && (transaction.occurrences === 0 || occurred < transaction.occurrences)) {
            allTransactionEvents.push(day);
            y = next.nextY;
            const { date: date, y: calculatedY } = nextTransactionFn({
                ...next,
                seedDate: (0, $igItr.default)(next.date, 1)
            });
            if ((0, $gUIpT.default)(date, next.date)) throw new Error('same date, recursive calc, we should not hit this error');
            // save data for next value
            next.nextY = calculatedY;
            next.date = date;
            occurred += 1;
        }
        return {
            date: day,
            y: y
        };
    });
    return {
        data: stack,
        allTransactionEvents: allTransactionEvents
    };
}

});
parcelRegister("igItr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4cc3831797a4057$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $d4cc3831797a4057$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});
parcelRegister("le96L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f741f874145d0154$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $6RzIO = parcelRequire("6RzIO");
function $f741f874145d0154$export$2e2bcd8739ae039(argument) {
    (0, $6RzIO.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $51lpG.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("51lpG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a7da7f4c81a8554$export$2e2bcd8739ae039; });
function $3a7da7f4c81a8554$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3a7da7f4c81a8554$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a7da7f4c81a8554$export$2e2bcd8739ae039(o);
}

});



parcelRegister("gUIpT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5045487affbaf52$export$2e2bcd8739ae039; });

var $h8HSd = parcelRequire("h8HSd");

var $6RzIO = parcelRequire("6RzIO");
function $c5045487affbaf52$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeftStartOfDay = (0, $h8HSd.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $h8HSd.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});
parcelRegister("h8HSd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a5375f03b0a15d$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $c7a5375f03b0a15d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("gDyFX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1cb2fb95fbd857a$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $c1cb2fb95fbd857a$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $6RzIO.default)(2, arguments);
    var time = (0, $le96L.default)(dirtyDate).getTime();
    var startTime = (0, $le96L.default)(interval.start).getTime();
    var endTime = (0, $le96L.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}

});


parcelRegister("hBIc7", function(module, exports) {

$parcel$export(module.exports, "dateRangeWithStrings", function () { return $b22048dac101ff84$export$693be1501f1a1ba1; });
$parcel$export(module.exports, "eachDay", function () { return $b22048dac101ff84$export$53a8306c967c5699; });

var $k0Sb0 = parcelRequire("k0Sb0");

var $ee4HE = parcelRequire("ee4HE");
parcelRequire("9St7S");
var $1rr1p = parcelRequire("1rr1p");

var $qqvI6 = parcelRequire("qqvI6");
const $b22048dac101ff84$export$693be1501f1a1ba1 = (0, $1rr1p.createSelector)((0, $qqvI6.schema).chartRange.select, (chartRange)=>{
    const { start: start, end: end } = chartRange;
    return {
        start: start,
        startString: (0, $k0Sb0.default)(start, 'yyyy-MM-dd'),
        end: end,
        endString: (0, $k0Sb0.default)(end, 'yyyy-MM-dd')
    };
});
const $b22048dac101ff84$export$53a8306c967c5699 = (0, $1rr1p.createSelector)((0, $qqvI6.schema).chartRange.select, (chartRange)=>(0, (/*@__PURE__*/$parcel$interopDefault($ee4HE)))(chartRange));

});
parcelRegister("k0Sb0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e91dd50cc5cd7f0e$export$2e2bcd8739ae039; });

var $7pQzR = parcelRequire("7pQzR");

var $cfoI5 = parcelRequire("cfoI5");

var $le96L = parcelRequire("le96L");

var $3rsJw = parcelRequire("3rsJw");

var $dmQbx = parcelRequire("dmQbx");

var $8zxzx = parcelRequire("8zxzx");

var $xRN1E = parcelRequire("xRN1E");

var $8d3vD = parcelRequire("8d3vD");

var $6RzIO = parcelRequire("6RzIO");

var $dCCOX = parcelRequire("dCCOX");

var $fhQJu = parcelRequire("fhQJu");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e91dd50cc5cd7f0e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e91dd50cc5cd7f0e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e91dd50cc5cd7f0e$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e91dd50cc5cd7f0e$var$doubleQuoteRegExp = /''/g;
var $e91dd50cc5cd7f0e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e91dd50cc5cd7f0e$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $6RzIO.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $fhQJu.default);
    var firstWeekContainsDate = (0, $8d3vD.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $8d3vD.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $le96L.default)(dirtyDate);
    if (!(0, $7pQzR.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $8zxzx.default)(originalDate);
    var utcDate = (0, $cfoI5.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($e91dd50cc5cd7f0e$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $dmQbx.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($e91dd50cc5cd7f0e$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $e91dd50cc5cd7f0e$var$cleanEscapedString(substring);
        var formatter = (0, $3rsJw.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $xRN1E.isProtectedWeekYearToken)(substring)) (0, $xRN1E.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $xRN1E.isProtectedDayOfYearToken)(substring)) (0, $xRN1E.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($e91dd50cc5cd7f0e$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $e91dd50cc5cd7f0e$var$cleanEscapedString(input) {
    var matched = input.match($e91dd50cc5cd7f0e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($e91dd50cc5cd7f0e$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("7pQzR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5663a6fd5511e169$export$2e2bcd8739ae039; });

var $cmc1k = parcelRequire("cmc1k");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $5663a6fd5511e169$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    if (!(0, $cmc1k.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $le96L.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("cmc1k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ff0dd17621a97b7$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $6RzIO = parcelRequire("6RzIO");
function $8ff0dd17621a97b7$export$2e2bcd8739ae039(value) {
    (0, $6RzIO.default)(1, arguments);
    return value instanceof Date || (0, $51lpG.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("cfoI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eaa0dace66c235b$export$2e2bcd8739ae039; });

var $egwKS = parcelRequire("egwKS");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $8eaa0dace66c235b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $egwKS.default)(dirtyDate, -amount);
}

});
parcelRegister("egwKS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a62bf7cf7b9521d9$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $a62bf7cf7b9521d9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var timestamp = (0, $le96L.default)(dirtyDate).getTime();
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});


parcelRegister("3rsJw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $281a2e82d409b287$export$2e2bcd8739ae039; });

var $iUfDY = parcelRequire("iUfDY");

var $9rMx7 = parcelRequire("9rMx7");

var $iymSi = parcelRequire("iymSi");

var $bCYgf = parcelRequire("bCYgf");

var $e0HMe = parcelRequire("e0HMe");

var $jOrUI = parcelRequire("jOrUI");

var $bDYa5 = parcelRequire("bDYa5");
var $281a2e82d409b287$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $281a2e82d409b287$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $bDYa5.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $e0HMe.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $jOrUI.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $jOrUI.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $iymSi.default)(date);
        // Padding
        return (0, $jOrUI.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $jOrUI.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $jOrUI.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $jOrUI.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $bDYa5.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $jOrUI.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $bCYgf.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $jOrUI.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $9rMx7.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $jOrUI.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $bDYa5.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $iUfDY.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $jOrUI.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $jOrUI.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $jOrUI.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $jOrUI.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $bDYa5.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $bDYa5.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $jOrUI.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $jOrUI.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $bDYa5.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $bDYa5.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $bDYa5.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $281a2e82d409b287$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $281a2e82d409b287$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $281a2e82d409b287$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $281a2e82d409b287$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $jOrUI.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $jOrUI.default)(timestamp, token.length);
    }
};
function $281a2e82d409b287$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $jOrUI.default)(minutes, 2);
}
function $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $jOrUI.default)(Math.abs(offset) / 60, 2);
    }
    return $281a2e82d409b287$var$formatTimezone(offset, dirtyDelimiter);
}
function $281a2e82d409b287$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $jOrUI.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $jOrUI.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $281a2e82d409b287$export$2e2bcd8739ae039 = $281a2e82d409b287$var$formatters;

});
parcelRegister("iUfDY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc399780b2b0aec4$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
var $dc399780b2b0aec4$var$MILLISECONDS_IN_DAY = 86400000;
function $dc399780b2b0aec4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dc399780b2b0aec4$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("9rMx7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e0c4858e45e9a69$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $byvVj = parcelRequire("byvVj");

var $60OYk = parcelRequire("60OYk");

var $6RzIO = parcelRequire("6RzIO");
var $6e0c4858e45e9a69$var$MILLISECONDS_IN_WEEK = 604800000;
function $6e0c4858e45e9a69$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var diff = (0, $byvVj.default)(date).getTime() - (0, $60OYk.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $6e0c4858e45e9a69$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("byvVj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $869ba20767f1348a$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $869ba20767f1348a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $le96L.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("60OYk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $460a48298a6e483f$export$2e2bcd8739ae039; });

var $iymSi = parcelRequire("iymSi");

var $byvVj = parcelRequire("byvVj");

var $6RzIO = parcelRequire("6RzIO");
function $460a48298a6e483f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var year = (0, $iymSi.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $byvVj.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("iymSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d81d25690b2c97ba$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $byvVj = parcelRequire("byvVj");
function $d81d25690b2c97ba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $byvVj.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $byvVj.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("bCYgf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8771fceed12cf89e$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $j1YKz = parcelRequire("j1YKz");

var $2yvSN = parcelRequire("2yvSN");

var $6RzIO = parcelRequire("6RzIO");
var $8771fceed12cf89e$var$MILLISECONDS_IN_WEEK = 604800000;
function $8771fceed12cf89e$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var diff = (0, $j1YKz.default)(date, options).getTime() - (0, $2yvSN.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $8771fceed12cf89e$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("j1YKz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddad3c02657f84fd$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");

var $dCCOX = parcelRequire("dCCOX");
function $ddad3c02657f84fd$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var weekStartsOn = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $le96L.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("dCCOX", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $9eacf000ef47a2dd$export$430a3269e24b912e; });
var $9eacf000ef47a2dd$var$defaultOptions = {};
function $9eacf000ef47a2dd$export$430a3269e24b912e() {
    return $9eacf000ef47a2dd$var$defaultOptions;
}
function $9eacf000ef47a2dd$export$95365be1b0704abc(newOptions) {
    $9eacf000ef47a2dd$var$defaultOptions = newOptions;
}

});


parcelRegister("2yvSN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dc77d031b6877e7$export$2e2bcd8739ae039; });

var $e0HMe = parcelRequire("e0HMe");

var $6RzIO = parcelRequire("6RzIO");

var $j1YKz = parcelRequire("j1YKz");

var $8d3vD = parcelRequire("8d3vD");

var $dCCOX = parcelRequire("dCCOX");
function $1dc77d031b6877e7$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var firstWeekContainsDate = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $e0HMe.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $j1YKz.default)(firstWeek, options);
    return date;
}

});
parcelRegister("e0HMe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a33305f247e30adc$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $j1YKz = parcelRequire("j1YKz");

var $8d3vD = parcelRequire("8d3vD");

var $dCCOX = parcelRequire("dCCOX");
function $a33305f247e30adc$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var firstWeekContainsDate = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $j1YKz.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $j1YKz.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("jOrUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6c856ebc9ae82ee$export$2e2bcd8739ae039; });
function $e6c856ebc9ae82ee$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("bDYa5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87a2011828c90e33$export$2e2bcd8739ae039; });

var $jOrUI = parcelRequire("jOrUI");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $87a2011828c90e33$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $jOrUI.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $jOrUI.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $jOrUI.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $jOrUI.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $jOrUI.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $jOrUI.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $jOrUI.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $jOrUI.default)(fractionalSeconds, token.length);
    }
};
var $87a2011828c90e33$export$2e2bcd8739ae039 = $87a2011828c90e33$var$formatters;

});


parcelRegister("dmQbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bb5cf506dd06653$export$2e2bcd8739ae039; });
var $9bb5cf506dd06653$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $9bb5cf506dd06653$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $9bb5cf506dd06653$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $9bb5cf506dd06653$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $9bb5cf506dd06653$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $9bb5cf506dd06653$var$timeLongFormatter(timePattern, formatLong));
};
var $9bb5cf506dd06653$var$longFormatters = {
    p: $9bb5cf506dd06653$var$timeLongFormatter,
    P: $9bb5cf506dd06653$var$dateTimeLongFormatter
};
var $9bb5cf506dd06653$export$2e2bcd8739ae039 = $9bb5cf506dd06653$var$longFormatters;

});

parcelRegister("8zxzx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63dba254cf419de0$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $63dba254cf419de0$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("xRN1E", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $065cceb4149e3fc5$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $065cceb4149e3fc5$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $065cceb4149e3fc5$export$8073c1ae88f0e727; });
var $065cceb4149e3fc5$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $065cceb4149e3fc5$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $065cceb4149e3fc5$export$c6cc36aa33304772(token) {
    return $065cceb4149e3fc5$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $065cceb4149e3fc5$export$c6b49d6dceb604a1(token) {
    return $065cceb4149e3fc5$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $065cceb4149e3fc5$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("fhQJu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b211592c26324d97$export$2e2bcd8739ae039; });

var $eG059 = parcelRequire("eG059");
var $b211592c26324d97$export$2e2bcd8739ae039 = (0, $eG059.default);

});
parcelRegister("eG059", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aaf50d37016ddcb1$export$2e2bcd8739ae039; });

var $bvM2P = parcelRequire("bvM2P");

var $haCAZ = parcelRequire("haCAZ");

var $AVlzc = parcelRequire("AVlzc");

var $eiIUR = parcelRequire("eiIUR");

var $8rsbS = parcelRequire("8rsbS");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $aaf50d37016ddcb1$var$locale = {
    code: 'en-US',
    formatDistance: (0, $bvM2P.default),
    formatLong: (0, $haCAZ.default),
    formatRelative: (0, $AVlzc.default),
    localize: (0, $eiIUR.default),
    match: (0, $8rsbS.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $aaf50d37016ddcb1$export$2e2bcd8739ae039 = $aaf50d37016ddcb1$var$locale;

});
parcelRegister("bvM2P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8617db99f2cb39a3$export$2e2bcd8739ae039; });
var $8617db99f2cb39a3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $8617db99f2cb39a3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8617db99f2cb39a3$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $8617db99f2cb39a3$export$2e2bcd8739ae039 = $8617db99f2cb39a3$var$formatDistance;

});

parcelRegister("haCAZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8014f25de2be27f$export$2e2bcd8739ae039; });

var $lbh04 = parcelRequire("lbh04");
var $c8014f25de2be27f$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $c8014f25de2be27f$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $c8014f25de2be27f$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $c8014f25de2be27f$var$formatLong = {
    date: (0, $lbh04.default)({
        formats: $c8014f25de2be27f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $lbh04.default)({
        formats: $c8014f25de2be27f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $lbh04.default)({
        formats: $c8014f25de2be27f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c8014f25de2be27f$export$2e2bcd8739ae039 = $c8014f25de2be27f$var$formatLong;

});
parcelRegister("lbh04", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6b7cff3d084a1cf$export$2e2bcd8739ae039; });
function $f6b7cff3d084a1cf$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("AVlzc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06efd8cc10c4bd73$export$2e2bcd8739ae039; });
var $06efd8cc10c4bd73$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $06efd8cc10c4bd73$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $06efd8cc10c4bd73$var$formatRelativeLocale[token];
};
var $06efd8cc10c4bd73$export$2e2bcd8739ae039 = $06efd8cc10c4bd73$var$formatRelative;

});

parcelRegister("eiIUR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6959687464919d6$export$2e2bcd8739ae039; });

var $jZkn4 = parcelRequire("jZkn4");
var $a6959687464919d6$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $a6959687464919d6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $a6959687464919d6$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $a6959687464919d6$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $a6959687464919d6$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $a6959687464919d6$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $a6959687464919d6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $a6959687464919d6$var$localize = {
    ordinalNumber: $a6959687464919d6$var$ordinalNumber,
    era: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a6959687464919d6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a6959687464919d6$export$2e2bcd8739ae039 = $a6959687464919d6$var$localize;

});
parcelRegister("jZkn4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8d3841961a689fd$export$2e2bcd8739ae039; });
function $e8d3841961a689fd$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("8rsbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6256b66dca390462$export$2e2bcd8739ae039; });

var $gcy5I = parcelRequire("gcy5I");

var $jChsd = parcelRequire("jChsd");
var $6256b66dca390462$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $6256b66dca390462$var$parseOrdinalNumberPattern = /\d+/i;
var $6256b66dca390462$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $6256b66dca390462$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $6256b66dca390462$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $6256b66dca390462$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6256b66dca390462$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $6256b66dca390462$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $6256b66dca390462$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $6256b66dca390462$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $6256b66dca390462$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $6256b66dca390462$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $6256b66dca390462$var$match = {
    ordinalNumber: (0, $jChsd.default)({
        matchPattern: $6256b66dca390462$var$matchOrdinalNumberPattern,
        parsePattern: $6256b66dca390462$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6256b66dca390462$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6256b66dca390462$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6256b66dca390462$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6256b66dca390462$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6256b66dca390462$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6256b66dca390462$export$2e2bcd8739ae039 = $6256b66dca390462$var$match;

});
parcelRegister("gcy5I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcb83626ff750417$export$2e2bcd8739ae039; });
function $bcb83626ff750417$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $bcb83626ff750417$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $bcb83626ff750417$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $bcb83626ff750417$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $bcb83626ff750417$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("jChsd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03af782d2d1fcb5a$export$2e2bcd8739ae039; });
function $03af782d2d1fcb5a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("ee4HE", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $a5b6056b4e2f4205$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5b6056b4e2f4205$var$_index = $a5b6056b4e2f4205$require$_interopRequireDefault((parcelRequire("azyJF")));

var $a5b6056b4e2f4205$var$_index2 = $a5b6056b4e2f4205$require$_interopRequireDefault((parcelRequire("jKO47")));
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var $a5b6056b4e2f4205$var$_default = (0, $a5b6056b4e2f4205$var$_index2.default)($a5b6056b4e2f4205$var$_index.default, 1);
module.exports.default = $a5b6056b4e2f4205$var$_default;
module.exports = module.exports.default;

});
parcelRegister("azyJF", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
var $7b281e0980823a3e$require$_interopRequireDefault = $2ZnTs.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7b281e0980823a3e$var$eachDayOfInterval;

var $7b281e0980823a3e$var$_index = $7b281e0980823a3e$require$_interopRequireDefault((parcelRequire("99U8H")));

var $7b281e0980823a3e$var$_index2 = $7b281e0980823a3e$require$_interopRequireDefault((parcelRequire("kMAIB")));
/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function $7b281e0980823a3e$var$eachDayOfInterval(dirtyInterval, options) {
    var _options$step;
    (0, $7b281e0980823a3e$var$_index2.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $7b281e0980823a3e$var$_index.default)(interval.start);
    var endDate = (0, $7b281e0980823a3e$var$_index.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, $7b281e0980823a3e$var$_index.default)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}
module.exports = module.exports.default;

});




parcelRegister("7BL3D", function(module, exports) {

$parcel$export(module.exports, "floatFromDinero", function () { return $d3e3d94113986d24$export$6418c34b373cf55c; });
$parcel$export(module.exports, "scaledFromFloat", function () { return $d3e3d94113986d24$export$a399e1be67d72f3f; });
$parcel$export(module.exports, "floatFromScaled", function () { return $d3e3d94113986d24$export$78a376bcaad68abd; });
$parcel$export(module.exports, "redinero", function () { return $d3e3d94113986d24$export$395ded569794395d; });
$parcel$export(module.exports, "toHumanCurrency", function () { return $d3e3d94113986d24$export$d66b0f7007165004; });
$parcel$export(module.exports, "toHumanInterest", function () { return $d3e3d94113986d24$export$99ddbcbf59945d1; });

var $8xOSr = parcelRequire("8xOSr");

var $6HqIz = parcelRequire("6HqIz");
var $2U14E = parcelRequire("2U14E");
function $d3e3d94113986d24$export$ade77fe35bc16802({ amount: float, currency: currency, scale: scale }) {
    // eventually need to consider base can be an array
    const base = currency.base;
    const factor = base ** (scale || currency.exponent);
    const amount = Math.round(float * factor);
    return (0, $6HqIz.dinero)({
        amount: amount,
        currency: currency,
        scale: scale
    });
}
function $d3e3d94113986d24$export$6418c34b373cf55c(d) {
    return parseFloat((0, $2U14E.toDecimal)(d));
}
function $d3e3d94113986d24$export$a399e1be67d72f3f(value, scale) {
    const factor = 10 ** scale;
    const amount = Math.round(value * factor);
    return {
        amount: amount,
        scale: -scale
    };
}
function $d3e3d94113986d24$export$78a376bcaad68abd({ amount: amount, scale: scale }, additionalScale) {
    const factor = Math.pow(10, scale + (additionalScale ?? 0));
    return amount * factor;
}
function $d3e3d94113986d24$export$395ded569794395d(value) {
    if (value === null || value === undefined) throw new Error(`value is ${value}`);
    if (typeof value === 'number') return $d3e3d94113986d24$export$ade77fe35bc16802({
        amount: value,
        currency: (0, $8xOSr.USD)
    });
    else if (typeof value === 'object' && 'amount' in value) return (0, $6HqIz.dinero)(value);
    return value;
}
// This function lets you pass a transformer and rounding options.
// It returns a function that takes a Dinero object and applies
// the closured transformer.
function $d3e3d94113986d24$var$createFormatter(transformer) {
    return function formatter(dineroObject) {
        return (0, $2U14E.toDecimal)(dineroObject, transformer);
    };
}
const $d3e3d94113986d24$export$d66b0f7007165004 = $d3e3d94113986d24$var$createFormatter(({ value: value, currency: currency })=>`${currency.code === 'USD' ? '$' : `${currency.code} `}${value}`);
const $d3e3d94113986d24$export$99ddbcbf59945d1 = ({ amount: amount, scale: scale, leadingSymbol: leadingSymbol = '', trailingSymbol: trailingSymbol = '' })=>{
    if (amount === 0) return `${leadingSymbol}0${trailingSymbol}`;
    const stringifiedArray = amount.toString().split('');
    // apply operations backwards
    stringifiedArray.reverse();
    stringifiedArray.splice(-scale - 2, 0, '.');
    // remove trailing zeros
    let trailingZeros = 0;
    for (let v of stringifiedArray){
        if (v === '0' || v === '.') trailingZeros++;
        else break;
    }
    const finalStringArray = stringifiedArray.slice(trailingZeros).reverse();
    if (finalStringArray[0] === '.') finalStringArray.splice(0, 0, '0');
    // add symbols to final string
    finalStringArray.splice(0, 0, leadingSymbol);
    finalStringArray.push(trailingSymbol);
    return finalStringArray.join('');
};

});
parcelRegister("2U14E", function(module, exports) {

$parcel$export(module.exports, "toDecimal", function () { return $21d1a5055eb3f10b$export$63ad841d70774900; });

var $bLCfm = parcelRequire("bLCfm");
function $21d1a5055eb3f10b$export$63ad841d70774900() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var dineroObject = _ref[0], transformer = _ref[1];
    var calculator = dineroObject.calculator;
    var toDecimalFn = (0, $bLCfm.toDecimal)(calculator);
    return toDecimalFn(dineroObject, transformer);
}

});
parcelRegister("bLCfm", function(module, exports) {

$parcel$export(module.exports, "toDecimal", function () { return $8911c08286c95ca6$export$63ad841d70774900; });

var $3GfaA = parcelRequire("3GfaA");

var $17TDA = parcelRequire("17TDA");

var $1lQUj = parcelRequire("1lQUj");
var $bXvrv = parcelRequire("bXvrv");
var $Q8hIv = parcelRequire("Q8hIv");
var $2fOuk = parcelRequire("2fOuk");
var $9jnce = parcelRequire("9jnce");

var $3Y5Nz = parcelRequire("3Y5Nz");
function $8911c08286c95ca6$export$63ad841d70774900(calculator) {
    var toUnitsFn = (0, $3Y5Nz.toUnits)(calculator);
    var computeBaseFn = (0, $bXvrv.computeBase)(calculator);
    var equalFn = (0, $Q8hIv.equal)(calculator);
    return function toDecimalFn() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], transformer = _ref[1];
        var _dineroObject$toJSON = dineroObject.toJSON(), currency = _dineroObject$toJSON.currency, scale = _dineroObject$toJSON.scale;
        var base = computeBaseFn(currency.base);
        var zero = calculator.zero();
        var ten = new Array(10).fill(null).reduce(calculator.increment, zero);
        var isMultiBase = (0, $2fOuk.isArray)(currency.base);
        var isBaseTen = equalFn(calculator.modulo(base, ten), zero);
        var isDecimal = !isMultiBase && isBaseTen;
        // eslint-disable-next-line functional/no-expression-statement
        (0, $17TDA.assert)(isDecimal, (0, $3GfaA.NON_DECIMAL_CURRENCY_MESSAGE));
        var units = toUnitsFn(dineroObject);
        var getDecimalFn = $8911c08286c95ca6$var$getDecimal(calculator, dineroObject.formatter);
        var value = getDecimalFn(units, scale);
        if (!transformer) return value;
        return transformer({
            value: value,
            currency: currency
        });
    };
}
function $8911c08286c95ca6$var$getDecimal(calculator, formatter) {
    var absoluteFn = (0, $1lQUj.absolute)(calculator);
    var equalFn = (0, $Q8hIv.equal)(calculator);
    var lessThanFn = (0, $9jnce.lessThan)(calculator);
    var zero = calculator.zero();
    return function(units, scale) {
        var whole = formatter.toString(units[0]);
        var fractional = formatter.toString(absoluteFn(units[1]));
        var scaleNumber = formatter.toNumber(scale);
        var decimal = "".concat(whole, ".").concat(fractional.padStart(scaleNumber, '0'));
        var leadsWithZero = equalFn(units[0], zero);
        var isNegative = lessThanFn(units[1], zero);
        // A leading negative zero is a special case because the `toString`
        // formatter won't preserve its negative sign (since 0 === -0).
        return leadsWithZero && isNegative ? "-".concat(decimal) : decimal;
    };
}

});
parcelRegister("1lQUj", function(module, exports) {

$parcel$export(module.exports, "absolute", function () { return $0fc0cae939db0b05$export$d31af2dc8039efd3; });

var $Q8hIv = parcelRequire("Q8hIv");

var $9jnce = parcelRequire("9jnce");
function $0fc0cae939db0b05$export$d31af2dc8039efd3(calculator) {
    var equalFn = (0, $Q8hIv.equal)(calculator);
    var lessThanFn = (0, $9jnce.lessThan)(calculator);
    var zero = calculator.zero();
    return function(input) {
        if (equalFn(input, zero)) return zero;
        if (lessThanFn(input, zero)) {
            var minusOne = calculator.decrement(zero);
            return calculator.multiply(minusOne, input);
        }
        return input;
    };
}

});

parcelRegister("3Y5Nz", function(module, exports) {

$parcel$export(module.exports, "toUnits", function () { return $2e3b792704cb2f9a$export$4059381979a3a85c; });

var $9mhCK = parcelRequire("9mhCK");
var $2fOuk = parcelRequire("2fOuk");
function $2e3b792704cb2f9a$var$_toConsumableArray(arr) {
    return $2e3b792704cb2f9a$var$_arrayWithoutHoles(arr) || $2e3b792704cb2f9a$var$_iterableToArray(arr) || $2e3b792704cb2f9a$var$_unsupportedIterableToArray(arr) || $2e3b792704cb2f9a$var$_nonIterableSpread();
}
function $2e3b792704cb2f9a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2e3b792704cb2f9a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2e3b792704cb2f9a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2e3b792704cb2f9a$var$_arrayLikeToArray(o, minLen);
}
function $2e3b792704cb2f9a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $2e3b792704cb2f9a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2e3b792704cb2f9a$var$_arrayLikeToArray(arr);
}
function $2e3b792704cb2f9a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2e3b792704cb2f9a$export$4059381979a3a85c(calculator) {
    var getDivisorsFn = (0, $9mhCK.getDivisors)(calculator);
    return function toUnitsFn() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], transformer = _ref[1];
        var _dineroObject$toJSON = dineroObject.toJSON(), amount = _dineroObject$toJSON.amount, currency = _dineroObject$toJSON.currency, scale = _dineroObject$toJSON.scale;
        var power = calculator.power, integerDivide = calculator.integerDivide, modulo = calculator.modulo;
        var bases = (0, $2fOuk.isArray)(currency.base) ? currency.base : [
            currency.base
        ];
        var divisors = getDivisorsFn(bases.map(function(base) {
            return power(base, scale);
        }));
        var value = divisors.reduce(function(amounts, divisor, index) {
            var amountLeft = amounts[index];
            var quotient = integerDivide(amountLeft, divisor);
            var remainder = modulo(amountLeft, divisor);
            return [].concat($2e3b792704cb2f9a$var$_toConsumableArray(amounts.filter(function(_, i) {
                return i !== index;
            })), [
                quotient,
                remainder
            ]);
        }, [
            amount
        ]);
        if (!transformer) return value;
        return transformer({
            value: value,
            currency: currency
        });
    };
}

});
parcelRegister("9mhCK", function(module, exports) {

$parcel$export(module.exports, "getDivisors", function () { return $6d03d6e333d66fc9$export$e7d37819eb69f4b9; });
function $6d03d6e333d66fc9$var$_toConsumableArray(arr) {
    return $6d03d6e333d66fc9$var$_arrayWithoutHoles(arr) || $6d03d6e333d66fc9$var$_iterableToArray(arr) || $6d03d6e333d66fc9$var$_unsupportedIterableToArray(arr) || $6d03d6e333d66fc9$var$_nonIterableSpread();
}
function $6d03d6e333d66fc9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6d03d6e333d66fc9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6d03d6e333d66fc9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6d03d6e333d66fc9$var$_arrayLikeToArray(o, minLen);
}
function $6d03d6e333d66fc9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6d03d6e333d66fc9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6d03d6e333d66fc9$var$_arrayLikeToArray(arr);
}
function $6d03d6e333d66fc9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6d03d6e333d66fc9$export$e7d37819eb69f4b9(calculator) {
    var multiply = calculator.multiply;
    return function(bases) {
        return bases.reduce(function(divisors, _, i) {
            var divisor = bases.slice(i).reduce(function(acc, curr) {
                return multiply(acc, curr);
            });
            return [].concat($6d03d6e333d66fc9$var$_toConsumableArray(divisors), [
                divisor
            ]);
        }, []);
    };
}

});





parcelRegister("2dBzU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70641c4ee4be6fe9$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $7jgDZ = parcelRequire("7jgDZ");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("aWtcP");
var $cPVO8 = parcelRequire("cPVO8");

var $cVMeo = parcelRequire("cVMeo");
var $eA2Db = parcelRequire("eA2Db");

var $9bdVj = parcelRequire("9bdVj");

var $bqgKG = parcelRequire("bqgKG");

var $eoNPv = parcelRequire("eoNPv");

var $1y9Ig = parcelRequire("1y9Ig");

var $em0X4 = parcelRequire("em0X4");

var $gbJfF = parcelRequire("gbJfF");
const $70641c4ee4be6fe9$var$TransactionsFlow = ({ transactions: transactions })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const [transactionFilter, setTransactionFilter] = (0, $bh6RR.useState)('all');
    const [activeView, setActiveView] = (0, $bh6RR.useState)(new Set([
        'table'
    ]));
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex py-2",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bqgKG.TagGroup), {
                        selectionMode: "multiple",
                        defaultSelectedKeys: 'all',
                        onSelectionChange: (keys)=>setTransactionFilter(keys),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bqgKG.Tag), {
                                id: "income",
                                className: "py-2 px-4",
                                children: "Income"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bqgKG.Tag), {
                                id: "expense",
                                className: "py-2 px-4",
                                children: "Expenses"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $bqgKG.Tag), {
                                id: "transfer",
                                className: "py-2 px-4",
                                children: "Transfers"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "grow flex justify-end",
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eA2Db.MenuTrigger), {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $eoNPv.Button), {
                                    "aria-label": "Menu",
                                    children: "..."
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $cVMeo.Menu), {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eA2Db.MenuSection), {
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $7jgDZ.Header), {
                                                    children: "Actions"
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cVMeo.MenuItem), {
                                                    onAction: ()=>navigate('/transactions/set'),
                                                    children: "Add..."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $9bdVj.Separator), {}),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eA2Db.MenuSection), {
                                            selectionMode: "single",
                                            selectedKeys: activeView,
                                            onSelectionChange: setActiveView,
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $7jgDZ.Header), {
                                                    children: "View"
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cVMeo.MenuItem), {
                                                    id: "table",
                                                    children: "as Table"
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cVMeo.MenuItem), {
                                                    id: "cards",
                                                    children: "as Cards"
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $cVMeo.MenuItem), {
                                                    id: "timeline",
                                                    children: "as Timeline"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($70641c4ee4be6fe9$var$DisplayTransactions, {
                navigate: navigate,
                // @ts-expect-error just pulling it out of a Set
                activeView: [
                    ...activeView.entries()
                ][0][0],
                transactions: transactions,
                transactionFilter: transactionFilter
            })
        ]
    });
};
var $70641c4ee4be6fe9$export$2e2bcd8739ae039 = $70641c4ee4be6fe9$var$TransactionsFlow;
const $70641c4ee4be6fe9$var$DisplayTransactions = ({ navigate: navigate, activeView: activeView, transactions: transactions, transactionFilter: transactionFilter })=>{
    const dispatch = (0, $cPVO8.useDispatch)();
    switch(activeView){
        case 'all':
        case 'table':
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $em0X4.TransactionTable), {
                label: "Transactions",
                transactions: transactions,
                transactionFilter: transactionFilter,
                navigate: navigate,
                dispatch: dispatch
            });
        case 'cards':
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1y9Ig.TransactionCards), {
                transactions: transactions,
                transactionFilter: transactionFilter,
                navigate: navigate,
                dispatch: dispatch
            });
        case 'timeline':
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $gbJfF.TransactionTimeline), {
                transactions: transactions,
                transactionFilter: transactionFilter,
                navigate: navigate,
                dispatch: dispatch
            });
    }
};

});
parcelRegister("cVMeo", function(module, exports) {

$parcel$export(module.exports, "Menu", function () { return $ccaba63285766d29$export$d9b273488cd8ce6f; });
$parcel$export(module.exports, "MenuItem", function () { return $ccaba63285766d29$export$2ce376c2cc3355c8; });
$parcel$export(module.exports, "MenuTrigger", function () { return (parcelRequire("eA2Db")).MenuTrigger; });
$parcel$export(module.exports, "MenuSection", function () { return (parcelRequire("eA2Db")).MenuSection; });

var $ih19M = parcelRequire("ih19M");

var $68TtM = parcelRequire("68TtM");
var $iff6j = parcelRequire("iff6j");
parcelRequire("bh6RR");

var $dgWhj = parcelRequire("dgWhj");
var $eA2Db = parcelRequire("eA2Db");
var $5lycU = parcelRequire("5lycU");

var $dgG9a = parcelRequire("dgG9a");

var $gP3Xs = parcelRequire("gP3Xs");
function $ccaba63285766d29$export$d9b273488cd8ce6f(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $gP3Xs.Popover), {
        placement: props.placement,
        className: "min-w-[150px]",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eA2Db.Menu), {
            ...props,
            className: "p-1 outline outline-0 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]"
        })
    });
}
function $ccaba63285766d29$export$2ce376c2cc3355c8(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $eA2Db.MenuItem), {
        ...props,
        className: (0, $dgG9a.dropdownItemStyles),
        children: (0, $dgWhj.composeRenderProps)(props.children, (children, { selectionMode: selectionMode, isSelected: isSelected, hasSubmenu: hasSubmenu })=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    selectionMode !== 'none' && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "flex items-center w-4",
                        children: isSelected && /*#__PURE__*/ (0, $ih19M.jsx)((0, $68TtM.default), {
                            "aria-hidden": true,
                            className: "w-4 h-4"
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "flex items-center flex-1 gap-2 font-normal truncate group-selected:font-semibold",
                        children: children
                    }),
                    hasSubmenu && /*#__PURE__*/ (0, $ih19M.jsx)((0, $iff6j.default), {
                        "aria-hidden": true,
                        className: "absolute w-4 h-4 right-2"
                    })
                ]
            }))
    });
}
function $ccaba63285766d29$export$1cec7dcdd713e220(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5lycU.Separator), {
        ...props,
        className: "mx-3 my-1 border-b border-gray-300 dark:border-zinc-700"
    });
}

});
parcelRegister("68TtM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $478e86736754ce44$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $478e86736754ce44$export$2e2bcd8739ae039 = (0, $iUesJ.default)("Check", [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
]);

});

parcelRegister("iff6j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d485576637b8ac4f$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $d485576637b8ac4f$export$2e2bcd8739ae039 = (0, $iUesJ.default)("ChevronRight", [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
]);

});

parcelRegister("dgG9a", function(module, exports) {

$parcel$export(module.exports, "ListBoxItem", function () { return $52da536ff4c9032f$export$a11e76429ed99b4; });
$parcel$export(module.exports, "dropdownItemStyles", function () { return $52da536ff4c9032f$export$c91e3c1c0e6e8314; });
$parcel$export(module.exports, "DropdownItem", function () { return $52da536ff4c9032f$export$6648d5fa18559e7f; });
$parcel$export(module.exports, "DropdownSection", function () { return $52da536ff4c9032f$export$7ab5ff309fff16bb; });

var $ih19M = parcelRequire("ih19M");

var $68TtM = parcelRequire("68TtM");
parcelRequire("bh6RR");

var $eqvPU = parcelRequire("eqvPU");
var $dgWhj = parcelRequire("dgWhj");
var $7jgDZ = parcelRequire("7jgDZ");
var $5Ihf9 = parcelRequire("5Ihf9");
var $juOz0 = parcelRequire("juOz0");

var $9SfKt = parcelRequire("9SfKt");

var $eGtYl = parcelRequire("eGtYl");
function $52da536ff4c9032f$export$41f133550aa26f48({ children: children, ...props }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Ihf9.ListBox), {
        ...props,
        className: (0, $eGtYl.composeTailwindRenderProps)(props.className, 'outline-0 p-1 border border-gray-300 dark:border-zinc-600 rounded-lg'),
        children: children
    });
}
const $52da536ff4c9032f$export$25fefe78d771888d = (0, $9SfKt.tv)({
    extend: (0, $eGtYl.focusRing),
    base: 'group relative flex items-center gap-8 cursor-default select-none py-1.5 px-2.5 rounded-md will-change-transform text-sm forced-color-adjust-none',
    variants: {
        isSelected: {
            false: 'text-slate-700 dark:text-zinc-300 hover:bg-slate-200 dark:hover:bg-zinc-700 -outline-offset-2',
            true: 'bg-blue-600 text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] [&:has(+[data-selected])]:rounded-b-none [&+[data-selected]]:rounded-t-none -outline-offset-4 outline-white dark:outline-white forced-colors:outline-[HighlightText]'
        },
        isDisabled: {
            true: 'text-slate-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        }
    }
});
function $52da536ff4c9032f$export$a11e76429ed99b4(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Ihf9.ListBoxItem), {
        ...props,
        textValue: textValue,
        className: $52da536ff4c9032f$export$25fefe78d771888d,
        children: (0, $dgWhj.composeRenderProps)(props.children, (children)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    children,
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "absolute left-4 right-4 bottom-0 h-px bg-white/20 forced-colors:bg-[HighlightText] hidden [.group[data-selected]:has(+[data-selected])_&]:block"
                    })
                ]
            }))
    });
}
const $52da536ff4c9032f$export$c91e3c1c0e6e8314 = (0, $9SfKt.tv)({
    base: 'group flex items-center gap-4 cursor-default select-none py-2 pl-3 pr-1 rounded-lg outline outline-0 text-sm forced-color-adjust-none',
    variants: {
        isDisabled: {
            false: 'text-gray-900 dark:text-zinc-100',
            true: 'text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        },
        isFocused: {
            true: 'bg-blue-600 text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText]'
        }
    }
});
function $52da536ff4c9032f$export$6648d5fa18559e7f(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Ihf9.ListBoxItem), {
        ...props,
        textValue: textValue,
        className: $52da536ff4c9032f$export$c91e3c1c0e6e8314,
        children: (0, $dgWhj.composeRenderProps)(props.children, (children, { isSelected: isSelected })=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "flex-1 flex items-center gap-2 truncate font-normal group-selected:font-semibold",
                        children: children
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "w-5 flex items-center",
                        children: isSelected && /*#__PURE__*/ (0, $ih19M.jsx)((0, $68TtM.default), {
                            className: "w-4 h-4"
                        })
                    })
                ]
            }))
    });
}
function $52da536ff4c9032f$export$7ab5ff309fff16bb(props) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $juOz0.Section), {
        className: "first:-mt-[5px] after:content-[''] after:block after:h-[5px]",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $7jgDZ.Header), {
                className: "text-sm font-semibold text-gray-500 dark:text-zinc-300 px-4 py-1 truncate sticky -top-[5px] -mt-px -mx-1 z-10 bg-gray-100/60 dark:bg-zinc-700/60 backdrop-blur-md supports-[-moz-appearance:none]:bg-gray-100 border-y dark:border-y-zinc-700 [&+*]:mt-1",
                children: props.title
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eqvPU.Collection), {
                items: props.items,
                children: props.children
            })
        ]
    });
}

});
parcelRegister("5Ihf9", function(module, exports) {

$parcel$export(module.exports, "ListBoxContext", function () { return $5a93616fe5d32958$export$7ff8f37d2d81a48d; });
$parcel$export(module.exports, "ListStateContext", function () { return $5a93616fe5d32958$export$7c5906fe4f1f2af2; });
$parcel$export(module.exports, "ListBox", function () { return $5a93616fe5d32958$export$41f133550aa26f48; });
$parcel$export(module.exports, "ListBoxItem", function () { return $5a93616fe5d32958$export$a11e76429ed99b4; });

var $juOz0 = parcelRequire("juOz0");

var $dgWhj = parcelRequire("dgWhj");

var $4HVSY = parcelRequire("4HVSY");

var $7jgDZ = parcelRequire("7jgDZ");

var $5lycU = parcelRequire("5lycU");

var $5Oi9Z = parcelRequire("5Oi9Z");

var $2NhrA = parcelRequire("2NhrA");
var $36LQn = parcelRequire("36LQn");
var $hAxtE = parcelRequire("hAxtE");
var $7caxR = parcelRequire("7caxR");
var $5Gawp = parcelRequire("5Gawp");
var $i91F7 = parcelRequire("i91F7");
var $kTnkE = parcelRequire("kTnkE");
var $daJU6 = parcelRequire("daJU6");
var $c8uzR = parcelRequire("c8uzR");
var $29c4f = parcelRequire("29c4f");

var $eqvPU = parcelRequire("eqvPU");

var $gfBTL = parcelRequire("gfBTL");

var $bG0JH = parcelRequire("bG0JH");
var $jyDr8 = parcelRequire("jyDr8");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5a93616fe5d32958$export$7ff8f37d2d81a48d = (0, $bh6RR.createContext)(null);
const $5a93616fe5d32958$export$7c5906fe4f1f2af2 = (0, $bh6RR.createContext)(null);
function $5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBox(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $5a93616fe5d32958$export$7ff8f37d2d81a48d);
    let state = (0, $bh6RR.useContext)($5a93616fe5d32958$export$7c5906fe4f1f2af2);
    // The structure of ListBox is a bit strange because it needs to work inside other components like ComboBox and Select.
    // Those components render two copies of their children so that the collection can be built even when the popover is closed.
    // The first copy sends a collection document via context which we render the collection portal into.
    // The second copy sends a ListState object via context which we use to render the ListBox without rebuilding the state.
    // Otherwise, we have a standalone ListBox, so we need to create a collection and state ourselves.
    if (state) return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBoxInner, {
        state: state,
        props: props,
        listBoxRef: ref
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eqvPU.CollectionBuilder), {
        content: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eqvPU.Collection), props)
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($5a93616fe5d32958$var$$eed445e0843c11d0$var$StandaloneListBox, {
            props: props,
            listBoxRef: ref,
            collection: collection
        }));
}
function $5a93616fe5d32958$var$$eed445e0843c11d0$var$StandaloneListBox({ props: props, listBoxRef: listBoxRef, collection: collection }) {
    props = {
        ...props,
        collection: collection,
        children: null,
        items: null
    };
    let { layoutDelegate: layoutDelegate } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let state = (0, $gfBTL.useListState)({
        ...props,
        layoutDelegate: layoutDelegate
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBoxInner, {
        state: state,
        props: props,
        listBoxRef: listBoxRef
    });
}
/**
 * A listbox displays a list of options and allows a user to select one or more of them.
 */ const $5a93616fe5d32958$export$41f133550aa26f48 = (0, $bh6RR.forwardRef)($5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBox);
function $5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBoxInner({ state: state, props: props, listBoxRef: listBoxRef }) {
    let { dragAndDropHooks: dragAndDropHooks, layout: layout = 'stack', orientation: orientation = 'vertical' } = props;
    let { collection: collection, selectionManager: selectionManager } = state;
    let isListDraggable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDraggableCollectionState);
    let isListDroppable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDroppableCollectionState);
    let { direction: direction } = (0, $c8uzR.useLocale)();
    let { disabledBehavior: disabledBehavior, disabledKeys: disabledKeys } = selectionManager;
    let collator = (0, $7caxR.useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let { isVirtualized: isVirtualized, layoutDelegate: layoutDelegate, dropTargetDelegate: ctxDropTargetDelegate, CollectionRoot: CollectionRoot } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let keyboardDelegate = (0, $bh6RR.useMemo)(()=>props.keyboardDelegate || new (0, $36LQn.ListKeyboardDelegate)({
            collection: collection,
            collator: collator,
            ref: listBoxRef,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            layout: layout,
            orientation: orientation,
            direction: direction,
            layoutDelegate: layoutDelegate
        }), [
        collection,
        collator,
        listBoxRef,
        disabledBehavior,
        disabledKeys,
        orientation,
        direction,
        props.keyboardDelegate,
        layout,
        layoutDelegate
    ]);
    let { listBoxProps: listBoxProps } = (0, $kTnkE.useListBox)({
        ...props,
        shouldSelectOnPressUp: isListDraggable || props.shouldSelectOnPressUp,
        keyboardDelegate: keyboardDelegate,
        isVirtualized: isVirtualized
    }, state, listBoxRef);
    let dragHooksProvided = (0, $bh6RR.useRef)(isListDraggable);
    let dropHooksProvided = (0, $bh6RR.useRef)(isListDroppable);
    (0, $bh6RR.useEffect)(()=>{
        if (dragHooksProvided.current !== isListDraggable) console.warn('Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
        if (dropHooksProvided.current !== isListDroppable) console.warn('Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
    }, [
        isListDraggable,
        isListDroppable
    ]);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, $bh6RR.useRef)(null);
    if (isListDraggable && dragAndDropHooks) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: collection,
            selectionManager: selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, listBoxRef);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    if (isListDroppable && dragAndDropHooks) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: collection,
            selectionManager: selectionManager
        });
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || ctxDropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(collection, listBoxRef, {
            orientation: orientation,
            layout: layout,
            direction: direction
        });
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: keyboardDelegate,
            dropTargetDelegate: dropTargetDelegate
        }, dropState, listBoxRef);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $5Gawp.useFocusRing)();
    let renderValues = {
        isDropTarget: isRootDropTarget,
        isEmpty: state.collection.size === 0,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        layout: props.layout || 'stack',
        state: state
    };
    let renderProps = (0, $dgWhj.useRenderProps)({
        className: props.className,
        style: props.style,
        defaultClassName: 'react-aria-ListBox',
        values: renderValues
    });
    let emptyState = null;
    if (state.collection.size === 0 && props.renderEmptyState) emptyState = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        // eslint-disable-next-line
        role: "option",
        style: {
            display: 'contents'
        }
    }, props.renderEmptyState(renderValues));
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2NhrA.FocusScope), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...(0, $bG0JH.filterDOMProps)(props),
        ...(0, $hAxtE.mergeProps)(listBoxProps, focusProps, droppableCollection === null || droppableCollection === void 0 ? void 0 : droppableCollection.collectionProps),
        ...renderProps,
        ref: listBoxRef,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        "data-drop-target": isRootDropTarget || undefined,
        "data-empty": state.collection.size === 0 || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-layout": props.layout || 'stack',
        "data-orientation": props.orientation || 'vertical'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                $5a93616fe5d32958$export$7ff8f37d2d81a48d,
                props
            ],
            [
                $5a93616fe5d32958$export$7c5906fe4f1f2af2,
                state
            ],
            [
                (0, $4HVSY.DragAndDropContext),
                {
                    dragAndDropHooks: dragAndDropHooks,
                    dragState: dragState,
                    dropState: dropState
                }
            ],
            [
                (0, $5lycU.SeparatorContext),
                {
                    elementType: 'div'
                }
            ],
            [
                (0, $4HVSY.DropIndicatorContext),
                {
                    render: $5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBoxDropIndicatorWrapper
                }
            ],
            [
                (0, $juOz0.SectionContext),
                {
                    name: 'ListBoxSection',
                    render: $5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBoxSection
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionRoot, {
        collection: collection,
        scrollRef: listBoxRef,
        persistedKeys: (0, $4HVSY.useDndPersistedKeys)(selectionManager, dragAndDropHooks, dropState),
        renderDropIndicator: (0, $4HVSY.useRenderDropIndicator)(dragAndDropHooks, dropState)
    })), emptyState, dragPreview));
}
function $5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBoxSection(props, ref, section, className = 'react-aria-ListBoxSection') {
    let state = (0, $bh6RR.useContext)($5a93616fe5d32958$export$7c5906fe4f1f2af2);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $bh6RR.useContext)((0, $4HVSY.DragAndDropContext));
    let { CollectionBranch: CollectionBranch } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let [headingRef, heading] = (0, $dgWhj.useSlot)();
    var _props_arialabel;
    let { headingProps: headingProps, groupProps: groupProps } = (0, $daJU6.useListBoxSection)({
        heading: heading,
        'aria-label': (_props_arialabel = props['aria-label']) !== null && _props_arialabel !== void 0 ? _props_arialabel : undefined
    });
    let renderProps = (0, $dgWhj.useRenderProps)({
        defaultClassName: className,
        className: props.className,
        style: props.style,
        values: {}
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("section", {
        ...(0, $bG0JH.filterDOMProps)(props),
        ...groupProps,
        ...renderProps,
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $7jgDZ.HeaderContext).Provider, {
        value: {
            ...headingProps,
            ref: headingRef
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: section,
        renderDropIndicator: (0, $4HVSY.useRenderDropIndicator)(dragAndDropHooks, dropState)
    })));
}
/**
 * A ListBoxSection represents a section within a ListBox.
 */ const $5a93616fe5d32958$export$dca12b0bb56e4fc = (0, $eqvPU.createBranchComponent)('section', $5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBoxSection);
const $5a93616fe5d32958$export$a11e76429ed99b4 = (0, $eqvPU.createLeafComponent)('item', function ListBoxItem(props, forwardedRef, item) {
    let ref = (0, $jyDr8.useObjectRef)(forwardedRef);
    let state = (0, $bh6RR.useContext)($5a93616fe5d32958$export$7c5906fe4f1f2af2);
    let { dragAndDropHooks: dragAndDropHooks, dragState: dragState, dropState: dropState } = (0, $bh6RR.useContext)((0, $4HVSY.DragAndDropContext));
    let { optionProps: optionProps, labelProps: labelProps, descriptionProps: descriptionProps, ...states } = (0, $29c4f.useOption)({
        key: item.key,
        'aria-label': props === null || props === void 0 ? void 0 : props['aria-label']
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)({
        isDisabled: !states.allowsSelection && !states.hasAction,
        onHoverStart: item.props.onHoverStart,
        onHoverChange: item.props.onHoverChange,
        onHoverEnd: item.props.onHoverEnd
    });
    let draggableItem = null;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key
    }, dragState);
    let droppableItem = null;
    if (dropState && dragAndDropHooks) droppableItem = dragAndDropHooks.useDroppableItem({
        target: {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        }
    }, dropState, ref);
    let isDragging = dragState && dragState.isDragging(item.key);
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        id: undefined,
        children: props.children,
        defaultClassName: 'react-aria-ListBoxItem',
        values: {
            ...states,
            isHovered: isHovered,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            allowsDragging: !!dragState,
            isDragging: isDragging,
            isDropTarget: droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.isDropTarget
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        if (!item.textValue) console.warn('A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.');
    }, [
        item.textValue
    ]);
    let ElementType = props.href ? 'a' : 'div';
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ElementType, {
        ...(0, $hAxtE.mergeProps)(optionProps, hoverProps, draggableItem === null || draggableItem === void 0 ? void 0 : draggableItem.dragProps, droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.dropProps),
        ...renderProps,
        ref: ref,
        "data-allows-dragging": !!dragState || undefined,
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": states.isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": (droppableItem === null || droppableItem === void 0 ? void 0 : droppableItem.isDropTarget) || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                (0, $5Oi9Z.TextContext),
                {
                    slots: {
                        label: labelProps,
                        description: descriptionProps
                    }
                }
            ]
        ]
    }, renderProps.children));
});
function $5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBoxDropIndicatorWrapper(props, ref) {
    ref = (0, $jyDr8.useObjectRef)(ref);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $bh6RR.useContext)((0, $4HVSY.DragAndDropContext));
    let { dropIndicatorProps: dropIndicatorProps, isHidden: isHidden, isDropTarget: isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, ref);
    if (isHidden) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBoxDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        ref: ref
    });
}
function $5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBoxDropIndicator(props, ref) {
    let { dropIndicatorProps: dropIndicatorProps, isDropTarget: isDropTarget, ...otherProps } = props;
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...otherProps,
        defaultClassName: 'react-aria-DropIndicator',
        values: {
            isDropTarget: isDropTarget
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...dropIndicatorProps,
        ...renderProps,
        // eslint-disable-next-line
        role: "option",
        ref: ref,
        "data-drop-target": isDropTarget || undefined
    });
}
const $5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBoxDropIndicatorForwardRef = (0, $bh6RR.forwardRef)($5a93616fe5d32958$var$$eed445e0843c11d0$var$ListBoxDropIndicator);

});
parcelRegister("4HVSY", function(module, exports) {

$parcel$export(module.exports, "DragAndDropContext", function () { return $5f48bb1265e81059$export$d188a835a7bc5783; });
$parcel$export(module.exports, "DropIndicatorContext", function () { return $5f48bb1265e81059$export$f55761759794cf55; });
$parcel$export(module.exports, "useRenderDropIndicator", function () { return $5f48bb1265e81059$export$971707d8a129a1f7; });
$parcel$export(module.exports, "useDndPersistedKeys", function () { return $5f48bb1265e81059$export$d1e8e3fbb7461f6; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5f48bb1265e81059$export$d188a835a7bc5783 = (0, $bh6RR.createContext)({});
const $5f48bb1265e81059$export$f55761759794cf55 = (0, $bh6RR.createContext)(null);
function $5f48bb1265e81059$var$$612b8eb6cb90e02d$var$DropIndicator(props, ref) {
    let { render: render } = (0, $bh6RR.useContext)($5f48bb1265e81059$export$f55761759794cf55);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, render(props, ref));
}
/**
 * A DropIndicator is rendered between items in a collection to indicate where dropped data will be inserted.
 */ const $5f48bb1265e81059$export$62ed72bc21f6b8a6 = (0, $bh6RR.forwardRef)($5f48bb1265e81059$var$$612b8eb6cb90e02d$var$DropIndicator);
function $5f48bb1265e81059$export$971707d8a129a1f7(dragAndDropHooks, dropState) {
    var _dragAndDropHooks_isVirtualDragging;
    let renderDropIndicator = dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.renderDropIndicator;
    let isVirtualDragging = dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : (_dragAndDropHooks_isVirtualDragging = dragAndDropHooks.isVirtualDragging) === null || _dragAndDropHooks_isVirtualDragging === void 0 ? void 0 : _dragAndDropHooks_isVirtualDragging.call(dragAndDropHooks);
    let fn = (0, $bh6RR.useCallback)((target)=>{
        // Only show drop indicators when virtual dragging or this is the current drop target.
        if (isVirtualDragging || (dropState === null || dropState === void 0 ? void 0 : dropState.isDropTarget(target))) return renderDropIndicator ? renderDropIndicator(target) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($5f48bb1265e81059$export$62ed72bc21f6b8a6, {
            target: target
        });
    // We invalidate whenever the target changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dropState === null || dropState === void 0 ? void 0 : dropState.target,
        isVirtualDragging,
        renderDropIndicator
    ]);
    return (dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDropIndicator) ? fn : undefined;
}
function $5f48bb1265e81059$export$d1e8e3fbb7461f6(selectionManager, dragAndDropHooks, dropState) {
    var _dragAndDropHooks_isVirtualDragging, _dropState_target;
    // Persist the focused key and the drop target key.
    let focusedKey = selectionManager.focusedKey;
    let dropTargetKey = null;
    if ((dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : (_dragAndDropHooks_isVirtualDragging = dragAndDropHooks.isVirtualDragging) === null || _dragAndDropHooks_isVirtualDragging === void 0 ? void 0 : _dragAndDropHooks_isVirtualDragging.call(dragAndDropHooks)) && (dropState === null || dropState === void 0 ? void 0 : (_dropState_target = dropState.target) === null || _dropState_target === void 0 ? void 0 : _dropState_target.type) === 'item') {
        dropTargetKey = dropState.target.key;
        var _dropState_collection_getKeyAfter;
        if (dropState.target.dropPosition === 'after') dropTargetKey = (_dropState_collection_getKeyAfter = dropState.collection.getKeyAfter(dropTargetKey)) !== null && _dropState_collection_getKeyAfter !== void 0 ? _dropState_collection_getKeyAfter : dropTargetKey;
    }
    return (0, $bh6RR.useMemo)(()=>{
        return new Set([
            focusedKey,
            dropTargetKey
        ].filter((k)=>k != null));
    }, [
        focusedKey,
        dropTargetKey
    ]);
}

});

parcelRegister("kTnkE", function(module, exports) {

$parcel$export(module.exports, "useListBox", function () { return $d6f64e4e204819f6$export$50eacbbf140a3141; });

var $c2C3a = parcelRequire("c2C3a");

var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");
var $gxMV2 = parcelRequire("gxMV2");

var $fmkmo = parcelRequire("fmkmo");

var $7D5kx = parcelRequire("7D5kx");

var $fADQn = parcelRequire("fADQn");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d6f64e4e204819f6$export$50eacbbf140a3141(props, state, ref) {
    let domProps = (0, $bG0JH.filterDOMProps)(props, {
        labelable: true
    });
    // Use props instead of state here. We don't want this to change due to long press.
    let selectionBehavior = props.selectionBehavior || 'toggle';
    let linkBehavior = props.linkBehavior || (selectionBehavior === 'replace' ? 'action' : 'override');
    if (selectionBehavior === 'toggle' && linkBehavior === 'action') // to initiate selection (checkboxes are not allowed inside a listbox). Link items will not be
    // selectable in this configuration.
    linkBehavior = 'override';
    let { listProps: listProps } = (0, $fADQn.useSelectableList)({
        ...props,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        linkBehavior: linkBehavior
    });
    let { focusWithinProps: focusWithinProps } = (0, $fmkmo.useFocusWithin)({
        onFocusWithin: props.onFocus,
        onBlurWithin: props.onBlur,
        onFocusWithinChange: props.onFocusChange
    });
    // Share list id and some props with child options.
    let id = (0, $gxMV2.useId)(props.id);
    (0, $c2C3a.listData).set(state, {
        id: id,
        shouldUseVirtualFocus: props.shouldUseVirtualFocus,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp,
        shouldFocusOnHover: props.shouldFocusOnHover,
        isVirtualized: props.isVirtualized,
        onAction: props.onAction,
        linkBehavior: linkBehavior
    });
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $7D5kx.useLabel)({
        ...props,
        id: id,
        // listbox is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span'
    });
    return {
        labelProps: labelProps,
        listBoxProps: (0, $hAxtE.mergeProps)(domProps, focusWithinProps, state.selectionManager.selectionMode === 'multiple' ? {
            'aria-multiselectable': 'true'
        } : {}, {
            role: 'listbox',
            ...(0, $hAxtE.mergeProps)(fieldProps, listProps)
        })
    };
}

});
parcelRegister("c2C3a", function(module, exports) {

$parcel$export(module.exports, "listData", function () { return $705ad57dcf79f61b$export$3585ede4d035bf14; });
$parcel$export(module.exports, "getItemId", function () { return $705ad57dcf79f61b$export$9145995848b05025; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $705ad57dcf79f61b$export$3585ede4d035bf14 = new WeakMap();
function $705ad57dcf79f61b$var$$b1f0cad8af73213b$var$normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}
function $705ad57dcf79f61b$export$9145995848b05025(state, itemKey) {
    let data = $705ad57dcf79f61b$export$3585ede4d035bf14.get(state);
    if (!data) throw new Error('Unknown list');
    return `${data.id}-option-${$705ad57dcf79f61b$var$$b1f0cad8af73213b$var$normalizeKey(itemKey)}`;
}

});


parcelRegister("daJU6", function(module, exports) {

$parcel$export(module.exports, "useListBoxSection", function () { return $3697aa7563942c30$export$c3f9f39876e4bc7; });

var $gxMV2 = parcelRequire("gxMV2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3697aa7563942c30$export$c3f9f39876e4bc7(props) {
    let { heading: heading, 'aria-label': ariaLabel } = props;
    let headingId = (0, $gxMV2.useId)();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Techincally, listbox cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, using role="presentation",
            // and only use it as a visual label for the nested group.
            id: headingId,
            role: 'presentation'
        } : {},
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}

});

parcelRegister("29c4f", function(module, exports) {

$parcel$export(module.exports, "useOption", function () { return $a9c0683199d16766$export$497855f14858aa34; });

var $c2C3a = parcelRequire("c2C3a");

var $jQZLC = parcelRequire("jQZLC");
var $bG0JH = parcelRequire("bG0JH");
var $be6XU = parcelRequire("be6XU");
var $hAxtE = parcelRequire("hAxtE");
var $gN5ZC = parcelRequire("gN5ZC");
var $gxMV2 = parcelRequire("gxMV2");

var $2stCI = parcelRequire("2stCI");

var $8tXMg = parcelRequire("8tXMg");
var $i91F7 = parcelRequire("i91F7");

var $gYN2y = parcelRequire("gYN2y");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a9c0683199d16766$export$497855f14858aa34(props, state, ref) {
    var _item_props, _item_props1;
    let { key: key } = props;
    let data = (0, $c2C3a.listData).get(state);
    var _props_isDisabled;
    let isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : state.selectionManager.isDisabled(key);
    var _props_isSelected;
    let isSelected = (_props_isSelected = props.isSelected) !== null && _props_isSelected !== void 0 ? _props_isSelected : state.selectionManager.isSelected(key);
    var _props_shouldSelectOnPressUp;
    let shouldSelectOnPressUp = (_props_shouldSelectOnPressUp = props.shouldSelectOnPressUp) !== null && _props_shouldSelectOnPressUp !== void 0 ? _props_shouldSelectOnPressUp : data === null || data === void 0 ? void 0 : data.shouldSelectOnPressUp;
    var _props_shouldFocusOnHover;
    let shouldFocusOnHover = (_props_shouldFocusOnHover = props.shouldFocusOnHover) !== null && _props_shouldFocusOnHover !== void 0 ? _props_shouldFocusOnHover : data === null || data === void 0 ? void 0 : data.shouldFocusOnHover;
    var _props_shouldUseVirtualFocus;
    let shouldUseVirtualFocus = (_props_shouldUseVirtualFocus = props.shouldUseVirtualFocus) !== null && _props_shouldUseVirtualFocus !== void 0 ? _props_shouldUseVirtualFocus : data === null || data === void 0 ? void 0 : data.shouldUseVirtualFocus;
    var _props_isVirtualized;
    let isVirtualized = (_props_isVirtualized = props.isVirtualized) !== null && _props_isVirtualized !== void 0 ? _props_isVirtualized : data === null || data === void 0 ? void 0 : data.isVirtualized;
    let labelId = (0, $gxMV2.useSlotId)();
    let descriptionId = (0, $gxMV2.useSlotId)();
    let optionProps = {
        role: 'option',
        'aria-disabled': isDisabled || undefined,
        'aria-selected': state.selectionManager.selectionMode !== 'none' ? isSelected : undefined
    };
    // Safari with VoiceOver on macOS misreads options with aria-labelledby or aria-label as simply "text".
    // We should not map slots to the label and description on Safari and instead just have VoiceOver read the textContent.
    // https://bugs.webkit.org/show_bug.cgi?id=209279
    if (!((0, $be6XU.isMac)() && (0, $be6XU.isWebKit)())) {
        optionProps['aria-label'] = props['aria-label'];
        optionProps['aria-labelledby'] = labelId;
        optionProps['aria-describedby'] = descriptionId;
    }
    let item = state.collection.getItem(key);
    if (isVirtualized) {
        let index = Number(item === null || item === void 0 ? void 0 : item.index);
        optionProps['aria-posinset'] = Number.isNaN(index) ? undefined : index + 1;
        optionProps['aria-setsize'] = (0, $2stCI.getItemCount)(state.collection);
    }
    let onAction = (data === null || data === void 0 ? void 0 : data.onAction) ? ()=>{
        var _data_onAction;
        return data === null || data === void 0 ? void 0 : (_data_onAction = data.onAction) === null || _data_onAction === void 0 ? void 0 : _data_onAction.call(data, key);
    } : undefined;
    let { itemProps: itemProps, isPressed: isPressed, isFocused: isFocused, hasAction: hasAction, allowsSelection: allowsSelection } = (0, $gYN2y.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        allowsDifferentPressOrigin: shouldSelectOnPressUp && shouldFocusOnHover,
        isVirtualized: isVirtualized,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        isDisabled: isDisabled,
        onAction: onAction || (item === null || item === void 0 ? void 0 : (_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.onAction) ? (0, $jQZLC.chain)(item === null || item === void 0 ? void 0 : (_item_props1 = item.props) === null || _item_props1 === void 0 ? void 0 : _item_props1.onAction, onAction) : undefined,
        linkBehavior: data === null || data === void 0 ? void 0 : data.linkBehavior
    });
    let { hoverProps: hoverProps } = (0, $i91F7.useHover)({
        isDisabled: isDisabled || !shouldFocusOnHover,
        onHoverStart () {
            if (!(0, $8tXMg.isFocusVisible)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    let domProps = (0, $bG0JH.filterDOMProps)(item === null || item === void 0 ? void 0 : item.props);
    delete domProps.id;
    let linkProps = (0, $gN5ZC.useLinkProps)(item === null || item === void 0 ? void 0 : item.props);
    return {
        optionProps: {
            ...optionProps,
            ...(0, $hAxtE.mergeProps)(domProps, itemProps, hoverProps, linkProps),
            id: (0, $c2C3a.getItemId)(state, key)
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        isFocused: isFocused,
        isFocusVisible: isFocused && (0, $8tXMg.isFocusVisible)(),
        isSelected: isSelected,
        isDisabled: isDisabled,
        isPressed: isPressed,
        allowsSelection: allowsSelection,
        hasAction: hasAction
    };
}

});

parcelRegister("gfBTL", function(module, exports) {

$parcel$export(module.exports, "useListState", function () { return $507eecdf4996f9b2$export$2f645645f7bca764; });

var $5pFaT = parcelRequire("5pFaT");

var $5XVcz = parcelRequire("5XVcz");
var $8K87f = parcelRequire("8K87f");

var $bh6RR = parcelRequire("bh6RR");

var $6ACFn = parcelRequire("6ACFn");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $507eecdf4996f9b2$export$2f645645f7bca764(props) {
    let { filter: filter, layoutDelegate: layoutDelegate } = props;
    let selectionState = (0, $8K87f.useMultipleSelectionState)(props);
    let disabledKeys = (0, $bh6RR.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let factory = (0, $bh6RR.useCallback)((nodes)=>filter ? new (0, $5pFaT.ListCollection)(filter(nodes)) : new (0, $5pFaT.ListCollection)(nodes), [
        filter
    ]);
    let context = (0, $bh6RR.useMemo)(()=>({
            suppressTextValueWarning: props.suppressTextValueWarning
        }), [
        props.suppressTextValueWarning
    ]);
    let collection = (0, $6ACFn.useCollection)(props, factory, context);
    let selectionManager = (0, $bh6RR.useMemo)(()=>new (0, $5XVcz.SelectionManager)(collection, selectionState, {
            layoutDelegate: layoutDelegate
        }), [
        collection,
        selectionState,
        layoutDelegate
    ]);
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey) && cachedCollection.current) {
            const startItem = cachedCollection.current.getItem(selectionState.focusedKey);
            const cachedItemNodes = [
                ...cachedCollection.current.getKeys()
            ].map((key)=>{
                const itemNode = cachedCollection.current.getItem(key);
                return (itemNode === null || itemNode === void 0 ? void 0 : itemNode.type) === 'item' ? itemNode : null;
            }).filter((node)=>node !== null);
            const itemNodes = [
                ...collection.getKeys()
            ].map((key)=>{
                const itemNode = collection.getItem(key);
                return (itemNode === null || itemNode === void 0 ? void 0 : itemNode.type) === 'item' ? itemNode : null;
            }).filter((node)=>node !== null);
            var _cachedItemNodes_length, _itemNodes_length;
            const diff = ((_cachedItemNodes_length = cachedItemNodes === null || cachedItemNodes === void 0 ? void 0 : cachedItemNodes.length) !== null && _cachedItemNodes_length !== void 0 ? _cachedItemNodes_length : 0) - ((_itemNodes_length = itemNodes === null || itemNodes === void 0 ? void 0 : itemNodes.length) !== null && _itemNodes_length !== void 0 ? _itemNodes_length : 0);
            var _startItem_index, _startItem_index1, _itemNodes_length1;
            let index = Math.min(diff > 1 ? Math.max(((_startItem_index = startItem === null || startItem === void 0 ? void 0 : startItem.index) !== null && _startItem_index !== void 0 ? _startItem_index : 0) - diff + 1, 0) : (_startItem_index1 = startItem === null || startItem === void 0 ? void 0 : startItem.index) !== null && _startItem_index1 !== void 0 ? _startItem_index1 : 0, ((_itemNodes_length1 = itemNodes === null || itemNodes === void 0 ? void 0 : itemNodes.length) !== null && _itemNodes_length1 !== void 0 ? _itemNodes_length1 : 0) - 1);
            let newNode = null;
            let isReverseSearching = false;
            while(index >= 0){
                if (!selectionManager.isDisabled(itemNodes[index].key)) {
                    newNode = itemNodes[index];
                    break;
                }
                // Find next, not disabled item.
                if (index < itemNodes.length - 1 && !isReverseSearching) index++;
                else {
                    isReverseSearching = true;
                    var _startItem_index2, _startItem_index3;
                    if (index > ((_startItem_index2 = startItem === null || startItem === void 0 ? void 0 : startItem.index) !== null && _startItem_index2 !== void 0 ? _startItem_index2 : 0)) index = (_startItem_index3 = startItem === null || startItem === void 0 ? void 0 : startItem.index) !== null && _startItem_index3 !== void 0 ? _startItem_index3 : 0;
                    index--;
                }
            }
            selectionState.setFocusedKey(newNode ? newNode.key : null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager,
        selectionState,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager
    };
}

});
parcelRegister("5pFaT", function(module, exports) {

$parcel$export(module.exports, "ListCollection", function () { return $e2baacb60b705965$export$d085fb9e920b5ca7; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $e2baacb60b705965$export$d085fb9e920b5ca7 {
    *[Symbol.iterator]() {
        yield* this.iterable;
    }
    get size() {
        return this.keyMap.size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        var _node_prevKey;
        return node ? (_node_prevKey = node.prevKey) !== null && _node_prevKey !== void 0 ? _node_prevKey : null : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        var _node_nextKey;
        return node ? (_node_nextKey = node.nextKey) !== null && _node_nextKey !== void 0 ? _node_nextKey : null : null;
    }
    getFirstKey() {
        return this.firstKey;
    }
    getLastKey() {
        return this.lastKey;
    }
    getItem(key) {
        var _this_keyMap_get;
        return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
    constructor(nodes){
        this.keyMap = new Map();
        this.firstKey = null;
        this.lastKey = null;
        this.iterable = nodes;
        let visit = (node)=>{
            this.keyMap.set(node.key, node);
            if (node.childNodes && node.type === 'section') for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let last = null;
        let index = 0;
        for (let [key, node] of this.keyMap){
            if (last) {
                last.nextKey = key;
                node.prevKey = last.key;
            } else {
                this.firstKey = key;
                node.prevKey = undefined;
            }
            if (node.type === 'item') node.index = index++;
            last = node;
            // Set nextKey as undefined since this might be the last node
            // If it isn't the last node, last.nextKey will properly set at start of new loop
            last.nextKey = undefined;
        }
        var _last_key;
        this.lastKey = (_last_key = last === null || last === void 0 ? void 0 : last.key) !== null && _last_key !== void 0 ? _last_key : null;
    }
}

});



parcelRegister("eGtYl", function(module, exports) {

$parcel$export(module.exports, "focusRing", function () { return $29839a088d561795$export$8e24544ddba725ee; });
$parcel$export(module.exports, "composeTailwindRenderProps", function () { return $29839a088d561795$export$216db8fb0316f8c3; });

var $dgWhj = parcelRequire("dgWhj");

var $cZXNZ = parcelRequire("cZXNZ");

var $9SfKt = parcelRequire("9SfKt");
const $29839a088d561795$export$8e24544ddba725ee = (0, $9SfKt.tv)({
    base: 'outline outline-blue-600 dark:outline-blue-500 forced-colors:outline-[Highlight] outline-offset-2',
    variants: {
        isFocusVisible: {
            false: 'outline-0',
            true: 'outline-2'
        }
    }
});
function $29839a088d561795$export$216db8fb0316f8c3(className, tw) {
    return (0, $dgWhj.composeRenderProps)(className, (className)=>(0, $cZXNZ.twMerge)(tw, className));
}

});


parcelRegister("gP3Xs", function(module, exports) {

$parcel$export(module.exports, "Popover", function () { return $5d1181dc6ddfe6d6$export$5b6b19405a83ff9d; });

var $ih19M = parcelRequire("ih19M");

var $dgWhj = parcelRequire("dgWhj");
var $bf3Og = parcelRequire("bf3Og");
var $6W801 = parcelRequire("6W801");
parcelRequire("bh6RR");

var $9SfKt = parcelRequire("9SfKt");
const $5d1181dc6ddfe6d6$var$styles = (0, $9SfKt.tv)({
    base: 'bg-white dark:bg-zinc-900/70 dark:backdrop-blur-2xl dark:backdrop-saturate-200 forced-colors:bg-[Canvas] shadow-2xl rounded-xl bg-clip-padding border border-black/10 dark:border-white/[15%] text-slate-700 dark:text-zinc-300',
    variants: {
        isEntering: {
            true: 'animate-in fade-in placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 placement-left:slide-in-from-right-1 placement-right:slide-in-from-left-1 ease-out duration-200'
        },
        isExiting: {
            true: 'animate-out fade-out placement-bottom:slide-out-to-top-1 placement-top:slide-out-to-bottom-1 placement-left:slide-out-to-right-1 placement-right:slide-out-to-left-1 ease-in duration-150'
        }
    }
});
function $5d1181dc6ddfe6d6$export$5b6b19405a83ff9d({ children: children, showArrow: showArrow, className: className, ...props }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $6W801.Popover), {
        offset: showArrow ? 12 : 8,
        ...props,
        className: (0, $dgWhj.composeRenderProps)(className, (className, renderProps)=>$5d1181dc6ddfe6d6$var$styles({
                ...renderProps,
                className: className
            })),
        children: [
            showArrow && /*#__PURE__*/ (0, $ih19M.jsx)((0, $bf3Og.OverlayArrow), {
                className: "group",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                    width: 12,
                    height: 12,
                    viewBox: "0 0 12 12",
                    className: "block fill-white dark:fill-[#1f1f21] forced-colors:fill-[Canvas] stroke-1 stroke-black/10 dark:stroke-zinc-600 forced-colors:stroke-[ButtonBorder] group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M0 0 L6 6 L12 0"
                    })
                })
            }),
            children
        ]
    });
}

});


parcelRegister("9bdVj", function(module, exports) {

$parcel$export(module.exports, "Separator", function () { return $5330f01c5ff73caf$export$1ff3c3f08ae963c0; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $5lycU = parcelRequire("5lycU");

var $9SfKt = parcelRequire("9SfKt");
const $5330f01c5ff73caf$var$styles = (0, $9SfKt.tv)({
    base: 'bg-gray-300 dark:bg-zinc-600 forced-colors:bg-[ButtonBorder]',
    variants: {
        orientation: {
            horizontal: 'h-px w-full',
            vertical: 'w-px'
        }
    },
    defaultVariants: {
        orientation: 'horizontal'
    }
});
function $5330f01c5ff73caf$export$1ff3c3f08ae963c0(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5lycU.Separator), {
        ...props,
        className: $5330f01c5ff73caf$var$styles({
            orientation: props.orientation,
            className: props.className
        })
    });
}

});

parcelRegister("bqgKG", function(module, exports) {

$parcel$export(module.exports, "TagGroup", function () { return $6af7ddb7fa350331$export$67ea30858aaf75e3; });
$parcel$export(module.exports, "Tag", function () { return $6af7ddb7fa350331$export$3288d34c523a1192; });

var $ih19M = parcelRequire("ih19M");

var $jVhj8 = parcelRequire("jVhj8");

var $bh6RR = parcelRequire("bh6RR");

var $9cr7a = parcelRequire("9cr7a");
var $dgWhj = parcelRequire("dgWhj");
var $eNHUP = parcelRequire("eNHUP");
var $5Oi9Z = parcelRequire("5Oi9Z");

var $cZXNZ = parcelRequire("cZXNZ");

var $9SfKt = parcelRequire("9SfKt");

var $arHbU = parcelRequire("arHbU");

var $eGtYl = parcelRequire("eGtYl");
const $6af7ddb7fa350331$var$colors = {
    gray: 'bg-gray-100 text-gray-600 border-gray-200 hover:border-gray-300 dark:bg-zinc-700 dark:text-zinc-300 dark:border-zinc-600 dark:hover:border-zinc-500',
    green: 'bg-green-100 text-green-700 border-green-200 hover:border-green-300 dark:bg-green-300/20 dark:text-green-400 dark:border-green-300/10 dark:hover:border-green-300/20',
    yellow: 'bg-yellow-100 text-yellow-700 border-yellow-200 hover:border-yellow-300 dark:bg-yellow-300/20 dark:text-yellow-400 dark:border-yellow-300/10 dark:hover:border-yellow-300/20',
    blue: 'bg-blue-100 text-blue-700 border-blue-200 hover:border-blue-300 dark:bg-blue-400/20 dark:text-blue-300 dark:border-blue-400/10 dark:hover:border-blue-400/20'
};
const $6af7ddb7fa350331$var$ColorContext = /*#__PURE__*/ (0, $bh6RR.createContext)('gray');
const $6af7ddb7fa350331$var$tagStyles = (0, $9SfKt.tv)({
    extend: (0, $eGtYl.focusRing),
    base: 'transition cursor-default text-xs rounded-full border px-3 py-0.5 flex items-center max-w-fit gap-1',
    variants: {
        color: {
            gray: '',
            green: '',
            yellow: '',
            blue: ''
        },
        allowsRemoving: {
            true: 'pr-1'
        },
        isSelected: {
            true: 'bg-blue-600 text-white border-transparent forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] forced-color-adjust-none'
        },
        isDisabled: {
            true: 'bg-gray-100 text-gray-300 forced-colors:text-[GrayText]'
        }
    },
    compoundVariants: Object.keys($6af7ddb7fa350331$var$colors).map((color)=>({
            isSelected: false,
            color: color,
            class: $6af7ddb7fa350331$var$colors[color]
        }))
});
function $6af7ddb7fa350331$export$67ea30858aaf75e3({ label: label, description: description, errorMessage: errorMessage, items: items, children: children, renderEmptyState: renderEmptyState, ...props }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eNHUP.TagGroup), {
        ...props,
        className: (0, $cZXNZ.twMerge)('flex flex-col gap-1', props.className),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $arHbU.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)($6af7ddb7fa350331$var$ColorContext.Provider, {
                value: props.color || 'gray',
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $eNHUP.TagList), {
                    items: items,
                    renderEmptyState: renderEmptyState,
                    className: "flex flex-wrap gap-1",
                    children: children
                })
            }),
            description && /*#__PURE__*/ (0, $ih19M.jsx)((0, $arHbU.Description), {
                children: description
            }),
            errorMessage && /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Oi9Z.Text), {
                slot: "errorMessage",
                className: "text-sm text-red-600",
                children: errorMessage
            })
        ]
    });
}
const $6af7ddb7fa350331$var$removeButtonStyles = (0, $9SfKt.tv)({
    extend: (0, $eGtYl.focusRing),
    base: 'cursor-default rounded-full transition-[background-color] p-0.5 flex items-center justify-center hover:bg-black/10 dark:hover:bg-white/10 pressed:bg-black/20 dark:pressed:bg-white/20'
});
function $6af7ddb7fa350331$export$3288d34c523a1192({ children: children, color: color, ...props }) {
    let textValue = typeof children === 'string' ? children : undefined;
    let groupColor = (0, $bh6RR.useContext)($6af7ddb7fa350331$var$ColorContext);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $eNHUP.Tag), {
        textValue: textValue,
        ...props,
        className: (0, $dgWhj.composeRenderProps)(props.className, (className, renderProps)=>$6af7ddb7fa350331$var$tagStyles({
                ...renderProps,
                className: className,
                color: color || groupColor
            })),
        children: ({ allowsRemoving: allowsRemoving })=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    children,
                    allowsRemoving && /*#__PURE__*/ (0, $ih19M.jsx)((0, $9cr7a.Button), {
                        slot: "remove",
                        className: $6af7ddb7fa350331$var$removeButtonStyles,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $jVhj8.default), {
                            "aria-hidden": true,
                            className: "w-3 h-3"
                        })
                    })
                ]
            })
    });
}

});
parcelRegister("jVhj8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e810c41ef33b64dc$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $e810c41ef33b64dc$export$2e2bcd8739ae039 = (0, $iUesJ.default)("X", [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
]);

});

parcelRegister("eNHUP", function(module, exports) {

$parcel$export(module.exports, "TagGroup", function () { return $ae9f8f97f897db4c$export$67ea30858aaf75e3; });
$parcel$export(module.exports, "TagList", function () { return $ae9f8f97f897db4c$export$f9fef0f55402315b; });
$parcel$export(module.exports, "Tag", function () { return $ae9f8f97f897db4c$export$3288d34c523a1192; });

var $9cr7a = parcelRequire("9cr7a");

var $juOz0 = parcelRequire("juOz0");

var $dgWhj = parcelRequire("dgWhj");

var $kubwK = parcelRequire("kubwK");

var $5Ihf9 = parcelRequire("5Ihf9");

var $5Oi9Z = parcelRequire("5Oi9Z");

var $5Gawp = parcelRequire("5Gawp");
var $i91F7 = parcelRequire("i91F7");
var $5MK9P = parcelRequire("5MK9P");
var $4bcx8 = parcelRequire("4bcx8");

var $eqvPU = parcelRequire("eqvPU");

var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");
var $jyDr8 = parcelRequire("jyDr8");

var $gfBTL = parcelRequire("gfBTL");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $ae9f8f97f897db4c$export$5b07b5dd2cbd96e3 = (0, $bh6RR.createContext)(null);
const $ae9f8f97f897db4c$export$e755ce3685dd0ca9 = (0, $bh6RR.createContext)(null);
function $ae9f8f97f897db4c$var$$eaf9e70818b436db$var$TagGroup(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $ae9f8f97f897db4c$export$5b07b5dd2cbd96e3);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eqvPU.CollectionBuilder), {
        content: props.children
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($ae9f8f97f897db4c$var$$eaf9e70818b436db$var$TagGroupInner, {
            props: props,
            forwardedRef: ref,
            collection: collection
        }));
}
function $ae9f8f97f897db4c$var$$eaf9e70818b436db$var$TagGroupInner({ props: props, forwardedRef: ref, collection: collection }) {
    let tagListRef = (0, $bh6RR.useRef)(null);
    let [labelRef, label] = (0, $dgWhj.useSlot)();
    let state = (0, $gfBTL.useListState)({
        ...props,
        children: undefined,
        collection: collection
    });
    // Prevent DOM props from going to two places.
    let domProps = (0, $bG0JH.filterDOMProps)(props);
    let domPropOverrides = Object.fromEntries(Object.entries(domProps).map(([k])=>[
            k,
            undefined
        ]));
    let { gridProps: gridProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $4bcx8.useTagGroup)({
        ...props,
        ...domPropOverrides,
        label: label
    }, state, tagListRef);
    var _props_className;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...domProps,
        ref: ref,
        slot: props.slot || undefined,
        className: (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : 'react-aria-TagGroup',
        style: props.style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                (0, $kubwK.LabelContext),
                {
                    ...labelProps,
                    elementType: 'span',
                    ref: labelRef
                }
            ],
            [
                $ae9f8f97f897db4c$export$e755ce3685dd0ca9,
                {
                    ...gridProps,
                    ref: tagListRef
                }
            ],
            [
                (0, $5Ihf9.ListStateContext),
                state
            ],
            [
                (0, $5Oi9Z.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ]
        ]
    }, props.children));
}
/**
 * A tag group is a focusable list of labels, categories, keywords, filters, or other items, with support for keyboard navigation, selection, and removal.
 */ const $ae9f8f97f897db4c$export$67ea30858aaf75e3 = (0, $bh6RR.forwardRef)($ae9f8f97f897db4c$var$$eaf9e70818b436db$var$TagGroup);
function $ae9f8f97f897db4c$var$$eaf9e70818b436db$var$TagList(props, ref) {
    let state = (0, $bh6RR.useContext)((0, $5Ihf9.ListStateContext));
    return state ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($ae9f8f97f897db4c$var$$eaf9e70818b436db$var$TagListInner, {
        props: props,
        forwardedRef: ref
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eqvPU.Collection), props);
}
function $ae9f8f97f897db4c$var$$eaf9e70818b436db$var$TagListInner({ props: props, forwardedRef: forwardedRef }) {
    let state = (0, $bh6RR.useContext)((0, $5Ihf9.ListStateContext));
    let { CollectionRoot: CollectionRoot } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let [gridProps, ref] = (0, $dgWhj.useContextProps)(props, forwardedRef, $ae9f8f97f897db4c$export$e755ce3685dd0ca9);
    delete gridProps.items;
    delete gridProps.renderEmptyState;
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $5Gawp.useFocusRing)();
    let renderValues = {
        isEmpty: state.collection.size === 0,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        state: state
    };
    let renderProps = (0, $dgWhj.useRenderProps)({
        className: props.className,
        style: props.style,
        defaultClassName: 'react-aria-TagList',
        values: renderValues
    });
    let persistedKeys = (0, $juOz0.usePersistedKeys)(state.selectionManager.focusedKey);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...(0, $hAxtE.mergeProps)(gridProps, focusProps),
        ...renderProps,
        ref: ref,
        "data-empty": state.collection.size === 0 || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, state.collection.size === 0 && props.renderEmptyState ? props.renderEmptyState(renderValues) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionRoot, {
        collection: state.collection,
        persistedKeys: persistedKeys
    }));
}
/**
 * A tag list is a container for tags within a TagGroup.
 */ const $ae9f8f97f897db4c$export$f9fef0f55402315b = (0, $bh6RR.forwardRef)($ae9f8f97f897db4c$var$$eaf9e70818b436db$var$TagList);
const $ae9f8f97f897db4c$export$3288d34c523a1192 = (0, $eqvPU.createLeafComponent)('item', (props, forwardedRef, item)=>{
    let state = (0, $bh6RR.useContext)((0, $5Ihf9.ListStateContext));
    let ref = (0, $jyDr8.useObjectRef)(forwardedRef);
    let { focusProps: focusProps, isFocusVisible: isFocusVisible } = (0, $5Gawp.useFocusRing)({
        within: true
    });
    let { rowProps: rowProps, gridCellProps: gridCellProps, removeButtonProps: removeButtonProps, ...states } = (0, $5MK9P.useTag)({
        item: item
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)({
        isDisabled: !states.allowsSelection,
        onHoverStart: item.props.onHoverStart,
        onHoverChange: item.props.onHoverChange,
        onHoverEnd: item.props.onHoverEnd
    });
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-Tag',
        values: {
            ...states,
            isFocusVisible: isFocusVisible,
            isHovered: isHovered,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        if (!item.textValue) console.warn('A `textValue` prop is required for <Tag> elements with non-plain text children for accessibility.');
    }, [
        item.textValue
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ref: ref,
        ...renderProps,
        ...(0, $hAxtE.mergeProps)((0, $bG0JH.filterDOMProps)(props), rowProps, focusProps, hoverProps),
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-allows-removing": states.allowsRemoving || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...gridCellProps,
        style: {
            display: 'contents'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                (0, $9cr7a.ButtonContext),
                {
                    slots: {
                        remove: removeButtonProps
                    }
                }
            ],
            [
                (0, $juOz0.CollectionRendererContext),
                (0, $juOz0.DefaultCollectionRenderer)
            ]
        ]
    }, renderProps.children)));
});

});
parcelRegister("5MK9P", function(module, exports) {

$parcel$export(module.exports, "useTag", function () { return $0ced414d67234128$export$3f568fff7dff2f03; });

var $4bcx8 = parcelRequire("4bcx8");

var $gMzjD = parcelRequire("gMzjD");

var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");
var $eHR6B = parcelRequire("eHR6B");
var $gxMV2 = parcelRequire("gxMV2");
var $gN5ZC = parcelRequire("gN5ZC");

var $3Nz7h = parcelRequire("3Nz7h");

var $8tXMg = parcelRequire("8tXMg");

var $kbHlJ = parcelRequire("kbHlJ");
function $0ced414d67234128$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0ced414d67234128$export$3f568fff7dff2f03(props, state, ref) {
    let { item: item } = props;
    let stringFormatter = (0, $kbHlJ.useLocalizedStringFormatter)($0ced414d67234128$var$$parcel$interopDefault((0, $gMzjD.default)), '@react-aria/tag');
    let buttonId = (0, $gxMV2.useId)();
    let { onRemove: onRemove } = (0, $4bcx8.hookData).get(state) || {};
    let { rowProps: rowProps, gridCellProps: gridCellProps, ...states } = (0, $3Nz7h.useGridListItem)({
        node: item
    }, state, ref);
    // We want the group to handle keyboard navigation between tags.
    delete rowProps.onKeyDownCapture;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { descriptionProps: _, ...stateWithoutDescription } = states;
    let onKeyDown = (e)=>{
        if (e.key === 'Delete' || e.key === 'Backspace') {
            e.preventDefault();
            if (state.selectionManager.isSelected(item.key)) onRemove === null || onRemove === void 0 || onRemove(new Set(state.selectionManager.selectedKeys));
            else onRemove === null || onRemove === void 0 || onRemove(new Set([
                item.key
            ]));
        }
    };
    let modality = (0, $8tXMg.useInteractionModality)();
    if (modality === 'virtual' && typeof window !== 'undefined' && 'ontouchstart' in window) modality = 'pointer';
    let description = onRemove && (modality === 'keyboard' || modality === 'virtual') ? stringFormatter.format('removeDescription') : '';
    let descProps = (0, $eHR6B.useDescription)(description);
    let isFocused = item.key === state.selectionManager.focusedKey;
    let domProps = (0, $bG0JH.filterDOMProps)(item.props);
    let linkProps = (0, $gN5ZC.useSyntheticLinkProps)(item.props);
    return {
        removeButtonProps: {
            'aria-label': stringFormatter.format('removeButtonLabel'),
            'aria-labelledby': `${buttonId} ${rowProps.id}`,
            isDisabled: state.disabledKeys.has(item.key) || item.props.isDisabled,
            id: buttonId,
            onPress: ()=>onRemove ? onRemove(new Set([
                    item.key
                ])) : null,
            excludeFromTabOrder: true
        },
        rowProps: (0, $hAxtE.mergeProps)(rowProps, domProps, linkProps, {
            tabIndex: isFocused || state.selectionManager.focusedKey == null ? 0 : -1,
            onKeyDown: onRemove ? onKeyDown : undefined,
            'aria-describedby': descProps['aria-describedby']
        }),
        gridCellProps: (0, $hAxtE.mergeProps)(gridCellProps, {
            'aria-errormessage': props['aria-errormessage'],
            'aria-label': props['aria-label']
        }),
        ...stateWithoutDescription,
        allowsRemoving: !!onRemove
    };
}

});
parcelRegister("4bcx8", function(module, exports) {

$parcel$export(module.exports, "hookData", function () { return $2a89fa8692602069$export$653eddfc964b0f8a; });
$parcel$export(module.exports, "useTagGroup", function () { return $2a89fa8692602069$export$4f8b5cda58b7e8ff; });

var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");

var $36LQn = parcelRequire("36LQn");

var $bh6RR = parcelRequire("bh6RR");

var $j61jy = parcelRequire("j61jy");

var $fmkmo = parcelRequire("fmkmo");

var $a2evB = parcelRequire("a2evB");

var $c8uzR = parcelRequire("c8uzR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $2a89fa8692602069$export$653eddfc964b0f8a = new WeakMap();
function $2a89fa8692602069$export$4f8b5cda58b7e8ff(props, state, ref) {
    let { direction: direction } = (0, $c8uzR.useLocale)();
    let keyboardDelegate = props.keyboardDelegate || new (0, $36LQn.ListKeyboardDelegate)({
        collection: state.collection,
        ref: ref,
        orientation: 'horizontal',
        direction: direction,
        disabledKeys: state.disabledKeys,
        disabledBehavior: state.selectionManager.disabledBehavior
    });
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $j61jy.useField)({
        ...props,
        labelElementType: 'span'
    });
    let { gridProps: gridProps } = (0, $a2evB.useGridList)({
        ...props,
        ...fieldProps,
        keyboardDelegate: keyboardDelegate,
        shouldFocusWrap: true,
        linkBehavior: 'override'
    }, state, ref);
    let [isFocusWithin, setFocusWithin] = (0, $bh6RR.useState)(false);
    let { focusWithinProps: focusWithinProps } = (0, $fmkmo.useFocusWithin)({
        onFocusWithinChange: setFocusWithin
    });
    let domProps = (0, $bG0JH.filterDOMProps)(props);
    // If the last tag is removed, focus the container.
    let prevCount = (0, $bh6RR.useRef)(state.collection.size);
    (0, $bh6RR.useEffect)(()=>{
        if (ref.current && prevCount.current > 0 && state.collection.size === 0 && isFocusWithin) ref.current.focus();
        prevCount.current = state.collection.size;
    }, [
        state.collection.size,
        isFocusWithin,
        ref
    ]);
    $2a89fa8692602069$export$653eddfc964b0f8a.set(state, {
        onRemove: props.onRemove
    });
    return {
        gridProps: (0, $hAxtE.mergeProps)(gridProps, domProps, {
            role: state.collection.size ? 'grid' : null,
            'aria-atomic': false,
            'aria-relevant': 'additions',
            'aria-live': isFocusWithin ? 'polite' : 'off',
            ...focusWithinProps,
            ...fieldProps
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps
    };
}

});
parcelRegister("j61jy", function(module, exports) {

$parcel$export(module.exports, "useField", function () { return $11365ee14f41f48c$export$294aa081a6c6f55d; });

var $7D5kx = parcelRequire("7D5kx");

var $hAxtE = parcelRequire("hAxtE");
var $gxMV2 = parcelRequire("gxMV2");
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $11365ee14f41f48c$export$294aa081a6c6f55d(props) {
    let { description: description, errorMessage: errorMessage, isInvalid: isInvalid, validationState: validationState } = props;
    let { labelProps: labelProps, fieldProps: fieldProps } = (0, $7D5kx.useLabel)(props);
    let descriptionId = (0, $gxMV2.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    let errorMessageId = (0, $gxMV2.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, $hAxtE.mergeProps)(fieldProps, {
        'aria-describedby': [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props['aria-describedby']
        ].filter(Boolean).join(' ') || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}

});

parcelRegister("a2evB", function(module, exports) {

$parcel$export(module.exports, "useGridList", function () { return $bbab799fce2a6936$export$664f9155035607eb; });

var $29RFN = parcelRequire("29RFN");

var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");
var $gxMV2 = parcelRequire("gxMV2");

var $d8MiS = parcelRequire("d8MiS");
var $g2XaT = parcelRequire("g2XaT");

var $huNh9 = parcelRequire("huNh9");

var $fADQn = parcelRequire("fADQn");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bbab799fce2a6936$export$664f9155035607eb(props, state, ref) {
    let { isVirtualized: isVirtualized, keyboardDelegate: keyboardDelegate, layoutDelegate: layoutDelegate, onAction: onAction, linkBehavior: linkBehavior = 'action', keyboardNavigationBehavior: keyboardNavigationBehavior = 'arrow' } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let { listProps: listProps } = (0, $fADQn.useSelectableList)({
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        ref: ref,
        keyboardDelegate: keyboardDelegate,
        layoutDelegate: layoutDelegate,
        isVirtualized: isVirtualized,
        selectOnFocus: state.selectionManager.selectionBehavior === 'replace',
        shouldFocusWrap: props.shouldFocusWrap,
        linkBehavior: linkBehavior
    });
    let id = (0, $gxMV2.useId)(props.id);
    (0, $29RFN.listMap).set(state, {
        id: id,
        onAction: onAction,
        linkBehavior: linkBehavior,
        keyboardNavigationBehavior: keyboardNavigationBehavior
    });
    let descriptionProps = (0, $g2XaT.useHighlightSelectionDescription)({
        selectionManager: state.selectionManager,
        hasItemActions: !!onAction
    });
    let hasTabbableChild = (0, $huNh9.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let domProps = (0, $bG0JH.filterDOMProps)(props, {
        labelable: true
    });
    let gridProps = (0, $hAxtE.mergeProps)(domProps, {
        role: 'grid',
        id: id,
        'aria-multiselectable': state.selectionManager.selectionMode === 'multiple' ? 'true' : undefined
    }, state.collection.size === 0 ? {
        tabIndex: hasTabbableChild ? -1 : 0
    } : listProps, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = 1;
    }
    (0, $d8MiS.useGridSelectionAnnouncement)({}, state);
    return {
        gridProps: gridProps
    };
}

});
parcelRegister("29RFN", function(module, exports) {

$parcel$export(module.exports, "listMap", function () { return $fa86da3857a50c0a$export$5b9bb410392e3991; });
$parcel$export(module.exports, "getRowId", function () { return $fa86da3857a50c0a$export$f45c25170b9a99c2; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $fa86da3857a50c0a$export$5b9bb410392e3991 = new WeakMap();
function $fa86da3857a50c0a$export$f45c25170b9a99c2(state, key) {
    var _listMap_get;
    let { id: id } = (_listMap_get = $fa86da3857a50c0a$export$5b9bb410392e3991.get(state)) !== null && _listMap_get !== void 0 ? _listMap_get : {};
    if (!id) throw new Error('Unknown list');
    return `${id}-${$fa86da3857a50c0a$export$e0c709538cb8ae18(key)}`;
}
function $fa86da3857a50c0a$export$e0c709538cb8ae18(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}

});

parcelRegister("d8MiS", function(module, exports) {

$parcel$export(module.exports, "useGridSelectionAnnouncement", function () { return $abd11c83735f6fba$export$137e594ef3218a10; });

var $1uMSl = parcelRequire("1uMSl");

var $lvrF1 = parcelRequire("lvrF1");

var $kbHlJ = parcelRequire("kbHlJ");

var $bh6RR = parcelRequire("bh6RR");

var $90mAp = parcelRequire("90mAp");
function $abd11c83735f6fba$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $abd11c83735f6fba$export$137e594ef3218a10(props, state) {
    let { getRowText: getRowText = (key)=>{
        var _state_collection_getTextValue, _state_collection, _state_collection_getItem;
        var _state_collection_getTextValue1;
        return (_state_collection_getTextValue1 = (_state_collection_getTextValue = (_state_collection = state.collection).getTextValue) === null || _state_collection_getTextValue === void 0 ? void 0 : _state_collection_getTextValue.call(_state_collection, key)) !== null && _state_collection_getTextValue1 !== void 0 ? _state_collection_getTextValue1 : (_state_collection_getItem = state.collection.getItem(key)) === null || _state_collection_getItem === void 0 ? void 0 : _state_collection_getItem.textValue;
    } } = props;
    let stringFormatter = (0, $kbHlJ.useLocalizedStringFormatter)($abd11c83735f6fba$var$$parcel$interopDefault((0, $1uMSl.default)), '@react-aria/grid');
    // Many screen readers do not announce when items in a grid are selected/deselected.
    // We do this using an ARIA live region.
    let selection = state.selectionManager.rawSelection;
    let lastSelection = (0, $bh6RR.useRef)(selection);
    (0, $90mAp.useUpdateEffect)(()=>{
        var _lastSelection_current;
        if (!state.selectionManager.isFocused) {
            lastSelection.current = selection;
            return;
        }
        let addedKeys = $abd11c83735f6fba$var$$92599c3fd427b763$var$diffSelection(selection, lastSelection.current);
        let removedKeys = $abd11c83735f6fba$var$$92599c3fd427b763$var$diffSelection(lastSelection.current, selection);
        // If adding or removing a single row from the selection, announce the name of that item.
        let isReplace = state.selectionManager.selectionBehavior === 'replace';
        let messages = [];
        if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
            if (state.collection.getItem(state.selectionManager.selectedKeys.keys().next().value)) {
                let currentSelectionText = getRowText(state.selectionManager.selectedKeys.keys().next().value);
                if (currentSelectionText) messages.push(stringFormatter.format('selectedItem', {
                    item: currentSelectionText
                }));
            }
        } else if (addedKeys.size === 1 && removedKeys.size === 0) {
            let addedText = getRowText(addedKeys.keys().next().value);
            if (addedText) messages.push(stringFormatter.format('selectedItem', {
                item: addedText
            }));
        } else if (removedKeys.size === 1 && addedKeys.size === 0) {
            if (state.collection.getItem(removedKeys.keys().next().value)) {
                let removedText = getRowText(removedKeys.keys().next().value);
                if (removedText) messages.push(stringFormatter.format('deselectedItem', {
                    item: removedText
                }));
            }
        }
        // Announce how many items are selected, except when selecting the first item.
        if (state.selectionManager.selectionMode === 'multiple') {
            if (messages.length === 0 || selection === 'all' || selection.size > 1 || lastSelection.current === 'all' || ((_lastSelection_current = lastSelection.current) === null || _lastSelection_current === void 0 ? void 0 : _lastSelection_current.size) > 1) messages.push(selection === 'all' ? stringFormatter.format('selectedAll') : stringFormatter.format('selectedCount', {
                count: selection.size
            }));
        }
        if (messages.length > 0) (0, $lvrF1.announce)(messages.join(' '));
        lastSelection.current = selection;
    }, [
        selection
    ]);
}
function $abd11c83735f6fba$var$$92599c3fd427b763$var$diffSelection(a, b) {
    let res = new Set();
    if (a === 'all' || b === 'all') return res;
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}

});
parcelRegister("1uMSl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c2a02254ff53170$export$2e2bcd8739ae039; });

var $bVQ1k = parcelRequire("bVQ1k");

var $4S5Et = parcelRequire("4S5Et");

var $6tUQi = parcelRequire("6tUQi");

var $cGiHL = parcelRequire("cGiHL");

var $3f5dw = parcelRequire("3f5dw");

var $ebM7M = parcelRequire("ebM7M");

var $86EUq = parcelRequire("86EUq");

var $aunSV = parcelRequire("aunSV");

var $9Ycfl = parcelRequire("9Ycfl");

var $5LIqQ = parcelRequire("5LIqQ");

var $43cQd = parcelRequire("43cQd");

var $82SC2 = parcelRequire("82SC2");

var $cjpmE = parcelRequire("cjpmE");

var $e0lxM = parcelRequire("e0lxM");

var $ekpI7 = parcelRequire("ekpI7");

var $10tob = parcelRequire("10tob");

var $1L3j1 = parcelRequire("1L3j1");

var $eE1W4 = parcelRequire("eE1W4");

var $beuFT = parcelRequire("beuFT");

var $grSjG = parcelRequire("grSjG");

var $9sTjM = parcelRequire("9sTjM");

var $gZAz6 = parcelRequire("gZAz6");

var $ahpnM = parcelRequire("ahpnM");

var $hLZsX = parcelRequire("hLZsX");

var $5rcyc = parcelRequire("5rcyc");

var $jzNlH = parcelRequire("jzNlH");

var $httR9 = parcelRequire("httR9");

var $go3Kk = parcelRequire("go3Kk");

var $183Sq = parcelRequire("183Sq");

var $fIS7o = parcelRequire("fIS7o");

var $dAuYW = parcelRequire("dAuYW");

var $fe7Rg = parcelRequire("fe7Rg");

var $d7Xhh = parcelRequire("d7Xhh");

var $bdUiJ = parcelRequire("bdUiJ");
var $5c2a02254ff53170$export$2e2bcd8739ae039 = {};
$5c2a02254ff53170$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $bVQ1k.default),
    "bg-BG": (0, $4S5Et.default),
    "cs-CZ": (0, $6tUQi.default),
    "da-DK": (0, $cGiHL.default),
    "de-DE": (0, $3f5dw.default),
    "el-GR": (0, $ebM7M.default),
    "en-US": (0, $86EUq.default),
    "es-ES": (0, $aunSV.default),
    "et-EE": (0, $9Ycfl.default),
    "fi-FI": (0, $5LIqQ.default),
    "fr-FR": (0, $43cQd.default),
    "he-IL": (0, $82SC2.default),
    "hr-HR": (0, $cjpmE.default),
    "hu-HU": (0, $e0lxM.default),
    "it-IT": (0, $ekpI7.default),
    "ja-JP": (0, $10tob.default),
    "ko-KR": (0, $1L3j1.default),
    "lt-LT": (0, $eE1W4.default),
    "lv-LV": (0, $beuFT.default),
    "nb-NO": (0, $grSjG.default),
    "nl-NL": (0, $9sTjM.default),
    "pl-PL": (0, $gZAz6.default),
    "pt-BR": (0, $ahpnM.default),
    "pt-PT": (0, $hLZsX.default),
    "ro-RO": (0, $5rcyc.default),
    "ru-RU": (0, $jzNlH.default),
    "sk-SK": (0, $httR9.default),
    "sl-SI": (0, $go3Kk.default),
    "sr-SP": (0, $183Sq.default),
    "sv-SE": (0, $fIS7o.default),
    "tr-TR": (0, $dAuYW.default),
    "uk-UA": (0, $fe7Rg.default),
    "zh-CN": (0, $d7Xhh.default),
    "zh-TW": (0, $bdUiJ.default)
};

});
parcelRegister("bVQ1k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a1e0c6f65f5c178$export$2e2bcd8739ae039; });
var $6a1e0c6f65f5c178$export$2e2bcd8739ae039 = {};
$6a1e0c6f65f5c178$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{63A}\u{64A}\u{631} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}`,
    "longPressToSelect": `\u{627}\u{636}\u{63A}\u{637} \u{645}\u{637}\u{648}\u{644}\u{64B}\u{627} \u{644}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{625}\u{644}\u{649} \u{648}\u{636}\u{639} \u{627}\u{644}\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}.`,
    "select": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}`,
    "selectedAll": `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}\u{629}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{639}\u{646}\u{627}\u{635}\u{631}`,
            one: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
            other: ()=>`${formatter.number(args.count)} \u{639}\u{646}\u{635}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}`
};

});

parcelRegister("4S5Et", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44f58d3f7a02831c$export$2e2bcd8739ae039; });
var $44f58d3f7a02831c$export$2e2bcd8739ae039 = {};
$44f58d3f7a02831c$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{435} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}.`,
    "longPressToSelect": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{438} \u{437}\u{430}\u{434}\u{440}\u{44A}\u{436}\u{442}\u{435} \u{437}\u{430} \u{434}\u{430} \u{432}\u{43B}\u{435}\u{437}\u{435}\u{442}\u{435} \u{432} \u{438}\u{437}\u{431}\u{438}\u{440}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{43D} \u{440}\u{435}\u{436}\u{438}\u{43C}.`,
    "select": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435}`,
    "selectedAll": `\u{412}\u{441}\u{438}\u{447}\u{43A}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438} \u{441}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{44F}\u{43C}\u{430} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`,
            one: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
            other: ()=>`${formatter.number(args.count)} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}.`
};

});

parcelRegister("6tUQi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aacce093f86a0ec7$export$2e2bcd8739ae039; });
var $aacce093f86a0ec7$export$2e2bcd8739ae039 = {};
$aacce093f86a0ec7$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Polo\u{17E}ka ${args.item} nen\xed vybr\xe1na.`,
    "longPressToSelect": `Dlouh\xfdm stisknut\xedm p\u{159}ejdete do re\u{17E}imu v\xfdb\u{11B}ru.`,
    "select": `Vybrat`,
    "selectedAll": `Vybr\xe1ny v\u{161}echny polo\u{17E}ky.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nevybr\xe1ny \u{17E}\xe1dn\xe9 polo\u{17E}ky`,
            one: ()=>`Vybr\xe1na ${formatter.number(args.count)} polo\u{17E}ka`,
            other: ()=>`Vybr\xe1no ${formatter.number(args.count)} polo\u{17E}ek`
        })}.`,
    "selectedItem": (args)=>`Vybr\xe1na polo\u{17E}ka ${args.item}.`
};

});

parcelRegister("cGiHL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7b7982570208eeb$export$2e2bcd8739ae039; });
var $a7b7982570208eeb$export$2e2bcd8739ae039 = {};
$a7b7982570208eeb$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} ikke valgt.`,
    "longPressToSelect": `Lav et langt tryk for at aktivere valgtilstand.`,
    "select": `V\xe6lg`,
    "selectedAll": `Alle elementer valgt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen elementer valgt`,
            one: ()=>`${formatter.number(args.count)} element valgt`,
            other: ()=>`${formatter.number(args.count)} elementer valgt`
        })}.`,
    "selectedItem": (args)=>`${args.item} valgt.`
};

});

parcelRegister("3f5dw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cf518d1c23eab53$export$2e2bcd8739ae039; });
var $0cf518d1c23eab53$export$2e2bcd8739ae039 = {};
$0cf518d1c23eab53$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nicht ausgew\xe4hlt.`,
    "longPressToSelect": `Gedr\xfcckt halten, um Auswahlmodus zu \xf6ffnen.`,
    "select": `Ausw\xe4hlen`,
    "selectedAll": `Alle Elemente ausgew\xe4hlt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Keine Elemente ausgew\xe4hlt`,
            one: ()=>`${formatter.number(args.count)} Element ausgew\xe4hlt`,
            other: ()=>`${formatter.number(args.count)} Elemente ausgew\xe4hlt`
        })}.`,
    "selectedItem": (args)=>`${args.item} ausgew\xe4hlt.`
};

});

parcelRegister("ebM7M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a924f117ebad6c7$export$2e2bcd8739ae039; });
var $9a924f117ebad6c7$export$2e2bcd8739ae039 = {};
$9a924f117ebad6c7$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} \u{3C4}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF} ${args.item}.`,
    "longPressToSelect": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C4}\u{3B5}\u{3C4}\u{3B1}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BC}\u{3C0}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3C3}\u{3B5} \u{3BB}\u{3B5}\u{3B9}\u{3C4}\u{3BF}\u{3C5}\u{3C1}\u{3B3}\u{3AF}\u{3B1} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{3C2}.`,
    "select": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
    "selectedAll": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3CC}\u{3BB}\u{3B1} \u{3C4}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{394}\u{3B5}\u{3BD} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`,
            one: ()=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} ${formatter.number(args.count)} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF}`,
            other: ()=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B1}\u{3BD} ${formatter.number(args.count)} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
        })}.`,
    "selectedItem": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3C7}\u{3B8}\u{3B7}\u{3BA}\u{3B5} \u{3C4}\u{3BF} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3BF} ${args.item}.`
};

});

parcelRegister("86EUq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b27869a9d7045bdb$export$2e2bcd8739ae039; });
var $b27869a9d7045bdb$export$2e2bcd8739ae039 = {};
$b27869a9d7045bdb$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} not selected.`,
    "select": `Select`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `No items selected`,
            one: ()=>`${formatter.number(args.count)} item selected`,
            other: ()=>`${formatter.number(args.count)} items selected`
        })}.`,
    "selectedAll": `All items selected.`,
    "selectedItem": (args)=>`${args.item} selected.`,
    "longPressToSelect": `Long press to enter selection mode.`
};

});

parcelRegister("aunSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e696448ffb5416b$export$2e2bcd8739ae039; });
var $4e696448ffb5416b$export$2e2bcd8739ae039 = {};
$4e696448ffb5416b$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} no seleccionado.`,
    "longPressToSelect": `Mantenga pulsado para abrir el modo de selecci\xf3n.`,
    "select": `Seleccionar`,
    "selectedAll": `Todos los elementos seleccionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ning\xfan elemento seleccionado`,
            one: ()=>`${formatter.number(args.count)} elemento seleccionado`,
            other: ()=>`${formatter.number(args.count)} elementos seleccionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} seleccionado.`
};

});

parcelRegister("9Ycfl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2e01dae410a23a9$export$2e2bcd8739ae039; });
var $c2e01dae410a23a9$export$2e2bcd8739ae039 = {};
$c2e01dae410a23a9$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} pole valitud.`,
    "longPressToSelect": `Valikure\u{17E}iimi sisenemiseks vajutage pikalt.`,
    "select": `Vali`,
    "selectedAll": `K\xf5ik \xfcksused valitud.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\xdcksusi pole valitud`,
            one: ()=>`${formatter.number(args.count)} \xfcksus valitud`,
            other: ()=>`${formatter.number(args.count)} \xfcksust valitud`
        })}.`,
    "selectedItem": (args)=>`${args.item} valitud.`
};

});

parcelRegister("5LIqQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ffb2b0d71f04f41$export$2e2bcd8739ae039; });
var $3ffb2b0d71f04f41$export$2e2bcd8739ae039 = {};
$3ffb2b0d71f04f41$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Kohdetta ${args.item} ei valittu.`,
    "longPressToSelect": `Siirry valintatilaan painamalla pitk\xe4\xe4n.`,
    "select": `Valitse`,
    "selectedAll": `Kaikki kohteet valittu.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ei yht\xe4\xe4n kohdetta valittu`,
            one: ()=>`${formatter.number(args.count)} kohde valittu`,
            other: ()=>`${formatter.number(args.count)} kohdetta valittu`
        })}.`,
    "selectedItem": (args)=>`${args.item} valittu.`
};

});

parcelRegister("43cQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $573dbe008490f002$export$2e2bcd8739ae039; });
var $573dbe008490f002$export$2e2bcd8739ae039 = {};
$573dbe008490f002$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} non s\xe9lectionn\xe9.`,
    "longPressToSelect": `Appuyez de mani\xe8re prolong\xe9e pour passer en mode de s\xe9lection.`,
    "select": `S\xe9lectionner`,
    "selectedAll": `Tous les \xe9l\xe9ments s\xe9lectionn\xe9s.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Aucun \xe9l\xe9ment s\xe9lectionn\xe9`,
            one: ()=>`${formatter.number(args.count)} \xe9l\xe9ment s\xe9lectionn\xe9`,
            other: ()=>`${formatter.number(args.count)} \xe9l\xe9ments s\xe9lectionn\xe9s`
        })}.`,
    "selectedItem": (args)=>`${args.item} s\xe9lectionn\xe9.`
};

});

parcelRegister("82SC2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d43ed0ab2adcb74f$export$2e2bcd8739ae039; });
var $d43ed0ab2adcb74f$export$2e2bcd8739ae039 = {};
$d43ed0ab2adcb74f$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{5DC}\u{5D0} \u{5E0}\u{5D1}\u{5D7}\u{5E8}.`,
    "longPressToSelect": `\u{5D4}\u{5E7}\u{5E9}\u{5D4} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D4} \u{5DC}\u{5DB}\u{5E0}\u{5D9}\u{5E1}\u{5D4} \u{5DC}\u{5DE}\u{5E6}\u{5D1} \u{5D1}\u{5D7}\u{5D9}\u{5E8}\u{5D4}.`,
    "select": `\u{5D1}\u{5D7}\u{5E8}`,
    "selectedAll": `\u{5DB}\u{5DC} \u{5D4}\u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{5DC}\u{5D0} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD}`,
            one: ()=>`\u{5E4}\u{5E8}\u{5D9}\u{5D8} ${formatter.number(args.count)} \u{5E0}\u{5D1}\u{5D7}\u{5E8}`,
            other: ()=>`${formatter.number(args.count)} \u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D1}\u{5D7}\u{5E8}\u{5D5}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{5E0}\u{5D1}\u{5D7}\u{5E8}.`
};

});

parcelRegister("cjpmE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $736812bd4f7d2f76$export$2e2bcd8739ae039; });
var $736812bd4f7d2f76$export$2e2bcd8739ae039 = {};
$736812bd4f7d2f76$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Stavka ${args.item} nije odabrana.`,
    "longPressToSelect": `Dugo pritisnite za ulazak u na\u{10D}in odabira.`,
    "select": `Odaberite`,
    "selectedAll": `Odabrane su sve stavke.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nije odabrana nijedna stavka`,
            one: ()=>`Odabrana je ${formatter.number(args.count)} stavka`,
            other: ()=>`Odabrano je ${formatter.number(args.count)} stavki`
        })}.`,
    "selectedItem": (args)=>`Stavka ${args.item} je odabrana.`
};

});

parcelRegister("e0lxM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b24134aecba4f94$export$2e2bcd8739ae039; });
var $2b24134aecba4f94$export$2e2bcd8739ae039 = {};
$2b24134aecba4f94$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nincs kijel\xf6lve.`,
    "longPressToSelect": `Nyomja hosszan a kijel\xf6l\xe9shez.`,
    "select": `Kijel\xf6l\xe9s`,
    "selectedAll": `Az \xf6sszes elem kijel\xf6lve.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Egy elem sincs kijel\xf6lve`,
            one: ()=>`${formatter.number(args.count)} elem kijel\xf6lve`,
            other: ()=>`${formatter.number(args.count)} elem kijel\xf6lve`
        })}.`,
    "selectedItem": (args)=>`${args.item} kijel\xf6lve.`
};

});

parcelRegister("ekpI7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $267ea41f5759a4ee$export$2e2bcd8739ae039; });
var $267ea41f5759a4ee$export$2e2bcd8739ae039 = {};
$267ea41f5759a4ee$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} non selezionato.`,
    "longPressToSelect": `Premi a lungo per passare alla modalit\xe0 di selezione.`,
    "select": `Seleziona`,
    "selectedAll": `Tutti gli elementi selezionati.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nessun elemento selezionato`,
            one: ()=>`${formatter.number(args.count)} elemento selezionato`,
            other: ()=>`${formatter.number(args.count)} elementi selezionati`
        })}.`,
    "selectedItem": (args)=>`${args.item} selezionato.`
};

});

parcelRegister("10tob", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f9bbef5583b8d53$export$2e2bcd8739ae039; });
var $7f9bbef5583b8d53$export$2e2bcd8739ae039 = {};
$7f9bbef5583b8d53$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    "longPressToSelect": `\u{9577}\u{62BC}\u{3057}\u{3057}\u{3066}\u{9078}\u{629E}\u{30E2}\u{30FC}\u{30C9}\u{3092}\u{958B}\u{304D}\u{307E}\u{3059}\u{3002}`,
    "select": `\u{9078}\u{629E}`,
    "selectedAll": `\u{3059}\u{3079}\u{3066}\u{306E}\u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{9805}\u{76EE}\u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
            one: ()=>`${formatter.number(args.count)} \u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`,
            other: ()=>`${formatter.number(args.count)} \u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}`
        })}\u{3002}`,
    "selectedItem": (args)=>`${args.item} \u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`
};

});

parcelRegister("1L3j1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $973d74846f48d900$export$2e2bcd8739ae039; });
var $973d74846f48d900$export$2e2bcd8739ae039 = {};
$973d74846f48d900$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item}\u{C774}(\u{AC00}) \u{C120}\u{D0DD}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "longPressToSelect": `\u{C120}\u{D0DD} \u{BAA8}\u{B4DC}\u{B85C} \u{B4E4}\u{C5B4}\u{AC00}\u{B824}\u{BA74} \u{AE38}\u{AC8C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`,
    "select": `\u{C120}\u{D0DD}`,
    "selectedAll": `\u{BAA8}\u{B4E0} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{C120}\u{D0DD}\u{B41C} \u{D56D}\u{BAA9}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
            one: ()=>`${formatter.number(args.count)}\u{AC1C} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`,
            other: ()=>`${formatter.number(args.count)}\u{AC1C} \u{D56D}\u{BAA9}\u{C774} \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}`
        })}.`,
    "selectedItem": (args)=>`${args.item}\u{C774}(\u{AC00}) \u{C120}\u{D0DD}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`
};

});

parcelRegister("eE1W4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1b7049049ad0b0c$export$2e2bcd8739ae039; });
var $e1b7049049ad0b0c$export$2e2bcd8739ae039 = {};
$e1b7049049ad0b0c$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nepasirinkta.`,
    "longPressToSelect": `Nor\u{117}dami \u{12F}jungti pasirinkimo re\u{17E}im\u{105}, paspauskite ir palaikykite.`,
    "select": `Pasirinkti`,
    "selectedAll": `Pasirinkti visi elementai.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nepasirinktas n\u{117} vienas elementas`,
            one: ()=>`Pasirinktas ${formatter.number(args.count)} elementas`,
            other: ()=>`Pasirinkta element\u{173}: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Pasirinkta: ${args.item}.`
};

});

parcelRegister("beuFT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d22b3e62bfce201$export$2e2bcd8739ae039; });
var $3d22b3e62bfce201$export$2e2bcd8739ae039 = {};
$3d22b3e62bfce201$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Vienums ${args.item} nav atlas\u{12B}ts.`,
    "longPressToSelect": `Ilgi turiet nospiestu. lai iesl\u{113}gtu atlases re\u{17E}\u{12B}mu.`,
    "select": `Atlas\u{12B}t`,
    "selectedAll": `Atlas\u{12B}ti visi vienumi.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nav atlas\u{12B}ts neviens vienums`,
            one: ()=>`Atlas\u{12B}to vienumu skaits: ${formatter.number(args.count)}`,
            other: ()=>`Atlas\u{12B}to vienumu skaits: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Atlas\u{12B}ts vienums ${args.item}.`
};

});

parcelRegister("grSjG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4050cd7080d44a01$export$2e2bcd8739ae039; });
var $4050cd7080d44a01$export$2e2bcd8739ae039 = {};
$4050cd7080d44a01$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} er ikke valgt.`,
    "longPressToSelect": `Bruk et langt trykk for \xe5 g\xe5 inn i valgmodus.`,
    "select": `Velg`,
    "selectedAll": `Alle elementer er valgt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Ingen elementer er valgt`,
            one: ()=>`${formatter.number(args.count)} element er valgt`,
            other: ()=>`${formatter.number(args.count)} elementer er valgt`
        })}.`,
    "selectedItem": (args)=>`${args.item} er valgt.`
};

});

parcelRegister("9sTjM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d8443bcddab6fa4$export$2e2bcd8739ae039; });
var $9d8443bcddab6fa4$export$2e2bcd8739ae039 = {};
$9d8443bcddab6fa4$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} niet geselecteerd.`,
    "longPressToSelect": `Druk lang om de selectiemodus te openen.`,
    "select": `Selecteren`,
    "selectedAll": `Alle items geselecteerd.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Geen items geselecteerd`,
            one: ()=>`${formatter.number(args.count)} item geselecteerd`,
            other: ()=>`${formatter.number(args.count)} items geselecteerd`
        })}.`,
    "selectedItem": (args)=>`${args.item} geselecteerd.`
};

});

parcelRegister("gZAz6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96ec12f345a3c4d0$export$2e2bcd8739ae039; });
var $96ec12f345a3c4d0$export$2e2bcd8739ae039 = {};
$96ec12f345a3c4d0$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Nie zaznaczono ${args.item}.`,
    "longPressToSelect": `Naci\u{15B}nij i przytrzymaj, aby wej\u{15B}\u{107} do trybu wyboru.`,
    "select": `Zaznacz`,
    "selectedAll": `Wszystkie zaznaczone elementy.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nie zaznaczono \u{17C}adnych element\xf3w`,
            one: ()=>`${formatter.number(args.count)} zaznaczony element`,
            other: ()=>`${formatter.number(args.count)} zaznaczonych element\xf3w`
        })}.`,
    "selectedItem": (args)=>`Zaznaczono ${args.item}.`
};

});

parcelRegister("ahpnM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c3a5c0cb90dcded$export$2e2bcd8739ae039; });
var $4c3a5c0cb90dcded$export$2e2bcd8739ae039 = {};
$4c3a5c0cb90dcded$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} n\xe3o selecionado.`,
    "longPressToSelect": `Mantenha pressionado para entrar no modo de sele\xe7\xe3o.`,
    "select": `Selecionar`,
    "selectedAll": `Todos os itens selecionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum item selecionado`,
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} selecionado.`
};

});

parcelRegister("hLZsX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74f96410eaeb4724$export$2e2bcd8739ae039; });
var $74f96410eaeb4724$export$2e2bcd8739ae039 = {};
$74f96410eaeb4724$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} n\xe3o selecionado.`,
    "longPressToSelect": `Prima continuamente para entrar no modo de sele\xe7\xe3o.`,
    "select": `Selecionar`,
    "selectedAll": `Todos os itens selecionados.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nenhum item selecionado`,
            one: ()=>`${formatter.number(args.count)} item selecionado`,
            other: ()=>`${formatter.number(args.count)} itens selecionados`
        })}.`,
    "selectedItem": (args)=>`${args.item} selecionado.`
};

});

parcelRegister("5rcyc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdd8fa7f13259868$export$2e2bcd8739ae039; });
var $fdd8fa7f13259868$export$2e2bcd8739ae039 = {};
$fdd8fa7f13259868$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} neselectat.`,
    "longPressToSelect": `Ap\u{103}sa\u{21B}i lung pentru a intra \xeen modul de selectare.`,
    "select": `Selectare`,
    "selectedAll": `Toate elementele selectate.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Niciun element selectat`,
            one: ()=>`${formatter.number(args.count)} element selectat`,
            other: ()=>`${formatter.number(args.count)} elemente selectate`
        })}.`,
    "selectedItem": (args)=>`${args.item} selectat.`
};

});

parcelRegister("jzNlH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43d36d1e4b3656ba$export$2e2bcd8739ae039; });
var $43d36d1e4b3656ba$export$2e2bcd8739ae039 = {};
$43d36d1e4b3656ba$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "longPressToSelect": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{438} \u{443}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{432}\u{445}\u{43E}\u{434}\u{430} \u{432} \u{440}\u{435}\u{436}\u{438}\u{43C} \u{432}\u{44B}\u{431}\u{43E}\u{440}\u{430}.`,
    "select": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}`,
    "selectedAll": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{44B} \u{432}\u{441}\u{435} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{44B}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{41D}\u{435}\u{442} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`,
            one: ()=>`${formatter.number(args.count)} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}`,
            other: ()=>`${formatter.number(args.count)} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`
};

});

parcelRegister("httR9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3b3b063d06ac979$export$2e2bcd8739ae039; });
var $e3b3b063d06ac979$export$2e2bcd8739ae039 = {};
$e3b3b063d06ac979$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Nevybrat\xe9 polo\u{17E}ky: ${args.item}.`,
    "longPressToSelect": `Dlh\u{161}\xedm stla\u{10D}en\xedm prejdite do re\u{17E}imu v\xfdberu.`,
    "select": `Vybra\u{165}`,
    "selectedAll": `V\u{161}etky vybrat\xe9 polo\u{17E}ky.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{17D}iadne vybrat\xe9 polo\u{17E}ky`,
            one: ()=>`${formatter.number(args.count)} vybrat\xe1 polo\u{17E}ka`,
            other: ()=>`Po\u{10D}et vybrat\xfdch polo\u{17E}iek:${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`Vybrat\xe9 polo\u{17E}ky: ${args.item}.`
};

});

parcelRegister("go3Kk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12724d87e40293db$export$2e2bcd8739ae039; });
var $12724d87e40293db$export$2e2bcd8739ae039 = {};
$12724d87e40293db$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`Element ${args.item} ni izbran.`,
    "longPressToSelect": `Za izbirni na\u{10D}in pritisnite in dlje \u{10D}asa dr\u{17E}ite.`,
    "select": `Izberite`,
    "selectedAll": `Vsi elementi so izbrani.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Noben element ni izbran`,
            one: ()=>`${formatter.number(args.count)} element je izbran`,
            other: ()=>`${formatter.number(args.count)} elementov je izbranih`
        })}.`,
    "selectedItem": (args)=>`Element ${args.item} je izbran.`
};

});

parcelRegister("183Sq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e8cc7740c67ddcf$export$2e2bcd8739ae039; });
var $8e8cc7740c67ddcf$export$2e2bcd8739ae039 = {};
$8e8cc7740c67ddcf$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} nije izabrano.`,
    "longPressToSelect": `Dugo pritisnite za ulazak u re\u{17E}im biranja.`,
    "select": `Izaberite`,
    "selectedAll": `Izabrane su sve stavke.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Nije izabrana nijedna stavka`,
            one: ()=>`Izabrana je ${formatter.number(args.count)} stavka`,
            other: ()=>`Izabrano je ${formatter.number(args.count)} stavki`
        })}.`,
    "selectedItem": (args)=>`${args.item} je izabrano.`
};

});

parcelRegister("fIS7o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3f2c9011314fafd$export$2e2bcd8739ae039; });
var $f3f2c9011314fafd$export$2e2bcd8739ae039 = {};
$f3f2c9011314fafd$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} ej markerat.`,
    "longPressToSelect": `Tryck l\xe4nge n\xe4r du vill \xf6ppna v\xe4ljarl\xe4ge.`,
    "select": `Markera`,
    "selectedAll": `Alla markerade objekt.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Inga markerade objekt`,
            one: ()=>`${formatter.number(args.count)} markerat objekt`,
            other: ()=>`${formatter.number(args.count)} markerade objekt`
        })}.`,
    "selectedItem": (args)=>`${args.item} markerat.`
};

});

parcelRegister("dAuYW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $204b2d77cd315ca2$export$2e2bcd8739ae039; });
var $204b2d77cd315ca2$export$2e2bcd8739ae039 = {};
$204b2d77cd315ca2$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} se\xe7ilmedi.`,
    "longPressToSelect": `Se\xe7im moduna girmek i\xe7in uzun bas\u{131}n.`,
    "select": `Se\xe7`,
    "selectedAll": `T\xfcm \xf6geler se\xe7ildi.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `Hi\xe7bir \xf6ge se\xe7ilmedi`,
            one: ()=>`${formatter.number(args.count)} \xf6ge se\xe7ildi`,
            other: ()=>`${formatter.number(args.count)} \xf6ge se\xe7ildi`
        })}.`,
    "selectedItem": (args)=>`${args.item} se\xe7ildi.`
};

});

parcelRegister("fe7Rg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d03bbff0e0ad7810$export$2e2bcd8739ae039; });
var $d03bbff0e0ad7810$export$2e2bcd8739ae039 = {};
$d03bbff0e0ad7810$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`${args.item} \u{43D}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "longPressToSelect": `\u{412}\u{438}\u{43A}\u{43E}\u{43D}\u{430}\u{439}\u{442}\u{435} \u{434}\u{43E}\u{432}\u{433}\u{435} \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{43D}\u{43D}\u{44F}, \u{449}\u{43E}\u{431} \u{43F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{432} \u{440}\u{435}\u{436}\u{438}\u{43C} \u{432}\u{438}\u{431}\u{43E}\u{440}\u{443}.`,
    "select": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438}`,
    "selectedAll": `\u{423}\u{441}\u{456} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{416}\u{43E}\u{434}\u{43D}\u{438}\u{445} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432} \u{43D}\u{435} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            one: ()=>`${formatter.number(args.count)} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}`,
            other: ()=>`\u{412}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{456}\u{432}: ${formatter.number(args.count)}`
        })}.`,
    "selectedItem": (args)=>`${args.item} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E}.`
};

});

parcelRegister("d7Xhh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ece4001d487dc5e5$export$2e2bcd8739ae039; });
var $ece4001d487dc5e5$export$2e2bcd8739ae039 = {};
$ece4001d487dc5e5$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`\u{672A}\u{9009}\u{62E9} ${args.item}\u{3002}`,
    "longPressToSelect": `\u{957F}\u{6309}\u{4EE5}\u{8FDB}\u{5165}\u{9009}\u{62E9}\u{6A21}\u{5F0F}\u{3002}`,
    "select": `\u{9009}\u{62E9}`,
    "selectedAll": `\u{5DF2}\u{9009}\u{62E9}\u{6240}\u{6709}\u{9879}\u{76EE}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9009}\u{62E9}\u{9879}\u{76EE}`,
            one: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}\u{9879}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9009}\u{62E9} ${formatter.number(args.count)} \u{4E2A}\u{9879}\u{76EE}`
        })}\u{3002}`,
    "selectedItem": (args)=>`\u{5DF2}\u{9009}\u{62E9} ${args.item}\u{3002}`
};

});

parcelRegister("bdUiJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77e4b36ac2eade49$export$2e2bcd8739ae039; });
var $77e4b36ac2eade49$export$2e2bcd8739ae039 = {};
$77e4b36ac2eade49$export$2e2bcd8739ae039 = {
    "deselectedItem": (args)=>`\u{672A}\u{9078}\u{53D6}\u{300C}${args.item}\u{300D}\u{3002}`,
    "longPressToSelect": `\u{9577}\u{6309}\u{4EE5}\u{9032}\u{5165}\u{9078}\u{64C7}\u{6A21}\u{5F0F}\u{3002}`,
    "select": `\u{9078}\u{53D6}`,
    "selectedAll": `\u{5DF2}\u{9078}\u{53D6}\u{6240}\u{6709}\u{9805}\u{76EE}\u{3002}`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `\u{672A}\u{9078}\u{53D6}\u{4EFB}\u{4F55}\u{9805}\u{76EE}`,
            one: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}\u{9805}\u{76EE}`,
            other: ()=>`\u{5DF2}\u{9078}\u{53D6} ${formatter.number(args.count)} \u{500B}\u{9805}\u{76EE}`
        })}\u{3002}`,
    "selectedItem": (args)=>`\u{5DF2}\u{9078}\u{53D6}\u{300C}${args.item}\u{300D}\u{3002}`
};

});


parcelRegister("90mAp", function(module, exports) {

$parcel$export(module.exports, "useUpdateEffect", function () { return $8d8e0ae7faa11d2a$export$496315a1608d9602; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8d8e0ae7faa11d2a$export$496315a1608d9602(effect, dependencies) {
    const isInitialMount = (0, $bh6RR.useRef)(true);
    const lastDeps = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        isInitialMount.current = true;
        return ()=>{
            isInitialMount.current = false;
        };
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!lastDeps.current || dependencies.some((dep, i)=>!Object.is(dep, lastDeps[i]))) effect();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});


parcelRegister("g2XaT", function(module, exports) {

$parcel$export(module.exports, "useHighlightSelectionDescription", function () { return $9e9553926c85e019$export$be42ebdab07ae4c2; });

var $1uMSl = parcelRequire("1uMSl");

var $eHR6B = parcelRequire("eHR6B");

var $8tXMg = parcelRequire("8tXMg");

var $kbHlJ = parcelRequire("kbHlJ");

var $bh6RR = parcelRequire("bh6RR");
function $9e9553926c85e019$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9e9553926c85e019$export$be42ebdab07ae4c2(props) {
    let stringFormatter = (0, $kbHlJ.useLocalizedStringFormatter)($9e9553926c85e019$var$$parcel$interopDefault((0, $1uMSl.default)), '@react-aria/grid');
    let modality = (0, $8tXMg.useInteractionModality)();
    // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
    let shouldLongPress = (modality === 'pointer' || modality === 'virtual' || modality == null) && typeof window !== 'undefined' && 'ontouchstart' in window;
    let interactionDescription = (0, $bh6RR.useMemo)(()=>{
        let selectionMode = props.selectionManager.selectionMode;
        let selectionBehavior = props.selectionManager.selectionBehavior;
        let message;
        if (shouldLongPress) message = stringFormatter.format('longPressToSelect');
        return selectionBehavior === 'replace' && selectionMode !== 'none' && props.hasItemActions ? message : undefined;
    }, [
        props.selectionManager.selectionMode,
        props.selectionManager.selectionBehavior,
        props.hasItemActions,
        stringFormatter,
        shouldLongPress
    ]);
    let descriptionProps = (0, $eHR6B.useDescription)(interactionDescription);
    return descriptionProps;
}

});

parcelRegister("huNh9", function(module, exports) {

$parcel$export(module.exports, "useHasTabbableChild", function () { return $0d5b8f675e187c55$export$eac1895992b9f3d6; });

var $2NhrA = parcelRequire("2NhrA");

var $f2PTm = parcelRequire("f2PTm");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0d5b8f675e187c55$export$eac1895992b9f3d6(ref, options) {
    let isDisabled = options === null || options === void 0 ? void 0 : options.isDisabled;
    let [hasTabbableChild, setHasTabbableChild] = (0, $bh6RR.useState)(false);
    (0, $f2PTm.useLayoutEffect)(()=>{
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !isDisabled) {
            let update = ()=>{
                if (ref.current) {
                    let walker = (0, $2NhrA.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            let observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    'tabIndex',
                    'disabled'
                ]
            });
            return ()=>{
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}

});



parcelRegister("gMzjD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a3a08657c6f6828$export$2e2bcd8739ae039; });

var $bfS0z = parcelRequire("bfS0z");

var $Yj3Pa = parcelRequire("Yj3Pa");

var $ewTlO = parcelRequire("ewTlO");

var $hwYOJ = parcelRequire("hwYOJ");

var $hQFpj = parcelRequire("hQFpj");

var $1bA4E = parcelRequire("1bA4E");

var $9EDl8 = parcelRequire("9EDl8");

var $616oS = parcelRequire("616oS");

var $eajRC = parcelRequire("eajRC");

var $j6WTf = parcelRequire("j6WTf");

var $7Tn6d = parcelRequire("7Tn6d");

var $8I2NW = parcelRequire("8I2NW");

var $g4Nmc = parcelRequire("g4Nmc");

var $7rs4n = parcelRequire("7rs4n");

var $4hxTn = parcelRequire("4hxTn");

var $bFx7q = parcelRequire("bFx7q");

var $czAv6 = parcelRequire("czAv6");

var $lxKEH = parcelRequire("lxKEH");

var $9zxNL = parcelRequire("9zxNL");

var $afTWJ = parcelRequire("afTWJ");

var $3rL2k = parcelRequire("3rL2k");

var $iQcZB = parcelRequire("iQcZB");

var $2Fizp = parcelRequire("2Fizp");

var $5eV0P = parcelRequire("5eV0P");

var $7o5vJ = parcelRequire("7o5vJ");

var $8yMtI = parcelRequire("8yMtI");

var $99meC = parcelRequire("99meC");

var $5MUK3 = parcelRequire("5MUK3");

var $kHZ0h = parcelRequire("kHZ0h");

var $fck1i = parcelRequire("fck1i");

var $1TSGJ = parcelRequire("1TSGJ");

var $KZw4r = parcelRequire("KZw4r");

var $3jNVz = parcelRequire("3jNVz");

var $iP5hi = parcelRequire("iP5hi");
var $0a3a08657c6f6828$export$2e2bcd8739ae039 = {};
$0a3a08657c6f6828$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $bfS0z.default),
    "bg-BG": (0, $Yj3Pa.default),
    "cs-CZ": (0, $ewTlO.default),
    "da-DK": (0, $hwYOJ.default),
    "de-DE": (0, $hQFpj.default),
    "el-GR": (0, $1bA4E.default),
    "en-US": (0, $9EDl8.default),
    "es-ES": (0, $616oS.default),
    "et-EE": (0, $eajRC.default),
    "fi-FI": (0, $j6WTf.default),
    "fr-FR": (0, $7Tn6d.default),
    "he-IL": (0, $8I2NW.default),
    "hr-HR": (0, $g4Nmc.default),
    "hu-HU": (0, $7rs4n.default),
    "it-IT": (0, $4hxTn.default),
    "ja-JP": (0, $bFx7q.default),
    "ko-KR": (0, $czAv6.default),
    "lt-LT": (0, $lxKEH.default),
    "lv-LV": (0, $9zxNL.default),
    "nb-NO": (0, $afTWJ.default),
    "nl-NL": (0, $3rL2k.default),
    "pl-PL": (0, $iQcZB.default),
    "pt-BR": (0, $2Fizp.default),
    "pt-PT": (0, $5eV0P.default),
    "ro-RO": (0, $7o5vJ.default),
    "ru-RU": (0, $8yMtI.default),
    "sk-SK": (0, $99meC.default),
    "sl-SI": (0, $5MUK3.default),
    "sr-SP": (0, $kHZ0h.default),
    "sv-SE": (0, $fck1i.default),
    "tr-TR": (0, $1TSGJ.default),
    "uk-UA": (0, $KZw4r.default),
    "zh-CN": (0, $3jNVz.default),
    "zh-TW": (0, $iP5hi.default)
};

});
parcelRegister("bfS0z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a98796c8d0fdf341$export$2e2bcd8739ae039; });
var $a98796c8d0fdf341$export$2e2bcd8739ae039 = {};
$a98796c8d0fdf341$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{625}\u{632}\u{627}\u{644}\u{629}`,
    "removeDescription": `\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} \u{645}\u{641}\u{62A}\u{627}\u{62D} DELETE \u{644}\u{625}\u{632}\u{627}\u{644}\u{629} \u{639}\u{644}\u{627}\u{645}\u{629}.`
};

});

parcelRegister("Yj3Pa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1af73c66aa68458$export$2e2bcd8739ae039; });
var $d1af73c66aa68458$export$2e2bcd8739ae039 = {};
$d1af73c66aa68458$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{41F}\u{440}\u{435}\u{43C}\u{430}\u{445}\u{432}\u{430}\u{43D}\u{435}`,
    "removeDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} Delete, \u{437}\u{430} \u{434}\u{430} \u{43F}\u{440}\u{435}\u{43C}\u{430}\u{445}\u{43D}\u{435}\u{442}\u{435} \u{43C}\u{430}\u{440}\u{43A}\u{435}\u{440}\u{430}.`
};

});

parcelRegister("ewTlO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3139da08e4528919$export$2e2bcd8739ae039; });
var $3139da08e4528919$export$2e2bcd8739ae039 = {};
$3139da08e4528919$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Odebrat`,
    "removeDescription": `Stisknut\xedm kl\xe1vesy Delete odeberete zna\u{10D}ku.`
};

});

parcelRegister("hwYOJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3330163b846027cc$export$2e2bcd8739ae039; });
var $3330163b846027cc$export$2e2bcd8739ae039 = {};
$3330163b846027cc$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Fjern`,
    "removeDescription": `Tryk p\xe5 Slet for at fjerne tag.`
};

});

parcelRegister("hQFpj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c8f643011e475e4$export$2e2bcd8739ae039; });
var $5c8f643011e475e4$export$2e2bcd8739ae039 = {};
$5c8f643011e475e4$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Entfernen`,
    "removeDescription": `Auf \u{201E}L\xf6schen\u{201C} dr\xfccken, um das Tag zu entfernen.`
};

});

parcelRegister("1bA4E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $080d90f9a12cd41e$export$2e2bcd8739ae039; });
var $080d90f9a12cd41e$export$2e2bcd8739ae039 = {};
$080d90f9a12cd41e$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{39A}\u{3B1}\u{3C4}\u{3AC}\u{3C1}\u{3B3}\u{3B7}\u{3C3}\u{3B7}`,
    "removeDescription": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{394}\u{3B9}\u{3B1}\u{3B3}\u{3C1}\u{3B1}\u{3C6}\u{3AE} \u{3B3}\u{3B9}\u{3B1} \u{3BD}\u{3B1} \u{3BA}\u{3B1}\u{3C4}\u{3B1}\u{3C1}\u{3B3}\u{3AE}\u{3C3}\u{3B5}\u{3C4}\u{3B5} \u{3C4}\u{3B7}\u{3BD} \u{3B5}\u{3C4}\u{3B9}\u{3BA}\u{3AD}\u{3C4}\u{3B1}.`
};

});

parcelRegister("9EDl8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7557085216a9df35$export$2e2bcd8739ae039; });
var $7557085216a9df35$export$2e2bcd8739ae039 = {};
$7557085216a9df35$export$2e2bcd8739ae039 = {
    "removeDescription": `Press Delete to remove tag.`,
    "removeButtonLabel": `Remove`
};

});

parcelRegister("616oS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed54dbb7197d7e33$export$2e2bcd8739ae039; });
var $ed54dbb7197d7e33$export$2e2bcd8739ae039 = {};
$ed54dbb7197d7e33$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Quitar`,
    "removeDescription": `Pulse Eliminar para quitar la etiqueta.`
};

});

parcelRegister("eajRC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c4467d08b95b840$export$2e2bcd8739ae039; });
var $3c4467d08b95b840$export$2e2bcd8739ae039 = {};
$3c4467d08b95b840$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Eemalda`,
    "removeDescription": `Sildi eemaldamiseks vajutage kustutusklahvi Delete.`
};

});

parcelRegister("j6WTf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $298910eb0fe68abf$export$2e2bcd8739ae039; });
var $298910eb0fe68abf$export$2e2bcd8739ae039 = {};
$298910eb0fe68abf$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Poista`,
    "removeDescription": `Poista tunniste painamalla Poista-painiketta.`
};

});

parcelRegister("7Tn6d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04e2f98efbb1a874$export$2e2bcd8739ae039; });
var $04e2f98efbb1a874$export$2e2bcd8739ae039 = {};
$04e2f98efbb1a874$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Supprimer`,
    "removeDescription": `Appuyez sur Supprimer pour supprimer l\u{2019}\xe9tiquette.`
};

});

parcelRegister("8I2NW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a9dd2e1c5e2f6d4$export$2e2bcd8739ae039; });
var $4a9dd2e1c5e2f6d4$export$2e2bcd8739ae039 = {};
$4a9dd2e1c5e2f6d4$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{5D4}\u{5E1}\u{5E8}`,
    "removeDescription": `\u{5DC}\u{5D7}\u{5E5} \u{5E2}\u{5DC} \u{5DE}\u{5D7}\u{5E7} \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5D4}\u{5E1}\u{5D9}\u{5E8} \u{5EA}\u{5D2}.`
};

});

parcelRegister("g4Nmc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90b45ba952afed9f$export$2e2bcd8739ae039; });
var $90b45ba952afed9f$export$2e2bcd8739ae039 = {};
$90b45ba952afed9f$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Ukloni`,
    "removeDescription": `Pritisnite Delete za uklanjanje oznake.`
};

});

parcelRegister("7rs4n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be0c624f40a00f66$export$2e2bcd8739ae039; });
var $be0c624f40a00f66$export$2e2bcd8739ae039 = {};
$be0c624f40a00f66$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Elt\xe1vol\xedt\xe1s`,
    "removeDescription": `Nyomja meg a Delete billenty\u{171}t a c\xedmke elt\xe1vol\xedt\xe1s\xe1hoz.`
};

});

parcelRegister("4hxTn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $052c2f5ce297bb70$export$2e2bcd8739ae039; });
var $052c2f5ce297bb70$export$2e2bcd8739ae039 = {};
$052c2f5ce297bb70$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Rimuovi`,
    "removeDescription": `Premi Elimina per rimuovere il tag.`
};

});

parcelRegister("bFx7q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cb33eeaaaebd375$export$2e2bcd8739ae039; });
var $7cb33eeaaaebd375$export$2e2bcd8739ae039 = {};
$7cb33eeaaaebd375$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{524A}\u{9664}`,
    "removeDescription": `\u{30BF}\u{30B0}\u{3092}\u{524A}\u{9664}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}Delete \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{307E}\u{3059}\u{3002}`
};

});

parcelRegister("czAv6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a6df678b4af5cb1$export$2e2bcd8739ae039; });
var $0a6df678b4af5cb1$export$2e2bcd8739ae039 = {};
$0a6df678b4af5cb1$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{C81C}\u{AC70}`,
    "removeDescription": `\u{D0DC}\u{ADF8}\u{B97C} \u{C81C}\u{AC70}\u{D558}\u{B824}\u{BA74} Delete \u{D0A4}\u{B97C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`
};

});

parcelRegister("lxKEH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61c188673fd7818c$export$2e2bcd8739ae039; });
var $61c188673fd7818c$export$2e2bcd8739ae039 = {};
$61c188673fd7818c$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Pa\u{161}alinti`,
    "removeDescription": `Nor\u{117}dami pa\u{161}alinti \u{17E}ym\u{105}, paspauskite \u{201E}Delete\u{201C} klavi\u{161}\u{105}.`
};

});

parcelRegister("9zxNL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aea39bbd934ddeb3$export$2e2bcd8739ae039; });
var $aea39bbd934ddeb3$export$2e2bcd8739ae039 = {};
$aea39bbd934ddeb3$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `No\u{146}emt`,
    "removeDescription": `Nospiediet Delete [Dz\u{113}st], lai no\u{146}emtu tagu.`
};

});

parcelRegister("afTWJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5677e07844c9583$export$2e2bcd8739ae039; });
var $d5677e07844c9583$export$2e2bcd8739ae039 = {};
$d5677e07844c9583$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Fjern`,
    "removeDescription": `Trykk p\xe5 Slett for \xe5 fjerne taggen.`
};

});

parcelRegister("3rL2k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a329db24e89d1de$export$2e2bcd8739ae039; });
var $6a329db24e89d1de$export$2e2bcd8739ae039 = {};
$6a329db24e89d1de$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Verwijderen`,
    "removeDescription": `Druk op Verwijderen om de tag te verwijderen.`
};

});

parcelRegister("iQcZB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c1b1bdbfa1eace0$export$2e2bcd8739ae039; });
var $8c1b1bdbfa1eace0$export$2e2bcd8739ae039 = {};
$8c1b1bdbfa1eace0$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Usu\u{144}`,
    "removeDescription": `Naci\u{15B}nij Usu\u{144}, aby usun\u{105}\u{107} znacznik.`
};

});

parcelRegister("2Fizp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abd3043d6991b894$export$2e2bcd8739ae039; });
var $abd3043d6991b894$export$2e2bcd8739ae039 = {};
$abd3043d6991b894$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Remover`,
    "removeDescription": `Pressione Delete para remover a tag.`
};

});

parcelRegister("5eV0P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c1d11f3c341319e$export$2e2bcd8739ae039; });
var $9c1d11f3c341319e$export$2e2bcd8739ae039 = {};
$9c1d11f3c341319e$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Eliminar`,
    "removeDescription": `Prima Delete para eliminar a tag.`
};

});

parcelRegister("7o5vJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a687d0a8ece63274$export$2e2bcd8739ae039; });
var $a687d0a8ece63274$export$2e2bcd8739ae039 = {};
$a687d0a8ece63274$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\xcendep\u{103}rta\u{163}i`,
    "removeDescription": `Ap\u{103}sa\u{21B}i pe Delete (\u{218}tergere) pentru a elimina eticheta.`
};

});

parcelRegister("8yMtI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c98be06badd8a4e$export$2e2bcd8739ae039; });
var $4c98be06badd8a4e$export$2e2bcd8739ae039 = {};
$4c98be06badd8a4e$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}`,
    "removeDescription": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} DELETE, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{442}\u{435}\u{433}.`
};

});

parcelRegister("99meC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03b16d38c5aac6f1$export$2e2bcd8739ae039; });
var $03b16d38c5aac6f1$export$2e2bcd8739ae039 = {};
$03b16d38c5aac6f1$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Odstr\xe1ni\u{165}`,
    "removeDescription": `Ak chcete odstr\xe1ni\u{165} zna\u{10D}ku, stla\u{10D}te kl\xe1ves Delete.`
};

});

parcelRegister("5MUK3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $869f19bcada3f7e7$export$2e2bcd8739ae039; });
var $869f19bcada3f7e7$export$2e2bcd8739ae039 = {};
$869f19bcada3f7e7$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Odstrani`,
    "removeDescription": `Pritisnite Delete, da odstranite oznako.`
};

});

parcelRegister("kHZ0h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $570a14a3ae5f376e$export$2e2bcd8739ae039; });
var $570a14a3ae5f376e$export$2e2bcd8739ae039 = {};
$570a14a3ae5f376e$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Ukloni`,
    "removeDescription": `Pritisnite Obri\u{161}i da biste uklonili oznaku.`
};

});

parcelRegister("fck1i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e27f075ec5b452c4$export$2e2bcd8739ae039; });
var $e27f075ec5b452c4$export$2e2bcd8739ae039 = {};
$e27f075ec5b452c4$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Ta bort`,
    "removeDescription": `Tryck p\xe5 Radera f\xf6r att ta bort taggen.`
};

});

parcelRegister("1TSGJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c11c9e84fd8d86d0$export$2e2bcd8739ae039; });
var $c11c9e84fd8d86d0$export$2e2bcd8739ae039 = {};
$c11c9e84fd8d86d0$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `Kald\u{131}r`,
    "removeDescription": `Etiketi kald\u{131}rmak i\xe7in Sil tu\u{15F}una bas\u{131}n.`
};

});

parcelRegister("KZw4r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac9cba6a76682df7$export$2e2bcd8739ae039; });
var $ac9cba6a76682df7$export$2e2bcd8739ae039 = {};
$ac9cba6a76682df7$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{412}\u{438}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{438}`,
    "removeDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Delete, \u{449}\u{43E}\u{431} \u{432}\u{438}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{438} \u{442}\u{435}\u{433}.`
};

});

parcelRegister("3jNVz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d7d3a909377646f$export$2e2bcd8739ae039; });
var $8d7d3a909377646f$export$2e2bcd8739ae039 = {};
$8d7d3a909377646f$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{5220}\u{9664}`,
    "removeDescription": `\u{6309}\u{4E0B}\u{201C}\u{5220}\u{9664}\u{201D}\u{4EE5}\u{5220}\u{9664}\u{6807}\u{8BB0}\u{3002}`
};

});

parcelRegister("iP5hi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1046aef2f1646ee$export$2e2bcd8739ae039; });
var $e1046aef2f1646ee$export$2e2bcd8739ae039 = {};
$e1046aef2f1646ee$export$2e2bcd8739ae039 = {
    "removeButtonLabel": `\u{79FB}\u{9664}`,
    "removeDescription": `\u{6309} Delete \u{9375}\u{4EE5}\u{79FB}\u{9664}\u{6A19}\u{8A18}\u{3002}`
};

});


parcelRegister("3Nz7h", function(module, exports) {

$parcel$export(module.exports, "useGridListItem", function () { return $8bee5a68ce31db66$export$9610e69494fadfd2; });

var $29RFN = parcelRequire("29RFN");

var $jQZLC = parcelRequire("jQZLC");
var $eF7Zd = parcelRequire("eF7Zd");
var $hAxtE = parcelRequire("hAxtE");
var $2FItP = parcelRequire("2FItP");
var $gxMV2 = parcelRequire("gxMV2");
var $gN5ZC = parcelRequire("gN5ZC");

var $bQDsd = parcelRequire("bQDsd");
var $2NhrA = parcelRequire("2NhrA");

var $6z78f = parcelRequire("6z78f");

var $bh6RR = parcelRequire("bh6RR");

var $8tXMg = parcelRequire("8tXMg");

var $gYN2y = parcelRequire("gYN2y");

var $c8uzR = parcelRequire("c8uzR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $8bee5a68ce31db66$var$$4e8b0456ef72939f$var$EXPANSION_KEYS = {
    'expand': {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    'collapse': {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function $8bee5a68ce31db66$export$9610e69494fadfd2(props, state, ref) {
    var _node_props, _node_props1;
    // Copied from useGridCell + some modifications to make it not so grid specific
    let { node: node, isVirtualized: isVirtualized, shouldSelectOnPressUp: shouldSelectOnPressUp } = props;
    // let stringFormatter = useLocalizedStringFormatter(intlMessages, '@react-aria/gridlist');
    let { direction: direction } = (0, $c8uzR.useLocale)();
    let { onAction: onAction, linkBehavior: linkBehavior, keyboardNavigationBehavior: keyboardNavigationBehavior } = (0, $29RFN.listMap).get(state);
    let descriptionId = (0, $gxMV2.useSlotId)();
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, $bh6RR.useRef)(null);
    let focus = ()=>{
        var _ref_current;
        // Don't shift focus to the row if the active element is a element within the row already
        // (e.g. clicking on a row button)
        if (ref.current !== null && (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !((_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.contains(document.activeElement)))) (0, $bQDsd.focusSafely)(ref.current);
    };
    let treeGridRowProps = {};
    let hasChildRows;
    let hasLink = state.selectionManager.isLink(node.key);
    if (node != null && 'expandedKeys' in state) {
        var _state_collection_getChildren, _state_collection, _filter_at;
        // TODO: ideally node.hasChildNodes would be a way to tell if a row has child nodes, but the row's contents make it so that value is always
        // true...
        let children = (_state_collection_getChildren = (_state_collection = state.collection).getChildren) === null || _state_collection_getChildren === void 0 ? void 0 : _state_collection_getChildren.call(_state_collection, node.key);
        hasChildRows = [
            ...children !== null && children !== void 0 ? children : []
        ].length > 1;
        if (onAction == null && !hasLink && state.selectionManager.selectionMode === 'none' && hasChildRows) onAction = ()=>state.toggleKey(node.key);
        let isExpanded = hasChildRows ? state.expandedKeys.has(node.key) : undefined;
        let setSize = 1;
        var _filter_at_index;
        if (node.level > 0 && (node === null || node === void 0 ? void 0 : node.parentKey) != null) {
            let parent = state.collection.getItem(node.parentKey);
            if (parent) {
                var _state_collection_getChildren1, _state_collection1;
                // siblings must exist because our original node exists, same with lastItem
                let siblings = (_state_collection_getChildren1 = (_state_collection1 = state.collection).getChildren) === null || _state_collection_getChildren1 === void 0 ? void 0 : _state_collection_getChildren1.call(_state_collection1, parent.key);
                setSize = (0, $6z78f.getLastItem)(siblings).index + 1;
            }
        } else setSize = ((_filter_at_index = (_filter_at = [
            ...state.collection
        ].filter((row)=>row.level === 0).at(-1)) === null || _filter_at === void 0 ? void 0 : _filter_at.index) !== null && _filter_at_index !== void 0 ? _filter_at_index : 0) + 1;
        treeGridRowProps = {
            'aria-expanded': isExpanded,
            'aria-level': node.level + 1,
            'aria-posinset': (node === null || node === void 0 ? void 0 : node.index) + 1,
            'aria-setsize': setSize
        };
    }
    let { itemProps: itemProps, ...itemStates } = (0, $gYN2y.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref: ref,
        isVirtualized: isVirtualized,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        onAction: onAction || ((_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.onAction) ? (0, $jQZLC.chain)((_node_props1 = node.props) === null || _node_props1 === void 0 ? void 0 : _node_props1.onAction, onAction ? ()=>onAction(node.key) : undefined) : undefined,
        focus: focus,
        linkBehavior: linkBehavior
    });
    let onKeyDown = (e)=>{
        if (!e.currentTarget.contains(e.target) || !ref.current || !document.activeElement) return;
        let walker = (0, $2NhrA.getFocusableTreeWalker)(ref.current);
        walker.currentNode = document.activeElement;
        if ('expandedKeys' in state && document.activeElement === ref.current) {
            if (e.key === $8bee5a68ce31db66$var$$4e8b0456ef72939f$var$EXPANSION_KEYS['expand'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && !state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            } else if (e.key === $8bee5a68ce31db66$var$$4e8b0456ef72939f$var$EXPANSION_KEYS['collapse'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            }
        }
        switch(e.key){
            case 'ArrowLeft':
                if (keyboardNavigationBehavior === 'arrow') {
                    // Find the next focusable element within the row.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, $bQDsd.focusSafely)(focusable);
                        (0, $2FItP.scrollIntoViewport)(focusable, {
                            containingElement: (0, $eF7Zd.getScrollParent)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then return focus back to the row
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'rtl') {
                            (0, $bQDsd.focusSafely)(ref.current);
                            (0, $2FItP.scrollIntoViewport)(ref.current, {
                                containingElement: (0, $eF7Zd.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = $8bee5a68ce31db66$var$$4e8b0456ef72939f$var$last(walker);
                            if (lastElement) {
                                (0, $bQDsd.focusSafely)(lastElement);
                                (0, $2FItP.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, $eF7Zd.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowRight':
                if (keyboardNavigationBehavior === 'arrow') {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, $bQDsd.focusSafely)(focusable);
                        (0, $2FItP.scrollIntoViewport)(focusable, {
                            containingElement: (0, $eF7Zd.getScrollParent)(ref.current)
                        });
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'ltr') {
                            (0, $bQDsd.focusSafely)(ref.current);
                            (0, $2FItP.scrollIntoViewport)(ref.current, {
                                containingElement: (0, $eF7Zd.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = $8bee5a68ce31db66$var$$4e8b0456ef72939f$var$last(walker);
                            if (lastElement) {
                                (0, $bQDsd.focusSafely)(lastElement);
                                (0, $2FItP.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, $eF7Zd.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching row children, e.g. menu buttons. We want arrow keys to navigate
                // to the row above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && ref.current.contains(e.target)) {
                    var _ref_current_parentElement;
                    e.stopPropagation();
                    e.preventDefault();
                    (_ref_current_parentElement = ref.current.parentElement) === null || _ref_current_parentElement === void 0 || _ref_current_parentElement.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
            case 'Tab':
                if (keyboardNavigationBehavior === 'tab') {
                    // If there is another focusable element within this item, stop propagation so the tab key
                    // is handled by the browser and not by useSelectableCollection (which would take us out of the list).
                    let walker = (0, $2NhrA.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    walker.currentNode = document.activeElement;
                    let next = e.shiftKey ? walker.previousNode() : walker.nextNode();
                    if (next) e.stopPropagation();
                }
        }
    };
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the row itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row
            // in that case since the list should act like a single tab stop.
            if (!(0, $8tXMg.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
    };
    let syntheticLinkProps = (0, $gN5ZC.useSyntheticLinkProps)(node.props);
    let linkProps = itemStates.hasAction ? syntheticLinkProps : {};
    // TODO: re-add when we get translations and fix this for iOS VO
    // let rowAnnouncement;
    // if (onAction) {
    //   rowAnnouncement = stringFormatter.format('hasActionAnnouncement');
    // } else if (hasLink) {
    //   rowAnnouncement = stringFormatter.format('hasLinkAnnouncement', {
    //     link: node.props.href
    //   });
    // }
    let rowProps = (0, $hAxtE.mergeProps)(itemProps, linkProps, {
        role: 'row',
        onKeyDownCapture: onKeyDown,
        onFocus: onFocus,
        // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
        'aria-label': node.textValue || undefined,
        'aria-selected': state.selectionManager.canSelectItem(node.key) ? state.selectionManager.isSelected(node.key) : undefined,
        'aria-disabled': state.selectionManager.isDisabled(node.key) || undefined,
        'aria-labelledby': descriptionId && node.textValue ? `${(0, $29RFN.getRowId)(state, node.key)} ${descriptionId}` : undefined,
        id: (0, $29RFN.getRowId)(state, node.key)
    });
    if (isVirtualized) rowProps['aria-rowindex'] = node.index + 1;
    let gridCellProps = {
        role: 'gridcell',
        'aria-colindex': 1
    };
    // TODO: should isExpanded and hasChildRows be a item state that gets returned by the hook?
    return {
        rowProps: {
            ...(0, $hAxtE.mergeProps)(rowProps, treeGridRowProps)
        },
        gridCellProps: gridCellProps,
        descriptionProps: {
            id: descriptionId
        },
        ...itemStates
    };
}
function $8bee5a68ce31db66$var$$4e8b0456ef72939f$var$last(walker) {
    let next = null;
    let last = null;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}

});



parcelRegister("arHbU", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $664781cb34daee7d$export$b04be29aa201d4f5; });
$parcel$export(module.exports, "Description", function () { return $664781cb34daee7d$export$393edc798c47379d; });
$parcel$export(module.exports, "FieldError", function () { return $664781cb34daee7d$export$f551688fc98f2e09; });
$parcel$export(module.exports, "fieldBorderStyles", function () { return $664781cb34daee7d$export$ef43aab117e9ac1c; });
$parcel$export(module.exports, "fieldGroupStyles", function () { return $664781cb34daee7d$export$9668428692f07fef; });
$parcel$export(module.exports, "FieldGroup", function () { return $664781cb34daee7d$export$f0fe469072bc6950; });
$parcel$export(module.exports, "Input", function () { return $664781cb34daee7d$export$f5b8910cec6cf069; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $dgWhj = parcelRequire("dgWhj");
var $lVuqN = parcelRequire("lVuqN");
var $9Zals = parcelRequire("9Zals");
var $kubwK = parcelRequire("kubwK");
var $5Oi9Z = parcelRequire("5Oi9Z");

var $cZXNZ = parcelRequire("cZXNZ");

var $9SfKt = parcelRequire("9SfKt");

var $eGtYl = parcelRequire("eGtYl");
function $664781cb34daee7d$export$b04be29aa201d4f5(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $kubwK.Label), {
        ...props,
        className: (0, $cZXNZ.twMerge)('text-sm text-gray-500 dark:text-zinc-400 font-medium cursor-default w-fit', props.className)
    });
}
function $664781cb34daee7d$export$393edc798c47379d(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Oi9Z.Text), {
        ...props,
        slot: "description",
        className: (0, $cZXNZ.twMerge)('text-sm text-gray-600', props.className)
    });
}
function $664781cb34daee7d$export$f551688fc98f2e09(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5Oi9Z.Text), {
        ...props,
        slot: "errorMessage",
        className: 'text-sm text-red-600 forced-colors:text-[Mark]'
    });
}
const $664781cb34daee7d$export$ef43aab117e9ac1c = (0, $9SfKt.tv)({
    variants: {
        isFocusWithin: {
            false: 'border-gray-300 dark:border-zinc-500 forced-colors:border-[ButtonBorder]',
            true: 'border-gray-600 dark:border-zinc-300 forced-colors:border-[Highlight]'
        },
        isInvalid: {
            true: 'border-red-600 dark:border-red-600 forced-colors:border-[Mark]'
        },
        isDisabled: {
            true: 'border-gray-200 dark:border-zinc-700 forced-colors:border-[GrayText]'
        }
    }
});
const $664781cb34daee7d$export$9668428692f07fef = (0, $9SfKt.tv)({
    extend: (0, $eGtYl.focusRing),
    base: 'group flex items-center h-9 bg-white dark:bg-zinc-900 forced-colors:bg-[Field] border-2 rounded-lg overflow-hidden',
    variants: $664781cb34daee7d$export$ef43aab117e9ac1c.variants
});
function $664781cb34daee7d$export$f0fe469072bc6950(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lVuqN.Group), {
        ...props,
        className: (0, $dgWhj.composeRenderProps)(props.className, (className, renderProps)=>$664781cb34daee7d$export$9668428692f07fef({
                ...renderProps,
                className: className
            }))
    });
}
function $664781cb34daee7d$export$f5b8910cec6cf069(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9Zals.Input), {
        ...props,
        className: (0, $eGtYl.composeTailwindRenderProps)(props.className, 'px-2 py-1.5 flex-1 min-w-0 outline outline-0 bg-white dark:bg-zinc-900 text-sm text-gray-800 dark:text-zinc-200 disabled:text-gray-200 dark:disabled:text-zinc-600')
    });
}

});
parcelRegister("lVuqN", function(module, exports) {

$parcel$export(module.exports, "GroupContext", function () { return $6ce5d0952221217b$export$f9c6924e160136d1; });
$parcel$export(module.exports, "Group", function () { return $6ce5d0952221217b$export$eb2fcfdbd7ba97d4; });

var $dgWhj = parcelRequire("dgWhj");

var $hAxtE = parcelRequire("hAxtE");
var $5Gawp = parcelRequire("5Gawp");
var $i91F7 = parcelRequire("i91F7");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $6ce5d0952221217b$export$f9c6924e160136d1 = (0, $bh6RR.createContext)({});
function $6ce5d0952221217b$var$$a049562f99e7db0e$var$Group(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $6ce5d0952221217b$export$f9c6924e160136d1);
    let { isDisabled: isDisabled, isInvalid: isInvalid, onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, ...otherProps } = props;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)({
        onHoverStart: onHoverStart,
        onHoverChange: onHoverChange,
        onHoverEnd: onHoverEnd,
        isDisabled: isDisabled
    });
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $5Gawp.useFocusRing)({
        within: true
    });
    isDisabled !== null && isDisabled !== void 0 ? isDisabled : isDisabled = !!props['aria-disabled'] && props['aria-disabled'] !== 'false';
    isInvalid !== null && isInvalid !== void 0 ? isInvalid : isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        values: {
            isHovered: isHovered,
            isFocusWithin: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-Group'
    });
    var _props_role, _props_slot;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...(0, $hAxtE.mergeProps)(otherProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        role: (_props_role = props.role) !== null && _props_role !== void 0 ? _props_role : 'group',
        slot: (_props_slot = props.slot) !== null && _props_slot !== void 0 ? _props_slot : undefined,
        "data-focus-within": isFocused || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-invalid": isInvalid || undefined
    }, renderProps.children);
}
/**
 * A group represents a set of related UI controls, and supports interactive states for styling.
 */ const $6ce5d0952221217b$export$eb2fcfdbd7ba97d4 = (0, $bh6RR.forwardRef)($6ce5d0952221217b$var$$a049562f99e7db0e$var$Group);

});

parcelRegister("9Zals", function(module, exports) {

$parcel$export(module.exports, "InputContext", function () { return $4a18815a6c515dbe$export$37fb8590cf2c088c; });
$parcel$export(module.exports, "Input", function () { return $4a18815a6c515dbe$export$f5b8910cec6cf069; });

var $dgWhj = parcelRequire("dgWhj");

var $73EHL = parcelRequire("73EHL");

var $hAxtE = parcelRequire("hAxtE");
var $5Gawp = parcelRequire("5Gawp");
var $i91F7 = parcelRequire("i91F7");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $4a18815a6c515dbe$export$37fb8590cf2c088c = (0, $bh6RR.createContext)({});
let $4a18815a6c515dbe$var$$3985021b0ad6602f$var$filterHoverProps = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, ...otherProps } = props;
    return otherProps;
};
function $4a18815a6c515dbe$var$$3985021b0ad6602f$var$Input(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $4a18815a6c515dbe$export$37fb8590cf2c088c);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)(props);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $5Gawp.useFocusRing)({
        isTextInput: true,
        autoFocus: props.autoFocus
    });
    let isInvalid = !!props['aria-invalid'] && props['aria-invalid'] !== 'false';
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        values: {
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: props.disabled || false,
            isInvalid: isInvalid
        },
        defaultClassName: 'react-aria-Input'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("input", {
        ...(0, $hAxtE.mergeProps)($4a18815a6c515dbe$var$$3985021b0ad6602f$var$filterHoverProps(props), focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-disabled": props.disabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-invalid": isInvalid || undefined
    });
}
/**
 * An input allows a user to input text.
 */ const $4a18815a6c515dbe$export$f5b8910cec6cf069 = (0, $73EHL.createHideableComponent)($4a18815a6c515dbe$var$$3985021b0ad6602f$var$Input);

});



parcelRegister("eoNPv", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $efec03ce2044ad98$export$353f5b6fc5456de1; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $9cr7a = parcelRequire("9cr7a");
var $dgWhj = parcelRequire("dgWhj");

var $9SfKt = parcelRequire("9SfKt");

var $eGtYl = parcelRequire("eGtYl");
let $efec03ce2044ad98$var$button = (0, $9SfKt.tv)({
    extend: (0, $eGtYl.focusRing),
    base: 'px-5 py-2 text-sm text-center transition rounded-lg border border-black/10 dark:border-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)] dark:shadow-none cursor-default',
    variants: {
        variant: {
            primary: 'bg-blue-600 hover:bg-blue-700 pressed:bg-blue-800 text-white',
            secondary: 'bg-gray-100 hover:bg-gray-200 pressed:bg-gray-300 text-gray-800 dark:bg-zinc-600 dark:hover:bg-zinc-500 dark:pressed:bg-zinc-400 dark:text-zinc-100',
            destructive: 'bg-red-700 hover:bg-red-800 pressed:bg-red-900 text-white',
            icon: 'border-0 p-1 flex items-center justify-center text-gray-600 hover:bg-black/[5%] pressed:bg-black/10 dark:text-zinc-400 dark:hover:bg-white/10 dark:pressed:bg-white/20 disabled:bg-transparent'
        },
        isDisabled: {
            true: 'bg-gray-100 dark:bg-zinc-800 text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText] border-black/5 dark:border-white/5'
        }
    },
    defaultVariants: {
        variant: 'primary'
    }
});
function $efec03ce2044ad98$export$353f5b6fc5456de1(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $9cr7a.Button), {
        ...props,
        className: (0, $dgWhj.composeRenderProps)(props.className, (className, renderProps)=>$efec03ce2044ad98$var$button({
                ...renderProps,
                variant: props.variant,
                className: className
            }))
    });
}

});

parcelRegister("1y9Ig", function(module, exports) {

$parcel$export(module.exports, "TransactionCards", function () { return $bd5545a0273a678b$export$67bed54a748b756d; });

var $ih19M = parcelRequire("ih19M");

var $7c0yZ = parcelRequire("7c0yZ");
var $5hQd5 = parcelRequire("5hQd5");
parcelRequire("bh6RR");

var $lVuqN = parcelRequire("lVuqN");

var $9SfKt = parcelRequire("9SfKt");

var $6QYcK = parcelRequire("6QYcK");

var $7BL3D = parcelRequire("7BL3D");

var $iSHzH = parcelRequire("iSHzH");

var $eoNPv = parcelRequire("eoNPv");

var $cclg0 = parcelRequire("cclg0");
const $bd5545a0273a678b$export$67bed54a748b756d = ({ navigate: navigate, dispatch: dispatch, transactions: transactions, transactionFilter: transactionFilter })=>{
    const transactionsFiltered = transactions.filter((transaction)=>transactionFilter === 'all' || transactionFilter.has(transaction.type));
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "grid grid-cols-1 gap-4 lg:grid-cols-3",
        children: transactionsFiltered.map((transaction)=>/*#__PURE__*/ (0, $ih19M.jsx)($bd5545a0273a678b$var$TransactionCard, {
                transaction: transaction,
                navigate: navigate,
                dispatch: dispatch
            }, transaction.id))
    });
};
const $bd5545a0273a678b$var$transactionTagCategory = (0, $9SfKt.tv)({
    base: 'inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset',
    variants: {
        type: {
            income: 'bg-green-50 text-green-700 ring-green-600',
            transfer: 'bg-purple-50 text-purple-700 ring-purple-600',
            expense: 'bg-red-50 text-red-700 ring-red-600'
        }
    }
});
const $bd5545a0273a678b$var$TransactionCard = ({ transaction: transaction, navigate: navigate, dispatch: dispatch })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "lg:col-start-3 lg:row-end-1",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                    className: "sr-only",
                    children: "Transaction"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "rounded-lg bg-gray-50 shadow-sm ring-1 ring-gray-900/5",
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "flex-auto pl-6 pt-3",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("dt", {
                                        className: "text-sm/6 font-semibold text-gray-900",
                                        children: transaction.raccount
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("dd", {
                                        className: "mt-1 text-base font-semibold text-gray-900",
                                        children: transaction.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "flex-none self-end justify-items-end px-6 pt-4",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: "text-sm/6 font-medium text-gray-500",
                                        children: transaction.type
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: $bd5545a0273a678b$var$transactionTagCategory({
                                            type: transaction.type
                                        }),
                                        children: transaction.category
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("dl", {
                                className: "my-2 flex flex-wrap px-6",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("dt", {
                                        className: "sr-only",
                                        children: "Frequency Of Transaction"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("dd", {
                                        className: "flex-none w-full",
                                        children: (0, $iSHzH.toHumanReoccurrence)(transaction)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("dd", {
                                        className: "text-sm/6 font-medium text-gray-500",
                                        children: (0, $iSHzH.nextOccurrence)(transaction)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "my-2 flex w-full flex-none justify-between px-6",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("dl", {
                                        className: "flex flex-wrap items-baseline justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("dt", {
                                                className: "sr-only",
                                                children: "Amount With Daily Rate"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("dd", {
                                                className: "text-sm/6 font-medium text-gray-500",
                                                children: [
                                                    (0, $7BL3D.toHumanCurrency)(transaction.dailyRate),
                                                    " per day"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("dd", {
                                                className: "w-full flex-none text-3xl/10 font-medium tracking-tight text-gray-900",
                                                children: (0, $7BL3D.toHumanCurrency)(transaction.value)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $lVuqN.Group), {
                                        "aria-label": "Actions",
                                        className: "space-x-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eoNPv.Button), {
                                                "aria-label": "Modify",
                                                className: "px-0.5",
                                                onPress: ()=>navigate('/transactions/set', (0, $cclg0.navigateToTransactionForm)(transaction)),
                                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7c0yZ.default), {
                                                    className: "max-h-3"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eoNPv.Button), {
                                                "aria-label": "Delete",
                                                className: "px-0.5",
                                                onPress: ()=>dispatch((0, $6QYcK.transactionRemove)({
                                                        id: transaction.id
                                                    })),
                                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5hQd5.default), {
                                                    className: "max-h-3"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});
parcelRegister("7c0yZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53ca174292e944d8$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $53ca174292e944d8$export$2e2bcd8739ae039 = (0, $iUesJ.default)("Pencil", [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
]);

});

parcelRegister("5hQd5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d970a20ef675e1f$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $3d970a20ef675e1f$export$2e2bcd8739ae039 = (0, $iUesJ.default)("Trash2", [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17",
            key: "1uufr5"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17",
            key: "xtxkd"
        }
    ]
]);

});

parcelRegister("6QYcK", function(module, exports) {

$parcel$export(module.exports, "transactionAdd", function () { return $84309da4889eaea2$export$6a371b65f0daac25; });
$parcel$export(module.exports, "transactionRemove", function () { return $84309da4889eaea2$export$6c83419d1556aa73; });

var $k0Sb0 = parcelRequire("k0Sb0");

var $qqvI6 = parcelRequire("qqvI6");

var $7BL3D = parcelRequire("7BL3D");

var $jUfjK = parcelRequire("jUfjK");

var $5EWGz = parcelRequire("5EWGz");

var $7uN6s = parcelRequire("7uN6s");
const $84309da4889eaea2$export$6a371b65f0daac25 = (0, $5EWGz.thunks).create('transaction:add', function*(ctx, next) {
    const transaction = {
        ...ctx.payload
    };
    if (!transaction?.id) transaction.id = (0, $jUfjK.default)();
    if (typeof transaction.start === 'object') transaction.start = (0, $k0Sb0.default)(transaction.start, 'yyyy-MM-dd');
    transaction.value = (0, $7BL3D.redinero)(transaction.value);
    transaction.cycle = ctx.payload?.cycle ?? 0;
    transaction.occurrences = ctx.payload?.occurrences ?? 0;
    transaction.dailyRate = (0, $7uN6s.transactionCompute)({
        transaction: transaction
    });
    yield* (0, $qqvI6.schema).update((0, $qqvI6.schema).transactions.add({
        [transaction.id]: transaction
    }));
    yield* next();
});
const $84309da4889eaea2$export$6c83419d1556aa73 = (0, $5EWGz.thunks).create('transaction:remove', function*(ctx, next) {
    yield* (0, $qqvI6.schema).update((0, $qqvI6.schema).transactions.remove([
        ctx.payload.id
    ]));
    yield* next();
});

});
parcelRegister("jUfjK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43dbf7527f908e31$export$2e2bcd8739ae039; });
let $43dbf7527f908e31$var$hex = [];
for(let i = 0; i < 256; i++)$43dbf7527f908e31$var$hex[i] = (i < 16 ? '0' : '') + i.toString(16);
function $43dbf7527f908e31$export$2e2bcd8739ae039() {
    let r = crypto.getRandomValues(new Uint8Array(16));
    r[6] = r[6] & 0x0f | 0x40;
    r[8] = r[8] & 0x3f | 0x80;
    return $43dbf7527f908e31$var$hex[r[0]] + $43dbf7527f908e31$var$hex[r[1]] + $43dbf7527f908e31$var$hex[r[2]] + $43dbf7527f908e31$var$hex[r[3]] + '-' + $43dbf7527f908e31$var$hex[r[4]] + $43dbf7527f908e31$var$hex[r[5]] + '-' + $43dbf7527f908e31$var$hex[r[6]] + $43dbf7527f908e31$var$hex[r[7]] + '-' + $43dbf7527f908e31$var$hex[r[8]] + $43dbf7527f908e31$var$hex[r[9]] + '-' + $43dbf7527f908e31$var$hex[r[10]] + $43dbf7527f908e31$var$hex[r[11]] + $43dbf7527f908e31$var$hex[r[12]] + $43dbf7527f908e31$var$hex[r[13]] + $43dbf7527f908e31$var$hex[r[14]] + $43dbf7527f908e31$var$hex[r[15]];
}

});

parcelRegister("5EWGz", function(module, exports) {

$parcel$export(module.exports, "thunks", function () { return $bc41b81ceda7acbd$export$eb2332b8a94a914a; });
parcelRequire("9St7S");
var $eGylm = parcelRequire("eGylm");
var $aye7b = parcelRequire("aye7b");
const $bc41b81ceda7acbd$export$eb2332b8a94a914a = (0, $eGylm.createThunks)();
// catch errors from task and logs them with extra info
$bc41b81ceda7acbd$export$eb2332b8a94a914a.use((0, $aye7b.mdw).err);
// where all the thunks get called in the middleware stack
$bc41b81ceda7acbd$export$eb2332b8a94a914a.use($bc41b81ceda7acbd$export$eb2332b8a94a914a.routes());

});


parcelRegister("iSHzH", function(module, exports) {

$parcel$export(module.exports, "toHumanReoccurrence", function () { return $5495bca8d02e10e4$export$ca13f28d48cc407f; });
$parcel$export(module.exports, "nextOccurrence", function () { return $5495bca8d02e10e4$export$e3f65e7079e87b1a; });
const $5495bca8d02e10e4$export$ca13f28d48cc407f = (transaction)=>{
    switch(transaction.rtype){
        case 'none':
            return `On ${transaction.start}`;
        case 'day':
            return `Every ${transaction.cycle === 1 ? 'day' : `${transaction.cycle} days`}`;
        case 'day of week':
            return `Every day ${transaction.cycle}`;
        case 'day of month':
            return `On day ${transaction.cycle} of the month`;
        case 'bimonthly':
            return `On day ${transaction.cycle} of every other month`;
        case 'quarterly':
            return `on day ${transaction.cycle} of the quarter`;
        case 'semiannually':
            return `Every year on day ${transaction.cycle} and 6 months afterwards`;
        case 'annually':
            return `Every ${transaction.cycle === 1 ? 'year' : `${transaction.cycle} years`}`;
        default:
            return '';
    }
};
const $5495bca8d02e10e4$export$e3f65e7079e87b1a = (transaction)=>{
    return `Next on ${transaction.seedDate.toLocaleDateString()}`;
};

});

parcelRegister("cclg0", function(module, exports) {

$parcel$export(module.exports, "navigateToTransactionForm", function () { return $09c1ca61ef5977c4$export$3d175fd1541a114c; });

var $2U14E = parcelRequire("2U14E");
const $09c1ca61ef5977c4$export$3d175fd1541a114c = (transaction)=>{
    return {
        state: {
            navigateTo: location.pathname,
            transaction: {
                id: transaction.id,
                raccount: transaction.raccountMeta.id,
                transferIn: transaction.transferInMeta?.id,
                description: transaction.description,
                category: transaction.category,
                type: transaction.type,
                start: transaction.start.toString(),
                ending: transaction.ending?.toString() ?? 'never',
                rtype: transaction.rtype,
                beginAfterOccurrences: transaction.beginAfterOccurrences ?? 0,
                cycle: transaction.cycle,
                value: parseFloat((0, $2U14E.toDecimal)(transaction.value)),
                valueType: transaction.valueType ?? 'static'
            }
        }
    };
};

});


parcelRegister("em0X4", function(module, exports) {

$parcel$export(module.exports, "TransactionTable", function () { return $0b3325fbbbcde51a$export$c3aee9fd7b24beba; });

var $ih19M = parcelRequire("ih19M");

var $7c0yZ = parcelRequire("7c0yZ");
var $5hQd5 = parcelRequire("5hQd5");

var $bh6RR = parcelRequire("bh6RR");

var $lVuqN = parcelRequire("lVuqN");

var $6QYcK = parcelRequire("6QYcK");

var $7BL3D = parcelRequire("7BL3D");

var $iSHzH = parcelRequire("iSHzH");

var $aprdT = parcelRequire("aprdT");
var $d3IV0 = parcelRequire("d3IV0");

var $eoNPv = parcelRequire("eoNPv");

var $cclg0 = parcelRequire("cclg0");
const $0b3325fbbbcde51a$export$c3aee9fd7b24beba = ({ label: label, transactions: transactions, transactionFilter: transactionFilter, navigate: navigate, dispatch: dispatch })=>{
    const transactionsFiltered = transactions.filter((transaction)=>transactionFilter === 'all' || transactionFilter.has(transaction.type));
    const [sortable, setSetSortable] = (0, $bh6RR.useState)({
        column: 'type',
        direction: 'descending'
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $aprdT.Table), {
        "aria-label": label,
        selectionMode: "none",
        onSortChange: (item)=>setSetSortable(item),
        sortDescriptor: sortable,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $aprdT.TableHeader), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $aprdT.Column), {
                        id: "raccount",
                        defaultWidth: "4fr",
                        isRowHeader: true,
                        allowsSorting: true,
                        children: "Account"
                    }),
                    [
                        [
                            'Description',
                            '4fr'
                        ],
                        [
                            'Category',
                            '2fr'
                        ],
                        [
                            'Type',
                            '3fr'
                        ],
                        [
                            'Frequency',
                            '4fr'
                        ],
                        [
                            'Value',
                            '2fr'
                        ],
                        [
                            'Daily Rate',
                            '1fr'
                        ],
                        [
                            'Actions',
                            '2fr'
                        ]
                    ].map((h)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $aprdT.Column), {
                            id: h[0],
                            defaultWidth: h[1],
                            allowsSorting: true,
                            children: h[0]
                        }, h[0]))
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $d3IV0.TableBody), {
                renderEmptyState: ()=>'No transactions.',
                children: transactionsFiltered.sort((0, $aprdT.singleSort)(sortable)).map((transaction)=>/*#__PURE__*/ (0, $ih19M.jsx)($0b3325fbbbcde51a$var$TransactionRow, {
                        transaction: transaction,
                        navigate: navigate,
                        dispatch: dispatch
                    }, transaction.id))
            })
        ]
    });
};
const $0b3325fbbbcde51a$var$TransactionRow = ({ transaction: transaction, navigate: navigate, dispatch: dispatch })=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $aprdT.Row), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aprdT.Cell), {
                children: transaction.raccount
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aprdT.Cell), {
                children: transaction.description
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aprdT.Cell), {
                children: transaction.category
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $aprdT.Cell), {
                children: [
                    transaction.type,
                    transaction.transferIn ? `${transaction.type === 'expense' ? ' paid' : ''} to ${transaction.transferIn}` : ``
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aprdT.Cell), {
                children: (0, $iSHzH.toHumanReoccurrence)(transaction)
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aprdT.Cell), {
                children: (0, $7BL3D.toHumanCurrency)(transaction.value)
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aprdT.Cell), {
                children: (0, $7BL3D.toHumanCurrency)(transaction.dailyRate)
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $aprdT.Cell), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $lVuqN.Group), {
                    "aria-label": "Actions",
                    className: "space-x-1",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eoNPv.Button), {
                            "aria-label": "Modify",
                            className: "px-0.5",
                            onPress: ()=>navigate('/transactions/set', (0, $cclg0.navigateToTransactionForm)(transaction)),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7c0yZ.default), {
                                className: "max-h-3"
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $eoNPv.Button), {
                            "aria-label": "Delete",
                            className: "px-0.5",
                            onPress: ()=>dispatch((0, $6QYcK.transactionRemove)({
                                    id: transaction.id
                                })),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5hQd5.default), {
                                className: "max-h-3"
                            })
                        })
                    ]
                })
            })
        ]
    });

});
parcelRegister("aprdT", function(module, exports) {

$parcel$export(module.exports, "Table", function () { return $e00722b2d6de7afd$export$54ec01a60f47d33d; });
$parcel$export(module.exports, "Column", function () { return $e00722b2d6de7afd$export$816b5d811295e6bc; });
$parcel$export(module.exports, "TableHeader", function () { return $e00722b2d6de7afd$export$f850895b287ef28e; });
$parcel$export(module.exports, "Row", function () { return $e00722b2d6de7afd$export$b59bdbef9ce70de2; });
$parcel$export(module.exports, "Cell", function () { return $e00722b2d6de7afd$export$f6f0c3fe4ec306ea; });
$parcel$export(module.exports, "singleSort", function () { return $e00722b2d6de7afd$export$368fa205f8f4f518; });
$parcel$export(module.exports, "TableBody", function () { return (parcelRequire("d3IV0")).TableBody; });

var $ih19M = parcelRequire("ih19M");

var $dOYfv = parcelRequire("dOYfv");
parcelRequire("bh6RR");

var $9cr7a = parcelRequire("9cr7a");
var $d3IV0 = parcelRequire("d3IV0");
var $eqvPU = parcelRequire("eqvPU");
var $dgWhj = parcelRequire("dgWhj");
var $lVuqN = parcelRequire("lVuqN");

var $9SfKt = parcelRequire("9SfKt");

var $4tN5V = parcelRequire("4tN5V");

var $eGtYl = parcelRequire("eGtYl");
function $e00722b2d6de7afd$export$54ec01a60f47d33d(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d3IV0.ResizableTableContainer), {
        className: "overflow-auto scroll-pt-[2.281rem] relative border dark:border-zinc-600 rounded-lg",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $d3IV0.Table), {
            ...props,
            className: "border-separate border-spacing-0"
        })
    });
}
const $e00722b2d6de7afd$var$columnStyles = (0, $9SfKt.tv)({
    extend: (0, $eGtYl.focusRing),
    base: 'px-2 h-5 flex-1 flex gap-1 items-center overflow-hidden'
});
const $e00722b2d6de7afd$var$resizerStyles = (0, $9SfKt.tv)({
    extend: (0, $eGtYl.focusRing),
    base: 'w-px px-[8px] translate-x-[8px] box-content py-1 h-5 bg-clip-content bg-gray-400 dark:bg-zinc-500 forced-colors:bg-[ButtonBorder] cursor-col-resize rounded resizing:bg-blue-600 forced-colors:resizing:bg-[Highlight] resizing:w-[2px] resizing:pl-[7px] -outline-offset-2'
});
function $e00722b2d6de7afd$export$816b5d811295e6bc(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d3IV0.Column), {
        ...props,
        className: (0, $eGtYl.composeTailwindRenderProps)(props.className, '[&:hover]:z-20 [&:focus-within]:z-20 text-start text-sm font-semibold text-gray-700 dark:text-zinc-300 cursor-default'),
        children: (0, $dgWhj.composeRenderProps)(props.children, (children, { allowsSorting: allowsSorting, sortDirection: sortDirection })=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $lVuqN.Group), {
                        role: "presentation",
                        tabIndex: -1,
                        className: $e00722b2d6de7afd$var$columnStyles,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "truncate",
                                children: children
                            }),
                            allowsSorting && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: `w-4 h-4 flex items-center justify-center transition ${sortDirection === 'descending' ? 'rotate-180' : ''}`,
                                children: sortDirection && /*#__PURE__*/ (0, $ih19M.jsx)((0, $dOYfv.default), {
                                    "aria-hidden": true,
                                    className: "w-4 h-4 text-gray-500 dark:text-zinc-400 forced-colors:text-[ButtonText]"
                                })
                            })
                        ]
                    }),
                    !props.width && /*#__PURE__*/ (0, $ih19M.jsx)((0, $d3IV0.ColumnResizer), {
                        className: $e00722b2d6de7afd$var$resizerStyles
                    })
                ]
            }))
    });
}
function $e00722b2d6de7afd$export$f850895b287ef28e(props) {
    let { selectionBehavior: selectionBehavior, selectionMode: selectionMode, allowsDragging: allowsDragging } = (0, $d3IV0.useTableOptions)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $d3IV0.TableHeader), {
        ...props,
        className: (0, $eGtYl.composeTailwindRenderProps)(props.className, 'sticky top-0 z-10 bg-gray-100/60 dark:bg-zinc-700/60 backdrop-blur-md supports-[-moz-appearance:none]:bg-gray-100 dark:supports-[-moz-appearance:none]:bg-zinc-700 forced-colors:bg-[Canvas] rounded-t-lg border-b dark:border-b-zinc-700'),
        children: [
            allowsDragging && /*#__PURE__*/ (0, $ih19M.jsx)($e00722b2d6de7afd$export$816b5d811295e6bc, {}),
            selectionBehavior === 'toggle' && /*#__PURE__*/ (0, $ih19M.jsx)((0, $d3IV0.Column), {
                width: 36,
                minWidth: 36,
                className: "text-start text-sm font-semibold cursor-default p-2",
                children: selectionMode === 'multiple' && /*#__PURE__*/ (0, $ih19M.jsx)((0, $4tN5V.Checkbox), {
                    slot: "selection"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eqvPU.Collection), {
                items: props.columns,
                children: props.children
            })
        ]
    });
}
const $e00722b2d6de7afd$var$rowStyles = (0, $9SfKt.tv)({
    extend: (0, $eGtYl.focusRing),
    base: 'group/row relative cursor-default select-none -outline-offset-2 text-gray-900 disabled:text-gray-300 dark:text-zinc-200 dark:disabled:text-zinc-600 text-sm hover:bg-gray-100 dark:hover:bg-zinc-700/60 selected:bg-blue-100 selected:hover:bg-blue-200 dark:selected:bg-blue-700/30 dark:selected:hover:bg-blue-700/40'
});
function $e00722b2d6de7afd$export$b59bdbef9ce70de2({ id: id, columns: columns, children: children, ...otherProps }) {
    let { selectionBehavior: selectionBehavior, allowsDragging: allowsDragging } = (0, $d3IV0.useTableOptions)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $d3IV0.Row), {
        id: id,
        ...otherProps,
        className: $e00722b2d6de7afd$var$rowStyles,
        children: [
            allowsDragging && /*#__PURE__*/ (0, $ih19M.jsx)($e00722b2d6de7afd$export$f6f0c3fe4ec306ea, {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $9cr7a.Button), {
                    slot: "drag",
                    children: "\u2261"
                })
            }),
            selectionBehavior === 'toggle' && /*#__PURE__*/ (0, $ih19M.jsx)($e00722b2d6de7afd$export$f6f0c3fe4ec306ea, {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $4tN5V.Checkbox), {
                    slot: "selection"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $eqvPU.Collection), {
                items: columns,
                children: children
            })
        ]
    });
}
const $e00722b2d6de7afd$var$cellStyles = (0, $9SfKt.tv)({
    extend: (0, $eGtYl.focusRing),
    base: 'border-b dark:border-b-zinc-700 group-last/row:border-b-0 [--selected-border:theme(colors.blue.200)] dark:[--selected-border:theme(colors.blue.900)] group-selected/row:border-[--selected-border] [:has(+[data-selected])_&]:border-[--selected-border] p-2 truncate -outline-offset-2'
});
function $e00722b2d6de7afd$export$f6f0c3fe4ec306ea(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d3IV0.Cell), {
        ...props,
        className: $e00722b2d6de7afd$var$cellStyles
    });
}
const $e00722b2d6de7afd$export$368fa205f8f4f518 = (sortable)=>function(a, b) {
        if (a[sortable.column.toLowerCase()] < b[sortable.column.toLowerCase()]) return sortable.direction === 'ascending' ? 1 : -1;
        if (a[sortable.column.toLowerCase()] > b[sortable.column.toLowerCase()]) return sortable.direction === 'ascending' ? -1 : 1;
        return 0;
    };

});
parcelRegister("dOYfv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0feae19a84d62df$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $a0feae19a84d62df$export$2e2bcd8739ae039 = (0, $iUesJ.default)("ArrowUp", [
    [
        "path",
        {
            d: "m5 12 7-7 7 7",
            key: "hav0vg"
        }
    ],
    [
        "path",
        {
            d: "M12 19V5",
            key: "x0mq9r"
        }
    ]
]);

});

parcelRegister("d3IV0", function(module, exports) {

$parcel$export(module.exports, "ResizableTableContainer", function () { return $da6e171bcb60f7fd$export$7063e69b8a954175; });
$parcel$export(module.exports, "Table", function () { return $da6e171bcb60f7fd$export$54ec01a60f47d33d; });
$parcel$export(module.exports, "useTableOptions", function () { return $da6e171bcb60f7fd$export$fddc468cd8cb4db9; });
$parcel$export(module.exports, "TableHeader", function () { return $da6e171bcb60f7fd$export$f850895b287ef28e; });
$parcel$export(module.exports, "Column", function () { return $da6e171bcb60f7fd$export$816b5d811295e6bc; });
$parcel$export(module.exports, "ColumnResizer", function () { return $da6e171bcb60f7fd$export$ee689e97a7664bfd; });
$parcel$export(module.exports, "TableBody", function () { return $da6e171bcb60f7fd$export$76ccd210b9029917; });
$parcel$export(module.exports, "Row", function () { return $da6e171bcb60f7fd$export$b59bdbef9ce70de2; });
$parcel$export(module.exports, "Cell", function () { return $da6e171bcb60f7fd$export$f6f0c3fe4ec306ea; });

var $9cr7a = parcelRequire("9cr7a");

var $hzBE3 = parcelRequire("hzBE3");

var $juOz0 = parcelRequire("juOz0");

var $dgWhj = parcelRequire("dgWhj");

var $4HVSY = parcelRequire("4HVSY");

var $cxt9V = parcelRequire("cxt9V");

var $1dNHT = parcelRequire("1dNHT");
var $eqvPU = parcelRequire("eqvPU");
var $72X2K = parcelRequire("72X2K");

var $dcsQ5 = parcelRequire("dcsQ5");

var $8K87f = parcelRequire("8K87f");
var $2oxz8 = parcelRequire("2oxz8");
var $kyRRA = parcelRequire("kyRRA");

var $2NhrA = parcelRequire("2NhrA");
var $36LQn = parcelRequire("36LQn");
var $hAxtE = parcelRequire("hAxtE");
var $5Gawp = parcelRequire("5Gawp");
var $i91F7 = parcelRequire("i91F7");
var $c8uzR = parcelRequire("c8uzR");
var $kbHlJ = parcelRequire("kbHlJ");
var $lGes6 = parcelRequire("lGes6");
var $4SWU2 = parcelRequire("4SWU2");
var $1UUYg = parcelRequire("1UUYg");
var $dcGdN = parcelRequire("dcGdN");
var $2QDeI = parcelRequire("2QDeI");
var $jVvar = parcelRequire("jVvar");
var $fKc9O = parcelRequire("fKc9O");
var $dQD2e = parcelRequire("dQD2e");
var $lhOYy = parcelRequire("lhOYy");

var $bG0JH = parcelRequire("bG0JH");
var $2w5A8 = parcelRequire("2w5A8");
var $AizmU = parcelRequire("AizmU");
var $f2PTm = parcelRequire("f2PTm");
var $jyDr8 = parcelRequire("jyDr8");
var $7KwSx = parcelRequire("7KwSx");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");
function $da6e171bcb60f7fd$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
class $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableCollection extends (0, $1dNHT.BaseCollection) {
    addNode(node) {
        super.addNode(node);
        this.columnsDirty || (this.columnsDirty = node.type === 'column');
        if (node.type === 'tableheader') this.head = node;
        if (node.type === 'tablebody') this.body = node;
    }
    commit(firstKey, lastKey, isSSR = false) {
        this.updateColumns(isSSR);
        super.commit(firstKey, lastKey, isSSR);
        this.rows = [
            ...this.getChildren(this.body.key)
        ];
    }
    updateColumns(isSSR) {
        if (!this.columnsDirty) return;
        this.rowHeaderColumnKeys = new Set();
        this.columns = [];
        let columnKeyMap = new Map();
        let visit = (node)=>{
            switch(node.type){
                case 'column':
                    columnKeyMap.set(node.key, node);
                    if (!node.hasChildNodes) {
                        node.index = this.columns.length;
                        this.columns.push(node);
                        if (node.props.isRowHeader) this.rowHeaderColumnKeys.add(node.key);
                    }
                    break;
            }
            for (let child of this.getChildren(node.key))visit(child);
        };
        for (let node of this.getChildren(this.head.key))visit(node);
        this.headerRows = (0, $dcsQ5.buildHeaderRows)(columnKeyMap, this.columns);
        this.columnsDirty = false;
        if (this.rowHeaderColumnKeys.size === 0 && this.columns.length > 0 && !isSSR) throw new Error('A table must have at least one Column with the isRowHeader prop set to true');
    }
    get columnCount() {
        return this.columns.length;
    }
    *[Symbol.iterator]() {
        // Wait until the collection is initialized.
        if (this.head.key === -1) return;
        yield this.head;
        yield this.body;
    }
    get size() {
        return this.rows.length;
    }
    getFirstKey() {
        return this.body.firstChildKey;
    }
    getLastKey() {
        return this.body.lastChildKey;
    }
    getKeyAfter(key) {
        let node = this.getItem(key);
        var _node_nextKey;
        if ((node === null || node === void 0 ? void 0 : node.type) === 'column') return (_node_nextKey = node.nextKey) !== null && _node_nextKey !== void 0 ? _node_nextKey : null;
        return super.getKeyAfter(key);
    }
    getKeyBefore(key) {
        var _this_getItem;
        let node = this.getItem(key);
        var _node_prevKey;
        if ((node === null || node === void 0 ? void 0 : node.type) === 'column') return (_node_prevKey = node.prevKey) !== null && _node_prevKey !== void 0 ? _node_prevKey : null;
        let k = super.getKeyBefore(key);
        if (k != null && ((_this_getItem = this.getItem(k)) === null || _this_getItem === void 0 ? void 0 : _this_getItem.type) === 'tablebody') return null;
        return k;
    }
    getChildren(key) {
        if (!this.getItem(key)) for (let row of this.headerRows){
            if (row.key === key) return row.childNodes;
        }
        return super.getChildren(key);
    }
    clone() {
        let collection = super.clone();
        collection.headerRows = this.headerRows;
        collection.columns = this.columns;
        collection.rowHeaderColumnKeys = this.rowHeaderColumnKeys;
        collection.head = this.head;
        collection.body = this.body;
        return collection;
    }
    getTextValue(key) {
        let row = this.getItem(key);
        if (!row) return '';
        // If the row has a textValue, use that.
        if (row.textValue) return row.textValue;
        // Otherwise combine the text of each of the row header columns.
        let rowHeaderColumnKeys = this.rowHeaderColumnKeys;
        let text = [];
        for (let cell of this.getChildren(key)){
            let column = this.columns[cell.index];
            if (rowHeaderColumnKeys.has(column.key) && cell.textValue) text.push(cell.textValue);
            if (text.length === rowHeaderColumnKeys.size) break;
        }
        return text.join(' ');
    }
    constructor(...args){
        super(...args), this.headerRows = [], this.columns = [], this.rows = [], this.rowHeaderColumnKeys = new Set(), this.head = new (0, $1dNHT.CollectionNode)('tableheader', -1), this.body = new (0, $1dNHT.CollectionNode)('tablebody', -2), this.columnsDirty = true;
    }
}
const $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$ResizableTableContainerContext = (0, $bh6RR.createContext)(null);
function $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$ResizableTableContainer(props, ref) {
    let containerRef = (0, $jyDr8.useObjectRef)(ref);
    let tableRef = (0, $bh6RR.useRef)(null);
    let scrollRef = (0, $bh6RR.useRef)(null);
    let [width, setWidth] = (0, $bh6RR.useState)(0);
    (0, $f2PTm.useLayoutEffect)(()=>{
        // Walk up the DOM from the Table to the ResizableTableContainer and stop
        // when we reach the first scrollable element. This is what we'll measure
        // to determine column widths (important due to width of scrollbars).
        // This will usually be the ResizableTableContainer for native tables, and
        // the Table itself for virtualized tables.
        let table = tableRef.current;
        while(table && table !== containerRef.current && !(0, $2w5A8.isScrollable)(table))table = table.parentElement;
        scrollRef.current = table;
    }, [
        containerRef
    ]);
    (0, $7KwSx.useResizeObserver)({
        ref: scrollRef,
        box: 'border-box',
        onResize () {
            var _scrollRef_current;
            var _scrollRef_current_clientWidth;
            setWidth((_scrollRef_current_clientWidth = (_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.clientWidth) !== null && _scrollRef_current_clientWidth !== void 0 ? _scrollRef_current_clientWidth : 0);
        }
    });
    (0, $f2PTm.useLayoutEffect)(()=>{
        var _scrollRef_current;
        var _scrollRef_current_clientWidth;
        setWidth((_scrollRef_current_clientWidth = (_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.clientWidth) !== null && _scrollRef_current_clientWidth !== void 0 ? _scrollRef_current_clientWidth : 0);
    }, []);
    let ctx = (0, $bh6RR.useMemo)(()=>({
            tableRef: tableRef,
            scrollRef: scrollRef,
            tableWidth: width,
            useTableColumnResizeState: (0, $2oxz8.useTableColumnResizeState),
            onResizeStart: props.onResizeStart,
            onResize: props.onResize,
            onResizeEnd: props.onResizeEnd
        }), [
        tableRef,
        width,
        props.onResizeStart,
        props.onResize,
        props.onResizeEnd
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...(0, $bG0JH.filterDOMProps)(props),
        ref: containerRef,
        className: props.className || 'react-aria-ResizableTableContainer',
        style: props.style,
        onScroll: props.onScroll
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$ResizableTableContainerContext.Provider, {
        value: ctx
    }, props.children));
}
const $da6e171bcb60f7fd$export$7063e69b8a954175 = (0, $bh6RR.forwardRef)($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$ResizableTableContainer);
const $da6e171bcb60f7fd$export$93e4b0b2cc49b648 = (0, $bh6RR.createContext)(null);
const $da6e171bcb60f7fd$export$38de1cb0526c21fb = (0, $bh6RR.createContext)(null);
const $da6e171bcb60f7fd$export$a2680a798823803c = (0, $bh6RR.createContext)(null);
function $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$Table(props, ref) {
    var _props_dragAndDropHooks;
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $da6e171bcb60f7fd$export$93e4b0b2cc49b648);
    // Separate selection state so we have access to it from collection components via useTableOptions.
    let selectionState = (0, $8K87f.useMultipleSelectionState)(props);
    let { selectionBehavior: selectionBehavior, selectionMode: selectionMode, disallowEmptySelection: disallowEmptySelection } = selectionState;
    let hasDragHooks = !!((_props_dragAndDropHooks = props.dragAndDropHooks) === null || _props_dragAndDropHooks === void 0 ? void 0 : _props_dragAndDropHooks.useDraggableCollectionState);
    let ctx = (0, $bh6RR.useMemo)(()=>({
            selectionBehavior: selectionMode === 'none' ? null : selectionBehavior,
            selectionMode: selectionMode,
            disallowEmptySelection: disallowEmptySelection,
            allowsDragging: hasDragHooks
        }), [
        selectionBehavior,
        selectionMode,
        disallowEmptySelection,
        hasDragHooks
    ]);
    let content = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableOptionsContext.Provider, {
        value: ctx
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eqvPU.Collection), props));
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eqvPU.CollectionBuilder), {
        content: content,
        createCollection: ()=>new $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableCollection()
    }, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableInner, {
            props: props,
            forwardedRef: ref,
            selectionState: selectionState,
            collection: collection
        }));
}
function $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableInner({ props: props, forwardedRef: ref, selectionState: selectionState, collection: collection }) {
    let tableContainerContext = (0, $bh6RR.useContext)($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$ResizableTableContainerContext);
    ref = (0, $jyDr8.useObjectRef)((0, $bh6RR.useMemo)(()=>(0, $AizmU.mergeRefs)(ref, tableContainerContext === null || tableContainerContext === void 0 ? void 0 : tableContainerContext.tableRef), [
        ref,
        tableContainerContext === null || tableContainerContext === void 0 ? void 0 : tableContainerContext.tableRef
    ]));
    let state = (0, $kyRRA.useTableState)({
        ...props,
        collection: collection,
        children: undefined,
        UNSAFE_selectionState: selectionState
    });
    let { isVirtualized: isVirtualized, layoutDelegate: layoutDelegate, dropTargetDelegate: ctxDropTargetDelegate, CollectionRoot: CollectionRoot } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let { dragAndDropHooks: dragAndDropHooks } = props;
    let { gridProps: gridProps } = (0, $lGes6.useTable)({
        ...props,
        layoutDelegate: layoutDelegate,
        isVirtualized: isVirtualized
    }, state, ref);
    let selectionManager = state.selectionManager;
    let hasDragHooks = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDraggableCollectionState);
    let hasDropHooks = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDroppableCollectionState);
    let dragHooksProvided = (0, $bh6RR.useRef)(hasDragHooks);
    let dropHooksProvided = (0, $bh6RR.useRef)(hasDropHooks);
    (0, $bh6RR.useEffect)(()=>{
        if (dragHooksProvided.current !== hasDragHooks) console.warn('Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
        if (dropHooksProvided.current !== hasDropHooks) console.warn('Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
    }, [
        hasDragHooks,
        hasDropHooks
    ]);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, $bh6RR.useRef)(null);
    if (hasDragHooks && dragAndDropHooks) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: collection,
            selectionManager: selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, ref);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    if (hasDropHooks && dragAndDropHooks) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: collection,
            selectionManager: selectionManager
        });
        let keyboardDelegate = new (0, $36LQn.ListKeyboardDelegate)({
            collection: collection,
            disabledKeys: selectionManager.disabledKeys,
            disabledBehavior: selectionManager.disabledBehavior,
            ref: ref,
            layoutDelegate: layoutDelegate
        });
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || ctxDropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(collection.rows, ref);
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: keyboardDelegate,
            dropTargetDelegate: dropTargetDelegate
        }, dropState, ref);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $5Gawp.useFocusRing)();
    let renderProps = (0, $dgWhj.useRenderProps)({
        className: props.className,
        style: props.style,
        defaultClassName: 'react-aria-Table',
        values: {
            isDropTarget: isRootDropTarget,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            state: state
        }
    });
    let isListDraggable = !!(hasDragHooks && !(dragState === null || dragState === void 0 ? void 0 : dragState.isDisabled));
    let style = renderProps.style;
    let layoutState = null;
    if (tableContainerContext) {
        layoutState = tableContainerContext.useTableColumnResizeState({
            tableWidth: tableContainerContext.tableWidth
        }, state);
        if (!isVirtualized) style = {
            ...style,
            tableLayout: 'fixed',
            width: 'fit-content'
        };
    }
    let ElementType = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('table');
    var _tableContainerContext_scrollRef;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                $da6e171bcb60f7fd$export$38de1cb0526c21fb,
                state
            ],
            [
                $da6e171bcb60f7fd$export$a2680a798823803c,
                layoutState
            ],
            [
                (0, $4HVSY.DragAndDropContext),
                {
                    dragAndDropHooks: dragAndDropHooks,
                    dragState: dragState,
                    dropState: dropState
                }
            ],
            [
                (0, $4HVSY.DropIndicatorContext),
                {
                    render: $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableDropIndicatorWrapper
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2NhrA.FocusScope), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ElementType, {
        ...(0, $bG0JH.filterDOMProps)(props),
        ...renderProps,
        ...(0, $hAxtE.mergeProps)(gridProps, focusProps, droppableCollection === null || droppableCollection === void 0 ? void 0 : droppableCollection.collectionProps),
        style: style,
        ref: ref,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        "data-allows-dragging": isListDraggable || undefined,
        "data-drop-target": isRootDropTarget || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionRoot, {
        collection: collection,
        scrollRef: (_tableContainerContext_scrollRef = tableContainerContext === null || tableContainerContext === void 0 ? void 0 : tableContainerContext.scrollRef) !== null && _tableContainerContext_scrollRef !== void 0 ? _tableContainerContext_scrollRef : ref,
        persistedKeys: (0, $4HVSY.useDndPersistedKeys)(selectionManager, dragAndDropHooks, dropState)
    }))), dragPreview);
}
/**
 * A table displays data in rows and columns and enables a user to navigate its contents via directional navigation keys,
 * and optionally supports row selection and sorting.
 */ const $da6e171bcb60f7fd$export$54ec01a60f47d33d = (0, $bh6RR.forwardRef)($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$Table);
function $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType(element) {
    let { isVirtualized: isVirtualized } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    return isVirtualized ? 'div' : element;
}
const $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableOptionsContext = (0, $bh6RR.createContext)(null);
function $da6e171bcb60f7fd$export$fddc468cd8cb4db9() {
    return (0, $bh6RR.useContext)($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableOptionsContext);
}
const $da6e171bcb60f7fd$export$f850895b287ef28e = (0, $eqvPU.createBranchComponent)('tableheader', (props, ref)=>{
    let collection = (0, $bh6RR.useContext)($da6e171bcb60f7fd$export$38de1cb0526c21fb).collection;
    let headerRows = (0, $72X2K.useCachedChildren)({
        items: collection.headerRows,
        children: (0, $bh6RR.useCallback)((item)=>{
            switch(item.type){
                case 'headerrow':
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableHeaderRow, {
                        item: item
                    });
                default:
                    throw new Error('Unsupported node type in TableHeader: ' + item.type);
            }
        }, [])
    });
    let THead = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('thead');
    let { rowGroupProps: rowGroupProps } = (0, $fKc9O.useTableRowGroup)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)({
        onHoverStart: props.onHoverStart,
        onHoverChange: props.onHoverChange,
        onHoverEnd: props.onHoverEnd
    });
    let renderProps = (0, $dgWhj.useRenderProps)({
        className: props.className,
        style: props.style,
        defaultClassName: 'react-aria-TableHeader',
        values: {
            isHovered: isHovered
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(THead, {
        ...(0, $hAxtE.mergeProps)((0, $bG0JH.filterDOMProps)(props), rowGroupProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-hovered": isHovered || undefined
    }, headerRows);
}, (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eqvPU.Collection), {
        dependencies: props.dependencies,
        items: props.columns
    }, props.children));
function $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableHeaderRow({ item: item }) {
    let ref = (0, $bh6RR.useRef)(null);
    let state = (0, $bh6RR.useContext)($da6e171bcb60f7fd$export$38de1cb0526c21fb);
    let { isVirtualized: isVirtualized, CollectionBranch: CollectionBranch } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let { rowProps: rowProps } = (0, $2QDeI.useTableHeaderRow)({
        node: item,
        isVirtualized: isVirtualized
    }, state, ref);
    let { checkboxProps: checkboxProps } = (0, $dQD2e.useTableSelectAllCheckbox)(state);
    let TR = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('tr');
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TR, {
        ...rowProps,
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                (0, $hzBE3.CheckboxContext),
                {
                    slots: {
                        selection: checkboxProps
                    }
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    })));
}
const $da6e171bcb60f7fd$export$816b5d811295e6bc = (0, $eqvPU.createLeafComponent)('column', (props, forwardedRef, column)=>{
    var _state_sortDescriptor, _state_sortDescriptor1;
    let ref = (0, $jyDr8.useObjectRef)(forwardedRef);
    let state = (0, $bh6RR.useContext)($da6e171bcb60f7fd$export$38de1cb0526c21fb);
    let { isVirtualized: isVirtualized } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let { columnHeaderProps: columnHeaderProps } = (0, $1UUYg.useTableColumnHeader)({
        node: column,
        isVirtualized: isVirtualized
    }, state, ref);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $5Gawp.useFocusRing)();
    let layoutState = (0, $bh6RR.useContext)($da6e171bcb60f7fd$export$a2680a798823803c);
    let isResizing = false;
    if (layoutState) isResizing = layoutState.resizingColumn === column.key;
    else {
        for(let prop in [
            'width',
            'defaultWidth',
            'minWidth',
            'maxWidth'
        ])if (prop in column.props) console.warn(`The ${prop} prop on a <Column> only applies when a <Table> is wrapped in a <ResizableTableContainer>. If you aren't using column resizing, you can set the width of a column with CSS.`);
    }
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)({
        isDisabled: !props.allowsSorting
    });
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        id: undefined,
        children: column.rendered,
        defaultClassName: 'react-aria-Column',
        values: {
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            allowsSorting: column.props.allowsSorting,
            sortDirection: ((_state_sortDescriptor = state.sortDescriptor) === null || _state_sortDescriptor === void 0 ? void 0 : _state_sortDescriptor.column) === column.key ? state.sortDescriptor.direction : undefined,
            isResizing: isResizing,
            startResize: ()=>{
                if (layoutState) {
                    layoutState.startResize(column.key);
                    state.setKeyboardNavigationDisabled(true);
                } else throw new Error('Wrap your <Table> in a <ResizableTableContainer> to enable column resizing');
            },
            sort: (direction)=>{
                state.sort(column.key, direction);
            }
        }
    });
    let style = renderProps.style;
    if (layoutState) style = {
        ...style,
        width: layoutState.getColumnWidth(column.key)
    };
    let TH = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('th');
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TH, {
        ...(0, $hAxtE.mergeProps)((0, $bG0JH.filterDOMProps)(props), columnHeaderProps, focusProps, hoverProps),
        ...renderProps,
        style: style,
        colSpan: column.colspan,
        ref: ref,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-resizing": isResizing || undefined,
        "data-allows-sorting": column.props.allowsSorting || undefined,
        "data-sort-direction": ((_state_sortDescriptor1 = state.sortDescriptor) === null || _state_sortDescriptor1 === void 0 ? void 0 : _state_sortDescriptor1.column) === column.key ? state.sortDescriptor.direction : undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$ColumnResizerContext,
                {
                    column: column,
                    triggerRef: ref
                }
            ],
            [
                (0, $juOz0.CollectionRendererContext),
                (0, $juOz0.DefaultCollectionRenderer)
            ]
        ]
    }, renderProps.children));
});
const $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$ColumnResizerContext = (0, $bh6RR.createContext)(null);
function $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$ColumnResizer(props, ref) {
    let layoutState = (0, $bh6RR.useContext)($da6e171bcb60f7fd$export$a2680a798823803c);
    if (!layoutState) throw new Error('Wrap your <Table> in a <ResizableTableContainer> to enable column resizing');
    let stringFormatter = (0, $kbHlJ.useLocalizedStringFormatter)($da6e171bcb60f7fd$var$$parcel$interopDefault((0, $cxt9V.default)), 'react-aria-components');
    let { onResizeStart: onResizeStart, onResize: onResize, onResizeEnd: onResizeEnd } = (0, $bh6RR.useContext)($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$ResizableTableContainerContext);
    let { column: column, triggerRef: triggerRef } = (0, $bh6RR.useContext)($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$ColumnResizerContext);
    let inputRef = (0, $bh6RR.useRef)(null);
    let { resizerProps: resizerProps, inputProps: inputProps, isResizing: isResizing } = (0, $dcGdN.useTableColumnResize)({
        column: column,
        'aria-label': props['aria-label'] || stringFormatter.format('tableResizer'),
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeEnd: onResizeEnd,
        triggerRef: triggerRef
    }, layoutState, inputRef);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $5Gawp.useFocusRing)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)(props);
    let isEResizable = layoutState.getColumnMinWidth(column.key) >= layoutState.getColumnWidth(column.key);
    let isWResizable = layoutState.getColumnMaxWidth(column.key) <= layoutState.getColumnWidth(column.key);
    let { direction: direction } = (0, $c8uzR.useLocale)();
    let resizableDirection = 'both';
    if (isEResizable) resizableDirection = direction === 'rtl' ? 'right' : 'left';
    else if (isWResizable) resizableDirection = direction === 'rtl' ? 'left' : 'right';
    else resizableDirection = 'both';
    let objectRef = (0, $jyDr8.useObjectRef)(ref);
    let [cursor, setCursor] = (0, $bh6RR.useState)('');
    (0, $bh6RR.useEffect)(()=>{
        if (!objectRef.current) return;
        let style = window.getComputedStyle(objectRef.current);
        setCursor(style.cursor);
    }, [
        objectRef,
        resizableDirection
    ]);
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-ColumnResizer',
        values: {
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isResizing: isResizing,
            isHovered: isHovered,
            resizableDirection: resizableDirection
        }
    });
    let [isMouseDown, setMouseDown] = (0, $bh6RR.useState)(false);
    let onPointerDown = (e)=>{
        if (e.pointerType === 'mouse') setMouseDown(true);
    };
    if (!isResizing && isMouseDown) setMouseDown(false);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ref: objectRef,
        role: "presentation",
        ...(0, $bG0JH.filterDOMProps)(props),
        ...renderProps,
        ...(0, $hAxtE.mergeProps)(resizerProps, {
            onPointerDown: onPointerDown
        }, hoverProps),
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-resizing": isResizing || undefined,
        "data-resizable-direction": resizableDirection
    }, renderProps.children, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("input", {
        ref: inputRef,
        ...(0, $hAxtE.mergeProps)(inputProps, focusProps)
    }), isResizing && isMouseDown && (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).createPortal((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: {
            position: 'fixed',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            cursor: cursor
        }
    }), document.body));
}
const $da6e171bcb60f7fd$export$ee689e97a7664bfd = (0, $bh6RR.forwardRef)($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$ColumnResizer);
const $da6e171bcb60f7fd$export$76ccd210b9029917 = (0, $eqvPU.createBranchComponent)('tablebody', (props, ref)=>{
    let state = (0, $bh6RR.useContext)($da6e171bcb60f7fd$export$38de1cb0526c21fb);
    let { isVirtualized: isVirtualized } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let collection = state.collection;
    let { CollectionBranch: CollectionBranch } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $bh6RR.useContext)((0, $4HVSY.DragAndDropContext));
    let isDroppable = !!(dragAndDropHooks === null || dragAndDropHooks === void 0 ? void 0 : dragAndDropHooks.useDroppableCollectionState) && !(dropState === null || dropState === void 0 ? void 0 : dropState.isDisabled);
    var _dropState_isDropTarget;
    let isRootDropTarget = isDroppable && !!dropState && ((_dropState_isDropTarget = dropState.isDropTarget({
        type: 'root'
    })) !== null && _dropState_isDropTarget !== void 0 ? _dropState_isDropTarget : false);
    let renderValues = {
        isDropTarget: isRootDropTarget,
        isEmpty: collection.size === 0
    };
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        id: undefined,
        children: undefined,
        defaultClassName: 'react-aria-TableBody',
        values: renderValues
    });
    let emptyState;
    let TR = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('tr');
    let TD = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('td');
    let numColumns = collection.columnCount;
    if (collection.size === 0 && props.renderEmptyState && state) {
        let rowProps = {};
        let rowHeaderProps = {};
        let style = {};
        if (isVirtualized) {
            rowProps['aria-rowindex'] = collection.headerRows.length + 1;
            rowHeaderProps['aria-colspan'] = numColumns;
            style = {
                display: 'contents'
            };
        } else rowHeaderProps['colSpan'] = numColumns;
        emptyState = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TR, {
            role: "row",
            ...rowProps,
            style: style
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TD, {
            role: "rowheader",
            ...rowHeaderProps,
            style: style
        }, props.renderEmptyState(renderValues)));
    }
    let { rowGroupProps: rowGroupProps } = (0, $fKc9O.useTableRowGroup)();
    let TBody = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('tbody');
    // TODO: TableBody doesn't support being the scrollable body of the table yet, to revisit if needed. Would need to
    // call useLoadMore here and walk up the DOM to the nearest scrollable element to set scrollRef
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TBody, {
        ...(0, $hAxtE.mergeProps)((0, $bG0JH.filterDOMProps)(props), rowGroupProps),
        ...renderProps,
        ref: ref,
        "data-empty": collection.size === 0 || undefined
    }, isDroppable && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$RootDropIndicator, null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionBranch, {
        collection: collection,
        parent: collection.body,
        renderDropIndicator: (0, $4HVSY.useRenderDropIndicator)(dragAndDropHooks, dropState)
    }), emptyState);
});
const $da6e171bcb60f7fd$export$b59bdbef9ce70de2 = (0, $eqvPU.createBranchComponent)('item', (props, forwardedRef, item)=>{
    let ref = (0, $jyDr8.useObjectRef)(forwardedRef);
    let state = (0, $bh6RR.useContext)($da6e171bcb60f7fd$export$38de1cb0526c21fb);
    let { dragAndDropHooks: dragAndDropHooks, dragState: dragState, dropState: dropState } = (0, $bh6RR.useContext)((0, $4HVSY.DragAndDropContext));
    let { isVirtualized: isVirtualized, CollectionBranch: CollectionBranch } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let { rowProps: rowProps, ...states } = (0, $jVvar.useTableRow)({
        node: item,
        shouldSelectOnPressUp: !!dragState,
        isVirtualized: isVirtualized
    }, state, ref);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $5Gawp.useFocusRing)();
    let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = (0, $5Gawp.useFocusRing)({
        within: true
    });
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)({
        isDisabled: !states.allowsSelection && !states.hasAction,
        onHoverStart: props.onHoverStart,
        onHoverChange: props.onHoverChange,
        onHoverEnd: props.onHoverEnd
    });
    let { checkboxProps: checkboxProps } = (0, $dQD2e.useTableSelectionCheckbox)({
        key: item.key
    }, state);
    let draggableItem = undefined;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key,
        hasDragButton: true
    }, dragState);
    let dropIndicator = undefined;
    let dropIndicatorRef = (0, $bh6RR.useRef)(null);
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $lhOYy.useVisuallyHidden)();
    if (dropState && dragAndDropHooks) dropIndicator = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        }
    }, dropState, dropIndicatorRef);
    let dragButtonRef = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        if (dragState && !dragButtonRef.current) console.warn('Draggable items in a Table must contain a <Button slot="drag"> element so that keyboard and screen reader users can drag them.');
    // eslint-disable-next-line
    }, []);
    let isDragging = dragState && dragState.isDragging(item.key);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { children: _, ...restProps } = props;
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...restProps,
        id: undefined,
        defaultClassName: 'react-aria-Row',
        values: {
            ...states,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            isDragging: isDragging,
            isDropTarget: dropIndicator === null || dropIndicator === void 0 ? void 0 : dropIndicator.isDropTarget,
            isFocusVisibleWithin: isFocusVisibleWithin
        }
    });
    let TR = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('tr');
    let TD = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('td');
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, dropIndicator && !dropIndicator.isHidden && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TR, {
        role: "row",
        style: {
            height: 0
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TD, {
        role: "gridcell",
        colSpan: state.collection.columnCount,
        style: {
            padding: 0
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicator.dropIndicatorProps,
        ref: dropIndicatorRef
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TR, {
        ...(0, $hAxtE.mergeProps)((0, $bG0JH.filterDOMProps)(props), rowProps, focusProps, hoverProps, draggableItem === null || draggableItem === void 0 ? void 0 : draggableItem.dragProps, focusWithinProps),
        ...renderProps,
        ref: ref,
        "data-disabled": states.isDisabled || undefined,
        "data-selected": states.isSelected || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": (dropIndicator === null || dropIndicator === void 0 ? void 0 : dropIndicator.isDropTarget) || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode,
        "data-focus-visible-within": isFocusVisibleWithin || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                (0, $hzBE3.CheckboxContext),
                {
                    slots: {
                        [(0, $dgWhj.DEFAULT_SLOT)]: {},
                        selection: checkboxProps
                    }
                }
            ],
            [
                (0, $9cr7a.ButtonContext),
                {
                    slots: {
                        [(0, $dgWhj.DEFAULT_SLOT)]: {},
                        drag: {
                            ...draggableItem === null || draggableItem === void 0 ? void 0 : draggableItem.dragButtonProps,
                            ref: dragButtonRef,
                            style: {
                                pointerEvents: 'none'
                            }
                        }
                    }
                }
            ]
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    }))));
}, (props)=>{
    if (props.id == null && typeof props.children === 'function') throw new Error('No id detected for the Row element. The Row element requires a id to be provided to it when the cells are rendered dynamically.');
    let dependencies = [
        props.value
    ].concat(props.dependencies);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $eqvPU.Collection), {
        dependencies: dependencies,
        items: props.columns,
        idScope: props.id
    }, props.children);
});
const $da6e171bcb60f7fd$export$f6f0c3fe4ec306ea = (0, $eqvPU.createLeafComponent)('cell', (props, forwardedRef, cell)=>{
    let ref = (0, $jyDr8.useObjectRef)(forwardedRef);
    let state = (0, $bh6RR.useContext)($da6e171bcb60f7fd$export$38de1cb0526c21fb);
    let { dragState: dragState } = (0, $bh6RR.useContext)((0, $4HVSY.DragAndDropContext));
    let { isVirtualized: isVirtualized } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    cell.column = state.collection.columns[cell.index];
    let { gridCellProps: gridCellProps, isPressed: isPressed } = (0, $4SWU2.useTableCell)({
        node: cell,
        shouldSelectOnPressUp: !!dragState,
        isVirtualized: isVirtualized
    }, state, ref);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $5Gawp.useFocusRing)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)({});
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        id: undefined,
        defaultClassName: 'react-aria-Cell',
        values: {
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isPressed: isPressed,
            isHovered: isHovered
        }
    });
    let TD = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('td');
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TD, {
        ...(0, $hAxtE.mergeProps)((0, $bG0JH.filterDOMProps)(props), gridCellProps, focusProps, hoverProps),
        ...renderProps,
        ref: ref,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": isPressed || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $juOz0.CollectionRendererContext).Provider, {
        value: (0, $juOz0.DefaultCollectionRenderer)
    }, renderProps.children));
});
function $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableDropIndicatorWrapper(props, ref) {
    ref = (0, $jyDr8.useObjectRef)(ref);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $bh6RR.useContext)((0, $4HVSY.DragAndDropContext));
    let buttonRef = (0, $bh6RR.useRef)(null);
    let { dropIndicatorProps: dropIndicatorProps, isHidden: isHidden, isDropTarget: isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, buttonRef);
    if (isHidden) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        buttonRef: buttonRef,
        ref: ref
    });
}
function $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableDropIndicator(props, ref) {
    let { dropIndicatorProps: dropIndicatorProps, isDropTarget: isDropTarget, buttonRef: buttonRef, ...otherProps } = props;
    let state = (0, $bh6RR.useContext)($da6e171bcb60f7fd$export$38de1cb0526c21fb);
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $lhOYy.useVisuallyHidden)();
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...otherProps,
        defaultClassName: 'react-aria-DropIndicator',
        values: {
            isDropTarget: isDropTarget
        }
    });
    let TR = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('tr');
    let TD = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('td');
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TR, {
        ...(0, $bG0JH.filterDOMProps)(props),
        ...renderProps,
        role: "row",
        ref: ref,
        "data-drop-target": isDropTarget || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TD, {
        role: "gridcell",
        colSpan: state.collection.columnCount,
        style: {
            padding: 0
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: buttonRef
    }), renderProps.children));
}
const $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableDropIndicatorForwardRef = (0, $bh6RR.forwardRef)($da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$TableDropIndicator);
function $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$RootDropIndicator() {
    let state = (0, $bh6RR.useContext)($da6e171bcb60f7fd$export$38de1cb0526c21fb);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $bh6RR.useContext)((0, $4HVSY.DragAndDropContext));
    let ref = (0, $bh6RR.useRef)(null);
    let { dropIndicatorProps: dropIndicatorProps } = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'root'
        }
    }, dropState, ref);
    let isDropTarget = dropState.isDropTarget({
        type: 'root'
    });
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $lhOYy.useVisuallyHidden)();
    let TR = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('tr');
    let TD = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('td');
    if (!isDropTarget && dropIndicatorProps['aria-hidden']) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TR, {
        role: "row",
        "aria-hidden": dropIndicatorProps['aria-hidden'],
        style: {
            height: 0
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TD, {
        role: "gridcell",
        colSpan: state.collection.columnCount,
        style: {
            padding: 0
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicatorProps,
        ref: ref
    })));
}
const $da6e171bcb60f7fd$export$f241c45dcdfa4093 = (0, $eqvPU.createLeafComponent)('loader', function TableLoadingIndicator(props, ref, item) {
    let state = (0, $bh6RR.useContext)($da6e171bcb60f7fd$export$38de1cb0526c21fb);
    let { isVirtualized: isVirtualized } = (0, $bh6RR.useContext)((0, $juOz0.CollectionRendererContext));
    let numColumns = state.collection.columns.length;
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-TableLoadingIndicator',
        values: null
    });
    let TR = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('tr');
    let TD = $da6e171bcb60f7fd$var$$1910c06f0ca9905e$var$useElementType('td');
    let rowProps = {};
    let rowHeaderProps = {};
    let style = {};
    if (isVirtualized) {
        rowProps['aria-rowindex'] = state.collection.headerRows.length + state.collection.size;
        rowHeaderProps['aria-colspan'] = numColumns;
        style = {
            display: 'contents'
        };
    } else rowHeaderProps['colSpan'] = numColumns;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TR, {
        role: "row",
        ref: ref,
        ...(0, $hAxtE.mergeProps)((0, $bG0JH.filterDOMProps)(props), rowProps),
        ...renderProps
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(TD, {
        role: "rowheader",
        ...rowHeaderProps,
        style: style
    }, renderProps.children)));
});

});
parcelRegister("cxt9V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93a9ff06cebf7106$export$2e2bcd8739ae039; });

var $jY548 = parcelRequire("jY548");

var $kRwLl = parcelRequire("kRwLl");

var $8hUcL = parcelRequire("8hUcL");

var $ioFoF = parcelRequire("ioFoF");

var $6S5iM = parcelRequire("6S5iM");

var $jihKj = parcelRequire("jihKj");

var $hPv0h = parcelRequire("hPv0h");

var $1w4Us = parcelRequire("1w4Us");

var $14ZxZ = parcelRequire("14ZxZ");

var $3FlfG = parcelRequire("3FlfG");

var $a0BHq = parcelRequire("a0BHq");

var $59kVk = parcelRequire("59kVk");

var $f9Atj = parcelRequire("f9Atj");

var $iRvrF = parcelRequire("iRvrF");

var $ivYoP = parcelRequire("ivYoP");

var $4yE50 = parcelRequire("4yE50");

var $j8wCv = parcelRequire("j8wCv");

var $iecd7 = parcelRequire("iecd7");

var $12nE3 = parcelRequire("12nE3");

var $fg2jQ = parcelRequire("fg2jQ");

var $fqhAK = parcelRequire("fqhAK");

var $1CaiQ = parcelRequire("1CaiQ");

var $gvhTO = parcelRequire("gvhTO");

var $etaTX = parcelRequire("etaTX");

var $8M1x5 = parcelRequire("8M1x5");

var $cPZkg = parcelRequire("cPZkg");

var $7HBk4 = parcelRequire("7HBk4");

var $rB6T0 = parcelRequire("rB6T0");

var $aaXUb = parcelRequire("aaXUb");

var $cMX2V = parcelRequire("cMX2V");

var $dL6sM = parcelRequire("dL6sM");

var $1Pfi8 = parcelRequire("1Pfi8");

var $k3i0X = parcelRequire("k3i0X");

var $hJF31 = parcelRequire("hJF31");
var $93a9ff06cebf7106$export$2e2bcd8739ae039 = {};
$93a9ff06cebf7106$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $jY548.default),
    "bg-BG": (0, $kRwLl.default),
    "cs-CZ": (0, $8hUcL.default),
    "da-DK": (0, $ioFoF.default),
    "de-DE": (0, $6S5iM.default),
    "el-GR": (0, $jihKj.default),
    "en-US": (0, $hPv0h.default),
    "es-ES": (0, $1w4Us.default),
    "et-EE": (0, $14ZxZ.default),
    "fi-FI": (0, $3FlfG.default),
    "fr-FR": (0, $a0BHq.default),
    "he-IL": (0, $59kVk.default),
    "hr-HR": (0, $f9Atj.default),
    "hu-HU": (0, $iRvrF.default),
    "it-IT": (0, $ivYoP.default),
    "ja-JP": (0, $4yE50.default),
    "ko-KR": (0, $j8wCv.default),
    "lt-LT": (0, $iecd7.default),
    "lv-LV": (0, $12nE3.default),
    "nb-NO": (0, $fg2jQ.default),
    "nl-NL": (0, $fqhAK.default),
    "pl-PL": (0, $1CaiQ.default),
    "pt-BR": (0, $gvhTO.default),
    "pt-PT": (0, $etaTX.default),
    "ro-RO": (0, $8M1x5.default),
    "ru-RU": (0, $cPZkg.default),
    "sk-SK": (0, $7HBk4.default),
    "sl-SI": (0, $rB6T0.default),
    "sr-SP": (0, $aaXUb.default),
    "sv-SE": (0, $cMX2V.default),
    "tr-TR": (0, $dL6sM.default),
    "uk-UA": (0, $1Pfi8.default),
    "zh-CN": (0, $k3i0X.default),
    "zh-TW": (0, $hJF31.default)
};

});
parcelRegister("jY548", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98ade0e4a2d4cb18$export$2e2bcd8739ae039; });
var $98ade0e4a2d4cb18$export$2e2bcd8739ae039 = {};
$98ade0e4a2d4cb18$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{62A}\u{63A}\u{64A}\u{64A}\u{631}\u{627}\u{62A} \u{627}\u{644}\u{623}\u{644}\u{648}\u{627}\u{646}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{62D}\u{62F}\u{62F} \u{639}\u{646}\u{635}\u{631}\u{64B}\u{627}`,
    "tableResizer": `\u{623}\u{62F}\u{627}\u{629} \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{627}\u{644}\u{62D}\u{62C}\u{645}`
};

});

parcelRegister("kRwLl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $147a803fc57a56c0$export$2e2bcd8739ae039; });
var $147a803fc57a56c0$export$2e2bcd8739ae039 = {};
$147a803fc57a56c0$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{426}\u{432}\u{435}\u{442}\u{43E}\u{432}\u{438} \u{43C}\u{43E}\u{441}\u{442}\u{440}\u{438}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43C}\u{435}\u{442}`,
    "tableResizer": `\u{41F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{438}\u{442}\u{435}\u{43B}`
};

});

parcelRegister("8hUcL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $190de96f2125a455$export$2e2bcd8739ae039; });
var $190de96f2125a455$export$2e2bcd8739ae039 = {};
$190de96f2125a455$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Vzorky barev`,
    "dropzoneLabel": `M\xedsto pro p\u{159}eta\u{17E}en\xed`,
    "selectPlaceholder": `Vyberte polo\u{17E}ku`,
    "tableResizer": `Zm\u{11B}na velikosti`
};

});

parcelRegister("ioFoF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5192387aa12048f7$export$2e2bcd8739ae039; });
var $5192387aa12048f7$export$2e2bcd8739ae039 = {};
$5192387aa12048f7$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Farvepr\xf8ver`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe6lg et element`,
    "tableResizer": `St\xf8rrelses\xe6ndring`
};

});

parcelRegister("6S5iM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5792380c2d97c455$export$2e2bcd8739ae039; });
var $5792380c2d97c455$export$2e2bcd8739ae039 = {};
$5792380c2d97c455$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Farbfelder`,
    "dropzoneLabel": `Ablegebereich`,
    "selectPlaceholder": `Element w\xe4hlen`,
    "tableResizer": `Gr\xf6\xdfenanpassung`
};

});

parcelRegister("jihKj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a599b5ebd00d8e81$export$2e2bcd8739ae039; });
var $a599b5ebd00d8e81$export$2e2bcd8739ae039 = {};
$a599b5ebd00d8e81$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{3A7}\u{3C1}\u{3C9}\u{3BC}\u{3B1}\u{3C4}\u{3B9}\u{3BA}\u{3AC} \u{3B4}\u{3B5}\u{3AF}\u{3B3}\u{3BC}\u{3B1}\u{3C4}\u{3B1}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3AD}\u{3BE}\u{3C4}\u{3B5} \u{3AD}\u{3BD}\u{3B1} \u{3B1}\u{3BD}\u{3C4}\u{3B9}\u{3BA}\u{3B5}\u{3AF}\u{3BC}\u{3B5}\u{3BD}\u{3BF}`,
    "tableResizer": `\u{391}\u{3BB}\u{3BB}\u{3B1}\u{3B3}\u{3AE} \u{3BC}\u{3B5}\u{3B3}\u{3AD}\u{3B8}\u{3BF}\u{3C5}\u{3C2}`
};

});

parcelRegister("hPv0h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f85d6e611cb140b6$export$2e2bcd8739ae039; });
var $f85d6e611cb140b6$export$2e2bcd8739ae039 = {};
$f85d6e611cb140b6$export$2e2bcd8739ae039 = {
    "selectPlaceholder": `Select an item`,
    "tableResizer": `Resizer`,
    "dropzoneLabel": `DropZone`,
    "colorSwatchPicker": `Color swatches`
};

});

parcelRegister("1w4Us", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37cf0f207e0aacfd$export$2e2bcd8739ae039; });
var $37cf0f207e0aacfd$export$2e2bcd8739ae039 = {};
$37cf0f207e0aacfd$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Muestras de colores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Seleccionar un art\xedculo`,
    "tableResizer": `Cambiador de tama\xf1o`
};

});

parcelRegister("14ZxZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b99ddd73afa015f5$export$2e2bcd8739ae039; });
var $b99ddd73afa015f5$export$2e2bcd8739ae039 = {};
$b99ddd73afa015f5$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `V\xe4rvin\xe4idised`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valige \xfcksus`,
    "tableResizer": `Suuruse muutja`
};

});

parcelRegister("3FlfG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84d13da997ebee2a$export$2e2bcd8739ae039; });
var $84d13da997ebee2a$export$2e2bcd8739ae039 = {};
$84d13da997ebee2a$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `V\xe4rimallit`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valitse kohde`,
    "tableResizer": `Koon muuttaja`
};

});

parcelRegister("a0BHq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d14b8977a2c80070$export$2e2bcd8739ae039; });
var $d14b8977a2c80070$export$2e2bcd8739ae039 = {};
$d14b8977a2c80070$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\xc9chantillons de couleurs`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `S\xe9lectionner un \xe9l\xe9ment`,
    "tableResizer": `Redimensionneur`
};

});

parcelRegister("59kVk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c18b9f319897be2$export$2e2bcd8739ae039; });
var $9c18b9f319897be2$export$2e2bcd8739ae039 = {};
$9c18b9f319897be2$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{5D3}\u{5D5}\u{5D2}\u{5DE}\u{5D9}\u{5D5}\u{5EA} \u{5E6}\u{5D1}\u{5E2}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{5D1}\u{5D7}\u{5E8} \u{5E4}\u{5E8}\u{5D9}\u{5D8}`,
    "tableResizer": `\u{5E9}\u{5D9}\u{5E0}\u{5D5}\u{5D9} \u{5D2}\u{5D5}\u{5D3}\u{5DC}`
};

});

parcelRegister("f9Atj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $095171c7869b8da8$export$2e2bcd8739ae039; });
var $095171c7869b8da8$export$2e2bcd8739ae039 = {};
$095171c7869b8da8$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Uzorci boja`,
    "dropzoneLabel": `Zona spu\u{161}tanja`,
    "selectPlaceholder": `Odaberite stavku`,
    "tableResizer": `Promjena veli\u{10D}ine`
};

});

parcelRegister("iRvrF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02ce3eb71055c4b7$export$2e2bcd8739ae039; });
var $02ce3eb71055c4b7$export$2e2bcd8739ae039 = {};
$02ce3eb71055c4b7$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Sz\xednt\xe1rak`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe1lasszon ki egy elemet`,
    "tableResizer": `\xc1tm\xe9retez\u{151}`
};

});

parcelRegister("ivYoP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c5909febb34def7$export$2e2bcd8739ae039; });
var $7c5909febb34def7$export$2e2bcd8739ae039 = {};
$7c5909febb34def7$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Campioni di colore`,
    "dropzoneLabel": `Zona di rilascio`,
    "selectPlaceholder": `Seleziona un elemento`,
    "tableResizer": `Ridimensionamento`
};

});

parcelRegister("4yE50", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be4ce0ec20f1ed36$export$2e2bcd8739ae039; });
var $be4ce0ec20f1ed36$export$2e2bcd8739ae039 = {};
$be4ce0ec20f1ed36$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{30AB}\u{30E9}\u{30FC}\u{30B9}\u{30A6}\u{30A9}\u{30C3}\u{30C1}`,
    "dropzoneLabel": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{30BE}\u{30FC}\u{30F3}`,
    "selectPlaceholder": `\u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}`,
    "tableResizer": `\u{30B5}\u{30A4}\u{30BA}\u{5909}\u{66F4}\u{30C4}\u{30FC}\u{30EB}`
};

});

parcelRegister("j8wCv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d62af8a8f7d6226$export$2e2bcd8739ae039; });
var $4d62af8a8f7d6226$export$2e2bcd8739ae039 = {};
$4d62af8a8f7d6226$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{C0C9}\u{C0C1} \u{ACAC}\u{BCF8}`,
    "dropzoneLabel": `\u{B4DC}\u{B86D} \u{C601}\u{C5ED}`,
    "selectPlaceholder": `\u{D56D}\u{BAA9} \u{C120}\u{D0DD}`,
    "tableResizer": `\u{D06C}\u{AE30} \u{C870}\u{C815}\u{AE30}`
};

});

parcelRegister("iecd7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aed3f8579c2504d5$export$2e2bcd8739ae039; });
var $aed3f8579c2504d5$export$2e2bcd8739ae039 = {};
$aed3f8579c2504d5$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Spalv\u{173} pavyzd\u{17E}iai`,
    "dropzoneLabel": `\u{201E}DropZone\u{201C}`,
    "selectPlaceholder": `Pasirinkite element\u{105}`,
    "tableResizer": `Dyd\u{17E}io keitiklis`
};

});

parcelRegister("12nE3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $287e9f066dffcb89$export$2e2bcd8739ae039; });
var $287e9f066dffcb89$export$2e2bcd8739ae039 = {};
$287e9f066dffcb89$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Kr\u{101}su paraugi`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izv\u{113}l\u{113}ties vienumu`,
    "tableResizer": `Izm\u{113}ra main\u{12B}t\u{101}js`
};

});

parcelRegister("fg2jQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $866b6c3ad97a431c$export$2e2bcd8739ae039; });
var $866b6c3ad97a431c$export$2e2bcd8739ae039 = {};
$866b6c3ad97a431c$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Fargekart`,
    "dropzoneLabel": `Droppsone`,
    "selectPlaceholder": `Velg et element`,
    "tableResizer": `St\xf8rrelsesendrer`
};

});

parcelRegister("fqhAK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b53a897d84283fa4$export$2e2bcd8739ae039; });
var $b53a897d84283fa4$export$2e2bcd8739ae039 = {};
$b53a897d84283fa4$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `kleurstalen`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecteer een item`,
    "tableResizer": `Resizer`
};

});

parcelRegister("1CaiQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6dd14c075f39033$export$2e2bcd8739ae039; });
var $f6dd14c075f39033$export$2e2bcd8739ae039 = {};
$f6dd14c075f39033$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Pr\xf3bki kolor\xf3w`,
    "dropzoneLabel": `Strefa upuszczania`,
    "selectPlaceholder": `Wybierz element`,
    "tableResizer": `Zmiana rozmiaru`
};

});

parcelRegister("gvhTO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31ae864753256006$export$2e2bcd8739ae039; });
var $31ae864753256006$export$2e2bcd8739ae039 = {};
$31ae864753256006$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Amostras de cores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`
};

});

parcelRegister("etaTX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2552b5763c1a33a6$export$2e2bcd8739ae039; });
var $2552b5763c1a33a6$export$2e2bcd8739ae039 = {};
$2552b5763c1a33a6$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Amostras de cores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`
};

});

parcelRegister("8M1x5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3f2571bdd5fbcb0$export$2e2bcd8739ae039; });
var $f3f2571bdd5fbcb0$export$2e2bcd8739ae039 = {};
$f3f2571bdd5fbcb0$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Specimene de culoare`,
    "dropzoneLabel": `Zon\u{103} de plasare`,
    "selectPlaceholder": `Selecta\u{21B}i un element`,
    "tableResizer": `Instrument de redimensionare`
};

});

parcelRegister("cPZkg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52f5fcf3fa7d48dd$export$2e2bcd8739ae039; });
var $52f5fcf3fa7d48dd$export$2e2bcd8739ae039 = {};
$52f5fcf3fa7d48dd$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{426}\u{432}\u{435}\u{442}\u{43E}\u{432}\u{44B}\u{435} \u{43E}\u{431}\u{440}\u{430}\u{437}\u{446}\u{44B}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
    "tableResizer": `\u{421}\u{440}\u{435}\u{434}\u{441}\u{442}\u{432}\u{43E} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{430}`
};

});

parcelRegister("7HBk4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42038a520e819bc9$export$2e2bcd8739ae039; });
var $42038a520e819bc9$export$2e2bcd8739ae039 = {};
$42038a520e819bc9$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Vzorkovn\xedky farieb`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Vyberte polo\u{17E}ku`,
    "tableResizer": `N\xe1stroj na zmenu ve\u{13E}kosti`
};

});

parcelRegister("rB6T0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c66359a9f807e97$export$2e2bcd8739ae039; });
var $3c66359a9f807e97$export$2e2bcd8739ae039 = {};
$3c66359a9f807e97$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Barvne palete`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izberite element`,
    "tableResizer": `Spreminjanje velikosti`
};

});

parcelRegister("aaXUb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65e8e3ab5ee46a5c$export$2e2bcd8739ae039; });
var $65e8e3ab5ee46a5c$export$2e2bcd8739ae039 = {};
$65e8e3ab5ee46a5c$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Uzorci boje`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izaberite stavku`,
    "tableResizer": `Promena veli\u{10D}ine`
};

});

parcelRegister("cMX2V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7fbb1ec03283d5f$export$2e2bcd8739ae039; });
var $b7fbb1ec03283d5f$export$2e2bcd8739ae039 = {};
$b7fbb1ec03283d5f$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `F\xe4rgrutor`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe4lj en artikel`,
    "tableResizer": `Storleks\xe4ndrare`
};

});

parcelRegister("dL6sM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d59d85a8ea9ec353$export$2e2bcd8739ae039; });
var $d59d85a8ea9ec353$export$2e2bcd8739ae039 = {};
$d59d85a8ea9ec353$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `Renk \xf6rnekleri`,
    "dropzoneLabel": `B\u{131}rakma B\xf6lgesi`,
    "selectPlaceholder": `Bir \xf6\u{11F}e se\xe7in`,
    "tableResizer": `Yeniden boyutland\u{131}r\u{131}c\u{131}`
};

});

parcelRegister("1Pfi8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20513e1cb0471f01$export$2e2bcd8739ae039; });
var $20513e1cb0471f01$export$2e2bcd8739ae039 = {};
$20513e1cb0471f01$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{417}\u{440}\u{430}\u{437}\u{43A}\u{438} \u{43A}\u{43E}\u{43B}\u{44C}\u{43E}\u{440}\u{456}\u{432}`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{412}\u{438}\u{431}\u{435}\u{440}\u{456}\u{442}\u{44C} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
    "tableResizer": `\u{417}\u{430}\u{441}\u{456}\u{431} \u{437}\u{43C}\u{456}\u{43D}\u{435}\u{43D}\u{43D}\u{44F} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440}\u{443}`
};

});

parcelRegister("k3i0X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2df92c63a6c933b$export$2e2bcd8739ae039; });
var $b2df92c63a6c933b$export$2e2bcd8739ae039 = {};
$b2df92c63a6c933b$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{989C}\u{8272}\u{8272}\u{677F}`,
    "dropzoneLabel": `\u{653E}\u{7F6E}\u{533A}\u{57DF}`,
    "selectPlaceholder": `\u{9009}\u{62E9}\u{4E00}\u{4E2A}\u{9879}\u{76EE}`,
    "tableResizer": `\u{5C3A}\u{5BF8}\u{8C03}\u{6574}\u{5668}`
};

});

parcelRegister("hJF31", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc2814000926ceb3$export$2e2bcd8739ae039; });
var $fc2814000926ceb3$export$2e2bcd8739ae039 = {};
$fc2814000926ceb3$export$2e2bcd8739ae039 = {
    "colorSwatchPicker": `\u{8272}\u{7968}`,
    "dropzoneLabel": `\u{653E}\u{7F6E}\u{5340}`,
    "selectPlaceholder": `\u{9078}\u{53D6}\u{9805}\u{76EE}`,
    "tableResizer": `\u{5927}\u{5C0F}\u{8ABF}\u{6574}\u{5668}`
};

});


parcelRegister("dcsQ5", function(module, exports) {

$parcel$export(module.exports, "buildHeaderRows", function () { return $a551747d1eb8fe90$export$7c127db850d4e81e; });
$parcel$export(module.exports, "TableCollection", function () { return $a551747d1eb8fe90$export$596e1b2e2cf93690; });

var $6z78f = parcelRequire("6z78f");

var $8Oe0W = parcelRequire("8Oe0W");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a551747d1eb8fe90$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY = 'row-header-column-' + Math.random().toString(36).slice(2);
let $a551747d1eb8fe90$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY_DRAG = 'row-header-column-' + Math.random().toString(36).slice(2);
while($a551747d1eb8fe90$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY === $a551747d1eb8fe90$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY_DRAG)$a551747d1eb8fe90$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY_DRAG = 'row-header-column-' + Math.random().toString(36).slice(2);
function $a551747d1eb8fe90$export$7c127db850d4e81e(keyMap, columnNodes) {
    if (columnNodes.length === 0) return [];
    let columns = [];
    let seen = new Map();
    for (let column of columnNodes){
        let parentKey = column.parentKey;
        let col = [
            column
        ];
        while(parentKey){
            let parent = keyMap.get(parentKey);
            if (!parent) break;
            // If we've already seen this parent, than it is shared
            // with a previous column. If the current column is taller
            // than the previous column, than we need to shift the parent
            // in the previous column so it's level with the current column.
            if (seen.has(parent)) {
                var _parent;
                var _colspan;
                (_colspan = (_parent = parent).colspan) !== null && _colspan !== void 0 ? _colspan : _parent.colspan = 0;
                parent.colspan++;
                let { column: column, index: index } = seen.get(parent);
                if (index > col.length) break;
                for(let i = index; i < col.length; i++)column.splice(i, 0, null);
                // Adjust shifted indices
                for(let i = col.length; i < column.length; i++)if (column[i] && seen.has(column[i])) seen.get(column[i]).index = i;
            } else {
                parent.colspan = 1;
                col.push(parent);
                seen.set(parent, {
                    column: col,
                    index: col.length - 1
                });
            }
            parentKey = parent.parentKey;
        }
        columns.push(col);
        column.index = columns.length - 1;
    }
    let maxLength = Math.max(...columns.map((c)=>c.length));
    let headerRows = Array(maxLength).fill(0).map(()=>[]);
    // Convert columns into rows.
    let colIndex = 0;
    for (let column of columns){
        let i = maxLength - 1;
        for (let item of column){
            if (item) {
                // Fill the space up until the current column with a placeholder
                let row = headerRows[i];
                let rowLength = row.reduce((p, c)=>{
                    var _c_colspan;
                    return p + ((_c_colspan = c.colspan) !== null && _c_colspan !== void 0 ? _c_colspan : 1);
                }, 0);
                if (rowLength < colIndex) {
                    let placeholder = {
                        type: 'placeholder',
                        key: 'placeholder-' + item.key,
                        colspan: colIndex - rowLength,
                        index: rowLength,
                        value: null,
                        rendered: null,
                        level: i,
                        hasChildNodes: false,
                        childNodes: [],
                        textValue: ''
                    };
                    // eslint-disable-next-line max-depth
                    if (row.length > 0) {
                        row[row.length - 1].nextKey = placeholder.key;
                        placeholder.prevKey = row[row.length - 1].key;
                    }
                    row.push(placeholder);
                }
                if (row.length > 0) {
                    row[row.length - 1].nextKey = item.key;
                    item.prevKey = row[row.length - 1].key;
                }
                item.level = i;
                item.colIndex = colIndex;
                row.push(item);
            }
            i--;
        }
        colIndex++;
    }
    // Add placeholders at the end of each row that is shorter than the maximum
    let i = 0;
    for (let row of headerRows){
        let rowLength = row.reduce((p, c)=>{
            var _c_colspan;
            return p + ((_c_colspan = c.colspan) !== null && _c_colspan !== void 0 ? _c_colspan : 1);
        }, 0);
        if (rowLength < columnNodes.length) {
            let placeholder = {
                type: 'placeholder',
                key: 'placeholder-' + row[row.length - 1].key,
                colspan: columnNodes.length - rowLength,
                index: rowLength,
                value: null,
                rendered: null,
                level: i,
                hasChildNodes: false,
                childNodes: [],
                textValue: '',
                prevKey: row[row.length - 1].key
            };
            row.push(placeholder);
        }
        i++;
    }
    return headerRows.map((childNodes, index)=>{
        let row = {
            type: 'headerrow',
            key: 'headerrow-' + index,
            index: index,
            value: null,
            rendered: null,
            level: 0,
            hasChildNodes: true,
            childNodes: childNodes,
            textValue: ''
        };
        return row;
    });
}
class $a551747d1eb8fe90$export$596e1b2e2cf93690 extends (0, $8Oe0W.GridCollection) {
    *[Symbol.iterator]() {
        yield* this.body.childNodes;
    }
    get size() {
        return this._size;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        var _node_prevKey;
        return (_node_prevKey = node === null || node === void 0 ? void 0 : node.prevKey) !== null && _node_prevKey !== void 0 ? _node_prevKey : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        var _node_nextKey;
        return (_node_nextKey = node === null || node === void 0 ? void 0 : node.nextKey) !== null && _node_nextKey !== void 0 ? _node_nextKey : null;
    }
    getFirstKey() {
        var _getFirstItem;
        var _getFirstItem_key;
        return (_getFirstItem_key = (_getFirstItem = (0, $6z78f.getFirstItem)(this.body.childNodes)) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key) !== null && _getFirstItem_key !== void 0 ? _getFirstItem_key : null;
    }
    getLastKey() {
        var _getLastItem;
        var _getLastItem_key;
        return (_getLastItem_key = (_getLastItem = (0, $6z78f.getLastItem)(this.body.childNodes)) === null || _getLastItem === void 0 ? void 0 : _getLastItem.key) !== null && _getLastItem_key !== void 0 ? _getLastItem_key : null;
    }
    getItem(key) {
        var _this_keyMap_get;
        return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        if (key === this.body.key) return this.body.childNodes;
        return super.getChildren(key);
    }
    getTextValue(key) {
        let row = this.getItem(key);
        if (!row) return '';
        // If the row has a textValue, use that.
        if (row.textValue) return row.textValue;
        // Otherwise combine the text of each of the row header columns.
        let rowHeaderColumnKeys = this.rowHeaderColumnKeys;
        if (rowHeaderColumnKeys) {
            let text = [];
            for (let cell of row.childNodes){
                let column = this.columns[cell.index];
                if (rowHeaderColumnKeys.has(column.key) && cell.textValue) text.push(cell.textValue);
                if (text.length === rowHeaderColumnKeys.size) break;
            }
            return text.join(' ');
        }
        return '';
    }
    constructor(nodes, prev, opts){
        let rowHeaderColumnKeys = new Set();
        let body = null;
        let columns = [];
        // Add cell for selection checkboxes if needed.
        if (opts === null || opts === void 0 ? void 0 : opts.showSelectionCheckboxes) {
            let rowHeaderColumn = {
                type: 'column',
                key: $a551747d1eb8fe90$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY,
                value: null,
                textValue: '',
                level: 0,
                index: (opts === null || opts === void 0 ? void 0 : opts.showDragButtons) ? 1 : 0,
                hasChildNodes: false,
                rendered: null,
                childNodes: [],
                props: {
                    isSelectionCell: true
                }
            };
            columns.unshift(rowHeaderColumn);
        }
        // Add cell for drag buttons if needed.
        if (opts === null || opts === void 0 ? void 0 : opts.showDragButtons) {
            let rowHeaderColumn = {
                type: 'column',
                key: $a551747d1eb8fe90$var$$788781baa30117fa$var$ROW_HEADER_COLUMN_KEY_DRAG,
                value: null,
                textValue: '',
                level: 0,
                index: 0,
                hasChildNodes: false,
                rendered: null,
                childNodes: [],
                props: {
                    isDragButtonCell: true
                }
            };
            columns.unshift(rowHeaderColumn);
        }
        let rows = [];
        let columnKeyMap = new Map();
        let visit = (node)=>{
            switch(node.type){
                case 'body':
                    body = node;
                    break;
                case 'column':
                    columnKeyMap.set(node.key, node);
                    if (!node.hasChildNodes) {
                        columns.push(node);
                        if (node.props.isRowHeader) rowHeaderColumnKeys.add(node.key);
                    }
                    break;
                case 'item':
                    rows.push(node);
                    return; // do not go into childNodes
            }
            for (let child of node.childNodes)visit(child);
        };
        for (let node of nodes)visit(node);
        let headerRows = $a551747d1eb8fe90$export$7c127db850d4e81e(columnKeyMap, columns);
        headerRows.forEach((row, i)=>rows.splice(i, 0, row));
        super({
            columnCount: columns.length,
            items: rows,
            visitNode: (node)=>{
                node.column = columns[node.index];
                return node;
            }
        }), this._size = 0;
        this.columns = columns;
        this.rowHeaderColumnKeys = rowHeaderColumnKeys;
        this.body = body;
        this.headerRows = headerRows;
        this._size = [
            ...body.childNodes
        ].length;
        // Default row header column to the first one.
        if (this.rowHeaderColumnKeys.size === 0) {
            let col = this.columns.find((column)=>{
                var _column_props, _column_props1;
                return !((_column_props = column.props) === null || _column_props === void 0 ? void 0 : _column_props.isDragButtonCell) && !((_column_props1 = column.props) === null || _column_props1 === void 0 ? void 0 : _column_props1.isSelectionCell);
            });
            if (col) this.rowHeaderColumnKeys.add(col.key);
        }
    }
}

});
parcelRegister("8Oe0W", function(module, exports) {

$parcel$export(module.exports, "GridCollection", function () { return $a26a265cccef1d39$export$de3fdf6493c353d; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $a26a265cccef1d39$export$de3fdf6493c353d {
    *[Symbol.iterator]() {
        yield* [
            ...this.rows
        ];
    }
    get size() {
        return [
            ...this.rows
        ].length;
    }
    getKeys() {
        return this.keyMap.keys();
    }
    getKeyBefore(key) {
        let node = this.keyMap.get(key);
        var _node_prevKey;
        return node ? (_node_prevKey = node.prevKey) !== null && _node_prevKey !== void 0 ? _node_prevKey : null : null;
    }
    getKeyAfter(key) {
        let node = this.keyMap.get(key);
        var _node_nextKey;
        return node ? (_node_nextKey = node.nextKey) !== null && _node_nextKey !== void 0 ? _node_nextKey : null : null;
    }
    getFirstKey() {
        var _;
        return (_ = [
            ...this.rows
        ][0]) === null || _ === void 0 ? void 0 : _.key;
    }
    getLastKey() {
        var _rows_;
        let rows = [
            ...this.rows
        ];
        return (_rows_ = rows[rows.length - 1]) === null || _rows_ === void 0 ? void 0 : _rows_.key;
    }
    getItem(key) {
        var _this_keyMap_get;
        return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
    }
    at(idx) {
        const keys = [
            ...this.getKeys()
        ];
        return this.getItem(keys[idx]);
    }
    getChildren(key) {
        let node = this.keyMap.get(key);
        return (node === null || node === void 0 ? void 0 : node.childNodes) || [];
    }
    constructor(opts){
        this.keyMap = new Map();
        this.keyMap = new Map();
        this.columnCount = opts === null || opts === void 0 ? void 0 : opts.columnCount;
        this.rows = [];
        let visit = (node)=>{
            // If the node is the same object as the previous node for the same key,
            // we can skip this node and its children. We always visit columns though,
            // because we depend on order to build the columns array.
            let prevNode = this.keyMap.get(node.key);
            if (opts.visitNode) node = opts.visitNode(node);
            this.keyMap.set(node.key, node);
            let childKeys = new Set();
            let last = null;
            for (let child of node.childNodes){
                if (child.type === 'cell' && child.parentKey == null) child.parentKey = node.key;
                childKeys.add(child.key);
                if (last) {
                    last.nextKey = child.key;
                    child.prevKey = last.key;
                } else child.prevKey = null;
                visit(child);
                last = child;
            }
            if (last) last.nextKey = null;
            // Remove deleted nodes and their children from the key map
            if (prevNode) {
                for (let child of prevNode.childNodes)if (!childKeys.has(child.key)) remove(child);
            }
        };
        let remove = (node)=>{
            this.keyMap.delete(node.key);
            for (let child of node.childNodes)if (this.keyMap.get(child.key) === child) remove(child);
        };
        let last = null;
        for (let [i, node] of opts.items.entries()){
            var _node_level, _node_key, _node_type, _node_value, _node_textValue, _node_index;
            let rowNode = {
                ...node,
                level: (_node_level = node.level) !== null && _node_level !== void 0 ? _node_level : 0,
                key: (_node_key = node.key) !== null && _node_key !== void 0 ? _node_key : 'row-' + i,
                type: (_node_type = node.type) !== null && _node_type !== void 0 ? _node_type : 'row',
                value: (_node_value = node.value) !== null && _node_value !== void 0 ? _node_value : null,
                hasChildNodes: true,
                childNodes: [
                    ...node.childNodes
                ],
                rendered: node.rendered,
                textValue: (_node_textValue = node.textValue) !== null && _node_textValue !== void 0 ? _node_textValue : '',
                index: (_node_index = node.index) !== null && _node_index !== void 0 ? _node_index : i
            };
            if (last) {
                last.nextKey = rowNode.key;
                rowNode.prevKey = last.key;
            } else rowNode.prevKey = null;
            this.rows.push(rowNode);
            visit(rowNode);
            last = rowNode;
        }
        if (last) last.nextKey = null;
    }
}

});


parcelRegister("2oxz8", function(module, exports) {

$parcel$export(module.exports, "useTableColumnResizeState", function () { return $ac8a0857cbde6e6e$export$cb895dcf85db1319; });

var $filR9 = parcelRequire("filR9");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ac8a0857cbde6e6e$export$cb895dcf85db1319(props, state) {
    let { getDefaultWidth: getDefaultWidth, getDefaultMinWidth: getDefaultMinWidth, tableWidth: tableWidth = 0 } = props;
    let [resizingColumn, setResizingColumn] = (0, $bh6RR.useState)(null);
    let columnLayout = (0, $bh6RR.useMemo)(()=>new (0, $filR9.TableColumnLayout)({
            getDefaultWidth: getDefaultWidth,
            getDefaultMinWidth: getDefaultMinWidth
        }), [
        getDefaultWidth,
        getDefaultMinWidth
    ]);
    let [controlledColumns, uncontrolledColumns] = (0, $bh6RR.useMemo)(()=>columnLayout.splitColumnsIntoControlledAndUncontrolled(state.collection.columns), [
        state.collection.columns,
        columnLayout
    ]);
    // uncontrolled column widths
    let [uncontrolledWidths, setUncontrolledWidths] = (0, $bh6RR.useState)(()=>columnLayout.getInitialUncontrolledWidths(uncontrolledColumns));
    // Update uncontrolled widths if the columns changed.
    let [lastColumns, setLastColumns] = (0, $bh6RR.useState)(state.collection.columns);
    if (state.collection.columns !== lastColumns) {
        if (state.collection.columns.length !== lastColumns.length || state.collection.columns.some((c, i)=>c.key !== lastColumns[i].key)) {
            let newUncontrolledWidths = columnLayout.getInitialUncontrolledWidths(uncontrolledColumns);
            setUncontrolledWidths(newUncontrolledWidths);
        }
        setLastColumns(state.collection.columns);
    }
    // combine columns back into one map that maintains same order as the columns
    let colWidths = (0, $bh6RR.useMemo)(()=>columnLayout.recombineColumns(state.collection.columns, uncontrolledWidths, uncontrolledColumns, controlledColumns), [
        state.collection.columns,
        uncontrolledWidths,
        uncontrolledColumns,
        controlledColumns,
        columnLayout
    ]);
    let startResize = (0, $bh6RR.useCallback)((key)=>{
        setResizingColumn(key);
    }, [
        setResizingColumn
    ]);
    let updateResizedColumns = (0, $bh6RR.useCallback)((key, width)=>{
        let newSizes = columnLayout.resizeColumnWidth(state.collection, uncontrolledWidths, key, width);
        let map = new Map(Array.from(uncontrolledColumns).map(([key])=>[
                key,
                newSizes.get(key)
            ]));
        map.set(key, width);
        setUncontrolledWidths(map);
        return newSizes;
    }, [
        uncontrolledColumns,
        setUncontrolledWidths,
        columnLayout,
        state.collection,
        uncontrolledWidths
    ]);
    let endResize = (0, $bh6RR.useCallback)(()=>{
        setResizingColumn(null);
    }, [
        setResizingColumn
    ]);
    let columnWidths = (0, $bh6RR.useMemo)(()=>columnLayout.buildColumnWidths(tableWidth, state.collection, colWidths), [
        tableWidth,
        state.collection,
        colWidths,
        columnLayout
    ]);
    return (0, $bh6RR.useMemo)(()=>({
            resizingColumn: resizingColumn,
            updateResizedColumns: updateResizedColumns,
            startResize: startResize,
            endResize: endResize,
            getColumnWidth: (key)=>columnLayout.getColumnWidth(key),
            getColumnMinWidth: (key)=>columnLayout.getColumnMinWidth(key),
            getColumnMaxWidth: (key)=>columnLayout.getColumnMaxWidth(key),
            tableState: state,
            columnWidths: columnWidths
        }), [
        columnLayout,
        columnWidths,
        resizingColumn,
        updateResizedColumns,
        startResize,
        endResize,
        state
    ]);
}

});
parcelRegister("filR9", function(module, exports) {

$parcel$export(module.exports, "TableColumnLayout", function () { return $cc486bdf77538648$export$7ff77a162970b30e; });

var $Cwu5d = parcelRequire("Cwu5d");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $cc486bdf77538648$export$7ff77a162970b30e {
    /** Takes an array of columns and splits it into 2 maps of columns with controlled and columns with uncontrolled widths. */ splitColumnsIntoControlledAndUncontrolled(columns) {
        return columns.reduce((acc, col)=>{
            if (col.props.width != null) acc[0].set(col.key, col);
            else acc[1].set(col.key, col);
            return acc;
        }, [
            new Map(),
            new Map()
        ]);
    }
    /** Takes uncontrolled and controlled widths and joins them into a single Map. */ recombineColumns(columns, uncontrolledWidths, uncontrolledColumns, controlledColumns) {
        return new Map(columns.map((col)=>{
            if (uncontrolledColumns.has(col.key)) return [
                col.key,
                uncontrolledWidths.get(col.key)
            ];
            else return [
                col.key,
                controlledColumns.get(col.key).props.width
            ];
        }));
    }
    /** Used to make an initial Map of the uncontrolled widths based on default widths. */ getInitialUncontrolledWidths(uncontrolledColumns) {
        return new Map(Array.from(uncontrolledColumns).map(([key, col])=>{
            var _this_getDefaultWidth, _this;
            var _col_props_defaultWidth, _ref;
            return [
                key,
                (_ref = (_col_props_defaultWidth = col.props.defaultWidth) !== null && _col_props_defaultWidth !== void 0 ? _col_props_defaultWidth : (_this_getDefaultWidth = (_this = this).getDefaultWidth) === null || _this_getDefaultWidth === void 0 ? void 0 : _this_getDefaultWidth.call(_this, col)) !== null && _ref !== void 0 ? _ref : '1fr'
            ];
        }));
    }
    getColumnWidth(key) {
        var _this_columnWidths_get;
        return (_this_columnWidths_get = this.columnWidths.get(key)) !== null && _this_columnWidths_get !== void 0 ? _this_columnWidths_get : 0;
    }
    getColumnMinWidth(key) {
        var _this_columnMinWidths_get;
        return (_this_columnMinWidths_get = this.columnMinWidths.get(key)) !== null && _this_columnMinWidths_get !== void 0 ? _this_columnMinWidths_get : 0;
    }
    getColumnMaxWidth(key) {
        var _this_columnMaxWidths_get;
        return (_this_columnMaxWidths_get = this.columnMaxWidths.get(key)) !== null && _this_columnMaxWidths_get !== void 0 ? _this_columnMaxWidths_get : 0;
    }
    resizeColumnWidth(collection, uncontrolledWidths, col, width) {
        let prevColumnWidths = this.columnWidths;
        let freeze = true;
        let newWidths = new Map();
        width = Math.max(this.getColumnMinWidth(col), Math.min(this.getColumnMaxWidth(col), Math.floor(width)));
        collection.columns.forEach((column)=>{
            var _prevColumnWidths_get, _column_props_width;
            if (column.key === col) {
                newWidths.set(column.key, width);
                freeze = false;
            } else if (freeze) newWidths.set(column.key, (_prevColumnWidths_get = prevColumnWidths.get(column.key)) !== null && _prevColumnWidths_get !== void 0 ? _prevColumnWidths_get : 0);
            else newWidths.set(column.key, (_column_props_width = column.props.width) !== null && _column_props_width !== void 0 ? _column_props_width : uncontrolledWidths.get(column.key));
        });
        return newWidths;
    }
    buildColumnWidths(tableWidth, collection, widths) {
        this.columnWidths = new Map();
        this.columnMinWidths = new Map();
        this.columnMaxWidths = new Map();
        // initial layout or table/window resizing
        let columnWidths = (0, $Cwu5d.calculateColumnSizes)(tableWidth, collection.columns.map((col)=>({
                ...col.props,
                key: col.key
            })), widths, (i)=>this.getDefaultWidth(collection.columns[i]), (i)=>this.getDefaultMinWidth(collection.columns[i]));
        // columns going in will be the same order as the columns coming out
        columnWidths.forEach((width, index)=>{
            let key = collection.columns[index].key;
            let column = collection.columns[index];
            this.columnWidths.set(key, width);
            var _column_props_minWidth;
            this.columnMinWidths.set(key, (0, $Cwu5d.getMinWidth)((_column_props_minWidth = column.props.minWidth) !== null && _column_props_minWidth !== void 0 ? _column_props_minWidth : this.getDefaultMinWidth(column), tableWidth));
            this.columnMaxWidths.set(key, (0, $Cwu5d.getMaxWidth)(column.props.maxWidth, tableWidth));
        });
        return this.columnWidths;
    }
    constructor(options){
        this.columnWidths = new Map();
        this.columnMinWidths = new Map();
        this.columnMaxWidths = new Map();
        var _options_getDefaultWidth;
        this.getDefaultWidth = (_options_getDefaultWidth = options === null || options === void 0 ? void 0 : options.getDefaultWidth) !== null && _options_getDefaultWidth !== void 0 ? _options_getDefaultWidth : ()=>'1fr';
        var _options_getDefaultMinWidth;
        this.getDefaultMinWidth = (_options_getDefaultMinWidth = options === null || options === void 0 ? void 0 : options.getDefaultMinWidth) !== null && _options_getDefaultMinWidth !== void 0 ? _options_getDefaultMinWidth : ()=>75;
    }
}

});
parcelRegister("Cwu5d", function(module, exports) {

$parcel$export(module.exports, "getMaxWidth", function () { return $2b52e210d18f8f55$export$59185c62a7544aa0; });
$parcel$export(module.exports, "getMinWidth", function () { return $2b52e210d18f8f55$export$f556054ce4358701; });
$parcel$export(module.exports, "calculateColumnSizes", function () { return $2b52e210d18f8f55$export$55d50dc687385491; });
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2b52e210d18f8f55$export$1994a077b98ee0d5(width) {
    return width != null && (!isNaN(width) || String(width).match(/^(\d+)(?=%$)/) !== null);
}
function $2b52e210d18f8f55$export$9078bad4c3934604(width) {
    if (!width) return 1;
    let match = width.match(/^(.+)(?=fr$)/);
    // if width is the incorrect format, just default it to a 1fr
    if (!match) {
        console.warn(`width: ${width} is not a supported format, width should be a number (ex. 150), percentage (ex. '50%') or fr unit (ex. '2fr')`, 'defaulting to \'1fr\'');
        return 1;
    }
    return parseFloat(match[0]);
}
function $2b52e210d18f8f55$export$7bbad27896f7ae9f(width, tableWidth) {
    if (typeof width === 'string') {
        let match = width.match(/^(\d+)(?=%$)/);
        if (!match) throw new Error('Only percentages or numbers are supported for static column widths');
        return tableWidth * (parseFloat(match[0]) / 100);
    }
    return width;
}
function $2b52e210d18f8f55$export$59185c62a7544aa0(maxWidth, tableWidth) {
    return maxWidth != null ? $2b52e210d18f8f55$export$7bbad27896f7ae9f(maxWidth, tableWidth) : Number.MAX_SAFE_INTEGER;
}
function $2b52e210d18f8f55$export$f556054ce4358701(minWidth, tableWidth) {
    return minWidth != null ? $2b52e210d18f8f55$export$7bbad27896f7ae9f(minWidth, tableWidth) : 0;
}
function $2b52e210d18f8f55$export$55d50dc687385491(availableWidth, columns, changedColumns, getDefaultWidth, getDefaultMinWidth) {
    let hasNonFrozenItems = false;
    let flexItems = columns.map((column, index)=>{
        var _column_width, _ref, _ref1;
        let width = changedColumns.get(column.key) != null ? changedColumns.get(column.key) : (_ref1 = (_ref = (_column_width = column.width) !== null && _column_width !== void 0 ? _column_width : column.defaultWidth) !== null && _ref !== void 0 ? _ref : getDefaultWidth === null || getDefaultWidth === void 0 ? void 0 : getDefaultWidth(index)) !== null && _ref1 !== void 0 ? _ref1 : '1fr';
        let frozen = false;
        let baseSize = 0;
        let flex = 0;
        let targetMainSize = 0;
        if ($2b52e210d18f8f55$export$1994a077b98ee0d5(width)) {
            baseSize = $2b52e210d18f8f55$export$7bbad27896f7ae9f(width, availableWidth);
            frozen = true;
        } else {
            flex = $2b52e210d18f8f55$export$9078bad4c3934604(width);
            if (flex <= 0) frozen = true;
        }
        var _column_minWidth, _ref2;
        let min = $2b52e210d18f8f55$export$f556054ce4358701((_ref2 = (_column_minWidth = column.minWidth) !== null && _column_minWidth !== void 0 ? _column_minWidth : getDefaultMinWidth === null || getDefaultMinWidth === void 0 ? void 0 : getDefaultMinWidth(index)) !== null && _ref2 !== void 0 ? _ref2 : 0, availableWidth);
        let max = $2b52e210d18f8f55$export$59185c62a7544aa0(column.maxWidth, availableWidth);
        let hypotheticalMainSize = Math.max(min, Math.min(baseSize, max));
        // 9.7.1
        // We don't make use of flex basis, it's always 0, so we are always in 'grow' mode.
        // 9.7.2
        if (frozen) targetMainSize = hypotheticalMainSize;
        else if (baseSize > hypotheticalMainSize) {
            frozen = true;
            targetMainSize = hypotheticalMainSize;
        }
        // 9.7.3
        if (!frozen) hasNonFrozenItems = true;
        return {
            frozen: frozen,
            baseSize: baseSize,
            hypotheticalMainSize: hypotheticalMainSize,
            min: min,
            max: max,
            flex: flex,
            targetMainSize: targetMainSize,
            violation: 0
        };
    });
    // 9.7.4
    // 9.7.4.a
    while(hasNonFrozenItems){
        // 9.7.4.b
        /**
     * Calculate the remaining free space as for initial free space,
     * above (9.7.3). If the sum of the unfrozen flex items’ flex factors is
     * less than one, multiply the initial free space by this sum (of flex factors).
     * If the magnitude of this value is less than the magnitude of
     * the remaining free space, use this as the remaining free space.
     */ let usedWidth = 0;
        let flexFactors = 0;
        flexItems.forEach((item)=>{
            if (item.frozen) usedWidth += item.targetMainSize;
            else {
                usedWidth += item.baseSize;
                flexFactors += item.flex;
            }
        });
        let remainingFreeSpace = availableWidth - usedWidth;
        // we only support integer FR's, and because of hasNonFrozenItems, we know that flexFactors > 0
        // so no need to check for flexFactors < 1
        // 9.7.4.c
        /**
     * If the remaining free space is zero
     * - Do nothing.
     * Else // remember, we're always in grow mode
     * - Find the ratio of the item’s flex grow factor to the
     * sum of the flex grow factors of all unfrozen items on
     * the line. Set the item’s target main size to its flex
     * base size plus a fraction of the remaining free space
     * proportional to the ratio.
     */ if (remainingFreeSpace > 0) flexItems.forEach((item)=>{
            if (!item.frozen) {
                let ratio = item.flex / flexFactors;
                item.targetMainSize = item.baseSize + ratio * remainingFreeSpace;
            }
        });
        // 9.7.4.d
        /**
     * Fix min/max violations. Clamp each non-frozen item’s
     * target main size by its used min and max main sizes
     * and floor its content-box size at zero. If the item’s
     * target main size was made smaller by this, it’s a max
     * violation. If the item’s target main size was made
     * larger by this, it’s a min violation.
     */ let totalViolation = 0;
        flexItems.forEach((item)=>{
            item.violation = 0;
            if (!item.frozen) {
                let { min: min, max: max, targetMainSize: targetMainSize } = item;
                item.targetMainSize = Math.max(min, Math.min(targetMainSize, max));
                item.violation = item.targetMainSize - targetMainSize;
                totalViolation += item.violation;
            }
        });
        // 9.7.4.e
        /**
     * Freeze over-flexed items. The total violation is the
     * sum of the adjustments from the previous step
     * ∑(clamped size - unclamped size). If the total violation is:
     * Zero
     * - Freeze all items.
     *
     * Positive
     * - Freeze all the items with min violations.
     *
     * Negative
     * - Freeze all the items with max violations.
     */ hasNonFrozenItems = false;
        flexItems.forEach((item)=>{
            if (totalViolation === 0 || Math.sign(totalViolation) === Math.sign(item.violation)) item.frozen = true;
            else if (!item.frozen) hasNonFrozenItems = true;
        });
    }
    return $2b52e210d18f8f55$var$$6818b1c4fc67028d$var$cascadeRounding(flexItems);
}
function $2b52e210d18f8f55$var$$6818b1c4fc67028d$var$cascadeRounding(flexItems) {
    /*
  Given an array of floats that sum to an integer, this rounds the floats
  and returns an array of integers with the same sum.
  */ let fpTotal = 0;
    let intTotal = 0;
    let roundedArray = [];
    flexItems.forEach(function(item) {
        let float = item.targetMainSize;
        let integer = Math.round(float + fpTotal) - intTotal;
        fpTotal += float;
        intTotal += integer;
        roundedArray.push(integer);
    });
    return roundedArray;
}

});



parcelRegister("kyRRA", function(module, exports) {

$parcel$export(module.exports, "useTableState", function () { return $9470c7a080b0d75f$export$907bcc6c48325fd6; });

var $dcsQ5 = parcelRequire("dcsQ5");

var $aBZGl = parcelRequire("aBZGl");

var $bh6RR = parcelRequire("bh6RR");

var $6ACFn = parcelRequire("6ACFn");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9470c7a080b0d75f$var$$4a0dd036d492cee4$var$OPPOSITE_SORT_DIRECTION = {
    ascending: 'descending',
    descending: 'ascending'
};
function $9470c7a080b0d75f$export$907bcc6c48325fd6(props) {
    let [isKeyboardNavigationDisabled, setKeyboardNavigationDisabled] = (0, $bh6RR.useState)(false);
    let { selectionMode: selectionMode = 'none', showSelectionCheckboxes: showSelectionCheckboxes, showDragButtons: showDragButtons } = props;
    let context = (0, $bh6RR.useMemo)(()=>({
            showSelectionCheckboxes: showSelectionCheckboxes && selectionMode !== 'none',
            showDragButtons: showDragButtons,
            selectionMode: selectionMode,
            columns: []
        }), [
        props.children,
        showSelectionCheckboxes,
        selectionMode,
        showDragButtons
    ]);
    let collection = (0, $6ACFn.useCollection)(props, (0, $bh6RR.useCallback)((nodes)=>new (0, $dcsQ5.TableCollection)(nodes, null, context), [
        context
    ]), context);
    let { disabledKeys: disabledKeys, selectionManager: selectionManager } = (0, $aBZGl.useGridState)({
        ...props,
        collection: collection,
        disabledBehavior: props.disabledBehavior || 'selection'
    });
    var _props_sortDescriptor;
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        selectionManager: selectionManager,
        showSelectionCheckboxes: props.showSelectionCheckboxes || false,
        sortDescriptor: (_props_sortDescriptor = props.sortDescriptor) !== null && _props_sortDescriptor !== void 0 ? _props_sortDescriptor : null,
        isKeyboardNavigationDisabled: collection.size === 0 || isKeyboardNavigationDisabled,
        setKeyboardNavigationDisabled: setKeyboardNavigationDisabled,
        sort (columnKey, direction) {
            var _props_sortDescriptor, _props_onSortChange;
            (_props_onSortChange = props.onSortChange) === null || _props_onSortChange === void 0 || _props_onSortChange.call(props, {
                column: columnKey,
                direction: direction !== null && direction !== void 0 ? direction : ((_props_sortDescriptor = props.sortDescriptor) === null || _props_sortDescriptor === void 0 ? void 0 : _props_sortDescriptor.column) === columnKey ? $9470c7a080b0d75f$var$$4a0dd036d492cee4$var$OPPOSITE_SORT_DIRECTION[props.sortDescriptor.direction] : 'ascending'
            });
        }
    };
}

});
parcelRegister("aBZGl", function(module, exports) {

$parcel$export(module.exports, "useGridState", function () { return $1b65910506201b05$export$4007ac09ff9c68ed; });

var $6z78f = parcelRequire("6z78f");

var $5XVcz = parcelRequire("5XVcz");
var $8K87f = parcelRequire("8K87f");

var $bh6RR = parcelRequire("bh6RR");
function $1b65910506201b05$export$4007ac09ff9c68ed(props) {
    let { collection: collection, focusMode: focusMode } = props;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let selectionState = props.UNSAFE_selectionState || (0, $8K87f.useMultipleSelectionState)(props);
    let disabledKeys = (0, $bh6RR.useMemo)(()=>props.disabledKeys ? new Set(props.disabledKeys) : new Set(), [
        props.disabledKeys
    ]);
    let setFocusedKey = selectionState.setFocusedKey;
    selectionState.setFocusedKey = (key, child)=>{
        // If focusMode is cell and an item is focused, focus a child cell instead.
        if (focusMode === 'cell' && key != null) {
            let item = collection.getItem(key);
            if ((item === null || item === void 0 ? void 0 : item.type) === 'item') {
                var _getLastItem, _getFirstItem;
                let children = (0, $6z78f.getChildNodes)(item, collection);
                var _getLastItem_key, _getFirstItem_key;
                if (child === 'last') key = (_getLastItem_key = (_getLastItem = (0, $6z78f.getLastItem)(children)) === null || _getLastItem === void 0 ? void 0 : _getLastItem.key) !== null && _getLastItem_key !== void 0 ? _getLastItem_key : null;
                else key = (_getFirstItem_key = (_getFirstItem = (0, $6z78f.getFirstItem)(children)) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key) !== null && _getFirstItem_key !== void 0 ? _getFirstItem_key : null;
            }
        }
        setFocusedKey(key, child);
    };
    let selectionManager = (0, $bh6RR.useMemo)(()=>new (0, $5XVcz.SelectionManager)(collection, selectionState), [
        collection,
        selectionState
    ]);
    // Reset focused key if that item is deleted from the collection.
    const cachedCollection = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        if (selectionState.focusedKey != null && cachedCollection.current && !collection.getItem(selectionState.focusedKey)) {
            const node = cachedCollection.current.getItem(selectionState.focusedKey);
            const parentNode = (node === null || node === void 0 ? void 0 : node.parentKey) != null && (node.type === 'cell' || node.type === 'rowheader' || node.type === 'column') ? cachedCollection.current.getItem(node.parentKey) : node;
            if (!parentNode) {
                selectionState.setFocusedKey(null);
                return;
            }
            const cachedRows = cachedCollection.current.rows;
            const rows = collection.rows;
            const diff = cachedRows.length - rows.length;
            let index = Math.min(diff > 1 ? Math.max(parentNode.index - diff + 1, 0) : parentNode.index, rows.length - 1);
            let newRow = null;
            while(index >= 0){
                if (!selectionManager.isDisabled(rows[index].key) && rows[index].type !== 'headerrow') {
                    newRow = rows[index];
                    break;
                }
                // Find next, not disabled row.
                if (index < rows.length - 1) index++;
                else {
                    if (index > parentNode.index) index = parentNode.index;
                    index--;
                }
            }
            if (newRow) {
                const childNodes = newRow.hasChildNodes ? [
                    ...(0, $6z78f.getChildNodes)(newRow, collection)
                ] : [];
                const keyToFocus = newRow.hasChildNodes && parentNode !== node && node && node.index < childNodes.length ? childNodes[node.index].key : newRow.key;
                selectionState.setFocusedKey(keyToFocus);
            } else selectionState.setFocusedKey(null);
        }
        cachedCollection.current = collection;
    }, [
        collection,
        selectionManager,
        selectionState,
        selectionState.focusedKey
    ]);
    return {
        collection: collection,
        disabledKeys: disabledKeys,
        isKeyboardNavigationDisabled: false,
        selectionManager: selectionManager
    };
}

});


parcelRegister("lGes6", function(module, exports) {

$parcel$export(module.exports, "useTable", function () { return $5fb6bbe6e09cbcd9$export$25bceaac3c7e4dc7; });

var $biOOL = parcelRequire("biOOL");

var $6L7os = parcelRequire("6L7os");

var $kc7uv = parcelRequire("kc7uv");

var $lvrF1 = parcelRequire("lvrF1");

var $bZuMw = parcelRequire("bZuMw");

var $hAxtE = parcelRequire("hAxtE");
var $eHR6B = parcelRequire("eHR6B");
var $gxMV2 = parcelRequire("gxMV2");
var $90mAp = parcelRequire("90mAp");

var $a7EiN = parcelRequire("a7EiN");

var $7caxR = parcelRequire("7caxR");
var $c8uzR = parcelRequire("c8uzR");
var $kbHlJ = parcelRequire("kbHlJ");

var $bh6RR = parcelRequire("bh6RR");
function $5fb6bbe6e09cbcd9$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5fb6bbe6e09cbcd9$export$25bceaac3c7e4dc7(props, state, ref) {
    let { keyboardDelegate: keyboardDelegate, isVirtualized: isVirtualized, layoutDelegate: layoutDelegate, layout: layout } = props;
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $7caxR.useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let { direction: direction } = (0, $c8uzR.useLocale)();
    let disabledBehavior = state.selectionManager.disabledBehavior;
    let delegate = (0, $bh6RR.useMemo)(()=>keyboardDelegate || new (0, $kc7uv.TableKeyboardDelegate)({
            collection: state.collection,
            disabledKeys: state.disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            direction: direction,
            collator: collator,
            layoutDelegate: layoutDelegate,
            layout: layout
        }), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        disabledBehavior,
        ref,
        direction,
        collator,
        layoutDelegate,
        layout
    ]);
    let id = (0, $gxMV2.useId)(props.id);
    (0, $biOOL.gridIds).set(state, id);
    let { gridProps: gridProps } = (0, $bZuMw.useGrid)({
        ...props,
        id: id,
        keyboardDelegate: delegate
    }, state, ref);
    // Override to include header rows
    if (isVirtualized) gridProps['aria-rowcount'] = state.collection.size + state.collection.headerRows.length;
    if ((0, $a7EiN.tableNestedRows)() && 'expandedKeys' in state) gridProps.role = 'treegrid';
    let { column: column, direction: sortDirection } = state.sortDescriptor || {};
    let stringFormatter = (0, $kbHlJ.useLocalizedStringFormatter)($5fb6bbe6e09cbcd9$var$$parcel$interopDefault((0, $6L7os.default)), '@react-aria/table');
    let sortDescription = (0, $bh6RR.useMemo)(()=>{
        var _state_collection_columns_find;
        var _state_collection_columns_find_textValue;
        let columnName = (_state_collection_columns_find_textValue = (_state_collection_columns_find = state.collection.columns.find((c)=>c.key === column)) === null || _state_collection_columns_find === void 0 ? void 0 : _state_collection_columns_find.textValue) !== null && _state_collection_columns_find_textValue !== void 0 ? _state_collection_columns_find_textValue : '';
        return sortDirection && column ? stringFormatter.format(`${sortDirection}Sort`, {
            columnName: columnName
        }) : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sortDirection,
        column,
        state.collection.columns
    ]);
    let descriptionProps = (0, $eHR6B.useDescription)(sortDescription);
    (0, $90mAp.useUpdateEffect)(()=>{
        if (sortDescription) (0, $lvrF1.announce)(sortDescription, 'assertive', 500);
    }, [
        sortDescription
    ]);
    return {
        gridProps: (0, $hAxtE.mergeProps)(gridProps, descriptionProps, {
            // merge sort description with long press information
            'aria-describedby': [
                descriptionProps['aria-describedby'],
                gridProps['aria-describedby']
            ].filter(Boolean).join(' ')
        })
    };
}

});
parcelRegister("biOOL", function(module, exports) {

$parcel$export(module.exports, "gridIds", function () { return $c78900543955e79d$export$552312adfd451dab; });
$parcel$export(module.exports, "getColumnHeaderId", function () { return $c78900543955e79d$export$37cd4213f2ad742e; });
$parcel$export(module.exports, "getCellId", function () { return $c78900543955e79d$export$19baff3266315d44; });
$parcel$export(module.exports, "getRowLabelledBy", function () { return $c78900543955e79d$export$85069b70317f543; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $c78900543955e79d$export$552312adfd451dab = new WeakMap();
function $c78900543955e79d$var$$2140fb2337097f2d$var$normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}
function $c78900543955e79d$export$37cd4213f2ad742e(state, columnKey) {
    let gridId = $c78900543955e79d$export$552312adfd451dab.get(state);
    if (!gridId) throw new Error('Unknown grid');
    return `${gridId}-${$c78900543955e79d$var$$2140fb2337097f2d$var$normalizeKey(columnKey)}`;
}
function $c78900543955e79d$export$19baff3266315d44(state, rowKey, columnKey) {
    let gridId = $c78900543955e79d$export$552312adfd451dab.get(state);
    if (!gridId) throw new Error('Unknown grid');
    return `${gridId}-${$c78900543955e79d$var$$2140fb2337097f2d$var$normalizeKey(rowKey)}-${$c78900543955e79d$var$$2140fb2337097f2d$var$normalizeKey(columnKey)}`;
}
function $c78900543955e79d$export$85069b70317f543(state, rowKey) {
    // A row is labelled by it's row headers.
    return [
        ...state.collection.rowHeaderColumnKeys
    ].map((columnKey)=>$c78900543955e79d$export$19baff3266315d44(state, rowKey, columnKey)).join(' ');
}

});

parcelRegister("6L7os", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2898ceb95daab18e$export$2e2bcd8739ae039; });

var $fsivt = parcelRequire("fsivt");

var $7kl3H = parcelRequire("7kl3H");

var $gjk93 = parcelRequire("gjk93");

var $lIn9Z = parcelRequire("lIn9Z");

var $6lX8B = parcelRequire("6lX8B");

var $3fwLp = parcelRequire("3fwLp");

var $iPOmr = parcelRequire("iPOmr");

var $boGP8 = parcelRequire("boGP8");

var $k62Ka = parcelRequire("k62Ka");

var $cntjO = parcelRequire("cntjO");

var $7vSVt = parcelRequire("7vSVt");

var $bIctJ = parcelRequire("bIctJ");

var $irTd2 = parcelRequire("irTd2");

var $2jOGA = parcelRequire("2jOGA");

var $8Zpwr = parcelRequire("8Zpwr");

var $frQwV = parcelRequire("frQwV");

var $lIwm2 = parcelRequire("lIwm2");

var $01gJt = parcelRequire("01gJt");

var $fBLUM = parcelRequire("fBLUM");

var $1e5sc = parcelRequire("1e5sc");

var $1Uy8e = parcelRequire("1Uy8e");

var $i7etv = parcelRequire("i7etv");

var $52stG = parcelRequire("52stG");

var $f1Ktr = parcelRequire("f1Ktr");

var $jw5T5 = parcelRequire("jw5T5");

var $dxTax = parcelRequire("dxTax");

var $kVoSx = parcelRequire("kVoSx");

var $aeQRR = parcelRequire("aeQRR");

var $7MpzK = parcelRequire("7MpzK");

var $4cIJG = parcelRequire("4cIJG");

var $7xztq = parcelRequire("7xztq");

var $bSRtZ = parcelRequire("bSRtZ");

var $1Yilj = parcelRequire("1Yilj");

var $fFjG7 = parcelRequire("fFjG7");
var $2898ceb95daab18e$export$2e2bcd8739ae039 = {};
$2898ceb95daab18e$export$2e2bcd8739ae039 = {
    "ar-AE": (0, $fsivt.default),
    "bg-BG": (0, $7kl3H.default),
    "cs-CZ": (0, $gjk93.default),
    "da-DK": (0, $lIn9Z.default),
    "de-DE": (0, $6lX8B.default),
    "el-GR": (0, $3fwLp.default),
    "en-US": (0, $iPOmr.default),
    "es-ES": (0, $boGP8.default),
    "et-EE": (0, $k62Ka.default),
    "fi-FI": (0, $cntjO.default),
    "fr-FR": (0, $7vSVt.default),
    "he-IL": (0, $bIctJ.default),
    "hr-HR": (0, $irTd2.default),
    "hu-HU": (0, $2jOGA.default),
    "it-IT": (0, $8Zpwr.default),
    "ja-JP": (0, $frQwV.default),
    "ko-KR": (0, $lIwm2.default),
    "lt-LT": (0, $01gJt.default),
    "lv-LV": (0, $fBLUM.default),
    "nb-NO": (0, $1e5sc.default),
    "nl-NL": (0, $1Uy8e.default),
    "pl-PL": (0, $i7etv.default),
    "pt-BR": (0, $52stG.default),
    "pt-PT": (0, $f1Ktr.default),
    "ro-RO": (0, $jw5T5.default),
    "ru-RU": (0, $dxTax.default),
    "sk-SK": (0, $kVoSx.default),
    "sl-SI": (0, $aeQRR.default),
    "sr-SP": (0, $7MpzK.default),
    "sv-SE": (0, $4cIJG.default),
    "tr-TR": (0, $7xztq.default),
    "uk-UA": (0, $bSRtZ.default),
    "zh-CN": (0, $1Yilj.default),
    "zh-TW": (0, $fFjG7.default)
};

});
parcelRegister("fsivt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e47d10571717b8b7$export$2e2bcd8739ae039; });
var $e47d10571717b8b7$export$2e2bcd8739ae039 = {};
$e47d10571717b8b7$export$2e2bcd8739ae039 = {
    "ascending": `\u{62A}\u{635}\u{627}\u{639}\u{62F}\u{64A}`,
    "ascendingSort": (args)=>`\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{639}\u{645}\u{648}\u{62F} ${args.columnName} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{635}\u{627}\u{639}\u{62F}\u{64A}`,
    "columnSize": (args)=>`${args.value} \u{628}\u{627}\u{644}\u{628}\u{643}\u{633}\u{644}`,
    "descending": `\u{62A}\u{646}\u{627}\u{632}\u{644}\u{64A}`,
    "descendingSort": (args)=>`\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{639}\u{645}\u{648}\u{62F} ${args.columnName} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{646}\u{627}\u{632}\u{644}\u{64A}`,
    "resizerDescription": `\u{627}\u{636}\u{63A}\u{637} \u{639}\u{644}\u{649} \u{645}\u{641}\u{62A}\u{627}\u{62D} Enter \u{644}\u{628}\u{62F}\u{621} \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{627}\u{644}\u{62D}\u{62C}\u{645}`,
    "select": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}`,
    "selectAll": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{627}\u{644}\u{643}\u{644}`,
    "sortable": `\u{639}\u{645}\u{648}\u{62F} \u{642}\u{627}\u{628}\u{644} \u{644}\u{644}\u{62A}\u{631}\u{62A}\u{64A}\u{628}`
};

});

parcelRegister("7kl3H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $051ce1fc3427330b$export$2e2bcd8739ae039; });
var $051ce1fc3427330b$export$2e2bcd8739ae039 = {};
$051ce1fc3427330b$export$2e2bcd8739ae039 = {
    "ascending": `\u{432}\u{44A}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}`,
    "ascendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{43E} \u{43F}\u{43E} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430} ${args.columnName} \u{432}\u{44A}\u{432} \u{432}\u{44A}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449} \u{440}\u{435}\u{434}`,
    "columnSize": (args)=>`${args.value} \u{43F}\u{438}\u{43A}\u{441}\u{435}\u{43B}\u{430}`,
    "descending": `\u{43D}\u{438}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}`,
    "descendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{43E} \u{43F}\u{43E} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430} ${args.columnName} \u{432} \u{43D}\u{438}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449} \u{440}\u{435}\u{434}`,
    "resizerDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{201E}Enter\u{201C}, \u{437}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{434}\u{430} \u{43F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{44F}\u{432}\u{430}\u{442}\u{435}`,
    "select": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435}`,
    "selectAll": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435} \u{432}\u{441}\u{438}\u{447}\u{43A}\u{43E}`,
    "sortable": `\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{449}\u{430} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430}`
};

});

parcelRegister("gjk93", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b1154cba7a23d36$export$2e2bcd8739ae039; });
var $0b1154cba7a23d36$export$2e2bcd8739ae039 = {};
$0b1154cba7a23d36$export$2e2bcd8739ae039 = {
    "ascending": `vzestupn\u{11B}`,
    "ascendingSort": (args)=>`\u{159}azeno vzestupn\u{11B} podle sloupce ${args.columnName}`,
    "columnSize": (args)=>`${args.value} pixel\u{16F}`,
    "descending": `sestupn\u{11B}`,
    "descendingSort": (args)=>`\u{159}azeno sestupn\u{11B} podle sloupce ${args.columnName}`,
    "resizerDescription": `Stisknut\xedm kl\xe1vesy Enter za\u{10D}nete m\u{11B}nit velikost`,
    "select": `Vybrat`,
    "selectAll": `Vybrat v\u{161}e`,
    "sortable": `sloupec s mo\u{17E}nost\xed \u{159}azen\xed`
};

});

parcelRegister("lIn9Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7e6b7d373164e1d$export$2e2bcd8739ae039; });
var $f7e6b7d373164e1d$export$2e2bcd8739ae039 = {};
$f7e6b7d373164e1d$export$2e2bcd8739ae039 = {
    "ascending": `stigende`,
    "ascendingSort": (args)=>`sorteret efter kolonne ${args.columnName} i stigende r\xe6kkef\xf8lge`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `faldende`,
    "descendingSort": (args)=>`sorteret efter kolonne ${args.columnName} i faldende r\xe6kkef\xf8lge`,
    "resizerDescription": `Tryk p\xe5 Enter for at \xe6ndre st\xf8rrelse`,
    "select": `V\xe6lg`,
    "selectAll": `V\xe6lg alle`,
    "sortable": `sorterbar kolonne`
};

});

parcelRegister("6lX8B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5256cb13d2cbd947$export$2e2bcd8739ae039; });
var $5256cb13d2cbd947$export$2e2bcd8739ae039 = {};
$5256cb13d2cbd947$export$2e2bcd8739ae039 = {
    "ascending": `aufsteigend`,
    "ascendingSort": (args)=>`sortiert nach Spalte ${args.columnName} in aufsteigender Reihenfolge`,
    "columnSize": (args)=>`${args.value} Pixel`,
    "descending": `absteigend`,
    "descendingSort": (args)=>`sortiert nach Spalte ${args.columnName} in absteigender Reihenfolge`,
    "resizerDescription": `Eingabetaste zum Starten der Gr\xf6\xdfen\xe4nderung dr\xfccken`,
    "select": `Ausw\xe4hlen`,
    "selectAll": `Alles ausw\xe4hlen`,
    "sortable": `sortierbare Spalte`
};

});

parcelRegister("3fwLp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c59c0176c485059f$export$2e2bcd8739ae039; });
var $c59c0176c485059f$export$2e2bcd8739ae039 = {};
$c59c0176c485059f$export$2e2bcd8739ae039 = {
    "ascending": `\u{3B1}\u{3CD}\u{3BE}\u{3BF}\u{3C5}\u{3C3}\u{3B1}`,
    "ascendingSort": (args)=>`\u{3B4}\u{3B9}\u{3B1}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3B1}\u{3BD}\u{3AC} \u{3C3}\u{3C4}\u{3AE}\u{3BB}\u{3B7} ${args.columnName} \u{3C3}\u{3B5} \u{3B1}\u{3CD}\u{3BE}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "columnSize": (args)=>`${args.value} pixel`,
    "descending": `\u{3C6}\u{3B8}\u{3AF}\u{3BD}\u{3BF}\u{3C5}\u{3C3}\u{3B1}`,
    "descendingSort": (args)=>`\u{3B4}\u{3B9}\u{3B1}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3B1}\u{3BD}\u{3AC} \u{3C3}\u{3C4}\u{3AE}\u{3BB}\u{3B7} ${args.columnName} \u{3C3}\u{3B5} \u{3C6}\u{3B8}\u{3AF}\u{3BD}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "resizerDescription": `\u{3A0}\u{3B1}\u{3C4}\u{3AE}\u{3C3}\u{3C4}\u{3B5} Enter \u{3B3}\u{3B9}\u{3B1} \u{3AD}\u{3BD}\u{3B1}\u{3C1}\u{3BE}\u{3B7} \u{3C4}\u{3B7}\u{3C2} \u{3B1}\u{3BB}\u{3BB}\u{3B1}\u{3B3}\u{3AE}\u{3C2} \u{3BC}\u{3B5}\u{3B3}\u{3AD}\u{3B8}\u{3BF}\u{3C5}\u{3C2}`,
    "select": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}`,
    "selectAll": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE} \u{3CC}\u{3BB}\u{3C9}\u{3BD}`,
    "sortable": `\u{3A3}\u{3C4}\u{3AE}\u{3BB}\u{3B7} \u{3B4}\u{3B9}\u{3B1}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{3C2}`
};

});

parcelRegister("iPOmr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a01727d0e66ff60$export$2e2bcd8739ae039; });
var $4a01727d0e66ff60$export$2e2bcd8739ae039 = {};
$4a01727d0e66ff60$export$2e2bcd8739ae039 = {
    "select": `Select`,
    "selectAll": `Select All`,
    "sortable": `sortable column`,
    "ascending": `ascending`,
    "descending": `descending`,
    "ascendingSort": (args)=>`sorted by column ${args.columnName} in ascending order`,
    "descendingSort": (args)=>`sorted by column ${args.columnName} in descending order`,
    "columnSize": (args)=>`${args.value} pixels`,
    "resizerDescription": `Press Enter to start resizing`
};

});

parcelRegister("boGP8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b255070c5b973afe$export$2e2bcd8739ae039; });
var $b255070c5b973afe$export$2e2bcd8739ae039 = {};
$b255070c5b973afe$export$2e2bcd8739ae039 = {
    "ascending": `de subida`,
    "ascendingSort": (args)=>`ordenado por columna ${args.columnName} en orden de subida`,
    "columnSize": (args)=>`${args.value} p\xedxeles`,
    "descending": `de bajada`,
    "descendingSort": (args)=>`ordenado por columna ${args.columnName} en orden de bajada`,
    "resizerDescription": `Pulse Intro para empezar a redimensionar`,
    "select": `Seleccionar`,
    "selectAll": `Seleccionar todos`,
    "sortable": `columna ordenable`
};

});

parcelRegister("k62Ka", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ca8e0eb9b782149$export$2e2bcd8739ae039; });
var $1ca8e0eb9b782149$export$2e2bcd8739ae039 = {};
$1ca8e0eb9b782149$export$2e2bcd8739ae039 = {
    "ascending": `t\xf5usev j\xe4rjestus`,
    "ascendingSort": (args)=>`sorditud veeru j\xe4rgi ${args.columnName} t\xf5usvas j\xe4rjestuses`,
    "columnSize": (args)=>`${args.value} pikslit`,
    "descending": `laskuv j\xe4rjestus`,
    "descendingSort": (args)=>`sorditud veeru j\xe4rgi ${args.columnName} laskuvas j\xe4rjestuses`,
    "resizerDescription": `Suuruse muutmise alustamiseks vajutage klahvi Enter`,
    "select": `Vali`,
    "selectAll": `Vali k\xf5ik`,
    "sortable": `sorditav veerg`
};

});

parcelRegister("cntjO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d733372973c84b$export$2e2bcd8739ae039; });
var $34d733372973c84b$export$2e2bcd8739ae039 = {};
$34d733372973c84b$export$2e2bcd8739ae039 = {
    "ascending": `nouseva`,
    "ascendingSort": (args)=>`lajiteltu sarakkeen ${args.columnName} mukaan nousevassa j\xe4rjestyksess\xe4`,
    "columnSize": (args)=>`${args.value} pikseli\xe4`,
    "descending": `laskeva`,
    "descendingSort": (args)=>`lajiteltu sarakkeen ${args.columnName} mukaan laskevassa j\xe4rjestyksess\xe4`,
    "resizerDescription": `Aloita koon muutos painamalla Enter-n\xe4pp\xe4int\xe4`,
    "select": `Valitse`,
    "selectAll": `Valitse kaikki`,
    "sortable": `lajiteltava sarake`
};

});

parcelRegister("7vSVt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e52e47fedf81a1c$export$2e2bcd8739ae039; });
var $9e52e47fedf81a1c$export$2e2bcd8739ae039 = {};
$9e52e47fedf81a1c$export$2e2bcd8739ae039 = {
    "ascending": `croissant`,
    "ascendingSort": (args)=>`tri\xe9 en fonction de la colonne\xa0${args.columnName} par ordre croissant`,
    "columnSize": (args)=>`${args.value}\xa0pixels`,
    "descending": `d\xe9croissant`,
    "descendingSort": (args)=>`tri\xe9 en fonction de la colonne\xa0${args.columnName} par ordre d\xe9croissant`,
    "resizerDescription": `Appuyez sur Entr\xe9e pour commencer le redimensionnement.`,
    "select": `S\xe9lectionner`,
    "selectAll": `S\xe9lectionner tout`,
    "sortable": `colonne triable`
};

});

parcelRegister("bIctJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59fcbe7f7725b002$export$2e2bcd8739ae039; });
var $59fcbe7f7725b002$export$2e2bcd8739ae039 = {};
$59fcbe7f7725b002$export$2e2bcd8739ae039 = {
    "ascending": `\u{5E2}\u{5D5}\u{5DC}\u{5D4}`,
    "ascendingSort": (args)=>`\u{5DE}\u{5D5}\u{5D9}\u{5DF} \u{5DC}\u{5E4}\u{5D9} \u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4} ${args.columnName} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5E2}\u{5D5}\u{5DC}\u{5D4}`,
    "columnSize": (args)=>`${args.value} \u{5E4}\u{5D9}\u{5E7}\u{5E1}\u{5DC}\u{5D9}\u{5DD}`,
    "descending": `\u{5D9}\u{5D5}\u{5E8}\u{5D3}`,
    "descendingSort": (args)=>`\u{5DE}\u{5D5}\u{5D9}\u{5DF} \u{5DC}\u{5E4}\u{5D9} \u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4} ${args.columnName} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5D9}\u{5D5}\u{5E8}\u{5D3}`,
    "resizerDescription": `\u{5D4}\u{5E7}\u{5E9} Enter \u{5DB}\u{5D3}\u{5D9} \u{5DC}\u{5E9}\u{5E0}\u{5D5}\u{5EA} \u{5D0}\u{5EA} \u{5D4}\u{5D2}\u{5D5}\u{5D3}\u{5DC}`,
    "select": `\u{5D1}\u{5D7}\u{5E8}`,
    "selectAll": `\u{5D1}\u{5D7}\u{5E8} \u{5D4}\u{5DB}\u{5D5}\u{5DC}`,
    "sortable": `\u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4} \u{5E9}\u{5E0}\u{5D9}\u{5EA}\u{5DF} \u{5DC}\u{5DE}\u{5D9}\u{5D9}\u{5DF}`
};

});

parcelRegister("irTd2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4de32d687a74fccd$export$2e2bcd8739ae039; });
var $4de32d687a74fccd$export$2e2bcd8739ae039 = {};
$4de32d687a74fccd$export$2e2bcd8739ae039 = {
    "ascending": `rastu\u{107}i`,
    "ascendingSort": (args)=>`razvrstano po stupcima ${args.columnName} rastu\u{107}em redoslijedom`,
    "columnSize": (args)=>`${args.value} piksela`,
    "descending": `padaju\u{107}i`,
    "descendingSort": (args)=>`razvrstano po stupcima ${args.columnName} padaju\u{107}im redoslijedom`,
    "resizerDescription": `Pritisnite Enter da biste zapo\u{10D}eli promenu veli\u{10D}ine`,
    "select": `Odaberite`,
    "selectAll": `Odaberite sve`,
    "sortable": `stupac koji se mo\u{17E}e razvrstati`
};

});

parcelRegister("2jOGA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13f3841a34504ed9$export$2e2bcd8739ae039; });
var $13f3841a34504ed9$export$2e2bcd8739ae039 = {};
$13f3841a34504ed9$export$2e2bcd8739ae039 = {
    "ascending": `n\xf6vekv\u{151}`,
    "ascendingSort": (args)=>`rendezve a(z) ${args.columnName} oszlop szerint, n\xf6vekv\u{151} sorrendben`,
    "columnSize": (args)=>`${args.value} k\xe9ppont`,
    "descending": `cs\xf6kken\u{151}`,
    "descendingSort": (args)=>`rendezve a(z) ${args.columnName} oszlop szerint, cs\xf6kken\u{151} sorrendben`,
    "resizerDescription": `Nyomja le az Enter billenty\u{171}t az \xe1tm\xe9retez\xe9s megkezd\xe9s\xe9hez`,
    "select": `Kijel\xf6l\xe9s`,
    "selectAll": `\xd6sszes kijel\xf6l\xe9se`,
    "sortable": `rendezend\u{151} oszlop`
};

});

parcelRegister("8Zpwr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fe7175107ba4cc2$export$2e2bcd8739ae039; });
var $2fe7175107ba4cc2$export$2e2bcd8739ae039 = {};
$2fe7175107ba4cc2$export$2e2bcd8739ae039 = {
    "ascending": `crescente`,
    "ascendingSort": (args)=>`in ordine crescente in base alla colonna ${args.columnName}`,
    "columnSize": (args)=>`${args.value} pixel`,
    "descending": `decrescente`,
    "descendingSort": (args)=>`in ordine decrescente in base alla colonna ${args.columnName}`,
    "resizerDescription": `Premi Invio per iniziare a ridimensionare`,
    "select": `Seleziona`,
    "selectAll": `Seleziona tutto`,
    "sortable": `colonna ordinabile`
};

});

parcelRegister("frQwV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29dbcb123d3113db$export$2e2bcd8739ae039; });
var $29dbcb123d3113db$export$2e2bcd8739ae039 = {};
$29dbcb123d3113db$export$2e2bcd8739ae039 = {
    "ascending": `\u{6607}\u{9806}`,
    "ascendingSort": (args)=>`\u{5217} ${args.columnName} \u{3092}\u{6607}\u{9806}\u{3067}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "columnSize": (args)=>`${args.value} \u{30D4}\u{30AF}\u{30BB}\u{30EB}`,
    "descending": `\u{964D}\u{9806}`,
    "descendingSort": (args)=>`\u{5217} ${args.columnName} \u{3092}\u{964D}\u{9806}\u{3067}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "resizerDescription": `Enter \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{3066}\u{30B5}\u{30A4}\u{30BA}\u{5909}\u{66F4}\u{3092}\u{958B}\u{59CB}`,
    "select": `\u{9078}\u{629E}`,
    "selectAll": `\u{3059}\u{3079}\u{3066}\u{9078}\u{629E}`,
    "sortable": `\u{4E26}\u{3079}\u{66FF}\u{3048}\u{53EF}\u{80FD}\u{306A}\u{5217}`
};

});

parcelRegister("lIwm2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5878351973add6e$export$2e2bcd8739ae039; });
var $a5878351973add6e$export$2e2bcd8739ae039 = {};
$a5878351973add6e$export$2e2bcd8739ae039 = {
    "ascending": `\u{C624}\u{B984}\u{CC28}\u{C21C}`,
    "ascendingSort": (args)=>`${args.columnName} \u{C5F4}\u{C744} \u{AE30}\u{C900}\u{C73C}\u{B85C} \u{C624}\u{B984}\u{CC28}\u{C21C}\u{C73C}\u{B85C} \u{C815}\u{B82C}\u{B428}`,
    "columnSize": (args)=>`${args.value} \u{D53D}\u{C140}`,
    "descending": `\u{B0B4}\u{B9BC}\u{CC28}\u{C21C}`,
    "descendingSort": (args)=>`${args.columnName} \u{C5F4}\u{C744} \u{AE30}\u{C900}\u{C73C}\u{B85C} \u{B0B4}\u{B9BC}\u{CC28}\u{C21C}\u{C73C}\u{B85C} \u{C815}\u{B82C}\u{B428}`,
    "resizerDescription": `\u{D06C}\u{AE30} \u{C870}\u{C815}\u{C744} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} Enter\u{B97C} \u{B204}\u{B974}\u{C138}\u{C694}.`,
    "select": `\u{C120}\u{D0DD}`,
    "selectAll": `\u{BAA8}\u{B450} \u{C120}\u{D0DD}`,
    "sortable": `\u{C815}\u{B82C} \u{AC00}\u{B2A5}\u{D55C} \u{C5F4}`
};

});

parcelRegister("01gJt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cd3f82bb2312f32$export$2e2bcd8739ae039; });
var $0cd3f82bb2312f32$export$2e2bcd8739ae039 = {};
$0cd3f82bb2312f32$export$2e2bcd8739ae039 = {
    "ascending": `did\u{117}jan\u{10D}ia tvarka`,
    "ascendingSort": (args)=>`surikiuota pagal stulpel\u{12F} ${args.columnName} did\u{117}jan\u{10D}ia tvarka`,
    "columnSize": (args)=>`${args.value} piks.`,
    "descending": `ma\u{17E}\u{117}jan\u{10D}ia tvarka`,
    "descendingSort": (args)=>`surikiuota pagal stulpel\u{12F} ${args.columnName} ma\u{17E}\u{117}jan\u{10D}ia tvarka`,
    "resizerDescription": `Paspauskite \u{201E}Enter\u{201C}, kad prad\u{117}tum\u{117}te keisti dyd\u{12F}`,
    "select": `Pasirinkti`,
    "selectAll": `Pasirinkti visk\u{105}`,
    "sortable": `rikiuojamas stulpelis`
};

});

parcelRegister("fBLUM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4831c5ace80cd346$export$2e2bcd8739ae039; });
var $4831c5ace80cd346$export$2e2bcd8739ae039 = {};
$4831c5ace80cd346$export$2e2bcd8739ae039 = {
    "ascending": `augo\u{161}\u{101} sec\u{12B}b\u{101}`,
    "ascendingSort": (args)=>`k\u{101}rtots p\u{113}c kolonnas ${args.columnName} augo\u{161}\u{101} sec\u{12B}b\u{101}`,
    "columnSize": (args)=>`${args.value} pikse\u{13C}i`,
    "descending": `dilsto\u{161}\u{101} sec\u{12B}b\u{101}`,
    "descendingSort": (args)=>`k\u{101}rtots p\u{113}c kolonnas ${args.columnName} dilsto\u{161}\u{101} sec\u{12B}b\u{101}`,
    "resizerDescription": `Nospiediet Enter, lai s\u{101}ktu izm\u{113}ru main\u{12B}\u{161}anu`,
    "select": `Atlas\u{12B}t`,
    "selectAll": `Atlas\u{12B}t visu`,
    "sortable": `k\u{101}rtojam\u{101} kolonna`
};

});

parcelRegister("1e5sc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07ed99aa586d3275$export$2e2bcd8739ae039; });
var $07ed99aa586d3275$export$2e2bcd8739ae039 = {};
$07ed99aa586d3275$export$2e2bcd8739ae039 = {
    "ascending": `stigende`,
    "ascendingSort": (args)=>`sortert etter kolonne ${args.columnName} i stigende rekkef\xf8lge`,
    "columnSize": (args)=>`${args.value} piksler`,
    "descending": `synkende`,
    "descendingSort": (args)=>`sortert etter kolonne ${args.columnName} i synkende rekkef\xf8lge`,
    "resizerDescription": `Trykk p\xe5 Enter for \xe5 starte st\xf8rrelsesendring`,
    "select": `Velg`,
    "selectAll": `Velg alle`,
    "sortable": `kolonne som kan sorteres`
};

});

parcelRegister("1Uy8e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ccb6ad1c674a97e$export$2e2bcd8739ae039; });
var $6ccb6ad1c674a97e$export$2e2bcd8739ae039 = {};
$6ccb6ad1c674a97e$export$2e2bcd8739ae039 = {
    "ascending": `oplopend`,
    "ascendingSort": (args)=>`gesorteerd in oplopende volgorde in kolom ${args.columnName}`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `aflopend`,
    "descendingSort": (args)=>`gesorteerd in aflopende volgorde in kolom ${args.columnName}`,
    "resizerDescription": `Druk op Enter om het formaat te wijzigen`,
    "select": `Selecteren`,
    "selectAll": `Alles selecteren`,
    "sortable": `sorteerbare kolom`
};

});

parcelRegister("i7etv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c0e702b60344550$export$2e2bcd8739ae039; });
var $8c0e702b60344550$export$2e2bcd8739ae039 = {};
$8c0e702b60344550$export$2e2bcd8739ae039 = {
    "ascending": `rosn\u{105}co`,
    "ascendingSort": (args)=>`posortowano wed\u{142}ug kolumny ${args.columnName} w porz\u{105}dku rosn\u{105}cym`,
    "columnSize": (args)=>`Liczba pikseli: ${args.value}`,
    "descending": `malej\u{105}co`,
    "descendingSort": (args)=>`posortowano wed\u{142}ug kolumny ${args.columnName} w porz\u{105}dku malej\u{105}cym`,
    "resizerDescription": `Naci\u{15B}nij Enter, aby rozpocz\u{105}\u{107} zmienianie rozmiaru`,
    "select": `Zaznacz`,
    "selectAll": `Zaznacz wszystko`,
    "sortable": `kolumna z mo\u{17C}liwo\u{15B}ci\u{105} sortowania`
};

});

parcelRegister("52stG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a91b07a1adb59af$export$2e2bcd8739ae039; });
var $2a91b07a1adb59af$export$2e2bcd8739ae039 = {};
$2a91b07a1adb59af$export$2e2bcd8739ae039 = {
    "ascending": `crescente`,
    "ascendingSort": (args)=>`classificado pela coluna ${args.columnName} em ordem crescente`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `decrescente`,
    "descendingSort": (args)=>`classificado pela coluna ${args.columnName} em ordem decrescente`,
    "resizerDescription": `Pressione Enter para come\xe7ar a redimensionar`,
    "select": `Selecionar`,
    "selectAll": `Selecionar tudo`,
    "sortable": `coluna classific\xe1vel`
};

});

parcelRegister("f1Ktr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeaf3af5ad7da2dd$export$2e2bcd8739ae039; });
var $eeaf3af5ad7da2dd$export$2e2bcd8739ae039 = {};
$eeaf3af5ad7da2dd$export$2e2bcd8739ae039 = {
    "ascending": `ascendente`,
    "ascendingSort": (args)=>`Ordenar por coluna ${args.columnName} em ordem ascendente`,
    "columnSize": (args)=>`${args.value} pixels`,
    "descending": `descendente`,
    "descendingSort": (args)=>`Ordenar por coluna ${args.columnName} em ordem descendente`,
    "resizerDescription": `Prima Enter para iniciar o redimensionamento`,
    "select": `Selecionar`,
    "selectAll": `Selecionar tudo`,
    "sortable": `Coluna orden\xe1vel`
};

});

parcelRegister("jw5T5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12f3c78f48ca14ed$export$2e2bcd8739ae039; });
var $12f3c78f48ca14ed$export$2e2bcd8739ae039 = {};
$12f3c78f48ca14ed$export$2e2bcd8739ae039 = {
    "ascending": `cresc\u{103}toare`,
    "ascendingSort": (args)=>`sortate dup\u{103} coloana ${args.columnName} \xeen ordine cresc\u{103}toare`,
    "columnSize": (args)=>`${args.value} pixeli`,
    "descending": `descresc\u{103}toare`,
    "descendingSort": (args)=>`sortate dup\u{103} coloana ${args.columnName} \xeen ordine descresc\u{103}toare`,
    "resizerDescription": `Ap\u{103}sa\u{21B}i pe Enter pentru a \xeencepe redimensionarea`,
    "select": `Selectare`,
    "selectAll": `Selectare total\u{103}`,
    "sortable": `coloan\u{103} sortabil\u{103}`
};

});

parcelRegister("dxTax", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4d5c82574d6761b$export$2e2bcd8739ae039; });
var $b4d5c82574d6761b$export$2e2bcd8739ae039 = {};
$b4d5c82574d6761b$export$2e2bcd8739ae039 = {
    "ascending": `\u{432}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}\u{430}\u{43D}\u{438}\u{435}`,
    "ascendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{435}\u{446} ${args.columnName} \u{432} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{435} \u{432}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}\u{430}\u{43D}\u{438}\u{44F}`,
    "columnSize": (args)=>`${args.value} \u{43F}\u{438}\u{43A}\u{441}.`,
    "descending": `\u{443}\u{431}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    "descendingSort": (args)=>`\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{435}\u{446} ${args.columnName} \u{432} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{435} \u{443}\u{431}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{44F}`,
    "resizerDescription": `\u{41D}\u{430}\u{436}\u{43C}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{430}\u{432}\u{438}\u{448}\u{443} Enter \u{434}\u{43B}\u{44F} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{43E}\u{432}`,
    "select": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}`,
    "selectAll": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} \u{432}\u{441}\u{435}`,
    "sortable": `\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{443}\u{435}\u{43C}\u{44B}\u{439} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{435}\u{446}`
};

});

parcelRegister("kVoSx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec5346533f8b58ee$export$2e2bcd8739ae039; });
var $ec5346533f8b58ee$export$2e2bcd8739ae039 = {};
$ec5346533f8b58ee$export$2e2bcd8739ae039 = {
    "ascending": `vzostupne`,
    "ascendingSort": (args)=>`zoraden\xe9 zostupne pod\u{13E}a st\u{13A}pca ${args.columnName}`,
    "columnSize": (args)=>`Po\u{10D}et pixelov: ${args.value}`,
    "descending": `zostupne`,
    "descendingSort": (args)=>`zoraden\xe9 zostupne pod\u{13E}a st\u{13A}pca ${args.columnName}`,
    "resizerDescription": `Stla\u{10D}en\xedm kl\xe1vesu Enter za\u{10D}nete zmenu ve\u{13E}kosti`,
    "select": `Vybra\u{165}`,
    "selectAll": `Vybra\u{165} v\u{161}etko`,
    "sortable": `zoradite\u{13E}n\xfd st\u{13A}pec`
};

});

parcelRegister("aeQRR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89d0cb50ac9b3f33$export$2e2bcd8739ae039; });
var $89d0cb50ac9b3f33$export$2e2bcd8739ae039 = {};
$89d0cb50ac9b3f33$export$2e2bcd8739ae039 = {
    "ascending": `nara\u{161}\u{10D}ajo\u{10D}e`,
    "ascendingSort": (args)=>`razvr\u{161}\u{10D}eno po stolpcu ${args.columnName} v nara\u{161}\u{10D}ajo\u{10D}em vrstnem redu`,
    "columnSize": (args)=>`${args.value} slikovnih pik`,
    "descending": `padajo\u{10D}e`,
    "descendingSort": (args)=>`razvr\u{161}\u{10D}eno po stolpcu ${args.columnName} v padajo\u{10D}em vrstnem redu`,
    "resizerDescription": `Pritisnite tipko Enter da za\u{10D}nete spreminjati velikost`,
    "select": `Izberite`,
    "selectAll": `Izberite vse`,
    "sortable": `razvrstljivi stolpec`
};

});

parcelRegister("7MpzK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cce1ee5cfb6d8a1$export$2e2bcd8739ae039; });
var $7cce1ee5cfb6d8a1$export$2e2bcd8739ae039 = {};
$7cce1ee5cfb6d8a1$export$2e2bcd8739ae039 = {
    "ascending": `rastu\u{107}i`,
    "ascendingSort": (args)=>`sortirano po kolonama ${args.columnName} rastu\u{107}im redosledom`,
    "columnSize": (args)=>`${args.value} piksela`,
    "descending": `padaju\u{107}i`,
    "descendingSort": (args)=>`sortirano po kolonama ${args.columnName} padaju\u{107}im redosledom`,
    "resizerDescription": `Pritisnite Enter da biste zapo\u{10D}eli promenu veli\u{10D}ine`,
    "select": `Izaberite`,
    "selectAll": `Izaberite sve`,
    "sortable": `kolona koja se mo\u{17E}e sortirati`
};

});

parcelRegister("4cIJG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8976c501d2a40c88$export$2e2bcd8739ae039; });
var $8976c501d2a40c88$export$2e2bcd8739ae039 = {};
$8976c501d2a40c88$export$2e2bcd8739ae039 = {
    "ascending": `stigande`,
    "ascendingSort": (args)=>`sorterat p\xe5 kolumn ${args.columnName} i stigande ordning`,
    "columnSize": (args)=>`${args.value} pixlar`,
    "descending": `fallande`,
    "descendingSort": (args)=>`sorterat p\xe5 kolumn ${args.columnName} i fallande ordning`,
    "resizerDescription": `Tryck p\xe5 Retur f\xf6r att b\xf6rja \xe4ndra storlek`,
    "select": `Markera`,
    "selectAll": `Markera allt`,
    "sortable": `sorterbar kolumn`
};

});

parcelRegister("7xztq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7de1d25f225308f$export$2e2bcd8739ae039; });
var $c7de1d25f225308f$export$2e2bcd8739ae039 = {};
$c7de1d25f225308f$export$2e2bcd8739ae039 = {
    "ascending": `artan s\u{131}rada`,
    "ascendingSort": (args)=>`${args.columnName} s\xfctuna g\xf6re artan d\xfczende s\u{131}rala`,
    "columnSize": (args)=>`${args.value} piksel`,
    "descending": `azalan s\u{131}rada`,
    "descendingSort": (args)=>`${args.columnName} s\xfctuna g\xf6re azalan d\xfczende s\u{131}rala`,
    "resizerDescription": `Yeniden boyutland\u{131}rmak i\xe7in Enter'a bas\u{131}n`,
    "select": `Se\xe7`,
    "selectAll": `T\xfcm\xfcn\xfc Se\xe7`,
    "sortable": `S\u{131}ralanabilir s\xfctun`
};

});

parcelRegister("bSRtZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6851996405d2e3d7$export$2e2bcd8739ae039; });
var $6851996405d2e3d7$export$2e2bcd8739ae039 = {};
$6851996405d2e3d7$export$2e2bcd8739ae039 = {
    "ascending": `\u{432}\u{438}\u{441}\u{445}\u{456}\u{434}\u{43D}\u{438}\u{439}`,
    "ascendingSort": (args)=>`\u{432}\u{456}\u{434}\u{441}\u{43E}\u{440}\u{442}\u{43E}\u{432}\u{430}\u{43D}\u{43E} \u{437}\u{430} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{446}\u{435}\u{43C} ${args.columnName} \u{443} \u{432}\u{438}\u{441}\u{445}\u{456}\u{434}\u{43D}\u{43E}\u{43C}\u{443} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{443}`,
    "columnSize": (args)=>`${args.value} \u{43F}\u{456}\u{43A}\u{441}.`,
    "descending": `\u{43D}\u{438}\u{437}\u{445}\u{456}\u{434}\u{43D}\u{438}\u{439}`,
    "descendingSort": (args)=>`\u{432}\u{456}\u{434}\u{441}\u{43E}\u{440}\u{442}\u{43E}\u{432}\u{430}\u{43D}\u{43E} \u{437}\u{430} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{446}\u{435}\u{43C} ${args.columnName} \u{443} \u{43D}\u{438}\u{437}\u{445}\u{456}\u{434}\u{43D}\u{43E}\u{43C}\u{443} \u{43F}\u{43E}\u{440}\u{44F}\u{434}\u{43A}\u{443}`,
    "resizerDescription": `\u{41D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{456}\u{442}\u{44C} Enter, \u{449}\u{43E}\u{431} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438} \u{437}\u{43C}\u{456}\u{43D}\u{443} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440}\u{443}`,
    "select": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438}`,
    "selectAll": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438} \u{432}\u{441}\u{435}`,
    "sortable": `\u{441}\u{43E}\u{440}\u{442}\u{443}\u{432}\u{430}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{435}\u{446}\u{44C}`
};

});

parcelRegister("1Yilj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $572d3a2c8bcdc3cc$export$2e2bcd8739ae039; });
var $572d3a2c8bcdc3cc$export$2e2bcd8739ae039 = {};
$572d3a2c8bcdc3cc$export$2e2bcd8739ae039 = {
    "ascending": `\u{5347}\u{5E8F}`,
    "ascendingSort": (args)=>`\u{6309}\u{5217} ${args.columnName} \u{5347}\u{5E8F}\u{6392}\u{5E8F}`,
    "columnSize": (args)=>`${args.value} \u{50CF}\u{7D20}`,
    "descending": `\u{964D}\u{5E8F}`,
    "descendingSort": (args)=>`\u{6309}\u{5217} ${args.columnName} \u{964D}\u{5E8F}\u{6392}\u{5E8F}`,
    "resizerDescription": `\u{6309}\u{201C}\u{8F93}\u{5165}\u{201D}\u{952E}\u{5F00}\u{59CB}\u{8C03}\u{6574}\u{5927}\u{5C0F}\u{3002}`,
    "select": `\u{9009}\u{62E9}`,
    "selectAll": `\u{5168}\u{9009}`,
    "sortable": `\u{53EF}\u{6392}\u{5E8F}\u{7684}\u{5217}`
};

});

parcelRegister("fFjG7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e464c92630dcdd6$export$2e2bcd8739ae039; });
var $0e464c92630dcdd6$export$2e2bcd8739ae039 = {};
$0e464c92630dcdd6$export$2e2bcd8739ae039 = {
    "ascending": `\u{905E}\u{589E}`,
    "ascendingSort": (args)=>`\u{5DF2}\u{4F9D}\u{64DA}\u{300C}${args.columnName}\u{300D}\u{6B04}\u{905E}\u{589E}\u{6392}\u{5E8F}`,
    "columnSize": (args)=>`${args.value} \u{50CF}\u{7D20}`,
    "descending": `\u{905E}\u{6E1B}`,
    "descendingSort": (args)=>`\u{5DF2}\u{4F9D}\u{64DA}\u{300C}${args.columnName}\u{300D}\u{6B04}\u{905E}\u{6E1B}\u{6392}\u{5E8F}`,
    "resizerDescription": `\u{6309} Enter \u{9375}\u{4EE5}\u{958B}\u{59CB}\u{8ABF}\u{6574}\u{5927}\u{5C0F}`,
    "select": `\u{9078}\u{53D6}`,
    "selectAll": `\u{5168}\u{9078}`,
    "sortable": `\u{53EF}\u{6392}\u{5E8F}\u{7684}\u{6B04}`
};

});


parcelRegister("kc7uv", function(module, exports) {

$parcel$export(module.exports, "TableKeyboardDelegate", function () { return $4a33da897865ced3$export$da43f8f5cb04028d; });

var $6z78f = parcelRequire("6z78f");

var $cBz34 = parcelRequire("cBz34");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $4a33da897865ced3$export$da43f8f5cb04028d extends (0, $cBz34.GridKeyboardDelegate) {
    isCell(node) {
        return node.type === 'cell' || node.type === 'rowheader' || node.type === 'column';
    }
    getKeyBelow(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return null;
        // If focus was on a column, then focus the first child column if any,
        // or find the corresponding cell in the first row.
        if (startItem.type === 'column') {
            var _getNthItem;
            let child = (0, $6z78f.getFirstItem)((0, $6z78f.getChildNodes)(startItem, this.collection));
            if (child) return child.key;
            let firstKey = this.getFirstKey();
            if (firstKey == null) return null;
            let firstItem = this.collection.getItem(firstKey);
            if (!firstItem) return null;
            var _getNthItem_key;
            return (_getNthItem_key = (_getNthItem = (0, $6z78f.getNthItem)((0, $6z78f.getChildNodes)(firstItem, this.collection), startItem.index)) === null || _getNthItem === void 0 ? void 0 : _getNthItem.key) !== null && _getNthItem_key !== void 0 ? _getNthItem_key : null;
        }
        return super.getKeyBelow(key);
    }
    getKeyAbove(key) {
        let startItem = this.collection.getItem(key);
        if (!startItem) return null;
        // If focus was on a column, focus the parent column if any
        if (startItem.type === 'column') {
            let parent = startItem.parentKey != null ? this.collection.getItem(startItem.parentKey) : null;
            if (parent && parent.type === 'column') return parent.key;
            return null;
        }
        // only return above row key if not header row
        let superKey = super.getKeyAbove(key);
        let superItem = superKey != null ? this.collection.getItem(superKey) : null;
        if (superItem && superItem.type !== 'headerrow') return superKey;
        // If no item was found, and focus was on a cell, then focus the
        // corresponding column header.
        if (this.isCell(startItem)) return this.collection.columns[startItem.index].key;
        // If focus was on a row, then focus the first column header.
        return this.collection.columns[0].key;
    }
    findNextColumnKey(column) {
        // Search following columns
        let key = this.findNextKey(column.key, (item)=>item.type === 'column');
        if (key != null) return key;
        // Wrap around to the first column
        let row = this.collection.headerRows[column.level];
        for (let item of (0, $6z78f.getChildNodes)(row, this.collection)){
            if (item.type === 'column') return item.key;
        }
        return null;
    }
    findPreviousColumnKey(column) {
        // Search previous columns
        let key = this.findPreviousKey(column.key, (item)=>item.type === 'column');
        if (key != null) return key;
        // Wrap around to the last column
        let row = this.collection.headerRows[column.level];
        let childNodes = [
            ...(0, $6z78f.getChildNodes)(row, this.collection)
        ];
        for(let i = childNodes.length - 1; i >= 0; i--){
            let item = childNodes[i];
            if (item.type === 'column') return item.key;
        }
        return null;
    }
    getKeyRightOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return null;
        // If focus was on a column, then focus the next column
        if (item.type === 'column') return this.direction === 'rtl' ? this.findPreviousColumnKey(item) : this.findNextColumnKey(item);
        return super.getKeyRightOf(key);
    }
    getKeyLeftOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return null;
        // If focus was on a column, then focus the previous column
        if (item.type === 'column') return this.direction === 'rtl' ? this.findNextColumnKey(item) : this.findPreviousColumnKey(item);
        return super.getKeyLeftOf(key);
    }
    getKeyForSearch(search, fromKey) {
        if (!this.collator) return null;
        let collection = this.collection;
        let key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
        if (key == null) return null;
        // If the starting key is a cell, search from its parent row.
        let startItem = collection.getItem(key);
        var _startItem_parentKey;
        if ((startItem === null || startItem === void 0 ? void 0 : startItem.type) === 'cell') key = (_startItem_parentKey = startItem.parentKey) !== null && _startItem_parentKey !== void 0 ? _startItem_parentKey : null;
        let hasWrapped = false;
        while(key != null){
            let item = collection.getItem(key);
            if (!item) return null;
            // Check each of the row header cells in this row for a match
            for (let cell of (0, $6z78f.getChildNodes)(item, this.collection)){
                let column = collection.columns[cell.index];
                if (collection.rowHeaderColumnKeys.has(column.key) && cell.textValue) {
                    let substring = cell.textValue.slice(0, search.length);
                    if (this.collator.compare(substring, search) === 0) {
                        // If we started on a cell, end on the matching cell. Otherwise, end on the row.
                        let fromItem = fromKey != null ? collection.getItem(fromKey) : startItem;
                        return (fromItem === null || fromItem === void 0 ? void 0 : fromItem.type) === 'cell' ? cell.key : item.key;
                    }
                }
            }
            key = this.getKeyBelow(key);
            // Wrap around when reaching the end of the collection
            if (key == null && !hasWrapped) {
                key = this.getFirstKey();
                hasWrapped = true;
            }
        }
        return null;
    }
}

});
parcelRegister("cBz34", function(module, exports) {

$parcel$export(module.exports, "GridKeyboardDelegate", function () { return $4d82773f50a4adfb$export$de9feff04fda126e; });

var $alJC6 = parcelRequire("alJC6");

var $6z78f = parcelRequire("6z78f");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $4d82773f50a4adfb$export$de9feff04fda126e {
    isCell(node) {
        return node.type === 'cell';
    }
    isRow(node) {
        return node.type === 'row' || node.type === 'item';
    }
    isDisabled(item) {
        var _item_props;
        return this.disabledBehavior === 'all' && (((_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || this.disabledKeys.has(item.key));
    }
    findPreviousKey(fromKey, pred) {
        let key = fromKey != null ? this.collection.getKeyBefore(fromKey) : this.collection.getLastKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (!item) return null;
            if (!this.isDisabled(item) && (!pred || pred(item))) return key;
            key = this.collection.getKeyBefore(key);
        }
        return null;
    }
    findNextKey(fromKey, pred) {
        let key = fromKey != null ? this.collection.getKeyAfter(fromKey) : this.collection.getFirstKey();
        while(key != null){
            let item = this.collection.getItem(key);
            if (!item) return null;
            if (!this.isDisabled(item) && (!pred || pred(item))) return key;
            key = this.collection.getKeyAfter(key);
            if (key == null) return null;
        }
        return null;
    }
    getKeyBelow(fromKey) {
        let key = fromKey;
        let startItem = this.collection.getItem(key);
        if (!startItem) return null;
        var _startItem_parentKey;
        // If focus was on a cell, start searching from the parent row
        if (this.isCell(startItem)) key = (_startItem_parentKey = startItem.parentKey) !== null && _startItem_parentKey !== void 0 ? _startItem_parentKey : null;
        if (key == null) return null;
        // Find the next item
        key = this.findNextKey(key, (item)=>item.type === 'item');
        if (key != null) {
            // If focus was on a cell, focus the cell with the same index in the next row.
            if (this.isCell(startItem)) {
                var _getNthItem;
                let item = this.collection.getItem(key);
                if (!item) return null;
                var _startItem_index, _getNthItem_key;
                return (_getNthItem_key = (_getNthItem = (0, $6z78f.getNthItem)((0, $6z78f.getChildNodes)(item, this.collection), (_startItem_index = startItem.index) !== null && _startItem_index !== void 0 ? _startItem_index : 0)) === null || _getNthItem === void 0 ? void 0 : _getNthItem.key) !== null && _getNthItem_key !== void 0 ? _getNthItem_key : null;
            }
            // Otherwise, focus the next row
            if (this.focusMode === 'row') return key;
        }
        return null;
    }
    getKeyAbove(fromKey) {
        let key = fromKey;
        let startItem = this.collection.getItem(key);
        if (!startItem) return null;
        var _startItem_parentKey;
        // If focus is on a cell, start searching from the parent row
        if (this.isCell(startItem)) key = (_startItem_parentKey = startItem.parentKey) !== null && _startItem_parentKey !== void 0 ? _startItem_parentKey : null;
        if (key == null) return null;
        // Find the previous item
        key = this.findPreviousKey(key, (item)=>item.type === 'item');
        if (key != null) {
            // If focus was on a cell, focus the cell with the same index in the previous row.
            if (this.isCell(startItem)) {
                var _getNthItem;
                let item = this.collection.getItem(key);
                if (!item) return null;
                var _startItem_index;
                return ((_getNthItem = (0, $6z78f.getNthItem)((0, $6z78f.getChildNodes)(item, this.collection), (_startItem_index = startItem.index) !== null && _startItem_index !== void 0 ? _startItem_index : 0)) === null || _getNthItem === void 0 ? void 0 : _getNthItem.key) || null;
            }
            // Otherwise, focus the previous row
            if (this.focusMode === 'row') return key;
        }
        return null;
    }
    getKeyRightOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return null;
        // If focus is on a row, focus the first child cell.
        if (this.isRow(item)) {
            var _getLastItem, _getFirstItem;
            let children = (0, $6z78f.getChildNodes)(item, this.collection);
            var _ref;
            return (_ref = this.direction === 'rtl' ? (_getLastItem = (0, $6z78f.getLastItem)(children)) === null || _getLastItem === void 0 ? void 0 : _getLastItem.key : (_getFirstItem = (0, $6z78f.getFirstItem)(children)) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key) !== null && _ref !== void 0 ? _ref : null;
        }
        // If focus is on a cell, focus the next cell if any,
        // otherwise focus the parent row.
        if (this.isCell(item) && item.parentKey != null) {
            let parent = this.collection.getItem(item.parentKey);
            if (!parent) return null;
            let children = (0, $6z78f.getChildNodes)(parent, this.collection);
            var _ref1;
            let next = (_ref1 = this.direction === 'rtl' ? (0, $6z78f.getNthItem)(children, item.index - 1) : (0, $6z78f.getNthItem)(children, item.index + 1)) !== null && _ref1 !== void 0 ? _ref1 : null;
            var _next_key;
            if (next) return (_next_key = next.key) !== null && _next_key !== void 0 ? _next_key : null;
            var _item_parentKey;
            // focus row only if focusMode is set to row
            if (this.focusMode === 'row') return (_item_parentKey = item.parentKey) !== null && _item_parentKey !== void 0 ? _item_parentKey : null;
            var _ref2;
            return (_ref2 = this.direction === 'rtl' ? this.getFirstKey(key) : this.getLastKey(key)) !== null && _ref2 !== void 0 ? _ref2 : null;
        }
        return null;
    }
    getKeyLeftOf(key) {
        let item = this.collection.getItem(key);
        if (!item) return null;
        // If focus is on a row, focus the last child cell.
        if (this.isRow(item)) {
            var _getFirstItem, _getLastItem;
            let children = (0, $6z78f.getChildNodes)(item, this.collection);
            var _ref;
            return (_ref = this.direction === 'rtl' ? (_getFirstItem = (0, $6z78f.getFirstItem)(children)) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key : (_getLastItem = (0, $6z78f.getLastItem)(children)) === null || _getLastItem === void 0 ? void 0 : _getLastItem.key) !== null && _ref !== void 0 ? _ref : null;
        }
        // If focus is on a cell, focus the previous cell if any,
        // otherwise focus the parent row.
        if (this.isCell(item) && item.parentKey != null) {
            let parent = this.collection.getItem(item.parentKey);
            if (!parent) return null;
            let children = (0, $6z78f.getChildNodes)(parent, this.collection);
            var _ref1;
            let prev = (_ref1 = this.direction === 'rtl' ? (0, $6z78f.getNthItem)(children, item.index + 1) : (0, $6z78f.getNthItem)(children, item.index - 1)) !== null && _ref1 !== void 0 ? _ref1 : null;
            var _prev_key;
            if (prev) return (_prev_key = prev.key) !== null && _prev_key !== void 0 ? _prev_key : null;
            var _item_parentKey;
            // focus row only if focusMode is set to row
            if (this.focusMode === 'row') return (_item_parentKey = item.parentKey) !== null && _item_parentKey !== void 0 ? _item_parentKey : null;
            var _ref2;
            return (_ref2 = this.direction === 'rtl' ? this.getLastKey(key) : this.getFirstKey(key)) !== null && _ref2 !== void 0 ? _ref2 : null;
        }
        return null;
    }
    getFirstKey(fromKey, global) {
        let key = fromKey !== null && fromKey !== void 0 ? fromKey : null;
        let item;
        if (key != null) {
            item = this.collection.getItem(key);
            if (!item) return null;
            // If global flag is not set, and a cell is currently focused,
            // move focus to the first cell in the parent row.
            if (this.isCell(item) && !global && item.parentKey != null) {
                var _getFirstItem;
                let parent = this.collection.getItem(item.parentKey);
                if (!parent) return null;
                var _getFirstItem_key;
                return (_getFirstItem_key = (_getFirstItem = (0, $6z78f.getFirstItem)((0, $6z78f.getChildNodes)(parent, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key) !== null && _getFirstItem_key !== void 0 ? _getFirstItem_key : null;
            }
        }
        // Find the first row
        key = this.findNextKey(undefined, (item)=>item.type === 'item');
        // If global flag is set (or if focus mode is cell), focus the first cell in the first row.
        if (key != null && (item && this.isCell(item) && global || this.focusMode === 'cell')) {
            var _getFirstItem1;
            let item = this.collection.getItem(key);
            if (!item) return null;
            var _getFirstItem_key1;
            key = (_getFirstItem_key1 = (_getFirstItem1 = (0, $6z78f.getFirstItem)((0, $6z78f.getChildNodes)(item, this.collection))) === null || _getFirstItem1 === void 0 ? void 0 : _getFirstItem1.key) !== null && _getFirstItem_key1 !== void 0 ? _getFirstItem_key1 : null;
        }
        // Otherwise, focus the row itself.
        return key;
    }
    getLastKey(fromKey, global) {
        let key = fromKey !== null && fromKey !== void 0 ? fromKey : null;
        let item;
        if (key != null) {
            item = this.collection.getItem(key);
            if (!item) return null;
            // If global flag is not set, and a cell is currently focused,
            // move focus to the last cell in the parent row.
            if (this.isCell(item) && !global && item.parentKey != null) {
                var _getLastItem;
                let parent = this.collection.getItem(item.parentKey);
                if (!parent) return null;
                let children = (0, $6z78f.getChildNodes)(parent, this.collection);
                var _getLastItem_key;
                return (_getLastItem_key = (_getLastItem = (0, $6z78f.getLastItem)(children)) === null || _getLastItem === void 0 ? void 0 : _getLastItem.key) !== null && _getLastItem_key !== void 0 ? _getLastItem_key : null;
            }
        }
        // Find the last row
        key = this.findPreviousKey(undefined, (item)=>item.type === 'item');
        // If global flag is set (or if focus mode is cell), focus the last cell in the last row.
        if (key != null && (item && this.isCell(item) && global || this.focusMode === 'cell')) {
            var _getLastItem1;
            let item = this.collection.getItem(key);
            if (!item) return null;
            let children = (0, $6z78f.getChildNodes)(item, this.collection);
            var _getLastItem_key1;
            key = (_getLastItem_key1 = (_getLastItem1 = (0, $6z78f.getLastItem)(children)) === null || _getLastItem1 === void 0 ? void 0 : _getLastItem1.key) !== null && _getLastItem_key1 !== void 0 ? _getLastItem_key1 : null;
        }
        // Otherwise, focus the row itself.
        return key;
    }
    getKeyPageAbove(fromKey) {
        let key = fromKey;
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        let pageY = Math.max(0, itemRect.y + itemRect.height - this.layoutDelegate.getVisibleRect().height);
        while(itemRect && itemRect.y > pageY && key != null){
            var _this_getKeyAbove;
            key = (_this_getKeyAbove = this.getKeyAbove(key)) !== null && _this_getKeyAbove !== void 0 ? _this_getKeyAbove : null;
            if (key == null) break;
            itemRect = this.layoutDelegate.getItemRect(key);
        }
        return key;
    }
    getKeyPageBelow(fromKey) {
        let key = fromKey;
        let itemRect = this.layoutDelegate.getItemRect(key);
        if (!itemRect) return null;
        let pageHeight = this.layoutDelegate.getVisibleRect().height;
        let pageY = Math.min(this.layoutDelegate.getContentSize().height, itemRect.y + pageHeight);
        while(itemRect && itemRect.y + itemRect.height < pageY){
            let nextKey = this.getKeyBelow(key);
            // If nextKey is undefined, we've reached the last row already
            if (nextKey == null) break;
            itemRect = this.layoutDelegate.getItemRect(nextKey);
            key = nextKey;
        }
        return key;
    }
    getKeyForSearch(search, fromKey) {
        let key = fromKey !== null && fromKey !== void 0 ? fromKey : null;
        if (!this.collator) return null;
        let collection = this.collection;
        key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
        if (key == null) return null;
        // If the starting key is a cell, search from its parent row.
        let startItem = collection.getItem(key);
        if (!startItem) return null;
        var _startItem_parentKey;
        if (startItem.type === 'cell') key = (_startItem_parentKey = startItem.parentKey) !== null && _startItem_parentKey !== void 0 ? _startItem_parentKey : null;
        let hasWrapped = false;
        while(key != null){
            let item = collection.getItem(key);
            if (!item) return null;
            // check row text value for match
            if (item.textValue) {
                let substring = item.textValue.slice(0, search.length);
                if (this.collator.compare(substring, search) === 0) {
                    var _getFirstItem;
                    var _getFirstItem_key;
                    if (this.isRow(item) && this.focusMode === 'cell') return (_getFirstItem_key = (_getFirstItem = (0, $6z78f.getFirstItem)((0, $6z78f.getChildNodes)(item, this.collection))) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key) !== null && _getFirstItem_key !== void 0 ? _getFirstItem_key : null;
                    return item.key;
                }
            }
            key = this.findNextKey(key, (item)=>item.type === 'item');
            // Wrap around when reaching the end of the collection
            if (key == null && !hasWrapped) {
                key = this.getFirstKey();
                hasWrapped = true;
            }
        }
        return null;
    }
    constructor(options){
        this.collection = options.collection;
        this.disabledKeys = options.disabledKeys;
        this.disabledBehavior = options.disabledBehavior || 'all';
        this.direction = options.direction;
        this.collator = options.collator;
        if (!options.layout && !options.ref) throw new Error('Either a layout or a ref must be specified.');
        this.layoutDelegate = options.layoutDelegate || (options.layout ? new $4d82773f50a4adfb$var$$d1c300d9c497e402$var$DeprecatedLayoutDelegate(options.layout) : new (0, $alJC6.DOMLayoutDelegate)(options.ref));
        this.focusMode = options.focusMode || 'row';
    }
}
class $4d82773f50a4adfb$var$$d1c300d9c497e402$var$DeprecatedLayoutDelegate {
    getContentSize() {
        return this.layout.getContentSize();
    }
    getItemRect(key) {
        var _this_layout_getLayoutInfo;
        return ((_this_layout_getLayoutInfo = this.layout.getLayoutInfo(key)) === null || _this_layout_getLayoutInfo === void 0 ? void 0 : _this_layout_getLayoutInfo.rect) || null;
    }
    getVisibleRect() {
        return this.layout.virtualizer.visibleRect;
    }
    constructor(layout){
        this.layout = layout;
    }
}

});


parcelRegister("bZuMw", function(module, exports) {

$parcel$export(module.exports, "useGrid", function () { return $096c0e888922e6d4$export$f6b86a04e5d66d90; });

var $cBz34 = parcelRequire("cBz34");

var $h1KDT = parcelRequire("h1KDT");

var $d8MiS = parcelRequire("d8MiS");

var $g2XaT = parcelRequire("g2XaT");

var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");
var $gxMV2 = parcelRequire("gxMV2");

var $bh6RR = parcelRequire("bh6RR");

var $7caxR = parcelRequire("7caxR");
var $c8uzR = parcelRequire("c8uzR");

var $huNh9 = parcelRequire("huNh9");

var $bLdgI = parcelRequire("bLdgI");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $096c0e888922e6d4$export$f6b86a04e5d66d90(props, state, ref) {
    let { isVirtualized: isVirtualized, keyboardDelegate: keyboardDelegate, focusMode: focusMode, scrollRef: scrollRef, getRowText: getRowText, onRowAction: onRowAction, onCellAction: onCellAction } = props;
    let { selectionManager: manager } = state;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
    // When virtualized, the layout object will be passed in as a prop and override this.
    let collator = (0, $7caxR.useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let { direction: direction } = (0, $c8uzR.useLocale)();
    let disabledBehavior = state.selectionManager.disabledBehavior;
    let delegate = (0, $bh6RR.useMemo)(()=>keyboardDelegate || new (0, $cBz34.GridKeyboardDelegate)({
            collection: state.collection,
            disabledKeys: state.disabledKeys,
            disabledBehavior: disabledBehavior,
            ref: ref,
            direction: direction,
            collator: collator,
            focusMode: focusMode
        }), [
        keyboardDelegate,
        state.collection,
        state.disabledKeys,
        disabledBehavior,
        ref,
        direction,
        collator,
        focusMode
    ]);
    let { collectionProps: collectionProps } = (0, $bLdgI.useSelectableCollection)({
        ref: ref,
        selectionManager: manager,
        keyboardDelegate: delegate,
        isVirtualized: isVirtualized,
        scrollRef: scrollRef
    });
    let id = (0, $gxMV2.useId)(props.id);
    (0, $h1KDT.gridMap).set(state, {
        keyboardDelegate: delegate,
        actions: {
            onRowAction: onRowAction,
            onCellAction: onCellAction
        }
    });
    let descriptionProps = (0, $g2XaT.useHighlightSelectionDescription)({
        selectionManager: manager,
        hasItemActions: !!(onRowAction || onCellAction)
    });
    let domProps = (0, $bG0JH.filterDOMProps)(props, {
        labelable: true
    });
    let onFocus = (0, $bh6RR.useCallback)((e)=>{
        if (manager.isFocused) {
            // If a focus event bubbled through a portal, reset focus state.
            if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
            return;
        }
        // Focus events can bubble through portals. Ignore these events.
        if (!e.currentTarget.contains(e.target)) return;
        manager.setFocused(true);
    }, [
        manager
    ]);
    // Continue to track collection focused state even if keyboard navigation is disabled
    let navDisabledHandlers = (0, $bh6RR.useMemo)(()=>({
            onBlur: collectionProps.onBlur,
            onFocus: onFocus
        }), [
        onFocus,
        collectionProps.onBlur
    ]);
    let hasTabbableChild = (0, $huNh9.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let gridProps = (0, $hAxtE.mergeProps)(domProps, {
        role: 'grid',
        id: id,
        'aria-multiselectable': manager.selectionMode === 'multiple' ? 'true' : undefined
    }, state.isKeyboardNavigationDisabled ? navDisabledHandlers : collectionProps, state.collection.size === 0 && {
        tabIndex: hasTabbableChild ? -1 : 0
    } || undefined, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = state.collection.columnCount;
    }
    (0, $d8MiS.useGridSelectionAnnouncement)({
        getRowText: getRowText
    }, state);
    return {
        gridProps: gridProps
    };
}

});
parcelRegister("h1KDT", function(module, exports) {

$parcel$export(module.exports, "gridMap", function () { return $57dbf8409d423157$export$e6235c0d09b995d0; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $57dbf8409d423157$export$e6235c0d09b995d0 = new WeakMap();

});


parcelRegister("a7EiN", function(module, exports) {

$parcel$export(module.exports, "tableNestedRows", function () { return $c9456910fbea6a5a$export$1b00cb14a96194e6; });
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $c9456910fbea6a5a$var$$f4e2df6bd15f8569$var$_tableNestedRows = false;
function $c9456910fbea6a5a$export$d9d8a0f82de49530() {
    $c9456910fbea6a5a$var$$f4e2df6bd15f8569$var$_tableNestedRows = true;
}
function $c9456910fbea6a5a$export$1b00cb14a96194e6() {
    return $c9456910fbea6a5a$var$$f4e2df6bd15f8569$var$_tableNestedRows;
}

});


parcelRegister("4SWU2", function(module, exports) {

$parcel$export(module.exports, "useTableCell", function () { return $8a412c6230649e12$export$49571c903d73624c; });

var $biOOL = parcelRequire("biOOL");

var $eb4Q2 = parcelRequire("eb4Q2");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8a412c6230649e12$export$49571c903d73624c(props, state, ref) {
    var _props_node_column;
    let { gridCellProps: gridCellProps, isPressed: isPressed } = (0, $eb4Q2.useGridCell)(props, state, ref);
    let columnKey = (_props_node_column = props.node.column) === null || _props_node_column === void 0 ? void 0 : _props_node_column.key;
    if (columnKey != null && state.collection.rowHeaderColumnKeys.has(columnKey)) {
        gridCellProps.role = 'rowheader';
        gridCellProps.id = (0, $biOOL.getCellId)(state, props.node.parentKey, columnKey);
    }
    return {
        gridCellProps: gridCellProps,
        isPressed: isPressed
    };
}

});
parcelRegister("eb4Q2", function(module, exports) {

$parcel$export(module.exports, "useGridCell", function () { return $9a3d79f838c6f0dd$export$c7e10bfc0c59f67c; });

var $h1KDT = parcelRequire("h1KDT");

var $bQDsd = parcelRequire("bQDsd");
var $2NhrA = parcelRequire("2NhrA");

var $eF7Zd = parcelRequire("eF7Zd");
var $hAxtE = parcelRequire("hAxtE");
var $2FItP = parcelRequire("2FItP");

var $8tXMg = parcelRequire("8tXMg");

var $bh6RR = parcelRequire("bh6RR");

var $c8uzR = parcelRequire("c8uzR");

var $gYN2y = parcelRequire("gYN2y");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $9a3d79f838c6f0dd$export$c7e10bfc0c59f67c(props, state, ref) {
    let { node: node, isVirtualized: isVirtualized, focusMode: focusMode = 'child', shouldSelectOnPressUp: shouldSelectOnPressUp, onAction: onAction } = props;
    let { direction: direction } = (0, $c8uzR.useLocale)();
    let { keyboardDelegate: keyboardDelegate, actions: { onCellAction: onCellAction } } = (0, $h1KDT.gridMap).get(state);
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, $bh6RR.useRef)(null);
    // Handles focusing the cell. If there is a focusable child,
    // it is focused, otherwise the cell itself is focused.
    let focus = ()=>{
        if (ref.current) {
            let treeWalker = (0, $2NhrA.getFocusableTreeWalker)(ref.current);
            if (focusMode === 'child') {
                // If focus is already on a focusable child within the cell, early return so we don't shift focus
                if (ref.current.contains(document.activeElement) && ref.current !== document.activeElement) return;
                let focusable = state.selectionManager.childFocusStrategy === 'last' ? $9a3d79f838c6f0dd$var$$ab90dcbc1b5466d0$var$last(treeWalker) : treeWalker.firstChild();
                if (focusable) {
                    (0, $bQDsd.focusSafely)(focusable);
                    return;
                }
            }
            if (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !ref.current.contains(document.activeElement)) (0, $bQDsd.focusSafely)(ref.current);
        }
    };
    let { itemProps: itemProps, isPressed: isPressed } = (0, $gYN2y.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref: ref,
        isVirtualized: isVirtualized,
        focus: focus,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        onAction: onCellAction ? ()=>onCellAction(node.key) : onAction,
        isDisabled: state.collection.size === 0
    });
    let onKeyDownCapture = (e)=>{
        if (!e.currentTarget.contains(e.target) || state.isKeyboardNavigationDisabled || !ref.current || !document.activeElement) return;
        let walker = (0, $2NhrA.getFocusableTreeWalker)(ref.current);
        walker.currentNode = document.activeElement;
        switch(e.key){
            case 'ArrowLeft':
                {
                    // Find the next focusable element within the cell.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    // Don't focus the cell itself if focusMode is "child"
                    if (focusMode === 'child' && focusable === ref.current) focusable = null;
                    e.preventDefault();
                    e.stopPropagation();
                    if (focusable) {
                        (0, $bQDsd.focusSafely)(focusable);
                        (0, $2FItP.scrollIntoViewport)(focusable, {
                            containingElement: (0, $eF7Zd.getScrollParent)(ref.current)
                        });
                    } else {
                        var _keyboardDelegate_getKeyLeftOf;
                        // If there is no next focusable child, then move to the next cell to the left of this one.
                        // This will be handled by useSelectableCollection. However, if there is no cell to the left
                        // of this one, only one column, and the grid doesn't focus rows, then the next key will be the
                        // same as this one. In that case we need to handle focusing either the cell or the first/last
                        // child, depending on the focus mode.
                        let prev = (_keyboardDelegate_getKeyLeftOf = keyboardDelegate.getKeyLeftOf) === null || _keyboardDelegate_getKeyLeftOf === void 0 ? void 0 : _keyboardDelegate_getKeyLeftOf.call(keyboardDelegate, node.key);
                        if (prev !== node.key) {
                            var // We want arrow keys to navigate to the next cell instead. We need to re-dispatch
                            // the event from a higher parent so it still bubbles and gets handled by useSelectableCollection.
                            _ref_current_parentElement;
                            (_ref_current_parentElement = ref.current.parentElement) === null || _ref_current_parentElement === void 0 || _ref_current_parentElement.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                            break;
                        }
                        if (focusMode === 'cell' && direction === 'rtl') {
                            (0, $bQDsd.focusSafely)(ref.current);
                            (0, $2FItP.scrollIntoViewport)(ref.current, {
                                containingElement: (0, $eF7Zd.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            focusable = direction === 'rtl' ? walker.firstChild() : $9a3d79f838c6f0dd$var$$ab90dcbc1b5466d0$var$last(walker);
                            if (focusable) {
                                (0, $bQDsd.focusSafely)(focusable);
                                (0, $2FItP.scrollIntoViewport)(focusable, {
                                    containingElement: (0, $eF7Zd.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                    break;
                }
            case 'ArrowRight':
                {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusMode === 'child' && focusable === ref.current) focusable = null;
                    e.preventDefault();
                    e.stopPropagation();
                    if (focusable) {
                        (0, $bQDsd.focusSafely)(focusable);
                        (0, $2FItP.scrollIntoViewport)(focusable, {
                            containingElement: (0, $eF7Zd.getScrollParent)(ref.current)
                        });
                    } else {
                        var _keyboardDelegate_getKeyRightOf;
                        let next = (_keyboardDelegate_getKeyRightOf = keyboardDelegate.getKeyRightOf) === null || _keyboardDelegate_getKeyRightOf === void 0 ? void 0 : _keyboardDelegate_getKeyRightOf.call(keyboardDelegate, node.key);
                        if (next !== node.key) {
                            var // We want arrow keys to navigate to the next cell instead. We need to re-dispatch
                            // the event from a higher parent so it still bubbles and gets handled by useSelectableCollection.
                            _ref_current_parentElement1;
                            (_ref_current_parentElement1 = ref.current.parentElement) === null || _ref_current_parentElement1 === void 0 || _ref_current_parentElement1.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                            break;
                        }
                        if (focusMode === 'cell' && direction === 'ltr') {
                            (0, $bQDsd.focusSafely)(ref.current);
                            (0, $2FItP.scrollIntoViewport)(ref.current, {
                                containingElement: (0, $eF7Zd.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            focusable = direction === 'rtl' ? $9a3d79f838c6f0dd$var$$ab90dcbc1b5466d0$var$last(walker) : walker.firstChild();
                            if (focusable) {
                                (0, $bQDsd.focusSafely)(focusable);
                                (0, $2FItP.scrollIntoViewport)(focusable, {
                                    containingElement: (0, $eF7Zd.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                    break;
                }
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching cell children, e.g. menu buttons. We want arrow keys to navigate
                // to the cell above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && ref.current.contains(e.target)) {
                    var _ref_current_parentElement2;
                    e.stopPropagation();
                    e.preventDefault();
                    (_ref_current_parentElement2 = ref.current.parentElement) === null || _ref_current_parentElement2 === void 0 || _ref_current_parentElement2.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    // Grid cells can have focusable elements inside them. In this case, focus should
    // be marshalled to that element rather than focusing the cell itself.
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the gridcell itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row/cell
            // in that case since the table should act like a single tab stop.
            if (!(0, $8tXMg.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
        // If the cell itself is focused, wait a frame so that focus finishes propagatating
        // up to the tree, and move focus to a focusable child if possible.
        requestAnimationFrame(()=>{
            if (focusMode === 'child' && document.activeElement === ref.current) focus();
        });
    };
    let gridCellProps = (0, $hAxtE.mergeProps)(itemProps, {
        role: 'gridcell',
        onKeyDownCapture: onKeyDownCapture,
        onFocus: onFocus
    });
    var _node_colIndex;
    if (isVirtualized) gridCellProps['aria-colindex'] = ((_node_colIndex = node.colIndex) !== null && _node_colIndex !== void 0 ? _node_colIndex : node.index) + 1; // aria-colindex is 1-based
    // When pressing with a pointer and cell selection is not enabled, usePress will be applied to the
    // row rather than the cell. However, when the row is draggable, usePress cannot preventDefault
    // on pointer down, so the browser will try to focus the cell which has a tabIndex applied.
    // To avoid this, remove the tabIndex from the cell briefly on pointer down.
    if (shouldSelectOnPressUp && gridCellProps.tabIndex != null && gridCellProps.onPointerDown == null) gridCellProps.onPointerDown = (e)=>{
        let el = e.currentTarget;
        let tabindex = el.getAttribute('tabindex');
        el.removeAttribute('tabindex');
        requestAnimationFrame(()=>{
            if (tabindex != null) el.setAttribute('tabindex', tabindex);
        });
    };
    return {
        gridCellProps: gridCellProps,
        isPressed: isPressed
    };
}
function $9a3d79f838c6f0dd$var$$ab90dcbc1b5466d0$var$last(walker) {
    let next = null;
    let last = null;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}

});


parcelRegister("1UUYg", function(module, exports) {

$parcel$export(module.exports, "useTableColumnHeader", function () { return $577cd6e01e8db0d3$export$9514819a8c81e960; });

var $biOOL = parcelRequire("biOOL");

var $6L7os = parcelRequire("6L7os");

var $be6XU = parcelRequire("be6XU");
var $hAxtE = parcelRequire("hAxtE");
var $eHR6B = parcelRequire("eHR6B");

var $bh6RR = parcelRequire("bh6RR");

var $6HV86 = parcelRequire("6HV86");

var $eb4Q2 = parcelRequire("eb4Q2");

var $kbHlJ = parcelRequire("kbHlJ");

var $b3OV8 = parcelRequire("b3OV8");
function $577cd6e01e8db0d3$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $577cd6e01e8db0d3$export$9514819a8c81e960(props, state, ref) {
    var _state_sortDescriptor, _state_sortDescriptor1;
    let { node: node } = props;
    let allowsSorting = node.props.allowsSorting;
    // if there are no focusable children, the column header will focus the cell
    let { gridCellProps: gridCellProps } = (0, $eb4Q2.useGridCell)({
        ...props,
        focusMode: 'child'
    }, state, ref);
    let isSelectionCellDisabled = node.props.isSelectionCell && state.selectionManager.selectionMode === 'single';
    let { pressProps: pressProps } = (0, $b3OV8.usePress)({
        isDisabled: !allowsSorting || isSelectionCellDisabled,
        onPress () {
            state.sort(node.key);
        },
        ref: ref
    });
    // Needed to pick up the focusable context, enabling things like Tooltips for example
    let { focusableProps: focusableProps } = (0, $6HV86.useFocusable)({}, ref);
    let ariaSort = undefined;
    let isSortedColumn = ((_state_sortDescriptor = state.sortDescriptor) === null || _state_sortDescriptor === void 0 ? void 0 : _state_sortDescriptor.column) === node.key;
    let sortDirection = (_state_sortDescriptor1 = state.sortDescriptor) === null || _state_sortDescriptor1 === void 0 ? void 0 : _state_sortDescriptor1.direction;
    // aria-sort not supported in Android Talkback
    if (node.props.allowsSorting && !(0, $be6XU.isAndroid)()) ariaSort = isSortedColumn ? sortDirection : 'none';
    let stringFormatter = (0, $kbHlJ.useLocalizedStringFormatter)($577cd6e01e8db0d3$var$$parcel$interopDefault((0, $6L7os.default)), '@react-aria/table');
    let sortDescription;
    if (allowsSorting) {
        sortDescription = `${stringFormatter.format('sortable')}`;
        // Android Talkback doesn't support aria-sort so we add sort order details to the aria-described by here
        if (isSortedColumn && sortDirection && (0, $be6XU.isAndroid)()) sortDescription = `${sortDescription}, ${stringFormatter.format(sortDirection)}`;
    }
    let descriptionProps = (0, $eHR6B.useDescription)(sortDescription);
    let shouldDisableFocus = state.collection.size === 0;
    (0, $bh6RR.useEffect)(()=>{
        if (shouldDisableFocus && state.selectionManager.focusedKey === node.key) state.selectionManager.setFocusedKey(null);
    }, [
        shouldDisableFocus,
        state.selectionManager,
        node.key
    ]);
    return {
        columnHeaderProps: {
            ...(0, $hAxtE.mergeProps)(gridCellProps, pressProps, focusableProps, descriptionProps, shouldDisableFocus ? {
                tabIndex: -1
            } : null),
            role: 'columnheader',
            id: (0, $biOOL.getColumnHeaderId)(state, node.key),
            'aria-colspan': node.colspan && node.colspan > 1 ? node.colspan : undefined,
            'aria-sort': ariaSort
        }
    };
}

});

parcelRegister("dcGdN", function(module, exports) {

$parcel$export(module.exports, "useTableColumnResize", function () { return $c447b03fb8587457$export$52994e973806c219; });

var $biOOL = parcelRequire("biOOL");

var $6L7os = parcelRequire("6L7os");

var $bh6RR = parcelRequire("bh6RR");

var $bQDsd = parcelRequire("bQDsd");

var $hAxtE = parcelRequire("hAxtE");
var $eHR6B = parcelRequire("eHR6B");
var $i7SiA = parcelRequire("i7SiA");
var $gxMV2 = parcelRequire("gxMV2");

var $8tXMg = parcelRequire("8tXMg");
var $jxA49 = parcelRequire("jxA49");
var $4FKZ4 = parcelRequire("4FKZ4");
var $b3OV8 = parcelRequire("b3OV8");

var $c8uzR = parcelRequire("c8uzR");
var $kbHlJ = parcelRequire("kbHlJ");

var $lhOYy = parcelRequire("lhOYy");
function $c447b03fb8587457$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c447b03fb8587457$export$52994e973806c219(props, state, ref) {
    let { column: item, triggerRef: triggerRef, isDisabled: isDisabled, onResizeStart: onResizeStart, onResize: onResize, onResizeEnd: onResizeEnd, 'aria-label': ariaLabel } = props;
    const stringFormatter = (0, $kbHlJ.useLocalizedStringFormatter)($c447b03fb8587457$var$$parcel$interopDefault((0, $6L7os.default)), '@react-aria/table');
    let id = (0, $gxMV2.useId)();
    let isResizing = state.resizingColumn === item.key;
    let isResizingRef = (0, $bh6RR.useRef)(isResizing);
    let lastSize = (0, $bh6RR.useRef)(null);
    let wasFocusedOnResizeStart = (0, $bh6RR.useRef)(false);
    let editModeEnabled = state.tableState.isKeyboardNavigationDisabled;
    let { direction: direction } = (0, $c8uzR.useLocale)();
    let { keyboardProps: keyboardProps } = (0, $jxA49.useKeyboard)({
        onKeyDown: (e)=>{
            if (editModeEnabled) {
                if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ' || e.key === 'Tab') {
                    e.preventDefault();
                    endResize(item);
                }
            } else {
                // Continue propagation on keydown events so they still bubbles to useSelectableCollection and are handled there
                e.continuePropagation();
                if (e.key === 'Enter') startResize(item);
            }
        }
    });
    let startResize = (0, $i7SiA.useEffectEvent)((item)=>{
        if (!isResizingRef.current) {
            lastSize.current = state.updateResizedColumns(item.key, state.getColumnWidth(item.key));
            state.startResize(item.key);
            state.tableState.setKeyboardNavigationDisabled(true);
            onResizeStart === null || onResizeStart === void 0 || onResizeStart(lastSize.current);
        }
        isResizingRef.current = true;
    });
    let resize = (0, $i7SiA.useEffectEvent)((item, newWidth)=>{
        let sizes = state.updateResizedColumns(item.key, newWidth);
        onResize === null || onResize === void 0 || onResize(sizes);
        lastSize.current = sizes;
    });
    let endResize = (0, $i7SiA.useEffectEvent)((item)=>{
        if (isResizingRef.current) {
            if (lastSize.current == null) lastSize.current = state.updateResizedColumns(item.key, state.getColumnWidth(item.key));
            state.endResize();
            state.tableState.setKeyboardNavigationDisabled(false);
            onResizeEnd === null || onResizeEnd === void 0 || onResizeEnd(lastSize.current);
            isResizingRef.current = false;
            if ((triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) && !wasFocusedOnResizeStart.current) (0, $bQDsd.focusSafely)(triggerRef.current);
        }
        lastSize.current = null;
    });
    const columnResizeWidthRef = (0, $bh6RR.useRef)(0);
    const { moveProps: moveProps } = (0, $4FKZ4.useMove)({
        onMoveStart () {
            columnResizeWidthRef.current = state.getColumnWidth(item.key);
            startResize(item);
        },
        onMove (e) {
            let { deltaX: deltaX, deltaY: deltaY, pointerType: pointerType } = e;
            if (direction === 'rtl') deltaX *= -1;
            if (pointerType === 'keyboard') {
                if (deltaY !== 0 && deltaX === 0) deltaX = deltaY * -1;
                deltaX *= 10;
            }
            // if moving up/down only, no need to resize
            if (deltaX !== 0) {
                columnResizeWidthRef.current += deltaX;
                resize(item, columnResizeWidthRef.current);
            }
        },
        onMoveEnd (e) {
            let { pointerType: pointerType } = e;
            columnResizeWidthRef.current = 0;
            if (pointerType === 'mouse' || pointerType === 'touch' && wasFocusedOnResizeStart.current) endResize(item);
        }
    });
    let onKeyDown = (0, $bh6RR.useCallback)((e)=>{
        var _moveProps_onKeyDown;
        if (editModeEnabled) (_moveProps_onKeyDown = moveProps.onKeyDown) === null || _moveProps_onKeyDown === void 0 || _moveProps_onKeyDown.call(moveProps, e);
    }, [
        editModeEnabled,
        moveProps
    ]);
    let min = Math.floor(state.getColumnMinWidth(item.key));
    let max = Math.floor(state.getColumnMaxWidth(item.key));
    if (max === Infinity) max = Number.MAX_SAFE_INTEGER;
    let value = Math.floor(state.getColumnWidth(item.key));
    let modality = (0, $8tXMg.useInteractionModality)();
    if (modality === 'virtual' && typeof window !== 'undefined' && 'ontouchstart' in window) modality = 'touch';
    let description = (triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) == null && (modality === 'keyboard' || modality === 'virtual') && !isResizing ? stringFormatter.format('resizerDescription') : undefined;
    let descriptionProps = (0, $eHR6B.useDescription)(description);
    let ariaProps = {
        'aria-label': ariaLabel,
        'aria-orientation': 'horizontal',
        'aria-labelledby': `${id} ${(0, $biOOL.getColumnHeaderId)(state.tableState, item.key)}`,
        'aria-valuetext': stringFormatter.format('columnSize', {
            value: value
        }),
        'type': 'range',
        min: min,
        max: max,
        value: value,
        ...descriptionProps
    };
    const focusInput = (0, $bh6RR.useCallback)(()=>{
        if (ref.current) (0, $bQDsd.focusSafely)(ref.current);
    }, [
        ref
    ]);
    let resizingColumn = state.resizingColumn;
    let prevResizingColumn = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        if (prevResizingColumn.current !== resizingColumn && resizingColumn != null && resizingColumn === item.key) {
            wasFocusedOnResizeStart.current = document.activeElement === ref.current;
            startResize(item);
            // Delay focusing input until Android Chrome's delayed click after touchend happens: https://bugs.chromium.org/p/chromium/issues/detail?id=1150073
            let timeout = setTimeout(()=>focusInput(), 0);
            // VoiceOver on iOS has problems focusing the input from a menu.
            let VOTimeout = setTimeout(focusInput, 400);
            return ()=>{
                clearTimeout(timeout);
                clearTimeout(VOTimeout);
            };
        }
        prevResizingColumn.current = resizingColumn;
    }, [
        resizingColumn,
        item,
        focusInput,
        ref,
        startResize
    ]);
    let onChange = (e)=>{
        let currentWidth = state.getColumnWidth(item.key);
        let nextValue = parseFloat(e.target.value);
        if (nextValue > currentWidth) nextValue = currentWidth + 10;
        else nextValue = currentWidth - 10;
        resize(item, nextValue);
    };
    let { pressProps: pressProps } = (0, $b3OV8.usePress)({
        onPressStart: (e)=>{
            if (e.ctrlKey || e.altKey || e.metaKey || e.shiftKey || e.pointerType === 'keyboard') return;
            if (e.pointerType === 'virtual' && state.resizingColumn != null) {
                endResize(item);
                return;
            }
            // Sometimes onPress won't trigger for quick taps on mobile so we want to focus the input so blurring away
            // can cancel resize mode for us.
            focusInput();
            // If resizer is always visible, mobile screenreader user can access the visually hidden resizer directly and thus we don't need
            // to handle a virtual click to start the resizer.
            if (e.pointerType !== 'virtual') startResize(item);
        },
        onPress: (e)=>{
            if ((e.pointerType === 'touch' && wasFocusedOnResizeStart.current || e.pointerType === 'mouse') && state.resizingColumn != null) endResize(item);
        }
    });
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $lhOYy.useVisuallyHidden)();
    return {
        resizerProps: (0, $hAxtE.mergeProps)(keyboardProps, {
            ...moveProps,
            onKeyDown: onKeyDown
        }, pressProps, {
            style: {
                touchAction: 'none'
            }
        }),
        inputProps: (0, $hAxtE.mergeProps)(visuallyHiddenProps, {
            id: id,
            onBlur: ()=>{
                endResize(item);
            },
            onChange: onChange,
            disabled: isDisabled
        }, ariaProps),
        isResizing: isResizing
    };
}

});
parcelRegister("4FKZ4", function(module, exports) {

$parcel$export(module.exports, "useMove", function () { return $1112bf3fb6d5beca$export$36da96379f79f245; });

var $e4uYM = parcelRequire("e4uYM");

var $bh6RR = parcelRequire("bh6RR");

var $i7SiA = parcelRequire("i7SiA");
var $foRcG = parcelRequire("foRcG");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1112bf3fb6d5beca$export$36da96379f79f245(props) {
    let { onMoveStart: onMoveStart, onMove: onMove, onMoveEnd: onMoveEnd } = props;
    let state = (0, $bh6RR.useRef)({
        didMove: false,
        lastPosition: null,
        id: null
    });
    let { addGlobalListener: addGlobalListener, removeGlobalListener: removeGlobalListener } = (0, $foRcG.useGlobalListeners)();
    let move = (0, $i7SiA.useEffectEvent)((originalEvent, pointerType, deltaX, deltaY)=>{
        if (deltaX === 0 && deltaY === 0) return;
        if (!state.current.didMove) {
            state.current.didMove = true;
            onMoveStart === null || onMoveStart === void 0 || onMoveStart({
                type: 'movestart',
                pointerType: pointerType,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        }
        onMove === null || onMove === void 0 || onMove({
            type: 'move',
            pointerType: pointerType,
            deltaX: deltaX,
            deltaY: deltaY,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    let end = (0, $i7SiA.useEffectEvent)((originalEvent, pointerType)=>{
        (0, $e4uYM.restoreTextSelection)();
        if (state.current.didMove) onMoveEnd === null || onMoveEnd === void 0 || onMoveEnd({
            type: 'moveend',
            pointerType: pointerType,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    let moveProps = (0, $bh6RR.useMemo)(()=>{
        let moveProps = {};
        let start = ()=>{
            (0, $e4uYM.disableTextSelection)();
            state.current.didMove = false;
        };
        if (typeof PointerEvent === 'undefined') {
            let onMouseMove = (e)=>{
                if (e.button === 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, 'mouse', e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onMouseUp = (e)=>{
                if (e.button === 0) {
                    end(e, 'mouse');
                    removeGlobalListener(window, 'mousemove', onMouseMove, false);
                    removeGlobalListener(window, 'mouseup', onMouseUp, false);
                }
            };
            moveProps.onMouseDown = (e)=>{
                if (e.button === 0) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    addGlobalListener(window, 'mousemove', onMouseMove, false);
                    addGlobalListener(window, 'mouseup', onMouseUp, false);
                }
            };
            let onTouchMove = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    let { pageX: pageX, pageY: pageY } = e.changedTouches[touch];
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, 'touch', pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: pageX,
                        pageY: pageY
                    };
                }
            };
            let onTouchEnd = (e)=>{
                let touch = [
                    ...e.changedTouches
                ].findIndex(({ identifier: identifier })=>identifier === state.current.id);
                if (touch >= 0) {
                    end(e, 'touch');
                    state.current.id = null;
                    removeGlobalListener(window, 'touchmove', onTouchMove);
                    removeGlobalListener(window, 'touchend', onTouchEnd);
                    removeGlobalListener(window, 'touchcancel', onTouchEnd);
                }
            };
            moveProps.onTouchStart = (e)=>{
                if (e.changedTouches.length === 0 || state.current.id != null) return;
                let { pageX: pageX, pageY: pageY, identifier: identifier } = e.changedTouches[0];
                start();
                e.stopPropagation();
                e.preventDefault();
                state.current.lastPosition = {
                    pageX: pageX,
                    pageY: pageY
                };
                state.current.id = identifier;
                addGlobalListener(window, 'touchmove', onTouchMove, false);
                addGlobalListener(window, 'touchend', onTouchEnd, false);
                addGlobalListener(window, 'touchcancel', onTouchEnd, false);
            };
        } else {
            let onPointerMove = (e)=>{
                if (e.pointerId === state.current.id) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    let pointerType = e.pointerType || 'mouse';
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    // Problems with PointerEvent#movementX/movementY:
                    // 1. it is always 0 on macOS Safari.
                    // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS
                    move(e, pointerType, e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            let onPointerUp = (e)=>{
                if (e.pointerId === state.current.id) {
                    let pointerType = e.pointerType || 'mouse';
                    end(e, pointerType);
                    state.current.id = null;
                    removeGlobalListener(window, 'pointermove', onPointerMove, false);
                    removeGlobalListener(window, 'pointerup', onPointerUp, false);
                    removeGlobalListener(window, 'pointercancel', onPointerUp, false);
                }
            };
            moveProps.onPointerDown = (e)=>{
                if (e.button === 0 && state.current.id == null) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    state.current.id = e.pointerId;
                    addGlobalListener(window, 'pointermove', onPointerMove, false);
                    addGlobalListener(window, 'pointerup', onPointerUp, false);
                    addGlobalListener(window, 'pointercancel', onPointerUp, false);
                }
            };
        }
        let triggerKeyboardMove = (e, deltaX, deltaY)=>{
            start();
            move(e, 'keyboard', deltaX, deltaY);
            end(e, 'keyboard');
        };
        moveProps.onKeyDown = (e)=>{
            switch(e.key){
                case 'Left':
                case 'ArrowLeft':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, -1, 0);
                    break;
                case 'Right':
                case 'ArrowRight':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 1, 0);
                    break;
                case 'Up':
                case 'ArrowUp':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, -1);
                    break;
                case 'Down':
                case 'ArrowDown':
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, 1);
                    break;
            }
        };
        return moveProps;
    }, [
        state,
        addGlobalListener,
        removeGlobalListener,
        move,
        end
    ]);
    return {
        moveProps: moveProps
    };
}

});


parcelRegister("2QDeI", function(module, exports) {

$parcel$export(module.exports, "useTableHeaderRow", function () { return $cc55b383a2ad4803$export$1b95a7d2d517b841; });

var $a7EiN = parcelRequire("a7EiN");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $cc55b383a2ad4803$export$1b95a7d2d517b841(props, state, ref) {
    let { node: node, isVirtualized: isVirtualized } = props;
    let rowProps = {
        role: 'row'
    };
    if (isVirtualized && !((0, $a7EiN.tableNestedRows)() && 'expandedKeys' in state)) rowProps['aria-rowindex'] = node.index + 1; // aria-rowindex is 1 based
    return {
        rowProps: rowProps
    };
}

});

parcelRegister("jVvar", function(module, exports) {

$parcel$export(module.exports, "useTableRow", function () { return $a026dda6970257ce$export$7f2f6ae19e707aa5; });

var $biOOL = parcelRequire("biOOL");

var $6z78f = parcelRequire("6z78f");

var $k7U7u = parcelRequire("k7U7u");

var $hAxtE = parcelRequire("hAxtE");
var $gN5ZC = parcelRequire("gN5ZC");

var $a7EiN = parcelRequire("a7EiN");

var $c8uzR = parcelRequire("c8uzR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $a026dda6970257ce$var$$b2db214c022798eb$var$EXPANSION_KEYS = {
    expand: {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    'collapse': {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function $a026dda6970257ce$export$7f2f6ae19e707aa5(props, state, ref) {
    let { node: node, isVirtualized: isVirtualized } = props;
    let { rowProps: rowProps, ...states } = (0, $k7U7u.useGridRow)(props, state, ref);
    let { direction: direction } = (0, $c8uzR.useLocale)();
    if (isVirtualized && !((0, $a7EiN.tableNestedRows)() && 'expandedKeys' in state)) rowProps['aria-rowindex'] = node.index + 1 + state.collection.headerRows.length; // aria-rowindex is 1 based
    else delete rowProps['aria-rowindex'];
    let treeGridRowProps = {};
    if ((0, $a7EiN.tableNestedRows)() && 'expandedKeys' in state) {
        let treeNode = state.keyMap.get(node.key);
        if (treeNode != null) {
            var _treeNode_props, _treeNode_props_children, _treeNode_props1, _getLastItem, _state_keyMap_get, _getLastItem1;
            let hasChildRows = ((_treeNode_props = treeNode.props) === null || _treeNode_props === void 0 ? void 0 : _treeNode_props.UNSTABLE_childItems) || ((_treeNode_props1 = treeNode.props) === null || _treeNode_props1 === void 0 ? void 0 : (_treeNode_props_children = _treeNode_props1.children) === null || _treeNode_props_children === void 0 ? void 0 : _treeNode_props_children.length) > state.userColumnCount;
            var _treeNode_indexOfType, _state_keyMap_get_childNodes, _getLastItem_indexOfType, _getLastItem_indexOfType1;
            treeGridRowProps = {
                onKeyDown: (e)=>{
                    if (e.key === $a026dda6970257ce$var$$b2db214c022798eb$var$EXPANSION_KEYS['expand'][direction] && state.selectionManager.focusedKey === treeNode.key && hasChildRows && state.expandedKeys !== 'all' && !state.expandedKeys.has(treeNode.key)) {
                        state.toggleKey(treeNode.key);
                        e.stopPropagation();
                    } else if (e.key === $a026dda6970257ce$var$$b2db214c022798eb$var$EXPANSION_KEYS['collapse'][direction] && state.selectionManager.focusedKey === treeNode.key && hasChildRows && (state.expandedKeys === 'all' || state.expandedKeys.has(treeNode.key))) {
                        state.toggleKey(treeNode.key);
                        e.stopPropagation();
                    }
                },
                'aria-expanded': hasChildRows ? state.expandedKeys === 'all' || state.expandedKeys.has(node.key) : undefined,
                'aria-level': treeNode.level,
                'aria-posinset': ((_treeNode_indexOfType = treeNode.indexOfType) !== null && _treeNode_indexOfType !== void 0 ? _treeNode_indexOfType : 0) + 1,
                'aria-setsize': treeNode.level > 1 ? ((_getLastItem_indexOfType = (_getLastItem = (0, $6z78f.getLastItem)((_state_keyMap_get_childNodes = (_state_keyMap_get = state.keyMap.get(treeNode.parentKey)) === null || _state_keyMap_get === void 0 ? void 0 : _state_keyMap_get.childNodes) !== null && _state_keyMap_get_childNodes !== void 0 ? _state_keyMap_get_childNodes : [])) === null || _getLastItem === void 0 ? void 0 : _getLastItem.indexOfType) !== null && _getLastItem_indexOfType !== void 0 ? _getLastItem_indexOfType : 0) + 1 : ((_getLastItem_indexOfType1 = (_getLastItem1 = (0, $6z78f.getLastItem)(state.collection.body.childNodes)) === null || _getLastItem1 === void 0 ? void 0 : _getLastItem1.indexOfType) !== null && _getLastItem_indexOfType1 !== void 0 ? _getLastItem_indexOfType1 : 0) + 1
            };
        }
    }
    let syntheticLinkProps = (0, $gN5ZC.useSyntheticLinkProps)(node.props);
    let linkProps = states.hasAction ? syntheticLinkProps : {};
    return {
        rowProps: {
            ...(0, $hAxtE.mergeProps)(rowProps, treeGridRowProps, linkProps),
            'aria-labelledby': (0, $biOOL.getRowLabelledBy)(state, node.key)
        },
        ...states
    };
}

});
parcelRegister("k7U7u", function(module, exports) {

$parcel$export(module.exports, "useGridRow", function () { return $6a31e65f75b2c0e6$export$96357d5a73f686fa; });

var $h1KDT = parcelRequire("h1KDT");

var $jQZLC = parcelRequire("jQZLC");

var $gYN2y = parcelRequire("gYN2y");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6a31e65f75b2c0e6$export$96357d5a73f686fa(props, state, ref) {
    var _node_props, _node_props1;
    let { node: node, isVirtualized: isVirtualized, shouldSelectOnPressUp: shouldSelectOnPressUp, onAction: onAction } = props;
    let { actions: actions } = (0, $h1KDT.gridMap).get(state);
    let onRowAction = actions.onRowAction ? ()=>{
        var _actions_onRowAction;
        return (_actions_onRowAction = actions.onRowAction) === null || _actions_onRowAction === void 0 ? void 0 : _actions_onRowAction.call(actions, node.key);
    } : onAction;
    let { itemProps: itemProps, ...states } = (0, $gYN2y.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref: ref,
        isVirtualized: isVirtualized,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        onAction: onRowAction || (node === null || node === void 0 ? void 0 : (_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.onAction) ? (0, $jQZLC.chain)(node === null || node === void 0 ? void 0 : (_node_props1 = node.props) === null || _node_props1 === void 0 ? void 0 : _node_props1.onAction, onRowAction) : undefined,
        isDisabled: state.collection.size === 0
    });
    let isSelected = state.selectionManager.isSelected(node.key);
    let rowProps = {
        role: 'row',
        'aria-selected': state.selectionManager.selectionMode !== 'none' ? isSelected : undefined,
        'aria-disabled': states.isDisabled || undefined,
        ...itemProps
    };
    if (isVirtualized) rowProps['aria-rowindex'] = node.index + 1; // aria-rowindex is 1 based
    return {
        rowProps: rowProps,
        ...states
    };
}

});


parcelRegister("fKc9O", function(module, exports) {

$parcel$export(module.exports, "useTableRowGroup", function () { return $1aafe448a52d24a2$export$6fb1613bd7b28198; });

var $lGes6 = parcelRequire("lGes6");

var $1UUYg = parcelRequire("1UUYg");

var $jVvar = parcelRequire("jVvar");

var $2QDeI = parcelRequire("2QDeI");

var $4SWU2 = parcelRequire("4SWU2");

var $dQD2e = parcelRequire("dQD2e");

var $dcGdN = parcelRequire("dcGdN");

var $hrKlv = parcelRequire("hrKlv");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $1aafe448a52d24a2$export$6fb1613bd7b28198() {
    return (0, $hrKlv.useGridRowGroup)();
}

});
parcelRegister("dQD2e", function(module, exports) {

$parcel$export(module.exports, "useTableSelectionCheckbox", function () { return $0984078e8c9a69b0$export$16ea7f650bd7c1bb; });
$parcel$export(module.exports, "useTableSelectAllCheckbox", function () { return $0984078e8c9a69b0$export$1003db6a7e384b99; });

var $biOOL = parcelRequire("biOOL");

var $6L7os = parcelRequire("6L7os");

var $aDlhw = parcelRequire("aDlhw");

var $kbHlJ = parcelRequire("kbHlJ");
function $0984078e8c9a69b0$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $0984078e8c9a69b0$export$16ea7f650bd7c1bb(props, state) {
    let { key: key } = props;
    const { checkboxProps: checkboxProps } = (0, $aDlhw.useGridSelectionCheckbox)(props, state);
    return {
        checkboxProps: {
            ...checkboxProps,
            'aria-labelledby': `${checkboxProps.id} ${(0, $biOOL.getRowLabelledBy)(state, key)}`
        }
    };
}
function $0984078e8c9a69b0$export$1003db6a7e384b99(state) {
    let { isEmpty: isEmpty, isSelectAll: isSelectAll, selectionMode: selectionMode } = state.selectionManager;
    const stringFormatter = (0, $kbHlJ.useLocalizedStringFormatter)($0984078e8c9a69b0$var$$parcel$interopDefault((0, $6L7os.default)), '@react-aria/table');
    return {
        checkboxProps: {
            'aria-label': stringFormatter.format(selectionMode === 'single' ? 'select' : 'selectAll'),
            isSelected: isSelectAll,
            isDisabled: selectionMode !== 'multiple' || state.collection.size === 0,
            isIndeterminate: !isEmpty && !isSelectAll,
            onChange: ()=>state.selectionManager.toggleSelectAll()
        }
    };
}

});
parcelRegister("aDlhw", function(module, exports) {

$parcel$export(module.exports, "useGridSelectionCheckbox", function () { return $2ec36fa7155e28ad$export$70e2eed1a92976ad; });

var $1uMSl = parcelRequire("1uMSl");

var $gxMV2 = parcelRequire("gxMV2");

var $kbHlJ = parcelRequire("kbHlJ");
function $2ec36fa7155e28ad$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $2ec36fa7155e28ad$export$70e2eed1a92976ad(props, state) {
    let { key: key } = props;
    let manager = state.selectionManager;
    let checkboxId = (0, $gxMV2.useId)();
    let isDisabled = !state.selectionManager.canSelectItem(key);
    let isSelected = state.selectionManager.isSelected(key);
    // Checkbox should always toggle selection, regardless of selectionBehavior.
    let onChange = ()=>manager.toggleSelection(key);
    const stringFormatter = (0, $kbHlJ.useLocalizedStringFormatter)($2ec36fa7155e28ad$var$$parcel$interopDefault((0, $1uMSl.default)), '@react-aria/grid');
    return {
        checkboxProps: {
            id: checkboxId,
            'aria-label': stringFormatter.format('select'),
            isSelected: isSelected,
            isDisabled: isDisabled,
            onChange: onChange
        }
    };
}

});


parcelRegister("hrKlv", function(module, exports) {

$parcel$export(module.exports, "useGridRowGroup", function () { return $99e841b9e533af1b$export$d3037f5d3f3e51bf; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $99e841b9e533af1b$export$d3037f5d3f3e51bf() {
    return {
        rowGroupProps: {
            role: 'rowgroup'
        }
    };
}

});



parcelRegister("4tN5V", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return $bde03f9cb5e16f96$export$48513f6b9f8ce62d; });

var $ih19M = parcelRequire("ih19M");

var $68TtM = parcelRequire("68TtM");
var $eg6AL = parcelRequire("eg6AL");
parcelRequire("bh6RR");

var $yTSxk = parcelRequire("yTSxk");
var $dgWhj = parcelRequire("dgWhj");

var $9SfKt = parcelRequire("9SfKt");

var $arHbU = parcelRequire("arHbU");

var $eGtYl = parcelRequire("eGtYl");
function $bde03f9cb5e16f96$export$4aa08d5625cb8ead(props) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $yTSxk.CheckboxGroup), {
        ...props,
        className: (0, $eGtYl.composeTailwindRenderProps)(props.className, 'flex flex-col gap-2'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $arHbU.Label), {
                children: props.label
            }),
            props.children,
            props.description && /*#__PURE__*/ (0, $ih19M.jsx)((0, $arHbU.Description), {
                children: props.description
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $arHbU.FieldError), {
                children: props.errorMessage
            })
        ]
    });
}
const $bde03f9cb5e16f96$var$checkboxStyles = (0, $9SfKt.tv)({
    base: 'flex gap-2 items-center group text-sm transition',
    variants: {
        isDisabled: {
            false: 'text-gray-800 dark:text-zinc-200',
            true: 'text-gray-300 dark:text-zinc-600 forced-colors:text-[GrayText]'
        }
    }
});
const $bde03f9cb5e16f96$var$boxStyles = (0, $9SfKt.tv)({
    extend: (0, $eGtYl.focusRing),
    base: 'w-5 h-5 flex-shrink-0 rounded flex items-center justify-center border-2 transition',
    variants: {
        isSelected: {
            false: 'bg-white dark:bg-zinc-900 border-[--color] [--color:theme(colors.gray.400)] dark:[--color:colors.zinc-400)] group-pressed:[--color:theme(colors.gray.500)] dark:group-pressed:[--color:theme(colors.zinc.300)]',
            true: 'bg-[--color] border-[--color] [--color:theme(colors.gray.700)] group-pressed:[--color:theme(colors.gray.800)] dark:[--color:theme(colors.slate.300)] dark:group-pressed:[--color:theme(colors.slate.200)] forced-colors:![--color:Highlight]'
        },
        isInvalid: {
            true: '[--color:theme(colors.red.700)] dark:[--color:theme(colors.red.600)] forced-colors:![--color:Mark] group-pressed:[--color:theme(colors.red.800)] dark:group-pressed:[--color:theme(colors.red.700)]'
        },
        isDisabled: {
            true: '[--color:theme(colors.gray.200)] dark:[--color:theme(colors.zinc.700)] forced-colors:![--color:GrayText]'
        }
    }
});
const $bde03f9cb5e16f96$var$iconStyles = 'w-4 h-4 text-white group-disabled:text-gray-400 dark:text-slate-900 dark:group-disabled:text-slate-600 forced-colors:text-[HighlightText]';
function $bde03f9cb5e16f96$export$48513f6b9f8ce62d(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $yTSxk.Checkbox), {
        ...props,
        className: (0, $dgWhj.composeRenderProps)(props.className, (className, renderProps)=>$bde03f9cb5e16f96$var$checkboxStyles({
                ...renderProps,
                className: className
            })),
        children: ({ isSelected: isSelected, isIndeterminate: isIndeterminate, ...renderProps })=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $bde03f9cb5e16f96$var$boxStyles({
                            isSelected: isSelected || isIndeterminate,
                            ...renderProps
                        }),
                        children: isIndeterminate ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $eg6AL.default), {
                            "aria-hidden": true,
                            className: $bde03f9cb5e16f96$var$iconStyles
                        }) : isSelected ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $68TtM.default), {
                            "aria-hidden": true,
                            className: $bde03f9cb5e16f96$var$iconStyles
                        }) : null
                    }),
                    props.children
                ]
            })
    });
}

});
parcelRegister("eg6AL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a617ac5b5533c8c7$export$2e2bcd8739ae039; });
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $a617ac5b5533c8c7$export$2e2bcd8739ae039 = (0, $iUesJ.default)("Minus", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ]
]);

});

parcelRegister("yTSxk", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return $1761993d8a6a66d1$export$48513f6b9f8ce62d; });
$parcel$export(module.exports, "CheckboxGroup", function () { return $1761993d8a6a66d1$export$4aa08d5625cb8ead; });

var $hzBE3 = parcelRequire("hzBE3");

var $dgWhj = parcelRequire("dgWhj");

var $e8uP1 = parcelRequire("e8uP1");

var $ldF9a = parcelRequire("ldF9a");

var $kubwK = parcelRequire("kubwK");

var $5Oi9Z = parcelRequire("5Oi9Z");

var $hAxtE = parcelRequire("hAxtE");
var $T6GEz = parcelRequire("T6GEz");
var $9RCU1 = parcelRequire("9RCU1");
var $ag647 = parcelRequire("ag647");
var $5Gawp = parcelRequire("5Gawp");
var $i91F7 = parcelRequire("i91F7");
var $lhOYy = parcelRequire("lhOYy");

var $47sfU = parcelRequire("47sfU");
var $gvzth = parcelRequire("gvzth");

var $bG0JH = parcelRequire("bG0JH");
var $AizmU = parcelRequire("AizmU");
var $jyDr8 = parcelRequire("jyDr8");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $1761993d8a6a66d1$export$baf37c4be89255b8 = (0, $bh6RR.createContext)(null);
const $1761993d8a6a66d1$export$139c5b8563afc1fc = (0, $bh6RR.createContext)(null);
function $1761993d8a6a66d1$var$$bc237834342dbd75$var$CheckboxGroup(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $1761993d8a6a66d1$export$baf37c4be89255b8);
    let { validationBehavior: formValidationBehavior } = (0, $dgWhj.useSlottedContext)((0, $ldF9a.FormContext)) || {};
    var _props_validationBehavior, _ref;
    let validationBehavior = (_ref = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref !== void 0 ? _ref : 'native';
    let state = (0, $47sfU.useCheckboxGroupState)({
        ...props,
        validationBehavior: validationBehavior
    });
    let [labelRef, label] = (0, $dgWhj.useSlot)();
    let { groupProps: groupProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, ...validation } = (0, $9RCU1.useCheckboxGroup)({
        ...props,
        label: label,
        validationBehavior: validationBehavior
    }, state);
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        values: {
            isDisabled: state.isDisabled,
            isReadOnly: state.isReadOnly,
            isRequired: props.isRequired || false,
            isInvalid: state.isInvalid,
            state: state
        },
        defaultClassName: 'react-aria-CheckboxGroup'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...groupProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-readonly": state.isReadOnly || undefined,
        "data-required": props.isRequired || undefined,
        "data-invalid": state.isInvalid || undefined,
        "data-disabled": props.isDisabled || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dgWhj.Provider), {
        values: [
            [
                $1761993d8a6a66d1$export$139c5b8563afc1fc,
                state
            ],
            [
                (0, $kubwK.LabelContext),
                {
                    ...labelProps,
                    ref: labelRef,
                    elementType: 'span'
                }
            ],
            [
                (0, $5Oi9Z.TextContext),
                {
                    slots: {
                        description: descriptionProps,
                        errorMessage: errorMessageProps
                    }
                }
            ],
            [
                (0, $e8uP1.FieldErrorContext),
                validation
            ]
        ]
    }, renderProps.children));
}
function $1761993d8a6a66d1$var$$bc237834342dbd75$var$Checkbox(props, ref) {
    let { inputRef: userProvidedInputRef = null, ...otherProps } = props;
    [props, ref] = (0, $dgWhj.useContextProps)(otherProps, ref, (0, $hzBE3.CheckboxContext));
    let { validationBehavior: formValidationBehavior } = (0, $dgWhj.useSlottedContext)((0, $ldF9a.FormContext)) || {};
    var _props_validationBehavior, _ref;
    let validationBehavior = (_ref = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref !== void 0 ? _ref : 'native';
    let groupState = (0, $bh6RR.useContext)($1761993d8a6a66d1$export$139c5b8563afc1fc);
    let inputRef = (0, $jyDr8.useObjectRef)((0, $AizmU.mergeRefs)(userProvidedInputRef, props.inputRef !== undefined ? props.inputRef : null));
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isDisabled: isDisabled, isReadOnly: isReadOnly, isPressed: isPressed, isInvalid: isInvalid } = groupState ? (0, $ag647.useCheckboxGroupItem)({
        ...(0, $dgWhj.removeDataAttributes)(props),
        // Value is optional for standalone checkboxes, but required for CheckboxGroup items;
        // it's passed explicitly here to avoid typescript error (requires ignore).
        // @ts-ignore
        value: props.value,
        // ReactNode type doesn't allow function children.
        children: typeof props.children === 'function' ? true : props.children
    }, groupState, inputRef) : (0, $T6GEz.useCheckbox)({
        ...(0, $dgWhj.removeDataAttributes)(props),
        children: typeof props.children === 'function' ? true : props.children,
        validationBehavior: validationBehavior
    }, (0, $gvzth.useToggleState)(props), inputRef);
    let { isFocused: isFocused, isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $5Gawp.useFocusRing)();
    let isInteractionDisabled = isDisabled || isReadOnly;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)({
        ...props,
        isDisabled: isInteractionDisabled
    });
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Checkbox',
        values: {
            isSelected: isSelected,
            isIndeterminate: props.isIndeterminate || false,
            isPressed: isPressed,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            isInvalid: isInvalid,
            isRequired: props.isRequired || false
        }
    });
    let DOMProps = (0, $bG0JH.filterDOMProps)(props);
    delete DOMProps.id;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("label", {
        ...(0, $hAxtE.mergeProps)(DOMProps, labelProps, hoverProps, renderProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-selected": isSelected || undefined,
        "data-indeterminate": props.isIndeterminate || undefined,
        "data-pressed": isPressed || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": isReadOnly || undefined,
        "data-invalid": isInvalid || undefined,
        "data-required": props.isRequired || undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $lhOYy.VisuallyHidden), {
        elementType: "span"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("input", {
        ...(0, $hAxtE.mergeProps)(inputProps, focusProps),
        ref: inputRef
    })), renderProps.children);
}
/**
 * A checkbox allows a user to select multiple items from a list of individual items, or
 * to mark one individual item as selected.
 */ const $1761993d8a6a66d1$export$48513f6b9f8ce62d = (0, $bh6RR.forwardRef)($1761993d8a6a66d1$var$$bc237834342dbd75$var$Checkbox);
/**
 * A checkbox group allows a user to select multiple items from a list of options.
 */ const $1761993d8a6a66d1$export$4aa08d5625cb8ead = (0, $bh6RR.forwardRef)($1761993d8a6a66d1$var$$bc237834342dbd75$var$CheckboxGroup);

});
parcelRegister("e8uP1", function(module, exports) {

$parcel$export(module.exports, "FieldErrorContext", function () { return $9f286e3bb4822614$export$ff05c3ac10437e03; });

var $dgWhj = parcelRequire("dgWhj");

var $5Oi9Z = parcelRequire("5Oi9Z");

var $bG0JH = parcelRequire("bG0JH");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $9f286e3bb4822614$export$ff05c3ac10437e03 = (0, $bh6RR.createContext)(null);
function $9f286e3bb4822614$var$$ee014567cb39d3f0$var$FieldError(props, ref) {
    let validation = (0, $bh6RR.useContext)($9f286e3bb4822614$export$ff05c3ac10437e03);
    if (!(validation === null || validation === void 0 ? void 0 : validation.isInvalid)) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($9f286e3bb4822614$var$$ee014567cb39d3f0$var$FieldErrorInner, {
        ...props,
        ref: ref
    });
}
/**
 * A FieldError displays validation errors for a form field.
 */ const $9f286e3bb4822614$export$f551688fc98f2e09 = (0, $bh6RR.forwardRef)($9f286e3bb4822614$var$$ee014567cb39d3f0$var$FieldError);
const $9f286e3bb4822614$var$$ee014567cb39d3f0$var$FieldErrorInner = (0, $bh6RR.forwardRef)((props, ref)=>{
    let validation = (0, $bh6RR.useContext)($9f286e3bb4822614$export$ff05c3ac10437e03);
    let domProps = (0, $bG0JH.filterDOMProps)(props);
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-FieldError',
        defaultChildren: validation.validationErrors.length === 0 ? undefined : validation.validationErrors.join(' '),
        values: validation
    });
    if (renderProps.children == null) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5Oi9Z.Text), {
        slot: "errorMessage",
        ...domProps,
        ...renderProps,
        ref: ref
    });
});

});

parcelRegister("ldF9a", function(module, exports) {

$parcel$export(module.exports, "FormContext", function () { return $46809f5d306bdcca$export$c24727297075ec6a; });

var $dgWhj = parcelRequire("dgWhj");

var $34HO0 = parcelRequire("34HO0");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $46809f5d306bdcca$export$c24727297075ec6a = (0, $bh6RR.createContext)(null);
function $46809f5d306bdcca$var$$d3e0e05bdfcf66bd$var$Form(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $46809f5d306bdcca$export$c24727297075ec6a);
    let { validationErrors: validationErrors, validationBehavior: validationBehavior = 'native', children: children, className: className, ...domProps } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("form", {
        noValidate: validationBehavior !== 'native',
        ...domProps,
        ref: ref,
        className: className || 'react-aria-Form'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($46809f5d306bdcca$export$c24727297075ec6a.Provider, {
        value: {
            ...props,
            validationBehavior: validationBehavior
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $34HO0.FormValidationContext).Provider, {
        value: validationErrors !== null && validationErrors !== void 0 ? validationErrors : {}
    }, children)));
}
/**
 * A form is a group of inputs that allows users to submit data to a server,
 * with support for providing field validation errors.
 */ const $46809f5d306bdcca$export$a7fed597f4b8afd8 = (0, $bh6RR.forwardRef)($46809f5d306bdcca$var$$d3e0e05bdfcf66bd$var$Form);

});
parcelRegister("34HO0", function(module, exports) {

$parcel$export(module.exports, "VALID_VALIDITY_STATE", function () { return $7bf844c3a4047458$export$aca958c65c314e6c; });
$parcel$export(module.exports, "DEFAULT_VALIDATION_RESULT", function () { return $7bf844c3a4047458$export$dad6ae84456c676a; });
$parcel$export(module.exports, "FormValidationContext", function () { return $7bf844c3a4047458$export$571b5131b7e65c11; });
$parcel$export(module.exports, "privateValidationStateProp", function () { return $7bf844c3a4047458$export$a763b9476acd3eb; });
$parcel$export(module.exports, "useFormValidationState", function () { return $7bf844c3a4047458$export$fc1a364ae1f3ff10; });
$parcel$export(module.exports, "mergeValidation", function () { return $7bf844c3a4047458$export$75ee7c75d68f5b0e; });

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $7bf844c3a4047458$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
const $7bf844c3a4047458$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = {
    ...$7bf844c3a4047458$export$aca958c65c314e6c,
    customError: true,
    valid: false
};
const $7bf844c3a4047458$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $7bf844c3a4047458$export$aca958c65c314e6c,
    validationErrors: []
};
const $7bf844c3a4047458$export$571b5131b7e65c11 = (0, $bh6RR.createContext)({});
const $7bf844c3a4047458$export$a763b9476acd3eb = '__formValidationState' + Date.now();
function $7bf844c3a4047458$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$7bf844c3a4047458$export$a763b9476acd3eb]) {
        let { realtimeValidation: realtimeValidation, displayValidation: displayValidation, updateValidation: updateValidation, resetValidation: resetValidation, commitValidation: commitValidation } = props[$7bf844c3a4047458$export$a763b9476acd3eb];
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $7bf844c3a4047458$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}
function $7bf844c3a4047458$var$$e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
    let { isInvalid: isInvalid, validationState: validationState, name: name, value: value, builtinValidation: builtinValidation, validate: validate, validationBehavior: validationBehavior = 'aria' } = props;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === 'invalid');
    // If the isInvalid prop is controlled, update validation result in realtime.
    let controlledError = isInvalid !== undefined ? {
        isInvalid: isInvalid,
        validationErrors: [],
        validationDetails: $7bf844c3a4047458$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    let clientError = (0, $bh6RR.useMemo)(()=>{
        if (!validate || value == null) return null;
        let validateErrors = $7bf844c3a4047458$var$$e5be200c675c3b3a$var$runValidate(validate, value);
        return $7bf844c3a4047458$var$$e5be200c675c3b3a$var$getValidationResult(validateErrors);
    }, [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = undefined;
    // Get relevant server errors from the form.
    let serverErrors = (0, $bh6RR.useContext)($7bf844c3a4047458$export$571b5131b7e65c11);
    let serverErrorMessages = (0, $bh6RR.useMemo)(()=>{
        if (name) return Array.isArray(name) ? name.flatMap((name)=>$7bf844c3a4047458$var$$e5be200c675c3b3a$var$asArray(serverErrors[name])) : $7bf844c3a4047458$var$$e5be200c675c3b3a$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    let [lastServerErrors, setLastServerErrors] = (0, $bh6RR.useState)(serverErrors);
    let [isServerErrorCleared, setServerErrorCleared] = (0, $bh6RR.useState)(false);
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    let serverError = (0, $bh6RR.useMemo)(()=>$7bf844c3a4047458$var$$e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    let nextValidation = (0, $bh6RR.useRef)($7bf844c3a4047458$export$dad6ae84456c676a);
    let [currentValidity, setCurrentValidity] = (0, $bh6RR.useState)($7bf844c3a4047458$export$dad6ae84456c676a);
    let lastError = (0, $bh6RR.useRef)($7bf844c3a4047458$export$dad6ae84456c676a);
    let commitValidation = ()=>{
        if (!commitQueued) return;
        setCommitQueued(false);
        let error = clientError || builtinValidation || nextValidation.current;
        if (!$7bf844c3a4047458$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    let [commitQueued, setCommitQueued] = (0, $bh6RR.useState)(false);
    (0, $bh6RR.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    let realtimeValidation = controlledError || serverError || clientError || builtinValidation || $7bf844c3a4047458$export$dad6ae84456c676a;
    let displayValidation = validationBehavior === 'native' ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation (value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === 'aria' && !$7bf844c3a4047458$var$$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation () {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            let error = $7bf844c3a4047458$export$dad6ae84456c676a;
            if (!$7bf844c3a4047458$var$$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === 'native') setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation () {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === 'native') setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $7bf844c3a4047458$var$$e5be200c675c3b3a$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $7bf844c3a4047458$var$$e5be200c675c3b3a$var$runValidate(validate, value) {
    if (typeof validate === 'function') {
        let e = validate(value);
        if (e && typeof e !== 'boolean') return $7bf844c3a4047458$var$$e5be200c675c3b3a$var$asArray(e);
    }
    return [];
}
function $7bf844c3a4047458$var$$e5be200c675c3b3a$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $7bf844c3a4047458$var$$e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $7bf844c3a4047458$var$$e5be200c675c3b3a$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return !!a && !!b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every((a, i)=>a === b.validationErrors[i]) && Object.entries(a.validationDetails).every(([k, v])=>b.validationDetails[k] === v);
}
function $7bf844c3a4047458$export$75ee7c75d68f5b0e(...results) {
    let errors = new Set();
    let isInvalid = false;
    let validationDetails = {
        ...$7bf844c3a4047458$export$aca958c65c314e6c
    };
    for (let v of results){
        var _validationDetails, _key;
        for (let e of v.validationErrors)errors.add(e);
        // Only these properties apply for checkboxes.
        isInvalid || (isInvalid = v.isInvalid);
        for(let key in validationDetails)(_validationDetails = validationDetails)[_key = key] || (_validationDetails[_key] = v.validationDetails[key]);
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: [
            ...errors
        ],
        validationDetails: validationDetails
    };
}

});


parcelRegister("T6GEz", function(module, exports) {

$parcel$export(module.exports, "useCheckbox", function () { return $31270fc16e609e2a$export$e375f10ce42261c5; });

var $bh6RR = parcelRequire("bh6RR");

var $hAxtE = parcelRequire("hAxtE");

var $34HO0 = parcelRequire("34HO0");

var $1rqKk = parcelRequire("1rqKk");

var $b3OV8 = parcelRequire("b3OV8");

var $bJcmR = parcelRequire("bJcmR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $31270fc16e609e2a$export$e375f10ce42261c5(props, state, inputRef) {
    // Create validation state here because it doesn't make sense to add to general useToggleState.
    let validationState = (0, $34HO0.useFormValidationState)({
        ...props,
        value: state.isSelected
    });
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = validationState.displayValidation;
    let { labelProps: labelProps, inputProps: inputProps, isSelected: isSelected, isPressed: isPressed, isDisabled: isDisabled, isReadOnly: isReadOnly } = (0, $bJcmR.useToggle)({
        ...props,
        isInvalid: isInvalid
    }, state, inputRef);
    (0, $1rqKk.useFormValidation)(props, validationState, inputRef);
    let { isIndeterminate: isIndeterminate, isRequired: isRequired, validationBehavior: validationBehavior = 'aria' } = props;
    (0, $bh6RR.useEffect)(()=>{
        // indeterminate is a property, but it can only be set via javascript
        // https://css-tricks.com/indeterminate-checkboxes/
        if (inputRef.current) inputRef.current.indeterminate = !!isIndeterminate;
    });
    // Reset validation state on label press for checkbox with a hidden input.
    let { pressProps: pressProps } = (0, $b3OV8.usePress)({
        isDisabled: isDisabled || isReadOnly,
        onPress () {
            // @ts-expect-error
            let { [(0, $34HO0.privateValidationStateProp)]: groupValidationState } = props;
            let { commitValidation: commitValidation } = groupValidationState ? groupValidationState : validationState;
            commitValidation();
        }
    });
    return {
        labelProps: (0, $hAxtE.mergeProps)(labelProps, pressProps),
        inputProps: {
            ...inputProps,
            checked: isSelected,
            'aria-required': isRequired && validationBehavior === 'aria' || undefined,
            required: isRequired && validationBehavior === 'native'
        },
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}

});
parcelRegister("1rqKk", function(module, exports) {

$parcel$export(module.exports, "useFormValidation", function () { return $471072d4ef070770$export$b8473d3665f3a75a; });

var $8tXMg = parcelRequire("8tXMg");

var $bh6RR = parcelRequire("bh6RR");

var $i7SiA = parcelRequire("i7SiA");
var $f2PTm = parcelRequire("f2PTm");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $471072d4ef070770$export$b8473d3665f3a75a(props, state, ref) {
    let { validationBehavior: validationBehavior, focus: focus } = props;
    (0, $f2PTm.useLayoutEffect)(()=>{
        if (validationBehavior === 'native' && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(' ') || 'Invalid value.' : '';
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute('title')) ref.current.title = '';
            if (!state.realtimeValidation.isInvalid) state.updateValidation($471072d4ef070770$var$$e93e671b31057976$var$getNativeValidity(ref.current));
        }
    });
    let onReset = (0, $i7SiA.useEffectEvent)(()=>{
        state.resetValidation();
    });
    let onInvalid = (0, $i7SiA.useEffectEvent)((e)=>{
        var _ref_current;
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        if (!e.defaultPrevented && ref && form && $471072d4ef070770$var$$e93e671b31057976$var$getFirstInvalidInput(form) === ref.current) {
            var _ref_current1;
            if (focus) focus();
            else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 || _ref_current1.focus();
            (0, $8tXMg.setInteractionModality)('keyboard');
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    let onChange = (0, $i7SiA.useEffectEvent)(()=>{
        state.commitValidation();
    });
    (0, $bh6RR.useEffect)(()=>{
        let input = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!input) return;
        let form = input.form;
        input.addEventListener('invalid', onInvalid);
        input.addEventListener('change', onChange);
        form === null || form === void 0 || form.addEventListener('reset', onReset);
        return ()=>{
            input.removeEventListener('invalid', onInvalid);
            input.removeEventListener('change', onChange);
            form === null || form === void 0 || form.removeEventListener('reset', onReset);
        };
    }, [
        ref,
        onInvalid,
        onChange,
        onReset,
        validationBehavior
    ]);
}
function $471072d4ef070770$var$$e93e671b31057976$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    let validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $471072d4ef070770$var$$e93e671b31057976$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $471072d4ef070770$var$$e93e671b31057976$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $471072d4ef070770$var$$e93e671b31057976$var$getFirstInvalidInput(form) {
    for(let i = 0; i < form.elements.length; i++){
        let element = form.elements[i];
        if (!element.validity.valid) return element;
    }
    return null;
}

});

parcelRegister("bJcmR", function(module, exports) {

$parcel$export(module.exports, "useToggle", function () { return $bbdbec061a6091c0$export$cbe85ee05b554577; });

var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");
var $1Jnl3 = parcelRequire("1Jnl3");

var $6HV86 = parcelRequire("6HV86");

var $b3OV8 = parcelRequire("b3OV8");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bbdbec061a6091c0$export$cbe85ee05b554577(props, state, ref) {
    let { isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, value: value, name: name, children: children, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, validationState: validationState = 'valid', isInvalid: isInvalid } = props;
    let onChange = (e)=>{
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected(e.target.checked);
    };
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn('If you do not provide children, you must specify an aria-label for accessibility');
    // This handles focusing the input on pointer down, which Safari does not do by default.
    let { pressProps: pressProps, isPressed: isPressed } = (0, $b3OV8.usePress)({
        isDisabled: isDisabled
    });
    // iOS does not toggle checkboxes if you drag off and back onto the label, so handle it ourselves.
    let { pressProps: labelProps, isPressed: isLabelPressed } = (0, $b3OV8.usePress)({
        isDisabled: isDisabled || isReadOnly,
        onPress () {
            state.toggle();
        }
    });
    let { focusableProps: focusableProps } = (0, $6HV86.useFocusable)(props, ref);
    let interactions = (0, $hAxtE.mergeProps)(pressProps, focusableProps);
    let domProps = (0, $bG0JH.filterDOMProps)(props, {
        labelable: true
    });
    (0, $1Jnl3.useFormReset)(ref, state.isSelected, state.setSelected);
    return {
        labelProps: (0, $hAxtE.mergeProps)(labelProps, {
            onClick: (e)=>e.preventDefault()
        }),
        inputProps: (0, $hAxtE.mergeProps)(domProps, {
            'aria-invalid': isInvalid || validationState === 'invalid' || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-controls': props['aria-controls'],
            'aria-readonly': isReadOnly || undefined,
            onChange: onChange,
            disabled: isDisabled,
            ...value == null ? {} : {
                value: value
            },
            name: name,
            type: 'checkbox',
            ...interactions
        }),
        isSelected: state.isSelected,
        isPressed: isPressed || isLabelPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid || validationState === 'invalid'
    };
}

});
parcelRegister("1Jnl3", function(module, exports) {

$parcel$export(module.exports, "useFormReset", function () { return $2dc7275e8743103e$export$5add1d006293d136; });

var $i7SiA = parcelRequire("i7SiA");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2dc7275e8743103e$export$5add1d006293d136(ref, initialValue, onReset) {
    let resetValue = (0, $bh6RR.useRef)(initialValue);
    let handleReset = (0, $i7SiA.useEffectEvent)(()=>{
        if (onReset) onReset(resetValue.current);
    });
    (0, $bh6RR.useEffect)(()=>{
        var _ref_current;
        let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        form === null || form === void 0 || form.addEventListener('reset', handleReset);
        return ()=>{
            form === null || form === void 0 || form.removeEventListener('reset', handleReset);
        };
    }, [
        ref,
        handleReset
    ]);
}

});



parcelRegister("9RCU1", function(module, exports) {

$parcel$export(module.exports, "useCheckboxGroup", function () { return $431bfe98b3218b98$export$49ff6f28c54f1cbe; });

var $8UIUM = parcelRequire("8UIUM");

var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");

var $j61jy = parcelRequire("j61jy");

var $fmkmo = parcelRequire("fmkmo");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $431bfe98b3218b98$export$49ff6f28c54f1cbe(props, state) {
    let { isDisabled: isDisabled, name: name, validationBehavior: validationBehavior = 'aria' } = props;
    let { isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = state.displayValidation;
    let { labelProps: labelProps, fieldProps: fieldProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $j61jy.useField)({
        ...props,
        // Checkbox group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: 'span',
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    });
    (0, $8UIUM.checkboxGroupData).set(state, {
        name: name,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior: validationBehavior
    });
    let domProps = (0, $bG0JH.filterDOMProps)(props, {
        labelable: true
    });
    let { focusWithinProps: focusWithinProps } = (0, $fmkmo.useFocusWithin)({
        onBlurWithin: props.onBlur,
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    });
    return {
        groupProps: (0, $hAxtE.mergeProps)(domProps, {
            role: 'group',
            'aria-disabled': isDisabled || undefined,
            ...fieldProps,
            ...focusWithinProps
        }),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}

});
parcelRegister("8UIUM", function(module, exports) {

$parcel$export(module.exports, "checkboxGroupData", function () { return $bc055120cf819aee$export$ec98120685d4f57d; });
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $bc055120cf819aee$export$ec98120685d4f57d = new WeakMap();

});


parcelRegister("ag647", function(module, exports) {

$parcel$export(module.exports, "useCheckboxGroupItem", function () { return $2dc7922a51dd28e3$export$353b32fc6898d37d; });

var $T6GEz = parcelRequire("T6GEz");

var $8UIUM = parcelRequire("8UIUM");

var $34HO0 = parcelRequire("34HO0");

var $bh6RR = parcelRequire("bh6RR");

var $gvzth = parcelRequire("gvzth");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2dc7922a51dd28e3$export$353b32fc6898d37d(props, state, inputRef) {
    const toggleState = (0, $gvzth.useToggleState)({
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isSelected: state.isSelected(props.value),
        onChange (isSelected) {
            if (isSelected) state.addValue(props.value);
            else state.removeValue(props.value);
            if (props.onChange) props.onChange(isSelected);
        }
    });
    let { name: name, descriptionId: descriptionId, errorMessageId: errorMessageId, validationBehavior: validationBehavior } = (0, $8UIUM.checkboxGroupData).get(state);
    var _props_validationBehavior;
    validationBehavior = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : validationBehavior;
    // Local validation for this checkbox.
    let { realtimeValidation: realtimeValidation } = (0, $34HO0.useFormValidationState)({
        ...props,
        value: toggleState.isSelected,
        // Server validation is handled at the group level.
        name: undefined,
        validationBehavior: 'aria'
    });
    // Update the checkbox group state when realtime validation changes.
    let nativeValidation = (0, $bh6RR.useRef)((0, $34HO0.DEFAULT_VALIDATION_RESULT));
    let updateValidation = ()=>{
        state.setInvalid(props.value, realtimeValidation.isInvalid ? realtimeValidation : nativeValidation.current);
    };
    (0, $bh6RR.useEffect)(updateValidation);
    // Combine group and checkbox level validation.
    let combinedRealtimeValidation = state.realtimeValidation.isInvalid ? state.realtimeValidation : realtimeValidation;
    let displayValidation = validationBehavior === 'native' ? state.displayValidation : combinedRealtimeValidation;
    var _props_isRequired;
    let res = (0, $T6GEz.useCheckbox)({
        ...props,
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isDisabled: props.isDisabled || state.isDisabled,
        name: props.name || name,
        isRequired: (_props_isRequired = props.isRequired) !== null && _props_isRequired !== void 0 ? _props_isRequired : state.isRequired,
        validationBehavior: validationBehavior,
        [(0, $34HO0.privateValidationStateProp)]: {
            realtimeValidation: combinedRealtimeValidation,
            displayValidation: displayValidation,
            resetValidation: state.resetValidation,
            commitValidation: state.commitValidation,
            updateValidation (v) {
                nativeValidation.current = v;
                updateValidation();
            }
        }
    }, toggleState, inputRef);
    return {
        ...res,
        inputProps: {
            ...res.inputProps,
            'aria-describedby': [
                props['aria-describedby'],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(' ') || undefined
        }
    };
}

});
parcelRegister("gvzth", function(module, exports) {

$parcel$export(module.exports, "useToggleState", function () { return $514603caba4a3224$export$8042c6c013fd5226; });

var $ljfvU = parcelRequire("ljfvU");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $514603caba4a3224$export$8042c6c013fd5226(props = {}) {
    let { isReadOnly: isReadOnly } = props;
    // have to provide an empty function so useControlledState doesn't throw a fit
    // can't use useControlledState's prop calling because we need the event object from the change
    let [isSelected, setSelected] = (0, $ljfvU.useControlledState)(props.isSelected, props.defaultSelected || false, props.onChange);
    function updateSelected(value) {
        if (!isReadOnly) setSelected(value);
    }
    function toggleState() {
        if (!isReadOnly) setSelected(!isSelected);
    }
    return {
        isSelected: isSelected,
        setSelected: updateSelected,
        toggle: toggleState
    };
}

});


parcelRegister("47sfU", function(module, exports) {

$parcel$export(module.exports, "useCheckboxGroupState", function () { return $fc0b5c50f3a62913$export$daff6da51032a415; });

var $34HO0 = parcelRequire("34HO0");

var $ljfvU = parcelRequire("ljfvU");

var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fc0b5c50f3a62913$export$daff6da51032a415(props = {}) {
    let [selectedValues, setValue] = (0, $ljfvU.useControlledState)(props.value, props.defaultValue || [], props.onChange);
    let isRequired = !!props.isRequired && selectedValues.length === 0;
    let invalidValues = (0, $bh6RR.useRef)(new Map());
    let validation = (0, $34HO0.useFormValidationState)({
        ...props,
        value: selectedValues
    });
    let isInvalid = validation.displayValidation.isInvalid;
    var _props_validationState;
    const state = {
        ...validation,
        value: selectedValues,
        setValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            setValue(value);
        },
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isSelected (value) {
            return selectedValues.includes(value);
        },
        addValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (!selectedValues.includes(value)) setValue(selectedValues.concat(value));
        },
        removeValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue)=>existingValue !== value));
        },
        toggleValue (value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue)=>existingValue !== value));
            else setValue(selectedValues.concat(value));
        },
        setInvalid (value, v) {
            let s = new Map(invalidValues.current);
            if (v.isInvalid) s.set(value, v);
            else s.delete(value);
            invalidValues.current = s;
            validation.updateValidation((0, $34HO0.mergeValidation)(...s.values()));
        },
        validationState: (_props_validationState = props.validationState) !== null && _props_validationState !== void 0 ? _props_validationState : isInvalid ? 'invalid' : null,
        isInvalid: isInvalid,
        isRequired: isRequired
    };
    return state;
}

});





parcelRegister("gbJfF", function(module, exports) {

$parcel$export(module.exports, "TransactionTimeline", function () { return $d089d5bd1439bcaf$export$dc1b48e83bd9cfae; });

var $ih19M = parcelRequire("ih19M");

var $k0Sb0 = parcelRequire("k0Sb0");

var $7c0yZ = parcelRequire("7c0yZ");
var $5hQd5 = parcelRequire("5hQd5");
parcelRequire("bh6RR");

var $lVuqN = parcelRequire("lVuqN");
parcelRequire("aWtcP");
var $i2TPN = parcelRequire("i2TPN");

var $9SfKt = parcelRequire("9SfKt");

var $8Nljb = parcelRequire("8Nljb");
parcelRequire("6rtue");
var $6QYcK = parcelRequire("6QYcK");

var $7BL3D = parcelRequire("7BL3D");

var $eoNPv = parcelRequire("eoNPv");

var $cclg0 = parcelRequire("cclg0");
const $d089d5bd1439bcaf$export$dc1b48e83bd9cfae = ({ navigate: navigate, dispatch: dispatch, transactions: transactions, transactionFilter: transactionFilter })=>{
    const transactionsTimeline = (0, $i2TPN.useSelector)((0, $8Nljb.transactionsInTimeline));
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flow-root",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
            role: "list",
            className: "space-y-6",
            children: transactionsTimeline.filter((d)=>d.transactions.length > 0).map((d, eventIdx)=>/*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                    className: "relative flex gap-x-4",
                    children: [
                        eventIdx === transactionsTimeline.length - 1 ? /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "h-6 absolute left-0 top-0 flex w-6 justify-center",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "w-px bg-gray-200"
                            })
                        }) : /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "-bottom-6 absolute left-0 top-0 flex w-6 justify-center",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "w-px bg-gray-200"
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "relative flex size-6 flex-none items-center justify-center bg-white",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: "size-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "flex-auto py-0.5 text-xs/5 text-gray-500",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: "font-medium text-gray-900",
                                            children: d.date.toLocaleDateString()
                                        }),
                                        ' ',
                                        (0, $k0Sb0.default)(d.date, 'EEEE'),
                                        d.transactions.filter((transaction)=>transactionFilter === 'all' || transactionFilter.has(transaction.type)).map((t)=>/*#__PURE__*/ (0, $ih19M.jsxs)("p", {
                                                className: "flex gap-3 max-w-md text-gray-500 py-1 sm:py-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                        className: "flex-auto gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                                className: "text-black",
                                                                children: t.raccount
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                                        className: "flex-none text-gray-800",
                                                                        children: t.category ? ` ${t.category}` : ''
                                                                    }),
                                                                    t.description ? ` ${t.description}` : ''
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                        className: "justify-end flex flex-wrap gap-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                                className: $d089d5bd1439bcaf$var$transactionTypeColor({
                                                                    type: t.type
                                                                }),
                                                                children: [
                                                                    $d089d5bd1439bcaf$var$transactionTypeToSymbol(t.type),
                                                                    (0, $7BL3D.toHumanCurrency)(t.value)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $lVuqN.Group), {
                                                                "aria-label": "Actions",
                                                                className: "flex-none space-x-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eoNPv.Button), {
                                                                        "aria-label": "Modify",
                                                                        className: "py-0.5 px-0.5",
                                                                        onPress: ()=>navigate('/transactions/set', (0, $cclg0.navigateToTransactionForm)(t)),
                                                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7c0yZ.default), {
                                                                            className: "max-h-3"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eoNPv.Button), {
                                                                        "aria-label": "Delete",
                                                                        className: "py-0.5 px-0.5",
                                                                        onPress: ()=>dispatch((0, $6QYcK.transactionRemove)({
                                                                                id: t.id
                                                                            })),
                                                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5hQd5.default), {
                                                                            className: "max-h-3"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }))
                                    ]
                                })
                            ]
                        })
                    ]
                }, eventIdx))
        })
    });
};
const $d089d5bd1439bcaf$var$transactionTypeColor = (0, $9SfKt.tv)({
    base: '',
    variants: {
        type: {
            income: 'text-green-700',
            transfer: 'text-purple-700',
            expense: 'text-red-700'
        }
    }
});
const $d089d5bd1439bcaf$var$transactionTypeToSymbol = (type)=>{
    switch(type){
        case 'income':
            return '+';
        case 'expense':
            return '-';
        case 'transfer':
            return "\u21C4";
        default:
            return '';
    }
};

});
parcelRegister("6rtue", function(module, exports) {
$parcel$export(module.exports, "transactionRemove", function () { return (parcelRequire("6QYcK")).transactionRemove; });

$parcel$export(module.exports, "tasks", function () { return $76d4b6b18a80104f$export$7191f9b9098a3ea4; });
$parcel$export(module.exports, "thunks", function () { return (parcelRequire("5EWGz")).thunks; });

var $5EWGz = parcelRequire("5EWGz");
parcelRequire("bDrX3");
parcelRequire("2G5a3");
parcelRequire("7ZEHv");
parcelRequire("6QYcK");
parcelRequire("8S85m");
const $76d4b6b18a80104f$export$7191f9b9098a3ea4 = [];

});
parcelRegister("bDrX3", function(module, exports) {

$parcel$export(module.exports, "updateAuth", function () { return $fd51c242f4c321ff$export$b064b60862b4ee07; });
parcelRequire("9St7S");
var $eAyML = parcelRequire("eAyML");

var $5EWGz = parcelRequire("5EWGz");
const $fd51c242f4c321ff$export$b064b60862b4ee07 = (0, $5EWGz.thunks).create('auth:session', function*(ctx, next) {
    yield* (0, $eAyML.updateStore)(ctx.payload);
    yield* next();
});

});

parcelRegister("2G5a3", function(module, exports) {

$parcel$export(module.exports, "accountAdd", function () { return $3e8a0cf1caf847c5$export$7e4be06412055804; });
$parcel$export(module.exports, "accountRemove", function () { return $3e8a0cf1caf847c5$export$290202b5190d0033; });

var $qqvI6 = parcelRequire("qqvI6");

var $7BL3D = parcelRequire("7BL3D");

var $jUfjK = parcelRequire("jUfjK");

var $5EWGz = parcelRequire("5EWGz");
const $3e8a0cf1caf847c5$export$7e4be06412055804 = (0, $5EWGz.thunks).create('account:add', function*(ctx, next) {
    const rawAccount = {
        ...ctx.payload
    };
    const account = {
        ...rawAccount
    };
    if (!rawAccount.id) account.id = (0, $jUfjK.default)();
    account.starting = (0, $7BL3D.redinero)(rawAccount.starting);
    console.log(rawAccount.interest);
    if (typeof rawAccount.interest === 'number') account.interest = (0, $7BL3D.scaledFromFloat)(rawAccount.interest, 5);
    console.log(rawAccount.interest);
    yield* (0, $qqvI6.schema).update((0, $qqvI6.schema).accounts.add({
        [account.id]: account
    }));
    yield* next();
});
const $3e8a0cf1caf847c5$export$290202b5190d0033 = (0, $5EWGz.thunks).create('account:remove', function*(ctx, next) {
    yield* (0, $qqvI6.schema).update((0, $qqvI6.schema).accounts.remove([
        ctx.payload.id
    ]));
    yield* next();
});

});

parcelRegister("7ZEHv", function(module, exports) {

$parcel$export(module.exports, "changeSetting", function () { return $f4de6f0c2c7f3ad9$export$a243d10711d7f4ca; });
parcelRequire("9St7S");
var $eAyML = parcelRequire("eAyML");

var $qqvI6 = parcelRequire("qqvI6");

var $5EWGz = parcelRequire("5EWGz");
const $f4de6f0c2c7f3ad9$export$a243d10711d7f4ca = (0, $5EWGz.thunks).create('setting', function*(ctx, next) {
    const { key: key, value: value } = ctx.payload;
    if (key === 'all') {
        const settings = yield* (0, $eAyML.select)((0, $qqvI6.schema).settings.select);
        const newSettings = Object.keys(settings).reduce((finalSettings, setting)=>{
            finalSettings[setting] = value;
            return finalSettings;
        }, {
            ...settings
        });
        yield* (0, $qqvI6.schema).update((0, $qqvI6.schema).settings.set(newSettings));
    } else yield* (0, $qqvI6.schema).update((0, $qqvI6.schema).settings.update({
        key: key,
        value: value
    }));
    yield* next();
});

});

parcelRegister("8S85m", function(module, exports) {

$parcel$export(module.exports, "updateChartDateRange", function () { return $0a4a75f01dc2c992$export$cf0ea6fcb03815fe; });

var $l7KXm = parcelRequire("l7KXm");
var $ejCCE = parcelRequire("ejCCE");

var $qqvI6 = parcelRequire("qqvI6");

var $5EWGz = parcelRequire("5EWGz");
const $0a4a75f01dc2c992$export$cf0ea6fcb03815fe = (0, $5EWGz.thunks).create('chartDateRange:update', function*(ctx, next) {
    const startDateInput = ctx.payload;
    const start = (0, $ejCCE.default)(startDateInput, 'yyyy-MM-dd', new Date());
    const end = (0, $l7KXm.default)(start, 1);
    yield* (0, $qqvI6.schema).update((0, $qqvI6.schema).chartRange.set({
        start: start,
        end: end
    }));
    yield* next();
});

});
parcelRegister("l7KXm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f60eacfe0e9716b8$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $4jKL6 = parcelRequire("4jKL6");

var $6RzIO = parcelRequire("6RzIO");
function $f60eacfe0e9716b8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $4jKL6.default)(dirtyDate, amount * 12);
}

});
parcelRegister("4jKL6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $324d3518b1b08498$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $324d3518b1b08498$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});


parcelRegister("ejCCE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6c0cca4ba136238$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $7octi = parcelRequire("7octi");

var $fhQJu = parcelRequire("fhQJu");

var $cfoI5 = parcelRequire("cfoI5");

var $le96L = parcelRequire("le96L");

var $5lXXI = parcelRequire("5lXXI");

var $dmQbx = parcelRequire("dmQbx");

var $8zxzx = parcelRequire("8zxzx");

var $xRN1E = parcelRequire("xRN1E");

var $8d3vD = parcelRequire("8d3vD");

var $6RzIO = parcelRequire("6RzIO");

var $bF26l = parcelRequire("bF26l");

var $dLP8x = parcelRequire("dLP8x");

var $dCCOX = parcelRequire("dCCOX");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $a6c0cca4ba136238$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $a6c0cca4ba136238$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $a6c0cca4ba136238$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $a6c0cca4ba136238$var$doubleQuoteRegExp = /''/g;
var $a6c0cca4ba136238$var$notWhitespaceRegExp = /\S/;
var $a6c0cca4ba136238$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $a6c0cca4ba136238$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $6RzIO.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $fhQJu.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $8d3vD.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $8d3vD.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $le96L.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $bF26l.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($a6c0cca4ba136238$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $dmQbx.default)) {
            var longFormatter = (0, $dmQbx.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($a6c0cca4ba136238$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $7octi.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $xRN1E.isProtectedWeekYearToken)(token)) (0, $xRN1E.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $xRN1E.isProtectedDayOfYearToken)(token)) (0, $xRN1E.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $dLP8x.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($a6c0cca4ba136238$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $a6c0cca4ba136238$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $51lpG.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $a6c0cca4ba136238$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $le96L.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $cfoI5.default)(date, (0, $8zxzx.default)(date));
    var flags = {};
    var _iterator2 = (0, $7octi.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $5lXXI.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $a6c0cca4ba136238$var$cleanEscapedString(input) {
    return input.match($a6c0cca4ba136238$var$escapedStringRegExp)[1].replace($a6c0cca4ba136238$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("7octi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $561472df61666821$export$2e2bcd8739ae039; });

var $9F6mQ = parcelRequire("9F6mQ");
function $561472df61666821$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $9F6mQ.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});
parcelRegister("9F6mQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $708ce1d4f20bd938$export$2e2bcd8739ae039; });

var $cnxX0 = parcelRequire("cnxX0");
function $708ce1d4f20bd938$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $cnxX0.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $cnxX0.default)(r, a) : void 0;
    }
}

});
parcelRegister("cnxX0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9031f7f2924753e9$export$2e2bcd8739ae039; });
function $9031f7f2924753e9$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});



parcelRegister("5lXXI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e5d6d2694ed7592$export$2e2bcd8739ae039; });
function $3e5d6d2694ed7592$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("bF26l", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $87d5274f95235e24$export$9a09e32dd4990fd5; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $87d5274f95235e24$export$5aaf7ff7f09ea4ee; });

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $2ryml = parcelRequire("2ryml");
var $87d5274f95235e24$var$TIMEZONE_UNIT_PRIORITY = 10;
var $87d5274f95235e24$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $fivc7.default)(this, Setter);
        (0, $2ryml.default)(this, "priority", void 0);
        (0, $2ryml.default)(this, "subPriority", 0);
    }
    (0, $kuNiL.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $87d5274f95235e24$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $7uMzR.default)(ValueSetter, _Setter);
    var _super = (0, $1JyKh.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $fivc7.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $kuNiL.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($87d5274f95235e24$export$81d53e3678089a6);
var $87d5274f95235e24$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $7uMzR.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $1JyKh.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $fivc7.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this2), "priority", $87d5274f95235e24$var$TIMEZONE_UNIT_PRIORITY);
        (0, $2ryml.default)((0, $hqR4t.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $kuNiL.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($87d5274f95235e24$export$81d53e3678089a6);

});
parcelRegister("hqR4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb0e0834598ff6d6$export$2e2bcd8739ae039; });
function $cb0e0834598ff6d6$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("7uMzR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5751042f9a4a77f6$export$2e2bcd8739ae039; });

var $hloi6 = parcelRequire("hloi6");
function $5751042f9a4a77f6$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $hloi6.default)(t, e);
}

});
parcelRegister("hloi6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca073d81f2a471af$export$2e2bcd8739ae039; });
function $ca073d81f2a471af$export$2e2bcd8739ae039(t, e) {
    return $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ca073d81f2a471af$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("1JyKh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1434f224efb0ce22$export$2e2bcd8739ae039; });

var $k5JCq = parcelRequire("k5JCq");

var $1TADt = parcelRequire("1TADt");

var $gLqR5 = parcelRequire("gLqR5");
function $1434f224efb0ce22$export$2e2bcd8739ae039(t) {
    var r = (0, $1TADt.default)();
    return function() {
        var e, o = (0, $k5JCq.default)(t);
        if (r) {
            var s = (0, $k5JCq.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $gLqR5.default)(this, e);
    };
}

});
parcelRegister("k5JCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea07a931d040ec2a$export$2e2bcd8739ae039; });
function $ea07a931d040ec2a$export$2e2bcd8739ae039(t) {
    return $ea07a931d040ec2a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ea07a931d040ec2a$export$2e2bcd8739ae039(t);
}

});

parcelRegister("1TADt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1617589007256c62$export$2e2bcd8739ae039; });
function $1617589007256c62$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1617589007256c62$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("gLqR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c345de07753d2fca$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $hqR4t = parcelRequire("hqR4t");
function $c345de07753d2fca$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $51lpG.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hqR4t.default)(t);
}

});


parcelRegister("fivc7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b230bc0d4245014d$export$2e2bcd8739ae039; });
function $b230bc0d4245014d$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("kuNiL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eebcda4657ff09bb$export$2e2bcd8739ae039; });

var $hTglg = parcelRequire("hTglg");
function $eebcda4657ff09bb$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $hTglg.default)(o.key), o);
    }
}
function $eebcda4657ff09bb$export$2e2bcd8739ae039(e, r, t) {
    return r && $eebcda4657ff09bb$var$_defineProperties(e.prototype, r), t && $eebcda4657ff09bb$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("hTglg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0643fe154cb74c1$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $cMfNc = parcelRequire("cMfNc");
function $d0643fe154cb74c1$export$2e2bcd8739ae039(t) {
    var i = (0, $cMfNc.default)(t, "string");
    return "symbol" == (0, $51lpG.default)(i) ? i : i + "";
}

});
parcelRegister("cMfNc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94d637ce061dd3ca$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");
function $94d637ce061dd3ca$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $51lpG.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $51lpG.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("2ryml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c78c172f6af0e63$export$2e2bcd8739ae039; });

var $hTglg = parcelRequire("hTglg");
function $1c78c172f6af0e63$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $hTglg.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});


parcelRegister("dLP8x", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $a06754d708967e28$export$19131010e7fd8373; });

var $kfK2H = parcelRequire("kfK2H");

var $7giry = parcelRequire("7giry");

var $bCjfP = parcelRequire("bCjfP");

var $erSGt = parcelRequire("erSGt");

var $b8jnr = parcelRequire("b8jnr");

var $9AuQQ = parcelRequire("9AuQQ");

var $fE7CR = parcelRequire("fE7CR");

var $4rJhG = parcelRequire("4rJhG");

var $l09IK = parcelRequire("l09IK");

var $kHjhn = parcelRequire("kHjhn");

var $ijC3v = parcelRequire("ijC3v");

var $k1agz = parcelRequire("k1agz");

var $hfumD = parcelRequire("hfumD");

var $34xUW = parcelRequire("34xUW");

var $1hrH9 = parcelRequire("1hrH9");

var $1y17U = parcelRequire("1y17U");

var $lAmiB = parcelRequire("lAmiB");

var $hBBos = parcelRequire("hBBos");

var $iaLki = parcelRequire("iaLki");

var $hjAYL = parcelRequire("hjAYL");

var $5c3u4 = parcelRequire("5c3u4");

var $gBHKn = parcelRequire("gBHKn");

var $iBp2S = parcelRequire("iBp2S");

var $5MoaU = parcelRequire("5MoaU");

var $4WIYq = parcelRequire("4WIYq");

var $pKJVW = parcelRequire("pKJVW");

var $9ieQT = parcelRequire("9ieQT");

var $58dhe = parcelRequire("58dhe");

var $5zhxn = parcelRequire("5zhxn");

var $ap9CX = parcelRequire("ap9CX");

var $iiRyl = parcelRequire("iiRyl");
var $a06754d708967e28$export$19131010e7fd8373 = {
    G: new (0, $kfK2H.EraParser)(),
    y: new (0, $7giry.YearParser)(),
    Y: new (0, $bCjfP.LocalWeekYearParser)(),
    R: new (0, $erSGt.ISOWeekYearParser)(),
    u: new (0, $b8jnr.ExtendedYearParser)(),
    Q: new (0, $9AuQQ.QuarterParser)(),
    q: new (0, $fE7CR.StandAloneQuarterParser)(),
    M: new (0, $4rJhG.MonthParser)(),
    L: new (0, $l09IK.StandAloneMonthParser)(),
    w: new (0, $kHjhn.LocalWeekParser)(),
    I: new (0, $ijC3v.ISOWeekParser)(),
    d: new (0, $k1agz.DateParser)(),
    D: new (0, $hfumD.DayOfYearParser)(),
    E: new (0, $34xUW.DayParser)(),
    e: new (0, $1hrH9.LocalDayParser)(),
    c: new (0, $1y17U.StandAloneLocalDayParser)(),
    i: new (0, $lAmiB.ISODayParser)(),
    a: new (0, $hBBos.AMPMParser)(),
    b: new (0, $iaLki.AMPMMidnightParser)(),
    B: new (0, $hjAYL.DayPeriodParser)(),
    h: new (0, $5c3u4.Hour1to12Parser)(),
    H: new (0, $gBHKn.Hour0to23Parser)(),
    K: new (0, $iBp2S.Hour0To11Parser)(),
    k: new (0, $5MoaU.Hour1To24Parser)(),
    m: new (0, $4WIYq.MinuteParser)(),
    s: new (0, $pKJVW.SecondParser)(),
    S: new (0, $9ieQT.FractionOfSecondParser)(),
    X: new (0, $58dhe.ISOTimezoneWithZParser)(),
    x: new (0, $5zhxn.ISOTimezoneParser)(),
    t: new (0, $ap9CX.TimestampSecondsParser)(),
    T: new (0, $iiRyl.TimestampMillisecondsParser)()
};

});
parcelRegister("kfK2H", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $ebe8ec790bf47813$export$8e5a1d3f85a9688; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");
var $ebe8ec790bf47813$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(EraParser, _Parser);
    var _super = (0, $1JyKh.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $fivc7.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 140);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $hUQxR.Parser));

});
parcelRegister("hUQxR", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $d0b06d02a4758be0$export$7acfa6ed01010e37; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $2ryml = parcelRequire("2ryml");

var $bF26l = parcelRequire("bF26l");
var $d0b06d02a4758be0$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $fivc7.default)(this, Parser);
        (0, $2ryml.default)(this, "incompatibleTokens", void 0);
        (0, $2ryml.default)(this, "priority", void 0);
        (0, $2ryml.default)(this, "subPriority", void 0);
    }
    (0, $kuNiL.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $bF26l.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("7giry", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $549855817f3e82c6$export$48d352de7cd4a988; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $549855817f3e82c6$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(YearParser, _Parser);
    var _super = (0, $1JyKh.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $fivc7.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 130);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $34rIp.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $hUQxR.Parser));

});
parcelRegister("34rIp", function(module, exports) {

$parcel$export(module.exports, "mapValue", function () { return $23c73e81834f16a1$export$4f84e3a82c7b538; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $23c73e81834f16a1$export$cc7cc9e2a3ff9388; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $23c73e81834f16a1$export$6497f4c0ecdfba8e; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $23c73e81834f16a1$export$d931c43c4608a164; });
$parcel$export(module.exports, "parseNDigits", function () { return $23c73e81834f16a1$export$513bb01536146ab6; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $23c73e81834f16a1$export$2c9307b2e29c533c; });
$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $23c73e81834f16a1$export$fb506d2676e7f207; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $23c73e81834f16a1$export$29126f735cbf69f7; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $23c73e81834f16a1$export$3d50627710b84d75; });

var $6QTFS = parcelRequire("6QTFS");

var $hTmlY = parcelRequire("hTmlY");
function $23c73e81834f16a1$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $23c73e81834f16a1$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $23c73e81834f16a1$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $6QTFS.millisecondsInHour) + minutes * (0, $6QTFS.millisecondsInMinute) + seconds * (0, $6QTFS.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $23c73e81834f16a1$export$d931c43c4608a164(dateString) {
    return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).anyDigitsSigned, dateString);
}
function $23c73e81834f16a1$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).singleDigit, dateString);
        case 2:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).twoDigits, dateString);
        case 3:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).threeDigits, dateString);
        case 4:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).fourDigits, dateString);
        default:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $23c73e81834f16a1$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $23c73e81834f16a1$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $23c73e81834f16a1$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $23c73e81834f16a1$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("hTmlY", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", function () { return $d068e9ab48ef4207$export$c123ee06d9da8480; });
$parcel$export(module.exports, "timezonePatterns", function () { return $d068e9ab48ef4207$export$a7ee192b982af9c1; });
var $d068e9ab48ef4207$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $d068e9ab48ef4207$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("bCjfP", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $87522dd793180ae9$export$b8ef38dfcf05d5db; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $e0HMe = parcelRequire("e0HMe");

var $j1YKz = parcelRequire("j1YKz");
var $87522dd793180ae9$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $1JyKh.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $fivc7.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 130);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $e0HMe.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $34rIp.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $j1YKz.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $j1YKz.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $hUQxR.Parser));

});

parcelRegister("erSGt", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $a84e016bf722cd37$export$951d1df011fde06f; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $byvVj = parcelRequire("byvVj");
var $a84e016bf722cd37$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $1JyKh.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $fivc7.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 130);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $34rIp.parseNDigitsSigned)(4, dateString);
                return (0, $34rIp.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $byvVj.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $hUQxR.Parser));

});

parcelRegister("b8jnr", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $81af78f43f454158$export$bad9d2ea38e8f1a; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $81af78f43f454158$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(ExtendedYearParser, _Parser);
    var _super = (0, $1JyKh.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $fivc7.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 130);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $34rIp.parseNDigitsSigned)(4, dateString);
                return (0, $34rIp.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $hUQxR.Parser));

});

parcelRegister("9AuQQ", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $6faf6842e3324a5b$export$5cb0f701186dde1d; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $6faf6842e3324a5b$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(QuarterParser, _Parser);
    var _super = (0, $1JyKh.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $fivc7.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 120);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $hUQxR.Parser));

});

parcelRegister("fE7CR", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $b64081c42280f47c$export$300c0c2990e20e6d; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $b64081c42280f47c$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $1JyKh.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $fivc7.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 120);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $hUQxR.Parser));

});

parcelRegister("4rJhG", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $33cccf8698e26325$export$400dd8b40ef138a3; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $34rIp = parcelRequire("34rIp");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");
var $33cccf8698e26325$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(MonthParser, _Parser);
    var _super = (0, $1JyKh.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $fivc7.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 110);
        return _this;
    }
    (0, $kuNiL.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $hUQxR.Parser));

});

parcelRegister("l09IK", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $f4a12364ed86f021$export$1d7eaa53eaa5deba; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $f4a12364ed86f021$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $1JyKh.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $fivc7.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 110);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $hUQxR.Parser));

});

parcelRegister("kHjhn", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $f116c747f72ce972$export$c4005ffc174e07c0; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");

var $dv4uq = parcelRequire("dv4uq");

var $j1YKz = parcelRequire("j1YKz");
var $f116c747f72ce972$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(LocalWeekParser, _Parser);
    var _super = (0, $1JyKh.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $fivc7.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 100);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $j1YKz.default)((0, $dv4uq.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $hUQxR.Parser));

});
parcelRegister("dv4uq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d41a7323856a4d2$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $bCYgf = parcelRequire("bCYgf");

var $6RzIO = parcelRequire("6RzIO");
function $9d41a7323856a4d2$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var week = (0, $8d3vD.default)(dirtyWeek);
    var diff = (0, $bCYgf.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("ijC3v", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $d557856122cd2900$export$6fc8dbedd560a6af; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");

var $eK3pq = parcelRequire("eK3pq");

var $byvVj = parcelRequire("byvVj");
var $d557856122cd2900$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(ISOWeekParser, _Parser);
    var _super = (0, $1JyKh.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $fivc7.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 100);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $byvVj.default)((0, $eK3pq.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $hUQxR.Parser));

});
parcelRegister("eK3pq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abb8018924dbdc39$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $9rMx7 = parcelRequire("9rMx7");

var $6RzIO = parcelRequire("6RzIO");
function $abb8018924dbdc39$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var isoWeek = (0, $8d3vD.default)(dirtyISOWeek);
    var diff = (0, $9rMx7.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("k1agz", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $03c2c5a25468de8c$export$e8d4b28a20981dd2; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $34rIp = parcelRequire("34rIp");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");
var $03c2c5a25468de8c$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $03c2c5a25468de8c$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $03c2c5a25468de8c$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(DateParser, _Parser);
    var _super = (0, $1JyKh.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $fivc7.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 90);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "subPriority", 1);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $34rIp.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $03c2c5a25468de8c$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $03c2c5a25468de8c$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $hUQxR.Parser));

});

parcelRegister("hfumD", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $c8eb640c9739e432$export$6cfe0d613455f615; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $c8eb640c9739e432$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(DayOfYearParser, _Parser);
    var _super = (0, $1JyKh.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $fivc7.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 90);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "subpriority", 1);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $34rIp.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $hUQxR.Parser));

});

parcelRegister("34xUW", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $23cc0e1fc897acb6$export$1b03c8b76262f7bd; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $crAxU = parcelRequire("crAxU");
var $23cc0e1fc897acb6$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(DayParser, _Parser);
    var _super = (0, $1JyKh.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $fivc7.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 90);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $crAxU.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $hUQxR.Parser));

});
parcelRegister("crAxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90f45aecbf821b24$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");

var $dCCOX = parcelRequire("dCCOX");
function $90f45aecbf821b24$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(2, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var weekStartsOn = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $le96L.default)(dirtyDate);
    var day = (0, $8d3vD.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("1hrH9", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $0eecdc9e9334cc90$export$44d1c127ab42c480; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $crAxU = parcelRequire("crAxU");
var $0eecdc9e9334cc90$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(LocalDayParser, _Parser);
    var _super = (0, $1JyKh.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $fivc7.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 90);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $crAxU.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $hUQxR.Parser));

});

parcelRegister("1y17U", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $1209d7268c6c9e45$export$e447a647caaaec1d; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $crAxU = parcelRequire("crAxU");
var $1209d7268c6c9e45$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $1JyKh.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $fivc7.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 90);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $crAxU.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $hUQxR.Parser));

});

parcelRegister("lAmiB", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $fb6e41e61f98589a$export$693fb1e525095b2a; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $4QPB4 = parcelRequire("4QPB4");
var $fb6e41e61f98589a$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(ISODayParser, _Parser);
    var _super = (0, $1JyKh.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $fivc7.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 90);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $34rIp.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $34rIp.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $34rIp.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $34rIp.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $4QPB4.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $hUQxR.Parser));

});
parcelRegister("4QPB4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38840ad6986b421a$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $38840ad6986b421a$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $6RzIO.default)(2, arguments);
    var day = (0, $8d3vD.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $le96L.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("hBBos", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $cd12e5ead675216a$export$8d1e08492351df91; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $cd12e5ead675216a$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(AMPMParser, _Parser);
    var _super = (0, $1JyKh.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $fivc7.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 80);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $34rIp.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $hUQxR.Parser));

});

parcelRegister("iaLki", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $d3addf314db295bf$export$73ca2bd0a17d273; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $d3addf314db295bf$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $1JyKh.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $fivc7.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 80);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $34rIp.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $hUQxR.Parser));

});

parcelRegister("hjAYL", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $c9b0e545431616d4$export$bb9212adf05373db; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $c9b0e545431616d4$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(DayPeriodParser, _Parser);
    var _super = (0, $1JyKh.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $fivc7.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 80);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $34rIp.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $hUQxR.Parser));

});

parcelRegister("5c3u4", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $3c80c6964acf8bae$export$8a04050a727a1756; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $3c80c6964acf8bae$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(Hour1to12Parser, _Parser);
    var _super = (0, $1JyKh.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $fivc7.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 70);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $hUQxR.Parser));

});

parcelRegister("gBHKn", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $c1720943b4076094$export$e56f4dea2c3e56dd; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $c1720943b4076094$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(Hour0to23Parser, _Parser);
    var _super = (0, $1JyKh.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $fivc7.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 70);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $hUQxR.Parser));

});

parcelRegister("iBp2S", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $d8af1c30a51245af$export$cbbe855312f87d77; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $d8af1c30a51245af$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(Hour0To11Parser, _Parser);
    var _super = (0, $1JyKh.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $fivc7.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 70);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $hUQxR.Parser));

});

parcelRegister("5MoaU", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $43543015b40a6495$export$6008046d2b34b6a5; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $43543015b40a6495$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(Hour1To24Parser, _Parser);
    var _super = (0, $1JyKh.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $fivc7.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 70);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $hUQxR.Parser));

});

parcelRegister("4WIYq", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $399f7706a432e843$export$2b52670d9e2be53; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $399f7706a432e843$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(MinuteParser, _Parser);
    var _super = (0, $1JyKh.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $fivc7.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 60);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $hUQxR.Parser));

});

parcelRegister("pKJVW", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $04d6977a32f84464$export$94d46d540cf1366a; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $04d6977a32f84464$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(SecondParser, _Parser);
    var _super = (0, $1JyKh.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $fivc7.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 50);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $hUQxR.Parser));

});

parcelRegister("9ieQT", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $6c4150d24044e0a5$export$b8e6f8b2d70893b1; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $6c4150d24044e0a5$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $1JyKh.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $fivc7.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 30);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $hUQxR.Parser));

});

parcelRegister("58dhe", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $3bc7ffa050e36def$export$104d901d49fea29b; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $3bc7ffa050e36def$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $1JyKh.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $fivc7.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 10);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $hUQxR.Parser));

});

parcelRegister("5zhxn", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $40ddd330e4d7bdd4$export$12910e5204b52b9; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
var $40ddd330e4d7bdd4$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $1JyKh.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $fivc7.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 10);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $kuNiL.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $hUQxR.Parser));

});

parcelRegister("ap9CX", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $7933b4f85229502e$export$2cd8bf877a05e96; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $7933b4f85229502e$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $1JyKh.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $fivc7.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 40);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $kuNiL.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $34rIp.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $hUQxR.Parser));

});

parcelRegister("iiRyl", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $d53372f35b035150$export$6d8f69c6906d6368; });

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $1JyKh = parcelRequire("1JyKh");

var $2ryml = parcelRequire("2ryml");

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
var $d53372f35b035150$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $7uMzR.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $1JyKh.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $fivc7.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "priority", 20);
        (0, $2ryml.default)((0, $hqR4t.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $kuNiL.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $34rIp.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $hUQxR.Parser));

});







parcelRegister("i4Ato", function(module, exports) {

$parcel$export(module.exports, "importEntries", function () { return $764df1567c2df7b1$export$d4c0344aed1dede4; });
parcelRequire("9St7S");
var $krVVU = parcelRequire("krVVU");

var $qqvI6 = parcelRequire("qqvI6");

var $kPdv0 = parcelRequire("kPdv0");

var $2G5a3 = parcelRequire("2G5a3");

var $5EWGz = parcelRequire("5EWGz");

var $k8U1X = parcelRequire("k8U1X");

var $6QYcK = parcelRequire("6QYcK");
const $764df1567c2df7b1$export$d4c0344aed1dede4 = (0, $5EWGz.thunks).create('importEntries', function*(ctx, next) {
    const { transactions: transactions, accounts: accounts, chartRange: chartRange, incomeReceived: incomeReceived, incomeExpected: incomeExpected } = (0, $kPdv0.reconcilerWithReconstitution)({}, ctx.payload);
    yield* (0, $qqvI6.schema).update([
        (0, $qqvI6.schema).transactions.reset(),
        (0, $qqvI6.schema).accounts.reset(),
        (0, $qqvI6.schema).chartRange.reset()
    ]);
    // the fires off a dispatch and returns immediately
    for (let account of accounts)yield* (0, $krVVU.put)((0, $2G5a3.accountAdd)(account));
    for (let transaction of transactions)yield* (0, $krVVU.put)((0, $6QYcK.transactionAdd)(transaction));
    if (chartRange?.start) yield* (0, $qqvI6.schema).update((0, $qqvI6.schema).chartRange.set(chartRange));
    if (incomeReceived) for (let income of incomeReceived)yield* (0, $krVVU.put)((0, $k8U1X.addIncomeReceived)(income));
    if (incomeExpected) for (let expected of incomeExpected)yield* (0, $krVVU.put)((0, $k8U1X.addIncomeExpected)(expected));
    yield* next();
});

});
parcelRegister("kPdv0", function(module, exports) {

$parcel$export(module.exports, "reconcilerWithReconstitution", function () { return $af53f1eb505b4eb6$export$aeb62f041c787429; });

var $kOtqV = parcelRequire("kOtqV");

var $6HqIz = parcelRequire("6HqIz");
function $af53f1eb505b4eb6$var$reconstitute(sliceName, item) {
    if (!item || typeof item !== 'object' && Object.entries(item).length > 0) return item;
    const reconstituted = {
        ...item
    };
    for (const [key, value] of Object.entries(item)){
        if (value && typeof value === 'object') {
            if ('amount' in value && 'currency' in value && 'scale' in value) reconstituted[key] = (0, $6HqIz.dinero)(value);
        }
    }
    return reconstituted;
}
function $af53f1eb505b4eb6$export$aeb62f041c787429(original, persisted) {
    const reconstituted = {
        ...persisted
    };
    const sliceNames = [
        'accounts',
        'transactions'
    ];
    for (const sliceName of sliceNames){
        if (sliceName in persisted) for (const [key, item] of Object.entries(persisted[sliceName])){
            const updatedData = $af53f1eb505b4eb6$var$reconstitute(sliceName, item);
            reconstituted[sliceName][key] = updatedData;
        }
    }
    if (reconstituted.chartRange) reconstituted.chartRange = {
        start: (0, $kOtqV.default)(reconstituted.chartRange.start),
        end: (0, $kOtqV.default)(reconstituted.chartRange.end)
    };
    return {
        ...original,
        ...reconstituted
    };
}

});
parcelRegister("kOtqV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f26f4f020ec09d14$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $f26f4f020ec09d14$export$2e2bcd8739ae039(argument) {
    (0, $6RzIO.default)(1, arguments);
    if (typeof argument === 'string') {
        var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
        if (parts) // Group 8 matches the sign
        return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == '-' ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == '-' ? -1 : 1), +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
        return new Date(NaN);
    }
    return (0, $le96L.default)(argument);
}

});


parcelRegister("k8U1X", function(module, exports) {

$parcel$export(module.exports, "addIncomeReceived", function () { return $9c0a35cd5f77f481$export$92fd8c5d9eef6443; });
$parcel$export(module.exports, "addIncomeExpected", function () { return $9c0a35cd5f77f481$export$d39f07485401a2e2; });

var $8xOSr = parcelRequire("8xOSr");

var $6HqIz = parcelRequire("6HqIz");

var $qqvI6 = parcelRequire("qqvI6");

var $jUfjK = parcelRequire("jUfjK");

var $5EWGz = parcelRequire("5EWGz");
const $9c0a35cd5f77f481$export$92fd8c5d9eef6443 = (0, $5EWGz.thunks).create('incomeReceived:add', function*(ctx, next) {
    const income = {
        ...ctx.payload
    };
    if (!income?.id) income.id = (0, $jUfjK.default)();
    const incomeDineroed = Object.entries(income).reduce((dineroed, [key, value])=>{
        dineroed[key] = typeof value === 'number' ? (0, $6HqIz.dinero)({
            amount: value,
            currency: (0, $8xOSr.USD)
        }) : value;
        return dineroed;
    }, {});
    yield* (0, $qqvI6.schema).update((0, $qqvI6.schema).incomeReceived.add({
        [income.id]: incomeDineroed
    }));
    yield* next();
});
const $9c0a35cd5f77f481$export$d39f07485401a2e2 = (0, $5EWGz.thunks).create('incomeExpected:add', function*(ctx, next) {
    const income = {
        ...ctx.payload
    };
    if (!income?.id) income.id = (0, $jUfjK.default)();
    yield* (0, $qqvI6.schema).update((0, $qqvI6.schema).incomeExpected.add({
        [income.id]: income
    }));
    yield* next();
});

});


parcelRegister("dTGcU", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("igwyJ").then(()=>parcelRequire('ZGhMq'));

});

parcelRegister("6smLu", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("8e15H"),
    $hffE7("buDHl"),
    $hffE7("bB8MH"),
    $hffE7("pwHtW")
]).then(()=>parcelRequire('6Nld0'));

});

parcelRegister("csDxh", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("gLFCs"),
    $hffE7("ifs8l")
]).then(()=>parcelRequire('8o1QY'));

});

parcelRegister("bNAqU", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("6n6p1").then(()=>parcelRequire('aJw1O'));

});

parcelRegister("jjSgE", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("6J2No"),
    $hffE7("buDHl"),
    $hffE7("89pai")
]).then(()=>parcelRequire('j7A12'));

});

parcelRegister("kz8rh", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("ed4uH").then(()=>parcelRequire('7gOdD'));

});

parcelRegister("6CBuk", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("6J2No"),
    $hffE7("buDHl"),
    $hffE7("bB8MH"),
    $hffE7("1EedH")
]).then(()=>parcelRequire('4nMdt'));

});

parcelRegister("jEvCB", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("gLFCs"),
    $hffE7("8e15H"),
    $hffE7("6SHXU")
]).then(()=>parcelRequire('ggb9e'));

});

parcelRegister("9UHRn", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("byx59").then(()=>parcelRequire('lpujR'));

});

parcelRegister("jGWx2", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("axIUG").then(()=>parcelRequire('j5Czy'));

});

parcelRegister("9YDuP", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("gQ2ae").then(()=>parcelRequire('e6O1p'));

});

var $ee4f39ea28c3478f$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"2lyl3\",\"index.9debe6a7.js\",\"i8uP8\",\"browser.686d0696.js\",\"igwyJ\",\"settings.4ee0ebd2.js\",\"pwHtW\",\"flow.295a6df7.js\",\"bB8MH\",\"flow.8ab0071d.js\",\"buDHl\",\"flow.e0e16ce8.js\",\"8e15H\",\"flow.ec54615a.js\",\"ifs8l\",\"accounts.5405d929.js\",\"gLFCs\",\"accounts.2b349542.js\",\"6n6p1\",\"container.1515c03d.js\",\"89pai\",\"accountInput.cd69dd5f.js\",\"6J2No\",\"accountInput.0a4c8020.js\",\"ed4uH\",\"container.ed6d0741.js\",\"1EedH\",\"transactionInput.e25e34d1.js\",\"6SHXU\",\"planning.b2370efa.js\",\"byx59\",\"financialindependence.0a717d7f.js\",\"axIUG\",\"importing.41367f11.js\",\"gQ2ae\",\"taxes.bba4eb1e.js\"]"));


var $ih19M = parcelRequire("ih19M");

const $1837e2f814e6b26b$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("8oL7M"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};


class $37df52de00425e52$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class $37df52de00425e52$export$14f2b6540d498ce extends $37df52de00425e52$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $37df52de00425e52$export$d08a45df86040161 extends $37df52de00425e52$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $37df52de00425e52$export$761f8c0e0fa4624f extends $37df52de00425e52$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $37df52de00425e52$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($37df52de00425e52$export$9b19f1a5abf91e06 || ($37df52de00425e52$export$9b19f1a5abf91e06 = {}));


var $8644507f4d2bfb12$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $8644507f4d2bfb12$export$1d0b400bf8a0fa55 {
    constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $37df52de00425e52$export$9b19f1a5abf91e06).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $1837e2f814e6b26b$export$98d92b1aa79f8cc7)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     */ invoke(functionName, options = {}) {
        var _a;
        return $8644507f4d2bfb12$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const { headers: headers, method: method, body: functionArgs } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                if (region && region !== 'any') _headers['x-region'] = region;
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                }
                const response = yield this.fetch(`${this.url}/${functionName}`, {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body
                }).catch((fetchError)=>{
                    throw new (0, $37df52de00425e52$export$14f2b6540d498ce)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $37df52de00425e52$export$d08a45df86040161)(response);
                if (!response.ok) throw new (0, $37df52de00425e52$export$761f8c0e0fa4624f)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                return {
                    data: null,
                    error: error
                };
            }
        });
    }
}


var $0a295593f55aceac$exports = {};
"use strict";
var $0a295593f55aceac$var$__importDefault = $0a295593f55aceac$exports && $0a295593f55aceac$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($0a295593f55aceac$exports, "__esModule", {
    value: true
});
$0a295593f55aceac$exports.PostgrestError = $0a295593f55aceac$exports.PostgrestBuilder = $0a295593f55aceac$exports.PostgrestTransformBuilder = $0a295593f55aceac$exports.PostgrestFilterBuilder = $0a295593f55aceac$exports.PostgrestQueryBuilder = $0a295593f55aceac$exports.PostgrestClient = void 0;

// Always update wrapper.mjs when updating this file.
const $0a295593f55aceac$var$PostgrestClient_1 = $0a295593f55aceac$var$__importDefault((parcelRequire("eB0am")));
$0a295593f55aceac$exports.PostgrestClient = $0a295593f55aceac$var$PostgrestClient_1.default;

const $0a295593f55aceac$var$PostgrestQueryBuilder_1 = $0a295593f55aceac$var$__importDefault((parcelRequire("3KbHr")));
$0a295593f55aceac$exports.PostgrestQueryBuilder = $0a295593f55aceac$var$PostgrestQueryBuilder_1.default;

const $0a295593f55aceac$var$PostgrestFilterBuilder_1 = $0a295593f55aceac$var$__importDefault((parcelRequire("llMbM")));
$0a295593f55aceac$exports.PostgrestFilterBuilder = $0a295593f55aceac$var$PostgrestFilterBuilder_1.default;

const $0a295593f55aceac$var$PostgrestTransformBuilder_1 = $0a295593f55aceac$var$__importDefault((parcelRequire("1u3br")));
$0a295593f55aceac$exports.PostgrestTransformBuilder = $0a295593f55aceac$var$PostgrestTransformBuilder_1.default;

const $0a295593f55aceac$var$PostgrestBuilder_1 = $0a295593f55aceac$var$__importDefault((parcelRequire("a6jdf")));
$0a295593f55aceac$exports.PostgrestBuilder = $0a295593f55aceac$var$PostgrestBuilder_1.default;

const $0a295593f55aceac$var$PostgrestError_1 = $0a295593f55aceac$var$__importDefault((parcelRequire("dUzfo")));
$0a295593f55aceac$exports.PostgrestError = $0a295593f55aceac$var$PostgrestError_1.default;
$0a295593f55aceac$exports.default = {
    PostgrestClient: $0a295593f55aceac$var$PostgrestClient_1.default,
    PostgrestQueryBuilder: $0a295593f55aceac$var$PostgrestQueryBuilder_1.default,
    PostgrestFilterBuilder: $0a295593f55aceac$var$PostgrestFilterBuilder_1.default,
    PostgrestTransformBuilder: $0a295593f55aceac$var$PostgrestTransformBuilder_1.default,
    PostgrestBuilder: $0a295593f55aceac$var$PostgrestBuilder_1.default,
    PostgrestError: $0a295593f55aceac$var$PostgrestError_1.default
};


const { PostgrestClient: $a81c39bf792d7bd5$export$796f32e2ee984aaa, PostgrestQueryBuilder: $a81c39bf792d7bd5$export$a81993b50ca081ad, PostgrestFilterBuilder: $a81c39bf792d7bd5$export$3158317c13bdc93a, PostgrestTransformBuilder: $a81c39bf792d7bd5$export$7b4361bb87e3030c, PostgrestBuilder: $a81c39bf792d7bd5$export$3106e21688a06353, PostgrestError: $a81c39bf792d7bd5$export$445b7e3a323f992f } = (0, (/*@__PURE__*/$parcel$interopDefault($0a295593f55aceac$exports)));
var // compatibility with CJS output
$a81c39bf792d7bd5$export$2e2bcd8739ae039 = {
    PostgrestClient: $a81c39bf792d7bd5$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $a81c39bf792d7bd5$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $a81c39bf792d7bd5$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $a81c39bf792d7bd5$export$7b4361bb87e3030c,
    PostgrestBuilder: $a81c39bf792d7bd5$export$3106e21688a06353,
    PostgrestError: $a81c39bf792d7bd5$export$445b7e3a323f992f
};


const $9eac742c82bfa4ce$export$83d89fbfd8236492 = '2.11.2';


const $9beb35519adf9fd9$export$88a84136db6a4b64 = {
    'X-Client-Info': `realtime-js/${(0, $9eac742c82bfa4ce$export$83d89fbfd8236492)}`
};
const $9beb35519adf9fd9$export$df3f558bb9a9c991 = '1.0.0';
const $9beb35519adf9fd9$export$7bd623b29ec8e1eb = 10000;
const $9beb35519adf9fd9$export$5e80cf62e56a877b = 1000;
var $9beb35519adf9fd9$export$a6d0320a1563d49e;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})($9beb35519adf9fd9$export$a6d0320a1563d49e || ($9beb35519adf9fd9$export$a6d0320a1563d49e = {}));
var $9beb35519adf9fd9$export$b83816118db74fe7;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})($9beb35519adf9fd9$export$b83816118db74fe7 || ($9beb35519adf9fd9$export$b83816118db74fe7 = {}));
var $9beb35519adf9fd9$export$8db7548e65d6ea55;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})($9beb35519adf9fd9$export$8db7548e65d6ea55 || ($9beb35519adf9fd9$export$8db7548e65d6ea55 = {}));
var $9beb35519adf9fd9$export$b2688bfb999f5751;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})($9beb35519adf9fd9$export$b2688bfb999f5751 || ($9beb35519adf9fd9$export$b2688bfb999f5751 = {}));
var $9beb35519adf9fd9$export$deda39003d27273;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})($9beb35519adf9fd9$export$deda39003d27273 || ($9beb35519adf9fd9$export$deda39003d27273 = {}));


// This file draws heavily from https://github.com/phoenixframework/phoenix/commit/cf098e9cf7a44ee6479d31d911a97d3c7430c6fe
// License: https://github.com/phoenixframework/phoenix/blob/master/LICENSE.md
class $1c480000c3f83d39$export$2e2bcd8739ae039 {
    constructor(){
        this.HEADER_LENGTH = 1;
    }
    decode(rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this._binaryDecode(rawPayload));
        if (typeof rawPayload === 'string') return callback(JSON.parse(rawPayload));
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const decoder = new TextDecoder();
        return this._decodeBroadcast(buffer, view, decoder);
    }
    _decodeBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        const data = JSON.parse(decoder.decode(buffer.slice(offset, buffer.byteLength)));
        return {
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
}


/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ class $bb053df52b5c973e$export$2e2bcd8739ae039 {
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    // Cancels any previous scheduleTimeout and schedules callback
    scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
}


/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $463a20c8442d7454$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($463a20c8442d7454$export$4d213a7d364021dc || ($463a20c8442d7454$export$4d213a7d364021dc = {}));
const $463a20c8442d7454$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $463a20c8442d7454$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $463a20c8442d7454$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $463a20c8442d7454$export$3df02a362b86a91(colType, value);
    return $463a20c8442d7454$var$noop(value);
};
const $463a20c8442d7454$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $463a20c8442d7454$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $463a20c8442d7454$export$4d213a7d364021dc.bool:
            return $463a20c8442d7454$export$3c2e6d1b7583eee6(value);
        case $463a20c8442d7454$export$4d213a7d364021dc.float4:
        case $463a20c8442d7454$export$4d213a7d364021dc.float8:
        case $463a20c8442d7454$export$4d213a7d364021dc.int2:
        case $463a20c8442d7454$export$4d213a7d364021dc.int4:
        case $463a20c8442d7454$export$4d213a7d364021dc.int8:
        case $463a20c8442d7454$export$4d213a7d364021dc.numeric:
        case $463a20c8442d7454$export$4d213a7d364021dc.oid:
            return $463a20c8442d7454$export$a0a81dc3380ce7d3(value);
        case $463a20c8442d7454$export$4d213a7d364021dc.json:
        case $463a20c8442d7454$export$4d213a7d364021dc.jsonb:
            return $463a20c8442d7454$export$d5b7a8bf56ee1fe2(value);
        case $463a20c8442d7454$export$4d213a7d364021dc.timestamp:
            return $463a20c8442d7454$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $463a20c8442d7454$export$4d213a7d364021dc.abstime:
        case $463a20c8442d7454$export$4d213a7d364021dc.date:
        case $463a20c8442d7454$export$4d213a7d364021dc.daterange:
        case $463a20c8442d7454$export$4d213a7d364021dc.int4range:
        case $463a20c8442d7454$export$4d213a7d364021dc.int8range:
        case $463a20c8442d7454$export$4d213a7d364021dc.money:
        case $463a20c8442d7454$export$4d213a7d364021dc.reltime:
        case $463a20c8442d7454$export$4d213a7d364021dc.text:
        case $463a20c8442d7454$export$4d213a7d364021dc.time:
        case $463a20c8442d7454$export$4d213a7d364021dc.timestamptz:
        case $463a20c8442d7454$export$4d213a7d364021dc.timetz:
        case $463a20c8442d7454$export$4d213a7d364021dc.tsrange:
        case $463a20c8442d7454$export$4d213a7d364021dc.tstzrange:
            return $463a20c8442d7454$var$noop(value);
        default:
            // Return the value for remaining types
            return $463a20c8442d7454$var$noop(value);
    }
};
const $463a20c8442d7454$var$noop = (value)=>{
    return value;
};
const $463a20c8442d7454$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $463a20c8442d7454$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $463a20c8442d7454$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON parse error: ${error}`);
        return value;
    }
    return value;
};
const $463a20c8442d7454$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$463a20c8442d7454$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $463a20c8442d7454$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $463a20c8442d7454$export$976fda7151b30cae = (socketUrl)=>{
    let url = socketUrl;
    url = url.replace(/^ws/i, 'http');
    url = url.replace(/(\/socket\/websocket|\/socket|\/websocket)\/?$/i, '');
    return url.replace(/\/+$/, '');
};




class $6c7107bb4019b428$export$2e2bcd8739ae039 {
    /**
     * Initializes the Push
     *
     * @param channel The Channel
     * @param event The event, for example `"phx_join"`
     * @param payload The payload, for example `{user_id: 123}`
     * @param timeout The push timeout in milliseconds
     */ constructor(channel, event, payload = {}, timeout = (0, $9beb35519adf9fd9$export$7bd623b29ec8e1eb)){
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = '';
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
    }
    resend(timeout) {
        this.timeout = timeout;
        this._cancelRefEvent();
        this.ref = '';
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
    }
    send() {
        if (this._hasReceived('timeout')) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload,
            ref: this.ref,
            join_ref: this.channel._joinRef()
        });
    }
    updatePayload(payload) {
        this.payload = Object.assign(Object.assign({}, this.payload), payload);
    }
    receive(status, callback) {
        var _a;
        if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    startTimeout() {
        if (this.timeoutTimer) return;
        this.ref = this.channel.socket._makeRef();
        this.refEvent = this.channel._replyEventName(this.ref);
        const callback = (payload)=>{
            this._cancelRefEvent();
            this._cancelTimeout();
            this.receivedResp = payload;
            this._matchReceive(payload);
        };
        this.channel._on(this.refEvent, {}, callback);
        this.timeoutTimer = setTimeout(()=>{
            this.trigger('timeout', {});
        }, this.timeout);
    }
    trigger(status, response) {
        if (this.refEvent) this.channel._trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
    destroy() {
        this._cancelRefEvent();
        this._cancelTimeout();
    }
    _cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel._off(this.refEvent, {});
    }
    _cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = undefined;
    }
    _matchReceive({ status: status, response: response }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    _hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
}



/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ var $76641d7888f8a937$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($76641d7888f8a937$export$f1ce049df2794fb4 || ($76641d7888f8a937$export$f1ce049df2794fb4 = {}));
class $76641d7888f8a937$export$2e2bcd8739ae039 {
    /**
     * Initializes the Presence.
     *
     * @param channel - The RealtimeChannel
     * @param opts - The options,
     *        for example `{events: {state: 'state', diff: 'diff'}}`
     */ constructor(channel, opts){
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.caller = {
            onJoin: ()=>{},
            onLeave: ()=>{},
            onSync: ()=>{}
        };
        const events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: 'presence_state',
            diff: 'presence_diff'
        };
        this.channel._on(events.state, {}, (newState)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel._joinRef();
            this.state = $76641d7888f8a937$export$2e2bcd8739ae039.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = $76641d7888f8a937$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, (diff)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = $76641d7888f8a937$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin((key, currentPresences, newPresences)=>{
            this.channel._trigger('presence', {
                event: 'join',
                key: key,
                currentPresences: currentPresences,
                newPresences: newPresences
            });
        });
        this.onLeave((key, currentPresences, leftPresences)=>{
            this.channel._trigger('presence', {
                event: 'leave',
                key: key,
                currentPresences: currentPresences,
                leftPresences: leftPresences
            });
        });
        this.onSync(()=>{
            this.channel._trigger('presence', {
                event: 'sync'
            });
        });
    }
    /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ static syncState(currentState, newState, onJoin, onLeave) {
        const state = this.cloneDeep(currentState);
        const transformedState = this.transformState(newState);
        const joins = {};
        const leaves = {};
        this.map(state, (key, presences)=>{
            if (!transformedState[key]) leaves[key] = presences;
        });
        this.map(transformedState, (key, newPresences)=>{
            const currentPresences = state[key];
            if (currentPresences) {
                const newPresenceRefs = newPresences.map((m)=>m.presence_ref);
                const curPresenceRefs = currentPresences.map((m)=>m.presence_ref);
                const joinedPresences = newPresences.filter((m)=>curPresenceRefs.indexOf(m.presence_ref) < 0);
                const leftPresences = currentPresences.filter((m)=>newPresenceRefs.indexOf(m.presence_ref) < 0);
                if (joinedPresences.length > 0) joins[key] = joinedPresences;
                if (leftPresences.length > 0) leaves[key] = leftPresences;
            } else joins[key] = newPresences;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ static syncDiff(state, diff, onJoin, onLeave) {
        const { joins: joins, leaves: leaves } = {
            joins: this.transformState(diff.joins),
            leaves: this.transformState(diff.leaves)
        };
        if (!onJoin) onJoin = ()=>{};
        if (!onLeave) onLeave = ()=>{};
        this.map(joins, (key, newPresences)=>{
            var _a;
            const currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
            state[key] = this.cloneDeep(newPresences);
            if (currentPresences.length > 0) {
                const joinedPresenceRefs = state[key].map((m)=>m.presence_ref);
                const curPresences = currentPresences.filter((m)=>joinedPresenceRefs.indexOf(m.presence_ref) < 0);
                state[key].unshift(...curPresences);
            }
            onJoin(key, currentPresences, newPresences);
        });
        this.map(leaves, (key, leftPresences)=>{
            let currentPresences = state[key];
            if (!currentPresences) return;
            const presenceRefsToRemove = leftPresences.map((m)=>m.presence_ref);
            currentPresences = currentPresences.filter((m)=>presenceRefsToRemove.indexOf(m.presence_ref) < 0);
            state[key] = currentPresences;
            onLeave(key, currentPresences, leftPresences);
            if (currentPresences.length === 0) delete state[key];
        });
        return state;
    }
    /** @internal */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ static transformState(state) {
        state = this.cloneDeep(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            if ('metas' in presences) newState[key] = presences.metas.map((presence)=>{
                presence['presence_ref'] = presence['phx_ref'];
                delete presence['phx_ref'];
                delete presence['phx_ref_prev'];
                return presence;
            });
            else newState[key] = presences;
            return newState;
        }, {});
    }
    /** @internal */ static cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /** @internal */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /** @internal */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /** @internal */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /** @internal */ inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel._joinRef();
    }
}



var $585d058bdae8d43c$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($585d058bdae8d43c$export$bc171c571098b6c4 || ($585d058bdae8d43c$export$bc171c571098b6c4 = {}));
var $585d058bdae8d43c$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($585d058bdae8d43c$export$9e3fe8e487ef792e || ($585d058bdae8d43c$export$9e3fe8e487ef792e = {}));
var $585d058bdae8d43c$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($585d058bdae8d43c$export$a6885b926af646a2 || ($585d058bdae8d43c$export$a6885b926af646a2 = {}));
const $585d058bdae8d43c$export$154db638d9c0559e = (0, $9beb35519adf9fd9$export$b83816118db74fe7);
class $585d058bdae8d43c$export$2e2bcd8739ae039 {
    constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, $9beb35519adf9fd9$export$b83816118db74fe7).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: ''
            },
            private: false
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, $6c7107bb4019b428$export$2e2bcd8739ae039)(this, (0, $9beb35519adf9fd9$export$8db7548e65d6ea55).join, this.params, this.timeout);
        this.rejoinTimer = new (0, $bb053df52b5c973e$export$2e2bcd8739ae039)(()=>this._rejoinUntilConnected(), this.socket.reconnectAfterMs);
        this.joinPush.receive('ok', ()=>{
            this.state = (0, $9beb35519adf9fd9$export$b83816118db74fe7).joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this._onClose(()=>{
            this.rejoinTimer.reset();
            this.socket.log('channel', `close ${this.topic} ${this._joinRef()}`);
            this.state = (0, $9beb35519adf9fd9$export$b83816118db74fe7).closed;
            this.socket._remove(this);
        });
        this._onError((reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log('channel', `error ${this.topic}`, reason);
            this.state = (0, $9beb35519adf9fd9$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('timeout', ()=>{
            if (!this._isJoining()) return;
            this.socket.log('channel', `timeout ${this.topic}`, this.joinPush.timeout);
            this.state = (0, $9beb35519adf9fd9$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, $9beb35519adf9fd9$export$8db7548e65d6ea55).reply, {}, (payload, ref)=>{
            this._trigger(this._replyEventName(ref), payload);
        });
        this.presence = new (0, $76641d7888f8a937$export$2e2bcd8739ae039)(this);
        this.broadcastEndpointURL = (0, $463a20c8442d7454$export$976fda7151b30cae)(this.socket.endPoint) + '/api/broadcast';
        this.private = this.params.config.private || false;
    }
    /** Subscribe registers your client with the server */ subscribe(callback, timeout = this.timeout) {
        var _a, _b;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.joinedOnce) throw `tried to subscribe multiple times. 'subscribe' can only be called a single time per channel instance`;
        else {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            this._onError((e)=>callback === null || callback === void 0 ? void 0 : callback($585d058bdae8d43c$export$a6885b926af646a2.CHANNEL_ERROR, e));
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($585d058bdae8d43c$export$a6885b926af646a2.CLOSED));
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: presence,
                postgres_changes: (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [],
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this.joinedOnce = true;
            this._rejoin(timeout);
            this.joinPush.receive('ok', async ({ postgres_changes: postgres_changes })=>{
                var _a;
                this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback($585d058bdae8d43c$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                } else {
                    const clientPostgresBindings = this.bindings.postgres_changes;
                    const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                    const newPostgresBindings = [];
                    for(let i = 0; i < bindingsLen; i++){
                        const clientPostgresBinding = clientPostgresBindings[i];
                        const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
                        const serverPostgresFilter = postgres_changes && postgres_changes[i];
                        if (serverPostgresFilter && serverPostgresFilter.event === event && serverPostgresFilter.schema === schema && serverPostgresFilter.table === table && serverPostgresFilter.filter === filter) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                            id: serverPostgresFilter.id
                        }));
                        else {
                            this.unsubscribe();
                            callback === null || callback === void 0 || callback($585d058bdae8d43c$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                            return;
                        }
                    }
                    this.bindings.postgres_changes = newPostgresBindings;
                    callback && callback($585d058bdae8d43c$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                }
            }).receive('error', (error)=>{
                callback === null || callback === void 0 || callback($585d058bdae8d43c$export$a6885b926af646a2.CHANNEL_ERROR, new Error(JSON.stringify(Object.values(error).join(', ') || 'error')));
                return;
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback($585d058bdae8d43c$export$a6885b926af646a2.TIMED_OUT);
                return;
            });
        }
        return this;
    }
    presenceState() {
        return this.presence.state;
    }
    async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts.timeout || this.timeout);
    }
    async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    on(type, filter, callback) {
        return this._on(type, filter, callback);
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this._canPush() && args.type === 'broadcast') {
            const { event: event, payload: endpoint_payload } = args;
            const authorization = this.socket.accessTokenValue ? `Bearer ${this.socket.accessTokenValue}` : '';
            const options = {
                method: 'POST',
                headers: {
                    Authorization: authorization,
                    apikey: this.socket.apiKey ? this.socket.apiKey : '',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this._push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    updateJoinPayload(payload) {
        this.joinPush.updatePayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ unsubscribe(timeout = this.timeout) {
        this.state = (0, $9beb35519adf9fd9$export$b83816118db74fe7).leaving;
        const onClose = ()=>{
            this.socket.log('channel', `leave ${this.topic}`);
            this._trigger((0, $9beb35519adf9fd9$export$8db7548e65d6ea55).close, 'leave', this._joinRef());
        };
        this.rejoinTimer.reset();
        // Destroy joinPush to avoid connection timeouts during unscription phase
        this.joinPush.destroy();
        return new Promise((resolve)=>{
            const leavePush = new (0, $6c7107bb4019b428$export$2e2bcd8739ae039)(this, (0, $9beb35519adf9fd9$export$8db7548e65d6ea55).leave, {}, timeout);
            leavePush.receive('ok', ()=>{
                onClose();
                resolve('ok');
            }).receive('timeout', ()=>{
                onClose();
                resolve('timed out');
            }).receive('error', ()=>{
                resolve('error');
            });
            leavePush.send();
            if (!this._canPush()) leavePush.trigger('ok', {});
        });
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _push(event, payload, timeout = this.timeout) {
        if (!this.joinedOnce) throw `tried to push '${event}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
        let pushEvent = new (0, $6c7107bb4019b428$export$2e2bcd8739ae039)(this, event, payload, timeout);
        if (this._canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ _onMessage(_event, payload, _ref) {
        return payload;
    }
    /** @internal */ _isMember(topic) {
        return this.topic === topic;
    }
    /** @internal */ _joinRef() {
        return this.joinPush.ref;
    }
    /** @internal */ _trigger(type, payload, ref) {
        var _a, _b;
        const typeLower = type.toLocaleLowerCase();
        const { close: close, error: error, leave: leave, join: join } = (0, $9beb35519adf9fd9$export$8db7548e65d6ea55);
        const events = [
            close,
            error,
            leave,
            join
        ];
        if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
        let handledPayload = this._onMessage(typeLower, payload, ref);
        if (payload && !handledPayload) throw 'channel onMessage callbacks must return the payload, modified or unmodified';
        if ([
            'insert',
            'update',
            'delete'
        ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter((bind)=>{
            var _a, _b, _c;
            return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === '*' || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
        }).map((bind)=>bind.callback(handledPayload, ref));
        else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter((bind)=>{
            var _a, _b, _c, _d, _e, _f;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                    return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        }).map((bind)=>{
            if (typeof handledPayload === 'object' && 'ids' in handledPayload) {
                const postgresChanges = handledPayload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                handledPayload = Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            bind.callback(handledPayload, ref);
        });
    }
    /** @internal */ _isClosed() {
        return this.state === (0, $9beb35519adf9fd9$export$b83816118db74fe7).closed;
    }
    /** @internal */ _isJoined() {
        return this.state === (0, $9beb35519adf9fd9$export$b83816118db74fe7).joined;
    }
    /** @internal */ _isJoining() {
        return this.state === (0, $9beb35519adf9fd9$export$b83816118db74fe7).joining;
    }
    /** @internal */ _isLeaving() {
        return this.state === (0, $9beb35519adf9fd9$export$b83816118db74fe7).leaving;
    }
    /** @internal */ _replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        return this;
    }
    /** @internal */ _off(type, filter) {
        const typeLower = type.toLocaleLowerCase();
        this.bindings[typeLower] = this.bindings[typeLower].filter((bind)=>{
            var _a;
            return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && $585d058bdae8d43c$export$2e2bcd8739ae039.isEqual(bind.filter, filter));
        });
        return this;
    }
    /** @internal */ static isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for(const k in obj1){
            if (obj1[k] !== obj2[k]) return false;
        }
        return true;
    }
    /** @internal */ _rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) this._rejoin();
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this._on((0, $9beb35519adf9fd9$export$8db7548e65d6ea55).close, {}, callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this._on((0, $9beb35519adf9fd9$export$8db7548e65d6ea55).error, {}, (reason)=>callback(reason));
    }
    /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ _canPush() {
        return this.socket.isConnected() && this._isJoined();
    }
    /** @internal */ _rejoin(timeout = this.timeout) {
        if (this._isLeaving()) return;
        this.socket._leaveOpenTopic(this.topic);
        this.state = (0, $9beb35519adf9fd9$export$b83816118db74fe7).joining;
        this.joinPush.resend(timeout);
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $463a20c8442d7454$export$20ce708a1f594c5e(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $463a20c8442d7454$export$20ce708a1f594c5e(payload.columns, payload.old_record);
        return records;
    }
}


const $cd4b3129f08519b6$var$noop = ()=>{};
const $cd4b3129f08519b6$var$NATIVE_WEBSOCKET_AVAILABLE = typeof WebSocket !== 'undefined';
const $cd4b3129f08519b6$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;


class $cd4b3129f08519b6$export$2e2bcd8739ae039 {
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket.
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers The optional headers to pass when connecting.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     */ constructor(endPoint, options){
        var _a;
        this.accessTokenValue = null;
        this.apiKey = null;
        this.channels = [];
        this.endPoint = '';
        this.httpEndpoint = '';
        this.headers = (0, $9beb35519adf9fd9$export$88a84136db6a4b64);
        this.params = {};
        this.timeout = (0, $9beb35519adf9fd9$export$7bd623b29ec8e1eb);
        this.heartbeatIntervalMs = 30000;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.ref = 0;
        this.logger = $cd4b3129f08519b6$var$noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, $1c480000c3f83d39$export$2e2bcd8739ae039)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.accessToken = null;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            let _fetch;
            if (customFetch) _fetch = customFetch;
            else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("8oL7M"))).then(({ default: fetch1 })=>fetch1(...args));
            else _fetch = fetch;
            return (...args)=>_fetch(...args);
        };
        this.endPoint = `${endPoint}/${(0, $9beb35519adf9fd9$export$b2688bfb999f5751).websocket}`;
        this.httpEndpoint = (0, $463a20c8442d7454$export$976fda7151b30cae)(endPoint);
        if (options === null || options === void 0 ? void 0 : options.transport) this.transport = options.transport;
        else this.transport = null;
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.headers) this.headers = Object.assign(Object.assign({}, this.headers), options.headers);
        if (options === null || options === void 0 ? void 0 : options.timeout) this.timeout = options.timeout;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if (options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) this.heartbeatIntervalMs = options.heartbeatIntervalMs;
        const accessTokenValue = (_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey;
        if (accessTokenValue) {
            this.accessTokenValue = accessTokenValue;
            this.apiKey = accessTokenValue;
        }
        this.reconnectAfterMs = (options === null || options === void 0 ? void 0 : options.reconnectAfterMs) ? options.reconnectAfterMs : (tries)=>{
            return [
                1000,
                2000,
                5000,
                10000
            ][tries - 1] || 10000;
        };
        this.encode = (options === null || options === void 0 ? void 0 : options.encode) ? options.encode : (payload, callback)=>{
            return callback(JSON.stringify(payload));
        };
        this.decode = (options === null || options === void 0 ? void 0 : options.decode) ? options.decode : this.serializer.decode.bind(this.serializer);
        this.reconnectTimer = new (0, $bb053df52b5c973e$export$2e2bcd8739ae039)(async ()=>{
            this.disconnect();
            this.connect();
        }, this.reconnectAfterMs);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
        if (options === null || options === void 0 ? void 0 : options.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.worker = (options === null || options === void 0 ? void 0 : options.worker) || false;
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
        }
        this.accessToken = (options === null || options === void 0 ? void 0 : options.accessToken) || null;
    }
    /**
     * Connects the socket, unless already connected.
     */ connect() {
        if (this.conn) return;
        if (this.transport) {
            this.conn = new this.transport(this.endpointURL(), undefined, {
                headers: this.headers
            });
            return;
        }
        if ($cd4b3129f08519b6$var$NATIVE_WEBSOCKET_AVAILABLE) {
            this.conn = new WebSocket(this.endpointURL());
            this.setupConnection();
            return;
        }
        this.conn = new $cd4b3129f08519b6$var$WSWebSocketDummy(this.endpointURL(), undefined, {
            close: ()=>{
                this.conn = null;
            }
        });
        (parcelRequire("qM4kX")).then(({ default: WS })=>{
            this.conn = new WS(this.endpointURL(), undefined, {
                headers: this.headers
            });
            this.setupConnection();
        });
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     */ endpointURL() {
        return this._appendParams(this.endPoint, Object.assign({}, this.params, {
            vsn: (0, $9beb35519adf9fd9$export$df3f558bb9a9c991)
        }));
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ disconnect(code, reason) {
        if (this.conn) {
            this.conn.onclose = function() {}; // noop
            if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : '');
            else this.conn.close();
            this.conn = null;
            // remove open handles
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.reconnectTimer.reset();
        }
    }
    /**
     * Returns all created channels
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (this.channels.length === 0) this.disconnect();
        return status;
    }
    /**
     * Unsubscribes and removes all channels
     */ async removeAllChannels() {
        const values_1 = await Promise.all(this.channels.map((channel)=>channel.unsubscribe()));
        this.disconnect();
        return values_1;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case (0, $9beb35519adf9fd9$export$a6d0320a1563d49e).connecting:
                return (0, $9beb35519adf9fd9$export$deda39003d27273).Connecting;
            case (0, $9beb35519adf9fd9$export$a6d0320a1563d49e).open:
                return (0, $9beb35519adf9fd9$export$deda39003d27273).Open;
            case (0, $9beb35519adf9fd9$export$a6d0320a1563d49e).closing:
                return (0, $9beb35519adf9fd9$export$deda39003d27273).Closing;
            default:
                return (0, $9beb35519adf9fd9$export$deda39003d27273).Closed;
        }
    }
    /**
     * Returns `true` is the connection is open.
     */ isConnected() {
        return this.connectionState() === (0, $9beb35519adf9fd9$export$deda39003d27273).Open;
    }
    channel(topic, params = {
        config: {}
    }) {
        const chan = new (0, $585d058bdae8d43c$export$2e2bcd8739ae039)(`realtime:${topic}`, params, this);
        this.channels.push(chan);
        return chan;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ push(data) {
        const { topic: topic, event: event, payload: payload, ref: ref } = data;
        const callback = ()=>{
            this.encode(data, (result)=>{
                var _a;
                (_a = this.conn) === null || _a === void 0 || _a.send(result);
            });
        };
        this.log('push', `${topic} ${event} (${ref})`, payload);
        if (this.isConnected()) callback();
        else this.sendBuffer.push(callback);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * @param token A JWT string to override the token set on the client.
     */ async setAuth(token = null) {
        let tokenToSend = token || this.accessToken && await this.accessToken() || this.accessTokenValue;
        if (tokenToSend) {
            let parsed = null;
            try {
                parsed = JSON.parse(atob(tokenToSend.split('.')[1]));
            } catch (_error) {}
            if (parsed && parsed.exp) {
                let now = Math.floor(Date.now() / 1000);
                let valid = now - parsed.exp < 0;
                if (!valid) {
                    this.log('auth', `InvalidJWTToken: Invalid value for JWT claim "exp" with value ${parsed.exp}`);
                    return Promise.reject(`InvalidJWTToken: Invalid value for JWT claim "exp" with value ${parsed.exp}`);
                }
            }
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                tokenToSend && channel.updateJoinPayload({
                    access_token: tokenToSend
                });
                if (channel.joinedOnce && channel._isJoined()) channel._push((0, $9beb35519adf9fd9$export$8db7548e65d6ea55).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     */ async sendHeartbeat() {
        var _a;
        if (!this.isConnected()) return;
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.log('transport', 'heartbeat timeout. Attempting to re-establish connection');
            (_a = this.conn) === null || _a === void 0 || _a.close((0, $9beb35519adf9fd9$export$5e80cf62e56a877b), 'hearbeat timeout');
            return;
        }
        this.pendingHeartbeatRef = this._makeRef();
        this.push({
            topic: 'phoenix',
            event: 'heartbeat',
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        this.setAuth();
    }
    /**
     * Flushes send buffer
     */ flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ _leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c._isJoined() || c._isJoining()));
        if (dupChannel) {
            this.log('transport', `leaving duplicate topic "${topic}"`);
            dupChannel.unsubscribe();
        }
    }
    /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c._joinRef() !== channel._joinRef());
    }
    /**
     * Sets up connection handlers.
     *
     * @internal
     */ setupConnection() {
        if (this.conn) {
            this.conn.binaryType = 'arraybuffer';
            this.conn.onopen = ()=>this._onConnOpen();
            this.conn.onerror = (error)=>this._onConnError(error);
            this.conn.onmessage = (event)=>this._onConnMessage(event);
            this.conn.onclose = (event)=>this._onConnClose(event);
        }
    }
    /** @internal */ _onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef) this.pendingHeartbeatRef = null;
            this.log('receive', `${payload.status || ''} ${topic} ${event} ${ref && '(' + ref + ')' || ''}`, payload);
            this.channels.filter((channel)=>channel._isMember(topic)).forEach((channel)=>channel._trigger(event, payload, ref));
            this.stateChangeCallbacks.message.forEach((callback)=>callback(msg));
        });
    }
    /** @internal */ async _onConnOpen() {
        this.log('transport', `connected to ${this.endpointURL()}`);
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (!this.worker) {
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.heartbeatTimer = setInterval(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
        } else {
            if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
            else this.log('worker', `starting default worker`);
            const objectUrl = this._workerObjectUrl(this.workerUrl);
            this.workerRef = new Worker(objectUrl);
            this.workerRef.onerror = (error)=>{
                this.log('worker', 'worker error', error.message);
                this.workerRef.terminate();
            };
            this.workerRef.onmessage = (event)=>{
                if (event.data.event === 'keepAlive') this.sendHeartbeat();
            };
            this.workerRef.postMessage({
                event: 'start',
                interval: this.heartbeatIntervalMs
            });
        }
        this.stateChangeCallbacks.open.forEach((callback)=>callback());
    }
    /** @internal */ _onConnClose(event) {
        this.log('transport', 'close', event);
        this._triggerChanError();
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.reconnectTimer.scheduleTimeout();
        this.stateChangeCallbacks.close.forEach((callback)=>callback(event));
    }
    /** @internal */ _onConnError(error) {
        this.log('transport', error.message);
        this._triggerChanError();
        this.stateChangeCallbacks.error.forEach((callback)=>callback(error));
    }
    /** @internal */ _triggerChanError() {
        this.channels.forEach((channel)=>channel._trigger((0, $9beb35519adf9fd9$export$8db7548e65d6ea55).error));
    }
    /** @internal */ _appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        const prefix = url.match(/\?/) ? '&' : '?';
        const query = new URLSearchParams(params);
        return `${url}${prefix}${query}`;
    }
    _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $cd4b3129f08519b6$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
}
class $cd4b3129f08519b6$var$WSWebSocketDummy {
    constructor(address, _protocols, options){
        this.binaryType = 'arraybuffer';
        this.onclose = ()=>{};
        this.onerror = ()=>{};
        this.onmessage = ()=>{};
        this.onopen = ()=>{};
        this.readyState = (0, $9beb35519adf9fd9$export$a6d0320a1563d49e).connecting;
        this.send = ()=>{};
        this.url = null;
        this.url = address;
        this.close = options.close;
    }
}






class $367d31db45a3c565$export$697502632950e9d3 extends Error {
    constructor(message){
        super(message);
        this.__isStorageError = true;
        this.name = 'StorageError';
    }
}
function $367d31db45a3c565$export$5a322e77e5eb0561(error) {
    return typeof error === 'object' && error !== null && '__isStorageError' in error;
}
class $367d31db45a3c565$export$ca9ecfd959b3871c extends $367d31db45a3c565$export$697502632950e9d3 {
    constructor(message, status){
        super(message);
        this.name = 'StorageApiError';
        this.status = status;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
}
class $367d31db45a3c565$export$29127ca2e1a271d extends $367d31db45a3c565$export$697502632950e9d3 {
    constructor(message, originalError){
        super(message);
        this.name = 'StorageUnknownError';
        this.originalError = originalError;
    }
}



var $781ab65ed1f6c2c7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $781ab65ed1f6c2c7$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("8oL7M"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};

const $781ab65ed1f6c2c7$export$ace1d6afc438cf26 = ()=>$781ab65ed1f6c2c7$var$__awaiter(void 0, void 0, void 0, function*() {
        if (typeof Response === 'undefined') // @ts-ignore
        return (yield Promise.resolve((parcelRequire("8oL7M")))).Response;
        return Response;
    });
const $781ab65ed1f6c2c7$export$69d519e35e6fc3d4 = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$781ab65ed1f6c2c7$export$69d519e35e6fc3d4(el));
    else if (typeof item === 'function' || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ''));
        result[newKey] = $781ab65ed1f6c2c7$export$69d519e35e6fc3d4(value);
    });
    return result;
};


var $c08781b5383b8ae1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $c08781b5383b8ae1$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $c08781b5383b8ae1$var$handleError = (error, reject, options)=>$c08781b5383b8ae1$var$__awaiter(void 0, void 0, void 0, function*() {
        const Res = yield (0, $781ab65ed1f6c2c7$export$ace1d6afc438cf26)();
        if (error instanceof Res && !(options === null || options === void 0 ? void 0 : options.noResolveJson)) error.json().then((err)=>{
            reject(new (0, $367d31db45a3c565$export$ca9ecfd959b3871c)($c08781b5383b8ae1$var$_getErrorMessage(err), error.status || 500));
        }).catch((err)=>{
            reject(new (0, $367d31db45a3c565$export$29127ca2e1a271d)($c08781b5383b8ae1$var$_getErrorMessage(err), err));
        });
        else reject(new (0, $367d31db45a3c565$export$29127ca2e1a271d)($c08781b5383b8ae1$var$_getErrorMessage(error), error));
    });
const $c08781b5383b8ae1$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json'
    }, options === null || options === void 0 ? void 0 : options.headers);
    if (body) params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
function $c08781b5383b8ae1$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    return $c08781b5383b8ae1$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            fetcher(url, $c08781b5383b8ae1$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
                if (!result.ok) throw result;
                if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
                return result.json();
            }).then((data)=>resolve(data)).catch((error)=>$c08781b5383b8ae1$var$handleError(error, reject, options));
        });
    });
}
function $c08781b5383b8ae1$export$3988ae62b71be9a3(fetcher, url, options, parameters) {
    return $c08781b5383b8ae1$var$__awaiter(this, void 0, void 0, function*() {
        return $c08781b5383b8ae1$var$_handleRequest(fetcher, 'GET', url, options, parameters);
    });
}
function $c08781b5383b8ae1$export$299ba2dee77727e9(fetcher, url, body, options, parameters) {
    return $c08781b5383b8ae1$var$__awaiter(this, void 0, void 0, function*() {
        return $c08781b5383b8ae1$var$_handleRequest(fetcher, 'POST', url, options, parameters, body);
    });
}
function $c08781b5383b8ae1$export$327f7b26ebf455db(fetcher, url, body, options, parameters) {
    return $c08781b5383b8ae1$var$__awaiter(this, void 0, void 0, function*() {
        return $c08781b5383b8ae1$var$_handleRequest(fetcher, 'PUT', url, options, parameters, body);
    });
}
function $c08781b5383b8ae1$export$5fd5031fecdacec3(fetcher, url, options, parameters) {
    return $c08781b5383b8ae1$var$__awaiter(this, void 0, void 0, function*() {
        return $c08781b5383b8ae1$var$_handleRequest(fetcher, 'HEAD', url, Object.assign(Object.assign({}, options), {
            noResolveJson: true
        }), parameters);
    });
}
function $c08781b5383b8ae1$export$cd7f480d6b8286c3(fetcher, url, body, options, parameters) {
    return $c08781b5383b8ae1$var$__awaiter(this, void 0, void 0, function*() {
        return $c08781b5383b8ae1$var$_handleRequest(fetcher, 'DELETE', url, options, parameters, body);
    });
}



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
'use strict';
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
'use strict';
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $034686670a8a195b$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup['-'.charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup['_'.charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
const $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    let buf = $d4ecdbf520e63dca$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    const buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        const len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        const buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) buf = $d4ecdbf520e63dca$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case 'base64':
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $034686670a8a195b$export$6100ba28696e12de(buf);
    else return $034686670a8a195b$export$6100ba28696e12de(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d4ecdbf520e63dca$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $d4ecdbf520e63dca$var$errors = {};
function $d4ecdbf520e63dca$var$E(sym, getMessage, Base) {
    $d4ecdbf520e63dca$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$d4ecdbf520e63dca$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$d4ecdbf520e63dca$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$d4ecdbf520e63dca$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d4ecdbf520e63dca$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $d4ecdbf520e63dca$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $d4ecdbf520e63dca$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength) {
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d4ecdbf520e63dca$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength);
}
function $d4ecdbf520e63dca$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $d4ecdbf520e63dca$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $d4ecdbf520e63dca$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d4ecdbf520e63dca$var$validateNumber(value, type);
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $d4ecdbf520e63dca$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $034686670a8a195b$export$d622b2ad8d90c771($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d4ecdbf520e63dca$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $d4ecdbf520e63dca$var$BufferBigIntNotDefined : fn;
}
function $d4ecdbf520e63dca$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $bddcfd1a56c52a50$require$Buffer = $d4ecdbf520e63dca$export$a143d493d941bafc;
var $bddcfd1a56c52a50$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $bddcfd1a56c52a50$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: 'name',
        order: 'asc'
    }
};
const $bddcfd1a56c52a50$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: '3600',
    contentType: 'text/plain;charset=UTF-8',
    upsert: false
};
class $bddcfd1a56c52a50$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, bucketId, fetch){
        this.url = url;
        this.headers = headers;
        this.bucketId = bucketId;
        this.fetch = (0, $781ab65ed1f6c2c7$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
     *
     * @param method HTTP method.
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadOrUpdate(method, path, fileBody, fileOptions) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let body;
                const options = Object.assign(Object.assign({}, $bddcfd1a56c52a50$var$DEFAULT_FILE_OPTIONS), fileOptions);
                let headers = Object.assign(Object.assign({}, this.headers), method === 'POST' && {
                    'x-upsert': String(options.upsert)
                });
                const metadata = options.metadata;
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                    if (metadata) headers['x-metadata'] = this.toBase64(this.encodeMetadata(metadata));
                }
                if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) headers = Object.assign(Object.assign({}, headers), fileOptions.headers);
                const cleanPath = this._removeEmptyFolders(path);
                const _path = this._getFinalPath(cleanPath);
                const res = yield this.fetch(`${this.url}/object/${_path}`, Object.assign({
                    method: method,
                    body: body,
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}));
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        id: data.Id,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ upload(path, fileBody, fileOptions) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('POST', path, fileBody, fileOptions);
        });
    }
    /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadToSignedUrl(path, token, fileBody, fileOptions) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            const cleanPath = this._removeEmptyFolders(path);
            const _path = this._getFinalPath(cleanPath);
            const url = new URL(this.url + `/object/upload/sign/${_path}`);
            url.searchParams.set('token', token);
            try {
                let body;
                const options = Object.assign({
                    upsert: $bddcfd1a56c52a50$var$DEFAULT_FILE_OPTIONS.upsert
                }, fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), {
                    'x-upsert': String(options.upsert)
                });
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                }
                const res = yield this.fetch(url.toString(), {
                    method: 'PUT',
                    body: body,
                    headers: headers
                });
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for 2 hours.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param options.upsert If set to true, allows the file to be overwritten if it already exists.
     */ createSignedUploadUrl(path, options) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                const headers = Object.assign({}, this.headers);
                if (options === null || options === void 0 ? void 0 : options.upsert) headers['x-upsert'] = 'true';
                const data = yield (0, $c08781b5383b8ae1$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/upload/sign/${_path}`, {}, {
                    headers: headers
                });
                const url = new URL(this.url + data.url);
                const token = url.searchParams.get('token');
                if (!token) throw new (0, $367d31db45a3c565$export$697502632950e9d3)('No token returned by API');
                return {
                    data: {
                        signedUrl: url.toString(),
                        path: path,
                        token: token
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */ update(path, fileBody, fileOptions) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('PUT', path, fileBody, fileOptions);
        });
    }
    /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     * @param options The destination options.
     */ move(fromPath, toPath, options) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $c08781b5383b8ae1$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/move`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     * @param options The destination options.
     */ copy(fromPath, toPath, options) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $c08781b5383b8ae1$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/copy`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: {
                        path: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ createSignedUrl(path, expiresIn, options) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                let data = yield (0, $c08781b5383b8ae1$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${_path}`, Object.assign({
                    expiresIn: expiresIn
                }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                    transform: options.transform
                } : {}), {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                const signedUrl = encodeURI(`${this.url}${data.signedURL}${downloadQueryParam}`);
                data = {
                    signedUrl: signedUrl
                };
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */ createSignedUrls(paths, expiresIn, options) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $c08781b5383b8ae1$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${this.bucketId}`, {
                    expiresIn: expiresIn,
                    paths: paths
                }, {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                return {
                    data: data.map((datum)=>Object.assign(Object.assign({}, datum), {
                            signedUrl: datum.signedURL ? encodeURI(`${this.url}${datum.signedURL}${downloadQueryParam}`) : null
                        })),
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */ download(path, options) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
            const renderPath = wantsTransformation ? 'render/image/authenticated' : 'object';
            const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
            const queryString = transformationQuery ? `?${transformationQuery}` : '';
            try {
                const _path = this._getFinalPath(path);
                const res = yield (0, $c08781b5383b8ae1$export$3988ae62b71be9a3)(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                    headers: this.headers,
                    noResolveJson: true
                });
                const data = yield res.blob();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing file.
     * @param path
     */ info(path) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                const data = yield (0, $c08781b5383b8ae1$export$3988ae62b71be9a3)(this.fetch, `${this.url}/object/info/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: (0, $781ab65ed1f6c2c7$export$69d519e35e6fc3d4)(data),
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Checks the existence of a file.
     * @param path
     */ exists(path) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                yield (0, $c08781b5383b8ae1$export$5fd5031fecdacec3)(this.fetch, `${this.url}/object/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: true,
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error) && error instanceof (0, $367d31db45a3c565$export$29127ca2e1a271d)) {
                    const originalError = error.originalError;
                    if ([
                        400,
                        404
                    ].includes(originalError === null || originalError === void 0 ? void 0 : originalError.status)) return {
                        data: false,
                        error: error
                    };
                }
                throw error;
            }
        });
    }
    /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? '' : options.download}` : '';
        if (downloadQueryParam !== '') _queryString.push(downloadQueryParam);
        const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
        const renderPath = wantsTransformation ? 'render/image' : 'object';
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== '') _queryString.push(transformationQuery);
        let queryString = _queryString.join('&');
        if (queryString !== '') queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */ remove(paths) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $c08781b5383b8ae1$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/object/${this.bucketId}`, {
                    prefixes: paths
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */ // async getMetadata(
    //   id: string
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */ // async updateMetadata(
    //   id: string,
    //   meta: Metadata
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await post(
    //       this.fetch,
    //       `${this.url}/metadata/${id}`,
    //       { ...meta },
    //       { headers: this.headers }
    //     )
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     */ list(path, options, parameters) {
        return $bddcfd1a56c52a50$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const body = Object.assign(Object.assign(Object.assign({}, $bddcfd1a56c52a50$var$DEFAULT_SEARCH_OPTIONS), options), {
                    prefix: path || ''
                });
                const data = yield (0, $c08781b5383b8ae1$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/list/${this.bucketId}`, body, {
                    headers: this.headers
                }, parameters);
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $bddcfd1a56c52a50$require$Buffer !== 'undefined') return $bddcfd1a56c52a50$require$Buffer.from(data).toString('base64');
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, '').replace(/\/+/g, '/');
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join('&');
    }
}


// generated by genversion
const $ebf4e74345f99280$export$83d89fbfd8236492 = '2.7.1';


const $bd9ab129bfc6e9f0$export$88a84136db6a4b64 = {
    'X-Client-Info': `storage-js/${(0, $ebf4e74345f99280$export$83d89fbfd8236492)}`
};





var $95d5e4d574e06de7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $95d5e4d574e06de7$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, fetch){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $bd9ab129bfc6e9f0$export$88a84136db6a4b64)), headers);
        this.fetch = (0, $781ab65ed1f6c2c7$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Retrieves the details of all Storage buckets within an existing project.
     */ listBuckets() {
        return $95d5e4d574e06de7$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $c08781b5383b8ae1$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing Storage bucket.
     *
     * @param id The unique identifier of the bucket you would like to retrieve.
     */ getBucket(id) {
        return $95d5e4d574e06de7$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $c08781b5383b8ae1$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket/${id}`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a new Storage bucket
     *
     * @param id A unique identifier for the bucket you are creating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     * @returns newly created bucket id
     */ createBucket(id, options = {
        public: false
    }) {
        return $95d5e4d574e06de7$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $c08781b5383b8ae1$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Updates a Storage bucket
     *
     * @param id A unique identifier for the bucket you are updating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     */ updateBucket(id, options) {
        return $95d5e4d574e06de7$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $c08781b5383b8ae1$export$327f7b26ebf455db)(this.fetch, `${this.url}/bucket/${id}`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Removes all objects inside a single bucket.
     *
     * @param id The unique identifier of the bucket you would like to empty.
     */ emptyBucket(id) {
        return $95d5e4d574e06de7$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $c08781b5383b8ae1$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket/${id}/empty`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
     * You must first `empty()` the bucket.
     *
     * @param id The unique identifier of the bucket you would like to delete.
     */ deleteBucket(id) {
        return $95d5e4d574e06de7$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $c08781b5383b8ae1$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/bucket/${id}`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $367d31db45a3c565$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
}


class $2eb783a76edf6e8b$export$6c85f5032e75eff9 extends (0, $95d5e4d574e06de7$export$2e2bcd8739ae039) {
    constructor(url, headers = {}, fetch){
        super(url, headers, fetch);
    }
    /**
     * Perform file operation in a bucket.
     *
     * @param id The bucket id to operate on.
     */ from(id) {
        return new (0, $bddcfd1a56c52a50$export$2e2bcd8739ae039)(this.url, this.headers, id, this.fetch);
    }
}


const $5a10e71ba72d2e8b$export$83d89fbfd8236492 = '2.47.12';


let $796658c002c495ce$var$JS_ENV = '';
// @ts-ignore
if (typeof Deno !== 'undefined') $796658c002c495ce$var$JS_ENV = 'deno';
else if (typeof document !== 'undefined') $796658c002c495ce$var$JS_ENV = 'web';
else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') $796658c002c495ce$var$JS_ENV = 'react-native';
else $796658c002c495ce$var$JS_ENV = 'node';
const $796658c002c495ce$export$88a84136db6a4b64 = {
    'X-Client-Info': `supabase-js-${$796658c002c495ce$var$JS_ENV}/${(0, $5a10e71ba72d2e8b$export$83d89fbfd8236492)}`
};
const $796658c002c495ce$export$b63a5c3a2e5becd2 = {
    headers: $796658c002c495ce$export$88a84136db6a4b64
};
const $796658c002c495ce$export$b31378ae815bea6b = {
    schema: 'public'
};
const $796658c002c495ce$export$af122550cc2345b3 = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
};
const $796658c002c495ce$export$59685507ca0a3912 = {};



var $8oL7M = parcelRequire("8oL7M");
var $b3105f555cda8576$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $b3105f555cda8576$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (0, $8oL7M.default);
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $b3105f555cda8576$export$3d2cf54f85b7fc8a = ()=>{
    if (typeof Headers === 'undefined') return 0, $8oL7M.Headers;
    return Headers;
};
const $b3105f555cda8576$export$651dd5aef824521f = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch1 = $b3105f555cda8576$export$98d92b1aa79f8cc7(customFetch);
    const HeadersConstructor = $b3105f555cda8576$export$3d2cf54f85b7fc8a();
    return (input, init)=>$b3105f555cda8576$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const accessToken = (_a = yield getAccessToken()) !== null && _a !== void 0 ? _a : supabaseKey;
            let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
            if (!headers.has('apikey')) headers.set('apikey', supabaseKey);
            if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${accessToken}`);
            return fetch1(input, Object.assign(Object.assign({}, init), {
                headers: headers
            }));
        });
};


var $11a052849a72c68c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $11a052849a72c68c$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $11a052849a72c68c$export$d95b4586d238a081(url) {
    return url.replace(/\/$/, '');
}
const $11a052849a72c68c$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined';
function $11a052849a72c68c$export$da186dc3f8eace71(options, defaults) {
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS, auth: DEFAULT_AUTH_OPTIONS, realtime: DEFAULT_REALTIME_OPTIONS, global: DEFAULT_GLOBAL_OPTIONS } = defaults;
    const result = {
        db: Object.assign(Object.assign({}, DEFAULT_DB_OPTIONS), dbOptions),
        auth: Object.assign(Object.assign({}, DEFAULT_AUTH_OPTIONS), authOptions),
        realtime: Object.assign(Object.assign({}, DEFAULT_REALTIME_OPTIONS), realtimeOptions),
        global: Object.assign(Object.assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions),
        accessToken: ()=>$11a052849a72c68c$var$__awaiter(this, void 0, void 0, function*() {
                return '';
            })
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else // hack around Required<>
    delete result.accessToken;
    return result;
}


const $6296559933ec1dbf$export$83d89fbfd8236492 = '2.67.3';


const $184cca3ec8f22631$export$7fedf552187f0c3d = 'http://localhost:9999';
const $184cca3ec8f22631$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $184cca3ec8f22631$export$2f9161bad044dacb = '';
const $184cca3ec8f22631$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $6296559933ec1dbf$export$83d89fbfd8236492)}`
};
const $184cca3ec8f22631$export$7d4b3a66850dd9bd = 10; // in seconds
const $184cca3ec8f22631$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $184cca3ec8f22631$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $184cca3ec8f22631$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};



function $8d2f8a630efb9749$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $8d2f8a630efb9749$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $8d2f8a630efb9749$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const $8d2f8a630efb9749$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $8d2f8a630efb9749$export$9ec034ee80211814 = ()=>{
    if (!$8d2f8a630efb9749$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($8d2f8a630efb9749$var$localStorageWriteTests.tested) return $8d2f8a630efb9749$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $8d2f8a630efb9749$var$localStorageWriteTests.tested = true;
        $8d2f8a630efb9749$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $8d2f8a630efb9749$var$localStorageWriteTests.tested = true;
        $8d2f8a630efb9749$var$localStorageWriteTests.writable = false;
    }
    return $8d2f8a630efb9749$var$localStorageWriteTests.writable;
};
function $8d2f8a630efb9749$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}

const $8d2f8a630efb9749$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("8oL7M"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $8d2f8a630efb9749$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $8d2f8a630efb9749$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $8d2f8a630efb9749$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $8d2f8a630efb9749$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
function $8d2f8a630efb9749$export$f0d30a693d94f11c(value) {
    const key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let base64 = '';
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    value = value.replace('-', '+').replace('_', '/');
    while(i < value.length){
        enc1 = key.indexOf(value.charAt(i++));
        enc2 = key.indexOf(value.charAt(i++));
        enc3 = key.indexOf(value.charAt(i++));
        enc4 = key.indexOf(value.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        base64 = base64 + String.fromCharCode(chr1);
        if (enc3 != 64 && chr2 != 0) base64 = base64 + String.fromCharCode(chr2);
        if (enc4 != 64 && chr3 != 0) base64 = base64 + String.fromCharCode(chr3);
    }
    return base64;
}
class $8d2f8a630efb9749$export$85f6557964517f1a {
    constructor(){
        this.promise = new $8d2f8a630efb9749$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$8d2f8a630efb9749$export$85f6557964517f1a.promiseConstructor = Promise;
function $8d2f8a630efb9749$export$cc1c0b988f7b5577(token) {
    // Regex checks for base64url format
    const base64UrlRegex = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}=?$|[a-z0-9_-]{2}(==)?$)$/i;
    const parts = token.split('.');
    if (parts.length !== 3) throw new Error('JWT is not valid: not a JWT structure');
    if (!base64UrlRegex.test(parts[1])) throw new Error('JWT is not valid: payload is not in base64url format');
    const base64Url = parts[1];
    return JSON.parse($8d2f8a630efb9749$export$f0d30a693d94f11c(base64Url));
}
async function $8d2f8a630efb9749$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $8d2f8a630efb9749$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $8d2f8a630efb9749$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $8d2f8a630efb9749$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $8d2f8a630efb9749$var$dec2hex).join('');
}
async function $8d2f8a630efb9749$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
function $8d2f8a630efb9749$var$base64urlencode(str) {
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $8d2f8a630efb9749$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $8d2f8a630efb9749$var$sha256(verifier);
    return $8d2f8a630efb9749$var$base64urlencode(hashed);
}
async function $8d2f8a630efb9749$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $8d2f8a630efb9749$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/PASSWORD_RECOVERY';
    await $8d2f8a630efb9749$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $8d2f8a630efb9749$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $8d2f8a630efb9749$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $8d2f8a630efb9749$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $184cca3ec8f22631$export$e4f5507f88977535));
    if (!apiVersion) return null;
    if (!apiVersion.match($8d2f8a630efb9749$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e) {
        return null;
    }
}


class $31cd6b190a54d9c2$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
}
function $31cd6b190a54d9c2$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $31cd6b190a54d9c2$export$45fde0b55b14f37b extends $31cd6b190a54d9c2$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $31cd6b190a54d9c2$export$4fe744aeb810d543(error) {
    return $31cd6b190a54d9c2$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $31cd6b190a54d9c2$export$f7559805d4a50078 extends $31cd6b190a54d9c2$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $31cd6b190a54d9c2$export$823c745ae0673c5e extends $31cd6b190a54d9c2$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $31cd6b190a54d9c2$export$403b3fc0d3ad5f0c extends $31cd6b190a54d9c2$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $31cd6b190a54d9c2$export$3e849aa4db565c1d(error) {
    return $31cd6b190a54d9c2$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $31cd6b190a54d9c2$export$7e277b620449c1b4 extends $31cd6b190a54d9c2$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $31cd6b190a54d9c2$export$9ef583f0381b4cc extends $31cd6b190a54d9c2$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $31cd6b190a54d9c2$export$bf5df8e043856ef5 extends $31cd6b190a54d9c2$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
function $31cd6b190a54d9c2$export$45edea3999507afd(error) {
    return $31cd6b190a54d9c2$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $31cd6b190a54d9c2$export$39583657eb2a7027 extends $31cd6b190a54d9c2$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
class $31cd6b190a54d9c2$export$2423b763f68be1b4 extends $31cd6b190a54d9c2$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $31cd6b190a54d9c2$export$a77af358da5fb874(error) {
    return $31cd6b190a54d9c2$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $31cd6b190a54d9c2$export$b034076aa04913a6 extends $31cd6b190a54d9c2$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
}
function $31cd6b190a54d9c2$export$dac36143fd8a46ef(error) {
    return $31cd6b190a54d9c2$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}


var $0fd10bcee0b9ca37$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $0fd10bcee0b9ca37$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $0fd10bcee0b9ca37$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function $0fd10bcee0b9ca37$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $8d2f8a630efb9749$export$e8ad6599be1036a7)(error)) throw new (0, $31cd6b190a54d9c2$export$2423b763f68be1b4)($0fd10bcee0b9ca37$var$_getErrorMessage(error), 0);
    if ($0fd10bcee0b9ca37$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $31cd6b190a54d9c2$export$2423b763f68be1b4)($0fd10bcee0b9ca37$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $31cd6b190a54d9c2$export$f7559805d4a50078)($0fd10bcee0b9ca37$var$_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, $8d2f8a630efb9749$export$5f69ecf1c14d56fd)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $184cca3ec8f22631$export$1f9a66038489bdeb)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $31cd6b190a54d9c2$export$b034076aa04913a6)($0fd10bcee0b9ca37$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $31cd6b190a54d9c2$export$b034076aa04913a6)($0fd10bcee0b9ca37$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $31cd6b190a54d9c2$export$403b3fc0d3ad5f0c)();
    throw new (0, $31cd6b190a54d9c2$export$45fde0b55b14f37b)($0fd10bcee0b9ca37$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $0fd10bcee0b9ca37$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $0fd10bcee0b9ca37$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $184cca3ec8f22631$export$e4f5507f88977535]) headers[0, $184cca3ec8f22631$export$e4f5507f88977535] = (0, $184cca3ec8f22631$export$1f9a66038489bdeb)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $0fd10bcee0b9ca37$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $0fd10bcee0b9ca37$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $0fd10bcee0b9ca37$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $31cd6b190a54d9c2$export$2423b763f68be1b4)($0fd10bcee0b9ca37$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $0fd10bcee0b9ca37$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $0fd10bcee0b9ca37$export$d3da1ecaf1206c58(e);
    }
}
function $0fd10bcee0b9ca37$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($0fd10bcee0b9ca37$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $8d2f8a630efb9749$export$e02d0a488392f690)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $0fd10bcee0b9ca37$export$db83aade1c2922c7(data) {
    const response = $0fd10bcee0b9ca37$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $0fd10bcee0b9ca37$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $0fd10bcee0b9ca37$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $0fd10bcee0b9ca37$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = $0fd10bcee0b9ca37$var$__rest(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $0fd10bcee0b9ca37$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $0fd10bcee0b9ca37$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}




var $6210133df009bd9d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $6210133df009bd9d$export$2e2bcd8739ae039 {
    constructor({ url: url = '', headers: headers = {}, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $8d2f8a630efb9749$export$98d92b1aa79f8cc7)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ async signOut(jwt, scope = 'global') {
        try {
            await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $0fd10bcee0b9ca37$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = $6210133df009bd9d$var$__rest(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $0fd10bcee0b9ca37$export$f5eaa950605b2146),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async createUser(attributes) {
        try {
            return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $0fd10bcee0b9ca37$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $0fd10bcee0b9ca37$export$7aed01df6e045e31)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async getUserById(uid) {
        try {
            return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $0fd10bcee0b9ca37$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async updateUserById(uid, attributes) {
        try {
            return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $0fd10bcee0b9ca37$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async deleteUser(id, shouldSoftDelete = false) {
        try {
            return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $0fd10bcee0b9ca37$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        try {
            const { data: data, error: error } = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        try {
            const data = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}








const $728e127ad47e6a32$export$bba7b6c94612d04b = {
    getItem: (key)=>{
        if (!(0, $8d2f8a630efb9749$export$9ec034ee80211814)()) return null;
        return globalThis.localStorage.getItem(key);
    },
    setItem: (key, value)=>{
        if (!(0, $8d2f8a630efb9749$export$9ec034ee80211814)()) return;
        globalThis.localStorage.setItem(key, value);
    },
    removeItem: (key)=>{
        if (!(0, $8d2f8a630efb9749$export$9ec034ee80211814)()) return;
        globalThis.localStorage.removeItem(key);
    }
};
function $728e127ad47e6a32$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}


/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $744b2f8d6806d348$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}




const $ab1a35134f5a0f92$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $8d2f8a630efb9749$export$9ec034ee80211814)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $ab1a35134f5a0f92$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $ab1a35134f5a0f92$export$4aa56776043a4631 extends $ab1a35134f5a0f92$export$23e9464cc010dff9 {
}
class $ab1a35134f5a0f92$export$4b982ee840d3d915 extends $ab1a35134f5a0f92$export$23e9464cc010dff9 {
}
async function $ab1a35134f5a0f92$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($ab1a35134f5a0f92$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    if (acquireTimeout > 0) setTimeout(()=>{
        abortController.abort();
        if ($ab1a35134f5a0f92$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                if ($ab1a35134f5a0f92$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($ab1a35134f5a0f92$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($ab1a35134f5a0f92$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new $ab1a35134f5a0f92$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($ab1a35134f5a0f92$export$e368aba7747330f2.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                return await fn();
            }
        }));
}
const $ab1a35134f5a0f92$var$PROCESS_LOCKS = {};
async function $ab1a35134f5a0f92$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $ab1a35134f5a0f92$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    const currentOperation = Promise.race([
        previousOperation.catch(()=>{
            // ignore error of previous operation that we're waiting to finish
            return null;
        }),
        acquireTimeout >= 0 ? new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new $ab1a35134f5a0f92$export$4b982ee840d3d915(`Acquring process lock with name "${name}" timed out`));
            }, acquireTimeout);
        }) : null
    ].filter((x)=>x)).catch((e)=>{
        if (e && e.isAcquireTimeout) throw e;
        return null;
    }).then(async ()=>{
        // previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    });
    $ab1a35134f5a0f92$var$PROCESS_LOCKS[name] = currentOperation.catch(async (e)=>{
        if (e && e.isAcquireTimeout) {
            // if the current operation timed out, it doesn't mean that the previous
            // operation finished, so we need contnue waiting for it to finish
            await previousOperation;
            return null;
        }
        throw e;
    });
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}


(0, $744b2f8d6806d348$export$ad067ce270531206)(); // Make "globalThis" available
const $c93138e9ca74cccc$var$DEFAULT_OPTIONS = {
    url: (0, $184cca3ec8f22631$export$7fedf552187f0c3d),
    storageKey: (0, $184cca3ec8f22631$export$86880b4b2e1a2384),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $184cca3ec8f22631$export$88a84136db6a4b64),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false
};
/** Current session will be checked for refresh at this interval. */ const $c93138e9ca74cccc$var$AUTO_REFRESH_TICK_DURATION = 30000;
/**
 * A token refresh will be attempted this many ticks before the current session expires. */ const $c93138e9ca74cccc$var$AUTO_REFRESH_TICK_THRESHOLD = 3;
async function $c93138e9ca74cccc$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
class $c93138e9ca74cccc$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     */ constructor(options){
        var _a, _b;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the the auth state is known and it's save to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        this.instanceID = $c93138e9ca74cccc$export$2e2bcd8739ae039.nextInstanceID;
        $c93138e9ca74cccc$export$2e2bcd8739ae039.nextInstanceID += 1;
        if (this.instanceID > 0 && (0, $8d2f8a630efb9749$export$4e09c449d6c407f7)()) console.warn('Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.');
        const settings = Object.assign(Object.assign({}, $c93138e9ca74cccc$var$DEFAULT_OPTIONS), options);
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        this.persistSession = settings.persistSession;
        this.storageKey = settings.storageKey;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, $6210133df009bd9d$export$2e2bcd8739ae039)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $8d2f8a630efb9749$export$98d92b1aa79f8cc7)(settings.fetch);
        this.lock = settings.lock || $c93138e9ca74cccc$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        if (settings.lock) this.lock = settings.lock;
        else if ((0, $8d2f8a630efb9749$export$4e09c449d6c407f7)() && ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.locks)) this.lock = (0, $ab1a35134f5a0f92$export$f4ff21938fb7af3c);
        else this.lock = $c93138e9ca74cccc$var$lockNoOp;
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $8d2f8a630efb9749$export$9ec034ee80211814)()) this.storage = (0, $728e127ad47e6a32$export$bba7b6c94612d04b);
            else {
                this.memoryStorage = {};
                this.storage = (0, $728e127ad47e6a32$export$d791f66d7e5710cf)(this.memoryStorage);
            }
        } else {
            this.memoryStorage = {};
            this.storage = (0, $728e127ad47e6a32$export$d791f66d7e5710cf)(this.memoryStorage);
        }
        if ((0, $8d2f8a630efb9749$export$4e09c449d6c407f7)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_b = this.broadcastChannel) === null || _b === void 0 || _b.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
            });
        }
        this.initialize();
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(`GoTrueClient@${this.instanceID} (${(0, $6296559933ec1dbf$export$83d89fbfd8236492)}) ${new Date().toISOString()}`, ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(-1, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            const params = (0, $8d2f8a630efb9749$export$7a29392fb778224c)(window.location.href);
            let callbackUrlType = 'none';
            if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
            else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, $8d2f8a630efb9749$export$4e09c449d6c407f7)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data: data, error: error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $31cd6b190a54d9c2$export$45edea3999507afd)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // failed login attempt via url,
                    // remove old session as in verifyOtp, signUp and signInWith*
                    await this._removeSession();
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                error: error
            };
            return {
                error: new (0, $31cd6b190a54d9c2$export$f7559805d4a50078)('Unexpected error during initialization', error)
            };
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $0fd10bcee0b9ca37$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $8d2f8a630efb9749$export$81b177cadfcf873c)(this.storage, this.storageKey);
                res = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $0fd10bcee0b9ca37$export$273fe4673a018c2e)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $0fd10bcee0b9ca37$export$273fe4673a018c2e)
                });
            } else throw new (0, $31cd6b190a54d9c2$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $0fd10bcee0b9ca37$export$db83aade1c2922c7)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $0fd10bcee0b9ca37$export$db83aade1c2922c7)
                });
            } else throw new (0, $31cd6b190a54d9c2$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $31cd6b190a54d9c2$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $8d2f8a630efb9749$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            const { data: data, error: error } = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $0fd10bcee0b9ca37$export$273fe4673a018c2e)
            });
            await (0, $8d2f8a630efb9749$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: new (0, $31cd6b190a54d9c2$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $0fd10bcee0b9ca37$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $31cd6b190a54d9c2$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $8d2f8a630efb9749$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { error: error } = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : 'sms'
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $31cd6b190a54d9c2$export$9ef583f0381b4cc)('You must provide either an email or phone number.');
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $0fd10bcee0b9ca37$export$273fe4673a018c2e)
            });
            if (error) throw error;
            if (!data) throw new Error('An error occurred on token verification.');
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ async signInWithSSO(params) {
        var _a, _b, _c;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $8d2f8a630efb9749$export$81b177cadfcf873c)(this.storage, this.storageKey);
            return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $0fd10bcee0b9ca37$export$b04785c46dcd8f8b)
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $31cd6b190a54d9c2$export$403b3fc0d3ad5f0c)();
                const { error: error } = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $31cd6b190a54d9c2$export$9ef583f0381b4cc)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $8d2f8a630efb9749$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            const hasExpired = currentSession.expires_at ? currentSession.expires_at <= Date.now() / 1000 : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.storage.isServer) {
                    let suppressWarning = this.suppressGetSessionWarning;
                    const proxySession = new Proxy(currentSession, {
                        get: (target, prop, receiver)=>{
                            if (!suppressWarning && prop === 'user') {
                                // only show warning when the user object is being accessed from the server
                                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                                suppressWarning = true; // keeps this proxy instance from logging additional warnings
                                this.suppressGetSessionWarning = true; // keeps this client's future proxy instances from warning
                            }
                            return Reflect.get(target, prop, receiver);
                        }
                    });
                    currentSession = proxySession;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return {
                data: {
                    session: null
                },
                error: error
            };
            return {
                data: {
                    session: session
                },
                error: null
            };
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return await this._getUser();
        });
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $0fd10bcee0b9ca37$export$e20f488897843593)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $31cd6b190a54d9c2$export$403b3fc0d3ad5f0c)()
                };
                return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $0fd10bcee0b9ca37$export$e20f488897843593)
                });
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) {
                if ((0, $31cd6b190a54d9c2$export$3e849aa4db565c1d)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, $8d2f8a630efb9749$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return {
                    data: {
                        user: null
                    },
                    error: error
                };
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $31cd6b190a54d9c2$export$403b3fc0d3ad5f0c)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, $8d2f8a630efb9749$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { data: data, error: userError } = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $0fd10bcee0b9ca37$export$e20f488897843593)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return {
                    data: {
                        user: session.user
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Decodes a JWT (without performing any validation).
     */ _decodeJWT(jwt) {
        return (0, $8d2f8a630efb9749$export$cc1c0b988f7b5577)(jwt);
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $31cd6b190a54d9c2$export$403b3fc0d3ad5f0c)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const payload = (0, $8d2f8a630efb9749$export$cc1c0b988f7b5577)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { session: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) throw error;
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $31cd6b190a54d9c2$export$403b3fc0d3ad5f0c)();
                const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!session) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                return {
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        try {
            if (!(0, $8d2f8a630efb9749$export$4e09c449d6c407f7)()) throw new (0, $31cd6b190a54d9c2$export$bf5df8e043856ef5)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, $31cd6b190a54d9c2$export$bf5df8e043856ef5)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, $31cd6b190a54d9c2$export$39583657eb2a7027)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, $31cd6b190a54d9c2$export$bf5df8e043856ef5)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, $31cd6b190a54d9c2$export$39583657eb2a7027)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $31cd6b190a54d9c2$export$bf5df8e043856ef5)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= $c93138e9ca74cccc$var$AUTO_REFRESH_TICK_DURATION) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return {
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */ _isImplicitGrantCallback(params) {
        return Boolean(params.access_token || params.error_description);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        const currentStorageContent = await (0, $8d2f8a630efb9749$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError) return {
                error: sessionError
            };
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $31cd6b190a54d9c2$export$4fe744aeb810d543)(error) && (error.status === 404 || error.status === 401 || error.status === 403))) return {
                        error: error
                    };
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, $8d2f8a630efb9749$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return {
                error: null
            };
        });
    }
    /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */ onAuthStateChange(callback) {
        const id = (0, $8d2f8a630efb9749$export$31b40729666a4ae0)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(-1, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $8d2f8a630efb9749$export$81b177cadfcf873c)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return {
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Links an oauth identity to an existing user.
     * This method supports the PKCE flow.
     */ async linkIdentity(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, $8d2f8a630efb9749$export$4e09c449d6c407f7)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return {
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            };
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $8d2f8a630efb9749$export$9e1b8e833f44ff21)(async (attempt)=>{
                if (attempt > 0) await (0, $8d2f8a630efb9749$export$e772c8ff12451969)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $0fd10bcee0b9ca37$export$273fe4673a018c2e)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $31cd6b190a54d9c2$export$a77af358da5fb874)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < $c93138e9ca74cccc$var$AUTO_REFRESH_TICK_DURATION;
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $8d2f8a630efb9749$export$4e09c449d6c407f7)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $8d2f8a630efb9749$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const timeNow = Math.round(Date.now() / 1000);
            const expiresWithMargin = ((_a = currentSession.expires_at) !== null && _a !== void 0 ? _a : Infinity) < timeNow + (0, $184cca3ec8f22631$export$7d4b3a66850dd9bd);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $184cca3ec8f22631$export$7d4b3a66850dd9bd)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $31cd6b190a54d9c2$export$a77af358da5fb874)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $31cd6b190a54d9c2$export$403b3fc0d3ad5f0c)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $8d2f8a630efb9749$export$85f6557964517f1a)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $31cd6b190a54d9c2$export$403b3fc0d3ad5f0c)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                session: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) {
                const result = {
                    session: null,
                    error: error
                };
                if (!(0, $31cd6b190a54d9c2$export$a77af358da5fb874)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        await (0, $8d2f8a630efb9749$export$e82c36d29078a87f)(this.storage, this.storageKey, session);
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        await (0, $8d2f8a630efb9749$export$d35c645d585317ec)(this.storage, this.storageKey);
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $8d2f8a630efb9749$export$4e09c449d6c407f7)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), $c93138e9ca74cccc$var$AUTO_REFRESH_TICK_DURATION);
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / $c93138e9ca74cccc$var$AUTO_REFRESH_TICK_DURATION);
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${$c93138e9ca74cccc$var$AUTO_REFRESH_TICK_DURATION}ms, refresh threshold is ${$c93138e9ca74cccc$var$AUTO_REFRESH_TICK_THRESHOLD} ticks`);
                            if (expiresInTicks <= $c93138e9ca74cccc$var$AUTO_REFRESH_TICK_THRESHOLD) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, $ab1a35134f5a0f92$export$23e9464cc010dff9)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $8d2f8a630efb9749$export$4e09c449d6c407f7)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>await this._onVisibilityChanged(false);
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(-1, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, $8d2f8a630efb9749$export$81b177cadfcf873c)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : {
                    issuer: params.issuer
                });
                const { data: data, error: error } = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return {
                    data: null,
                    error: error
                };
                if (params.factorType === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return {
                    data: data,
                    error: null
                };
            });
        } catch (error) {
            if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#verify}
     */ async _verify(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    const { data: data, error: error } = await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: {
                            code: params.code,
                            challenge_id: params.challengeId
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return {
                        data: null,
                        error: error
                    };
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return {
                        data: data,
                        error: error
                    };
                });
            } catch (error) {
                if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challenge}
     */ async _challenge(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    return await (0, $0fd10bcee0b9ca37$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: {
                            channel: params.channel
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                });
            } catch (error) {
                if ((0, $31cd6b190a54d9c2$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return {
            data: null,
            error: challengeError
        };
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
        const totp = factors.filter((factor)=>factor.factor_type === 'totp' && factor.status === 'verified');
        const phone = factors.filter((factor)=>factor.factor_type === 'phone' && factor.status === 'verified');
        return {
            data: {
                all: factors,
                totp: totp,
                phone: phone
            },
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel() {
        return this._acquireLock(-1, async ()=>{
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                if (!session) return {
                    data: {
                        currentLevel: null,
                        nextLevel: null,
                        currentAuthenticationMethods: []
                    },
                    error: null
                };
                const payload = this._decodeJWT(session.access_token);
                let currentLevel = null;
                if (payload.aal) currentLevel = payload.aal;
                let nextLevel = currentLevel;
                const verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
                if (verifiedFactors.length > 0) nextLevel = 'aal2';
                const currentAuthenticationMethods = payload.amr || [];
                return {
                    data: {
                        currentLevel: currentLevel,
                        nextLevel: nextLevel,
                        currentAuthenticationMethods: currentAuthenticationMethods
                    },
                    error: null
                };
            });
        });
    }
}
$c93138e9ca74cccc$export$2e2bcd8739ae039.nextInstanceID = 0;



const $9dca537b18613d0e$var$AuthAdminApi = (0, $6210133df009bd9d$export$2e2bcd8739ae039);
var $9dca537b18613d0e$export$2e2bcd8739ae039 = $9dca537b18613d0e$var$AuthAdminApi;



const $9a8aa1ecd4e1043e$var$AuthClient = (0, $c93138e9ca74cccc$export$2e2bcd8739ae039);
var $9a8aa1ecd4e1043e$export$2e2bcd8739ae039 = $9a8aa1ecd4e1043e$var$AuthClient;








class $fd8d6f7ecee4c43f$export$8199a418bb09bd56 extends (0, $9a8aa1ecd4e1043e$export$2e2bcd8739ae039) {
    constructor(options){
        super(options);
    }
}


var $cb2acc2586e63cf7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $cb2acc2586e63cf7$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
     * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
     * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
     * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
     * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
     * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
     * @param options.realtime Options passed along to realtime-js constructor.
     * @param options.global.fetch A custom fetch implementation.
     * @param options.global.headers Any additional headers to send with each network request.
     */ constructor(supabaseUrl, supabaseKey, options){
        var _a, _b, _c;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        if (!supabaseUrl) throw new Error('supabaseUrl is required.');
        if (!supabaseKey) throw new Error('supabaseKey is required.');
        const _supabaseUrl = (0, $11a052849a72c68c$export$d95b4586d238a081)(supabaseUrl);
        this.realtimeUrl = `${_supabaseUrl}/realtime/v1`.replace(/^http/i, 'ws');
        this.authUrl = `${_supabaseUrl}/auth/v1`;
        this.storageUrl = `${_supabaseUrl}/storage/v1`;
        this.functionsUrl = `${_supabaseUrl}/functions/v1`;
        // default storage key uses the supabase project ref as a namespace
        const defaultStorageKey = `sb-${new URL(this.authUrl).hostname.split('.')[0]}-auth-token`;
        const DEFAULTS = {
            db: (0, $796658c002c495ce$export$b31378ae815bea6b),
            realtime: (0, $796658c002c495ce$export$59685507ca0a3912),
            auth: Object.assign(Object.assign({}, (0, $796658c002c495ce$export$af122550cc2345b3)), {
                storageKey: defaultStorageKey
            }),
            global: (0, $796658c002c495ce$export$b63a5c3a2e5becd2)
        };
        const settings = (0, $11a052849a72c68c$export$da186dc3f8eace71)(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_a = settings.auth.storageKey) !== null && _a !== void 0 ? _a : '';
        this.headers = (_b = settings.global.headers) !== null && _b !== void 0 ? _b : {};
        if (!settings.accessToken) this.auth = this._initSupabaseAuthClient((_c = settings.auth) !== null && _c !== void 0 ? _c : {}, this.headers, settings.global.fetch);
        else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = (0, $b3105f555cda8576$export$651dd5aef824521f)(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient(Object.assign({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this)
        }, settings.realtime));
        this.rest = new (0, $a81c39bf792d7bd5$export$796f32e2ee984aaa)(`${_supabaseUrl}/rest/v1`, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch
        });
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
     * Supabase Functions allows you to deploy and invoke edge functions.
     */ get functions() {
        return new (0, $8644507f4d2bfb12$export$1d0b400bf8a0fa55)(this.functionsUrl, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
     * Supabase Storage allows you to manage user-generated content, such as photos or videos.
     */ get storage() {
        return new (0, $2eb783a76edf6e8b$export$6c85f5032e75eff9)(this.storageUrl, this.headers, this.fetch);
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        return this.rest.from(relation);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.schema
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return this.rest.schema(schema);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.rpc
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, options = {}) {
        return this.rest.rpc(fn, args, options);
    }
    /**
     * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
     *
     * @param {string} name - The name of the Realtime channel.
     * @param {Object} opts - The options to pass to the Realtime channel.
     *
     */ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
     * Returns all Realtime channels.
     */ getChannels() {
        return this.realtime.getChannels();
    }
    /**
     * Unsubscribes and removes Realtime channel from Realtime client.
     *
     * @param {RealtimeChannel} channel - The name of the Realtime channel.
     *
     */ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
     * Unsubscribes and removes all Realtime channels from Realtime client.
     */ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    _getAccessToken() {
        var _a, _b;
        return $cb2acc2586e63cf7$var$__awaiter(this, void 0, void 0, function*() {
            if (this.accessToken) return yield this.accessToken();
            const { data: data } = yield this.auth.getSession();
            return (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : null;
        });
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug }, headers, fetch) {
        var _a;
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new (0, $fd8d6f7ecee4c43f$export$8199a418bb09bd56)({
            url: this.authUrl,
            headers: Object.assign(Object.assign({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            fetch: fetch,
            // auth checks if there is a custom authorizaiton header using this flag
            // so it knows whether to return an error when getUser is called with no session
            hasCustomAuthorizationHeader: (_a = 'Authorization' in this.headers, _a !== void 0) ? _a : false
        });
    }
    _initRealtimeClient(options) {
        return new (0, $cd4b3129f08519b6$export$2e2bcd8739ae039)(this.realtimeUrl, Object.assign(Object.assign({}, options), {
            params: Object.assign({
                apikey: this.supabaseKey
            }, options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        let data = this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, 'CLIENT', session === null || session === void 0 ? void 0 : session.access_token);
        });
        return data;
    }
    _handleTokenChanged(event, source, token) {
        if ((event === 'TOKEN_REFRESHED' || event === 'SIGNED_IN') && this.changedAccessToken !== token) this.changedAccessToken = token;
        else if (event === 'SIGNED_OUT') {
            this.realtime.setAuth();
            if (source == 'STORAGE') this.auth.signOut();
            this.changedAccessToken = undefined;
        }
    }
}





const $5a1fcc18818239b9$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new (0, $cb2acc2586e63cf7$export$2e2bcd8739ae039)(supabaseUrl, supabaseKey, options);
};



var $bh6RR = parcelRequire("bh6RR");
var $6fc264ec92100d3a$exports = {};

$parcel$export($6fc264ec92100d3a$exports, "createRoot", function () { return $6fc264ec92100d3a$export$882461b6382ed46c; }, function (v) { return $6fc264ec92100d3a$export$882461b6382ed46c = v; });
$parcel$export($6fc264ec92100d3a$exports, "hydrateRoot", function () { return $6fc264ec92100d3a$export$757ceba2d55c277e; }, function (v) { return $6fc264ec92100d3a$export$757ceba2d55c277e = v; });
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
'use strict';

var $6afFj = parcelRequire("6afFj");
var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $6afFj.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $6afFj.hydrateRoot;



var $10WBQ = parcelRequire("10WBQ");

var $aWtcP = parcelRequire("aWtcP");

var $ih19M = parcelRequire("ih19M");
var $4c1054d6b7f3fad6$var$e, $4c1054d6b7f3fad6$var$t = "colors", $4c1054d6b7f3fad6$var$n = "sizes", $4c1054d6b7f3fad6$var$r = "space", $4c1054d6b7f3fad6$export$22deaee80f3d7c38 = {
    gap: $4c1054d6b7f3fad6$var$r,
    gridGap: $4c1054d6b7f3fad6$var$r,
    columnGap: $4c1054d6b7f3fad6$var$r,
    gridColumnGap: $4c1054d6b7f3fad6$var$r,
    rowGap: $4c1054d6b7f3fad6$var$r,
    gridRowGap: $4c1054d6b7f3fad6$var$r,
    inset: $4c1054d6b7f3fad6$var$r,
    insetBlock: $4c1054d6b7f3fad6$var$r,
    insetBlockEnd: $4c1054d6b7f3fad6$var$r,
    insetBlockStart: $4c1054d6b7f3fad6$var$r,
    insetInline: $4c1054d6b7f3fad6$var$r,
    insetInlineEnd: $4c1054d6b7f3fad6$var$r,
    insetInlineStart: $4c1054d6b7f3fad6$var$r,
    margin: $4c1054d6b7f3fad6$var$r,
    marginTop: $4c1054d6b7f3fad6$var$r,
    marginRight: $4c1054d6b7f3fad6$var$r,
    marginBottom: $4c1054d6b7f3fad6$var$r,
    marginLeft: $4c1054d6b7f3fad6$var$r,
    marginBlock: $4c1054d6b7f3fad6$var$r,
    marginBlockEnd: $4c1054d6b7f3fad6$var$r,
    marginBlockStart: $4c1054d6b7f3fad6$var$r,
    marginInline: $4c1054d6b7f3fad6$var$r,
    marginInlineEnd: $4c1054d6b7f3fad6$var$r,
    marginInlineStart: $4c1054d6b7f3fad6$var$r,
    padding: $4c1054d6b7f3fad6$var$r,
    paddingTop: $4c1054d6b7f3fad6$var$r,
    paddingRight: $4c1054d6b7f3fad6$var$r,
    paddingBottom: $4c1054d6b7f3fad6$var$r,
    paddingLeft: $4c1054d6b7f3fad6$var$r,
    paddingBlock: $4c1054d6b7f3fad6$var$r,
    paddingBlockEnd: $4c1054d6b7f3fad6$var$r,
    paddingBlockStart: $4c1054d6b7f3fad6$var$r,
    paddingInline: $4c1054d6b7f3fad6$var$r,
    paddingInlineEnd: $4c1054d6b7f3fad6$var$r,
    paddingInlineStart: $4c1054d6b7f3fad6$var$r,
    top: $4c1054d6b7f3fad6$var$r,
    right: $4c1054d6b7f3fad6$var$r,
    bottom: $4c1054d6b7f3fad6$var$r,
    left: $4c1054d6b7f3fad6$var$r,
    scrollMargin: $4c1054d6b7f3fad6$var$r,
    scrollMarginTop: $4c1054d6b7f3fad6$var$r,
    scrollMarginRight: $4c1054d6b7f3fad6$var$r,
    scrollMarginBottom: $4c1054d6b7f3fad6$var$r,
    scrollMarginLeft: $4c1054d6b7f3fad6$var$r,
    scrollMarginX: $4c1054d6b7f3fad6$var$r,
    scrollMarginY: $4c1054d6b7f3fad6$var$r,
    scrollMarginBlock: $4c1054d6b7f3fad6$var$r,
    scrollMarginBlockEnd: $4c1054d6b7f3fad6$var$r,
    scrollMarginBlockStart: $4c1054d6b7f3fad6$var$r,
    scrollMarginInline: $4c1054d6b7f3fad6$var$r,
    scrollMarginInlineEnd: $4c1054d6b7f3fad6$var$r,
    scrollMarginInlineStart: $4c1054d6b7f3fad6$var$r,
    scrollPadding: $4c1054d6b7f3fad6$var$r,
    scrollPaddingTop: $4c1054d6b7f3fad6$var$r,
    scrollPaddingRight: $4c1054d6b7f3fad6$var$r,
    scrollPaddingBottom: $4c1054d6b7f3fad6$var$r,
    scrollPaddingLeft: $4c1054d6b7f3fad6$var$r,
    scrollPaddingX: $4c1054d6b7f3fad6$var$r,
    scrollPaddingY: $4c1054d6b7f3fad6$var$r,
    scrollPaddingBlock: $4c1054d6b7f3fad6$var$r,
    scrollPaddingBlockEnd: $4c1054d6b7f3fad6$var$r,
    scrollPaddingBlockStart: $4c1054d6b7f3fad6$var$r,
    scrollPaddingInline: $4c1054d6b7f3fad6$var$r,
    scrollPaddingInlineEnd: $4c1054d6b7f3fad6$var$r,
    scrollPaddingInlineStart: $4c1054d6b7f3fad6$var$r,
    fontSize: "fontSizes",
    background: $4c1054d6b7f3fad6$var$t,
    backgroundColor: $4c1054d6b7f3fad6$var$t,
    backgroundImage: $4c1054d6b7f3fad6$var$t,
    borderImage: $4c1054d6b7f3fad6$var$t,
    border: $4c1054d6b7f3fad6$var$t,
    borderBlock: $4c1054d6b7f3fad6$var$t,
    borderBlockEnd: $4c1054d6b7f3fad6$var$t,
    borderBlockStart: $4c1054d6b7f3fad6$var$t,
    borderBottom: $4c1054d6b7f3fad6$var$t,
    borderBottomColor: $4c1054d6b7f3fad6$var$t,
    borderColor: $4c1054d6b7f3fad6$var$t,
    borderInline: $4c1054d6b7f3fad6$var$t,
    borderInlineEnd: $4c1054d6b7f3fad6$var$t,
    borderInlineStart: $4c1054d6b7f3fad6$var$t,
    borderLeft: $4c1054d6b7f3fad6$var$t,
    borderLeftColor: $4c1054d6b7f3fad6$var$t,
    borderRight: $4c1054d6b7f3fad6$var$t,
    borderRightColor: $4c1054d6b7f3fad6$var$t,
    borderTop: $4c1054d6b7f3fad6$var$t,
    borderTopColor: $4c1054d6b7f3fad6$var$t,
    caretColor: $4c1054d6b7f3fad6$var$t,
    color: $4c1054d6b7f3fad6$var$t,
    columnRuleColor: $4c1054d6b7f3fad6$var$t,
    fill: $4c1054d6b7f3fad6$var$t,
    outline: $4c1054d6b7f3fad6$var$t,
    outlineColor: $4c1054d6b7f3fad6$var$t,
    stroke: $4c1054d6b7f3fad6$var$t,
    textDecorationColor: $4c1054d6b7f3fad6$var$t,
    fontFamily: "fonts",
    fontWeight: "fontWeights",
    lineHeight: "lineHeights",
    letterSpacing: "letterSpacings",
    blockSize: $4c1054d6b7f3fad6$var$n,
    minBlockSize: $4c1054d6b7f3fad6$var$n,
    maxBlockSize: $4c1054d6b7f3fad6$var$n,
    inlineSize: $4c1054d6b7f3fad6$var$n,
    minInlineSize: $4c1054d6b7f3fad6$var$n,
    maxInlineSize: $4c1054d6b7f3fad6$var$n,
    width: $4c1054d6b7f3fad6$var$n,
    minWidth: $4c1054d6b7f3fad6$var$n,
    maxWidth: $4c1054d6b7f3fad6$var$n,
    height: $4c1054d6b7f3fad6$var$n,
    minHeight: $4c1054d6b7f3fad6$var$n,
    maxHeight: $4c1054d6b7f3fad6$var$n,
    flexBasis: $4c1054d6b7f3fad6$var$n,
    gridTemplateColumns: $4c1054d6b7f3fad6$var$n,
    gridTemplateRows: $4c1054d6b7f3fad6$var$n,
    borderWidth: "borderWidths",
    borderTopWidth: "borderWidths",
    borderRightWidth: "borderWidths",
    borderBottomWidth: "borderWidths",
    borderLeftWidth: "borderWidths",
    borderStyle: "borderStyles",
    borderTopStyle: "borderStyles",
    borderRightStyle: "borderStyles",
    borderBottomStyle: "borderStyles",
    borderLeftStyle: "borderStyles",
    borderRadius: "radii",
    borderTopLeftRadius: "radii",
    borderTopRightRadius: "radii",
    borderBottomRightRadius: "radii",
    borderBottomLeftRadius: "radii",
    boxShadow: "shadows",
    textShadow: "shadows",
    transition: "transitions",
    zIndex: "zIndices"
}, $4c1054d6b7f3fad6$var$o = (e, t)=>"function" == typeof t ? {
        "()": Function.prototype.toString.call(t)
    } : t, $4c1054d6b7f3fad6$var$l = ()=>{
    const e = Object.create(null);
    return (t, n, ...r)=>{
        const i = ((e)=>JSON.stringify(e, $4c1054d6b7f3fad6$var$o))(t);
        return i in e ? e[i] : e[i] = n(t, ...r);
    };
}, $4c1054d6b7f3fad6$var$s = Symbol.for("sxs.internal"), $4c1054d6b7f3fad6$var$a = (e, t)=>Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), $4c1054d6b7f3fad6$var$c = (e)=>{
    for(const t in e)return !0;
    return !1;
}, { hasOwnProperty: $4c1054d6b7f3fad6$var$d } = Object.prototype, $4c1054d6b7f3fad6$var$g = (e)=>e.includes("-") ? e : e.replace(/[A-Z]/g, (e)=>"-" + e.toLowerCase()), $4c1054d6b7f3fad6$var$p = /\s+(?![^()]*\))/, $4c1054d6b7f3fad6$var$u = (e)=>(t)=>e(..."string" == typeof t ? String(t).split($4c1054d6b7f3fad6$var$p) : [
            t
        ]), $4c1054d6b7f3fad6$var$h = {
    appearance: (e)=>({
            WebkitAppearance: e,
            appearance: e
        }),
    backfaceVisibility: (e)=>({
            WebkitBackfaceVisibility: e,
            backfaceVisibility: e
        }),
    backdropFilter: (e)=>({
            WebkitBackdropFilter: e,
            backdropFilter: e
        }),
    backgroundClip: (e)=>({
            WebkitBackgroundClip: e,
            backgroundClip: e
        }),
    boxDecorationBreak: (e)=>({
            WebkitBoxDecorationBreak: e,
            boxDecorationBreak: e
        }),
    clipPath: (e)=>({
            WebkitClipPath: e,
            clipPath: e
        }),
    content: (e)=>({
            content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"`
        }),
    hyphens: (e)=>({
            WebkitHyphens: e,
            hyphens: e
        }),
    maskImage: (e)=>({
            WebkitMaskImage: e,
            maskImage: e
        }),
    maskSize: (e)=>({
            WebkitMaskSize: e,
            maskSize: e
        }),
    tabSize: (e)=>({
            MozTabSize: e,
            tabSize: e
        }),
    textSizeAdjust: (e)=>({
            WebkitTextSizeAdjust: e,
            textSizeAdjust: e
        }),
    userSelect: (e)=>({
            WebkitUserSelect: e,
            userSelect: e
        }),
    marginBlock: $4c1054d6b7f3fad6$var$u((e, t)=>({
            marginBlockStart: e,
            marginBlockEnd: t || e
        })),
    marginInline: $4c1054d6b7f3fad6$var$u((e, t)=>({
            marginInlineStart: e,
            marginInlineEnd: t || e
        })),
    maxSize: $4c1054d6b7f3fad6$var$u((e, t)=>({
            maxBlockSize: e,
            maxInlineSize: t || e
        })),
    minSize: $4c1054d6b7f3fad6$var$u((e, t)=>({
            minBlockSize: e,
            minInlineSize: t || e
        })),
    paddingBlock: $4c1054d6b7f3fad6$var$u((e, t)=>({
            paddingBlockStart: e,
            paddingBlockEnd: t || e
        })),
    paddingInline: $4c1054d6b7f3fad6$var$u((e, t)=>({
            paddingInlineStart: e,
            paddingInlineEnd: t || e
        }))
}, $4c1054d6b7f3fad6$var$f = /([\d.]+)([^]*)/, $4c1054d6b7f3fad6$var$m = (e, t)=>e.length ? e.reduce((e, n)=>(e.push(...t.map((e)=>e.includes("&") ? e.replace(/&/g, /[ +>|~]/.test(n) && /&.*&/.test(e) ? `:is(${n})` : n) : n + " " + e)), e), []) : t, $4c1054d6b7f3fad6$var$b = (e, t)=>e in $4c1054d6b7f3fad6$var$S && "string" == typeof t ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (t, n, r, i)=>n + ("stretch" === r ? `-moz-available${i};${$4c1054d6b7f3fad6$var$g(e)}:${n}-webkit-fill-available` : `-moz-fit-content${i};${$4c1054d6b7f3fad6$var$g(e)}:${n}fit-content`) + i) : String(t), $4c1054d6b7f3fad6$var$S = {
    blockSize: 1,
    height: 1,
    inlineSize: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    width: 1
}, $4c1054d6b7f3fad6$var$k = (e)=>e ? e + "-" : "", $4c1054d6b7f3fad6$var$y = (e, t, n)=>e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (e, r, i, o, l)=>"$" == o == !!i ? e : (r || "--" == o ? "calc(" : "") + "var(--" + ("$" === o ? $4c1054d6b7f3fad6$var$k(t) + (l.includes("$") ? "" : $4c1054d6b7f3fad6$var$k(n)) + l.replace(/\$/g, "-") : l) + ")" + (r || "--" == o ? "*" + (r || "") + (i || "1") + ")" : "")), $4c1054d6b7f3fad6$var$B = /\s*,\s*(?![^()]*\))/, $4c1054d6b7f3fad6$var$$ = Object.prototype.toString, $4c1054d6b7f3fad6$var$x = (e, t, n, r, i)=>{
    let o, l, s;
    const a = (e, t, n)=>{
        let c, d;
        const p = (e)=>{
            for(c in e){
                const x = 64 === c.charCodeAt(0), z = x && Array.isArray(e[c]) ? e[c] : [
                    e[c]
                ];
                for (d of z){
                    const e = /[A-Z]/.test(S = c) ? S : S.replace(/-[^]/g, (e)=>e[1].toUpperCase()), z = "object" == typeof d && d && d.toString === $4c1054d6b7f3fad6$var$$ && (!r.utils[e] || !t.length);
                    if (e in r.utils && !z) {
                        const t = r.utils[e];
                        if (t !== l) {
                            l = t, p(t(d)), l = null;
                            continue;
                        }
                    } else if (e in $4c1054d6b7f3fad6$var$h) {
                        const t = $4c1054d6b7f3fad6$var$h[e];
                        if (t !== s) {
                            s = t, p(t(d)), s = null;
                            continue;
                        }
                    }
                    if (x && (u = c.slice(1) in r.media ? "@media " + r.media[c.slice(1)] : c, c = u.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (e, t, n, r, i, o)=>{
                        const l = $4c1054d6b7f3fad6$var$f.test(t), s = .0625 * (l ? -1 : 1), [a, c] = l ? [
                            r,
                            t
                        ] : [
                            t,
                            r
                        ];
                        return "(" + ("=" === n[0] ? "" : ">" === n[0] === l ? "max-" : "min-") + a + ":" + ("=" !== n[0] && 1 === n.length ? c.replace($4c1054d6b7f3fad6$var$f, (e, t, r)=>Number(t) + s * (">" === n ? 1 : -1) + r) : c) + (i ? ") and (" + (">" === i[0] ? "min-" : "max-") + a + ":" + (1 === i.length ? o.replace($4c1054d6b7f3fad6$var$f, (e, t, n)=>Number(t) + s * (">" === i ? -1 : 1) + n) : o) : "") + ")";
                    })), z) {
                        const e = x ? n.concat(c) : [
                            ...n
                        ], r = x ? [
                            ...t
                        ] : $4c1054d6b7f3fad6$var$m(t, c.split($4c1054d6b7f3fad6$var$B));
                        void 0 !== o && i($4c1054d6b7f3fad6$var$I(...o)), o = void 0, a(d, r, e);
                    } else void 0 === o && (o = [
                        [],
                        t,
                        n
                    ]), c = x || 36 !== c.charCodeAt(0) ? c : `--${$4c1054d6b7f3fad6$var$k(r.prefix)}${c.slice(1).replace(/\$/g, "-")}`, d = z ? d : "number" == typeof d ? d && e in $4c1054d6b7f3fad6$var$R ? String(d) + "px" : String(d) : $4c1054d6b7f3fad6$var$y($4c1054d6b7f3fad6$var$b(e, null == d ? "" : d), r.prefix, r.themeMap[e]), o[0].push(`${x ? `${c} ` : `${$4c1054d6b7f3fad6$var$g(c)}:`}${d}`);
                }
            }
            var u, S;
        };
        p(e), void 0 !== o && i($4c1054d6b7f3fad6$var$I(...o)), o = void 0;
    };
    a(e, t, n);
}, $4c1054d6b7f3fad6$var$I = (e, t, n)=>`${n.map((e)=>`${e}{`).join("")}${t.length ? `${t.join(",")}{` : ""}${e.join(";")}${t.length ? "}" : ""}${Array(n.length ? n.length + 1 : 0).join("}")}`, $4c1054d6b7f3fad6$var$R = {
    animationDelay: 1,
    animationDuration: 1,
    backgroundSize: 1,
    blockSize: 1,
    border: 1,
    borderBlock: 1,
    borderBlockEnd: 1,
    borderBlockEndWidth: 1,
    borderBlockStart: 1,
    borderBlockStartWidth: 1,
    borderBlockWidth: 1,
    borderBottom: 1,
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderBottomWidth: 1,
    borderEndEndRadius: 1,
    borderEndStartRadius: 1,
    borderInlineEnd: 1,
    borderInlineEndWidth: 1,
    borderInlineStart: 1,
    borderInlineStartWidth: 1,
    borderInlineWidth: 1,
    borderLeft: 1,
    borderLeftWidth: 1,
    borderRadius: 1,
    borderRight: 1,
    borderRightWidth: 1,
    borderSpacing: 1,
    borderStartEndRadius: 1,
    borderStartStartRadius: 1,
    borderTop: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    borderTopWidth: 1,
    borderWidth: 1,
    bottom: 1,
    columnGap: 1,
    columnRule: 1,
    columnRuleWidth: 1,
    columnWidth: 1,
    containIntrinsicSize: 1,
    flexBasis: 1,
    fontSize: 1,
    gap: 1,
    gridAutoColumns: 1,
    gridAutoRows: 1,
    gridTemplateColumns: 1,
    gridTemplateRows: 1,
    height: 1,
    inlineSize: 1,
    inset: 1,
    insetBlock: 1,
    insetBlockEnd: 1,
    insetBlockStart: 1,
    insetInline: 1,
    insetInlineEnd: 1,
    insetInlineStart: 1,
    left: 1,
    letterSpacing: 1,
    margin: 1,
    marginBlock: 1,
    marginBlockEnd: 1,
    marginBlockStart: 1,
    marginBottom: 1,
    marginInline: 1,
    marginInlineEnd: 1,
    marginInlineStart: 1,
    marginLeft: 1,
    marginRight: 1,
    marginTop: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    offsetDistance: 1,
    offsetRotate: 1,
    outline: 1,
    outlineOffset: 1,
    outlineWidth: 1,
    overflowClipMargin: 1,
    padding: 1,
    paddingBlock: 1,
    paddingBlockEnd: 1,
    paddingBlockStart: 1,
    paddingBottom: 1,
    paddingInline: 1,
    paddingInlineEnd: 1,
    paddingInlineStart: 1,
    paddingLeft: 1,
    paddingRight: 1,
    paddingTop: 1,
    perspective: 1,
    right: 1,
    rowGap: 1,
    scrollMargin: 1,
    scrollMarginBlock: 1,
    scrollMarginBlockEnd: 1,
    scrollMarginBlockStart: 1,
    scrollMarginBottom: 1,
    scrollMarginInline: 1,
    scrollMarginInlineEnd: 1,
    scrollMarginInlineStart: 1,
    scrollMarginLeft: 1,
    scrollMarginRight: 1,
    scrollMarginTop: 1,
    scrollPadding: 1,
    scrollPaddingBlock: 1,
    scrollPaddingBlockEnd: 1,
    scrollPaddingBlockStart: 1,
    scrollPaddingBottom: 1,
    scrollPaddingInline: 1,
    scrollPaddingInlineEnd: 1,
    scrollPaddingInlineStart: 1,
    scrollPaddingLeft: 1,
    scrollPaddingRight: 1,
    scrollPaddingTop: 1,
    shapeMargin: 1,
    textDecoration: 1,
    textDecorationThickness: 1,
    textIndent: 1,
    textUnderlineOffset: 1,
    top: 1,
    transitionDelay: 1,
    transitionDuration: 1,
    verticalAlign: 1,
    width: 1,
    wordSpacing: 1
}, $4c1054d6b7f3fad6$var$z = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97)), $4c1054d6b7f3fad6$var$W = (e)=>((e)=>{
        let t, n = "";
        for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $4c1054d6b7f3fad6$var$z(t % 52) + n;
        return $4c1054d6b7f3fad6$var$z(t % 52) + n;
    })(((e, t)=>{
        let n = t.length;
        for(; n;)e = 33 * e ^ t.charCodeAt(--n);
        return e;
    })(5381, JSON.stringify(e)) >>> 0), $4c1054d6b7f3fad6$var$j = [
    "themed",
    "global",
    "styled",
    "onevar",
    "resonevar",
    "allvar",
    "inline"
], $4c1054d6b7f3fad6$var$E = (e)=>{
    if (e.href && !e.href.startsWith(location.origin)) return !1;
    try {
        return !!e.cssRules;
    } catch (e) {
        return !1;
    }
}, $4c1054d6b7f3fad6$var$T = (e)=>{
    let t;
    const n = ()=>{
        const { cssRules: e } = t.sheet;
        return [].map.call(e, (n, r)=>{
            const { cssText: i } = n;
            let o = "";
            if (i.startsWith("--sxs")) return "";
            if (e[r - 1] && (o = e[r - 1].cssText).startsWith("--sxs")) {
                if (!n.cssRules.length) return "";
                for(const e in t.rules)if (t.rules[e].group === n) return `--sxs{--sxs:${[
                    ...t.rules[e].cache
                ].join(" ")}}${i}`;
                return n.cssRules.length ? `${o}${i}` : "";
            }
            return i;
        }).join("");
    }, r = ()=>{
        if (t) {
            const { rules: e, sheet: n } = t;
            if (!n.deleteRule) {
                for(; 3 === Object(Object(n.cssRules)[0]).type;)n.cssRules.splice(0, 1);
                n.cssRules = [];
            }
            for(const t in e)delete e[t];
        }
        const i = Object(e).styleSheets || [];
        for (const e of i)if ($4c1054d6b7f3fad6$var$E(e)) {
            for(let i = 0, o = e.cssRules; o[i]; ++i){
                const l = Object(o[i]);
                if (1 !== l.type) continue;
                const s = Object(o[i + 1]);
                if (4 !== s.type) continue;
                ++i;
                const { cssText: a } = l;
                if (!a.startsWith("--sxs")) continue;
                const c = a.slice(14, -3).trim().split(/\s+/), d = $4c1054d6b7f3fad6$var$j[c[0]];
                d && (t || (t = {
                    sheet: e,
                    reset: r,
                    rules: {},
                    toString: n
                }), t.rules[d] = {
                    group: s,
                    index: i,
                    cache: new Set(c)
                });
            }
            if (t) break;
        }
        if (!t) {
            const i = (e, t)=>({
                    type: t,
                    cssRules: [],
                    insertRule (e, t) {
                        this.cssRules.splice(t, 0, i(e, {
                            import: 3,
                            undefined: 1
                        }[(e.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
                    },
                    get cssText () {
                        return "@media{}" === e ? `@media{${[].map.call(this.cssRules, (e)=>e.cssText).join("")}}` : e;
                    }
                });
            t = {
                sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : i("", "text/css"),
                rules: {},
                reset: r,
                toString: n
            };
        }
        const { sheet: o, rules: l } = t;
        for(let e = $4c1054d6b7f3fad6$var$j.length - 1; e >= 0; --e){
            const t = $4c1054d6b7f3fad6$var$j[e];
            if (!l[t]) {
                const n = $4c1054d6b7f3fad6$var$j[e + 1], r = l[n] ? l[n].index : o.cssRules.length;
                o.insertRule("@media{}", r), o.insertRule(`--sxs{--sxs:${e}}`, r), l[t] = {
                    group: o.cssRules[r + 1],
                    index: r,
                    cache: new Set([
                        e
                    ])
                };
            }
            $4c1054d6b7f3fad6$var$v(l[t]);
        }
    };
    return r(), t;
}, $4c1054d6b7f3fad6$var$v = (e)=>{
    const t = e.group;
    let n = t.cssRules.length;
    e.apply = (e)=>{
        try {
            t.insertRule(e, n), ++n;
        } catch (e) {}
    };
}, $4c1054d6b7f3fad6$var$M = Symbol(), $4c1054d6b7f3fad6$var$w = $4c1054d6b7f3fad6$var$l(), $4c1054d6b7f3fad6$var$C = (e, t)=>$4c1054d6b7f3fad6$var$w(e, ()=>(...n)=>{
            let r = {
                type: null,
                composers: new Set
            };
            for (const t of n)if (null != t) {
                if (t[$4c1054d6b7f3fad6$var$s]) {
                    null == r.type && (r.type = t[$4c1054d6b7f3fad6$var$s].type);
                    for (const e of t[$4c1054d6b7f3fad6$var$s].composers)r.composers.add(e);
                } else t.constructor !== Object || t.$$typeof ? null == r.type && (r.type = t) : r.composers.add($4c1054d6b7f3fad6$var$P(t, e));
            }
            return null == r.type && (r.type = "span"), r.composers.size || r.composers.add([
                "PJLV",
                {},
                [],
                [],
                {},
                []
            ]), $4c1054d6b7f3fad6$var$L(e, r, t);
        }), $4c1054d6b7f3fad6$var$P = ({ variants: e, compoundVariants: t, defaultVariants: n, ...r }, i)=>{
    const o = `${$4c1054d6b7f3fad6$var$k(i.prefix)}c-${$4c1054d6b7f3fad6$var$W(r)}`, l = [], s = [], a = Object.create(null), g = [];
    for(const e in n)a[e] = String(n[e]);
    if ("object" == typeof e && e) for(const t in e){
        p = a, u = t, $4c1054d6b7f3fad6$var$d.call(p, u) || (a[t] = "undefined");
        const n = e[t];
        for(const e in n){
            const r = {
                [t]: String(e)
            };
            "undefined" === String(e) && g.push(t);
            const i = n[e], o = [
                r,
                i,
                !$4c1054d6b7f3fad6$var$c(i)
            ];
            l.push(o);
        }
    }
    var p, u;
    if ("object" == typeof t && t) for (const e of t){
        let { css: t, ...n } = e;
        t = "object" == typeof t && t || {};
        for(const e in n)n[e] = String(n[e]);
        const r = [
            n,
            t,
            !$4c1054d6b7f3fad6$var$c(t)
        ];
        s.push(r);
    }
    return [
        o,
        r,
        l,
        s,
        a,
        g
    ];
}, $4c1054d6b7f3fad6$var$L = (e, t, n)=>{
    const [r, i, o, l] = $4c1054d6b7f3fad6$var$O(t.composers), c = "function" == typeof t.type || t.type.$$typeof ? ((e)=>{
        function t() {
            for(let n = 0; n < t[$4c1054d6b7f3fad6$var$M].length; n++){
                const [r, i] = t[$4c1054d6b7f3fad6$var$M][n];
                e.rules[r].apply(i);
            }
            return t[$4c1054d6b7f3fad6$var$M] = [], null;
        }
        return t[$4c1054d6b7f3fad6$var$M] = [], t.rules = {}, $4c1054d6b7f3fad6$var$j.forEach((e)=>t.rules[e] = {
                apply: (n)=>t[$4c1054d6b7f3fad6$var$M].push([
                        e,
                        n
                    ])
            }), t;
    })(n) : null, d = (c || n).rules, g = `.${r}${i.length > 1 ? `:where(.${i.slice(1).join(".")})` : ""}`, p = (s)=>{
        s = "object" == typeof s && s || $4c1054d6b7f3fad6$var$D;
        const { css: a, ...p } = s, u = {};
        for(const e in o)if (delete p[e], e in s) {
            let t = s[e];
            "object" == typeof t && t ? u[e] = {
                "@initial": o[e],
                ...t
            } : (t = String(t), u[e] = "undefined" !== t || l.has(e) ? t : o[e]);
        } else u[e] = o[e];
        const h = new Set([
            ...i
        ]);
        for (const [r, i, o, l] of t.composers){
            n.rules.styled.cache.has(r) || (n.rules.styled.cache.add(r), $4c1054d6b7f3fad6$var$x(i, [
                `.${r}`
            ], [], e, (e)=>{
                d.styled.apply(e);
            }));
            const t = $4c1054d6b7f3fad6$var$A(o, u, e.media), s = $4c1054d6b7f3fad6$var$A(l, u, e.media, !0);
            for (const i of t)if (void 0 !== i) for (const [t, o, l] of i){
                const i = `${r}-${$4c1054d6b7f3fad6$var$W(o)}-${t}`;
                h.add(i);
                const s = (l ? n.rules.resonevar : n.rules.onevar).cache, a = l ? d.resonevar : d.onevar;
                s.has(i) || (s.add(i), $4c1054d6b7f3fad6$var$x(o, [
                    `.${i}`
                ], [], e, (e)=>{
                    a.apply(e);
                }));
            }
            for (const t of s)if (void 0 !== t) for (const [i, o] of t){
                const t = `${r}-${$4c1054d6b7f3fad6$var$W(o)}-${i}`;
                h.add(t), n.rules.allvar.cache.has(t) || (n.rules.allvar.cache.add(t), $4c1054d6b7f3fad6$var$x(o, [
                    `.${t}`
                ], [], e, (e)=>{
                    d.allvar.apply(e);
                }));
            }
        }
        if ("object" == typeof a && a) {
            const t = `${r}-i${$4c1054d6b7f3fad6$var$W(a)}-css`;
            h.add(t), n.rules.inline.cache.has(t) || (n.rules.inline.cache.add(t), $4c1054d6b7f3fad6$var$x(a, [
                `.${t}`
            ], [], e, (e)=>{
                d.inline.apply(e);
            }));
        }
        for (const e of String(s.className || "").trim().split(/\s+/))e && h.add(e);
        const f = p.className = [
            ...h
        ].join(" ");
        return {
            type: t.type,
            className: f,
            selector: g,
            props: p,
            toString: ()=>f,
            deferredInjector: c
        };
    };
    return $4c1054d6b7f3fad6$var$a(p, {
        className: r,
        selector: g,
        [$4c1054d6b7f3fad6$var$s]: t,
        toString: ()=>(n.rules.styled.cache.has(r) || p(), r)
    });
}, $4c1054d6b7f3fad6$var$O = (e)=>{
    let t = "";
    const n = [], r = {}, i = [];
    for (const [o, , , , l, s] of e){
        "" === t && (t = o), n.push(o), i.push(...s);
        for(const e in l){
            const t = l[e];
            (void 0 === r[e] || "undefined" !== t || s.includes(t)) && (r[e] = t);
        }
    }
    return [
        t,
        n,
        r,
        new Set(i)
    ];
}, $4c1054d6b7f3fad6$var$A = (e, t, n, r)=>{
    const i = [];
    e: for (let [o, l, s] of e){
        if (s) continue;
        let e, a = 0, c = !1;
        for(e in o){
            const r = o[e];
            let i = t[e];
            if (i !== r) {
                if ("object" != typeof i || !i) continue e;
                {
                    let e, t, o = 0;
                    for(const l in i){
                        if (r === String(i[l])) {
                            if ("@initial" !== l) {
                                const e = l.slice(1);
                                (t = t || []).push(e in n ? n[e] : l.replace(/^@media ?/, "")), c = !0;
                            }
                            a += o, e = !0;
                        }
                        ++o;
                    }
                    if (t && t.length && (l = {
                        ["@media " + t.join(", ")]: l
                    }), !e) continue e;
                }
            }
        }
        (i[a] = i[a] || []).push([
            r ? "cv" : `${e}-${o[e]}`,
            l,
            c
        ]);
    }
    return i;
}, $4c1054d6b7f3fad6$var$D = {}, $4c1054d6b7f3fad6$var$H = $4c1054d6b7f3fad6$var$l(), $4c1054d6b7f3fad6$var$N = (e, t)=>$4c1054d6b7f3fad6$var$H(e, ()=>(...n)=>{
            const r = ()=>{
                for (let r of n){
                    r = "object" == typeof r && r || {};
                    let n = $4c1054d6b7f3fad6$var$W(r);
                    if (!t.rules.global.cache.has(n)) {
                        if (t.rules.global.cache.add(n), "@import" in r) {
                            let e = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;
                            for (let n of [].concat(r["@import"]))n = n.includes('"') || n.includes("'") ? n : `"${n}"`, t.sheet.insertRule(`@import ${n};`, e++);
                            delete r["@import"];
                        }
                        $4c1054d6b7f3fad6$var$x(r, [], [], e, (e)=>{
                            t.rules.global.apply(e);
                        });
                    }
                }
                return "";
            };
            return $4c1054d6b7f3fad6$var$a(r, {
                toString: r
            });
        }), $4c1054d6b7f3fad6$var$V = $4c1054d6b7f3fad6$var$l(), $4c1054d6b7f3fad6$var$G = (e, t)=>$4c1054d6b7f3fad6$var$V(e, ()=>(n)=>{
            const r = `${$4c1054d6b7f3fad6$var$k(e.prefix)}k-${$4c1054d6b7f3fad6$var$W(n)}`, i = ()=>{
                if (!t.rules.global.cache.has(r)) {
                    t.rules.global.cache.add(r);
                    const i = [];
                    $4c1054d6b7f3fad6$var$x(n, [], [], e, (e)=>i.push(e));
                    const o = `@keyframes ${r}{${i.join("")}}`;
                    t.rules.global.apply(o);
                }
                return r;
            };
            return $4c1054d6b7f3fad6$var$a(i, {
                get name () {
                    return i();
                },
                toString: i
            });
        }), $4c1054d6b7f3fad6$var$F = class {
    constructor(e, t, n, r){
        this.token = null == e ? "" : String(e), this.value = null == t ? "" : String(t), this.scale = null == n ? "" : String(n), this.prefix = null == r ? "" : String(r);
    }
    get computedValue() {
        return "var(" + this.variable + ")";
    }
    get variable() {
        return "--" + $4c1054d6b7f3fad6$var$k(this.prefix) + $4c1054d6b7f3fad6$var$k(this.scale) + this.token;
    }
    toString() {
        return this.computedValue;
    }
}, $4c1054d6b7f3fad6$var$J = $4c1054d6b7f3fad6$var$l(), $4c1054d6b7f3fad6$var$U = (e, t)=>$4c1054d6b7f3fad6$var$J(e, ()=>(n, r)=>{
            r = "object" == typeof n && n || Object(r);
            const i = `.${n = (n = "string" == typeof n ? n : "") || `${$4c1054d6b7f3fad6$var$k(e.prefix)}t-${$4c1054d6b7f3fad6$var$W(r)}`}`, o = {}, l = [];
            for(const t in r){
                o[t] = {};
                for(const n in r[t]){
                    const i = `--${$4c1054d6b7f3fad6$var$k(e.prefix)}${t}-${n}`, s = $4c1054d6b7f3fad6$var$y(String(r[t][n]), e.prefix, t);
                    o[t][n] = new $4c1054d6b7f3fad6$var$F(n, s, t, e.prefix), l.push(`${i}:${s}`);
                }
            }
            const s = ()=>{
                if (l.length && !t.rules.themed.cache.has(n)) {
                    t.rules.themed.cache.add(n);
                    const i = `${r === e.theme ? ":root," : ""}.${n}{${l.join(";")}}`;
                    t.rules.themed.apply(i);
                }
                return n;
            };
            return {
                ...o,
                get className () {
                    return s();
                },
                selector: i,
                toString: s
            };
        }), $4c1054d6b7f3fad6$var$Z = $4c1054d6b7f3fad6$var$l(), $4c1054d6b7f3fad6$export$3c6706659c99b84e = (e)=>{
    let t = !1;
    const n = $4c1054d6b7f3fad6$var$Z(e, (e)=>{
        t = !0;
        const n = "prefix" in (e = "object" == typeof e && e || {}) ? String(e.prefix) : "", r = "object" == typeof e.media && e.media || {}, o = "object" == typeof e.root ? e.root || null : globalThis.document || null, l = "object" == typeof e.theme && e.theme || {}, s = {
            prefix: n,
            media: r,
            theme: l,
            themeMap: "object" == typeof e.themeMap && e.themeMap || {
                ...$4c1054d6b7f3fad6$export$22deaee80f3d7c38
            },
            utils: "object" == typeof e.utils && e.utils || {}
        }, a = $4c1054d6b7f3fad6$var$T(o), c = {
            css: $4c1054d6b7f3fad6$var$C(s, a),
            globalCss: $4c1054d6b7f3fad6$var$N(s, a),
            keyframes: $4c1054d6b7f3fad6$var$G(s, a),
            createTheme: $4c1054d6b7f3fad6$var$U(s, a),
            reset () {
                a.reset(), c.theme.toString();
            },
            theme: {},
            sheet: a,
            config: s,
            prefix: n,
            getCssText: a.toString,
            toString: a.toString
        };
        return String(c.theme = c.createTheme(l)), c;
    });
    return t || n.reset(), n;
}, $4c1054d6b7f3fad6$var$Y = ()=>$4c1054d6b7f3fad6$var$e || ($4c1054d6b7f3fad6$var$e = $4c1054d6b7f3fad6$export$3c6706659c99b84e()), $4c1054d6b7f3fad6$export$25d302a5b900a763 = (...e)=>$4c1054d6b7f3fad6$var$Y().createTheme(...e), $4c1054d6b7f3fad6$export$db53682eef82cc11 = (...e)=>$4c1054d6b7f3fad6$var$Y().globalCss(...e), $4c1054d6b7f3fad6$export$d25ddfdf17c3ad3e = (...e)=>$4c1054d6b7f3fad6$var$Y().keyframes(...e), $4c1054d6b7f3fad6$export$dbf350e5966cf602 = (...e)=>$4c1054d6b7f3fad6$var$Y().css(...e);
 //# sourceMappingUrl=index.map


// src/theming/defaultThemes.ts
var $fbb3f532a915e7a3$export$1efbf737de6c4d31 = {
    default: {
        colors: {
            brand: "hsl(153 60.0% 53.0%)",
            brandAccent: "hsl(154 54.8% 45.1%)",
            brandButtonText: "white",
            defaultButtonBackground: "white",
            defaultButtonBackgroundHover: "#eaeaea",
            defaultButtonBorder: "lightgray",
            defaultButtonText: "gray",
            dividerBackground: "#eaeaea",
            inputBackground: "transparent",
            inputBorder: "lightgray",
            inputBorderHover: "gray",
            inputBorderFocus: "gray",
            inputText: "black",
            inputLabelText: "gray",
            inputPlaceholder: "darkgray",
            messageText: "#2b805a",
            messageBackground: "#e7fcf1",
            messageBorder: "#d0f3e1",
            messageTextDanger: "#ff6369",
            messageBackgroundDanger: "#fff8f8",
            messageBorderDanger: "#822025",
            anchorTextColor: "gray",
            anchorTextHoverColor: "darkgray"
        },
        space: {
            spaceSmall: "4px",
            spaceMedium: "8px",
            spaceLarge: "16px",
            labelBottomMargin: "8px",
            anchorBottomMargin: "4px",
            emailInputSpacing: "4px",
            socialAuthSpacing: "4px",
            buttonPadding: "10px 15px",
            inputPadding: "10px 15px"
        },
        fontSizes: {
            baseBodySize: "13px",
            baseInputSize: "14px",
            baseLabelSize: "14px",
            baseButtonSize: "14px"
        },
        fonts: {
            bodyFontFamily: `ui-sans-serif, sans-serif`,
            buttonFontFamily: `ui-sans-serif, sans-serif`,
            inputFontFamily: `ui-sans-serif, sans-serif`,
            labelFontFamily: `ui-sans-serif, sans-serif`
        },
        // fontWeights: {},
        // lineHeights: {},
        // letterSpacings: {},
        // sizes: {},
        borderWidths: {
            buttonBorderWidth: "1px",
            inputBorderWidth: "1px"
        },
        // borderStyles: {},
        radii: {
            borderRadiusButton: "4px",
            buttonBorderRadius: "4px",
            inputBorderRadius: "4px"
        }
    },
    dark: {
        colors: {
            brandButtonText: "white",
            defaultButtonBackground: "#2e2e2e",
            defaultButtonBackgroundHover: "#3e3e3e",
            defaultButtonBorder: "#3e3e3e",
            defaultButtonText: "white",
            dividerBackground: "#2e2e2e",
            inputBackground: "#1e1e1e",
            inputBorder: "#3e3e3e",
            inputBorderHover: "gray",
            inputBorderFocus: "gray",
            inputText: "white",
            inputPlaceholder: "darkgray",
            messageText: "#85e0b7",
            messageBackground: "#072719",
            messageBorder: "#2b805a",
            messageBackgroundDanger: "#1f1315"
        }
    }
};
var $fbb3f532a915e7a3$export$1691803dd359fb24 = {
    default: {
        colors: {
            brand: "black",
            brandAccent: "#333333",
            brandButtonText: "white",
            defaultButtonBackground: "white",
            defaultButtonBorder: "lightgray",
            defaultButtonText: "gray",
            dividerBackground: "#eaeaea",
            inputBackground: "transparent",
            inputBorder: "lightgray",
            inputText: "black",
            inputPlaceholder: "darkgray",
            messageText: "#2b805a",
            messageBackground: "#e7fcf1",
            messageBorder: "#d0f3e1",
            messageTextDanger: "#ff6369",
            messageBackgroundDanger: "#fff8f8",
            messageBorderDanger: "#822025"
        },
        space: {
            spaceSmall: "4px",
            spaceMedium: "8px",
            spaceLarge: "16px"
        },
        fontSizes: {
            baseInputSize: "14px",
            baseLabelSize: "12px"
        },
        fonts: {
            bodyFontFamily: "",
            inputFontFamily: "",
            buttonFontFamily: "",
            labelFontFamily: ""
        },
        // fontWeights: {},
        // lineHeights: {},
        // letterSpacings: {},
        // sizes: {},
        borderWidths: {},
        // borderStyles: {},
        radii: {}
    },
    dark: {
        colors: {
            brand: "white",
            brandAccent: "#afafaf",
            brandButtonText: "black",
            defaultButtonBackground: "#080808",
            defaultButtonBorder: "black",
            defaultButtonText: "white",
            dividerBackground: "black",
            inputBackground: "transparent",
            inputBorder: "gray",
            inputText: "black",
            inputPlaceholder: "darkgray",
            messageText: "#85e0b7",
            messageBackground: "#072719",
            messageBorder: "#2b805a",
            messageBackgroundDanger: "#1f1315"
        }
    }
};
// src/theming/Themes.ts
var $fbb3f532a915e7a3$export$a0b632a28672d3c0 = {
    colors: {
        brand: "hsl(153 60.0% 53.0%)",
        brandAccent: "hsl(154 54.8% 45.1%)",
        brandButtonText: "white",
        defaultButtonBackground: "white",
        defaultButtonBackgroundHover: "#eaeaea",
        defaultButtonBorder: "lightgray",
        defaultButtonText: "gray",
        dividerBackground: "#eaeaea",
        inputBackground: "transparent",
        inputBorder: "lightgray",
        inputBorderHover: "gray",
        inputBorderFocus: "gray",
        inputText: "black",
        inputLabelText: "gray",
        inputPlaceholder: "darkgray",
        messageText: "gray",
        messageTextDanger: "red",
        anchorTextColor: "gray",
        anchorTextHoverColor: "darkgray"
    },
    space: {
        spaceSmall: "4px",
        spaceMedium: "8px",
        spaceLarge: "16px",
        labelBottomMargin: "8px",
        anchorBottomMargin: "4px",
        emailInputSpacing: "4px",
        socialAuthSpacing: "4px",
        buttonPadding: "10px 15px",
        inputPadding: "10px 15px"
    },
    fontSizes: {
        baseBodySize: "13px",
        baseInputSize: "14px",
        baseLabelSize: "14px",
        baseButtonSize: "14px"
    },
    fonts: {
        bodyFontFamily: `ui-sans-serif, sans-serif`,
        buttonFontFamily: `ui-sans-serif, sans-serif`,
        inputFontFamily: `ui-sans-serif, sans-serif`,
        labelFontFamily: `ui-sans-serif, sans-serif`
    },
    // fontWeights: {},
    // lineHeights: {},
    // letterSpacings: {},
    // sizes: {},
    borderWidths: {
        buttonBorderWidth: "1px",
        inputBorderWidth: "1px"
    },
    // borderStyles: {},
    radii: {
        borderRadiusButton: "4px",
        buttonBorderRadius: "4px",
        inputBorderRadius: "4px"
    }
};
var $fbb3f532a915e7a3$var$defaultDarkTheme = {
    colors: {
        brandButtonText: "white",
        defaultButtonBackground: "#2e2e2e",
        defaultButtonBackgroundHover: "#3e3e3e",
        defaultButtonBorder: "#3e3e3e",
        defaultButtonText: "white",
        dividerBackground: "#2e2e2e",
        inputBackground: "#1e1e1e",
        inputBorder: "#3e3e3e",
        inputBorderHover: "gray",
        inputBorderFocus: "gray",
        inputText: "white",
        inputPlaceholder: "darkgray"
    }
};
var $fbb3f532a915e7a3$export$10c083462c34aef3 = {
    colors: {
        brand: "black",
        brandAccent: "#333333",
        brandButtonText: "white",
        defaultButtonBackground: "white",
        defaultButtonBorder: "lightgray",
        defaultButtonText: "gray",
        dividerBackground: "#eaeaea",
        inputBackground: "transparent",
        inputBorder: "lightgray",
        inputText: "black",
        inputPlaceholder: "darkgray"
    },
    space: {
        spaceSmall: "4px",
        spaceMedium: "8px",
        spaceLarge: "16px"
    },
    fontSizes: {
        baseInputSize: "14px",
        baseLabelSize: "12px"
    },
    fonts: {
        bodyFontFamily: "",
        inputFontFamily: "",
        buttonFontFamily: "",
        labelFontFamily: ""
    },
    // fontWeights: {},
    // lineHeights: {},
    // letterSpacings: {},
    // sizes: {},
    borderWidths: {},
    // borderStyles: {},
    radii: {}
};
var $fbb3f532a915e7a3$var$minimalDark = {
    colors: {
        brand: "white",
        brandAccent: "#afafaf",
        brandButtonText: "black",
        defaultButtonBackground: "#080808",
        defaultButtonBorder: "black",
        defaultButtonText: "white",
        dividerBackground: "black",
        inputBackground: "transparent",
        inputBorder: "gray",
        inputText: "black",
        inputPlaceholder: "darkgray"
    }
};
var $fbb3f532a915e7a3$export$b3d5651a66c6b359 = {
    supabase: $fbb3f532a915e7a3$var$defaultDarkTheme,
    minimal: $fbb3f532a915e7a3$var$minimalDark
};
// src/constants.ts
var $fbb3f532a915e7a3$export$50bf86b71c5fd0d9 = {
    SIGN_IN: "sign_in",
    SIGN_UP: "sign_up",
    FORGOTTEN_PASSWORD: "forgotten_password",
    MAGIC_LINK: "magic_link",
    UPDATE_PASSWORD: "update_password",
    VERIFY_OTP: "verify_otp"
};
var $fbb3f532a915e7a3$export$fed8a8b2609af45 = "supabase-auth-ui";
var $fbb3f532a915e7a3$export$1ba50affd1ee3341 = {
    // interfaces
    ROOT: "root",
    SIGN_IN: $fbb3f532a915e7a3$export$50bf86b71c5fd0d9.SIGN_IN,
    SIGN_UP: $fbb3f532a915e7a3$export$50bf86b71c5fd0d9.SIGN_UP,
    FORGOTTEN_PASSWORD: $fbb3f532a915e7a3$export$50bf86b71c5fd0d9.FORGOTTEN_PASSWORD,
    MAGIC_LINK: $fbb3f532a915e7a3$export$50bf86b71c5fd0d9.MAGIC_LINK,
    UPDATE_PASSWORD: $fbb3f532a915e7a3$export$50bf86b71c5fd0d9.UPDATE_PASSWORD,
    // ui
    anchor: "ui-anchor",
    button: "ui-button",
    container: "ui-container",
    divider: "ui-divider",
    input: "ui-input",
    label: "ui-label",
    loader: "ui-loader",
    message: "ui-message"
};
// src/theming/utils.ts
function $fbb3f532a915e7a3$export$4b9a51591ef11077(classNameKey, defaultStyles, appearance) {
    var _a, _b;
    const classNames = [];
    const className = $fbb3f532a915e7a3$export$1ba50affd1ee3341[classNameKey];
    classNames.push((appearance == null ? void 0 : appearance.prependedClassName) ? (appearance == null ? void 0 : appearance.prependedClassName) + "_" + className : $fbb3f532a915e7a3$export$fed8a8b2609af45 + "_" + className);
    if ((_a = appearance == null ? void 0 : appearance.className) == null ? void 0 : _a[classNameKey]) classNames.push((_b = appearance == null ? void 0 : appearance.className) == null ? void 0 : _b[classNameKey]);
    if ((appearance == null ? void 0 : appearance.extend) === void 0 || (appearance == null ? void 0 : appearance.extend) === true) classNames.push(defaultStyles);
    return classNames;
}
// src/types.ts
var $fbb3f532a915e7a3$export$7ad2fb95186e1106 = /* @__PURE__ */ ((SocialLayouts2)=>{
    SocialLayouts2[SocialLayouts2["horizontal"] = 0] = "horizontal";
    SocialLayouts2[SocialLayouts2["vertical"] = 1] = "vertical";
    return SocialLayouts2;
})($fbb3f532a915e7a3$export$7ad2fb95186e1106 || {});
// src/utils.ts
function $fbb3f532a915e7a3$var$value(src, next) {
    let k;
    if (src && next && typeof src === "object" && typeof next === "object") {
        if (Array.isArray(next)) for(k = 0; k < next.length; k++)src[k] = $fbb3f532a915e7a3$var$value(src[k], next[k]);
        else for(k in next)src[k] = $fbb3f532a915e7a3$var$value(src[k], next[k]);
        return src;
    }
    return next;
}
function $fbb3f532a915e7a3$export$4950aa0f605343fb(target, ...args) {
    let len = args.length;
    for(let i = 0; i < len; i++)target = $fbb3f532a915e7a3$var$value(target, args[i]);
    return target;
}
function $fbb3f532a915e7a3$export$ce69bd05624d0c48(string, data) {
    return string.replace(/{{(\w+)}}/g, (placeholderWithDelimiters, placeholderWithoutDelimiters)=>data.hasOwnProperty(placeholderWithoutDelimiters) ? data[placeholderWithoutDelimiters] : placeholderWithDelimiters);
}
// src/localization/en.json
var $fbb3f532a915e7a3$export$84584c2a98eb6753 = {
    sign_up: {
        email_label: "Email address",
        password_label: "Create a Password",
        email_input_placeholder: "Your email address",
        password_input_placeholder: "Your password",
        button_label: "Sign up",
        loading_button_label: "Signing up ...",
        social_provider_text: "Sign in with {{provider}}",
        link_text: "Don't have an account? Sign up",
        confirmation_text: "Check your email for the confirmation link"
    },
    sign_in: {
        email_label: "Email address",
        password_label: "Your Password",
        email_input_placeholder: "Your email address",
        password_input_placeholder: "Your password",
        button_label: "Sign in",
        loading_button_label: "Signing in ...",
        social_provider_text: "Sign in with {{provider}}",
        link_text: "Already have an account? Sign in"
    },
    magic_link: {
        email_input_label: "Email address",
        email_input_placeholder: "Your email address",
        button_label: "Send Magic Link",
        loading_button_label: "Sending Magic Link ...",
        link_text: "Send a magic link email",
        confirmation_text: "Check your email for the magic link"
    },
    forgotten_password: {
        email_label: "Email address",
        password_label: "Your Password",
        email_input_placeholder: "Your email address",
        button_label: "Send reset password instructions",
        loading_button_label: "Sending reset instructions ...",
        link_text: "Forgot your password?",
        confirmation_text: "Check your email for the password reset link"
    },
    update_password: {
        password_label: "New password",
        password_input_placeholder: "Your new password",
        button_label: "Update password",
        loading_button_label: "Updating password ...",
        confirmation_text: "Your password has been updated"
    },
    verify_otp: {
        email_input_label: "Email address",
        email_input_placeholder: "Your email address",
        phone_input_label: "Phone number",
        phone_input_placeholder: "Your phone number",
        token_input_label: "Token",
        token_input_placeholder: "Your Otp token",
        button_label: "Verify token",
        loading_button_label: "Signing in ..."
    }
};



var $bh6RR = parcelRequire("bh6RR");
const $b2e80c6a87ef7ea1$var$g1 = (0, $4c1054d6b7f3fad6$export$dbf350e5966cf602)({
    fontFamily: "$bodyFontFamily",
    fontSize: "$baseBodySize",
    marginBottom: "$anchorBottomMargin",
    color: "$anchorTextColor",
    display: "block",
    textAlign: "center",
    textDecoration: "underline",
    "&:hover": {
        color: "$anchorTextHoverColor"
    }
}), $b2e80c6a87ef7ea1$var$V = ({ children: t, appearance: l, ...n })=>{
    var o;
    const r = (0, $fbb3f532a915e7a3$export$4b9a51591ef11077)("anchor", $b2e80c6a87ef7ea1$var$g1(), l);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("a", {
        ...n,
        style: (o = l == null ? void 0 : l.style) == null ? void 0 : o.anchor,
        className: r.join(" ")
    }, t);
}, $b2e80c6a87ef7ea1$var$h1 = (0, $4c1054d6b7f3fad6$export$dbf350e5966cf602)({
    fontFamily: "$buttonFontFamily",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "$borderRadiusButton",
    fontSize: "$baseButtonSize",
    padding: "$buttonPadding",
    cursor: "pointer",
    borderWidth: "$buttonBorderWidth",
    borderStyle: "solid",
    width: "100%",
    transitionProperty: "background-color",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "100ms",
    "&:disabled": {
        opacity: 0.7,
        cursor: "unset"
    },
    variants: {
        color: {
            default: {
                backgroundColor: "$defaultButtonBackground",
                color: "$defaultButtonText",
                borderColor: "$defaultButtonBorder",
                "&:hover:not(:disabled)": {
                    backgroundColor: "$defaultButtonBackgroundHover"
                }
            },
            primary: {
                backgroundColor: "$brand",
                color: "$brandButtonText",
                borderColor: "$brandAccent",
                "&:hover:not(:disabled)": {
                    backgroundColor: "$brandAccent"
                }
            }
        }
    }
}), $b2e80c6a87ef7ea1$var$U = ({ children: t, color: l = "default", appearance: n, icon: r, loading: o = !1, ...v })=>{
    var C;
    const E = (0, $fbb3f532a915e7a3$export$4b9a51591ef11077)("button", $b2e80c6a87ef7ea1$var$h1({
        color: l
    }), n);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
        ...v,
        style: (C = n == null ? void 0 : n.style) == null ? void 0 : C.button,
        className: E.join(" "),
        disabled: o
    }, r, t);
}, $b2e80c6a87ef7ea1$var$f1 = (0, $4c1054d6b7f3fad6$export$dbf350e5966cf602)({
    display: "flex",
    gap: "4px",
    variants: {
        direction: {
            horizontal: {
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(48px, 1fr))"
            },
            vertical: {
                flexDirection: "column",
                margin: "8px 0"
            }
        },
        gap: {
            small: {
                gap: "4px"
            },
            medium: {
                gap: "8px"
            },
            large: {
                gap: "16px"
            }
        }
    }
}), $b2e80c6a87ef7ea1$var$N = ({ children: t, appearance: l, ...n })=>{
    var o;
    const r = (0, $fbb3f532a915e7a3$export$4b9a51591ef11077)("container", $b2e80c6a87ef7ea1$var$f1({
        direction: n.direction,
        gap: n.gap
    }), l);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...n,
        style: (o = l == null ? void 0 : l.style) == null ? void 0 : o.container,
        className: r.join(" ")
    }, t);
}, $b2e80c6a87ef7ea1$var$E1 = (0, $4c1054d6b7f3fad6$export$dbf350e5966cf602)({
    background: "$dividerBackground",
    display: "block",
    margin: "16px 0",
    height: "1px",
    width: "100%"
}), $b2e80c6a87ef7ea1$var$C1 = ({ children: t, appearance: l, ...n })=>{
    var o;
    const r = (0, $fbb3f532a915e7a3$export$4b9a51591ef11077)("divider", $b2e80c6a87ef7ea1$var$E1(), l);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        ...n,
        style: (o = l == null ? void 0 : l.style) == null ? void 0 : o.divider,
        className: r.join(" ")
    });
}, $b2e80c6a87ef7ea1$var$w1 = (0, $4c1054d6b7f3fad6$export$dbf350e5966cf602)({
    fontFamily: "$inputFontFamily",
    background: "$inputBackground",
    borderRadius: "$inputBorderRadius",
    padding: "$inputPadding",
    cursor: "text",
    borderWidth: "$inputBorderWidth",
    borderColor: "$inputBorder",
    borderStyle: "solid",
    fontSize: "$baseInputSize",
    width: "100%",
    color: "$inputText",
    boxSizing: "border-box",
    "&:hover": {
        borderColor: "$inputBorderHover",
        outline: "none"
    },
    "&:focus": {
        borderColor: "$inputBorderFocus",
        outline: "none"
    },
    "&::placeholder": {
        color: "$inputPlaceholder",
        letterSpacing: "initial"
    },
    transitionProperty: "background-color, border",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "100ms",
    variants: {
        type: {
            default: {
                letterSpacing: "0px"
            },
            password: {
                letterSpacing: "0px"
            }
        }
    }
}), $b2e80c6a87ef7ea1$var$D = ({ children: t, appearance: l, ...n })=>{
    var o;
    const r = (0, $fbb3f532a915e7a3$export$4b9a51591ef11077)("input", $b2e80c6a87ef7ea1$var$w1({
        type: n.type === "password" ? "password" : "default"
    }), l);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("input", {
        ...n,
        style: (o = l == null ? void 0 : l.style) == null ? void 0 : o.input,
        className: r.join(" ")
    }, t);
}, $b2e80c6a87ef7ea1$var$v1 = (0, $4c1054d6b7f3fad6$export$dbf350e5966cf602)({
    fontFamily: "$labelFontFamily",
    fontSize: "$baseLabelSize",
    marginBottom: "$labelBottomMargin",
    color: "$inputLabelText",
    display: "block"
}), $b2e80c6a87ef7ea1$var$H = ({ children: t, appearance: l, ...n })=>{
    var o;
    const r = (0, $fbb3f532a915e7a3$export$4b9a51591ef11077)("label", $b2e80c6a87ef7ea1$var$v1(), l);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("label", {
        ...n,
        style: (o = l == null ? void 0 : l.style) == null ? void 0 : o.label,
        className: r.join(" ")
    }, t);
}, $b2e80c6a87ef7ea1$var$x1 = (0, $4c1054d6b7f3fad6$export$dbf350e5966cf602)({
    fontFamily: "$bodyFontFamily",
    fontSize: "$baseInputSize",
    marginBottom: "$labelBottomMargin",
    display: "block",
    textAlign: "center",
    borderRadius: "0.375rem",
    padding: "1.5rem 1rem",
    lineHeight: "1rem",
    color: "$messageText",
    backgroundColor: "$messageBackground",
    border: "1px solid $messageBorder",
    variants: {
        color: {
            danger: {
                color: "$messageTextDanger",
                backgroundColor: "$messageBackgroundDanger",
                border: "1px solid $messageBorderDanger"
            }
        }
    }
}), $b2e80c6a87ef7ea1$var$F = ({ children: t, appearance: l, ...n })=>{
    var o;
    const r = (0, $fbb3f532a915e7a3$export$4b9a51591ef11077)("message", $b2e80c6a87ef7ea1$var$x1({
        color: n.color
    }), l);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        ...n,
        style: (o = l == null ? void 0 : l.style) == null ? void 0 : o.message,
        className: r.join(" ")
    }, t);
};
function $b2e80c6a87ef7ea1$var$X({ setAuthView: t = ()=>{}, supabaseClient: l, redirectTo: n, i18n: r, appearance: o, showLinks: v = !1 }) {
    var _;
    const [E, C] = (0, $bh6RR.useState)(""), [w, d] = (0, $bh6RR.useState)(""), [i, m] = (0, $bh6RR.useState)(""), [c, y] = (0, $bh6RR.useState)(!1), x = async (h)=>{
        var s, M;
        if (h.preventDefault(), d(""), m(""), y(!0), E.length === 0) {
            d((s = r == null ? void 0 : r.magic_link) == null ? void 0 : s.empty_email_address), y(!1);
            return;
        }
        const { error: g } = await l.auth.signInWithOtp({
            email: E,
            options: {
                emailRedirectTo: n
            }
        });
        g ? d(g.message) : m((M = r == null ? void 0 : r.magic_link) == null ? void 0 : M.confirmation_text), y(!1);
    }, a = r == null ? void 0 : r.magic_link;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("form", {
        id: "auth-magic-link",
        onSubmit: x
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$N, {
        gap: "large",
        direction: "vertical",
        appearance: o
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$H, {
        htmlFor: "email",
        appearance: o
    }, a == null ? void 0 : a.email_input_label), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$D, {
        id: "email",
        name: "email",
        type: "email",
        autoFocus: !0,
        placeholder: a == null ? void 0 : a.email_input_placeholder,
        onChange: (h)=>{
            d && d(""), C(h.target.value);
        },
        appearance: o
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$U, {
        color: "primary",
        type: "submit",
        loading: c,
        appearance: o
    }, c ? a == null ? void 0 : a.loading_button_label : a == null ? void 0 : a.button_label), v && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$V, {
        href: "#auth-sign-in",
        onClick: (h)=>{
            h.preventDefault(), t((0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).SIGN_IN);
        },
        appearance: o
    }, (_ = r == null ? void 0 : r.sign_in) == null ? void 0 : _.link_text), i && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$F, {
        appearance: o
    }, i), w && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$F, {
        color: "danger",
        appearance: o
    }, w)));
}
const $b2e80c6a87ef7ea1$var$L = (0, $4c1054d6b7f3fad6$export$dbf350e5966cf602)({
    width: "21px",
    height: "21px"
}), $b2e80c6a87ef7ea1$var$_1 = ({ provider: t })=>t == "google" ? $b2e80c6a87ef7ea1$var$y1() : t == "facebook" ? $b2e80c6a87ef7ea1$var$L1() : t == "twitter" ? $b2e80c6a87ef7ea1$var$b1() : t == "apple" ? $b2e80c6a87ef7ea1$var$p1() : t == "github" ? $b2e80c6a87ef7ea1$var$k1() : t == "gitlab" ? $b2e80c6a87ef7ea1$var$M1() : t == "bitbucket" ? $b2e80c6a87ef7ea1$var$S1() : t == "discord" ? $b2e80c6a87ef7ea1$var$N1() : t == "azure" ? $b2e80c6a87ef7ea1$var$F1() : t == "keycloak" ? $b2e80c6a87ef7ea1$var$z1() : t == "linkedin" ? $b2e80c6a87ef7ea1$var$$1() : t == "notion" ? $b2e80c6a87ef7ea1$var$B1() : t == "slack" ? $b2e80c6a87ef7ea1$var$D1() : t == "spotify" ? $b2e80c6a87ef7ea1$var$H1() : t == "twitch" ? $b2e80c6a87ef7ea1$var$P1() : t == "workos" ? $b2e80c6a87ef7ea1$var$V1() : t == "kakao" ? $b2e80c6a87ef7ea1$var$I1() : null, $b2e80c6a87ef7ea1$var$y1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "21px",
        height: "21px"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#FFC107",
        d: "M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#FF3D00",
        d: "M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#4CAF50",
        d: "M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#1976D2",
        d: "M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
    })), $b2e80c6a87ef7ea1$var$L1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "21px",
        height: "21px"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#039be5",
        d: "M24 5A19 19 0 1 0 24 43A19 19 0 1 0 24 5Z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#fff",
        d: "M26.572,29.036h4.917l0.772-4.995h-5.69v-2.73c0-2.075,0.678-3.915,2.619-3.915h3.119v-4.359c-0.548-0.074-1.707-0.236-3.897-0.236c-4.573,0-7.254,2.415-7.254,7.917v3.323h-4.701v4.995h4.701v13.729C22.089,42.905,23.032,43,24,43c0.875,0,1.729-0.08,2.572-0.194V29.036z"
    })), $b2e80c6a87ef7ea1$var$b1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "21px",
        height: "21px"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#03A9F4",
        d: "M42,12.429c-1.323,0.586-2.746,0.977-4.247,1.162c1.526-0.906,2.7-2.351,3.251-4.058c-1.428,0.837-3.01,1.452-4.693,1.776C34.967,9.884,33.05,9,30.926,9c-4.08,0-7.387,3.278-7.387,7.32c0,0.572,0.067,1.129,0.193,1.67c-6.138-0.308-11.582-3.226-15.224-7.654c-0.64,1.082-1,2.349-1,3.686c0,2.541,1.301,4.778,3.285,6.096c-1.211-0.037-2.351-0.374-3.349-0.914c0,0.022,0,0.055,0,0.086c0,3.551,2.547,6.508,5.923,7.181c-0.617,0.169-1.269,0.263-1.941,0.263c-0.477,0-0.942-0.054-1.392-0.135c0.94,2.902,3.667,5.023,6.898,5.086c-2.528,1.96-5.712,3.134-9.174,3.134c-0.598,0-1.183-0.034-1.761-0.104C9.268,36.786,13.152,38,17.321,38c13.585,0,21.017-11.156,21.017-20.834c0-0.317-0.01-0.633-0.025-0.945C39.763,15.197,41.013,13.905,42,12.429"
    })), $b2e80c6a87ef7ea1$var$p1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        fill: "gray",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "21px",
        height: "21px"
    }, " ", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M 15.904297 1.078125 C 15.843359 1.06875 15.774219 1.0746094 15.699219 1.0996094 C 14.699219 1.2996094 13.600391 1.8996094 12.900391 2.5996094 C 12.300391 3.1996094 11.800781 4.1996094 11.800781 5.0996094 C 11.800781 5.2996094 11.999219 5.5 12.199219 5.5 C 13.299219 5.4 14.399609 4.7996094 15.099609 4.0996094 C 15.699609 3.2996094 16.199219 2.4 16.199219 1.5 C 16.199219 1.275 16.087109 1.10625 15.904297 1.078125 z M 16.199219 5.4003906 C 14.399219 5.4003906 13.600391 6.5 12.400391 6.5 C 11.100391 6.5 9.9003906 5.5 8.4003906 5.5 C 6.3003906 5.5 3.0996094 7.4996094 3.0996094 12.099609 C 2.9996094 16.299609 6.8 21 9 21 C 10.3 21 10.600391 20.199219 12.400391 20.199219 C 14.200391 20.199219 14.600391 21 15.900391 21 C 17.400391 21 18.500391 19.399609 19.400391 18.099609 C 19.800391 17.399609 20.100391 17.000391 20.400391 16.400391 C 20.600391 16.000391 20.4 15.600391 20 15.400391 C 17.4 14.100391 16.900781 9.9003906 19.800781 8.4003906 C 20.300781 8.1003906 20.4 7.4992188 20 7.1992188 C 18.9 6.1992187 17.299219 5.4003906 16.199219 5.4003906 z"
    })), $b2e80c6a87ef7ea1$var$k1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        fill: "gray",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30",
        width: "21px",
        height: "21px"
    }, " ", /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M15,3C8.373,3,3,8.373,3,15c0,5.623,3.872,10.328,9.092,11.63C12.036,26.468,12,26.28,12,26.047v-2.051 c-0.487,0-1.303,0-1.508,0c-0.821,0-1.551-0.353-1.905-1.009c-0.393-0.729-0.461-1.844-1.435-2.526 c-0.289-0.227-0.069-0.486,0.264-0.451c0.615,0.174,1.125,0.596,1.605,1.222c0.478,0.627,0.703,0.769,1.596,0.769 c0.433,0,1.081-0.025,1.691-0.121c0.328-0.833,0.895-1.6,1.588-1.962c-3.996-0.411-5.903-2.399-5.903-5.098 c0-1.162,0.495-2.286,1.336-3.233C9.053,10.647,8.706,8.73,9.435,8c1.798,0,2.885,1.166,3.146,1.481C13.477,9.174,14.461,9,15.495,9 c1.036,0,2.024,0.174,2.922,0.483C18.675,9.17,19.763,8,21.565,8c0.732,0.731,0.381,2.656,0.102,3.594 c0.836,0.945,1.328,2.066,1.328,3.226c0,2.697-1.904,4.684-5.894,5.097C18.199,20.49,19,22.1,19,23.313v2.734 c0,0.104-0.023,0.179-0.035,0.268C23.641,24.676,27,20.236,27,15C27,8.373,21.627,3,15,3z"
    })), $b2e80c6a87ef7ea1$var$M1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "21px",
        height: "21px"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#e53935",
        d: "M24 43L16 20 32 20z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#ff7043",
        d: "M24 43L42 20 32 20z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#e53935",
        d: "M37 5L42 20 32 20z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#ffa726",
        d: "M24 43L42 20 45 28z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#ff7043",
        d: "M24 43L6 20 16 20z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#e53935",
        d: "M11 5L6 20 16 20z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#ffa726",
        d: "M24 43L6 20 3 28z"
    })), $b2e80c6a87ef7ea1$var$S1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        xmlns: "http://www.w3.org/2000/svg",
        width: "512",
        height: "512",
        viewBox: "0 0 62.42 62.42"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("defs", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("linearGradient", {
        id: "New_Gradient_Swatch_1",
        x1: "64.01",
        y1: "30.27",
        x2: "32.99",
        y2: "54.48",
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("stop", {
        offset: "0.18",
        stopColor: "#0052cc"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("stop", {
        offset: "1",
        stopColor: "#2684ff"
    }))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("title", null, "Bitbucket-blue"), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("g", {
        id: "Blue",
        transform: "translate(0 -3.13)"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M2,6.26A2,2,0,0,0,0,8.58L8.49,60.12a2.72,2.72,0,0,0,2.66,2.27H51.88a2,2,0,0,0,2-1.68L62.37,8.59a2,2,0,0,0-2-2.32ZM37.75,43.51h-13L21.23,25.12H40.9Z",
        fill: "#2684ff"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M59.67,25.12H40.9L37.75,43.51h-13L9.4,61.73a2.71,2.71,0,0,0,1.75.66H51.89a2,2,0,0,0,2-1.68Z",
        fill: "url(#New_Gradient_Swatch_1)"
    })))), $b2e80c6a87ef7ea1$var$N1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "21px",
        height: "21px"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#536dfe",
        d: "M39.248,10.177c-2.804-1.287-5.812-2.235-8.956-2.778c-0.057-0.01-0.114,0.016-0.144,0.068	c-0.387,0.688-0.815,1.585-1.115,2.291c-3.382-0.506-6.747-0.506-10.059,0c-0.3-0.721-0.744-1.603-1.133-2.291	c-0.03-0.051-0.087-0.077-0.144-0.068c-3.143,0.541-6.15,1.489-8.956,2.778c-0.024,0.01-0.045,0.028-0.059,0.051	c-5.704,8.522-7.267,16.835-6.5,25.044c0.003,0.04,0.026,0.079,0.057,0.103c3.763,2.764,7.409,4.442,10.987,5.554	c0.057,0.017,0.118-0.003,0.154-0.051c0.846-1.156,1.601-2.374,2.248-3.656c0.038-0.075,0.002-0.164-0.076-0.194	c-1.197-0.454-2.336-1.007-3.432-1.636c-0.087-0.051-0.094-0.175-0.014-0.234c0.231-0.173,0.461-0.353,0.682-0.534	c0.04-0.033,0.095-0.04,0.142-0.019c7.201,3.288,14.997,3.288,22.113,0c0.047-0.023,0.102-0.016,0.144,0.017	c0.22,0.182,0.451,0.363,0.683,0.536c0.08,0.059,0.075,0.183-0.012,0.234c-1.096,0.641-2.236,1.182-3.434,1.634	c-0.078,0.03-0.113,0.12-0.075,0.196c0.661,1.28,1.415,2.498,2.246,3.654c0.035,0.049,0.097,0.07,0.154,0.052	c3.595-1.112,7.241-2.79,11.004-5.554c0.033-0.024,0.054-0.061,0.057-0.101c0.917-9.491-1.537-17.735-6.505-25.044	C39.293,10.205,39.272,10.187,39.248,10.177z M16.703,30.273c-2.168,0-3.954-1.99-3.954-4.435s1.752-4.435,3.954-4.435	c2.22,0,3.989,2.008,3.954,4.435C20.658,28.282,18.906,30.273,16.703,30.273z M31.324,30.273c-2.168,0-3.954-1.99-3.954-4.435	s1.752-4.435,3.954-4.435c2.22,0,3.989,2.008,3.954,4.435C35.278,28.282,33.544,30.273,31.324,30.273z"
    })), $b2e80c6a87ef7ea1$var$F1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "21px",
        height: "21px"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("linearGradient", {
        id: "k8yl7~hDat~FaoWq8WjN6a",
        x1: "-1254.397",
        x2: "-1261.911",
        y1: "877.268",
        y2: "899.466",
        gradientTransform: "translate(1981.75 -1362.063) scale(1.5625)",
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("stop", {
        offset: "0",
        stopColor: "#114a8b"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("stop", {
        offset: "1",
        stopColor: "#0669bc"
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "url(#k8yl7~hDat~FaoWq8WjN6a)",
        d: "M17.634,6h11.305L17.203,40.773c-0.247,0.733-0.934,1.226-1.708,1.226H6.697 c-0.994,0-1.8-0.806-1.8-1.8c0-0.196,0.032-0.39,0.094-0.576L15.926,7.227C16.173,6.494,16.86,6,17.634,6L17.634,6z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#0078d4",
        d: "M34.062,29.324H16.135c-0.458-0.001-0.83,0.371-0.831,0.829c0,0.231,0.095,0.451,0.264,0.608 l11.52,10.752C27.423,41.826,27.865,42,28.324,42h10.151L34.062,29.324z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("linearGradient", {
        id: "k8yl7~hDat~FaoWq8WjN6b",
        x1: "-1252.05",
        x2: "-1253.788",
        y1: "887.612",
        y2: "888.2",
        gradientTransform: "translate(1981.75 -1362.063) scale(1.5625)",
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("stop", {
        offset: "0",
        stopOpacity: ".3"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("stop", {
        offset: ".071",
        stopOpacity: ".2"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("stop", {
        offset: ".321",
        stopOpacity: ".1"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("stop", {
        offset: ".623",
        stopOpacity: ".05"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("stop", {
        offset: "1",
        stopOpacity: "0"
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "url(#k8yl7~hDat~FaoWq8WjN6b)",
        d: "M17.634,6c-0.783-0.003-1.476,0.504-1.712,1.25L5.005,39.595 c-0.335,0.934,0.151,1.964,1.085,2.299C6.286,41.964,6.493,42,6.702,42h9.026c0.684-0.122,1.25-0.603,1.481-1.259l2.177-6.416 l7.776,7.253c0.326,0.27,0.735,0.419,1.158,0.422h10.114l-4.436-12.676l-12.931,0.003L28.98,6H17.634z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("linearGradient", {
        id: "k8yl7~hDat~FaoWq8WjN6c",
        x1: "-1252.952",
        x2: "-1244.704",
        y1: "876.6",
        y2: "898.575",
        gradientTransform: "translate(1981.75 -1362.063) scale(1.5625)",
        gradientUnits: "userSpaceOnUse"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("stop", {
        offset: "0",
        stopColor: "#3ccbf4"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("stop", {
        offset: "1",
        stopColor: "#2892df"
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "url(#k8yl7~hDat~FaoWq8WjN6c)",
        d: "M32.074,7.225C31.827,6.493,31.141,6,30.368,6h-12.6c0.772,0,1.459,0.493,1.705,1.224 l10.935,32.399c0.318,0.942-0.188,1.963-1.13,2.281C29.093,41.968,28.899,42,28.703,42h12.6c0.994,0,1.8-0.806,1.8-1.801 c0-0.196-0.032-0.39-0.095-0.575L32.074,7.225z"
    })), $b2e80c6a87ef7ea1$var$z1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        width: "512",
        height: "512",
        viewBox: "0 0 512 512",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M472.136 163.959H408.584C407.401 163.959 406.218 163.327 405.666 162.3L354.651 73.6591C354.02 72.632 352.916 72 351.654 72H143.492C142.309 72 141.126 72.632 140.574 73.6591L87.5084 165.618L36.414 254.259C35.862 255.286 35.862 256.55 36.414 257.656L87.5084 346.297L140.495 438.335C141.047 439.362 142.23 440.073 143.413 439.994H351.654C352.837 439.994 354.02 439.362 354.651 438.335L405.745 349.694C406.297 348.667 407.48 347.956 408.663 348.035H472.215C474.344 348.035 476 346.297 476 344.243V167.83C475.921 165.697 474.186 163.959 472.136 163.959ZM228.728 349.694L212.721 377.345C212.485 377.74 212.091 378.135 211.696 378.372C211.223 378.609 210.75 378.767 210.198 378.767H178.422C177.318 378.767 176.293 378.214 175.82 377.187L128.431 294.787L123.779 286.65L106.748 257.498C106.511 257.103 106.353 256.629 106.432 256.076C106.432 255.602 106.59 255.049 106.827 254.654L123.937 224.949L175.899 134.886C176.451 133.938 177.476 133.306 178.501 133.306H210.198C210.75 133.306 211.302 133.464 211.854 133.701C212.248 133.938 212.643 134.254 212.879 134.728L228.886 162.537C229.359 163.485 229.28 164.67 228.728 165.539L177.397 254.654C177.16 255.049 177.081 255.523 177.081 255.918C177.081 256.392 177.239 256.787 177.397 257.182L228.728 346.218C229.438 347.403 229.359 348.667 228.728 349.694V349.694ZM388.083 257.498L371.051 286.65L366.399 294.787L319.011 377.187C318.459 378.135 317.512 378.767 316.409 378.767H284.632C284.08 378.767 283.607 378.609 283.134 378.372C282.74 378.135 282.346 377.819 282.109 377.345L266.103 349.694C265.393 348.667 265.393 347.403 266.024 346.376L317.355 257.34C317.591 256.945 317.67 256.471 317.67 256.076C317.67 255.602 317.513 255.207 317.355 254.812L266.024 165.697C265.472 164.749 265.393 163.643 265.866 162.695L281.873 134.886C282.109 134.491 282.503 134.096 282.898 133.859C283.371 133.543 283.923 133.464 284.553 133.464H316.409C317.512 133.464 318.538 134.017 319.011 135.044L370.972 225.107L388.083 254.812C388.319 255.286 388.477 255.76 388.477 256.234C388.477 256.55 388.319 257.024 388.083 257.498V257.498Z",
        fill: "#008AAA"
    })), $b2e80c6a87ef7ea1$var$$1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "21px",
        height: "21px"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#0288D1",
        d: "M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#FFF",
        d: "M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
    })), $b2e80c6a87ef7ea1$var$B1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "21px",
        height: "21px",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M11.553,11.099c1.232,1.001,1.694,0.925,4.008,0.77 l21.812-1.31c0.463,0,0.078-0.461-0.076-0.538l-3.622-2.619c-0.694-0.539-1.619-1.156-3.391-1.002l-21.12,1.54 c-0.77,0.076-0.924,0.461-0.617,0.77L11.553,11.099z",
        clipRule: "evenodd"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M12.862,16.182v22.95c0,1.233,0.616,1.695,2.004,1.619 l23.971-1.387c1.388-0.076,1.543-0.925,1.543-1.927V14.641c0-1-0.385-1.54-1.234-1.463l-25.05,1.463 C13.171,14.718,12.862,15.181,12.862,16.182L12.862,16.182z",
        clipRule: "evenodd"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#424242",
        fillRule: "evenodd",
        d: "M11.553,11.099c1.232,1.001,1.694,0.925,4.008,0.77 l21.812-1.31c0.463,0,0.078-0.461-0.076-0.538l-3.622-2.619c-0.694-0.539-1.619-1.156-3.391-1.002l-21.12,1.54 c-0.77,0.076-0.924,0.461-0.617,0.77L11.553,11.099z M12.862,16.182v22.95c0,1.233,0.616,1.695,2.004,1.619l23.971-1.387 c1.388-0.076,1.543-0.925,1.543-1.927V14.641c0-1-0.385-1.54-1.234-1.463l-25.05,1.463C13.171,14.718,12.862,15.181,12.862,16.182 L12.862,16.182z M36.526,17.413c0.154,0.694,0,1.387-0.695,1.465l-1.155,0.23v16.943c-1.003,0.539-1.928,0.847-2.698,0.847 c-1.234,0-1.543-0.385-2.467-1.54l-7.555-11.86v11.475l2.391,0.539c0,0,0,1.386-1.929,1.386l-5.317,0.308 c-0.154-0.308,0-1.078,0.539-1.232l1.388-0.385V20.418l-1.927-0.154c-0.155-0.694,0.23-1.694,1.31-1.772l5.704-0.385l7.862,12.015 V19.493l-2.005-0.23c-0.154-0.848,0.462-1.464,1.233-1.54L36.526,17.413z M7.389,5.862l21.968-1.618 c2.698-0.231,3.392-0.076,5.087,1.155l7.013,4.929C42.614,11.176,43,11.407,43,12.33v27.032c0,1.694-0.617,2.696-2.775,2.849 l-25.512,1.541c-1.62,0.077-2.391-0.154-3.239-1.232l-5.164-6.7C5.385,34.587,5,33.664,5,32.585V8.556 C5,7.171,5.617,6.015,7.389,5.862z",
        clipRule: "evenodd"
    })), $b2e80c6a87ef7ea1$var$D1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "21px",
        height: "21px"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#33d375",
        d: "M33,8c0-2.209-1.791-4-4-4s-4,1.791-4,4c0,1.254,0,9.741,0,11c0,2.209,1.791,4,4,4s4-1.791,4-4	C33,17.741,33,9.254,33,8z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#33d375",
        d: "M43,19c0,2.209-1.791,4-4,4c-1.195,0-4,0-4,0s0-2.986,0-4c0-2.209,1.791-4,4-4S43,16.791,43,19z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#40c4ff",
        d: "M8,14c-2.209,0-4,1.791-4,4s1.791,4,4,4c1.254,0,9.741,0,11,0c2.209,0,4-1.791,4-4s-1.791-4-4-4	C17.741,14,9.254,14,8,14z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#40c4ff",
        d: "M19,4c2.209,0,4,1.791,4,4c0,1.195,0,4,0,4s-2.986,0-4,0c-2.209,0-4-1.791-4-4S16.791,4,19,4z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#e91e63",
        d: "M14,39.006C14,41.212,15.791,43,18,43s4-1.788,4-3.994c0-1.252,0-9.727,0-10.984	c0-2.206-1.791-3.994-4-3.994s-4,1.788-4,3.994C14,29.279,14,37.754,14,39.006z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#e91e63",
        d: "M4,28.022c0-2.206,1.791-3.994,4-3.994c1.195,0,4,0,4,0s0,2.981,0,3.994c0,2.206-1.791,3.994-4,3.994	S4,30.228,4,28.022z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#ffc107",
        d: "M39,33c2.209,0,4-1.791,4-4s-1.791-4-4-4c-1.254,0-9.741,0-11,0c-2.209,0-4,1.791-4,4s1.791,4,4,4	C29.258,33,37.746,33,39,33z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#ffc107",
        d: "M28,43c-2.209,0-4-1.791-4-4c0-1.195,0-4,0-4s2.986,0,4,0c2.209,0,4,1.791,4,4S30.209,43,28,43z"
    })), $b2e80c6a87ef7ea1$var$H1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        width: "512",
        height: "512",
        viewBox: "0 0 512 512",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M255.498 31.0034C131.513 31.0034 31 131.515 31 255.502C31 379.492 131.513 480 255.498 480C379.497 480 480 379.495 480 255.502C480 131.522 379.497 31.0135 255.495 31.0135L255.498 31V31.0034ZM358.453 354.798C354.432 361.391 345.801 363.486 339.204 359.435C286.496 327.237 220.139 319.947 141.993 337.801C134.463 339.516 126.957 334.798 125.24 327.264C123.516 319.731 128.217 312.225 135.767 310.511C221.284 290.972 294.639 299.384 353.816 335.549C360.413 339.596 362.504 348.2 358.453 354.798ZM385.932 293.67C380.864 301.903 370.088 304.503 361.858 299.438C301.512 262.345 209.528 251.602 138.151 273.272C128.893 276.067 119.118 270.851 116.309 261.61C113.521 252.353 118.74 242.597 127.981 239.782C209.512 215.044 310.87 227.026 380.17 269.612C388.4 274.68 391 285.456 385.935 293.676V293.673L385.932 293.67ZM388.293 230.016C315.935 187.039 196.56 183.089 127.479 204.055C116.387 207.42 104.654 201.159 101.293 190.063C97.9326 178.964 104.189 167.241 115.289 163.87C194.59 139.796 326.418 144.446 409.723 193.902C419.722 199.826 422.995 212.71 417.068 222.675C411.168 232.653 398.247 235.943 388.303 230.016H388.293V230.016Z",
        fill: "#1ED760"
    })), $b2e80c6a87ef7ea1$var$P1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        width: "512",
        height: "512",
        viewBox: "0 0 512 512",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M416 240L352 304H288L232 360V304H160V64H416V240Z",
        fill: "white"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M144 32L64 112V400H160V480L240 400H304L448 256V32H144ZM416 240L352 304H288L232 360V304H160V64H416V240Z",
        fill: "#9146FF"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M368 120H336V216H368V120Z",
        fill: "#9146FF"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M280 120H248V216H280V120Z",
        fill: "#9146FF"
    })), $b2e80c6a87ef7ea1$var$V1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        width: "512",
        height: "512",
        viewBox: "0 0 512 512",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M33 256.043C33 264.556 35.3159 273.069 39.4845 280.202L117.993 415.493C126.098 429.298 138.373 440.572 153.657 445.634C183.764 455.528 214.797 442.873 229.618 417.333L248.609 384.661L173.806 256.043L252.777 119.831L271.768 87.1591C277.557 77.2654 284.968 69.4424 294 63H285.894H172.185C150.878 63 131.193 74.2742 120.54 92.6812L39.7161 231.884C35.3159 239.016 33 247.53 33 256.043Z",
        fill: "#6363F1"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M480 256.058C480 247.539 477.684 239.021 473.516 231.883L393.849 94.6596C379.028 69.3331 347.995 56.4396 317.888 66.34C302.603 71.4053 290.329 82.6871 282.224 96.5015L264.391 127.354L339.194 256.058L260.223 392.131L241.232 424.825C235.443 434.495 228.032 442.553 219 449H227.106H340.815C362.122 449 381.807 437.718 392.46 419.299L473.284 280.003C477.684 272.866 480 264.577 480 256.058Z",
        fill: "#6363F1"
    })), $b2e80c6a87ef7ea1$var$I1 = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", {
        className: $b2e80c6a87ef7ea1$var$L(),
        xmlns: "http://www.w3.org/2000/svg",
        width: "2500",
        height: "2500",
        viewBox: "0 0 256 256"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#FFE812",
        d: "M256 236c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20V20C0 8.954 8.954 0 20 0h216c11.046 0 20 8.954 20 20v216z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M128 36C70.562 36 24 72.713 24 118c0 29.279 19.466 54.97 48.748 69.477-1.593 5.494-10.237 35.344-10.581 37.689 0 0-.207 1.762.934 2.434s2.483.15 2.483.15c3.272-.457 37.943-24.811 43.944-29.04 5.995.849 12.168 1.29 18.472 1.29 57.438 0 104-36.712 104-82 0-45.287-46.562-82-104-82z"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        fill: "#FFE812",
        d: "M70.5 146.625c-3.309 0-6-2.57-6-5.73V105.25h-9.362c-3.247 0-5.888-2.636-5.888-5.875s2.642-5.875 5.888-5.875h30.724c3.247 0 5.888 2.636 5.888 5.875s-2.642 5.875-5.888 5.875H76.5v35.645c0 3.16-2.691 5.73-6 5.73zM123.112 146.547c-2.502 0-4.416-1.016-4.993-2.65l-2.971-7.778-18.296-.001-2.973 7.783c-.575 1.631-2.488 2.646-4.99 2.646a9.155 9.155 0 0 1-3.814-.828c-1.654-.763-3.244-2.861-1.422-8.52l14.352-37.776c1.011-2.873 4.082-5.833 7.99-5.922 3.919.088 6.99 3.049 8.003 5.928l14.346 37.759c1.826 5.672.236 7.771-1.418 8.532a9.176 9.176 0 0 1-3.814.827c-.001 0 0 0 0 0zm-11.119-21.056L106 108.466l-5.993 17.025h11.986zM138 145.75c-3.171 0-5.75-2.468-5.75-5.5V99.5c0-3.309 2.748-6 6.125-6s6.125 2.691 6.125 6v35.25h12.75c3.171 0 5.75 2.468 5.75 5.5s-2.579 5.5-5.75 5.5H138zM171.334 146.547c-3.309 0-6-2.691-6-6V99.5c0-3.309 2.691-6 6-6s6 2.691 6 6v12.896l16.74-16.74c.861-.861 2.044-1.335 3.328-1.335 1.498 0 3.002.646 4.129 1.772 1.051 1.05 1.678 2.401 1.764 3.804.087 1.415-.384 2.712-1.324 3.653l-13.673 13.671 14.769 19.566a5.951 5.951 0 0 1 1.152 4.445 5.956 5.956 0 0 1-2.328 3.957 5.94 5.94 0 0 1-3.609 1.211 5.953 5.953 0 0 1-4.793-2.385l-14.071-18.644-2.082 2.082v13.091a6.01 6.01 0 0 1-6.002 6.003z"
    }));
function $b2e80c6a87ef7ea1$var$A1({ supabaseClient: t, socialLayout: l = "vertical", providers: n = [
    "github",
    "google",
    "azure"
], providerScopes: r, queryParams: o, redirectTo: v, onlyThirdPartyProviders: E = !0, view: C = "sign_in", i18n: w, appearance: d }) {
    const [i, m] = (0, $bh6RR.useState)(!1), [c, y] = (0, $bh6RR.useState)(""), x = l === "vertical", a = C === "magic_link" ? "sign_in" : C, _ = async (g)=>{
        m(!0);
        const { error: s } = await t.auth.signInWithOAuth({
            provider: g,
            options: {
                redirectTo: v,
                scopes: r == null ? void 0 : r[g],
                queryParams: o
            }
        });
        s && y(s.message), m(!1);
    };
    function h(g) {
        const s = g.toLowerCase();
        return g.charAt(0).toUpperCase() + s.slice(1);
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, n && n.length > 0 && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$N, {
        gap: "large",
        direction: "vertical",
        appearance: d
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$N, {
        direction: x ? "vertical" : "horizontal",
        gap: x ? "small" : "medium",
        appearance: d
    }, n.map((g)=>{
        var s;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$U, {
            key: g,
            color: "default",
            loading: i,
            onClick: ()=>_(g),
            appearance: d
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$_1, {
            provider: g
        }), x && (0, $fbb3f532a915e7a3$export$ce69bd05624d0c48)((s = w == null ? void 0 : w[a]) == null ? void 0 : s.social_provider_text, {
            provider: h(g)
        }));
    }))), !E && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$C1, {
        appearance: d
    })));
}
function $b2e80c6a87ef7ea1$var$Q({ authView: t = "sign_in", defaultEmail: l = "", defaultPassword: n = "", setAuthView: r = ()=>{}, setDefaultEmail: o = (x)=>{}, setDefaultPassword: v = (x)=>{}, supabaseClient: E, showLinks: C = !1, redirectTo: w, additionalData: d, magicLink: i, i18n: m, appearance: c, children: y }) {
    var T, G, Z, j;
    const x = (0, $bh6RR.useRef)(!0), [a, _] = (0, $bh6RR.useState)(l), [h, g] = (0, $bh6RR.useState)(n), [s, M] = (0, $bh6RR.useState)(""), [p, B] = (0, $bh6RR.useState)(!1), [P, A] = (0, $bh6RR.useState)("");
    (0, $bh6RR.useEffect)(()=>(x.current = !0, _(l), g(n), ()=>{
            x.current = !1;
        }), [
        t
    ]);
    const O = async (k)=>{
        var q;
        switch(k.preventDefault(), M(""), B(!0), t){
            case "sign_in":
                const { error: K } = await E.auth.signInWithPassword({
                    email: a,
                    password: h
                });
                K && M(K.message);
                break;
            case "sign_up":
                let Y = {
                    emailRedirectTo: w
                };
                d && (Y.data = d);
                const { data: { user: r1, session: o1 }, error: J } = await E.auth.signUp({
                    email: a,
                    password: h,
                    options: Y
                });
                J ? M(J.message) : r1 && !o1 && A((q = m == null ? void 0 : m.sign_up) == null ? void 0 : q.confirmation_text);
                break;
        }
        x.current && B(!1);
    }, z = (k)=>{
        o(a), v(h), r(k);
    }, f = m == null ? void 0 : m[t];
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("form", {
        id: t === "sign_in" ? "auth-sign-in" : "auth-sign-up",
        onSubmit: O,
        autoComplete: "on",
        style: {
            width: "100%"
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$N, {
        direction: "vertical",
        gap: "large",
        appearance: c
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$N, {
        direction: "vertical",
        gap: "large",
        appearance: c
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$H, {
        htmlFor: "email",
        appearance: c
    }, f == null ? void 0 : f.email_label), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$D, {
        id: "email",
        type: "email",
        name: "email",
        placeholder: f == null ? void 0 : f.email_input_placeholder,
        defaultValue: a,
        onChange: (k)=>_(k.target.value),
        autoComplete: "email",
        appearance: c
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$H, {
        htmlFor: "password",
        appearance: c
    }, f == null ? void 0 : f.password_label), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$D, {
        id: "password",
        type: "password",
        name: "password",
        placeholder: f == null ? void 0 : f.password_input_placeholder,
        defaultValue: h,
        onChange: (k)=>g(k.target.value),
        autoComplete: t === "sign_in" ? "current-password" : "new-password",
        appearance: c
    })), y), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$U, {
        type: "submit",
        color: "primary",
        loading: p,
        appearance: c
    }, p ? f == null ? void 0 : f.loading_button_label : f == null ? void 0 : f.button_label), C && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$N, {
        direction: "vertical",
        gap: "small",
        appearance: c
    }, t === (0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).SIGN_IN && i && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$V, {
        href: "#auth-magic-link",
        onClick: (k)=>{
            k.preventDefault(), r((0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).MAGIC_LINK);
        },
        appearance: c
    }, (T = m == null ? void 0 : m.magic_link) == null ? void 0 : T.link_text), t === (0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).SIGN_IN && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$V, {
        href: "#auth-forgot-password",
        onClick: (k)=>{
            k.preventDefault(), r((0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).FORGOTTEN_PASSWORD);
        },
        appearance: c
    }, (G = m == null ? void 0 : m.forgotten_password) == null ? void 0 : G.link_text), t === (0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).SIGN_IN ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$V, {
        href: "#auth-sign-up",
        onClick: (k)=>{
            k.preventDefault(), z((0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).SIGN_UP);
        },
        appearance: c
    }, (Z = m == null ? void 0 : m.sign_up) == null ? void 0 : Z.link_text) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$V, {
        href: "#auth-sign-in",
        onClick: (k)=>{
            k.preventDefault(), z((0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).SIGN_IN);
        },
        appearance: c
    }, (j = m == null ? void 0 : m.sign_in) == null ? void 0 : j.link_text))), P && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$F, {
        appearance: c
    }, P), s && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$F, {
        color: "danger",
        appearance: c
    }, s));
}
function $b2e80c6a87ef7ea1$var$e1({ setAuthView: t = ()=>{}, supabaseClient: l, redirectTo: n, i18n: r, appearance: o, showLinks: v = !1 }) {
    var _;
    const [E, C] = (0, $bh6RR.useState)(""), [w, d] = (0, $bh6RR.useState)(""), [i, m] = (0, $bh6RR.useState)(""), [c, y] = (0, $bh6RR.useState)(!1), x = async (h)=>{
        var s;
        h.preventDefault(), d(""), m(""), y(!0);
        const { error: g } = await l.auth.resetPasswordForEmail(E, {
            redirectTo: n
        });
        g ? d(g.message) : m((s = r == null ? void 0 : r.forgotten_password) == null ? void 0 : s.confirmation_text), y(!1);
    }, a = r == null ? void 0 : r.forgotten_password;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("form", {
        id: "auth-forgot-password",
        onSubmit: x
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$N, {
        direction: "vertical",
        gap: "large",
        appearance: o
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$N, {
        gap: "large",
        direction: "vertical",
        appearance: o
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$H, {
        htmlFor: "email",
        appearance: o
    }, a == null ? void 0 : a.email_label), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$D, {
        id: "email",
        name: "email",
        type: "email",
        autoFocus: !0,
        placeholder: a == null ? void 0 : a.email_input_placeholder,
        onChange: (h)=>C(h.target.value),
        appearance: o
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$U, {
        type: "submit",
        color: "primary",
        loading: c,
        appearance: o
    }, c ? a == null ? void 0 : a.loading_button_label : a == null ? void 0 : a.button_label), v && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$V, {
        href: "#auth-sign-in",
        onClick: (h)=>{
            h.preventDefault(), t((0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).SIGN_IN);
        },
        appearance: o
    }, (_ = r == null ? void 0 : r.sign_in) == null ? void 0 : _.link_text), i && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$F, {
        appearance: o
    }, i), w && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$F, {
        color: "danger",
        appearance: o
    }, w))));
}
function $b2e80c6a87ef7ea1$var$t1({ supabaseClient: t, i18n: l, appearance: n }) {
    const [r, o] = (0, $bh6RR.useState)(""), [v, E] = (0, $bh6RR.useState)(""), [C, w] = (0, $bh6RR.useState)(""), [d, i] = (0, $bh6RR.useState)(!1), m = async (y)=>{
        var a;
        y.preventDefault(), E(""), w(""), i(!0);
        const { error: x } = await t.auth.updateUser({
            password: r
        });
        x ? E(x.message) : w((a = l == null ? void 0 : l.update_password) == null ? void 0 : a.confirmation_text), i(!1);
    }, c = l == null ? void 0 : l.update_password;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("form", {
        id: "auth-update-password",
        onSubmit: m
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$N, {
        gap: "large",
        direction: "vertical",
        appearance: n
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$H, {
        htmlFor: "password",
        appearance: n
    }, c == null ? void 0 : c.password_label), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$D, {
        id: "password",
        name: "password",
        placeholder: c == null ? void 0 : c.password_input_placeholder,
        type: "password",
        autoFocus: !0,
        onChange: (y)=>o(y.target.value),
        appearance: n
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$U, {
        type: "submit",
        color: "primary",
        loading: d,
        appearance: n
    }, d ? c == null ? void 0 : c.loading_button_label : c == null ? void 0 : c.button_label), C && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$F, {
        appearance: n
    }, C), v && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$F, {
        color: "danger",
        appearance: n
    }, v)));
}
function $b2e80c6a87ef7ea1$var$U1({ setAuthView: t = ()=>{}, supabaseClient: l, otpType: n = "email", i18n: r, appearance: o, showLinks: v = !1 }) {
    var M;
    const [E, C] = (0, $bh6RR.useState)(""), [w, d] = (0, $bh6RR.useState)(""), [i, m] = (0, $bh6RR.useState)(""), [c, y] = (0, $bh6RR.useState)(""), [x, a] = (0, $bh6RR.useState)(""), [_, h] = (0, $bh6RR.useState)(!1), g = async (p)=>{
        p.preventDefault(), y(""), a(""), h(!0);
        let B = {
            email: E,
            token: i,
            type: n
        };
        [
            "sms",
            "phone_change"
        ].includes(n) && (B = {
            phone: w,
            token: i,
            type: n
        });
        const { error: P } = await l.auth.verifyOtp(B);
        P && y(P.message), h(!1);
    }, s = r == null ? void 0 : r.verify_otp;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("form", {
        id: "auth-magic-link",
        onSubmit: g
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$N, {
        gap: "large",
        direction: "vertical",
        appearance: o
    }, [
        "sms",
        "phone_change"
    ].includes(n) ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$H, {
        htmlFor: "phone",
        appearance: o
    }, s == null ? void 0 : s.phone_input_label), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$D, {
        id: "phone",
        name: "phone",
        type: "text",
        autoFocus: !0,
        placeholder: s == null ? void 0 : s.phone_input_placeholder,
        onChange: (p)=>d(p.target.value),
        appearance: o
    })) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$H, {
        htmlFor: "email",
        appearance: o
    }, s == null ? void 0 : s.email_input_label), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$D, {
        id: "email",
        name: "email",
        type: "email",
        autoFocus: !0,
        placeholder: s == null ? void 0 : s.email_input_placeholder,
        onChange: (p)=>C(p.target.value),
        appearance: o
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$H, {
        htmlFor: "token",
        appearance: o
    }, s == null ? void 0 : s.token_input_label), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$D, {
        id: "token",
        name: "token",
        type: "text",
        placeholder: s == null ? void 0 : s.token_input_placeholder,
        onChange: (p)=>m(p.target.value),
        appearance: o
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$U, {
        color: "primary",
        type: "submit",
        loading: _,
        appearance: o
    }, _ ? s == null ? void 0 : s.loading_button_label : s == null ? void 0 : s.button_label), v && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$V, {
        href: "#auth-sign-in",
        onClick: (p)=>{
            p.preventDefault(), t((0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).SIGN_IN);
        },
        appearance: o
    }, (M = r == null ? void 0 : r.sign_in) == null ? void 0 : M.link_text), x && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$F, {
        appearance: o
    }, x), c && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$F, {
        color: "danger",
        appearance: o
    }, c)));
}
const $b2e80c6a87ef7ea1$var$l1 = (0, $bh6RR.createContext)({
    user: null,
    session: null
}), $b2e80c6a87ef7ea1$var$R1 = (t)=>{
    const { supabaseClient: l } = t, [n, r] = (0, $bh6RR.useState)(null), [o, v] = (0, $bh6RR.useState)((n == null ? void 0 : n.user) ?? null);
    (0, $bh6RR.useEffect)(()=>{
        (async ()=>{
            var d;
            const { data: w } = await l.auth.getSession();
            r(w.session), v(((d = w.session) == null ? void 0 : d.user) ?? null);
        })();
        const { data: C } = l.auth.onAuthStateChange(async (w, d)=>{
            r(d), v((d == null ? void 0 : d.user) ?? null);
        });
        return ()=>{
            C == null || C.subscription.unsubscribe();
        };
    }, []);
    const E = {
        session: n,
        user: o
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$l1.Provider, {
        value: E,
        ...t
    });
}, $b2e80c6a87ef7ea1$var$O1 = ()=>{
    const t = (0, $bh6RR.useContext)($b2e80c6a87ef7ea1$var$l1);
    if (t === void 0) throw new Error("useUser must be used within a UserContextProvider.");
    return t;
};
function $b2e80c6a87ef7ea1$export$334c29725a78c21d({ supabaseClient: t, socialLayout: l = "vertical", providers: n, providerScopes: r, queryParams: o, view: v = "sign_in", redirectTo: E, onlyThirdPartyProviders: C = !1, magicLink: w = !1, showLinks: d = !0, appearance: i, theme: m = "default", localization: c = {
    variables: {}
}, otpType: y = "email", additionalData: x, children: a }) {
    const _ = (0, $fbb3f532a915e7a3$export$4950aa0f605343fb)((0, $fbb3f532a915e7a3$export$84584c2a98eb6753), c.variables ?? {}), [h, g] = (0, $bh6RR.useState)(v), [s, M] = (0, $bh6RR.useState)(""), [p, B] = (0, $bh6RR.useState)(""), P = h === "sign_in" || h === "sign_up" || h === "magic_link";
    (0, $bh6RR.useEffect)(()=>{
        var z, f;
        (0, $4c1054d6b7f3fad6$export$3c6706659c99b84e)({
            theme: (0, $fbb3f532a915e7a3$export$4950aa0f605343fb)(((z = i == null ? void 0 : i.theme) == null ? void 0 : z.default) ?? {}, ((f = i == null ? void 0 : i.variables) == null ? void 0 : f.default) ?? {})
        });
    }, [
        i
    ]);
    const A = ({ children: z })=>{
        var f;
        return(// @ts-ignore
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: m !== "default" ? (0, $4c1054d6b7f3fad6$export$25d302a5b900a763)((0, $fbb3f532a915e7a3$export$4950aa0f605343fb)(// @ts-ignore
            i == null ? void 0 : i.theme[m], ((f = i == null ? void 0 : i.variables) == null ? void 0 : f[m]) ?? {})) : ""
        }, P && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$A1, {
            appearance: i,
            supabaseClient: t,
            providers: n,
            providerScopes: r,
            queryParams: o,
            socialLayout: l,
            redirectTo: E,
            onlyThirdPartyProviders: C,
            i18n: _,
            view: h
        }), !C && z));
    };
    (0, $bh6RR.useEffect)(()=>{
        const { data: z } = t.auth.onAuthStateChange((f)=>{
            f === "PASSWORD_RECOVERY" ? g("update_password") : f === "USER_UPDATED" && g("sign_in");
        });
        return g(v), ()=>z.subscription.unsubscribe();
    }, [
        v
    ]);
    const O = {
        supabaseClient: t,
        setAuthView: g,
        defaultEmail: s,
        defaultPassword: p,
        setDefaultEmail: M,
        setDefaultPassword: B,
        redirectTo: E,
        magicLink: w,
        showLinks: d,
        i18n: _,
        appearance: i
    };
    switch(h){
        case (0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).SIGN_IN:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(A, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$Q, {
                ...O,
                authView: "sign_in"
            }));
        case (0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).SIGN_UP:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(A, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$Q, {
                appearance: i,
                supabaseClient: t,
                authView: "sign_up",
                setAuthView: g,
                defaultEmail: s,
                defaultPassword: p,
                setDefaultEmail: M,
                setDefaultPassword: B,
                redirectTo: E,
                magicLink: w,
                showLinks: d,
                i18n: _,
                additionalData: x,
                children: a
            }));
        case (0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).FORGOTTEN_PASSWORD:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(A, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$e1, {
                appearance: i,
                supabaseClient: t,
                setAuthView: g,
                redirectTo: E,
                showLinks: d,
                i18n: _
            }));
        case (0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).MAGIC_LINK:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(A, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$X, {
                appearance: i,
                supabaseClient: t,
                setAuthView: g,
                redirectTo: E,
                showLinks: d,
                i18n: _
            }));
        case (0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).UPDATE_PASSWORD:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$t1, {
                appearance: i,
                supabaseClient: t,
                i18n: _
            });
        case (0, $fbb3f532a915e7a3$export$50bf86b71c5fd0d9).VERIFY_OTP:
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$var$U1, {
                appearance: i,
                supabaseClient: t,
                otpType: y,
                i18n: _
            });
        default:
            return null;
    }
}
$b2e80c6a87ef7ea1$export$334c29725a78c21d.ForgottenPassword = $b2e80c6a87ef7ea1$var$e1;
$b2e80c6a87ef7ea1$export$334c29725a78c21d.UpdatePassword = $b2e80c6a87ef7ea1$var$t1;
$b2e80c6a87ef7ea1$export$334c29725a78c21d.MagicLink = $b2e80c6a87ef7ea1$var$X;
$b2e80c6a87ef7ea1$export$334c29725a78c21d.UserContextProvider = $b2e80c6a87ef7ea1$var$R1;
$b2e80c6a87ef7ea1$export$334c29725a78c21d.useUser = $b2e80c6a87ef7ea1$var$O1;
const $b2e80c6a87ef7ea1$var$W1 = (0, $4c1054d6b7f3fad6$export$dbf350e5966cf602)({
    borderRadius: "12px",
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    width: "360px",
    padding: "28px 32px"
}), $b2e80c6a87ef7ea1$export$83741bd541c5a4b4 = ({ children: t, appearance: l })=>{
    const n = [
        `${(0, $fbb3f532a915e7a3$export$fed8a8b2609af45)}_ui-card`,
        $b2e80c6a87ef7ea1$var$W1(),
        l == null ? void 0 : l.className
    ];
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: n.join(" ")
    }, t);
}, $b2e80c6a87ef7ea1$export$4ee457d816cea81a = (t)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$export$334c29725a78c21d, {
        showLinks: !1,
        ...t,
        onlyThirdPartyProviders: !1,
        view: "sign_up"
    }), $b2e80c6a87ef7ea1$export$b64708c6f1b3ed96 = (t)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$export$334c29725a78c21d, {
        showLinks: !1,
        ...t,
        onlyThirdPartyProviders: !1,
        view: "sign_in"
    }), $b2e80c6a87ef7ea1$export$af9e93f26bc74a5f = (t)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$export$334c29725a78c21d, {
        ...t,
        view: "magic_link",
        showLinks: !1
    }), $b2e80c6a87ef7ea1$export$7749df3b0fed2b78 = (t)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$export$334c29725a78c21d, {
        ...t,
        view: "sign_in",
        showLinks: !1,
        onlyThirdPartyProviders: !0
    }), $b2e80c6a87ef7ea1$export$ad90e678da64bba4 = (t)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$export$334c29725a78c21d, {
        showLinks: !1,
        ...t,
        view: "forgotten_password"
    }), $b2e80c6a87ef7ea1$export$e60dde0f38d571d2 = (t)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$export$334c29725a78c21d, {
        ...t,
        view: "update_password"
    }), $b2e80c6a87ef7ea1$export$687e1a141666feba = (t)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($b2e80c6a87ef7ea1$export$334c29725a78c21d, {
        ...t,
        view: "verify_otp"
    });




var $bh6RR = parcelRequire("bh6RR");

var $gN5ZC = parcelRequire("gN5ZC");

var $10WBQ = parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
var $99w1R = parcelRequire("99w1R");
parcelRequire("aWtcP");
var $i2TPN = parcelRequire("i2TPN");

var $9SfKt = parcelRequire("9SfKt");

var $ih19M = parcelRequire("ih19M");
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $87a27b8245005905$export$2e2bcd8739ae039 = (0, $iUesJ.default)("Heart", [
    [
        "path",
        {
            d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
            key: "c3ymky"
        }
    ]
]);


parcelRequire("bh6RR");
parcelRequire("aWtcP");
var $i2TPN = parcelRequire("i2TPN");

var $qqvI6 = parcelRequire("qqvI6");
const $71be021be987ba70$export$a06f1c675e846f6f = (props)=>{
    const settings = (0, $i2TPN.useSelector)((0, $qqvI6.schema).settings.select);
    return /*#__PURE__*/ (0, $ih19M.jsx)("footer", {
        className: "bg-gray-50",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "text-base text-gray-500 hover:text-gray-900 flex justify-center",
                    children: [
                        "Made with",
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $87a27b8245005905$export$2e2bcd8739ae039), {
                            className: "px-1"
                        }),
                        "by",
                        ' ',
                        /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                            href: "https://www.jacobbolda.com",
                            className: "px-1",
                            children: "Jacob Bolda"
                        }),
                        ' ',
                        "and",
                        /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                            href: "https://github.com/jbolda/finatr/graphs/contributors",
                            className: "px-1",
                            children: "all our contributors"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("nav", {
                    className: "-mx-5 my-2 flex flex-wrap justify-center",
                    "aria-label": "Footer",
                    children: $71be021be987ba70$var$navigation.main.filter((item)=>settings[item.to] !== false).map((item)=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "px-5 py-2",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                href: item.to,
                                className: "text-base text-gray-500 hover:text-gray-900",
                                children: item.name
                            })
                        }, item.name))
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "mt-3 flex justify-center space-x-6",
                    children: $71be021be987ba70$var$navigation.social.map((item)=>/*#__PURE__*/ (0, $ih19M.jsxs)("a", {
                            href: item.to,
                            className: "text-gray-400 hover:text-gray-500",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    className: "sr-only",
                                    children: item.name
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)(item.icon, {
                                    className: "h-6 w-6",
                                    "aria-hidden": "true"
                                })
                            ]
                        }, item.name))
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "mt-8 flex justify-center space-x-6 text-base text-gray-500",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                        href: "https://www.netlify.com",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                            src: "https://www.netlify.com/img/global/badges/netlify-color-bg.svg",
                            alt: "Deploys by Netlify"
                        })
                    })
                })
            ]
        })
    });
};
const $71be021be987ba70$var$navigation = {
    main: [
        {
            name: 'Home',
            to: '/'
        },
        {
            name: 'Planning',
            to: '/planning'
        },
        {
            name: 'Cash Flow',
            to: '/flow'
        },
        {
            name: 'Import',
            to: '/import'
        }
    ],
    social: [
        {
            name: 'Twitter',
            to: 'https://www.twitter.com/jacobbolda',
            icon: (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    ...props,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
                    })
                })
        },
        {
            name: 'GitHub',
            to: 'https://github.com/jbolda/finatr',
            icon: (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    ...props,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
                        clipRule: "evenodd"
                    })
                })
        }
    ]
};



var $ih19M = parcelRequire("ih19M");
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $c8dad8f91598d0e6$export$2e2bcd8739ae039 = (0, $iUesJ.default)("ArrowLeftToLine", [
    [
        "path",
        {
            d: "M3 19V5",
            key: "rwsyhb"
        }
    ],
    [
        "path",
        {
            d: "m13 6-6 6 6 6",
            key: "1yhaz7"
        }
    ],
    [
        "path",
        {
            d: "M7 12h14",
            key: "uoisry"
        }
    ]
]);

/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $0ae400e02fb26b88$export$2e2bcd8739ae039 = (0, $iUesJ.default)("ArrowRightLeft", [
    [
        "path",
        {
            d: "m16 3 4 4-4 4",
            key: "1x1c3m"
        }
    ],
    [
        "path",
        {
            d: "M20 7H4",
            key: "zbl0bi"
        }
    ],
    [
        "path",
        {
            d: "m8 21-4-4 4-4",
            key: "h9nckh"
        }
    ],
    [
        "path",
        {
            d: "M4 17h16",
            key: "g4d7ey"
        }
    ]
]);

/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $6389970f15a0833e$export$2e2bcd8739ae039 = (0, $iUesJ.default)("ArrowRightToLine", [
    [
        "path",
        {
            d: "M17 12H3",
            key: "8awo09"
        }
    ],
    [
        "path",
        {
            d: "m11 18 6-6-6-6",
            key: "8c2y43"
        }
    ],
    [
        "path",
        {
            d: "M21 5v14",
            key: "nzette"
        }
    ]
]);

/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $2ef59ef99b9a1007$export$2e2bcd8739ae039 = (0, $iUesJ.default)("Banknote", [
    [
        "rect",
        {
            width: "20",
            height: "12",
            x: "2",
            y: "6",
            rx: "2",
            key: "9lu3g6"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "2",
            key: "1c9p78"
        }
    ],
    [
        "path",
        {
            d: "M6 12h.01M18 12h.01",
            key: "113zkx"
        }
    ]
]);

/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $4396b3fe8f77303a$export$2e2bcd8739ae039 = (0, $iUesJ.default)("ChartColumnIncreasing", [
    [
        "path",
        {
            d: "M13 17V9",
            key: "1fwyjl"
        }
    ],
    [
        "path",
        {
            d: "M18 17V5",
            key: "sfb6ij"
        }
    ],
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ],
    [
        "path",
        {
            d: "M8 17v-3",
            key: "17ska0"
        }
    ]
]);

/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $d1d73fbaac92efcf$export$2e2bcd8739ae039 = (0, $iUesJ.default)("ChartColumnStacked", [
    [
        "path",
        {
            d: "M11 13H7",
            key: "t0o9gq"
        }
    ],
    [
        "path",
        {
            d: "M19 9h-4",
            key: "rera1j"
        }
    ],
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ],
    [
        "rect",
        {
            x: "15",
            y: "5",
            width: "4",
            height: "12",
            rx: "1",
            key: "q8uenq"
        }
    ],
    [
        "rect",
        {
            x: "7",
            y: "8",
            width: "4",
            height: "9",
            rx: "1",
            key: "sr5ea"
        }
    ]
]);

/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $148d5f0341257ae1$export$2e2bcd8739ae039 = (0, $iUesJ.default)("HandCoins", [
    [
        "path",
        {
            d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17",
            key: "geh8rc"
        }
    ],
    [
        "path",
        {
            d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
            key: "1fto5m"
        }
    ],
    [
        "path",
        {
            d: "m2 16 6 6",
            key: "1pfhp9"
        }
    ],
    [
        "circle",
        {
            cx: "16",
            cy: "9",
            r: "2.9",
            key: "1n0dlu"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "5",
            r: "3",
            key: "151irh"
        }
    ]
]);

/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $3566773b8a02a237$export$2e2bcd8739ae039 = (0, $iUesJ.default)("Landmark", [
    [
        "line",
        {
            x1: "3",
            x2: "21",
            y1: "22",
            y2: "22",
            key: "j8o0r"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6",
            y1: "18",
            y2: "11",
            key: "10tf0k"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "18",
            y2: "11",
            key: "54lgf6"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "18",
            y2: "11",
            key: "380y"
        }
    ],
    [
        "line",
        {
            x1: "18",
            x2: "18",
            y1: "18",
            y2: "11",
            key: "1kevvc"
        }
    ],
    [
        "polygon",
        {
            points: "12 2 20 7 4 7",
            key: "jkujk7"
        }
    ]
]);

/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $c6dfa6c38518482e$export$2e2bcd8739ae039 = (0, $iUesJ.default)("Menu", [
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "12",
            y2: "12",
            key: "1e0a9i"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "6",
            y2: "6",
            key: "1owob3"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "18",
            y2: "18",
            key: "yk5zj1"
        }
    ]
]);

/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $53db815af926c0b5$export$2e2bcd8739ae039 = (0, $iUesJ.default)("NotebookText", [
    [
        "path",
        {
            d: "M2 6h4",
            key: "aawbzj"
        }
    ],
    [
        "path",
        {
            d: "M2 10h4",
            key: "l0bgd4"
        }
    ],
    [
        "path",
        {
            d: "M2 14h4",
            key: "1gsvsf"
        }
    ],
    [
        "path",
        {
            d: "M2 18h4",
            key: "1bu2t1"
        }
    ],
    [
        "rect",
        {
            width: "16",
            height: "20",
            x: "4",
            y: "2",
            rx: "2",
            key: "1nb95v"
        }
    ],
    [
        "path",
        {
            d: "M9.5 8h5",
            key: "11mslq"
        }
    ],
    [
        "path",
        {
            d: "M9.5 12H16",
            key: "ktog6x"
        }
    ],
    [
        "path",
        {
            d: "M9.5 16H14",
            key: "p1seyn"
        }
    ]
]);

/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $cee0bca87e3dca3a$export$2e2bcd8739ae039 = (0, $iUesJ.default)("Presentation", [
    [
        "path",
        {
            d: "M2 3h20",
            key: "91anmk"
        }
    ],
    [
        "path",
        {
            d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3",
            key: "2k9sn8"
        }
    ],
    [
        "path",
        {
            d: "m7 21 5-5 5 5",
            key: "bip4we"
        }
    ]
]);

/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $1f1bd77ebd3f1dbf$export$2e2bcd8739ae039 = (0, $iUesJ.default)("Settings", [
    [
        "path",
        {
            d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
            key: "1qme2f"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
]);

/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $iUesJ = parcelRequire("iUesJ");
const $fdac76f1ae78f089$export$2e2bcd8739ae039 = (0, $iUesJ.default)("TrendingUp", [
    [
        "polyline",
        {
            points: "22 7 13.5 15.5 8.5 10.5 2 17",
            key: "126l90"
        }
    ],
    [
        "polyline",
        {
            points: "16 7 22 7 22 13",
            key: "kwv8wd"
        }
    ]
]);



var $bh6RR = parcelRequire("bh6RR");

var $9cr7a = parcelRequire("9cr7a");
var $eqvPU = parcelRequire("eqvPU");
var $7jgDZ = parcelRequire("7jgDZ");
var $dgWhj = parcelRequire("dgWhj");

var $hAxtE = parcelRequire("hAxtE");
var $5Gawp = parcelRequire("5Gawp");
var $i91F7 = parcelRequire("i91F7");
var $bG0JH = parcelRequire("bG0JH");
var $hAxtE = parcelRequire("hAxtE");
var $gN5ZC = parcelRequire("gN5ZC");

var $6HV86 = parcelRequire("6HV86");

var $b3OV8 = parcelRequire("b3OV8");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $98b2e880c5197439$export$dcf14c9974fe2767(props, ref) {
    let { elementType: elementType = 'a', onPress: onPress, onPressStart: onPressStart, onPressEnd: onPressEnd, onClick: deprecatedOnClick, isDisabled: isDisabled, ...otherProps } = props;
    let linkProps = {};
    if (elementType !== 'a') linkProps = {
        role: 'link',
        tabIndex: !isDisabled ? 0 : undefined
    };
    let { focusableProps: focusableProps } = (0, $6HV86.useFocusable)(props, ref);
    let { pressProps: pressProps, isPressed: isPressed } = (0, $b3OV8.usePress)({
        onPress: onPress,
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        isDisabled: isDisabled,
        ref: ref
    });
    let domProps = (0, $bG0JH.filterDOMProps)(otherProps, {
        labelable: true
    });
    let interactionHandlers = (0, $hAxtE.mergeProps)(focusableProps, pressProps);
    let router = (0, $gN5ZC.useRouter)();
    let routerLinkProps = (0, $gN5ZC.useLinkProps)(props);
    return {
        isPressed: isPressed,
        linkProps: (0, $hAxtE.mergeProps)(domProps, routerLinkProps, {
            ...interactionHandlers,
            ...linkProps,
            'aria-disabled': isDisabled || undefined,
            'aria-current': props['aria-current'],
            onClick: (e)=>{
                var _pressProps_onClick;
                (_pressProps_onClick = pressProps.onClick) === null || _pressProps_onClick === void 0 || _pressProps_onClick.call(pressProps, e);
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn('onClick is deprecated, please use onPress');
                }
                // If a custom router is provided, prevent default and forward if this link should client navigate.
                if (!router.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
                !e.isDefaultPrevented() && (0, $gN5ZC.shouldClientNavigate)(e.currentTarget, e) && props.href) {
                    e.preventDefault();
                    router.open(e.currentTarget, e, props.href, props.routerOptions);
                }
            }
        })
    };
}



var $bh6RR = parcelRequire("bh6RR");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $533f31f98b7d57a6$export$e2509388b49734e7 = (0, $bh6RR.createContext)(null);
function $533f31f98b7d57a6$var$$4f118338184dc1d9$var$Link(props, ref) {
    [props, ref] = (0, $dgWhj.useContextProps)(props, ref, $533f31f98b7d57a6$export$e2509388b49734e7);
    let ElementType = props.href && !props.isDisabled ? 'a' : 'span';
    let { linkProps: linkProps, isPressed: isPressed } = (0, $98b2e880c5197439$export$dcf14c9974fe2767)({
        ...props,
        elementType: ElementType
    }, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $i91F7.useHover)(props);
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $5Gawp.useFocusRing)();
    let renderProps = (0, $dgWhj.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Link',
        values: {
            isCurrent: !!props['aria-current'],
            isDisabled: props.isDisabled || false,
            isPressed: isPressed,
            isHovered: isHovered,
            isFocused: isFocused,
            isFocusVisible: isFocusVisible
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ElementType, {
        ref: ref,
        slot: props.slot || undefined,
        ...(0, $hAxtE.mergeProps)(renderProps, linkProps, hoverProps, focusProps),
        "data-focused": isFocused || undefined,
        "data-hovered": isHovered || undefined,
        "data-pressed": isPressed || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-current": !!props['aria-current'] || undefined,
        "data-disabled": props.isDisabled || undefined
    }, renderProps.children);
}
/**
 * A link allows a user to navigate to another page or resource within a web page
 * or application.
 */ const $533f31f98b7d57a6$export$a6c7ac8248d6e38a = (0, $bh6RR.forwardRef)($533f31f98b7d57a6$var$$4f118338184dc1d9$var$Link);


var $eA2Db = parcelRequire("eA2Db");
var $6W801 = parcelRequire("6W801");
parcelRequire("aWtcP");
var $i2TPN = parcelRequire("i2TPN");

var $9SfKt = parcelRequire("9SfKt");

var $qqvI6 = parcelRequire("qqvI6");
const $f8e0a1c88805e08d$var$navigation = [
    {
        name: 'Examples',
        to: '/examples',
        icon: (0, $cee0bca87e3dca3a$export$2e2bcd8739ae039)
    },
    {
        name: 'Import/Export',
        to: '/import',
        icon: (0, $0ae400e02fb26b88$export$2e2bcd8739ae039)
    },
    {
        name: 'Accounts',
        to: '/accounts',
        icon: (0, $3566773b8a02a237$export$2e2bcd8739ae039)
    },
    {
        name: 'Transactions',
        to: '/transactions',
        icon: (0, $148d5f0341257ae1$export$2e2bcd8739ae039)
    },
    {
        name: 'FI',
        to: '/financialindependence',
        icon: (0, $fdac76f1ae78f089$export$2e2bcd8739ae039)
    },
    {
        name: 'Taxes',
        tag: 'alpha',
        to: '/taxes',
        icon: (0, $2ef59ef99b9a1007$export$2e2bcd8739ae039)
    }
];
const $f8e0a1c88805e08d$var$graphs = [
    {
        name: 'Planning',
        to: '/planning',
        icon: (0, $53db815af926c0b5$export$2e2bcd8739ae039)
    },
    {
        name: 'Cash Flow',
        to: '/flow',
        icon: (0, $d1d73fbaac92efcf$export$2e2bcd8739ae039)
    }
];
const $f8e0a1c88805e08d$var$sidebarCollapse = (0, $9SfKt.tv)({
    base: 'hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:flex-col',
    variants: {
        sidebar: {
            wide: 'lg:w-56',
            collapsed: 'lg:w-16'
        }
    }
});
const $f8e0a1c88805e08d$export$1e0197c05a154c40 = /*#__PURE__*/ (0, $bh6RR.createContext)({
    sidebar: 'wide',
    setSidebar: ()=>{}
});
function $f8e0a1c88805e08d$export$2e2bcd8739ae039() {
    const { sidebar: sidebar } = (0, $bh6RR.useContext)($f8e0a1c88805e08d$export$1e0197c05a154c40);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $f8e0a1c88805e08d$var$sidebarCollapse({
                    sidebar: sidebar
                }),
                children: /*#__PURE__*/ (0, $ih19M.jsx)($f8e0a1c88805e08d$var$SidebarContent, {
                    withHeader: true
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "sticky top-0 z-40 flex items-center gap-x-6 bg-gray-900 px-4 py-4 shadow-sm sm:px-6 lg:hidden",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $eA2Db.MenuTrigger), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9cr7a.Button), {
                                "aria-label": "Menu",
                                className: "-m-2.5 p-2.5 text-gray-400 lg:hidden",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "sr-only",
                                        children: "Open sidebar"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $c6dfa6c38518482e$export$2e2bcd8739ae039), {
                                        className: "size-6",
                                        "aria-hidden": "true"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $6W801.Popover), {
                                className: "relative z-50 lg:hidden transition-all duration-300 ease-linear",
                                crossOffset: -100,
                                containerPadding: 0,
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: "pointer-events-none fixed -z-40 inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)($f8e0a1c88805e08d$var$SidebarContent, {
                                        withHeader: false,
                                        forceSidebarState: "wide"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $533f31f98b7d57a6$export$a6c7ac8248d6e38a), {
                        href: "/",
                        className: "flex-1 text-sm/6 font-semibold text-white",
                        children: "Finatr"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $533f31f98b7d57a6$export$a6c7ac8248d6e38a), {
                        href: "/settings",
                        className: ()=>`flex items-center gap-x-4 px-6 py-3 text-sm/6 font-semibold text-white ${location.pathname === '/settings' ? 'bg-gray-800' : 'hover:bg-gray-800'}`,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1f1bd77ebd3f1dbf$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
}
const $f8e0a1c88805e08d$var$sidebarItem = (0, $9SfKt.tv)({
    base: 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
    variants: {
        link: {
            default: 'text-gray-400 hover:bg-gray-800 hover:text-white',
            selected: 'bg-gray-800 text-white'
        }
    }
});
function $f8e0a1c88805e08d$var$SidebarContent({ withHeader: withHeader = true, forceSidebarState: forceSidebarState }) {
    const { sidebar: sidebar, setSidebar: setSidebar } = (0, $bh6RR.useContext)($f8e0a1c88805e08d$export$1e0197c05a154c40);
    const sidebarWidth = forceSidebarState ?? sidebar;
    const settings = (0, $i2TPN.useSelector)((0, $qqvI6.schema).settings.select);
    const fullNavigation = [
        {
            name: null,
            id: 'records',
            children: $f8e0a1c88805e08d$var$navigation.filter((item)=>settings[item.to.substring(1)])
        },
        {
            name: 'Graphs',
            id: 'graphs',
            children: $f8e0a1c88805e08d$var$graphs.filter((item)=>settings[item.to.substring(1)])
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "flex grow flex-col gap-y-5 overflow-y-auto overflow-x-hidden bg-gray-900 pl-5",
        children: [
            withHeader ? /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex h-16 shrink-0 items-center",
                children: [
                    sidebarWidth === 'wide' ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $533f31f98b7d57a6$export$a6c7ac8248d6e38a), {
                                href: "/",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "sr-only",
                                        children: "Home"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $4396b3fe8f77303a$export$2e2bcd8739ae039), {
                                        color: "white",
                                        className: "h-8 w-auto"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "flex-1 text-sm/6 font-semibold text-white pl-3",
                                children: "Finatr"
                            })
                        ]
                    }) : null,
                    !forceSidebarState ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $9cr7a.Button), {
                        className: "pr-1 text-white bg-gray-900",
                        onPress: ()=>setSidebar((state)=>state === 'wide' ? 'collapsed' : 'wide'),
                        children: sidebarWidth === 'wide' ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $c8dad8f91598d0e6$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $6389970f15a0833e$export$2e2bcd8739ae039), {})
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ (0, $ih19M.jsxs)("nav", {
                className: "flex flex-1 flex-col py-1",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eA2Db.Menu), {
                        className: "-mx-2 space-y-1",
                        selectionMode: "single",
                        "aria-label": "navigation",
                        items: fullNavigation ?? settings,
                        selectedKeys: [
                            location.pathname
                        ],
                        dependencies: [
                            sidebarWidth
                        ],
                        children: (section)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $eA2Db.MenuSection), {
                                children: [
                                    section?.name ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $7jgDZ.Header), {
                                        className: "text-xs/6 font-semibold text-gray-400",
                                        children: section.name
                                    }) : null,
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $eqvPU.Collection), {
                                        items: section.children,
                                        children: (item)=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $eA2Db.MenuItem), {
                                                id: item.to,
                                                href: item.to,
                                                "aria-label": item.name,
                                                className: ()=>$f8e0a1c88805e08d$var$sidebarItem({
                                                        link: location.pathname === item.to ? 'selected' : 'default'
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)(item.icon, {
                                                        "aria-hidden": "true",
                                                        className: "size-6 shrink-0"
                                                    }),
                                                    sidebarWidth === 'wide' ? item.name : null,
                                                    sidebarWidth === 'wide' && item?.tag ? /*#__PURE__*/ (0, $ih19M.jsx)("sup", {
                                                        children: item.tag
                                                    }) : null
                                                ]
                                            })
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "-mx-6 mt-auto",
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $533f31f98b7d57a6$export$a6c7ac8248d6e38a), {
                            href: "/settings",
                            className: ()=>`flex items-center gap-x-4 px-6 py-3 text-sm/6 font-semibold text-white ${location.pathname === '/settings' ? 'bg-gray-800' : 'hover:bg-gray-800'}`,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1f1bd77ebd3f1dbf$export$2e2bcd8739ae039), {}),
                                sidebarWidth === 'wide' ? /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    children: "Settings"
                                }) : null
                            ]
                        })
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $99w1R = parcelRequire("99w1R");
parcelRequire("aWtcP");
var $i2TPN = parcelRequire("i2TPN");

var $qqvI6 = parcelRequire("qqvI6");

var $8Nljb = parcelRequire("8Nljb");

var $7BL3D = parcelRequire("7BL3D");

var $2dBzU = parcelRequire("2dBzU");
const $2362f8b24b7bedef$var$useSelector = (0, $i2TPN.useSelector);
const $2362f8b24b7bedef$var$AccountView = ()=>{
    const { id: id } = (0, $99w1R.useParams)();
    const account = id ? $2362f8b24b7bedef$var$useSelector((s)=>(0, $qqvI6.schema).accounts.selectById(s, {
            id: id
        })) : undefined;
    const transactions = id ? $2362f8b24b7bedef$var$useSelector((s)=>(0, $8Nljb.transactionsByAccountId)(s, id)) : undefined;
    if (!account || !transactions) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        children: "Account not found"
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("h1", {
                className: "text-3xl font-semibold",
                children: [
                    "Account ",
                    account.name
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("p", {
                children: [
                    "Balance: ",
                    (0, $7BL3D.toHumanCurrency)(account.starting)
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                className: "text-xl pt-8",
                children: "Related Transactions"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2dBzU.default), {
                transactions: transactions
            })
        ]
    });
};
var $2362f8b24b7bedef$export$2e2bcd8739ae039 = $2362f8b24b7bedef$var$AccountView;



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("aWtcP");
var $cPVO8 = parcelRequire("cPVO8");

var $i4Ato = parcelRequire("i4Ato");
var $598a966db9611d16$exports = {};
$598a966db9611d16$exports = JSON.parse("{\"transactions\":[{\"id\":\"b59b562a-321a-45a6-964c-c1cb0232311a\",\"raccount\":\"080f8f3a-a7d7-463c-b5ce-008d89f5c2e5\",\"description\":\"beginning of month\",\"category\":\"paycheck\",\"type\":\"income\",\"start\":\"YYYY-01-01\",\"rtype\":\"day of month\",\"cycle\":1,\"value\":2800},{\"id\":\"23df0d4b-7cd4-4840-8be4-c58deb85f8ce\",\"raccount\":\"080f8f3a-a7d7-463c-b5ce-008d89f5c2e5\",\"description\":\"middle of month\",\"category\":\"paycheck\",\"type\":\"income\",\"start\":\"YYYY-01-01\",\"rtype\":\"day of month\",\"cycle\":15,\"value\":2800},{\"id\":\"15206ac6-7bca-4511-84ed-f35529f9b40d\",\"raccount\":\"080f8f3a-a7d7-463c-b5ce-008d89f5c2e5\",\"description\":\"rent, electric and water\",\"category\":\"rent\",\"type\":\"expense\",\"start\":\"YYYY-01-05\",\"rtype\":\"day of month\",\"cycle\":5,\"value\":3200},{\"id\":\"5c58e080-709e-4d86-9c14-55aa06749359\",\"raccount\":\"2cb6ba86-0e12-4283-ad95-09f9370e279a\",\"description\":\"beginning of month\",\"category\":\"retirement\",\"type\":\"income\",\"start\":\"YYYY-01-01\",\"rtype\":\"day of month\",\"cycle\":1,\"value\":200},{\"id\":\"34353fff-1565-47ff-a860-92d330ac4919\",\"raccount\":\"2cb6ba86-0e12-4283-ad95-09f9370e279a\",\"description\":\"middle of month\",\"category\":\"retirement\",\"type\":\"income\",\"start\":\"YYYY-01-01\",\"rtype\":\"day of month\",\"cycle\":15,\"value\":200},{\"id\":\"e5ef2fa9-e89b-43d5-8029-5849ab9d7952\",\"raccount\":\"cd182267-5437-4c7d-8f17-515ef1f091f8\",\"description\":\"internet\",\"category\":\"internet\",\"type\":\"expense\",\"start\":\"YYYY-01-05\",\"rtype\":\"day of month\",\"cycle\":5,\"value\":80},{\"id\":\"1590c1cf-0bae-44ea-84b3-165b5ca63cee\",\"raccount\":\"080f8f3a-a7d7-463c-b5ce-008d89f5c2e5\",\"description\":\"student loans\",\"category\":\"student loans\",\"type\":\"expense\",\"start\":\"YYYY-01-20\",\"rtype\":\"day of month\",\"cycle\":20,\"value\":400},{\"id\":\"29993d5c-c7b8-4ea9-be6c-31419e5a7b12\",\"raccount\":\"cd182267-5437-4c7d-8f17-515ef1f091f8\",\"description\":\"groceries\",\"category\":\"groceries\",\"type\":\"expense\",\"start\":\"YYYY-01-01\",\"rtype\":\"day of week\",\"cycle\":1,\"value\":150},{\"id\":\"ce42454e-09c0-47d4-b24a-9f528e27e0b3\",\"raccount\":\"cd182267-5437-4c7d-8f17-515ef1f091f8\",\"description\":\"going out\",\"category\":\"going out\",\"type\":\"expense\",\"start\":\"YYYY-01-01\",\"rtype\":\"day of week\",\"cycle\":5,\"value\":80},{\"id\":\"cb5a5564-0cf5-4da7-a11c-681302e43760\",\"raccount\":\"cd182267-5437-4c7d-8f17-515ef1f091f8\",\"description\":\"metro card\",\"category\":\"transportation\",\"type\":\"expense\",\"start\":\"YYYY-01-01\",\"rtype\":\"day of month\",\"cycle\":5,\"value\":200},{\"id\":\"c7ea3f5c-95f0-4fc5-915a-9e4ade4ebfa2\",\"raccount\":\"cd182267-5437-4c7d-8f17-515ef1f091f8\",\"description\":\"cell phone\",\"category\":\"cell phone\",\"type\":\"expense\",\"start\":\"YYYY-01-01\",\"rtype\":\"day of month\",\"cycle\":2,\"value\":100},{\"id\":\"c6add7c9-26ef-4f40-94b4-49bbaa5fa3c7\",\"raccount\":\"cd182267-5437-4c7d-8f17-515ef1f091f8\",\"description\":\"fun\",\"category\":\"fun\",\"type\":\"expense\",\"start\":\"YYYY-01-01\",\"rtype\":\"day of week\",\"cycle\":4,\"value\":50}],\"accounts\":[{\"id\":\"2cb6ba86-0e12-4283-ad95-09f9370e279a\",\"name\":\"IRA\",\"starting\":50000,\"interest\":8,\"vehicle\":\"investment\",\"visible\":false},{\"id\":\"080f8f3a-a7d7-463c-b5ce-008d89f5c2e5\",\"name\":\"checking\",\"starting\":4000,\"interest\":0,\"vehicle\":\"operating\",\"visible\":true},{\"id\":\"cd182267-5437-4c7d-8f17-515ef1f091f8\",\"name\":\"credit card\",\"starting\":1200,\"interest\":0,\"vehicle\":\"credit line\",\"visible\":true,\"payback\":{\"category\":\"credit card payment\",\"transactions\":[{\"description\":\"pay off current balance\",\"debtAccount\":\"credit card\",\"raccount\":\"080f8f3a-a7d7-463c-b5ce-008d89f5c2e5\",\"start\":\"YYYY-02-15\",\"rtype\":\"day of month\",\"cycle\":15,\"occurrences\":1,\"value\":0,\"computedAmount\":{\"reference\":\"starting\"},\"id\":\"d26ae14c-2f33-46e7-8122-b2b849e43a5b\"},{\"description\":\"pay off future expenses\",\"debtAccount\":\"credit card\",\"raccount\":\"080f8f3a-a7d7-463c-b5ce-008d89f5c2e5\",\"start\":\"YYYY-02-15\",\"rtype\":\"day of month\",\"cycle\":15,\"beginAfterOccurrences\":1,\"value\":1500,\"id\":\"e526deda-0cce-4c40-9a32-49766932c14c\"}]}}]}");


var $d6b07b0795391f98$exports = {};
$d6b07b0795391f98$exports = JSON.parse("{\"transactions\":[{\"id\":\"ce42454e-09c0-47d4-b24a-9f528e27e0b3\",\"raccount\":\"f87a4199-8fb2-42e8-854c-d30dc8dd58e5\",\"description\":\"bi-weekly paycheck\",\"category\":\"paycheck\",\"type\":\"income\",\"start\":\"YYYY-01-01\",\"rtype\":\"day\",\"cycle\":14,\"value\":1500},{\"id\":\"bf757794-5e33-406a-a510-c33bf9814755\",\"raccount\":\"f87a4199-8fb2-42e8-854c-d30dc8dd58e5\",\"description\":\"monthly rent\",\"category\":\"rent\",\"type\":\"expense\",\"start\":\"YYYY-01-01\",\"rtype\":\"day of month\",\"cycle\":1,\"value\":700}],\"accounts\":[{\"id\":\"f87a4199-8fb2-42e8-854c-d30dc8dd58e5\",\"name\":\"account\",\"starting\":400,\"interest\":{\"amount\":2000,\"scale\":2},\"vehicle\":\"operating\",\"visible\":true}]}");


const $3baefdd682d02482$var$listOfExamples = [
    {
        name: 'Simple Example',
        content: `
    This is a real simple example where you get paid every two weeks.
    Your only expense is paying rent once a month. Wouldn't that be nice!
    `,
        file: (0, (/*@__PURE__*/$parcel$interopDefault($d6b07b0795391f98$exports)))
    },
    {
        name: 'High Housing Expenses',
        content: `
    This example shows what living in San Francisco, Silicon Valley,
    or Washington DC may look like. You get paid well relative to the
    rest of the country, but most of that goes to living expenses.
    You only have one source of income, but a decent salary nonetheless.
    You carry a credit card, and pay your other expenses with that.
    `,
        file: (0, (/*@__PURE__*/$parcel$interopDefault($598a966db9611d16$exports)))
    }
];
const $3baefdd682d02482$var$Examples = ()=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "relative max-w-lg mx-auto divide-y-2 divide-gray-200 lg:max-w-7xl",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($3baefdd682d02482$var$ExampleHeading, {}),
            /*#__PURE__*/ (0, $ih19M.jsx)($3baefdd682d02482$var$ExampleList, {
                listOfExamples: $3baefdd682d02482$var$listOfExamples
            })
        ]
    });
var $3baefdd682d02482$export$2e2bcd8739ae039 = $3baefdd682d02482$var$Examples;
const $3baefdd682d02482$var$ExampleHeading = ()=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("h1", {
                className: "text-3xl font-semibold",
                children: "Examples"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "mt-3 sm:mt-4 lg:grid lg:grid-cols-2 lg:gap-5 lg:items-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    className: "text-xl text-gray-500",
                    children: "The following are various examples that you can test out. They are even valuable as a template to get you jump-started. Find one that seems to match your current situation? Give it a shot and see what it looks like. You can always come back here and try another."
                })
            })
        ]
    });
const $3baefdd682d02482$var$ExampleList = ({ listOfExamples: listOfExamples })=>{
    const dispatch = (0, $cPVO8.useDispatch)();
    const navigate = (0, $99w1R.useNavigate)();
    const loadExample = async (json)=>{
        const today = new Date();
        const jsonModified = {
            accounts: json.accounts,
            transactions: json.transactions.map((d)=>({
                    ...d,
                    start: d.start.replace('YYYY', today.getFullYear())
                }))
        };
        console.log('example loaded', jsonModified);
        dispatch((0, $i4Ato.importEntries)(jsonModified));
        navigate(`/planning`);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "mt-6 pt-10 grid gap-16 lg:grid-cols-2 lg:gap-x-5 lg:gap-y-12",
        children: listOfExamples.map((example)=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                        className: "mt-2 block text-left",
                        onClick: (event)=>loadExample(event),
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                    className: "text-xl font-semibold text-gray-900",
                                    children: example.name
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                    className: "mt-3 text-base text-gray-500",
                                    children: example.content
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                            className: "text-base font-semibold text-indigo-600 hover:text-indigo-500",
                            onClick: (event)=>loadExample(example.file),
                            children: `Load Example ->`
                        })
                    })
                ]
            }, example.name))
    });
};



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $10WBQ = parcelRequire("10WBQ");
const $b429779cebeac9bf$var$Homepage = ()=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($b429779cebeac9bf$var$Hero, {}),
            /*#__PURE__*/ (0, $ih19M.jsx)($b429779cebeac9bf$var$Features, {})
        ]
    });
var $b429779cebeac9bf$export$2e2bcd8739ae039 = $b429779cebeac9bf$var$Homepage;
function $b429779cebeac9bf$var$Hero() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "relative isolate px-6 pt-14 lg:px-8",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    "aria-hidden": "true",
                    className: "pointer-events-none absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        style: {
                            clipPath: 'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)'
                        },
                        className: "relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-cyan-700 to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "mx-auto max-w-2xl py-32 sm:py-48 lg:py-56",
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("h1", {
                                className: "text-balance text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "block xl:inline",
                                        children: "helping you"
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "block text-indigo-600 xl:inline",
                                        children: "analyze your future"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                className: "mt-8 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8",
                                children: "Plan for your future financial events and adeptly route your path forward."
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "mt-10 flex items-center justify-center gap-x-6",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $10WBQ.Link), {
                                        to: "planning",
                                        className: "rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                                        children: "Get started"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $10WBQ.Link), {
                                        to: "examples",
                                        className: "text-sm/6 font-semibold text-gray-900",
                                        children: [
                                            "Examples ",
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                "aria-hidden": "true",
                                                children: "\u2192"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    "aria-hidden": "true",
                    className: "pointer-events-none absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        style: {
                            clipPath: 'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)'
                        },
                        className: "relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-cyan-700 to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
                    })
                })
            ]
        })
    });
}
function $b429779cebeac9bf$var$Features() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "bg-white py-24 sm:py-32",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                    className: "text-base/7 font-semibold text-indigo-600",
                    children: "stop focusing on the past"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    className: "mt-2 max-w-lg text-pretty text-4xl font-semibold tracking-tight text-gray-950 sm:text-5xl",
                    children: "Design your decisions to fund your future"
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "mt-10 grid grid-cols-1 gap-4 sm:mt-16 lg:grid-cols-6 lg:grid-rows-2",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "relative lg:col-span-3",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "absolute inset-px rounded-lg bg-white max-lg:rounded-t-[2rem] lg:rounded-tl-[2rem]"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-t-[calc(2rem+1px)] lg:rounded-tl-[calc(2rem+1px)]",
                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "p-10 pt-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                                                className: "text-sm/4 font-semibold text-indigo-600",
                                                children: "Plan"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: "mt-2 text-lg font-medium tracking-tight text-gray-950",
                                                children: "Lay Out Your Transactions"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: "mt-2 max-w-lg text-sm/6 text-gray-600",
                                                children: "List out your transactions and how often their occur. We can anticipate your future account balances and derive insights. That milestone coming up? Let's celebrate it! Oh, there may be a low balance, should we make an adjustment?"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-t-[2rem] lg:rounded-tl-[2rem]"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "relative lg:col-span-3",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "absolute inset-px rounded-lg bg-white lg:rounded-tr-[2rem]"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-tr-[calc(2rem+1px)]",
                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "p-10 pt-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                                                className: "text-sm/4 font-semibold text-indigo-600",
                                                children: "Update"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: "mt-2 text-lg font-medium tracking-tight text-gray-950",
                                                children: "View Expected Account Balances"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: "mt-2 max-w-lg text-sm/6 text-gray-600",
                                                children: "If we know your account balances and transactions, we can project your future balances as well! Imagine knowing early if your account will dip below zero. Let's fix that before you are charged fees."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 lg:rounded-tr-[2rem]"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "relative lg:col-span-2",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "absolute inset-px rounded-lg bg-white lg:rounded-bl-[2rem]"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-bl-[calc(2rem+1px)]",
                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "p-10 pt-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                                                className: "text-sm/4 font-semibold text-indigo-600",
                                                children: "Speed"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: "mt-2 text-lg font-medium tracking-tight text-gray-950",
                                                children: "Ready for power users"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: "mt-2 max-w-lg text-sm/6 text-gray-600",
                                                children: "Finatr is open-source. Interested in a feature? Let's discuss. Want customizable reports and views? Let's start hacking!"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 lg:rounded-bl-[2rem]"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "relative lg:col-span-2",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "absolute inset-px rounded-lg bg-white"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)]",
                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "p-10 pt-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                                                className: "text-sm/4 font-semibold text-indigo-600",
                                                children: "Privacy"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: "mt-2 text-lg font-medium tracking-tight text-gray-950",
                                                children: "Own your data"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: "mt-2 max-w-lg text-sm/6 text-gray-600",
                                                children: "Finatr is being built with local-first principles. This includes offline support, and control of your data. Freely download and upload your data at any time. We don't save or access your data."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "relative lg:col-span-2",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "absolute inset-px rounded-lg bg-white max-lg:rounded-b-[2rem] lg:rounded-br-[2rem]"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-b-[calc(2rem+1px)] lg:rounded-br-[calc(2rem+1px)]",
                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "p-10 pt-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                                                className: "text-sm/4 font-semibold text-indigo-600",
                                                children: "FI"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: "mt-2 text-lg font-medium tracking-tight text-gray-950",
                                                children: "Confidentally Build For Financial Independence (FI)"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: "mt-2 max-w-lg text-sm/6 text-gray-600",
                                                children: 'The root ideals of "Financial Independence" point towards providing confience, leverage, and options. Knowing your future balances and investing to meet goals gives you confidence in your decisions, and leverage and options with your career.'
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-b-[2rem] lg:rounded-br-[2rem]"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");
parcelRequire("aWtcP");
var $i2TPN = parcelRequire("i2TPN");

var $8Nljb = parcelRequire("8Nljb");

var $2dBzU = parcelRequire("2dBzU");
const $5366f8eb919980f7$var$TransactionsOverview = ()=>{
    const transactions = (0, $i2TPN.useSelector)((0, $8Nljb.transactionsWithAccounts));
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("h1", {
                className: "text-3xl font-semibold",
                children: "Transactions"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2dBzU.default), {
                transactions: transactions
            })
        ]
    });
};
var $5366f8eb919980f7$export$2e2bcd8739ae039 = $5366f8eb919980f7$var$TransactionsOverview;



var $qqvI6 = parcelRequire("qqvI6");

const $8e5e18fbbe33c793$var$Settings = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("dTGcU")));

const $8e5e18fbbe33c793$var$Financial = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("6smLu")));

const $8e5e18fbbe33c793$var$Accounts = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("csDxh")));

const $8e5e18fbbe33c793$var$AccountsContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("bNAqU")));

const $8e5e18fbbe33c793$var$AccountInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("jjSgE")));

const $8e5e18fbbe33c793$var$TransactionsContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("kz8rh")));

const $8e5e18fbbe33c793$var$TransactionInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("6CBuk")));

const $8e5e18fbbe33c793$var$Planning = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("jEvCB")));

const $8e5e18fbbe33c793$var$FinancialIndependence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("9UHRn")));

const $8e5e18fbbe33c793$var$Importing = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("jGWx2")));

const $8e5e18fbbe33c793$var$Taxes = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("9YDuP")));
function $8e5e18fbbe33c793$var$FeatureFlag({ flag: flag, children: children }) {
    if (flag) return children;
    return /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$NoMatch, {});
}
function $8e5e18fbbe33c793$var$AppWrapper({ children: children }) {
    const [sidebar, setSidebarState] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState('wide');
    const navigate = (0, $99w1R.useNavigate)();
    const setSidebar = (0, $bh6RR.useCallback)((args)=>setSidebarState(args), []);
    const sidebarContextValue = (0, $bh6RR.useMemo)(()=>({
            sidebar: sidebar,
            setSidebar: setSidebar
        }), [
        sidebar,
        setSidebar
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $gN5ZC.RouterProvider), {
        navigate: navigate,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $f8e0a1c88805e08d$export$1e0197c05a154c40).Provider, {
            value: sidebarContextValue,
            children: children
        })
    });
}
const $8e5e18fbbe33c793$var$sidebarMain = (0, $9SfKt.tv)({
    base: 'grow py-10',
    variants: {
        sidebar: {
            wide: 'lg:pl-56',
            collapsed: 'lg:pl-16'
        }
    }
});
function $8e5e18fbbe33c793$var$App({ supabase: supabase }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)($8e5e18fbbe33c793$var$AppWrapper, {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $f8e0a1c88805e08d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$Main, {
                supabase: supabase
            })
        ]
    });
}
function $8e5e18fbbe33c793$var$Main({ supabase: supabase }) {
    const { sidebar: sidebar } = (0, $bh6RR.useContext)((0, $f8e0a1c88805e08d$export$1e0197c05a154c40));
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "flex flex-col min-h-screen",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("main", {
                className: $8e5e18fbbe33c793$var$sidebarMain({
                    sidebar: sidebar
                }),
                children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "px-4 sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$Routes, {
                        supabase: supabase
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $71be021be987ba70$export$a06f1c675e846f6f), {})
        ]
    });
}
function $8e5e18fbbe33c793$var$Routes({ supabase: supabase }) {
    const auth = (0, $i2TPN.useSelector)((0, $qqvI6.schema).auth.select);
    const settings = (0, $i2TPN.useSelector)((0, $qqvI6.schema).settings.select);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $99w1R.Routes), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                index: true,
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b429779cebeac9bf$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                path: "examples",
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3baefdd682d02482$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                path: "auth",
                element: supabase && !auth.user ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $b2e80c6a87ef7ea1$export$334c29725a78c21d), {
                    supabaseClient: supabase,
                    appearance: {
                        theme: (0, $fbb3f532a915e7a3$export$1efbf737de6c4d31)
                    }
                }) : /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: "Logged in!"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                path: "settings",
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                        children: "..."
                    }),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$Settings, {})
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                path: "flow",
                element: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$FeatureFlag, {
                    flag: settings.flow,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                        fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                            children: "..."
                        }),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$Financial, {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $99w1R.Route), {
                path: "accounts",
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                        children: "..."
                    }),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$AccountsContainer, {})
                }),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                        index: true,
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                            fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                                children: "..."
                            }),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$Accounts, {})
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                        path: "set",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                            fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                                children: "..."
                            }),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$AccountInput, {})
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                        path: "view/:id",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                            fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                                children: "..."
                            }),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2362f8b24b7bedef$export$2e2bcd8739ae039), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $99w1R.Route), {
                path: "transactions",
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                        children: "..."
                    }),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$TransactionsContainer, {})
                }),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                        index: true,
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                            fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                                children: "..."
                            }),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5366f8eb919980f7$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                        path: "set",
                        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                            fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                                children: "..."
                            }),
                            children: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$TransactionInput, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                path: "planning",
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                        children: "..."
                    }),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$Planning, {})
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                path: "financialindependence",
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                        children: "..."
                    }),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$FinancialIndependence, {})
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                path: "import",
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                        children: "..."
                    }),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$Importing, {})
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                path: "taxes",
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Suspense, {
                    fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                        children: "..."
                    }),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$Taxes, {})
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $99w1R.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, $ih19M.jsx)($8e5e18fbbe33c793$var$NoMatch, {})
            })
        ]
    });
}
function $8e5e18fbbe33c793$var$NoMatch() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                children: "Nothing to see here!"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $10WBQ.Link), {
                    to: "/",
                    children: "Go to the home page"
                })
            })
        ]
    });
}
var /*
Sticky footer relies on flex where the default is 0 1 auto
for flex-grow, flex-shrink and flex-basis, respectively.
We set flex-grow=1 for the center div at a minHeight flexbox
98vh (account for browser margins) which sticks the footer
to the bottom of the page.
*/ $8e5e18fbbe33c793$export$2e2bcd8739ae039 = $8e5e18fbbe33c793$var$App;



var $qqvI6 = parcelRequire("qqvI6");
parcelRequire("9St7S");
var $15Qbp = parcelRequire("15Qbp");
var $1lCWl = parcelRequire("1lCWl");
var $kfNOd = parcelRequire("kfNOd");
var $8Qg8J = parcelRequire("8Qg8J");
var $2EoHU = parcelRequire("2EoHU");
var $bXLEQ = parcelRequire("bXLEQ");
var $krVVU = parcelRequire("krVVU");
var $eAyML = parcelRequire("eAyML");

var $qqvI6 = parcelRequire("qqvI6");

var $bDrX3 = parcelRequire("bDrX3");
parcelRequire("9St7S");
var $8Qg8J = parcelRequire("8Qg8J");
var $6wugg = parcelRequire("6wugg");
var $krVVU = parcelRequire("krVVU");
function $b3e9d883d71c5099$export$317f995a867c35a3(options) {
    return function* setup() {
        const extension = window.__REDUX_DEVTOOLS_EXTENSION__;
        if (options.enabled !== false && extension) {
            const { name: name, store: store } = options;
            const dt = yield* $b3e9d883d71c5099$var$setupDevTools({
                name: name,
                store: store,
                extension: extension
            });
            while(true){
                const action = yield* (0, $krVVU.take)('*');
                yield* dt.send(action);
            }
        }
    };
}
function $b3e9d883d71c5099$var$setupDevTools(options) {
    return (0, $6wugg.resource)(function*(provide) {
        // https://github.com/reduxjs/redux-devtools/blob/main/extension/src/pageScript/index.ts
        const { name: name = 'starfx', store: store, extension: extension } = options;
        const opts = {
            name: name,
            hostname: 'localhost',
            port: 9555,
            autoReconnect: true,
            disconnectOnUnload: true
        };
        yield* (0, $8Qg8J.ensure)(()=>{
            extension.disconnect();
        });
        const devToolsInstance = extension.connect(opts);
        // Initialize the DevTools instance with the initial state
        devToolsInstance.init(store.getState());
        // Return the DevTools instance for later use
        yield* provide({
            send: function*(action) {
                devToolsInstance.send(action, store.getState());
            }
        });
    });
}



var $6rtue = parcelRequire("6rtue");
var $5EWGz = parcelRequire("5EWGz");

var $kPdv0 = parcelRequire("kPdv0");
const $018ea07a6b68e4f7$var$devtoolsEnabled = true;
function $018ea07a6b68e4f7$export$281a42ec42dc777b({ logs: logs = true, initialState: initialState = {}, supabase: supabase }) {
    const localPersistor = (0, $1lCWl.createPersistor)({
        key: 'finatr',
        adapter: (0, $1lCWl.createLocalStorageAdapter)(),
        reconciler: (0, $kPdv0.reconcilerWithReconstitution),
        allowlist: [
            'settings',
            'chartRange',
            'accounts',
            'transactions',
            'incomeReceived',
            'incomeExpected'
        ]
    });
    const store = (0, $kfNOd.createStore)({
        initialState: {
            ...(0, $qqvI6.initialState),
            ...initialState
        },
        middleware: [
            (0, $1lCWl.persistStoreMdw)(localPersistor),
            $018ea07a6b68e4f7$var$persistDBMdw(supabase)
        ]
    });
    if (supabase) supabase.channel('schema-db-changes').on('postgres_changes', {
        event: '*',
        schema: 'public'
    }, (payload)=>{
        console.log(payload);
    //   {
    //     "schema": "public",
    //     "table": "accounts",
    //     "commit_timestamp": "2024-10-12T08:13:44.729Z",
    //     "eventType": "INSERT",
    //     "new": {
    //         "id": "f87a4199-8fb2-42e8-854c-d30dc8dd58e5",
    //         "interest": {
    //             "amount": 2000,
    //             "scale": 2
    //         },
    //         "name": "account",
    //         "starting": {
    //             "amount": 40000,
    //             "currency": {
    //                 "base": 10,
    //                 "code": "USD",
    //                 "exponent": 2
    //             },
    //             "scale": 2
    //         },
    //         "user_id": "d3ff1312-1dd9-4487-8b0c-bc0b4d21014a",
    //         "vehicle": "operating",
    //         "visible": true
    //     },
    //     "old": {},
    //     "errors": null
    // }
    }).subscribe();
    const tsks = [];
    if (logs) // log all actions dispatched
    tsks.push(function* logActions() {
        while(true){
            const action = yield* (0, $krVVU.take)('*');
            console.log(action);
        }
    });
    tsks.push(function* auth() {
        if (!supabase) return;
        const auth = yield* (0, $15Qbp.call)(supabase.auth.getSession());
        if (auth.data?.session) yield* (0, $krVVU.put)((0, $bDrX3.updateAuth)([
            (0, $qqvI6.schema).auth.set(auth.data.session)
        ]));
        const { data: data } = supabase.auth.onAuthStateChange((_event, session)=>{
            store.dispatch((0, $bDrX3.updateAuth)([
                (0, $qqvI6.schema).auth.set(session ? session : {
                    user: null
                })
            ]));
        });
        yield* (0, $8Qg8J.ensure)(()=>data.subscription.unsubscribe());
        yield* (0, $krVVU.take)('auth:session');
        // only on first auth, rehydrate
        yield* $018ea07a6b68e4f7$var$dbRehydrate(supabase);
        // really suspend, no other good way right now? need an effection upgrade?
        while(true)yield* (0, $krVVU.take)('auth:session');
    }, (0, $5EWGz.thunks).bootup, (0, $b3e9d883d71c5099$export$317f995a867c35a3)({
        name: 'finatr',
        store: store,
        enabled: $018ea07a6b68e4f7$var$devtoolsEnabled
    }), ...(0, $6rtue.tasks));
    store.run(function*() {
        yield* localPersistor.rehydrate();
        const group = yield* (0, $bXLEQ.parallel)(tsks);
        yield* (0, $qqvI6.schema).update((0, $qqvI6.schema).loaders.success({
            id: (0, $1lCWl.PERSIST_LOADER_ID)
        }));
        yield* group;
    });
    return store;
}
function* $018ea07a6b68e4f7$var$dbRehydrate(supabase) {
    try {
        const state = yield* (0, $eAyML.select)((s)=>s);
        // @ts-expect-error
        if (!state.auth.user) return;
        // @ts-expect-error
        const { data: transactionArray, error: transactionsError } = yield* (0, $15Qbp.call)(// @ts-expect-error
        supabase.from('transactions').select());
        // @ts-expect-error
        const { data: accountArray, error: accountsError } = yield* (0, $15Qbp.call)(// @ts-expect-error
        supabase.from('accounts').select());
        const stateFromStorage = {
            transactions: transactionArray.reduce((o, t)=>{
                o[t.id] = t;
                return o;
            }, {}),
            accounts: accountArray.reduce((o, t)=>{
                o[t.id] = t;
                return o;
            }, {})
        };
        const nextState = (0, $kPdv0.reconcilerWithReconstitution)(state, stateFromStorage);
        yield* (0, $eAyML.updateStore)(function(state) {
            Object.keys(nextState).forEach((key)=>{
                state[key] = nextState[key];
            });
        });
        return (0, $2EoHU.Ok)(undefined);
    } catch (error) {
        return (0, $2EoHU.Err)(error);
    }
}
const $018ea07a6b68e4f7$var$PATCH_REPLACE = 'replace';
const $018ea07a6b68e4f7$var$PATCH_ADD = 'add';
const $018ea07a6b68e4f7$var$PATCH_REMOVE = 'remove';
const $018ea07a6b68e4f7$var$dbAllowlist = [
    'accounts',
    'transactions'
];
function $018ea07a6b68e4f7$var$persistDBMdw(supabase) {
    return function*(update, next) {
        yield* next();
        if (!supabase) return;
        // cheap check as we likely only want to handle a single record here
        // avoid persist and otherwise updates
        if (update.patches.length > 3) return;
        const state = yield* (0, $eAyML.select)((s)=>s);
        if (!state?.auth?.user) return;
        for (let patch of update.patches){
            const table = patch.path[0];
            if ($018ea07a6b68e4f7$var$dbAllowlist.includes(table)) try {
                switch(patch.op){
                    case $018ea07a6b68e4f7$var$PATCH_ADD:
                        const data = $018ea07a6b68e4f7$var$staticalize(table, patch.value);
                        // @ts-expect-error its really a promise
                        yield* (0, $15Qbp.call)(supabase.from(table).upsert(data));
                        break;
                    case $018ea07a6b68e4f7$var$PATCH_REPLACE:
                        if (patch.path[1]) {
                            const data = $018ea07a6b68e4f7$var$staticalize(table, patch.value);
                            // @ts-expect-error its really a promise
                            yield* (0, $15Qbp.call)(supabase.from(table).upsert(data));
                        }
                        break;
                    case $018ea07a6b68e4f7$var$PATCH_REMOVE:
                        if (patch.path[1]) yield* (0, $15Qbp.call)(// @ts-expect-error its really a promise
                        supabase.from(table).delete().eq('id', patch.path[1]));
                        break;
                }
            } catch (error) {
                console.warn(error);
            }
        }
    };
}
const $018ea07a6b68e4f7$var$staticalize = (table, item)=>{
    const jsonify = JSON.parse(JSON.stringify(item));
    return jsonify;
};


const $d0bb92445f8cf837$var$supabaseUrl = undefined;
const $d0bb92445f8cf837$var$supabaseKey = undefined;
const $d0bb92445f8cf837$var$supabase = !$d0bb92445f8cf837$var$supabaseUrl || !$d0bb92445f8cf837$var$supabaseKey ? null : (0, $5a1fcc18818239b9$export$5d730b7aed1a3eb0)($d0bb92445f8cf837$var$supabaseUrl, $d0bb92445f8cf837$var$supabaseKey);
const $d0bb92445f8cf837$var$store = (0, $018ea07a6b68e4f7$export$281a42ec42dc777b)({
    logs: true,
    initialState: {},
    supabase: $d0bb92445f8cf837$var$supabase
});
async function $d0bb92445f8cf837$var$init() {
    (0, (/*@__PURE__*/$parcel$interopDefault($6fc264ec92100d3a$exports))).createRoot(document.getElementById('root')).render(/*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).StrictMode, {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $aWtcP.Provider), {
            schema: (0, $qqvI6.schema),
            store: $d0bb92445f8cf837$var$store,
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $10WBQ.BrowserRouter), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8e5e18fbbe33c793$export$2e2bcd8739ae039), {
                    supabase: $d0bb92445f8cf837$var$supabase
                })
            })
        })
    }));
}
$d0bb92445f8cf837$var$init().catch((err)=>console.error('root error', err));


//# sourceMappingURL=index.9debe6a7.js.map
